webpackJsonp([36,34],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.translate = exports.store = exports.DataApi = exports.router = exports.vue = undefined;
	
	var _extends2 = __webpack_require__(43);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(22);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _translate = __webpack_require__(238);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(445);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(73);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vueResource = __webpack_require__(186);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _store = __webpack_require__(144);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _api = __webpack_require__(8);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _elementUi = __webpack_require__(89);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(412);
	
	var _dqUi = __webpack_require__(226);
	
	var _dqUi2 = _interopRequireDefault(_dqUi);
	
	var _en = __webpack_require__(376);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _vueUuid = __webpack_require__(528);
	
	var _vueUuid2 = _interopRequireDefault(_vueUuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var destinationPages = ['user', 'location', 'till', 'cit', 'mix', 'report', 'softwaresettings', 'adminsettings'];
	
	var previousPages = ['start', 'logout'];
	_vue2.default.use(_api2.default);
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_dqUi2.default, {});
	_vue2.default.use(_vueUuid2.default);
	
	_vue2.default.config.errorHandler = function (err, vm, info) {
	  console.log(err);
	};
	
	_router2.default.beforeEach(function (to, from, next) {
	  if (to.name === 'generic.error.ErrorPage' && from.name === 'login' && _store2.default.getters['generalSession/getCurrentSession'].state === 'error') {
	    return;
	  }
	  if (!(to.meta && to.meta.authorize === false)) {
	    _store2.default.commit('generalSession/checkSession', to);
	
	
	    if (from.path !== to.path && (from.name === null || previousPages.some(function (p) {
	      return from.name.includes(p);
	    }) || !destinationPages.some(function (e) {
	      return to.name.includes(e);
	    }))) {
	      _store2.default.commit('generalOrganization/setOrganizationSimpleTree', to);
	    }
	    new _promise2.default(function (resolve, reject) {
	      var interval = setInterval(function () {
	        if (_store2.default.getters['generalSession/getCurrentSession'].state === 'ready') {
	          resolve('Stuff worked!');
	          clearInterval(interval);
	        } else if (_store2.default.getters['generalSession/getCurrentSession'].state === 'error') {
	          console.log('It broke!');
	          clearInterval(interval);
	          reject({ message: 'It broke', session: _store2.default.getters['generalSession/getCurrentSession'] });
	        }
	      }, 100);
	    }).then(function (response) {
	      return next();
	    }, function (response) {
	      console.log('error!!', response);
	    });
	  } else {
	    next();
	  }
	});
	
	var vue = new _vue2.default((0, _extends3.default)({
	  router: _router2.default,
	  store: _store2.default,
	  translate: _translate2.default
	}, _App2.default)).$mount('#app');
	
	exports.vue = vue;
	exports.router = _router2.default;
	exports.DataApi = _api2.default;
	exports.store = _store2.default;
	exports.translate = _translate2.default;

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(50);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _slicedToArray2 = __webpack_require__(145);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(22);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _auth = __webpack_require__(211);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cit = __webpack_require__(212);
	
	var _cit2 = _interopRequireDefault(_cit);
	
	var _currency = __webpack_require__(213);
	
	var _currency2 = _interopRequireDefault(_currency);
	
	var _department = __webpack_require__(214);
	
	var _department2 = _interopRequireDefault(_department);
	
	var _event = __webpack_require__(215);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _location = __webpack_require__(216);
	
	var _location2 = _interopRequireDefault(_location);
	
	var _mix = __webpack_require__(217);
	
	var _mix2 = _interopRequireDefault(_mix);
	
	var _organization = __webpack_require__(218);
	
	var _organization2 = _interopRequireDefault(_organization);
	
	var _till = __webpack_require__(221);
	
	var _till2 = _interopRequireDefault(_till);
	
	var _unitroles = __webpack_require__(223);
	
	var _unitroles2 = _interopRequireDefault(_unitroles);
	
	var _report = __webpack_require__(219);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _softwaresettings = __webpack_require__(220);
	
	var _softwaresettings2 = _interopRequireDefault(_softwaresettings);
	
	var _adminsettings = __webpack_require__(210);
	
	var _adminsettings2 = _interopRequireDefault(_adminsettings);
	
	var _unit = __webpack_require__(222);
	
	var _unit2 = _interopRequireDefault(_unit);
	
	var _user = __webpack_require__(224);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _utility = __webpack_require__(225);
	
	var _utility2 = _interopRequireDefault(_utility);
	
	var _router = __webpack_require__(73);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _elementUi = __webpack_require__(89);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _store = __webpack_require__(144);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NETWORK_TIMEOUT_MS = 30000;
	
	var API_STANDARDS_TREE = 'x';
	
	var API_PREFIX = 'leda/api';
	
	var API_HOST = (function () {
	    return typeof window === 'object' && window !== null && window.self === window
	      ? (window.location.protocol + '//' + (window.location.hostname ? window.location.hostname : 'localhost') + (window.location.port ? ':' + window.location.port : '') + '/services')
	      : 'http://localhost/services'
	  })();
	
	var API_VERSION = 'v2';
	
	var API_SUBTYPE = '';
	
	exports.default = {
	  apiConfig: {
	    apiStandardsTree: API_STANDARDS_TREE,
	    apiPrefix: API_PREFIX,
	    apiDomain: API_HOST,
	    apiVersion: API_VERSION,
	    apiSubtype: API_SUBTYPE,
	    callCounter: 0,
	    networkTimeout: NETWORK_TIMEOUT_MS
	  },
	  apiUrl: function apiUrl() {
	    return API_HOST + '/' + API_PREFIX + '/';
	  },
	  init: function init() {},
	  install: function install(Vue, options) {
	    this.init();
	    var self = this;
	
	    this._vue = Vue;
	
	    Vue.prototype.$dataApi = function () {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return self;
	    };
	  },
	  getJwtToken: function getJwtToken() {
	    var idToken = window.localStorage.getItem('id_token');
	    if (!idToken) {
	      var vegaData = window.localStorage.getItem('vega');
	      if (vegaData) {
	        var _JSON$parse = JSON.parse(vegaData),
	            jwtToken = _JSON$parse.jwt_token;
	
	        idToken = jwtToken;
	      }
	    }
	    return idToken;
	  },
	  getRefreshToken: function getRefreshToken() {
	    var refreshToken = window.localStorage.getItem('id_refresh_token');
	    if (!refreshToken) {
	      var vegaData = window.localStorage.getItem('vega');
	      if (vegaData) {
	        var _JSON$parse2 = JSON.parse(vegaData),
	            idRefreshToken = _JSON$parse2.refresh_token;
	
	        refreshToken = idRefreshToken;
	      }
	    }
	    return refreshToken;
	  },
	  request: function request(options) {
	    var _this = this;
	
	    var fullApiUrl = this.apiUrl() + options.url;
	
	    var requestTimeout = NETWORK_TIMEOUT_MS;
	    var url = options.url;
	    if (url.indexOf('ui/report/') > -1 && url !== 'ui/report/reports-list') {
	      requestTimeout = 10 * 60 * 1000;
	    }
	
	    if (!window.navigator.onLine) {
	      _elementUi2.default.Message.error('It seems you have lost the internet connection!');
	    }
	
	    var vm = this;
	    var token = this.getJwtToken();
	    var refreshToken = this.getRefreshToken();
	
	    return new _promise2.default(function (resolve, reject) {
	      var originatedWithToken = !!token;
	
	      var networkTimeout = setTimeout(function () {
	        console.log('Connection timeout to REST Api');
	        var err = {
	          status: 500,
	          statusMessage: 'Could not connect to backend server'
	        };
	
	        reject(err);
	      }, requestTimeout);
	
	      var requestHeaders = {};
	
	      if (options.headers !== undefined) {
	        requestHeaders = options.headers;
	      }
	
	      requestHeaders.Accept = 'application/json';
	
	      if (options.accept !== undefined) {
	        requestHeaders.Accept = options.accept;
	      }
	
	      if (options.authorization !== false) {
	        requestHeaders['Authorization'] = 'Bearer ' + token;
	      }
	
	      var requestOptions = {
	        timeout: requestTimeout,
	        headers: requestHeaders,
	        credentials: false,
	        params: options.params
	      };
	
	      if (options.responseType) {
	        requestOptions.responseType = options.responseType;
	      }
	
	      var param1 = null;
	      var param2 = null;
	
	      if (options.method === 'post' || options.method === 'put') {
	        param1 = options.body;
	        param2 = requestOptions;
	      } else {
	        param1 = requestOptions;
	      }
	
	      _this._vue.http[options.method](fullApiUrl, param1, param2).then(function (response) {
	        clearTimeout(networkTimeout);
	
	        var newResponse = response;
	
	        if (response.status === 200) {
	          if (typeof options.parseResponse === 'function') {
	            var r = options.parseResponse(response);
	            if (r === false) {
	              newResponse.status = 400;
	              newResponse.statusMessage = 'Parse error';
	              reject(newResponse);
	            }
	          }
	
	          resolve(newResponse);
	        } else {
	          console.log('reject response != status 200');
	          newResponse.status = response.status;
	          newResponse.statusMessage = 'Status not 200';
	
	          reject(newResponse);
	        }
	      }, function (err) {
	        function handle400(exc) {
	          clearTimeout(networkTimeout);
	          var msgCode = 'xxxxxx';
	
	          if (exc.body.code && exc.body.code === msgCode && exc.body.text) {
	            _elementUi2.default.Message.warning(exc.body.text);
	          } else if (exc.body.code && exc.body.msgId) {
	            if (exc.body.msgId.includes(' ')) {
	              var parsed = exc.body.msgId;
	
	              parsed = parsed.replace(/\s/g, '_').replace(/[^\w\s]/gi, '').toUpperCase();
	              _elementUi2.default.Message.warning(_vue2.default.t('server_messages.' + parsed));
	            } else {
	              if (exc.body.businessDetails) {
	                _elementUi2.default.Message.warning(_vue2.default.t('server_messages.' + exc.body.msgId, { reason: exc.body.businessDetails }));
	              } else {
	                var message = _vue2.default.t('server_messages.' + exc.body.msgId);
	
	                if (message.includes('[{reason}]')) {
	                  message = message.replace(/\s*\[\{reason\}\]/, '');
	                }
	                _elementUi2.default.Message.warning(message);
	              }
	            }
	          } else if (exc.body.data) {
	            _elementUi2.default.Message.warning(exc.body.data);
	          } else if (exc.body.message && Array.isArray(exc.body.message) && exc.body.message.length > 0) {
	            _elementUi2.default.Message.warning(_vue2.default.t('server_messages.' + exc.body.message[0]));
	          } else {
	            _elementUi2.default.Message.warning('An error occurred');
	          }
	
	          reject(exc);
	        }
	
	        function handle401(exc) {
	          clearTimeout(networkTimeout);
	
	          console.log('in error!', err);
	
	          if (exc.body && exc.body.msgId === 'MFA_REQUIRED') {
	            reject(err);
	          }
	          if (exc.body.code && exc.body.msgId) {
	            _elementUi2.default.Message.warning(_vue2.default.t('server_messages.' + exc.body.msgId));
	
	            if (exc.body.msgId === 'sessionTimeout' && _router2.default.currentRoute.path !== '/login') {
	              window.localStorage.removeItem('vega');
	              window.localStorage.removeItem('id_token');
	              window.localStorage.removeItem('id_token_created_at');
	              window.localStorage.removeItem('id_refresh_token');
	
	              window.location.href = '/login';
	            }
	          } else if (exc.body.data) {
	            _elementUi2.default.Message.warning(exc.body.data);
	          } else {
	            console.log('not authorized', _router2.default, this);
	            _store2.default.commit('generalSession/sessionError');
	            _router2.default.replace({
	              name: 'login'
	            });
	
	            reject(err);
	          }
	        }
	
	        function handle404(exc) {
	          clearTimeout(networkTimeout);
	
	          console.log('in error!', err);
	
	          if (exc.body.code && exc.body.msgId) {
	            _elementUi2.default.Message.warning(_vue2.default.t('server_messages.' + exc.body.msgId));
	          } else if (exc.body.data) {
	            _elementUi2.default.Message.warning(exc.body.data);
	          } else {
	            _router2.default.push({
	              name: 'generic.error.ErrorPage',
	              params: {
	                error_response: {
	                  error_message: 'unknown_error'
	                }
	              }
	            });
	            reject(exc);
	          }
	        }
	
	        function handle409(exc) {
	          clearTimeout(networkTimeout);
	
	          console.log('in error!', err);
	
	          if (exc.body.code && exc.body.msgId) {
	            _elementUi2.default.Message.warning(_vue2.default.t('server_messages.' + exc.body.msgId));
	          } else if (exc.body.data) {
	            _elementUi2.default.Message.warning(exc.body.data);
	          } else {
	            _router2.default.push({
	              name: 'generic.error.ErrorPage',
	              params: {
	                error_response: {
	                  error_message: 'unknown_error'
	                }
	              }
	            });
	          }
	          reject(exc);
	        }
	
	        function handleOthers(exc) {
	          clearTimeout(networkTimeout);
	
	          console.log('in error!', err);
	
	          _router2.default.replace({
	            name: 'generic.error.ErrorPage',
	            params: {
	              error_response: exc
	            }
	          });
	
	          reject(exc);
	        }
	
	        if (err.status === 400) {
	          handle400(err);
	        } else if (err.status === 401 || err.status === 403) {
	          if (!originatedWithToken) {
	            reject(err);
	            return;
	          }
	
	          var skipRefresh = options && options.skipRefresh === true;
	
	          if (skipRefresh && err.body && (err.body.msgId === 'sessionTimeout' || err.body.msgId === 'accessNotAllowed')) {
	            try {
	              _store2.default.commit('generalSession/clearSessionSilent');
	            } catch (error) {
	              console.warn('Could not commit clearSessionSilent', error);
	            }
	            window.localStorage.removeItem('vega');
	            window.localStorage.removeItem('id_token');
	            window.localStorage.removeItem('id_token_created_at');
	            window.localStorage.removeItem('id_refresh_token');
	            reject(err);
	            return;
	          }
	
	          if (err.body.msgId === 'sessionTimeout' && _router2.default.currentRoute.path !== '/login') {
	            vm._vue.http.post(_this.apiUrl() + 'ui/auth/refresh', {
	              refreshToken: refreshToken
	            }, {
	              timeout: NETWORK_TIMEOUT_MS
	            }).then(function (response) {
	              clearTimeout(networkTimeout);
	              var _response$body$messag = (0, _slicedToArray3.default)(response.body.message, 2),
	                  token = _response$body$messag[0],
	                  refreshToken = _response$body$messag[1];
	
	              var authData = {
	                jwt_token: token,
	                refresh_token: refreshToken,
	                createdAt: new Date().getTime()
	              };
	              window.localStorage.setItem('vega', (0, _stringify2.default)(authData));
	              window.localStorage.setItem('id_token', token);
	              window.localStorage.setItem('id_refresh_token', refreshToken);
	              window.localStorage.setItem('id_token_created_at', new Date().getTime());
	
	              resolve(vm.request(options));
	            }, function (err2) {
	              if (err2.status === 400) {
	                handle400(err2);
	              } else if (err2.status === 401 || err2.status === 403) {
	                console.log('Apparently token expired.');
	                handle401(err2);
	              } else if (err2.status === 404) {
	                handle404(err2);
	              } else if (err2.status === 409) {
	                handle409(err2);
	              } else {
	                handleOthers(err2);
	              }
	            });
	          } else if (err.body.msgId === 'accessNotAllowed' && _router2.default.currentRoute.path !== '/login') {
	            _elementUi2.default.Message.warning(_vue2.default.t('server_messages.' + err.body.msgId));
	
	            window.localStorage.removeItem('vega');
	            window.localStorage.removeItem('id_token');
	            window.localStorage.removeItem('id_token_created_at');
	            window.localStorage.removeItem('id_refresh_token');
	            window.location.reload(true);
	          } else if (err.body.msgId === 'accessNotAllowed' && _router2.default.currentRoute.path.includes('/login')) {
	            window.localStorage.removeItem('vega');
	            window.localStorage.removeItem('id_token');
	            window.localStorage.removeItem('id_token_created_at');
	            window.localStorage.removeItem('id_refresh_token');
	          } else {
	            handle401(err);
	          }
	        } else if (err.status === 404) {
	          handle404(err);
	        } else if (err.status === 409) {
	          handle409(err);
	        } else {
	          handleOthers(err);
	        }
	      }).catch(function (error) {
	        console.log('Catch error', error);
	        reject(error);
	      });
	    });
	  },
	
	  endpoints: {
	    auth: _auth2.default,
	    cit: _cit2.default,
	    currency: _currency2.default,
	    department: _department2.default,
	    event: _event2.default,
	    location: _location2.default,
	    mix: _mix2.default,
	    organization: _organization2.default,
	    till: _till2.default,
	    unitRoles: _unitroles2.default,
	    report: _report2.default,
	    softwaresettings: _softwaresettings2.default,
	    adminsettingsEndpoint: _adminsettings2.default,
	    unit: _unit2.default,
	    user: _user2.default,
	    utility: _utility2.default
	  }
	};

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.previousRoute = exports.router = undefined;
	
	var _toConsumableArray2 = __webpack_require__(25);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _menu = __webpack_require__(237);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _vueRouter = __webpack_require__(527);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  linkActiveClass: 'is-active',
	  scrollBehavior: function scrollBehavior() {
	    return { y: 0 };
	  },
	  routes: [].concat((0, _toConsumableArray3.default)(generateRoutesFromMenu(_menu2.default)), [{
	    path: '*',
	    redirect: { name: 'unit' }
	  }])
	});
	
	var previousRoute = null;
	
	router.beforeEach(function (to, from, next) {
	  if (from.name) {
	    exports.previousRoute = previousRoute = {
	      name: from.name,
	      query: from.query
	    };
	  }
	  next();
	});
	
	function generateRoutesFromMenu() {
	  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  for (var i = 0, l = menu.length; i < l; i++) {
	    var item = menu[i];
	    if (item.path) {
	      routes.push(item);
	    }
	    generateRoutesFromMenu(item.children, routes);
	  }
	  return routes;
	}
	
	exports.router = router;
	exports.previousRoute = previousRoute;
	exports.default = router;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(530);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _session = __webpack_require__(248);
	
	var _session2 = _interopRequireDefault(_session);
	
	var _organizationSimpleTree = __webpack_require__(240);
	
	var _organizationSimpleTree2 = _interopRequireDefault(_organizationSimpleTree);
	
	var _overrideSettings = __webpack_require__(246);
	
	var _overrideSettings2 = _interopRequireDefault(_overrideSettings);
	
	var _overrideInventorySettings = __webpack_require__(243);
	
	var _overrideInventorySettings2 = _interopRequireDefault(_overrideInventorySettings);
	
	var _overrideOm61InventorySettings = __webpack_require__(245);
	
	var _overrideOm61InventorySettings2 = _interopRequireDefault(_overrideOm61InventorySettings);
	
	var _overrideTariffSettings = __webpack_require__(247);
	
	var _overrideTariffSettings2 = _interopRequireDefault(_overrideTariffSettings);
	
	var _overrideAcceptablesSetting = __webpack_require__(241);
	
	var _overrideAcceptablesSetting2 = _interopRequireDefault(_overrideAcceptablesSetting);
	
	var _overrideMinimumOrderCoinRollsSettings = __webpack_require__(244);
	
	var _overrideMinimumOrderCoinRollsSettings2 = _interopRequireDefault(_overrideMinimumOrderCoinRollsSettings);
	
	var _overrideCoinDistributionSetting = __webpack_require__(242);
	
	var _overrideCoinDistributionSetting2 = _interopRequireDefault(_overrideCoinDistributionSetting);
	
	var _denominationForCurrency = __webpack_require__(239);
	
	var _denominationForCurrency2 = _interopRequireDefault(_denominationForCurrency);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    generalSession: _session2.default,
	    generalOrganization: _organizationSimpleTree2.default,
	    overrideSettings: _overrideSettings2.default,
	    overrideInventorySettings: _overrideInventorySettings2.default,
	    overrideOm61InventorySettings: _overrideOm61InventorySettings2.default,
	    overrideTariffSettings: _overrideTariffSettings2.default,
	    overrideAcceptablesSetting: _overrideAcceptablesSetting2.default,
	    overrideMinimumOrderCoinRollsSettings: _overrideMinimumOrderCoinRollsSettings2.default,
	    overrideCoinDistributionSetting: _overrideCoinDistributionSetting2.default,
	    denominationForCurrency: _denominationForCurrency2.default
	  }
	});

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getOverview: function getOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/admin/settings',
	      params: params
	    });
	  }
	};

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  authLogin: function authLogin(params, redirect) {
	    var authorizationHash = window.btoa(params.username + ':' + params.password);
	
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/auth/login',
	      authorization: false,
	      headers: {
	        'Authorization': 'Basic ' + authorizationHash
	      }
	    });
	  },
	  authLoginMfa: function authLoginMfa(mfaRequest) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/v2/validate-mfa-token',
	      authorization: false,
	      body: mfaRequest
	
	    });
	  },
	  requestQrPairingMfa: function requestQrPairingMfa(mfaTemporalToken) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/v2/qr-code-pairing',
	      authorization: false,
	      accept: 'image/png',
	      responseType: 'arraybuffer',
	      headers: {
	        'Temporal-Jwt': mfaTemporalToken
	      }
	    });
	  },
	  getOrganizationMfaSettings: function getOrganizationMfaSettings(mfaTemporalToken) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/v2/mfa-settings',
	      authorization: false,
	      headers: {
	        'Temporal-Jwt': mfaTemporalToken
	      }
	    });
	  },
	  logout: function logout(refreshToken) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/auth/logout',
	      skipRefresh: true,
	      body: { refreshToken: refreshToken }
	    });
	  },
	  forgotPassword: function forgotPassword(id) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/auth/forgotPassword',
	      authorization: false,
	      body: id
	    });
	  },
	  resetPassword: function resetPassword(params, id, token) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/auth/resetPassword/' + id + '/' + token,
	      authorization: false,
	      body: params
	    });
	  }
	};

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getCampaignsUnit: function getCampaignsUnit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/cit/campaigns-unit',
	      params: params
	    });
	  },
	  getCampaignsUnitMaster: function getCampaignsUnitMaster(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/cit/campaigns-unit-master',
	      params: params
	    });
	  },
	  getCampaignsUnitGroupDetails: function getCampaignsUnitGroupDetails(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/cit/campaigns-unit-group-details',
	      params: params
	    });
	  },
	  getOverview: function getOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/cit/overview',
	      params: params
	    });
	  },
	  getSearch: function getSearch(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/cit/search',
	      params: params
	    });
	  },
	  deleteDelete: function deleteDelete(params) {
	    return _2.default.request({
	      method: 'delete',
	      url: 'ui/cit/delete',
	      params: params
	    });
	  },
	  getInforForEdit: function getInforForEdit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/cit/info-for-edit',
	      params: params
	    });
	  },
	  postAdd: function postAdd(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/cit/add-workflow',
	      body: params
	    });
	  },
	  putEdit: function putEdit(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/cit/update-workflow',
	      body: params
	    });
	  },
	  getWorkflowPages: function getWorkflowPages(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/cit/get-pages',
	      params: params
	    });
	  },
	  getWorkflows: function getWorkflows(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/cit/workflows',
	      params: params
	    });
	  },
	  getWorkflowExport: function getWorkflowExport(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/cit/export-workflow?workflowId=' + params,
	      accept: 'application/xml'
	    });
	  },
	  postImportWorkflow: function postImportWorkflow(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/cit/import-workflow',
	      body: params,
	      headers: { 'Content-type': 'multipart/form-data' }
	    });
	  },
	  getPlaceholdersAndActions: function getPlaceholdersAndActions(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/v2/placeholder/placeholders-and-placeholder-actions/' + params
	    });
	  },
	  getPlaceholderConditions: function getPlaceholderConditions() {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/v2/placeholder-conditions'
	    });
	  }
	};

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getAll: function getAll(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/currency/all',
	      params: params
	    });
	  },
	  getAllEnabled: function getAllEnabled(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/currency/all-enabled',
	      params: params
	    });
	  },
	  update: function update(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/currency/update',
	      body: params
	    });
	  },
	  getCurrencyDenominations: function getCurrencyDenominations(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/currency/get-currency-denominations',
	      params: params
	    });
	  }
	};

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getSearch: function getSearch(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/departments/search',
	      params: params
	    });
	  },
	  getDepartmentsForOrganizationAndItsAncestors: function getDepartmentsForOrganizationAndItsAncestors(orgUuid) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/departments/org-and-ancestors/' + orgUuid
	    });
	  },
	  get: function get(uuid) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/departments/' + uuid
	    });
	  },
	  create: function create(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/departments',
	      body: body
	    });
	  },
	  update: function update(uuid, body) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/departments/' + uuid,
	      body: body
	    });
	  },
	  deleteDelete: function deleteDelete(params) {
	    return _2.default.request({
	      method: 'delete',
	      url: 'ui/departments/' + params.uuid
	    });
	  }
	};

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getEventsByUnit: function getEventsByUnit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/event/events-by-unit',
	      params: params
	    });
	  }
	};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getOverview: function getOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/location/overview',
	      params: params
	    });
	  },
	  getSearch: function getSearch(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/location/search',
	      params: params
	    });
	  },
	  deleteDelete: function deleteDelete(params) {
	    return _2.default.request({
	      method: 'delete',
	      url: 'ui/location/delete',
	      params: params
	    });
	  },
	  getInforForEdit: function getInforForEdit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/location/info-for-edit',
	      params: params
	    });
	  },
	  postAdd: function postAdd(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/location/add',
	      body: params
	    });
	  },
	  putEdit: function putEdit(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/location/edit',
	      body: params
	    });
	  },
	  getCountries: function getCountries(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/location/countries',
	      params: params
	    });
	  },
	  getTimeZones: function getTimeZones(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/location/time-zones',
	      params: params
	    });
	  },
	  getStates: function getStates(id) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/location/countries/' + id + '/states'
	    });
	  }
	};

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getGet: function getGet(uuid) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/mix/get/' + uuid
	    });
	  },
	  getOverview: function getOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/mix/overview',
	      params: params
	    });
	  },
	  getOverviewByOrganization: function getOverviewByOrganization(organizationUUID) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/mix/search/organization/' + organizationUUID
	    });
	  },
	  getOverviewByUnit: function getOverviewByUnit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/mix/overview-by-unit',
	      params: params
	    });
	  },
	  getSearch: function getSearch(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/mix/search',
	      params: params
	    });
	  },
	  deleteDelete: function deleteDelete(params) {
	    return _2.default.request({
	      method: 'delete',
	      url: 'ui/mix/delete',
	      params: params
	    });
	  },
	  postAdd: function postAdd(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/mix/add',
	      body: params
	    });
	  },
	  putEdit: function putEdit(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/mix/edit',
	      body: params
	    });
	  }
	};

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(301);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getOverview: function getOverview(params) {
	    if (params.organizationType) {
	      var _params = params,
	          organizationType = _params.organizationType,
	          rest = (0, _objectWithoutProperties3.default)(_params, ['organizationType']);
	
	      rest['filterField'] = 'organizationType';
	      rest['filterValues'] = organizationType;
	      params = rest;
	    }
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/overview',
	      params: params
	    });
	  },
	  getParentOverview: function getParentOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/parent-overview',
	      params: params
	    });
	  },
	  deleteDelete: function deleteDelete(params) {
	    return _2.default.request({
	      method: 'delete',
	      url: 'ui/organization/delete',
	      params: params
	    });
	  },
	  getInforForEdit: function getInforForEdit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/info-for-edit',
	      params: params
	    });
	  },
	  getJobDetails: function getJobDetails(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/job-details',
	      params: params
	    });
	  },
	  getRecyclerOverallJobDetails: function getRecyclerOverallJobDetails(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/job-details/recycler-overall',
	      params: params
	    });
	  },
	  updateJobDetails: function updateJobDetails(params, form) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/organization/job-details',
	      params: params,
	      body: form
	    });
	  },
	  updateRecyclerOverallJobDetails: function updateRecyclerOverallJobDetails(params, form) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/organization/job-details/recycler-overall',
	      params: params,
	      body: form
	    });
	  },
	  postAdd: function postAdd(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/organization/add',
	      body: params
	    });
	  },
	  putEdit: function putEdit(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/organization/edit',
	      body: params
	    });
	  },
	  getSimpleTree: function getSimpleTree(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/simple-tree',
	      body: params
	    });
	  },
	  getLookUpCIT: function getLookUpCIT(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/lookUpCIT',
	      params: params
	    });
	  },
	  getLookUpMaintenance: function getLookUpMaintenance(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/lookUpMaintenance',
	      params: params
	    });
	  },
	  getTypes: function getTypes(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/types',
	      params: params
	    });
	  },
	  getMyOrganization: function getMyOrganization(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/my-organization',
	      params: params
	    });
	  },
	  getNotifications: function getNotifications(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/organization/notifications',
	      params: params
	    });
	  },
	  updateNotification: function updateNotification(params, body) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/organization/notification',
	      params: params,
	      body: body
	    });
	  }
	};

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  generateReport: function generateReport(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/generate-report',
	      body: body
	    });
	  },
	  getCampaignsWithBarcodes: function getCampaignsWithBarcodes(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/campaigns-with-barcodes',
	      body: body
	    });
	  },
	  getInternalTransactionsByDate: function getInternalTransactionsByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/internal-transactions-by-date',
	      body: body
	    });
	  },
	  getSalesByDate: function getSalesByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/sales-by-date',
	      body: body
	    });
	  },
	  getTransactionsWithReference: function getTransactionsWithReference(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/transactions-with-reference',
	      body: body
	    });
	  },
	  getReptileTransactionsWithReference: function getReptileTransactionsWithReference(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-transactions-with-reference',
	      body: body
	    });
	  },
	  getManualTransactionsByDate: function getManualTransactionsByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/manual-transactions-by-date',
	      body: body
	    });
	  },
	  getEndOfDayClientsByDate: function getEndOfDayClientsByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/endofdayclients-by-date',
	      body: body
	    });
	  },
	  getEventsByDate: function getEventsByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/events-by-date',
	      body: body
	    });
	  },
	  getReportTypes: function getReportTypes(unitUuids) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reports-list',
	      body: { unitUuids: unitUuids }
	    });
	  },
	  getAvailableUnitsForOrganization: function getAvailableUnitsForOrganization(orgUuid) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/v2/reports/organization/' + orgUuid + '/available-units'
	    });
	  },
	  getReptileTransactionsByDate: function getReptileTransactionsByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-transactions-by-date',
	      body: body
	    });
	  },
	  getReptileCampaignsAndTransactionsByDate: function getReptileCampaignsAndTransactionsByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-campaigns-and-transactions-by-date',
	      body: body
	    });
	  },
	  getReptileCampaignsAndTransactionsMoneyInOutCounterByDate: function getReptileCampaignsAndTransactionsMoneyInOutCounterByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-campaigns-and-transactions-money-in-out-by-date',
	      body: body
	    });
	  },
	  getReptileReportForDenominationPerUser: function getReptileReportForDenominationPerUser(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-denomination-per-user',
	      body: body
	    });
	  },
	  getReptileReportForDenominationWithPin: function getReptileReportForDenominationWithPin(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-denomination-with-pin',
	      body: body
	    });
	  },
	  getReptileReportForClosedCampaignsByUnitAndDate: function getReptileReportForClosedCampaignsByUnitAndDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-campaigns-by-date',
	      body: body
	    });
	  },
	  getReptileClearboxDenomination: function getReptileClearboxDenomination(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-clearbox-denomination',
	      body: body
	    });
	  },
	  getReptileClearboxDenominationV2: function getReptileClearboxDenominationV2(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-clearbox-denomination-v2',
	      body: body
	    });
	  },
	  getReptileEndOfDayInfoByDate: function getReptileEndOfDayInfoByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-endofdayinfo-by-date',
	      body: body
	    });
	  },
	  getReptileLincstationEndOfDayInfoByDate: function getReptileLincstationEndOfDayInfoByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-lincstationendofdayinfo-by-date',
	      body: body
	    });
	  },
	  getReptileAdvancedManualDeposit: function getReptileAdvancedManualDeposit(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-amd',
	      body: body
	    });
	  },
	  getReptileSalesByDate: function getReptileSalesByDate(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-sales-report',
	      body: body
	    });
	  },
	  getReptileRecyclerReport: function getReptileRecyclerReport(body) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/report/reptile-recycler-report',
	      body: body
	    });
	  }
	};

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getOverview: function getOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/settings/overview-organization-settings',
	      params: params
	    });
	  },
	  getSearch: function getSearch(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/settings/search-organization-settings',
	      params: params
	    });
	  },
	  deleteDeleteOrganizationSettings: function deleteDeleteOrganizationSettings(params) {
	    return _2.default.request({
	      method: 'delete',
	      url: 'ui/settings/delete-organization-settings',
	      params: params
	    });
	  },
	  getDefaultSettings: function getDefaultSettings(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/settings/default-settings',
	      params: params
	    });
	  },
	  getSettingsByOrgAndUnittype: function getSettingsByOrgAndUnittype(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/settings/settings-by-org-and-unittype',
	      params: params
	    });
	  },
	  postOverrideSettingsForUnit: function postOverrideSettingsForUnit(uuid, params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/settings/override-settings-for-unit?uuid=' + uuid,
	      body: params
	    });
	  },
	  getSettingsByUnit: function getSettingsByUnit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/settings/unit-settings',
	      params: params
	    });
	  },
	  postOverrideSettingsForOrganization: function postOverrideSettingsForOrganization(url, params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/settings/override-settings-for-organization',
	      params: url,
	      body: params
	    });
	  },
	  postUpdateSettingsForOrganization: function postUpdateSettingsForOrganization(url, params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/settings/update-settings-for-organization',
	      params: url,
	      body: params
	    });
	  }
	};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getOverview: function getOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/till/overview',
	      params: params
	    });
	  },
	  getTillsForOrganization: function getTillsForOrganization(organizationUuid) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/till/search/organization/' + organizationUuid
	    });
	  },
	  getTillsForUnit: function getTillsForUnit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/till/search/unit/' + params.uuid,
	      params: params.params
	    });
	  },
	  getTill: function getTill(tillUuid) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/till/get/' + tillUuid
	    });
	  },
	  deleteDelete: function deleteDelete(params) {
	    return _2.default.request({
	      method: 'delete',
	      url: 'ui/till/delete',
	      params: params
	    });
	  },
	  postAdd: function postAdd(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/till/add',
	      body: params
	    });
	  },
	  putEdit: function putEdit(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/till/edit',
	      body: params
	    });
	  },
	  getUnitsToBeDisconnected: function getUnitsToBeDisconnected(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/till/delete',
	      body: params
	    });
	  }
	};

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getOverview: function getOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/overview',
	      params: params
	    });
	  },
	  getAllUnits: function getAllUnits(organizationUUID) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/overview/organization/' + organizationUUID
	    });
	  },
	  getSearch: function getSearch(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/search',
	      params: params
	    });
	  },
	  deleteDelete: function deleteDelete(params) {
	    return _2.default.request({
	      method: 'delete',
	      url: 'ui/unit/delete',
	      params: params
	    });
	  },
	  getTypes: function getTypes(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/types',
	      params: params
	    });
	  },
	  getTypeFamilies: function getTypeFamilies(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/type/families',
	      params: params
	    });
	  },
	  getInforForEdit: function getInforForEdit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/info-for-edit',
	      params: params
	    });
	  },
	  postAdd: function postAdd(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/unit/add',
	      body: params
	    });
	  },
	  putEdit: function putEdit(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/unit/edit',
	      body: params
	    });
	  },
	  getSummary: function getSummary(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/summary',
	      params: params
	    });
	  },
	  getInventory: function getInventory(unitUuid) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/inventory/' + unitUuid
	    });
	  },
	  getLastTransactions: function getLastTransactions(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/last-transactions',
	      params: params
	    });
	  },
	  getComponent: function getComponent(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/component',
	      params: params
	    });
	  },
	  getOverviewWithoutSubs: function getOverviewWithoutSubs(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/overview-without-subs',
	      params: params
	    });
	  },
	  getUnitAndPlaceholderStatus: function getUnitAndPlaceholderStatus(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/status',
	      params: params
	    });
	  },
	  getNotifications: function getNotifications(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/event/notifications',
	      params: params
	    });
	  },
	  getPlaceholderInformation: function getPlaceholderInformation(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/placeholder-information',
	      params: params
	    });
	  },
	  getTransactionLines: function getTransactionLines(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/transaction/lines',
	      params: params
	    });
	  },
	  getAcceptableMaterials: function getAcceptableMaterials(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit/get-currency-acceptable-materials',
	      params: params
	    });
	  }
	};

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getOverview: function getOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit-roles/overview',
	      params: params
	    });
	  },
	  getSearch: function getSearch(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit-roles/search',
	      params: params
	    });
	  },
	  getUnitRole: function getUnitRole(id) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit-roles/info-for-edit?id=' + id
	    });
	  },
	  getPermissions: function getPermissions() {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit-roles/permissions'
	    });
	  },
	  postAdd: function postAdd(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/unit-roles/create',
	      body: params
	    });
	  },
	  putEdit: function putEdit(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/unit-roles/edit',
	      body: params
	    });
	  },
	  deleteDelete: function deleteDelete(params) {
	    return _2.default.request({
	      method: 'delete',
	      url: 'ui/unit-roles/delete',
	      params: params
	    });
	  },
	  getUnitRolesByOrgUuid: function getUnitRolesByOrgUuid(uuid) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/unit-roles/by-organization?uuid=' + uuid
	    });
	  }
	};

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getWhoAmI: function getWhoAmI() {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/user/who-am-i'
	    });
	  },
	  getRoles: function getRoles() {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/user/roles'
	    });
	  },
	  getCitRoles: function getCitRoles() {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/user/cit-roles'
	    });
	  },
	  getGet: function getGet(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/user/get',
	      params: params
	    });
	  },
	  getOverview: function getOverview(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/user/overview',
	      params: params
	    });
	  },
	  getOverviewByUnit: function getOverviewByUnit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/user/overview-by-unit',
	      params: params
	    });
	  },
	  postAdd: function postAdd(params) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/user/add',
	      body: params
	    });
	  },
	  deleteDelete: function deleteDelete(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/user/delete',
	      params: params
	    });
	  },
	  unlock: function unlock(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/user/unlock',
	      params: params
	    });
	  },
	  getInforForEdit: function getInforForEdit(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/user/info-for-edit',
	      params: params
	    });
	  },
	  putEdit: function putEdit(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/user/edit',
	      body: params
	    });
	  },
	  getSearch: function getSearch(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/user/search',
	      params: params
	    });
	  },
	  getUserPermissions: function getUserPermissions(params) {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/user/userpermissions',
	      params: params
	    });
	  },
	  putChangePassword: function putChangePassword(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/user/change-password',
	      body: params
	    });
	  },
	  putChangePin: function putChangePin(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/user/change-pin',
	      body: params
	    });
	  },
	  putUpdateProfile: function putUpdateProfile(params) {
	    return _2.default.request({
	      method: 'put',
	      url: 'ui/user/update-profile',
	      body: params
	    });
	  },
	  resetQrSecret: function resetQrSecret(userUUID) {
	    return _2.default.request({
	      method: 'post',
	      url: 'ui/v2/reset-secret/' + userUUID,
	      body: ''
	    });
	  }
	};

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(8);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getBuildProperties: function getBuildProperties() {
	    return _2.default.request({
	      method: 'get',
	      url: 'ui/utility/version',
	      authorization: false
	    });
	  }
	};

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _overview = __webpack_require__(232);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _sidemenu = __webpack_require__(234);
	
	var _sidemenu2 = _interopRequireDefault(_sidemenu);
	
	var _usermenu = __webpack_require__(236);
	
	var _usermenu2 = _interopRequireDefault(_usermenu);
	
	var _settingspanel = __webpack_require__(233);
	
	var _settingspanel2 = _interopRequireDefault(_settingspanel);
	
	var _inventorypanel = __webpack_require__(229);
	
	var _inventorypanel2 = _interopRequireDefault(_inventorypanel);
	
	var _om61inventorypanel = __webpack_require__(231);
	
	var _om61inventorypanel2 = _interopRequireDefault(_om61inventorypanel);
	
	var _tariffspanel = __webpack_require__(235);
	
	var _tariffspanel2 = _interopRequireDefault(_tariffspanel);
	
	var _acceptablespanel = __webpack_require__(227);
	
	var _acceptablespanel2 = _interopRequireDefault(_acceptablespanel);
	
	var _minimumordercoinrollspanel = __webpack_require__(230);
	
	var _minimumordercoinrollspanel2 = _interopRequireDefault(_minimumordercoinrollspanel);
	
	var _coindistributionpanel = __webpack_require__(228);
	
	var _coindistributionpanel2 = _interopRequireDefault(_coindistributionpanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = [_overview2.default, _sidemenu2.default, _usermenu2.default, _settingspanel2.default, _inventorypanel2.default, _om61inventorypanel2.default, _tariffspanel2.default, _acceptablespanel2.default, _minimumordercoinrollspanel2.default, _coindistributionpanel2.default];
	
	var install = function install(Vue) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (install.installed) return;
	
	  components.map(function (component) {
	    Vue.component(component.name, component);
	  });
	};
	
	if (typeof window !== 'undefined' && window.Vue) {
	  install(window.Vue);
	}
	
	module.exports = {
	  Overview: _overview2.default,
	  install: install,
	  version: '1.0.0'
	};

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _acceptablespanel = __webpack_require__(470);
	
	var _acceptablespanel2 = _interopRequireDefault(_acceptablespanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_acceptablespanel2.default.install = function (Vue) {
	  Vue.component(_acceptablespanel2.default.name, _acceptablespanel2.default);
	};
	
	exports.default = _acceptablespanel2.default;

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coindistributionpanel = __webpack_require__(471);
	
	var _coindistributionpanel2 = _interopRequireDefault(_coindistributionpanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_coindistributionpanel2.default.install = function (Vue) {
	  Vue.component(_coindistributionpanel2.default.name, _coindistributionpanel2.default);
	};
	
	exports.default = _coindistributionpanel2.default;

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inventorypanel = __webpack_require__(472);
	
	var _inventorypanel2 = _interopRequireDefault(_inventorypanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_inventorypanel2.default.install = function (Vue) {
	  Vue.component(_inventorypanel2.default.name, _inventorypanel2.default);
	};
	
	exports.default = _inventorypanel2.default;

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _minimumordercoinrollspanel = __webpack_require__(473);
	
	var _minimumordercoinrollspanel2 = _interopRequireDefault(_minimumordercoinrollspanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_minimumordercoinrollspanel2.default.install = function (Vue) {
	  Vue.component(_minimumordercoinrollspanel2.default.name, _minimumordercoinrollspanel2.default);
	};
	
	exports.default = _minimumordercoinrollspanel2.default;

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _om61inventorypanel = __webpack_require__(474);
	
	var _om61inventorypanel2 = _interopRequireDefault(_om61inventorypanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_om61inventorypanel2.default.install = function (Vue) {
	  Vue.component(_om61inventorypanel2.default.name, _om61inventorypanel2.default);
	};
	
	exports.default = _om61inventorypanel2.default;

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _overview = __webpack_require__(475);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_overview2.default.install = function (Vue) {
	  Vue.component(_overview2.default.name, _overview2.default);
	};
	
	exports.default = _overview2.default;

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _settingspanel = __webpack_require__(476);
	
	var _settingspanel2 = _interopRequireDefault(_settingspanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_settingspanel2.default.install = function (Vue) {
	  Vue.component(_settingspanel2.default.name, _settingspanel2.default);
	};
	
	exports.default = _settingspanel2.default;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sidemenu = __webpack_require__(477);
	
	var _sidemenu2 = _interopRequireDefault(_sidemenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_sidemenu2.default.install = function (Vue) {
	  Vue.component(_sidemenu2.default.name, _sidemenu2.default);
	};
	
	exports.default = _sidemenu2.default;

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tariffspanel = __webpack_require__(478);
	
	var _tariffspanel2 = _interopRequireDefault(_tariffspanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_tariffspanel2.default.install = function (Vue) {
	  Vue.component(_tariffspanel2.default.name, _tariffspanel2.default);
	};
	
	exports.default = _tariffspanel2.default;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _usermenu = __webpack_require__(479);
	
	var _usermenu2 = _interopRequireDefault(_usermenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_usermenu2.default.install = function (Vue) {
	  Vue.component(_usermenu2.default.name, _usermenu2.default);
	};
	
	exports.default = _usermenu2.default;

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(184);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	
	exports.default = [{
	  name: 'start',
	  path: '/',
	  meta: {
	    title: _vue2.default.t('generic.login.title'),
	    authorize: false
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'login',
	  path: '/login',
	  meta: {
	    title: _vue2.default.t('generic.login.title'),
	    authorize: false
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(8/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'logout',
	  path: '/logout',
	  meta: {
	    title: _vue2.default.t('generic.login.title'),
	    authorize: false
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(8/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'generic.error.ErrorPage',
	  path: '/error',
	  meta: {
	    title: _vue2.default.t('generic.errors.title'),
	    authorize: false
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(446)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.unit',
	  path: '/unit/overview/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.unit.titles.overview'),
	    sidemenu: true,
	    prefix: 'UNI_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(462)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.unit.create',
	  path: '/unit/create',
	  meta: {
	    title: _vue2.default.t('management.unit.titles.create'),
	    actionButtonText: 'Create'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(93)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.unit.read',
	  path: '/unit/read/:uuid',
	  meta: {
	    title: _vue2.default.t('management.unit.titles.read'),
	    sidemenu: true,
	    actionButtonText: 'Read'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(463)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  props: true
	}, {
	  name: 'management.unit.readsettings',
	  path: '/unit/readsettings/:uuid',
	  meta: {
	    title: _vue2.default.t('management.unit.titles.readsettings'),
	    sidemenu: true,
	    actionButtonText: 'Read settings',
	    readOnly: true
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(93)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.unit.update',
	  path: '/unit/update/:uuid',
	  meta: {
	    title: _vue2.default.t('management.unit.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(93)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.unit.preview',
	  path: '/unit/preview/:uuid',
	  meta: {
	    title: _vue2.default.t('management.unit.titles.preview'),
	    actionButtonText: 'Preview',
	    readOnly: true
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(93)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.unit.inventory',
	  path: '/unit/inventory/:uuid',
	  meta: {
	    title: _vue2.default.t('management.unit.titles.inventory'),
	    actionButtonText: 'Inventory'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(461)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.organization',
	  path: '/organization/overview/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.organization.titles.overview'),
	    sidemenu: true,
	    prefix: 'ORG_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(456)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.organization.create',
	  path: '/organization/create',
	  meta: {
	    title: _vue2.default.t('management.organization.titles.create'),
	    actionButtonText: 'Create'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.organization.jobs',
	  path: '/organization/jobs/:uuid',
	  meta: {
	    title: _vue2.default.t('management.organization.titles.jobs'),
	    actionButtonText: 'Jobs'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(455)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.organization.update',
	  path: '/organization/update/:uuid',
	  meta: {
	    title: _vue2.default.t('management.organization.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(6/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.organization.readsettings',
	  path: '/organization/readsettings/:uuid',
	  meta: {
	    title: _vue2.default.t('management.organization.titles.readsettings'),
	    sidemenu: true,
	    actionButtonText: 'Read settings',
	    readOnly: true
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(6/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.till',
	  path: '/till/overview/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.till.titles.overview'),
	    sidemenu: true,
	    prefix: 'TIL_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(459)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.till.create',
	  path: '/till/create/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.till.titles.create'),
	    actionButtonText: 'Create'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.till.update',
	  path: '/till/update/:uuid',
	  meta: {
	    title: _vue2.default.t('management.till.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(4/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.till.read',
	  path: '/till/read/:uuid',
	  meta: {
	    title: _vue2.default.t('management.till.titles.read'),
	    sidemenu: true,
	    actionButtonText: 'Read',
	    readOnly: true
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(4/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  props: true
	}, {
	  name: 'management.user',
	  path: '/user/overview/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.user.titles.overview'),
	    sidemenu: true,
	    prefix: 'USR_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(467)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.user.readsettings',
	  path: '/user/readsettings/:uuid',
	  meta: {
	    title: _vue2.default.t('management.user.titles.readsettings'),
	    sidemenu: true,
	    prefix: 'USR_',
	    readOnly: true
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.user.create',
	  path: '/user/create/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.user.titles.create'),
	    actionButtonText: 'Create'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.user.update',
	  path: '/user/update/:uuid',
	  meta: {
	    title: _vue2.default.t('management.user.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.user.change-password',
	  path: '/user/change-password',
	  meta: {
	    title: _vue2.default.t('management.user.titles.changepassword'),
	    actionButtonText: 'Save'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(464)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.user.change-pincode',
	  path: '/user/change-pincode',
	  meta: {
	    title: _vue2.default.t('management.user.titles.changepincodes'),
	    actionButtonText: 'Save'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(465)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.user.update-profile',
	  path: '/user/update-profile',
	  meta: {
	    title: _vue2.default.t('management.user.titles.updateprofile'),
	    actionButtonText: 'Save'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(469)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'forgotPassword',
	  path: '/forgotPassword',
	  meta: {
	    title: _vue2.default.t('management.user.titles.forgotpassword'),
	    authorize: false
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(466)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'resetPassword',
	  path: '/resetPassword/:id/:token',
	  meta: {
	    title: _vue2.default.t('management.user.titles.resetpassword'),
	    authorize: false
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(468)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.location',
	  path: '/location/overview/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.location.titles.overview'),
	    sidemenu: true,
	    prefix: 'LOC_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(451)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.location.create',
	  path: '/location/create',
	  meta: {
	    title: _vue2.default.t('management.location.titles.create'),
	    actionButtonText: 'Create'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.location.readsettings',
	  path: '/location/readsettings/:uuid',
	  meta: {
	    title: _vue2.default.t('management.location.titles.readsettings'),
	    sidemenu: true,
	    actionButtonText: 'Read settings',
	    readOnly: true
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(5/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.location.update',
	  path: '/location/update/:uuid',
	  meta: {
	    title: _vue2.default.t('management.location.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(5/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.mix',
	  path: '/mix/overview/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.mix.titles.overview'),
	    actionButtonText: 'Overview',
	    sidemenu: true,
	    prefix: 'MIX_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(452)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.mix.create',
	  path: '/mix/create/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.mix.titles.create'),
	    actionButtonText: 'Create'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(185)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.mix.update',
	  path: '/mix/edit/:uuid',
	  meta: {
	    title: _vue2.default.t('management.mix.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(9/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(185)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.mix.read',
	  path: '/mix/read/:uuid',
	  meta: {
	    title: _vue2.default.t('management.mix.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(453)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.notification.read',
	  path: '/notifications/read/:unitUuid/:index',
	  meta: {
	    title: _vue2.default.t('management.notification.titles.read'),
	    actionButtonText: 'Read'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(454)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.report',
	  path: '/report/overview',
	  meta: {
	    title: _vue2.default.t('management.report.titles.overview'),
	    actionButtonText: 'createReport',
	    prefix: 'REP_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(457)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.cit',
	  path: '/cit/overview/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.cit.titles.overview'),
	    sidemenu: true,
	    prefix: 'SET_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(32, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(448)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.cit.create',
	  path: '/cit/create',
	  meta: {
	    title: _vue2.default.t('management.cit.titles.create'),
	    actionButtonText: 'Create'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.cit.readsettings',
	  path: '/cit/readsettings/:uuid',
	  meta: {
	    title: _vue2.default.t('management.cit.titles.readsettings'),
	    sidemenu: true,
	    actionButtonText: 'Read settings',
	    readOnly: true
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.cit.update',
	  path: '/cit/update/:uuid',
	  meta: {
	    title: _vue2.default.t('management.cit.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.department',
	  path: '/department/overview/:uuid?',
	  meta: {
	    title: _vue2.default.t('management.department.titles.overview'),
	    sidemenu: true,
	    prefix: 'DEP_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(450)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.department.create',
	  path: '/department/create',
	  meta: {
	    title: _vue2.default.t('management.department.titles.create'),
	    actionButtonText: 'Create'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.department.preview',
	  path: '/department/preview/:uuid',
	  meta: {
	    title: _vue2.default.t('management.department.titles.preview'),
	    actionButtonText: 'Preview',
	    readOnly: true
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(7/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.department.update',
	  path: '/department/update/:uuid',
	  meta: {
	    title: _vue2.default.t('management.department.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(7/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.softwaresettings',
	  path: '/softwaresettings/overview/',
	  meta: {
	    title: _vue2.default.t('management.softwaresettings.titles.overview'),
	    sidemenu: true,
	    prefix: 'SET_'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(458)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.softwaresettings.create',
	  path: '/softwaresettings/create',
	  meta: {
	    title: _vue2.default.t('management.softwaresettings.titles.create'),
	    actionButtonText: 'Create'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.softwaresettings.update',
	  path: '/softwaresettings/update/:orgUuid/:unitTypeUuid',
	  meta: {
	    title: _vue2.default.t('management.softwaresettings.titles.update'),
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(3/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.softwaresettings.readsettings',
	  path: '/softwaresettings/readsettings/:orgUuid/:unitTypeUuid',
	  meta: {
	    title: _vue2.default.t('management.softwaresettings.titles.readsettings'),
	    sidemenu: true,
	    readOnly: true
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(3/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.transaction.read',
	  path: '/transaction/read/:unitUuid/:uuid',
	  meta: {
	    title: _vue2.default.t('management.transaction.read'),
	    actionButtonText: 'Read'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(460)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.unit.campaign.read',
	  path: '/cit/read/:uuid/:groupedCampaigns',
	  meta: {
	    title: _vue2.default.t('management.unit.campaign.read'),
	    actionButtonText: 'Read'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(449)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: 'management.adminsettings',
	  path: '/adminsettings/overview/',
	  meta: {
	    title: _vue2.default.t('management.adminsettings.titles.overview'),
	    sidemenu: true,
	    prefix: 'ADM_',
	    actionButtonText: 'Update'
	  },
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(447)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(184);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.use(__webpack_require__(186));
	
	_vue2.default.locale('en', __webpack_require__(415));
	_vue2.default.locale('nl', __webpack_require__(417));
	_vue2.default.locale('fr', __webpack_require__(416));
	_vue2.default.locale('de', __webpack_require__(414));
	_vue2.default.locale('sk', __webpack_require__(419));
	_vue2.default.locale('pl', __webpack_require__(418));
	
	var storage = window.localStorage.getItem('lang');
	if (storage === null) {
	  _vue2.default.config.lang = 'en';
	  window.localStorage.setItem('lang', _vue2.default.config.lang);
	} else {
	  _vue2.default.config.lang = storage;
	}

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namespaced = true;
	
	var state = {
	  denominationsForCurrency: []
	};
	
	var mutations = {
	  setDenominationsForCurrency: function setDenominationsForCurrency(state, data) {
	    state.denominationsForCurrency = data.denominationsForCurrency;
	  }
	};
	
	var getters = {
	  getDenominationsForCurrency: function getDenominationsForCurrency(state) {
	    return state;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(8);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _router = __webpack_require__(73);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespaced = true;
	
	var state = {
	  simpleTree: 'simpletree'
	};
	
	var mutations = {
	  setOrganizationSimpleTree: function setOrganizationSimpleTree(state, credentials) {
	    if (_index2.default.getJwtToken()) {
	      _index2.default.endpoints.organization.getSimpleTree().then(function (response) {
	        if (response.status === 200) {
	          state.simpleTree = response.body;
	        }
	      }, function (response) {
	        _router2.default.push({
	          name: 'generic.error.ErrorPage',
	          params: {
	            error_response: {
	              error_message: 'could_not_load'
	            }
	          }
	        });
	      });
	    }
	  }
	};
	
	var getters = {
	  getOrganizationSimpleTree: function getOrganizationSimpleTree(state) {
	    return state.simpleTree;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namespaced = true;
	
	var state = {
	  acceptablesSetting: {}
	};
	
	var mutations = {
	  setOverrideAcceptablesSetting: function setOverrideAcceptablesSetting(state, data) {
	    state.acceptablesSetting = data.acceptablesSetting;
	  }
	};
	
	var getters = {
	  getOverrideAcceptablesSetting: function getOverrideAcceptablesSetting(state) {
	    return state;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namespaced = true;
	
	var state = {
	  coinDistributionSetting: {}
	};
	
	var mutations = {
	  setOverrideCoinDistributionSetting: function setOverrideCoinDistributionSetting(state, data) {
	    state.coinDistributionSetting = data.coinDistributionSetting;
	  }
	};
	
	var getters = {
	  getOverrideCoinDistributionSetting: function getOverrideCoinDistributionSetting(state) {
	    return state;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namespaced = true;
	
	var state = {
	  inventorySettings: {}
	};
	
	var mutations = {
	  setOverrideInventorySettings: function setOverrideInventorySettings(state, data) {
	    state.inventorySettings = data.inventorySettings;
	  }
	};
	
	var getters = {
	  getOverrideInventorySettings: function getOverrideInventorySettings(state) {
	    return state;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namespaced = true;
	
	var state = {
	  minimumOrderCoinRollsSettings: {}
	};
	
	var mutations = {
	  setOverrideMinimumOrderCoinRollsSettings: function setOverrideMinimumOrderCoinRollsSettings(state, data) {
	    state.minimumOrderCoinRollsSettings = data.minimumOrderCoinRollsSettings;
	  }
	};
	
	var getters = {
	  getOverrideMinimumOrderCoinRollsSettings: function getOverrideMinimumOrderCoinRollsSettings(state) {
	    return state;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namespaced = true;
	
	var state = {
	  inventorySettings: [],
	  recyclerSettings: []
	};
	
	var mutations = {
	  setOverrideOm61InventorySettings: function setOverrideOm61InventorySettings(state, data) {
	    state.inventorySettings = data.inventorySettings;
	    state.recyclerSettings = data.recyclerSettings;
	  }
	};
	
	var getters = {
	  getOverrideOm61InventorySettings: function getOverrideOm61InventorySettings(state) {
	    return state;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namespaced = true;
	
	var state = {
	  settings: {}
	};
	
	var mutations = {
	  setOverrideSettings: function setOverrideSettings(state, data) {
	    state.settings = data.settings;
	  }
	};
	
	var getters = {
	  getOverrideSettings: function getOverrideSettings(state) {
	    return state;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namespaced = true;
	
	var state = {
	  tariffs: {}
	};
	
	var mutations = {
	  setOverrideTariffSettings: function setOverrideTariffSettings(state, data) {
	    state.tariffs = data;
	  }
	};
	
	var getters = {
	  getOverrideTariffSettings: function getOverrideTariffSettings(state) {
	    return state;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(66);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(43);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(50);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _slicedToArray2 = __webpack_require__(145);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _elementUi = __webpack_require__(89);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _index = __webpack_require__(8);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _router = __webpack_require__(73);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespaced = true;
	
	var state = {
	  currentSession: {
	    state: 'undefined',
	    visible: false,
	    createdAt: 0,
	    loadedAt: 0,
	    refreshingAt: 0,
	    data: {
	      session: {},
	      user: undefined
	    },
	    type: '',
	    roles: {},
	    parentUuids: {}
	  }
	};
	
	function handleAuthLogin(response) {
	  if (response.status === 200 && response.body.message) {
	    var _response$body$messag = (0, _slicedToArray3.default)(response.body.message, 2),
	        token = _response$body$messag[0],
	        refreshToken = _response$body$messag[1];
	
	    if (!token || !refreshToken) {
	      state.currentSession.state = 'error';
	      return;
	    }
	    var authData = {
	      jwt_token: token,
	      refresh_token: refreshToken,
	      createdAt: new Date().getTime()
	    };
	    window.localStorage.setItem('vega', (0, _stringify2.default)(authData));
	    window.localStorage.setItem('id_token', token);
	    window.localStorage.setItem('id_refresh_token', refreshToken);
	    window.localStorage.setItem('id_token_created_at', new Date().getTime());
	    state.currentSession.loadedAt = Date.now();
	    state.currentSession.data.session = { id_token: token };
	
	    state.currentSession.state = 'undefined';
	
	    _router2.default.push({ name: 'management.unit' });
	  } else {
	    state.currentSession.state = 'error';
	  }
	}
	
	function handleAuthLoginError(response) {
	  if (response.body && response.body.msgId === 'MFA_REQUIRED') {
	    window.localStorage.setItem('mfaTemporalToken', response.body.data);
	    _router2.default.push({ query: (0, _extends3.default)({}, _router2.default.query, { mfa: 'true' }) });
	    return;
	  }
	
	  state.currentSession.state = 'error';
	  if (response.body.message[0] === 'LOCKED') {
	    state.currentSession.data.error = { message: _vue2.default.t('server_messages.LOCKED') };
	  } else {
	    state.currentSession.data.error = { message: _vue2.default.t('server_messages.INVALID_CREDENTIALS') };
	  }
	}
	
	var decodeToken = function decodeToken(token) {
	  try {
	    var payload = token.split('.')[1];
	    return JSON.parse(window.atob(payload));
	  } catch (e) {
	    return null;
	  }
	};
	
	function getJwtToken() {
	  var idToken = window.localStorage.getItem('id_token');
	  if (!idToken) {
	    var vegaData = window.localStorage.getItem('vega');
	    if (vegaData) {
	      var _JSON$parse = JSON.parse(vegaData),
	          jwtToken = _JSON$parse.jwt_token;
	
	      idToken = jwtToken;
	    }
	  }
	  return idToken;
	}
	
	function getRefreshToken() {
	  var refreshToken = window.localStorage.getItem('id_refresh_token');
	  if (!refreshToken) {
	    var vegaData = window.localStorage.getItem('vega');
	    if (vegaData) {
	      var _JSON$parse2 = JSON.parse(vegaData),
	          idRefreshToken = _JSON$parse2.refresh_token;
	
	      refreshToken = idRefreshToken;
	    }
	  }
	  return refreshToken;
	}
	
	var mutations = {
	  authLogin: function authLogin(state, credentials) {
	    state.currentSession.state = 'loading';
	    _index2.default.endpoints.auth.authLogin(credentials).then(function (response) {
	      handleAuthLogin(response);
	    }, function (response) {
	      handleAuthLoginError(response);
	    });
	  },
	  authLoginMfa: function authLoginMfa(state, mfaRequest) {
	    state.currentSession.state = 'loading';
	    _index2.default.endpoints.auth.authLoginMfa(mfaRequest).then(function (response) {
	      handleAuthLogin(response);
	    }, function (response) {
	      handleAuthLoginError(response);
	    });
	  },
	  sessionError: function sessionError(state) {
	    window.localStorage.removeItem('vega');
	    window.localStorage.removeItem('id_token');
	    window.localStorage.removeItem('id_token_created_at');
	
	    state.currentSession.data.error = { message: _vue2.default.t('server_messages.INVALID_CREDENTIALS') };
	
	    if (state.currentSession.state === 'logout') {
	      state.currentSession.data.error = { message: _vue2.default.t('server_messages.LOGOUT') };
	    }
	
	    if (state.currentSession.state !== 'loading') {
	      state.currentSession.data.error = { message: _vue2.default.t('server_messages.UNAUTHORIZED') };
	    }
	
	    state.currentSession.state = 'error';
	    _elementUi2.default.Message.warning({ message: state.currentSession.data.error.message });
	  },
	  clearSessionSilent: function clearSessionSilent(state) {
	    window.localStorage.removeItem('vega');
	    window.localStorage.removeItem('id_token');
	    window.localStorage.removeItem('id_token_created_at');
	    window.localStorage.removeItem('id_refresh_token');
	
	    state.currentSession.data = {
	      session: {},
	      user: undefined
	    };
	    state.currentSession.roles = {};
	    state.currentSession.state = 'logout';
	  },
	  logoutCurrentSession: function logoutCurrentSession(state) {
	    if (getJwtToken()) {
	      _index2.default.endpoints.auth.logout(getRefreshToken()).then(function (response) {
	        window.localStorage.removeItem('vega');
	        window.localStorage.removeItem('id_token');
	        window.localStorage.removeItem('id_token_created_at');
	        window.localStorage.removeItem('id_refresh_token');
	        state.currentSession.data = {
	          session: {},
	          user: undefined
	        };
	        state.currentSession.roles = {};
	        state.currentSession.state = 'logout';
	        window.location.reload(true);
	      }, function (err) {
	        console.log('err', err);
	        window.localStorage.removeItem('vega');
	        window.localStorage.removeItem('id_token');
	        window.localStorage.removeItem('id_token_created_at');
	        state.currentSession.data = {
	          session: {},
	          user: undefined
	        };
	        state.currentSession.roles = {};
	        state.currentSession.state = 'logout';
	      });
	    }
	  },
	  checkSession: function checkSession(state, options) {
	    if (state.currentSession.state === 'undefined') {
	      var token = getJwtToken();
	
	      var currentRoute = window.location.pathname;
	      var resetPasswordForm = currentRoute.includes('resetPassword');
	
	      if (!token && !resetPasswordForm) {
	        _router2.default.push({
	          name: 'login'
	        });
	      }
	
	      var idToken = window.localStorage.getItem('id_token');
	      state.currentSession.state = 'loading';
	      state.currentSession.data.session = { id_token: token };
	
	      var jwtPayload = null;
	      if (!resetPasswordForm) {
	        if (idToken) {
	          jwtPayload = decodeToken(idToken);
	        }
	
	        if (jwtPayload && jwtPayload.sub && jwtPayload.name) {
	          state.currentSession.data.user = {
	            uuid: jwtPayload.sub && jwtPayload.sub.startsWith('f:') ? jwtPayload.sub.split(':')[2] : jwtPayload.sub,
	            name: jwtPayload.name
	          };
	          _index2.default.endpoints.user.getGet({ uuid: state.currentSession.data.user.uuid }).then(function (userDetailsResponse) {
	            state.currentSession.state = 'ready';
	            state.currentSession.data.user = (0, _assign2.default)(state.currentSession.data.user, userDetailsResponse.body);
	            state.currentSession.loadedAt = Date.now();
	          }, function (error) {
	            state.currentSession.state = 'error';
	            state.currentSession.data.error = error;
	            _router2.default.push({
	              name: 'login'
	            });
	          });
	        } else {
	          _index2.default.endpoints.user.getWhoAmI().then(function (whoIAmResponse) {
	            state.currentSession.data.user = whoIAmResponse.body;
	
	            _index2.default.endpoints.user.getGet({ uuid: state.currentSession.data.user.uuid }).then(function (userDetailsResponse) {
	              state.currentSession.state = 'ready';
	              state.currentSession.data.user = (0, _assign2.default)(state.currentSession.data.user, userDetailsResponse.body);
	              state.currentSession.loadedAt = Date.now();
	            }, function (error) {
	              state.currentSession.state = 'error';
	              state.currentSession.data.error = error;
	              _router2.default.push({
	                name: 'login'
	              });
	            });
	          }, function (whoIAmResponse) {
	            state.currentSession.state = 'error';
	            _router2.default.push({
	              name: 'login'
	            });
	          });
	        }
	      } else {
	        state.currentSession.data.error = { message: 'Unauthorized access or an expired session' };
	      }
	    }
	  },
	  setRoles: function setRoles(state, roles) {
	    state.currentSession.roles = roles;
	  }
	};
	
	var getters = {
	  getCurrentSession: function getCurrentSession(state) {
	    return state.currentSession;
	  }
	};
	
	exports.default = {
	  namespaced: namespaced,
	  state: state,
	  mutations: mutations,
	  getters: getters
	};

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(23);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(32);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(50);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(66);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONFIG = {
	  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
	  MINUTE_TOKENS: ['mm', 'm'],
	  SECOND_TOKENS: ['ss', 's'],
	  APM_TOKENS: ['A', 'a'],
	  BASIC_TYPES: ['hour', 'minute', 'second', 'apm']
	};
	
	var DEFAULT_OPTIONS = {
	  format: 'HH:mm',
	  minuteInterval: 1,
	  secondInterval: 1,
	  hourRange: null,
	  minuteRange: null,
	  secondRange: null,
	  hideDisabledHours: false,
	  hideDisabledMinutes: false,
	  hideDisabledSeconds: false,
	  hideDisabledItems: false,
	  hideDropdown: false,
	  blurDelay: 300,
	  manualInputTimeout: 1000,
	  dropOffsetHeight: 160
	};
	
	exports.default = {
	  name: 'VueTimepicker',
	  props: {
	    value: { type: [Object, String] },
	    format: { type: String },
	    minuteInterval: { type: [Number, String] },
	    secondInterval: { type: [Number, String] },
	
	    hourRange: { type: Array },
	    minuteRange: { type: Array },
	    secondRange: { type: Array },
	
	    hideDisabledHours: { type: Boolean, default: false },
	    hideDisabledMinutes: { type: Boolean, default: false },
	    hideDisabledSeconds: { type: Boolean, default: false },
	    hideDisabledItems: { type: Boolean, default: false },
	
	    hideClearButton: { type: Boolean, default: false },
	    disabled: { type: Boolean, default: false },
	    closeOnComplete: { type: Boolean, default: false },
	
	    id: { type: String },
	    name: { type: String },
	    inputClass: { type: [String, Object, Array] },
	    placeholder: { type: String },
	    tabindex: { type: [Number, String], default: 0 },
	    inputWidth: { type: String },
	    autocomplete: { type: String, default: 'off' },
	
	    hourLabel: { type: String },
	    minuteLabel: { type: String },
	    secondLabel: { type: String },
	    apmLabel: { type: String },
	    amText: { type: String },
	    pmText: { type: String },
	
	    blurDelay: { type: [Number, String] },
	    advancedKeyboard: { type: Boolean, default: false },
	
	    lazy: { type: Boolean, default: false },
	    autoScroll: { type: Boolean, default: false },
	
	    dropDirection: { type: String, default: 'down' },
	    dropOffsetHeight: { type: [Number, String] },
	    containerId: { type: String },
	    appendToBody: { type: Boolean, default: false },
	
	    manualInput: { type: Boolean, default: false },
	    manualInputTimeout: { type: [Number, String] },
	    hideDropdown: { type: Boolean, default: false },
	    fixedDropdownButton: { type: Boolean, default: false },
	
	    debugMode: { type: Boolean, default: false }
	  },
	
	  data: function data() {
	    return {
	      timeValue: {},
	
	      hours: [],
	      minutes: [],
	      seconds: [],
	      apms: [],
	
	      isActive: false,
	      showDropdown: false,
	      isFocusing: false,
	      debounceTimer: undefined,
	
	      hourType: 'HH',
	      minuteType: 'mm',
	      secondType: '',
	      apmType: '',
	      hour: '',
	      minute: '',
	      second: '',
	      apm: '',
	      fullValues: undefined,
	      bakDisplayTime: undefined,
	      doClearApmChecking: false,
	
	      selectionTimer: undefined,
	      kbInputTimer: undefined,
	      kbInputLog: '',
	      bakCurrentPos: undefined,
	      forceDropOnTop: false
	    };
	  },
	
	
	  computed: {
	    opts: function opts() {
	      var options = (0, _assign2.default)({}, DEFAULT_OPTIONS);
	
	      if (this.format && this.format.length) {
	        options.format = String(this.format);
	      }
	
	      if (this.isNumber(this.minuteInterval)) {
	        options.minuteInterval = +this.minuteInterval;
	      }
	
	      if (!options.minuteInterval || options.minuteInterval < 1 || options.minuteInterval > 60) {
	        if (this.debugMode) {
	          if (options.minuteInterval > 60) {
	            this.debugLog('"minute-interval" should be less than 60. Current value is ' + this.minuteInterval);
	          } else if (options.minuteInterval === 0 || options.minuteInterval < 1) {
	            this.debugLog('"minute-interval" should be NO less than 1. Current value is ' + this.minuteInterval);
	          }
	        }
	        if (options.minuteInterval === 0) {
	          options.minuteInterval = 60;
	        } else {
	          options.minuteInterval = 1;
	        }
	      }
	
	      if (this.isNumber(this.secondInterval)) {
	        options.secondInterval = +this.secondInterval;
	      }
	
	      if (!options.secondInterval || options.secondInterval < 1 || options.secondInterval > 60) {
	        if (this.debugMode) {
	          if (options.secondInterval > 60) {
	            this.debugLog('"second-interval" should be less than 60. Current value is ' + this.secondInterval);
	          } else if (options.secondInterval === 0 || options.secondInterval < 1) {
	            this.debugLog('"second-interval" should be NO less than 1. Current value is ' + this.secondInterval);
	          }
	        }
	        if (options.secondInterval === 0) {
	          options.secondInterval = 60;
	        } else {
	          options.secondInterval = 1;
	        }
	      }
	
	      if (this.hourRange && Array.isArray(this.hourRange)) {
	        options.hourRange = JSON.parse((0, _stringify2.default)(this.hourRange));
	        if (!this.hourRange.length && this.debugMode) {
	          this.debugLog('The "hour-range" array is empty (length === 0)');
	        }
	      }
	
	      if (this.minuteRange && Array.isArray(this.minuteRange)) {
	        options.minuteRange = JSON.parse((0, _stringify2.default)(this.minuteRange));
	        if (!this.minuteRange.length && this.debugMode) {
	          this.debugLog('The "minute-range" array is empty (length === 0)');
	        }
	      }
	
	      if (this.secondRange && Array.isArray(this.secondRange)) {
	        options.secondRange = JSON.parse((0, _stringify2.default)(this.secondRange));
	        if (!this.secondRange.length && this.debugMode) {
	          this.debugLog('The "second-range" array is empty (length === 0)');
	        }
	      }
	
	      if (this.hideDisabledItems) {
	        options.hideDisabledItems = true;
	      }
	
	      if (this.hideDisabledHours || this.hideDisabledItems) {
	        options.hideDisabledHours = true;
	      }
	      if (this.hideDisabledMinutes || this.hideDisabledItems) {
	        options.hideDisabledMinutes = true;
	      }
	      if (this.hideDisabledSeconds || this.hideDisabledItems) {
	        options.hideDisabledSeconds = true;
	      }
	
	      if (this.hideDropdown) {
	        if (this.manualInput) {
	          options.hideDropdown = true;
	        } else if (this.debugMode) {
	          this.debugLog('"hide-dropdown" only works with "manual-input" mode');
	        }
	      }
	
	      if (this.blurDelay && +this.blurDelay > 0) {
	        options.blurDelay = +this.blurDelay;
	      }
	
	      if (this.manualInputTimeout && +this.manualInputTimeout > 0) {
	        options.manualInputTimeout = +this.manualInputTimeout;
	      }
	
	      if (this.dropOffsetHeight && +this.dropOffsetHeight > 0) {
	        options.dropOffsetHeight = +this.dropOffsetHeight;
	      }
	
	      return options;
	    },
	    useStringValue: function useStringValue() {
	      return typeof this.value === 'string';
	    },
	    formatString: function formatString() {
	      return this.opts.format || DEFAULT_OPTIONS.format;
	    },
	    inUse: function inUse() {
	      var _this = this;
	
	      var typesInUse = CONFIG.BASIC_TYPES.filter(function (type) {
	        return _this.getTokenByType(type);
	      });
	
	      typesInUse.sort(function (l, r) {
	        return _this.formatString.indexOf(_this.getTokenByType(l) || null) - _this.formatString.indexOf(_this.getTokenByType(r) || null);
	      });
	      var tokensInUse = typesInUse.map(function (type) {
	        return _this.getTokenByType(type);
	      });
	      return {
	        hour: !!this.hourType,
	        minute: !!this.minuteType,
	        second: !!this.secondType,
	        apm: !!this.apmType,
	        types: typesInUse || [],
	        tokens: tokensInUse || []
	      };
	    },
	    displayTime: function displayTime() {
	      var formatString = String(this.formatString);
	      if (this.hour) {
	        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
	      }
	      if (this.minute) {
	        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
	      }
	      if (this.second && this.secondType) {
	        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
	      }
	      if (this.apm && this.apmType) {
	        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
	      }
	      return formatString;
	    },
	    customDisplayTime: function customDisplayTime() {
	      if (!this.amText && !this.pmText) {
	        return this.displayTime;
	      }
	      return this.displayTime.replace(new RegExp(this.apm, 'g'), this.apmDisplayText(this.apm));
	    },
	    inputIsEmpty: function inputIsEmpty() {
	      return this.formatString === this.displayTime;
	    },
	    allValueSelected: function allValueSelected() {
	      if (this.inUse.hour && !this.hour || this.inUse.minute && !this.minute || this.inUse.second && !this.second || this.inUse.apm && !this.apm) {
	        return false;
	      }
	      return true;
	    },
	    columnsSequence: function columnsSequence() {
	      return this.inUse.types.map(function (type) {
	        return type;
	      }) || [];
	    },
	    showClearBtn: function showClearBtn() {
	      if (this.hideClearButton || this.disabled) {
	        return false;
	      }
	      return !this.inputIsEmpty;
	    },
	    showDropdownBtn: function showDropdownBtn() {
	      if (this.fixedDropdownButton) {
	        return true;
	      }
	      if (this.opts.hideDropdown && this.isActive && !this.showDropdown) {
	        return true;
	      }
	      return false;
	    },
	    baseOn12Hours: function baseOn12Hours() {
	      return this.hourType === 'h' || this.hourType === 'hh';
	    },
	    hourRangeIn24HrFormat: function hourRangeIn24HrFormat() {
	      var _this2 = this;
	
	      if (!this.hourType || !this.opts.hourRange) {
	        return false;
	      }
	      if (!this.opts.hourRange.length) {
	        return [];
	      }
	
	      var range = [];
	      this.opts.hourRange.forEach(function (value) {
	        if (value instanceof Array) {
	          if (value.length > 2 && _this2.debugMode) {
	            _this2.debugLog('Nested array within "hour-range" must contain no more than two items. Only the first two items of ' + (0, _stringify2.default)(value) + ' will be taken into account.');
	          }
	
	          var start = value[0];
	          var end = value[1] || value[0];
	
	          if (_this2.is12hRange(start)) {
	            start = _this2.translate12hRange(start);
	          }
	          if (_this2.is12hRange(end)) {
	            end = _this2.translate12hRange(end);
	          }
	
	          for (var i = +start; i <= +end; i++) {
	            if (i < 0 || i > 24) {
	              continue;
	            }
	            if (!range.includes(i)) {
	              range.push(i);
	            }
	          }
	        } else {
	          if (_this2.is12hRange(value)) {
	            value = _this2.translate12hRange(value);
	          } else {
	            value = +value;
	          }
	          if (value < 0 || value > 24) {
	            return;
	          }
	          if (!range.includes(value)) {
	            range.push(value);
	          }
	        }
	      });
	      range.sort(function (l, r) {
	        return l - r;
	      });
	      return range;
	    },
	    restrictedHourRange: function restrictedHourRange() {
	      if (!this.hourRangeIn24HrFormat) {
	        return false;
	      }
	
	      if (this.baseOn12Hours) {
	        var range = this.hourRangeIn24HrFormat.map(function (value) {
	          if (value === 12) {
	            return '12p';
	          } else if (value === 24 || value === 0) {
	            return '12a';
	          }
	          return value > 12 ? value % 12 + 'p' : value + 'a';
	        });
	        return range;
	      }
	
	      return this.hourRangeIn24HrFormat;
	    },
	    validHoursList: function validHoursList() {
	      var _this3 = this;
	
	      if (!this.manualInput) {
	        return false;
	      }
	      if (this.restrictedHourRange) {
	        var list = [];
	        if (this.baseOn12Hours) {
	          list = this.restrictedHourRange.map(function (hr) {
	            var l = hr.substr(0, hr.length - 1);
	            var r = hr.substr(-1);
	            return '' + _this3.formatValue(_this3.hourType, l) + r;
	          });
	          var am12Index = list.indexOf('12a');
	          if (am12Index > 0) {
	            list.unshift(list.splice(am12Index, 1)[0]);
	          }
	          return list;
	        }
	        list = this.restrictedHourRange.map(function (hr) {
	          return _this3.formatValue(_this3.hourType, hr);
	        });
	        if (list.length > 1 && list[0] && list[0] === '24') {
	          list.push(list.shift());
	        }
	        return list;
	      }
	      if (this.baseOn12Hours) {
	        return [].concat([], this.hours.map(function (hr) {
	          return hr + 'a';
	        }), this.hours.map(function (hr) {
	          return hr + 'p';
	        }));
	      }
	      return this.hours;
	    },
	    has: function has() {
	      var result = {
	        customApmText: false
	      };
	      var apmEnabled = !!this.apmType;
	
	      if (apmEnabled && this.hourRangeIn24HrFormat && this.hourRangeIn24HrFormat.length) {
	        var range = [].concat([], this.hourRangeIn24HrFormat);
	        result.am = range.some(function (value) {
	          return value < 12 || value === 24;
	        });
	        result.pm = range.some(function (value) {
	          return value >= 12 && value < 24;
	        });
	      } else {
	        result.am = apmEnabled;
	        result.pm = apmEnabled;
	      }
	      if (this.amText && this.amText.length || this.pmText && this.pmText.length) {
	        result.customApmText = true;
	      }
	      return result;
	    },
	    minuteRangeList: function minuteRangeList() {
	      if (!this.minuteType || !this.opts.minuteRange) {
	        return false;
	      }
	      if (!this.opts.minuteRange.length) {
	        return [];
	      }
	      return this.renderRangeList(this.opts.minuteRange, 'minute');
	    },
	    secondRangeList: function secondRangeList() {
	      if (!this.secondType || !this.opts.secondRange) {
	        return false;
	      }
	      if (!this.opts.secondRange.length) {
	        return [];
	      }
	      return this.renderRangeList(this.opts.secondRange, 'second');
	    },
	    hourLabelText: function hourLabelText() {
	      return this.hourLabel || this.hourType;
	    },
	    minuteLabelText: function minuteLabelText() {
	      return this.minuteLabel || this.minuteType;
	    },
	    secondLabelText: function secondLabelText() {
	      return this.secondLabel || this.secondType;
	    },
	    apmLabelText: function apmLabelText() {
	      return this.apmLabel || this.apmType;
	    },
	    inputWidthStyle: function inputWidthStyle() {
	      if (!this.inputWidth || !this.inputWidth.length) {
	        return;
	      }
	      return {
	        width: this.inputWidth
	      };
	    },
	    tokenRegexBase: function tokenRegexBase() {
	      return this.inUse.tokens.join('|');
	    },
	    tokenChunks: function tokenChunks() {
	      if (!this.manualInput && !this.useStringValue) {
	        return false;
	      }
	
	      var formatString = String(this.formatString);
	      var tokensRegxStr = '(' + this.tokenRegexBase + ')+?';
	      var tokensMatchAll = this.getMatchAllByRegex(formatString, tokensRegxStr);
	
	      var tokenChunks = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(tokensMatchAll), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var tkMatch = _step.value;
	
	          var rawToken = tkMatch[0];
	          var tokenMatchItem = {
	            index: tkMatch.index,
	            token: rawToken,
	            type: this.getTokenType(rawToken),
	            needsCalibrate: rawToken.length < 2,
	            len: (rawToken || '').length
	          };
	          tokenChunks.push(tokenMatchItem);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return tokenChunks;
	    },
	    needsPosCalibrate: function needsPosCalibrate() {
	      if (!this.manualInput) {
	        return false;
	      }
	      return this.tokenChunks.some(function (chk) {
	        return chk.needsCalibrate;
	      });
	    },
	    tokenChunksPos: function tokenChunksPos() {
	      var _this4 = this;
	
	      if (!this.manualInput) {
	        return false;
	      }
	      if (!this.needsPosCalibrate) {
	        return this.tokenChunks.map(function (chk) {
	          return {
	            token: chk.token,
	            type: chk.type,
	            start: chk.index,
	            end: chk.index + chk.len
	          };
	        });
	      }
	      var list = [];
	      var calibrateLen = 0;
	      this.tokenChunks.forEach(function (chk) {
	        var chunkCurrentLen = void 0;
	
	        if (chk.type === 'apm' && _this4.has.customApmText) {
	          if (_this4.apm && _this4.apm.length) {
	            var customApmText = _this4.apm.toLowerCase() === 'am' ? _this4.amText : _this4.pmText;
	            chunkCurrentLen = customApmText && customApmText.length ? customApmText.length : chk.len;
	          } else {
	            chunkCurrentLen = chk.len;
	          }
	        } else {
	          chunkCurrentLen = _this4[chk.type] && _this4[chk.type].length ? _this4[chk.type].length : chk.len;
	        }
	        list.push({
	          token: chk.token,
	          type: chk.type,
	          start: chk.index + calibrateLen,
	          end: chk.index + calibrateLen + chunkCurrentLen
	        });
	        if (chk.needsCalibrate && chunkCurrentLen > chk.len) {
	          calibrateLen += chunkCurrentLen - chk.len;
	        }
	      });
	      return list;
	    },
	    invalidValues: function invalidValues() {
	      if (this.inputIsEmpty) {
	        return [];
	      }
	      if (!this.restrictedHourRange && !this.minuteRangeList && !this.secondRangeList && this.opts.minuteInterval === 1 && this.opts.secondInterval === 1) {
	        return [];
	      }
	
	      var result = [];
	      if (this.inUse.hour && !this.isEmptyValue(this.hourType, this.hour) && (!this.isValidValue(this.hourType, this.hour) || this.isDisabled('hour', this.hour))) {
	        result.push('hour');
	      }
	      if (this.inUse.minute && !this.isEmptyValue(this.minuteType, this.minute) && (!this.isValidValue(this.minuteType, this.minute) || this.isDisabled('minute', this.minute) || this.notInInterval('minute', this.minute))) {
	        result.push('minute');
	      }
	      if (this.inUse.second && !this.isEmptyValue(this.secondType, this.second) && (!this.isValidValue(this.secondType, this.second) || this.isDisabled('second', this.second) || this.notInInterval('second', this.second))) {
	        result.push('second');
	      }
	      if (this.inUse.apm && !this.isEmptyValue(this.apmType, this.apm) && (!this.isValidValue(this.apmType, this.apm) || this.isDisabled('apm', this.apm))) {
	        result.push('apm');
	      }
	      if (result.length) {
	        return result;
	      }
	      return [];
	    },
	    hasInvalidInput: function hasInvalidInput() {
	      return Boolean(this.invalidValues && this.invalidValues.length);
	    },
	    autoDirectionEnabled: function autoDirectionEnabled() {
	      return this.dropDirection === 'auto';
	    },
	    dropdownDirClass: function dropdownDirClass() {
	      if (this.autoDirectionEnabled) {
	        return this.forceDropOnTop ? 'drop-up' : 'drop-down';
	      }
	      return this.dropDirection === 'up' ? 'drop-up' : 'drop-down';
	    }
	  },
	
	  watch: {
	    'opts.format': function optsFormat(newValue) {
	      this.renderFormat(newValue);
	    },
	    'opts.minuteInterval': function optsMinuteInterval(newInteval) {
	      this.renderList('minute', newInteval);
	    },
	    'opts.secondInterval': function optsSecondInterval(newInteval) {
	      this.renderList('second', newInteval);
	    },
	
	    value: {
	      deep: true,
	      handler: function handler() {
	        this.readValues();
	      }
	    },
	    displayTime: function displayTime() {
	      this.fillValues();
	    },
	    disabled: function disabled(toDisabled) {
	      if (toDisabled) {
	        if (this.isActive) {
	          this.isActive = false;
	        }
	        if (this.showDropdown) {
	          this.showDropdown = false;
	        }
	      }
	    },
	    'invalidValues.length': function invalidValuesLength(newLength, oldLength) {
	      if (newLength && newLength >= 1) {
	        this.$emit('error', this.invalidValues);
	      } else if (oldLength && oldLength >= 1) {
	        this.$emit('error', []);
	      }
	    }
	  },
	
	  methods: {
	    formatValue: function formatValue(token, i) {
	      if (!this.isNumber(i)) {
	        return '';
	      }
	      i = +i;
	      switch (token) {
	        case 'H':
	        case 'h':
	        case 'k':
	        case 'm':
	        case 's':
	          if (['h', 'k'].includes(token) && i === 0) {
	            return token === 'k' ? '24' : '12';
	          }
	          return String(i);
	        case 'HH':
	        case 'mm':
	        case 'ss':
	        case 'hh':
	        case 'kk':
	          if (['hh', 'kk'].includes(token) && i === 0) {
	            return token === 'kk' ? '24' : '12';
	          }
	          return i < 10 ? '0' + i : String(i);
	        default:
	          return '';
	      }
	    },
	    checkAcceptingType: function checkAcceptingType(validValues, formatString) {
	      if (!validValues || !formatString || !formatString.length) {
	        return '';
	      }
	      for (var i = 0; i < validValues.length; i++) {
	        if (formatString.indexOf(validValues[i]) > -1) {
	          return validValues[i];
	        }
	      }
	      return '';
	    },
	    renderFormat: function renderFormat(newFormat) {
	      var _this5 = this;
	
	      newFormat = newFormat || this.opts.format || DEFAULT_OPTIONS.format;
	
	      var hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat);
	      var minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat);
	      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
	      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);
	
	      if (!hourType && !minuteType && !this.secondType && !this.apmType) {
	        if (this.debugMode && this.format) {
	          this.debugLog('No valid tokens found in your defined "format" string "' + this.format + '". Fallback to the default "HH:mm" format.');
	        }
	        hourType = 'HH';
	        minuteType = 'mm';
	      }
	      this.hourType = hourType;
	      this.minuteType = minuteType;
	
	      this.hourType ? this.renderHoursList() : this.hours = [];
	      this.minuteType ? this.renderList('minute') : this.minutes = [];
	      this.secondType ? this.renderList('second') : this.seconds = [];
	      this.apmType ? this.renderApmList() : this.apms = [];
	
	      this.$nextTick(function () {
	        _this5.readValues();
	      });
	    },
	    renderHoursList: function renderHoursList() {
	      var hoursCount = this.baseOn12Hours ? 12 : 24;
	      var hours = [];
	      for (var i = 0; i < hoursCount; i++) {
	        if (this.hourType === 'k' || this.hourType === 'kk') {
	          hours.push(this.formatValue(this.hourType, i + 1));
	        } else {
	          hours.push(this.formatValue(this.hourType, i));
	        }
	      }
	      this.hours = hours;
	    },
	    renderList: function renderList(listType, interval) {
	      if (!this.isMinuteOrSecond(listType)) {
	        return;
	      }
	
	      var isMinute = listType === 'minute';
	      interval = interval || (isMinute ? this.opts.minuteInterval || DEFAULT_OPTIONS.minuteInterval : this.opts.secondInterval || DEFAULT_OPTIONS.secondInterval);
	
	      var result = [];
	      for (var i = 0; i < 60; i += interval) {
	        result.push(this.formatValue(isMinute ? this.minuteType : this.secondType, i));
	      }
	      isMinute ? this.minutes = result : this.seconds = result;
	    },
	    renderApmList: function renderApmList() {
	      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
	    },
	    readValues: function readValues() {
	      if (this.useStringValue) {
	        if (this.debugMode) {
	          this.debugLog('Received a string value: "' + this.value + '"');
	        }
	        this.readStringValues(this.value);
	      } else {
	        if (this.debugMode) {
	          this.debugLog('Received an object value: "' + (0, _stringify2.default)(this.value || {}) + '"');
	        }
	        this.readObjectValues(this.value);
	      }
	    },
	    readObjectValues: function readObjectValues(objValue) {
	      var _this6 = this;
	
	      var timeValue = JSON.parse((0, _stringify2.default)(objValue || {}));
	      var values = (0, _keys2.default)(timeValue);
	
	      if (values.length === 0) {
	        this.addFallbackValues();
	        return;
	      }
	
	      CONFIG.BASIC_TYPES.forEach(function (type) {
	        var token = _this6.getTokenByType(type);
	        if (values.indexOf(token) > -1) {
	          var sanitizedValue = _this6.sanitizedValue(token, timeValue[token]);
	          _this6[type] = sanitizedValue;
	          timeValue[token] = sanitizedValue;
	        } else {
	          _this6[type] = '';
	        }
	      });
	      this.timeValue = timeValue;
	    },
	    getMatchAllByRegex: function getMatchAllByRegex(testString, regexString) {
	      var str = 'polyfillTest';
	      var needsPolyfill = Boolean(!str.matchAll || typeof str.matchAll !== 'function');
	      return needsPolyfill ? this.polyfillMatchAll(testString, regexString) : testString.matchAll(new RegExp(regexString, 'g'));
	    },
	    readStringValues: function readStringValues(stringValue) {
	      var _this7 = this;
	
	      if (!stringValue || !stringValue.length) {
	        this.addFallbackValues();
	        return;
	      }
	
	      var formatString = String(this.formatString);
	      var tokensRegxStr = '(' + this.tokenRegexBase + ')+?';
	      var othersRegxStr = '[^(' + this.tokenRegexBase + ')]+';
	
	      var tokensMatchAll = this.getMatchAllByRegex(formatString, tokensRegxStr);
	      var othersMatchAll = this.getMatchAllByRegex(formatString, othersRegxStr);
	
	      var chunks = [];
	      var tokenChunks = [];
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(tokensMatchAll), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var tkMatch = _step2.value;
	
	          var tokenMatchItem = {
	            index: tkMatch.index,
	            token: tkMatch[0],
	            isValueToken: true
	          };
	          chunks.push(tokenMatchItem);
	          tokenChunks.push(tokenMatchItem);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(othersMatchAll), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var otMatch = _step3.value;
	
	          chunks.push({
	            index: otMatch.index,
	            token: otMatch[0]
	          });
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      chunks.sort(function (l, r) {
	        return l.index < r.index ? -1 : 1;
	      });
	
	      var regexCombo = '';
	      chunks.forEach(function (chunk) {
	        if (chunk.isValueToken) {
	          var tokenRegex = _this7.getTokenRegex(chunk.token) || '';
	          regexCombo += tokenRegex;
	        } else {
	          var safeChars = chunk.token.replace(/\\{0}(\*|\?|\.|\+)/g, '\\$1');
	          regexCombo += '(?:' + safeChars + ')';
	        }
	      });
	
	      var comboReg = new RegExp(regexCombo);
	
	      if (comboReg.test(stringValue)) {
	        var matchResults = stringValue.match(new RegExp(regexCombo));
	        var valueResults = matchResults.slice(1, tokenChunks.length + 1);
	        var timeValue = {};
	        valueResults.forEach(function (value, vrIndex) {
	          if (tokenChunks[vrIndex]) {
	            var targetToken = tokenChunks[vrIndex].token;
	            timeValue[targetToken] = _this7.setValueFromString(value, targetToken);
	          }
	        });
	        this.timeValue = timeValue;
	
	        if (this.debugMode) {
	          var tokenChunksForLog = tokenChunks.map(function (tChunk) {
	            return tChunk && tChunk.token;
	          });
	          this.debugLog('Successfully parsed values ' + (0, _stringify2.default)(valueResults) + '\nfor ' + (0, _stringify2.default)(tokenChunksForLog) + '\nin format pattern \'' + this.formatString + '\'');
	        }
	      } else {
	        if (this.debugMode) {
	          this.debugLog('The input string in "v-model" does NOT match the "format" pattern\nformat: ' + this.formatString + '\nv-model: ' + stringValue);
	        }
	      }
	    },
	    polyfillMatchAll: function polyfillMatchAll(targetString, regxStr) {
	      var matchesList = targetString.match(new RegExp(regxStr, 'g'));
	      var result = [];
	      var indicesReg = [];
	      if (matchesList && matchesList.length) {
	        matchesList.forEach(function (matchedItem) {
	          var existIndex = indicesReg.findIndex(function (idxItem) {
	            return idxItem.str === matchedItem;
	          });
	          var index = void 0;
	          if (existIndex >= 0) {
	            if (indicesReg[existIndex] && indicesReg[existIndex].regex) {
	              index = indicesReg[existIndex].regex.exec(targetString).index;
	            }
	          } else {
	            var itemIndicesRegex = new RegExp(matchedItem, 'g');
	            index = itemIndicesRegex.exec(targetString).index;
	            indicesReg.push({
	              str: String(matchedItem),
	              regex: itemIndicesRegex
	            });
	          }
	          result.push({
	            0: String(matchedItem),
	            index: index
	          });
	        });
	      }
	      return result;
	    },
	    addFallbackValues: function addFallbackValues() {
	      var _this8 = this;
	
	      var timeValue = {};
	      this.inUse.types.forEach(function (type) {
	        timeValue[_this8.getTokenByType(type)] = '';
	      });
	      this.timeValue = timeValue;
	    },
	    setValueFromString: function setValueFromString(parsedValue, token) {
	      if (!token || !parsedValue) {
	        return '';
	      }
	      var tokenType = this.getTokenType(token);
	      if (!tokenType || !tokenType.length) {
	        return '';
	      }
	      var stdValue = parsedValue !== this.getTokenByType(tokenType) ? parsedValue : '';
	      this[tokenType] = stdValue;
	      return stdValue;
	    },
	    fillValues: function fillValues(forceEmit) {
	      var _this9 = this;
	
	      var fullValues = {};
	
	      var baseHour = this.hour;
	      var baseHourType = this.hourType;
	
	      var apmValue = void 0;
	
	      if (!baseHourType || !this.isNumber(baseHour)) {
	        CONFIG.HOUR_TOKENS.forEach(function (token) {
	          return fullValues[token] = '';
	        });
	        apmValue = this.lowerCasedApm(this.apm || '');
	        fullValues.a = apmValue;
	        fullValues.A = apmValue.toUpperCase();
	      } else {
	        var hourValue = +baseHour;
	        var _apmValue = this.baseOn12Hours && this.apm ? this.lowerCasedApm(this.apm) : false;
	
	        CONFIG.HOUR_TOKENS.forEach(function (token) {
	          if (token === baseHourType) {
	            fullValues[token] = baseHour;
	            return;
	          }
	
	          var value = void 0;
	          var apm = void 0;
	          switch (token) {
	            case 'H':
	            case 'HH':
	            case 'k':
	            case 'kk':
	              if (_this9.baseOn12Hours) {
	                if (_apmValue === 'pm') {
	                  value = hourValue < 12 ? hourValue + 12 : hourValue;
	                } else if (['k', 'kk'].includes(token)) {
	                  value = hourValue === 12 ? 24 : hourValue;
	                } else {
	                  value = hourValue % 12;
	                }
	              } else {
	                if (['k', 'kk'].includes(token)) {
	                  value = hourValue === 0 ? 24 : hourValue;
	                } else {
	                  value = hourValue % 24;
	                }
	              }
	              fullValues[token] = _this9.formatValue(token, value);
	              break;
	            case 'h':
	            case 'hh':
	              if (_this9.baseOn12Hours) {
	                value = hourValue;
	                apm = _apmValue || '';
	              } else {
	                if (hourValue > 11 && hourValue < 24) {
	                  apm = 'pm';
	                  value = hourValue === 12 ? 12 : hourValue % 12;
	                } else {
	                  apm = 'am';
	                  value = hourValue % 12 === 0 ? 12 : hourValue;
	                }
	              }
	              fullValues[token] = _this9.formatValue(token, value);
	              fullValues.a = apm;
	              fullValues.A = apm.toUpperCase();
	              break;
	          }
	        });
	      }
	
	      fullValues.m = this.formatValue('m', this.minute);
	      fullValues.mm = this.formatValue('mm', this.minute);
	      fullValues.s = this.formatValue('s', this.second);
	      fullValues.ss = this.formatValue('ss', this.second);
	
	      this.fullValues = fullValues;
	
	      if (!this.lazy || forceEmit) {
	        this.emitTimeValue();
	      }
	
	      if (this.closeOnComplete && this.allValueSelected && this.showDropdown) {
	        this.toggleActive();
	      }
	    },
	    getFullData: function getFullData() {
	      if (!this.fullValues) {
	        this.fillValues();
	      }
	      return {
	        data: JSON.parse((0, _stringify2.default)(this.fullValues)),
	        displayTime: this.inputIsEmpty ? '' : String(this.displayTime)
	      };
	    },
	    emitTimeValue: function emitTimeValue() {
	      if (this.lazy && this.bakDisplayTime === this.displayTime) {
	        if (this.debugMode) {
	          this.debugLog('The value does not change on `lazy` mode. Skip the emitting `input` and `change` event.');
	        }
	        return;
	      }
	
	      var fullData = this.getFullData();
	
	      if (this.useStringValue) {
	        this.$emit('input', fullData.displayTime);
	      } else {
	        var fullValues = fullData.data;
	        var tokensInUse = this.inUse.tokens || [];
	        var timeValue = {};
	        tokensInUse.forEach(function (token) {
	          timeValue[token] = fullValues[token] || '';
	        });
	        this.$emit('input', JSON.parse((0, _stringify2.default)(timeValue)));
	      }
	
	      this.$emit('change', fullData);
	    },
	    translate12hRange: function translate12hRange(value) {
	      var valueT = this.match12hRange(value);
	      if (+valueT[1] === 12) {
	        return +valueT[1] + (valueT[2].toLowerCase() === 'p' ? 0 : 12);
	      }
	      return +valueT[1] + (valueT[2].toLowerCase() === 'p' ? 12 : 0);
	    },
	    isDisabled: function isDisabled(type, value) {
	      if (!this.isBasicType(type) || !this.inUse[type]) {
	        return true;
	      }
	      switch (type) {
	        case 'hour':
	          return this.isDisabledHour(value);
	        case 'minute':
	        case 'second':
	          if (!this[type + 'RangeList']) {
	            return false;
	          }
	          return !this[type + 'RangeList'].includes(value);
	        case 'apm':
	          if (!this.restrictedHourRange) {
	            return false;
	          }
	          return !this.has[this.lowerCasedApm(value)];
	        default:
	          return true;
	      }
	    },
	    isDisabledHour: function isDisabledHour(value) {
	      if (!this.restrictedHourRange) {
	        return false;
	      }
	      if (this.baseOn12Hours) {
	        if (!this.apm || !this.apm.length) {
	          return false;
	        } else {
	          var token = this.apm.toLowerCase() === 'am' ? 'a' : 'p';
	          return !this.restrictedHourRange.includes('' + +value + token);
	        }
	      }
	
	      if ((this.hourType === 'HH' || this.hourType === 'H') && +value === 0 && this.restrictedHourRange.includes(24)) {
	        return false;
	      }
	      return !this.restrictedHourRange.includes(+value);
	    },
	    notInInterval: function notInInterval(section, value) {
	      if (!section || !this.isMinuteOrSecond(section)) {
	        return;
	      }
	      if (this.opts[section + 'Interval'] === 1) {
	        return false;
	      }
	      return +value % this.opts[section + 'Interval'] !== 0;
	    },
	    renderRangeList: function renderRangeList(rawRange, section) {
	      var _this10 = this;
	
	      if (!rawRange || !section || !this.isMinuteOrSecond(section)) {
	        return [];
	      }
	      var range = [];
	      var formatedValue = void 0;
	      rawRange.forEach(function (value) {
	        if (value instanceof Array) {
	          if (value.length > 2 && _this10.debugMode) {
	            _this10.debugLog('Nested array within "' + section + '-range" must contain no more than two items. Only the first two items of ' + (0, _stringify2.default)(value) + ' will be taken into account.');
	          }
	          var start = value[0];
	          var end = value[1] || value[0];
	          for (var i = +start; i <= +end; i++) {
	            if (i < 0 || i > 59) {
	              continue;
	            }
	            formatedValue = _this10.formatValue(_this10.getTokenByType(section), i);
	            if (!range.includes(formatedValue)) {
	              range.push(formatedValue);
	            }
	          }
	        } else {
	          if (+value < 0 || +value > 59) {
	            return;
	          }
	          formatedValue = _this10.formatValue(_this10.getTokenByType(section), value);
	          if (!range.includes(formatedValue)) {
	            range.push(formatedValue);
	          }
	        }
	      });
	      range.sort(function (l, r) {
	        return l - r;
	      });
	
	      if (this.debugMode) {
	        var fullList = (section === 'minute' ? this.minutes : this.seconds) || [];
	        var validItems = fullList.filter(function (item) {
	          return range.includes(item);
	        });
	        if (!validItems || !validItems.length) {
	          if (section === 'minute') {
	            this.debugLog('The minute list is empty due to the "minute-range" config\nminute-range: ' + (0, _stringify2.default)(this.minuteRange) + '\nminute-interval: ' + this.opts.minuteInterval);
	          } else {
	            this.debugLog('The second list is empty due to the "second-range" config\nsecond-range: ' + (0, _stringify2.default)(this.secondRange) + '\nsecond-interval: ' + this.opts.secondInterval);
	          }
	        }
	      }
	      return range;
	    },
	    forceApmSelection: function forceApmSelection() {
	      if (this.manualInput) {
	        return;
	      }
	      if (this.apmType && !this.apm) {
	        if (this.has.am || this.has.pm) {
	          this.doClearApmChecking = true;
	          var apmValue = this.has.am ? 'am' : 'pm';
	          this.apm = this.apmType === 'A' ? apmValue.toUpperCase() : apmValue;
	        }
	      }
	    },
	    emptyApmSelection: function emptyApmSelection() {
	      if (this.doClearApmChecking && this.hour === '' && this.minute === '' && this.second === '') {
	        this.apm = '';
	      }
	      this.doClearApmChecking = false;
	    },
	    apmDisplayText: function apmDisplayText(apmValue) {
	      if (this.amText && this.lowerCasedApm(apmValue) === 'am') {
	        return this.amText;
	      }
	      if (this.pmText && this.lowerCasedApm(apmValue) === 'pm') {
	        return this.pmText;
	      }
	      return apmValue;
	    },
	    toggleActive: function toggleActive() {
	      var _this11 = this;
	
	      if (this.disabled) {
	        return;
	      }
	      this.isActive = !this.isActive;
	
	      if (this.isActive) {
	        this.isFocusing = true;
	        if (this.manualInput) {
	          this.$emit('focus');
	        }
	        if (!this.opts.hideDropdown) {
	          this.setDropdownState(true);
	        }
	
	        if (this.lazy) {
	          this.bakDisplayTime = String(this.displayTime || '');
	        }
	        if (this.manualInput && !this.inputIsEmpty) {
	          this.$nextTick(function () {
	            if (_this11.$refs.input && _this11.$refs.input.selectionStart === 0 && _this11.$refs.input.selectionEnd === _this11.displayTime.length) {
	              _this11.selectFirstSlot();
	            }
	          });
	        }
	      } else {
	        if (this.showDropdown) {
	          this.setDropdownState(false);
	        } else if (this.manualInput) {
	          this.$emit('blur', this.getFullData());
	        }
	        this.isFocusing = false;
	        if (this.lazy) {
	          this.fillValues(true);
	          this.bakDisplayTime = undefined;
	        }
	      }
	
	      if (this.restrictedHourRange && this.baseOn12Hours) {
	        this.showDropdown ? this.forceApmSelection() : this.emptyApmSelection();
	      }
	      if (this.showDropdown) {
	        this.checkForAutoScroll();
	      }
	    },
	    setDropdownState: function setDropdownState(toShow) {
	      var fromUserClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (toShow) {
	        if (this.appendToBody) {
	          this.appendDropdownToBody();
	        }
	        this.keepFocusing();
	        if (this.autoDirectionEnabled) {
	          this.checkDropDirection();
	        }
	        this.showDropdown = true;
	        this.$emit('open');
	        if (fromUserClick) {
	          if (this.fixedDropdownButton) {
	            this.isActive = true;
	          }
	          this.$emit('blur', this.getFullData());
	          this.checkForAutoScroll();
	        }
	      } else {
	        this.showDropdown = false;
	        this.$emit('close', this.getFullData());
	        if (this.appendToBody) {
	          this.removeDropdownFromBody();
	        }
	      }
	    },
	    appendDropdownToBody: function appendDropdownToBody() {
	      var dropdown = this.$refs && this.$refs.dropdown;
	      var body = document.getElementsByTagName('body')[0];
	      if (body && dropdown) {
	        window.addEventListener('scroll', this.updateDropdownPos);
	        dropdown.classList.add('vue__time-picker-dropdown');
	        this.updateDropdownPos();
	        body.appendChild(dropdown);
	      }
	    },
	    updateDropdownPos: function updateDropdownPos() {
	      if (!this.appendToBody) {
	        return;
	      }
	      var dropdown = this.$refs && this.$refs.dropdown;
	      var body = document.getElementsByTagName('body')[0];
	      if (body && dropdown) {
	        var box = this.$el.getBoundingClientRect();
	        if (this.dropdownDirClass === 'drop-up') {
	          dropdown.style.bottom = window.innerHeight - box.y + 'px';
	          dropdown.style.top = 'auto';
	        } else {
	          dropdown.style.top = box.y + box.height + 'px';
	          dropdown.style.bottom = 'auto';
	        }
	        dropdown.style.left = box.x + 'px';
	      }
	    },
	    removeDropdownFromBody: function removeDropdownFromBody() {
	      var dropdown = this.$refs && this.$refs.dropdown;
	      var body = document.getElementsByTagName('body')[0];
	      if (body && dropdown && body.contains(dropdown)) {
	        body.removeChild(dropdown);
	      }
	      if (dropdown) {
	        dropdown.classList.remove('vue__time-picker-dropdown');
	        dropdown.style.top = '';
	        dropdown.style.bottom = '';
	        dropdown.style.left = '';
	        this.$el.appendChild(dropdown);
	      }
	      window.removeEventListener('scroll', this.updateDropdownPos);
	    },
	    blurEvent: function blurEvent() {
	      if (this.manualInput && !this.opts.hideDropdown) {
	        this.$emit('blur', this.getFullData());
	      }
	    },
	    select: function select(type, value) {
	      if (this.isBasicType(type) && !this.isDisabled(type, value)) {
	        this[type] = value;
	        if (this.doClearApmChecking) {
	          this.doClearApmChecking = false;
	        }
	      }
	    },
	    clearTime: function clearTime() {
	      if (this.disabled) {
	        return;
	      }
	      this.hour = '';
	      this.minute = '';
	      this.second = '';
	      this.apm = '';
	
	      if (this.manualInput && this.$refs && this.$refs.input && this.$refs.input.value.length) {
	        this.$refs.input.value = '';
	      }
	
	      if (this.lazy) {
	        this.fillValues(true);
	      }
	    },
	    checkForAutoScroll: function checkForAutoScroll() {
	      var _this12 = this;
	
	      if (this.inputIsEmpty) {
	        return;
	      }
	      if (this.autoScroll) {
	        this.$nextTick(function () {
	          _this12.scrollToSelectedValues();
	        });
	      } else if (this.advancedKeyboard) {
	        this.$nextTick(function () {
	          var firstColumn = _this12.inUse.types[0];
	          _this12.scrollToSelected(firstColumn, true);
	        });
	      }
	    },
	    scrollToSelected: function scrollToSelected(column) {
	      var allowFallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!this.timeValue || this.inputIsEmpty) {
	        return;
	      }
	      var targetList = void 0;
	      if (this.appendToBody && this.$refs && this.$refs.dropdown) {
	        targetList = this.$refs.dropdown.querySelectorAll('ul.' + column + 's')[0];
	      } else {
	        targetList = this.$el.querySelectorAll('ul.' + column + 's')[0];
	      }
	      var targetValue = this.activeItemInCol(column)[0];
	      if (!targetValue && allowFallback) {
	        targetValue = this.validItemsInCol(column)[0];
	      }
	      if (targetList && targetValue) {
	        targetList.scrollTop = targetValue.offsetTop || 0;
	        if (this.advancedKeyboard) {
	          targetValue.focus();
	        }
	      }
	    },
	    scrollToSelectedValues: function scrollToSelectedValues() {
	      var _this13 = this;
	
	      if (!this.timeValue || this.inputIsEmpty) {
	        return;
	      }
	      this.inUse.types.forEach(function (section) {
	        _this13.scrollToSelected(section);
	      });
	    },
	    onFocus: function onFocus() {
	      if (this.disabled) {
	        return;
	      }
	      if (!this.isFocusing) {
	        this.isFocusing = true;
	      }
	      if (!this.isActive) {
	        this.toggleActive();
	      }
	    },
	    escBlur: function escBlur() {
	      if (this.disabled) {
	        return;
	      }
	      window.clearTimeout(this.debounceTimer);
	      this.isFocusing = false;
	      var inputBox = this.$el.querySelectorAll('input.display-time')[0];
	      if (inputBox) {
	        inputBox.blur();
	      }
	    },
	    debounceBlur: function debounceBlur() {
	      var _this14 = this;
	
	      if (this.disabled) {
	        return;
	      }
	      this.isFocusing = false;
	      window.clearTimeout(this.debounceTimer);
	      this.debounceTimer = window.setTimeout(function () {
	        window.clearTimeout(_this14.debounceTimer);
	        _this14.onBlur();
	      }, this.opts.blurDelay);
	    },
	    onBlur: function onBlur() {
	      if (!this.disabled && !this.isFocusing && this.isActive) {
	        this.toggleActive();
	      }
	    },
	    keepFocusing: function keepFocusing() {
	      if (this.disabled) {
	        return;
	      }
	      window.clearTimeout(this.debounceTimer);
	      if (!this.isFocusing) {
	        this.isFocusing = true;
	      }
	    },
	    onTab: function onTab(column, value, evt) {
	      if (this.appendToBody && evt.shiftKey) {
	        var firstColumn = this.inUse.types[0];
	        if (column !== firstColumn) {
	          return;
	        }
	        var firstValidValue = this.validItemsInCol(firstColumn)[0];
	
	        if (firstValidValue && firstValidValue.getAttribute('data-key') === String(value)) {
	          evt.preventDefault();
	
	          if (this.$refs && this.$refs.input) {
	            this.$refs.input.focus();
	          }
	        }
	      }
	    },
	    validItemsInCol: function validItemsInCol(column) {
	      var columnClass = column + 's';
	      if (this.appendToBody && this.$refs && this.$refs.dropdown) {
	        return this.$refs.dropdown.querySelectorAll('ul.' + columnClass + ' > li:not(.hint):not([disabled])');
	      }
	      return this.$el.querySelectorAll('ul.' + columnClass + ' > li:not(.hint):not([disabled])');
	    },
	    activeItemInCol: function activeItemInCol(column) {
	      var columnClass = column + 's';
	      if (this.appendToBody && this.$refs && this.$refs.dropdown) {
	        return this.$refs.dropdown.querySelectorAll('ul.' + columnClass + ' > li.active:not(.hint)');
	      }
	      return this.$el.querySelectorAll('ul.' + columnClass + ' > li.active:not(.hint)');
	    },
	    getClosestSibling: function getClosestSibling(column, dataKey) {
	      var getPrevious = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var siblingsInCol = this.validItemsInCol(column);
	      var selfIndex = Array.prototype.findIndex.call(siblingsInCol, function (sbl) {
	        return sbl.getAttribute('data-key') === dataKey;
	      });
	
	      if (getPrevious && selfIndex === 0) {
	        return siblingsInCol[siblingsInCol.length - 1];
	      }
	
	      if (!getPrevious && selfIndex === siblingsInCol.length - 1) {
	        return siblingsInCol[0];
	      }
	
	      if (selfIndex < 0) {
	        return siblingsInCol[0];
	      }
	
	      if (getPrevious) {
	        return siblingsInCol[selfIndex - 1];
	      }
	      return siblingsInCol[selfIndex + 1];
	    },
	    prevItem: function prevItem(column, dataKey) {
	      var isManualInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var targetItem = this.getClosestSibling(column, dataKey, true);
	      if (targetItem) {
	        return isManualInput ? targetItem : targetItem.focus();
	      }
	    },
	    nextItem: function nextItem(column, dataKey) {
	      var isManualInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var targetItem = this.getClosestSibling(column, dataKey, false);
	      if (targetItem) {
	        return isManualInput ? targetItem : targetItem.focus();
	      }
	    },
	    getSideColumnName: function getSideColumnName(currentColumn) {
	      var toLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var currentColumnIndex = this.inUse.types.indexOf(currentColumn);
	      if (toLeft && currentColumnIndex <= 0) {
	        if (this.debugMode) {
	          this.debugLog('You\'re in the leftmost list already');
	        }
	        return;
	      } else if (!toLeft && currentColumnIndex === this.inUse.types.length - 1) {
	        if (this.debugMode) {
	          this.debugLog('You\'re in the rightmost list already');
	        }
	        return;
	      }
	      return this.inUse.types[toLeft ? currentColumnIndex - 1 : currentColumnIndex + 1];
	    },
	    getFirstItemInSideColumn: function getFirstItemInSideColumn(currentColumn) {
	      var toLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var targetColumn = this.getSideColumnName(currentColumn, toLeft);
	      if (!targetColumn) {
	        return;
	      }
	      var listItems = this.validItemsInCol(targetColumn);
	      if (listItems && listItems[0]) {
	        return listItems[0];
	      }
	    },
	    getActiveItemInSideColumn: function getActiveItemInSideColumn(currentColumn) {
	      var toLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var targetColumn = this.getSideColumnName(currentColumn, toLeft);
	      if (!targetColumn) {
	        return;
	      }
	      var activeItems = this.activeItemInCol(targetColumn);
	      if (activeItems && activeItems[0]) {
	        return activeItems[0];
	      }
	    },
	    toLeftColumn: function toLeftColumn(currentColumn) {
	      var targetItem = this.getActiveItemInSideColumn(currentColumn, true) || this.getFirstItemInSideColumn(currentColumn, true);
	      if (targetItem) {
	        targetItem.focus();
	      }
	    },
	    toRightColumn: function toRightColumn(currentColumn) {
	      var targetItem = this.getActiveItemInSideColumn(currentColumn, false) || this.getFirstItemInSideColumn(currentColumn, false);
	      if (targetItem) {
	        targetItem.focus();
	      }
	    },
	    onMouseDown: function onMouseDown() {
	      var _this15 = this;
	
	      if (!this.manualInput) {
	        return;
	      }
	      window.clearTimeout(this.selectionTimer);
	      this.selectionTimer = window.setTimeout(function () {
	        window.clearTimeout(_this15.selectionTimer);
	        if (_this15.$refs && _this15.$refs.input) {
	          var nearestSlot = _this15.getNearestChunkByPos(_this15.$refs.input.selectionStart || 0);
	          _this15.debounceSetInputSelection(nearestSlot);
	        }
	      }, 50);
	    },
	    keyDownHandler: function keyDownHandler(evt) {
	      if (evt.isComposing || evt.keyCode === 229) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        return false;
	      }
	
	      if (evt.keyCode >= 48 && evt.keyCode <= 57 || evt.keyCode >= 96 && evt.keyCode <= 105) {
	        evt.preventDefault();
	        this.keyboardInput(evt.key);
	      } else if ([65, 80, 77].includes(evt.keyCode)) {
	        evt.preventDefault();
	        this.keyboardInput(evt.key, true);
	      } else if (evt.keyCode >= 37 && evt.keyCode <= 40) {
	        evt.preventDefault();
	        this.clearKbInputLog();
	        this.arrowHandler(evt);
	      } else if (evt.keyCode === 8 || evt.keyCode === 46) {
	        evt.preventDefault();
	        this.clearKbInputLog();
	        this.clearTime();
	      } else if (evt.keyCode === 9) {
	        this.clearKbInputLog();
	        this.tabHandler(evt);
	      } else if (evt.keyCode === 186 || evt.keyCode === 32) {
	        evt.preventDefault();
	        this.clearKbInputLog();
	        this.toNextSlot();
	      } else if (evt.keyCode !== 27 && !(evt.metaKey || evt.ctrlKey)) {
	        evt.preventDefault();
	      }
	    },
	    onCompostionStart: function onCompostionStart(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      this.bakCurrentPos = this.getCurrentTokenChunk();
	      return false;
	    },
	    onCompostionEnd: function onCompostionEnd(evt) {
	      var _this16 = this;
	
	      evt.preventDefault();
	      evt.stopPropagation();
	
	      var cpsData = evt.data;
	      var inputIsCustomApmText = false;
	      if (this.has.customApmText) {
	        inputIsCustomApmText = this.isCustomApmText(cpsData);
	      }
	      if (inputIsCustomApmText) {
	        this.setSanitizedValueToSection('apm', inputIsCustomApmText);
	      }
	
	      this.$refs.input.value = this.has.customApmText ? this.customDisplayTime : this.displayTime;
	
	      this.$nextTick(function () {
	        if (_this16.bakCurrentPos) {
	          var bakPos = JSON.parse((0, _stringify2.default)(_this16.bakCurrentPos));
	          if (inputIsCustomApmText) {
	            bakPos.end = bakPos.start + cpsData.length;
	          }
	          _this16.debounceSetInputSelection(bakPos);
	          _this16.bakCurrentPos = null;
	        }
	      });
	      return false;
	    },
	    pasteHandler: function pasteHandler(evt) {
	      evt.preventDefault();
	      var pastingText = (evt.clipboardData || window.clipboardData).getData('text');
	      if (this.debugMode) {
	        this.debugLog('Pasting value "' + pastingText + '" from clipboard');
	      }
	      if (!pastingText || !pastingText.length) {
	        return;
	      }
	
	      if (this.has.customApmText) {
	        pastingText = this.replaceCustomApmText(pastingText);
	      }
	
	      if (this.inputIsEmpty) {
	        this.readStringValues(pastingText);
	      } else {
	        this.kbInputLog = pastingText.substr(-2, 2);
	        this.setKbInput();
	        this.debounceClearKbLog();
	      }
	    },
	    arrowHandler: function arrowHandler(evt) {
	      var direction = { 37: 'L', 38: 'U', 39: 'R', 40: 'D' }[evt.keyCode];
	      if (direction === 'U' || direction === 'D') {
	        if (this.inputIsEmpty) {
	          this.selectFirstValidValue();
	        } else {
	          var currentChunk = this.getCurrentTokenChunk();
	          if (!currentChunk) {
	            this.selectFirstValidValue();
	            return;
	          }
	          var tokenType = currentChunk.type;
	          this.getClosestValidItemInCol(tokenType, this[tokenType], direction);
	          var newChunkPos = this.getCurrentTokenChunk();
	          this.debounceSetInputSelection(newChunkPos);
	        }
	      } else if (direction === 'R') {
	        this.toLateralToken(false);
	      } else if (direction === 'L') {
	        this.toLateralToken(true);
	      }
	    },
	    tabHandler: function tabHandler(evt) {
	      if (!this.inputIsEmpty && this.tokenChunksPos && this.tokenChunksPos.length) {
	        var currentChunk = this.getCurrentTokenChunk();
	        if (!currentChunk) {
	          return;
	        }
	        var firstChunk = this.tokenChunksPos[0];
	        var lastChunk = this.tokenChunksPos[this.tokenChunksPos.length - 1];
	        if (evt.shiftKey && currentChunk.token !== firstChunk.token || !evt.shiftKey && currentChunk.token !== lastChunk.token) {
	          evt.preventDefault();
	          this.toLateralToken(evt.shiftKey);
	        }
	      } else if (this.appendToBody && this.advancedKeyboard) {
	        if (evt.shiftKey) {
	          return;
	        }
	        evt.preventDefault();
	        if (this.inputIsEmpty) {
	          var firstColumn = this.inUse.types[0];
	          var targetValue = this.validItemsInCol(firstColumn)[0];
	          if (targetValue) {
	            targetValue.focus();
	          }
	        }
	      }
	    },
	    keyboardInput: function keyboardInput(newChar) {
	      var isApm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var currentChunk = this.getCurrentTokenChunk();
	      if (!currentChunk || currentChunk.type !== 'apm' && isApm || currentChunk.type === 'apm' && !isApm) {
	        return;
	      }
	      this.kbInputLog = '' + this.kbInputLog.substr(-1) + newChar;
	      this.setKbInput();
	      this.debounceClearKbLog();
	    },
	    clearKbInputLog: function clearKbInputLog() {
	      window.clearTimeout(this.kbInputTimer);
	      this.kbInputLog = '';
	    },
	    debounceClearKbLog: function debounceClearKbLog() {
	      var _this17 = this;
	
	      window.clearTimeout(this.kbInputTimer);
	      this.kbInputTimer = window.setTimeout(function () {
	        _this17.clearKbInputLog();
	      }, this.opts.manualInputTimeout);
	    },
	    setKbInput: function setKbInput(value) {
	      value = value || this.kbInputLog;
	      var currentChunk = this.getCurrentTokenChunk();
	      if (!currentChunk || !value || !value.length) {
	        return;
	      }
	      var chunkType = currentChunk.type;
	      var chunkToken = currentChunk.token;
	
	      var validValue = void 0;
	      if (chunkType === 'apm') {
	        if (this.lowerCasedApm(value).includes('a')) {
	          validValue = 'am';
	        } else if (this.lowerCasedApm(value).includes('p')) {
	          validValue = 'pm';
	        }
	        if (validValue) {
	          validValue = chunkToken === 'A' ? validValue.toUpperCase() : validValue;
	        }
	      } else {
	        if (this.isValidValue(chunkToken, value)) {
	          validValue = value;
	        } else {
	          var lastInputValue = this.formatValue(chunkToken, value.substr(-1));
	          if (this.isValidValue(chunkToken, lastInputValue)) {
	            validValue = lastInputValue;
	          }
	        }
	      }
	
	      if (validValue) {
	        this.setSanitizedValueToSection(chunkType, validValue);
	        var newChunkPos = this.getCurrentTokenChunk();
	        this.debounceSetInputSelection(newChunkPos);
	      }
	      if (this.debugMode) {
	        if (validValue) {
	          this.debugLog('Successfully set value "' + validValue + '" from latest input "' + value + '" for the "' + chunkType + '" slot');
	        } else {
	          this.debugLog('Value "' + value + '" is invalid in the "' + chunkType + '" slot');
	        }
	      }
	    },
	    onChange: function onChange() {
	      if (!this.manualInput || !this.$refs || !this.$refs.input) {
	        return;
	      }
	      var autoFillValue = this.$refs.input.value || '';
	      if (autoFillValue && autoFillValue.length) {
	        this.readStringValues(autoFillValue);
	      }
	    },
	    getNearestChunkByPos: function getNearestChunkByPos(startPos) {
	      if (!this.tokenChunksPos || !this.tokenChunksPos.length) {
	        return;
	      }
	      var nearest = void 0;
	      var nearestDelta = -1;
	      for (var i = 0; i < this.tokenChunksPos.length; i++) {
	        var chunk = JSON.parse((0, _stringify2.default)(this.tokenChunksPos[i]));
	        if (chunk.start === startPos) {
	          return chunk;
	        }
	        var delta = Math.abs(chunk.start - startPos);
	        if (nearestDelta < 0) {
	          nearest = chunk;
	          nearestDelta = delta;
	        } else {
	          if (nearestDelta <= delta) {
	            return nearest;
	          }
	          nearestDelta = delta;
	          nearest = chunk;
	        }
	      }
	      return nearest;
	    },
	    selectFirstValidValue: function selectFirstValidValue() {
	      if (!this.tokenChunksPos || !this.tokenChunksPos.length) {
	        return;
	      }
	      var firstSlotType = this.tokenChunksPos[0].type;
	      if (firstSlotType === 'hour') {
	        this.getClosestHourItem();
	      } else {
	        this.getClosestValidItemInCol(firstSlotType, this[firstSlotType]);
	      }
	      this.selectFirstSlot();
	    },
	    getClosestHourItem: function getClosestHourItem(currentValue) {
	      var _this18 = this;
	
	      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'U';
	
	      if (!this.validHoursList || !this.validHoursList.length) {
	        if (this.debugMode) {
	          this.debugLog('No valid hour values found, please check your "hour-range" config\nhour-range: ' + (0, _stringify2.default)(this.hourRange));
	        }
	        return;
	      }
	      if (!currentValue) {
	        this.setManualHour(this.validHoursList[0]);
	        return;
	      }
	      var currentIndex = this.validHoursList.findIndex(function (item) {
	        if (!_this18.baseOn12Hours) {
	          return item === currentValue;
	        } else {
	          var valueKey = '' + currentValue + (_this18.lowerCasedApm(_this18.apm) === 'pm' ? 'p' : 'a');
	          return item === valueKey;
	        }
	      });
	      var nextIndex = void 0;
	      if (currentIndex === -1) {
	        nextIndex = 0;
	      } else if (direction === 'D') {
	        nextIndex = currentIndex === 0 ? this.validHoursList.length - 1 : currentIndex - 1;
	      } else {
	        nextIndex = (currentIndex + 1) % this.validHoursList.length;
	      }
	      var nextItem = this.validHoursList[nextIndex];
	      this.setManualHour(nextItem);
	    },
	    getClosestValidItemInCol: function getClosestValidItemInCol(column, currentValue) {
	      var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'U';
	
	      if (column === 'hour') {
	        this.getClosestHourItem(currentValue, direction);
	      } else {
	        var nextItem = direction === 'D' ? this.prevItem(column, this[column], true) : this.nextItem(column, this[column], true);
	        if (nextItem) {
	          this.select(column, nextItem.getAttribute('data-key'));
	        }
	      }
	    },
	    setSanitizedValueToSection: function setSanitizedValueToSection(section, inputValue) {
	      if (!section || !this.getTokenByType(section)) {
	        return;
	      }
	
	      var sanitizedValue = this.sanitizedValue(this.getTokenByType(section), inputValue);
	      this[section] = sanitizedValue;
	    },
	    setManualHour: function setManualHour(nextItem) {
	      if (this.is12hRange(nextItem)) {
	        var hourT = this.match12hRange(nextItem);
	        var apmValue = hourT[2] === 'a' ? 'AM' : 'PM';
	        this.setSanitizedValueToSection('apm', this.apmType === 'a' ? apmValue.toLowerCase() : apmValue);
	        this.setSanitizedValueToSection('hour', hourT[1]);
	      } else {
	        this.setSanitizedValueToSection('hour', nextItem);
	      }
	    },
	    debounceSetInputSelection: function debounceSetInputSelection(_ref) {
	      var _this19 = this;
	
	      var _ref$start = _ref.start,
	          start = _ref$start === undefined ? 0 : _ref$start,
	          _ref$end = _ref.end,
	          end = _ref$end === undefined ? 0 : _ref$end;
	
	      this.$nextTick(function () {
	        _this19.setInputSelectionRange(start, end);
	      });
	      window.clearTimeout(this.selectionTimer);
	      this.selectionTimer = window.setTimeout(function () {
	        window.clearTimeout(_this19.selectionTimer);
	
	        if (_this19.$refs.input && (_this19.$refs.input.selectionStart !== start || _this19.$refs.input.selectionEnd !== end)) {
	          _this19.setInputSelectionRange(start, end);
	        }
	      }, 30);
	    },
	    setInputSelectionRange: function setInputSelectionRange(start, end) {
	      if (this.$refs && this.$refs.input) {
	        this.$refs.input.setSelectionRange(start, end);
	      }
	    },
	    getCurrentTokenChunk: function getCurrentTokenChunk() {
	      return this.getNearestChunkByPos(this.$refs.input && this.$refs.input.selectionStart || 0);
	    },
	    selectFirstSlot: function selectFirstSlot() {
	      var firstChunkPos = this.getNearestChunkByPos(0);
	      this.debounceSetInputSelection(firstChunkPos);
	    },
	    toNextSlot: function toNextSlot() {
	      if (!this.inputIsEmpty && this.tokenChunksPos && this.tokenChunksPos.length) {
	        var currentChunk = this.getCurrentTokenChunk();
	        if (!currentChunk) {
	          return;
	        }
	        var lastChunk = this.tokenChunksPos[this.tokenChunksPos.length - 1];
	        if (currentChunk.token !== lastChunk.token) {
	          this.toLateralToken(false);
	        }
	      }
	    },
	    toLateralToken: function toLateralToken(toLeft) {
	      var currentChunk = this.getCurrentTokenChunk();
	      if (!currentChunk) {
	        this.selectFirstValidValue();
	        return;
	      }
	      var currentChunkIndex = this.tokenChunksPos.findIndex(function (chk) {
	        return chk.token === currentChunk.token;
	      });
	      if (!toLeft && currentChunkIndex >= this.tokenChunksPos.length - 1 || toLeft && currentChunkIndex === 0) {
	        if (this.debugMode) {
	          if (toLeft) {
	            this.debugLog('You\'re in the leftmost slot already');
	          } else {
	            this.debugLog('You\'re in the rightmost slot already');
	          }
	        }
	        return;
	      }
	      var targetSlotPos = toLeft ? this.tokenChunksPos[currentChunkIndex - 1] : this.tokenChunksPos[currentChunkIndex + 1];
	      this.debounceSetInputSelection(targetSlotPos);
	    },
	    isCustomApmText: function isCustomApmText(inputData) {
	      if (!inputData || !inputData.length) {
	        return false;
	      }
	      if (this.amText && this.amText === inputData) {
	        return this.apmType === 'A' ? 'AM' : 'am';
	      }
	      if (this.pmText && this.pmText === inputData) {
	        return this.apmType === 'A' ? 'PM' : 'pm';
	      }
	      return false;
	    },
	    replaceCustomApmText: function replaceCustomApmText(inputString) {
	      if (this.amText && this.amText.length && inputString.includes(this.amText)) {
	        return inputString.replace(new RegExp(this.amText, 'g'), this.apmType === 'A' ? 'AM' : 'am');
	      } else if (this.pmText && this.pmText.length && inputString.includes(this.pmText)) {
	        return inputString.replace(new RegExp(this.pmText, 'g'), this.apmType === 'A' ? 'PM' : 'pm');
	      }
	      return inputString;
	    },
	    checkDropDirection: function checkDropDirection() {
	      if (!this.$el) {
	        return;
	      }
	      var container = void 0;
	      if (this.containerId && this.containerId.length) {
	        container = document.getElementById(this.containerId);
	        if (!container && this.debugMode) {
	          this.debugLog('Container with id "' + this.containerId + '" not found. Fallback to document body.');
	        }
	      }
	      var el = this.$el;
	      var spaceDown = void 0;
	      if (container && container.offsetHeight) {
	        spaceDown = container.offsetTop + container.offsetHeight - (el.offsetTop + el.offsetHeight);
	      } else {
	        var docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
	        spaceDown = docHeight - (el.offsetTop + el.offsetHeight);
	      }
	      this.forceDropOnTop = this.opts.dropOffsetHeight > spaceDown;
	    },
	    is12hRange: function is12hRange(value) {
	      return (/^\d{1,2}(a|p|A|P)$/.test(value)
	      );
	    },
	    match12hRange: function match12hRange(value) {
	      return value.match(/^(\d{1,2})(a|p|A|P)$/);
	    },
	    isNumber: function isNumber(value) {
	      return !isNaN(parseFloat(value)) && isFinite(value);
	    },
	    isBasicType: function isBasicType(type) {
	      return CONFIG.BASIC_TYPES.includes(type);
	    },
	    lowerCasedApm: function lowerCasedApm(apmValue) {
	      return (apmValue || '').toLowerCase();
	    },
	    getTokenRegex: function getTokenRegex(token) {
	      switch (token) {
	        case 'HH':
	          return '([01][0-9]|2[0-3]|H{2})';
	        case 'H':
	          return '([0-9]{1}|1[0-9]|2[0-3]|H{1})';
	        case 'hh':
	          return '(0[1-9]|1[0-2]|h{2})';
	        case 'h':
	          return '([1-9]{1}|1[0-2]|h{1})';
	        case 'kk':
	          return '(0[1-9]|1[0-9]|2[0-4]|k{2})';
	        case 'k':
	          return '([1-9]{1}|1[0-9]|2[0-4]|k{1})';
	        case 'mm':
	          return '([0-5][0-9]|m{2})';
	        case 'ss':
	          return '([0-5][0-9]|s{2})';
	        case 'm':
	          return '([0-9]{1}|[1-5][0-9]|m{1})';
	        case 's':
	          return '([0-9]{1}|[1-5][0-9]|s{1})';
	        case 'A':
	          return '(AM|PM|A{1})';
	        case 'a':
	          return '(am|pm|a{1})';
	        default:
	          return '';
	      }
	    },
	    isEmptyValue: function isEmptyValue(targetToken, testValue) {
	      return !testValue || !testValue.length || testValue && testValue === targetToken;
	    },
	    isValidValue: function isValidValue(targetToken, testValue) {
	      if (!targetToken || this.isEmptyValue(targetToken, testValue)) {
	        return false;
	      }
	      var tokenRegexStr = this.getTokenRegex(targetToken);
	      if (!tokenRegexStr || !tokenRegexStr.length) {
	        return false;
	      }
	      return new RegExp('^' + tokenRegexStr + '$').test(testValue);
	    },
	    sanitizedValue: function sanitizedValue(targetToken, inputValue) {
	      if (this.isValidValue(targetToken, inputValue)) {
	        return inputValue;
	      }
	      return '';
	    },
	    getTokenType: function getTokenType(token) {
	      return this.inUse.types[this.inUse.tokens.indexOf(token)] || '';
	    },
	    getTokenByType: function getTokenByType(type) {
	      return this[type + 'Type'] || '';
	    },
	    isMinuteOrSecond: function isMinuteOrSecond(type) {
	      return ['minute', 'second'].includes(type);
	    },
	    debugLog: function debugLog(logText) {
	      var _this20 = this;
	
	      if (!logText || !logText.length) {
	        return;
	      }
	      var identifier = '';
	      if (this.id) {
	        identifier += '#' + this.id;
	      }
	      if (this.name) {
	        identifier += '[name=' + this.name + ']';
	      }
	      if (this.inputClass) {
	        var inputClasses = [];
	        if (typeof this.inputClass === 'string') {
	          inputClasses = this.inputClass.split(/\s/g);
	        } else if (Array.isArray(this.inputClass)) {
	          inputClasses = [].concat([], this.inputClass);
	        } else if ((0, _typeof3.default)(this.inputClass) === 'object') {
	          (0, _keys2.default)(this.inputClass).forEach(function (clsName) {
	            if (_this20.inputClass[clsName]) {
	              inputClasses.push(clsName);
	            }
	          });
	        }
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)(inputClasses), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var inputClass = _step4.value;
	
	            if (inputClass && inputClass.trim().length) {
	              identifier += '.' + inputClass.trim();
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	      var finalLogText = 'DEBUG: ' + logText + (identifier ? '\n\t(' + identifier + ')' : '');
	      if (window.console.debug && typeof window.console.debug === 'function') {
	        window.console.debug(finalLogText);
	      } else {
	        window.console.log(finalLogText);
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    window.clearTimeout(this.debounceTimer);
	    window.clearTimeout(this.selectionTimer);
	    window.clearTimeout(this.kbInputTimer);
	    this.renderFormat();
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.clearTimeout(this.debounceTimer);
	    window.clearTimeout(this.selectionTimer);
	    window.clearTimeout(this.kbInputTimer);
	  }
	};

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(32);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(85);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _freeze = __webpack_require__(298);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ftbLogo = __webpack_require__(438);
	
	var _ftbLogo2 = _interopRequireDefault(_ftbLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainMenuKeys = (0, _freeze2.default)({
	  'management_unit': 0,
	  'management_user': 1,
	  'management_location': 2,
	  'management_department': 3,
	  'management_organization': 4,
	  'management_till': 5,
	  'management_mix': 6,
	  'management_unitRoles': 7,
	  'management_report': 8,
	  'management_cit': 9,
	  'management_softwaresettings': 10,
	  'management_adminsettings': 11
	});
	
	exports.default = {
	  data: function data() {
	    var _mainMenu;
	
	    return {
	      selectedLanguage: _vue2.default.config.lang,
	      currentLanguage: '',
	      mainMenu: (_mainMenu = {}, (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_unit, {
	        name: 'management.unit',
	        path: '/unit',
	        visible: true,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.units'),
	          icon: 'ion-ios-list-outline'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_user, {
	        name: 'management.user',
	        path: '/user',
	        visible: true,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.users'),
	          icon: 'ion-ios-people-outline'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_location, {
	        name: 'management.location',
	        path: '/location',
	        visible: true,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.locations'),
	          icon: 'ion-ios-location-outline'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_department, {
	        name: 'management.department',
	        path: '/department',
	        visible: false,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.departments'),
	          icon: 'ion-network'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_organization, {
	        name: 'management.organization',
	        path: '/organization',
	        visible: true,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.organizations'),
	          icon: 'ion-ios-briefcase-outline'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_till, {
	        name: 'management.till',
	        path: '/till',
	        visible: false,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.tills'),
	          icon: 'ion-ios-folder-outline'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_mix, {
	        name: 'management.mix',
	        path: '/mix',
	        visible: false,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.mixes'),
	          icon: 'ion-calculator'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_report, {
	        name: 'management.report',
	        path: '/report',
	        visible: true,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.report'),
	          icon: 'ion-ios-paper-outline'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_cit, {
	        name: 'management.cit',
	        path: '/cit',
	        visible: false,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.citworkflow'),
	          icon: 'ion-cash'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_softwaresettings, {
	        name: 'management.softwaresettings',
	        path: '/softwaresettings',
	        visible: false,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.softwaresettings'),
	          icon: 'ion-ios-gear-outline'
	        }
	      }), (0, _defineProperty3.default)(_mainMenu, MainMenuKeys.management_adminsettings, {
	        name: 'management.adminsettings',
	        path: '/adminsettings',
	        visible: false,
	        meta: {
	          title: _vue2.default.t('generic.mainmenu.adminsettings'),
	          icon: 'ion-android-desktop'
	        }
	      }), _mainMenu),
	      isSubmenuActive: false,
	      showSidemenu: false,
	      isOpenActive: false,
	      buildProp: {},
	      permissions: [{
	        prefix: {
	          organization: 'ORG_',
	          till: 'TIL_',
	          department: 'DEP_',
	          unit: 'UNI_',
	          user: 'USR_',
	          location: 'LOC_',
	          cit: 'SET_',
	          report: 'REP_',
	          softwaresettings: 'SET_',
	          mix: 'MIX_',
	          adminsettings: 'ADM_'
	        },
	        actions: {
	          create: 'C',
	          read: 'R',
	          update: 'U',
	          delete: 'D'
	        }
	      }],
	      isFTBStyleApplied: false,
	      ftbLogo: _ftbLogo2.default,
	      dialogTryNewPortal: false
	    };
	  },
	  created: function created() {
	    this.getBuildProperties();
	    this.currentLanguage = window.localStorage.getItem('lang');
	    this.isFTBStyleApplied = (undefined) === 'true';
	  },
	  mounted: function mounted() {
	    document.addEventListener('visibilitychange', this.handleVisibility);
	
	    window.addEventListener('focus', this.handleVisibility);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('visibilitychange', this.handleVisibility);
	    window.removeEventListener('focus', this.handleVisibility);
	  },
	
	  watch: {
	    '$route': function $route(toRoute, fromRoute) {
	      window.document.title = this.$route.meta.title + ' - ' + _vue2.default.t('generic.application_name');
	
	      this.checkRoles();
	    }
	  },
	  methods: {
	    getJwtToken: function getJwtToken() {
	      var idToken = window.localStorage.getItem('id_token');
	      if (!idToken) {
	        var vegaData = window.localStorage.getItem('vega');
	        if (vegaData) {
	          var _JSON$parse = JSON.parse(vegaData),
	              jwtToken = _JSON$parse.jwt_token;
	
	          idToken = jwtToken;
	        }
	      }
	      return idToken;
	    },
	    handleVisibility: function handleVisibility() {
	      if (!document.hidden) {
	        if (this.$route.name.includes('forgotPassword') || this.$route.name.includes('resetPassword')) {
	          return;
	        }
	        var token = this.getJwtToken();
	        if (!token && !this.$route.name.includes('login')) {
	          this.$store.getters['generalSession/getCurrentSession'].state = 'error';
	          this.$router.replace({ name: 'logout' });
	        }
	
	        if (token && (this.$route.name.includes('login') || this.$route.name.includes('mfa'))) {
	          this.$store.getters['generalSession/getCurrentSession'].state = 'undefined';
	          this.$router.replace({ name: 'management.unit' });
	        }
	        if (token && this.$route.name.includes('logout')) {
	          this.$router.replace({ name: 'management.unit' });
	        }
	        if (!token && this.$route.name.includes('logout')) {
	          this.$router.replace({ name: 'login' });
	        }
	      }
	    },
	    getMainPage: function getMainPage() {
	      var session = this.$store.getters['generalSession/getCurrentSession'];
	
	      if (session && session.data && session.data.user) {
	        return { name: 'management.unit' };
	      }
	
	      return { name: 'start' };
	    },
	    checkRoles: function checkRoles() {
	      var _this = this;
	
	      var roles = this.getRoles;
	
	      if ((0, _keys2.default)(roles).length === 0 && roles.constructor === Object && this.getCurrentSession.state === 'ready') {
	        this.$dataApi().endpoints.user.getUserPermissions().then(function (response) {
	          if (response.status === 200) {
	            var permissions = response.body;
	            _this.$store.commit('generalSession/setRoles', permissions);
	
	            for (var prop in permissions) {
	              if (!permissions.hasOwnProperty(prop)) continue;
	
	              if (permissions[prop].permission === 'ORG_R') {
	                _this.showSidemenu = true;
	              }
	              if (permissions[prop].permission === 'DEP_R') {
	                _this.mainMenu[MainMenuKeys.management_department].visible = true;
	              }
	              if (permissions[prop].permission === 'TIL_R') {
	                _this.mainMenu[MainMenuKeys.management_till].visible = true;
	              }
	              if (permissions[prop].permission === 'MIX_R') {
	                _this.mainMenu[MainMenuKeys.management_mix].visible = true;
	              }
	              if (permissions[prop].permission === 'SET_R') {
	                _this.mainMenu[MainMenuKeys.management_cit].visible = true;
	                _this.mainMenu[MainMenuKeys.management_softwaresettings].visible = true;
	              }
	              if (permissions[prop].permission === 'ADM_R') {
	                _this.mainMenu[MainMenuKeys.management_adminsettings].visible = true;
	              }
	            }
	          }
	        });
	      }
	    },
	    checkPermissions: function checkPermissions(route) {
	      var check = false;
	      var prefix = this.permissions[0].prefix[this.$route.path.split('/')[1]];
	      var goTo = route.path.split('/')[2];
	      var actions = this.permissions[0].actions;
	
	      var userSession = this.getCurrentSession;
	
	      var result = [];
	      if (userSession.data.user !== undefined) {
	        result = userSession.data.user.userRoles;
	      }
	
	      var arr = [];
	      for (var i = 0; i < result.length; i++) {
	        arr.push(result[i]['code']);
	        if (result[i]['code'] === 'superadmin' || result[i]['code'] === 'supervisor' || result[i]['code'] === 'dealer' || result[i]['code'] === 'dealerview') {
	          this.mainMenu[MainMenuKeys.management_report].visible = true;
	          this.mainMenu[MainMenuKeys.management_cit].visible = true;
	          this.mainMenu[MainMenuKeys.management_department].visible = true;
	          break;
	        }
	      }
	
	      var permissions = userSession.roles;
	      if (goTo === 'create' || goTo === 'read' || goTo === 'update' || goTo === 'delete') {
	        for (var property in permissions) {
	          if (!permissions.hasOwnProperty(property)) continue;
	
	          if (permissions[property].permission === prefix + actions[goTo]) {
	            check = true;
	          }
	        }
	
	        if (!check) {
	          this.$router.push({
	            name: 'generic.error.ErrorPage',
	            params: {
	              error_response: {
	                error_message: 'unauthorized'
	              }
	            }
	          });
	        }
	      }
	    },
	    toggleSubMenu: function toggleSubMenu() {
	      this.isSubmenuActive = !this.isSubmenuActive;
	      this.isOpenActive = !this.isOpenActive;
	    },
	    handleMenu: function handleMenu(key) {
	      if (this.$route.name !== 'management.unit.read') {
	        this.$router.push({
	          params: {
	            uuid: key
	          },
	          name: this.$route.name
	        });
	      }
	    },
	    resetSubMenu: function resetSubMenu() {
	      if (this.$route.name !== 'management.unit.read') {
	        this.$router.push({
	          name: this.$route.name
	        });
	      }
	    },
	    changeLanguage: function changeLanguage(lang) {
	      this.selectedLanguage = _vue2.default.config.lang = lang;
	      window.localStorage.setItem('lang', lang);
	      this.currentLanguage = window.localStorage.getItem('lang');
	      if (!this.$route.fullPath.includes('mfa')) {
	        window.location.reload();
	      }
	    },
	    getFlagClass: function getFlagClass(id) {
	      if (this.isFTBStyleApplied && id === 'en') {
	        id = 'us';
	      }
	      var value = ['flag-icon-' + id];
	      if (this.orderKey === id) {
	        value.push('active');
	      }
	      return value.join(' ');
	    },
	    getBuildProperties: function getBuildProperties() {
	      var _this2 = this;
	
	      this.$dataApi().endpoints.utility.getBuildProperties().then(function (response) {
	        if (response.status === 200) {
	          _this2.buildProp = response.body;
	        }
	      });
	    },
	    navigateToNewPortal: function navigateToNewPortal() {
	      this.dialogTryNewPortal = false;
	      window.location.href =  true ? (function () {
	    return typeof window === 'object' && window !== null && window.self === window
	      ? (window.location.protocol + '//' + (window.location.hostname ? window.location.hostname : 'localhost') + (window.location.port ? ':' + window.location.port : '') + '/v2/')
	      : 'http://localhost/v2/'
	  })() : process.env.V2_URL;
	    }
	  },
	  computed: {
	    getCurrentSession: function getCurrentSession() {
	      return this.$store.getters['generalSession/getCurrentSession'];
	    },
	    getRoles: function getRoles() {
	      return this.getCurrentSession.roles;
	    },
	    getOrganizationSimpleTree: function getOrganizationSimpleTree() {
	      return this.$store.getters['generalOrganization/getOrganizationSimpleTree'];
	    },
	    isLoggedIn: function isLoggedIn() {
	      return this.getCurrentSession.state === 'ready' && this.getCurrentSession.data.user;
	    },
	    currentYear: function currentYear() {
	      return new Date().getFullYear();
	    }
	  },
	  events: {
	    timeUpdate: function timeUpdate(timeEntry) {
	      this.totalTime += parseFloat(timeEntry.totalTime);
	    },
	    deleteTime: function deleteTime(timeEntry) {
	      this.totalTime -= parseFloat(timeEntry.totalTime);
	    }
	  },
	  filters: {
	    uppercase: function uppercase(value) {
	      if (!value) return '';
	      value = value.toString();
	      return value.toUpperCase();
	    }
	  }
	};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(25);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DqAcceptablespanel',
	  replace: true,
	  props: {
	    label: '',
	    overridden: false,
	    acceptablesSetting: [],
	    readOnly: false
	  },
	  data: function data() {
	    return {
	      acceptablesSettingNew: [].concat((0, _toConsumableArray3.default)(this.acceptablesSetting))
	    };
	  },
	  mounted: function mounted() {
	    this.updateSettings();
	  },
	
	  watch: {
	    acceptablesSettings: function acceptablesSettings() {
	      this.updateSettings();
	    }
	  },
	  methods: {
	    updateSettings: function updateSettings() {
	      this.acceptablesSettingNew = [].concat((0, _toConsumableArray3.default)(this.acceptablesSetting));
	      this.$store.commit('overrideAcceptablesSetting/setOverrideAcceptablesSetting', { acceptablesSetting: this.acceptablesSettingNew });
	    }
	  }
	};

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(25);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DqCoindistributionpanel',
	  replace: true,
	  props: {
	    overridden: false,
	    coindistributionsetting: [],
	    readOnly: false
	  },
	  data: function data() {
	    return {
	      coinDistributionSettingNew: [].concat((0, _toConsumableArray3.default)(this.coindistributionsetting))
	    };
	  },
	  mounted: function mounted() {
	    this.updateSettings();
	  },
	
	  watch: {
	    coinDistributionSettings: function coinDistributionSettings() {
	      this.updateSettings();
	    }
	  },
	  methods: {
	    updateSettings: function updateSettings() {
	      this.coinDistributionSettingNew = [].concat((0, _toConsumableArray3.default)(this.coindistributionsetting));
	      this.$store.commit('overrideCoinDistributionSetting/setOverrideCoinDistributionSetting', { coinDistributionSetting: this.coinDistributionSettingNew });
	    }
	  }
	};

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(25);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var excludedPlaceholders = ['om61'];
	
	exports.default = {
	  name: 'DqInventorypanel',
	  replace: true,
	  props: {
	    label: '',
	    valueColumn: true,
	    maxDispensableColumn: true,
	    overridden: false,
	    acceptableMaterials: [],
	    readOnly: false
	  },
	  data: function data() {
	    return {
	      inventorySettingsNew: [].concat((0, _toConsumableArray3.default)(this.acceptableMaterials)),
	      maxValues: {
	        '0.01': 200,
	        '0.02': 200,
	        '0.05': 200,
	        '0.1': 200,
	        '0.2': 140,
	        '0.5': 115,
	        '1.0': 130,
	        '1.00': 130,
	        '2.0': 100,
	        '2.00': 100
	      }
	    };
	  },
	  computed: {
	    hasMaxDispensable: function hasMaxDispensable() {
	      return this.acceptableMaterials.some(function (row) {
	        return 'maxDispensable' in row;
	      });
	    },
	    hasRecycler: function hasRecycler() {
	      return this.acceptableMaterials.some(function (row) {
	        return 'recycled' in row;
	      });
	    },
	    hasMaxAmount: function hasMaxAmount() {
	      return this.acceptableMaterials.some(function (row) {
	        return 'maxAmount' in row;
	      });
	    },
	    hasHightAmount: function hasHightAmount() {
	      return this.acceptableMaterials.some(function (row) {
	        return 'highAmount' in row;
	      });
	    },
	    hasMinAmount: function hasMinAmount() {
	      return this.acceptableMaterials.some(function (row) {
	        return 'minAmount' in row;
	      });
	    },
	    hasLowAmount: function hasLowAmount() {
	      return this.acceptableMaterials.some(function (row) {
	        return 'lowAmount' in row;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.updateSettings();
	  },
	
	  watch: {
	    inventorySettings: function inventorySettings() {
	      this.updateSettings();
	    }
	  },
	  methods: {
	    filteredAcceptableMaterials: function filteredAcceptableMaterials() {
	      var _this = this;
	
	      return this.acceptableMaterials.filter(function (m) {
	        return !excludedPlaceholders.includes(m.placeholder) && !_this.isNonRecyclableDollarCoin(m);
	      });
	    },
	    nonRecyleableMaterials: function nonRecyleableMaterials() {
	      var _this2 = this;
	
	      return this.acceptableMaterials.filter(function (m) {
	        return !excludedPlaceholders.includes(m.placeholder) && _this2.isNonRecyclableDollarCoin(m);
	      });
	    },
	    updateSettings: function updateSettings(row, field) {
	      this.inventorySettingsNew = [].concat((0, _toConsumableArray3.default)(this.acceptableMaterials));
	      this.$store.commit('overrideInventorySettings/setOverrideInventorySettings', { inventorySettings: this.inventorySettingsNew });
	
	      if (this.maxDispensableColumn) {
	        this.validateMaxDispensableColumn(row, field);
	      }
	    },
	    validateMaxDispensableColumn: function validateMaxDispensableColumn(row, field) {
	      var _this3 = this;
	
	      var inventoryValid = true;
	      this.acceptableMaterials.forEach(function (material) {
	        if (material === row && field === 'maxDispensable') {
	          if (material.maxDispensable > material.maxDispensableAmountForDrawer) {
	            _this3.$message.error({ message: _vue2.default.t('management.unit.softwaresettings.inventorypanel.messages.excideMaximumDrawer', { limit: material.maxDispensableAmountForDrawer }) });
	            inventoryValid = false;
	          } else if (material.maxDispensable > material.maxDispensableAmountForCup) {
	            _this3.$message.warning({ message: _vue2.default.t('management.unit.softwaresettings.inventorypanel.messages.excideMaximumCup', { limit: material.maxDispensableAmountForCup }) });
	          }
	        }
	      });
	      inventoryValid = this.checkAllMaxDispensableValidity();
	      this.$emit('setInventoryValid', inventoryValid);
	    },
	    checkAllMaxDispensableValidity: function checkAllMaxDispensableValidity() {
	      return this.acceptableMaterials.every(function (material) {
	        if (material.maxDispensable !== undefined && material.maxDispensableAmountForDrawer !== undefined) {
	          return material.maxDispensable <= material.maxDispensableAmountForDrawer;
	        }
	        return true;
	      });
	    },
	    getMaxDispensable: function getMaxDispensable(denomination, material) {
	      var materialItem = this.acceptableMaterials.find(function (item) {
	        return item.denomination.value === denomination && item.denomination.material === material;
	      });
	
	      if (materialItem.maxDispensableAmountForDrawer) {
	        return materialItem.maxDispensableAmountForDrawer;
	      }
	
	      return this.maxValues[denomination] || 100;
	    },
	    isInvalid: function isInvalid(row) {
	      return row.maxDispensable > row.maxDispensableAmountForDrawer;
	    },
	    isNonRecyclableDollarCoin: function isNonRecyclableDollarCoin(row) {
	      var _row$denomination = row.denomination,
	          material = _row$denomination.material,
	          currency = _row$denomination.currency,
	          value = _row$denomination.value;
	
	      return material === 'COIN' && currency === 'USD' && value >= 0.5;
	    }
	  }
	};

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(25);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DqMinimumordercoinrollspanel',
	  replace: true,
	  props: {
	    label: '',
	    overridden: false,
	    minimumOrderCoinRollsSettings: [],
	    readOnly: false
	  },
	  data: function data() {
	    return {
	      minimumOrderCoinRollsSettingsNew: [].concat((0, _toConsumableArray3.default)(this.minimumOrderCoinRollsSettings))
	    };
	  },
	  mounted: function mounted() {
	    this.updateSettings();
	  },
	
	  watch: {
	    minimumOrderCoinRollsSettings: function minimumOrderCoinRollsSettings() {
	      this.updateSettings();
	    }
	  },
	  methods: {
	    updateSettings: function updateSettings() {
	      this.minimumOrderCoinRollsSettingsNew = [].concat((0, _toConsumableArray3.default)(this.minimumOrderCoinRollsSettings));
	      this.$store.commit('overrideMinimumOrderCoinRollsSettings/setOverrideMinimumOrderCoinRollsSettings', { minimumOrderCoinRollsSettings: this.minimumOrderCoinRollsSettingsNew });
	    }
	  }
	};

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DqOm61Inventorypanel',
	  replace: true,
	  props: {
	    label: '',
	    valueColumn: true,
	    overridden: false,
	    acceptableMaterials: [],
	    recyclerSettings: [],
	    unitTypeUuid: '',
	    readOnly: false,
	    form: {},
	    formRules: {},
	    currency: {
	      default: { iso3: 'EUR' }
	    }
	  },
	  data: function data() {
	    return {
	      om61InventorySettings: [],
	      om61DefaultInventorySettings: [],
	      maxNumberOfRecyclers: 0,
	      denominations: [],
	      status: '',
	      rowUpdateKey: 0,
	      overviewParams: { pagesize: 0 }
	    };
	  },
	  created: function created() {
	    this.initializeData();
	  },
	  mounted: function mounted() {
	    this.updateSettings();
	  },
	
	  methods: {
	    initializeData: function initializeData() {
	      var self = this;
	      self.getCurrency(self, function (currency) {
	        self.getEnabledDenominations(self, currency, function (denominations) {
	          self.getDefaultInventorySettings(self, function (unitTypeSettings) {
	            self.initializeOm61InventorySettings(self, denominations, unitTypeSettings);
	          });
	        });
	      });
	    },
	    getCurrency: function getCurrency(self, callback) {
	      if (self.currency.uuid === undefined) {
	        self.$dataApi().endpoints.currency.getAllEnabled(self.overviewParams).then(function (response) {
	          if (response.status === 200) {
	            var resultCurrency = response.body.items;
	            self.currency = resultCurrency.find(function (_ref) {
	              var iso3 = _ref.iso3;
	              return iso3 === self.currency.iso3;
	            });
	            callback(self.currency);
	          }
	        }, function (response) {
	          self.redirectToError('could_not_load', response.body.message);
	        });
	      } else {
	        callback(self.currency);
	      }
	    },
	    getEnabledDenominations: function getEnabledDenominations(self, currency, callback) {
	      var denominationsParams = {
	        currencyUuid: currency.uuid
	      };
	      self.$dataApi().endpoints.currency.getCurrencyDenominations(denominationsParams).then(function (denominationsresponse) {
	        if (denominationsresponse.status === 200) {
	          var allDenominations = denominationsresponse.body;
	          self.denominations = allDenominations.filter(function (d) {
	            return d.material === 'BIL';
	          }).filter(function (d) {
	            return d.enabled;
	          }).map(function (d) {
	            return d.value;
	          });
	          callback(self.denominations);
	        }
	      }, function (denominationsresponse) {
	        self.redirectToError('could_not_load', denominationsresponse.body.message);
	      });
	    },
	    getDefaultInventorySettings: function getDefaultInventorySettings(self, callback) {
	      var params = {
	        unitTypeUuid: self.unitTypeUuid
	      };
	
	      self.$dataApi().endpoints.softwaresettings.getDefaultSettings(params).then(function (response) {
	        if (response.status === 200) {
	          var settings = response.body['settingsList'];
	          var inventorySettings = settings.find(function (_ref2) {
	            var key = _ref2.key;
	            return key === 'inventorySettings';
	          });
	          var acceptableMaterials = JSON.parse(inventorySettings['value']).acceptableMaterials;
	          self.om61DefaultInventorySettings = acceptableMaterials.filter(function (m) {
	            return m.placeholder === 'om61';
	          });
	          self.om61DefaultInventorySettings.forEach(function (m) {
	            m.denomination.value = parseInt(m.denomination.value);
	          });
	          callback(self.om61DefaultInventorySettings);
	        }
	      }, function (response) {
	        self.redirectToError('could_not_load', response.body.message);
	      });
	    },
	    initializeOm61InventorySettings: function initializeOm61InventorySettings(self, denominations, unitTypeSettings) {
	      var denominationsForCurrency = denominations;
	      this.$store.commit('denominationForCurrency/setDenominationsForCurrency', { denominationsForCurrency: denominationsForCurrency });
	
	      self.maxNumberOfRecyclers = JSON.parse(self.recyclerSettings.value).maxNumberOfRecyclers;
	      var recyclerSettings = JSON.parse(self.recyclerSettings.value).settings || [];
	      var om61Materials = self.acceptableMaterials.filter(function (m) {
	        return m.placeholder === 'om61';
	      });
	      self.om61InventorySettings = [];
	
	      var _loop = function _loop(i) {
	        var denomination = denominations[i];
	        var numberOfRecyclers = self.calculateRecyclers(self, recyclerSettings, denomination);
	        var om61Material = om61Materials.find(function (r) {
	          return parseInt(r.denomination.value) === denomination;
	        });
	        if (om61Material === undefined) {
	          om61Material = unitTypeSettings.find(function (r) {
	            return parseInt(r.denomination.value) === denomination;
	          });
	        }
	        self.om61InventorySettings.push({
	          numberOfRecyclers: numberOfRecyclers,
	          denomination: denomination,
	          minAmount: numberOfRecyclers === 0 || om61Material === undefined ? 0 : om61Material.minAmount,
	          maxAmount: numberOfRecyclers === 0 || om61Material === undefined ? 0 : om61Material.maxAmount,
	          optimumAmount: numberOfRecyclers === 0 || om61Material === undefined ? 0 : om61Material.optimumAmount
	        });
	      };
	
	      for (var i = 0; i < denominations.length; i++) {
	        _loop(i);
	      }
	      this.formRules.om61SettingsValid = [{ required: true }];
	      self.updateStatus();
	      this.updateSettings();
	    },
	    calculateRecyclers: function calculateRecyclers(self, recyclerSettings, denomination) {
	      var t = recyclerSettings.find(function (r) {
	        return parseInt(r.denomination.value) === denomination;
	      });
	      if (t === undefined) {
	        if (recyclerSettings.length === 0) {
	          var totalRecyclers = self.getTotalUsedRecyclers();
	          return totalRecyclers < self.maxNumberOfRecyclers ? 1 : 0;
	        } else {
	          return 0;
	        }
	      } else {
	        return t.numberOfRecyclers;
	      }
	    },
	    recyclersUpdated: function recyclersUpdated(recyclerDataRow) {
	      var defaultValues = this.om61DefaultInventorySettings.find(function (m) {
	        return parseInt(m.denomination.value) === parseInt(recyclerDataRow.denomination);
	      });
	      if (defaultValues != null) {
	        recyclerDataRow.minAmount = defaultValues.minAmount * recyclerDataRow.numberOfRecyclers;
	        recyclerDataRow.maxAmount = defaultValues.maxAmount * recyclerDataRow.numberOfRecyclers;
	        recyclerDataRow.optimumAmount = defaultValues.optimumAmount * recyclerDataRow.numberOfRecyclers;
	      }
	      this.updateStatus();
	      this.updateSettings();
	      this.forceUpdate();
	    },
	    updateSettings: function updateSettings() {
	      var _this = this;
	
	      var inventorySettings = [];
	      var recyclerSettings = {
	        maxNumberOfRecyclers: this.maxNumberOfRecyclers,
	        settings: []
	      };
	      this.om61InventorySettings.filter(function (s) {
	        return s.numberOfRecyclers !== 0;
	      }).forEach(function (s) {
	        var denomination = {
	          value: s.denomination,
	          currency: _this.currency.iso3,
	          material: 'BILL'
	        };
	        inventorySettings.push({
	          placeholder: 'om61',
	          minAmount: s.minAmount,
	          maxAmount: s.maxAmount,
	          optimumAmount: s.optimumAmount,
	          recycled: true,
	          denomination: denomination
	        });
	        recyclerSettings.settings.push({
	          numberOfRecyclers: s.numberOfRecyclers,
	          denomination: denomination
	        });
	      });
	
	      this.$store.commit('overrideOm61InventorySettings/setOverrideOm61InventorySettings', { inventorySettings: inventorySettings, recyclerSettings: recyclerSettings });
	    },
	    forceUpdate: function forceUpdate() {
	      this.rowUpdateKey += 1;
	    },
	    updateStatus: function updateStatus() {
	      var totalRecyclers = this.getTotalUsedRecyclers();
	      if (totalRecyclers <= this.maxNumberOfRecyclers) {
	        this.status = {
	          message: _vue2.default.t('management.unit.softwaresettings.inventorypanel.messages.recyclerStatusInfo', { totalRecyclers: totalRecyclers, maxNumberOfRecyclers: this.maxNumberOfRecyclers }),
	          class: 'om61-recycler-status'
	        };
	        this.form.om61SettingsValid = 'true';
	      } else {
	        this.status = {
	          message: _vue2.default.t('management.unit.softwaresettings.inventorypanel.messages.recyclerStatusError', { totalRecyclers: totalRecyclers, maxNumberOfRecyclers: this.maxNumberOfRecyclers }),
	          class: 'el-form-item__error om61-recycler-status'
	        };
	        this.form.om61SettingsValid = undefined;
	      }
	    },
	    getTotalUsedRecyclers: function getTotalUsedRecyclers() {
	      return this.om61InventorySettings.map(function (s) {
	        return s.numberOfRecyclers;
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0);
	    }
	  },
	  watch: {
	    currency: {
	      handler: function handler() {
	        this.initializeData();
	      }
	    }
	  }
	};

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(43);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(32);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(23);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _currencySymbolMap = __webpack_require__(88);
	
	var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);
	
	var _downloadjs = __webpack_require__(167);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchUrlParamName = 'search';
	var pageUrlParamName = 'page';
	var pageSizeUrlParamName = 'pagesize';
	var filterParamName = 'filter';
	
	exports.default = {
	  name: 'DqOverview',
	  replace: true,
	  props: {
	    dataSource: {
	      type: Object,
	      required: true,
	      default: function _default() {
	        return {
	          endpoint: null
	        };
	      }
	    },
	    contentOnly: {
	      default: function _default() {
	        return false;
	      }
	    },
	    disableSort: {
	      default: function _default() {
	        return false;
	      }
	    },
	    filterSection: {
	      default: function _default() {
	        return true;
	      }
	    },
	    search: {
	      default: function _default() {
	        return true;
	      }
	    },
	    exportSdcWorkflow: {
	      default: function _default() {
	        return false;
	      }
	    },
	    generateSdcWorkflowFilename: {
	      default: function _default() {
	        return false;
	      }
	    },
	    userPermissionNeeded: {
	      default: function _default() {
	        return false;
	      }
	    },
	    transactionOverview: {
	      default: function _default() {
	        return false;
	      }
	    },
	    clearboxCampaignOverview: {
	      default: function _default() {
	        return false;
	      }
	    },
	    totalText: {
	      default: function _default() {
	        return true;
	      }
	    },
	    pagination: {
	      type: Object,
	      default: function _default() {
	        return {
	          items: 25
	        };
	      }
	    },
	    rows: {
	      type: Object,
	      default: function _default() {
	        return {
	          zebra: true
	        };
	      }
	    },
	    direction: {
	      default: function _default() {
	        return 'ASC';
	      }
	    },
	    field: {
	      default: function _default() {
	        return 'name';
	      }
	    },
	    overrideError: {
	      default: function _default() {
	        return null;
	      }
	    },
	    overrideClass: {
	      default: function _default() {
	        return '';
	      }
	    },
	    hideIfNoRecords: {
	      default: function _default() {
	        return false;
	      }
	    },
	    columns: {
	      type: Array,
	      required: true
	    },
	    actions: {
	      type: Object,
	      default: function _default() {
	        return {
	          create: {
	            label: _vue2.default.t('generic.overview.buttons.create'),
	            action: {},
	            disable: false
	          },
	          read: {
	            label: _vue2.default.t('generic.overview.buttons.read'),
	            action: {},
	            disable: false
	          },
	          readsettings: {
	            label: 'Read extra',
	            action: {},
	            disable: false
	          },
	          update: {
	            label: _vue2.default.t('generic.overview.buttons.update'),
	            action: {},
	            disable: false
	          },
	          preview: {
	            label: _vue2.default.t('generic.overview.buttons.preview'),
	            action: {},
	            disable: false
	          },
	          delete: {
	            label: _vue2.default.t('generic.overview.buttons.delete'),
	            column: '',
	            action: {},
	            disable: false
	          },
	          unlock: {
	            label: _vue2.default.t('generic.overview.buttons.unlock'),
	            column: '',
	            action: {},
	            disable: false
	          },
	          filter: {
	            label: _vue2.default.t('generic.overview.buttons.filter'),
	            name: ''
	          }
	        };
	      }
	    },
	    itemActions: [] },
	  data: function data() {
	    return {
	      itemsData: '',
	      itemsTotal: 0,
	      allItems: '',
	      filterValues: '',
	      itemsCurrentlyLoading: false,
	      itemsSearchValue: '',
	      oldSearchValue: '',
	      itemsParams: {},
	      itemsError: false,
	      itemsShowLoading: true,
	
	      componentErrorMessage: '',
	
	      dialogUnlockVisible: false,
	      dialogUnlockName: '',
	      dialogUnlockIdentifier: '',
	      dialogUnlockLoading: false,
	      unlockParams: {},
	
	      dialogDeleteVisible: false,
	      dialogDeleteName: '',
	      dialogDeleteIdentifier: '',
	
	      dialogDeleteUnitList: [],
	
	      dialogDeleteUnitFormatted: '',
	      dialogDeleteLoading: false,
	      deleteParams: {},
	
	      dialogFilterVisible: false,
	
	      paginationCurrentItems: '',
	      paginationPageSizeOptions: [5, 10, 15, 20, 25, 50, 100],
	      paginationPageSize: 10,
	
	      getFunction: 'overviewFunction',
	
	      searching: false,
	      timer: 0,
	
	      permissions: [{
	        actions: {
	          create: 'C',
	          read: 'R',
	          readsettings: 'R',
	          update: 'U',
	          preview: 'U',
	          delete: 'D',
	          unlock: 'U'
	        }
	      }],
	      showButtons: {
	        create: false,
	        read: false,
	        update: false,
	        preview: false,
	        delete: false,
	        unlock: false,
	        readsettings: false
	      },
	
	      content: {},
	      loadingText: _vue2.default.t('generic.forms.loading'),
	      loadingFilterData: true,
	      resultFilterDataExcluding: [],
	      resultFilterDataIncluding: [],
	      form: {
	        filter: [],
	        showFilter: '',
	        dialog_filter: []
	      }
	    };
	  },
	  watch: {
	    '$route.params.uuid': 'getItems'
	  },
	  created: function created() {
	    var pagesizeFromRoute = this.$route.query.pagesize;
	    var pageFromRoute = this.$route.query.page;
	    var searchValueFromRoute = this.$route.query.search;
	    var filterFromRoute = this.$route.query.filter;
	
	    if (searchValueFromRoute && searchValueFromRoute !== '') {
	      this.searchValue = searchValueFromRoute;
	      this.itemsParams.searchValue = searchValueFromRoute;
	      this.itemsSearchValue = searchValueFromRoute;
	      this.searching = true;
	    }
	
	    if (pagesizeFromRoute && pagesizeFromRoute !== '') {
	      this.pagination.items = pagesizeFromRoute;
	    }
	
	    if (filterFromRoute && filterFromRoute !== '') {
	      var filterArray = filterFromRoute.split(',');
	      this.itemsParams.filterValues = filterArray;
	      this.form.filter = filterArray;
	    }
	
	    this.itemsParams = {
	      pagesize: this.pagination.items,
	      direction: this.direction,
	      field: this.field
	    };
	
	    this.paginationPageSize = this.pagination.items;
	
	    if (pageFromRoute && pageFromRoute !== '') {
	      var pageInt = parseInt(pageFromRoute, 10);
	      this.itemsParams.page = pageInt;
	      this.current = pageInt;
	      this.pageNumber = pageInt;
	    }
	
	    this.checkRoles();
	
	    this.getItems();
	  },
	  computed: {
	    getCurrentSession: function getCurrentSession() {
	      return this.$store.getters['generalSession/getCurrentSession'];
	    },
	    getRoles: function getRoles() {
	      return this.getCurrentSession.roles;
	    }
	  },
	  methods: {
	    navigateToDetail: function navigateToDetail(item) {
	      var route = this.actions.read.redirectUrl({ item: item });
	
	      if (typeof route === 'string') {
	        this.$router.push(route);
	      } else if ((typeof route === 'undefined' ? 'undefined' : (0, _typeof3.default)(route)) === 'object') {
	        this.$router.push(route);
	      }
	    },
	    sdcWorkflowExport: function sdcWorkflowExport(workflowForExport) {
	      var _this = this;
	
	      if (workflowForExport.Version === 1) {
	        return;
	      }
	      this.dataSource.exportSdcWorkflowFunction(workflowForExport.UUID).then(function (response) {
	        var filename = _this.actions.generateSdcWorkflowFilename.action(workflowForExport);
	        (0, _downloadjs2.default)(response.bodyText, filename, 'application/xml');
	      });
	    },
	    sort: function sort(s) {
	      if (this.disableSort) {
	        return;
	      }
	      if (s === this.itemsParams.field) {
	        this.itemsParams.direction = this.getSortDirection() === 'asc' ? 'desc' : 'asc';
	      }
	      this.itemsParams.field = s;
	      this.field = this.itemsParams.field;
	      this.direction = this.itemsParams.direction;
	      this.getItemsData(false);
	    },
	    isSortField: function isSortField(c) {
	      if (this.disableSort) {
	        return false;
	      }
	      return c === this.itemsParams.field;
	    },
	    isFilterField: function isFilterField(c) {
	      return this.actions.filter !== undefined && this.actions.filter.name !== '' && this.actions.filter.name === c;
	    },
	    isFilterEnabled: function isFilterEnabled() {
	      return this.form.filter !== undefined && this.form.filter.length > 0;
	    },
	    getSortDirection: function getSortDirection() {
	      if (this.itemsParams.direction !== null && this.itemsParams.direction !== undefined && this.itemsParams.direction.toLowerCase() === 'desc') {
	        return 'desc';
	      } else {
	        return 'asc';
	      }
	    },
	    startFilterScreen: function startFilterScreen() {
	      this.form.dialog_filter = this.form.filter;
	      this.dialogFilterVisible = true;
	    },
	    filterHasToBeDisplayed: function filterHasToBeDisplayed() {
	      return !this.itemsError && this.actions.filter !== undefined && this.actions.filter.name !== '';
	    },
	    filterOverview: function filterOverview() {
	      this.form.filter = this.form.dialog_filter;
	      this.dialogFilterVisible = false;
	      this.handlePaginationChange(1);
	    },
	    changeFilterSelection: function changeFilterSelection() {},
	    getFilterLabel: function getFilterLabel(item) {
	      var returnStr = '';
	      var arrayStr = item.split(' ');
	      for (var i = 0; i < arrayStr.length; i++) {
	        arrayStr[i] = arrayStr[i].slice(0, 1).toUpperCase().concat(arrayStr[i].slice(1).toLowerCase());
	      }
	      returnStr = arrayStr.join(' ');
	      return returnStr;
	    },
	    getFilterData: function getFilterData() {
	      this.resultFilterDataIncluding = this.filterValues;
	      this.loadingFilterData = false;
	    },
	    handlePaginationChange: function handlePaginationChange(value) {
	      this.itemsParams.page = value;
	
	      this.getItemsData(false);
	    },
	    handlePaginationPageSize: function handlePaginationPageSize() {
	      this.itemsParams.pagesize = this.paginationPageSize;
	      this.itemsParams.page = 1;
	      this.pagination.items = this.paginationPageSize;
	      this.getItemsData(false);
	    },
	    checkRoles: function checkRoles() {
	      var _this2 = this;
	
	      var roles = this.getRoles;
	      if ((0, _keys2.default)(roles).length === 0 && roles.constructor === Object && this.getCurrentSession.state === 'ready') {
	        this.$dataApi().endpoints.user.getUserPermissions().then(function (response) {
	          if (response.status === 200) {
	            _this2.$store.commit('generalSession/setRoles', response.body);
	            _this2.checkPermission();
	          }
	        }, function (response) {
	          _this2.redirectToError('could_not_load', response.body.message);
	        });
	      } else {
	        this.checkPermission();
	      }
	    },
	    checkPermission: function checkPermission() {
	      var prefix = this.$route.meta.prefix;
	
	      var actions = this.permissions[0].actions;
	
	      var permissions = this.getRoles;
	
	      for (var prop in actions) {
	        if (!actions.hasOwnProperty(prop)) continue;
	
	        for (var property in permissions) {
	          if (!permissions.hasOwnProperty(property)) continue;
	
	          if (this.$route.name === 'management.unit.read' && !this.contentOnly) {
	            if (this.userPermissionNeeded) {
	              var perm = permissions[property].permission;
	              if (perm === 'USR_R') {
	                this.showButtons['read'] = true;
	                this.showButtons['unlock'] = true;
	              } else if (perm === 'USR_C') {
	                this.showButtons['create'] = true;
	              } else if (perm === 'USR_D') {
	                this.showButtons['delete'] = true;
	              } else if (perm === 'USR_U') {
	                this.showButtons['update'] = true;
	                this.showButtons['preview'] = true;
	              }
	            } else if (this.transactionOverview) {
	              var _perm = permissions[property].permission;
	              if (_perm === 'TRA_R') {
	                this.showButtons['read'] = true;
	              }
	            } else if (this.clearboxCampaignOverview) {
	              var _perm2 = permissions[property].permission;
	              if (_perm2 === 'SDC_R') {
	                this.showButtons['read'] = true;
	              }
	            }
	          } else if (permissions[property].permission === prefix + actions[prop]) {
	            if (prop === 'readsettings') {
	              var userSession = this.$store.getters['generalSession/getCurrentSession'];
	              var userRoles = userSession.data.user.userRoles;
	
	              var showReadConfigButton = false;
	
	              var _iteratorNormalCompletion = true;
	              var _didIteratorError = false;
	              var _iteratorError = undefined;
	
	              try {
	                for (var _iterator = (0, _getIterator3.default)(userRoles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                  var role = _step.value;
	
	                  if (role.code === 'dealerview') {
	                    showReadConfigButton = true;
	                    break;
	                  }
	                }
	              } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                  }
	                } finally {
	                  if (_didIteratorError) {
	                    throw _iteratorError;
	                  }
	                }
	              }
	
	              var isAdmin = userRoles.some(function (role) {
	                return role.code === 'supervisor';
	              });
	              var isDealerView = userRoles.some(function (role) {
	                return role.code === 'dealerview';
	              });
	
	              if (!isAdmin && !isDealerView && this.$route.name === 'management.till') {
	                this.showButtons['read'] = false;
	              }
	
	              this.showButtons[prop] = showReadConfigButton;
	            } else {
	              this.showButtons[prop] = true;
	            }
	          }
	        }
	      }
	    },
	    getItems: function getItems() {
	      return this.getItemsData(true);
	    },
	    getItemsData: function getItemsData(refreshFilterData) {
	      var _this3 = this;
	
	      this.itemsShowLoading = true;
	
	      this.paginationPageSize = this.pagination.items;
	
	      if (this.$route.params.uuid !== 'undefined') {
	        if (this.$route.name === 'management.unit.read') {
	          this.itemsParams.uuid = this.$route.params.uuid;
	        } else if (!this.contentOnly) {
	          if (this.itemsParams.organizationUuid !== this.$route.params.uuid) {
	            this.itemsParams.page = 1;
	          }
	          this.itemsParams.organizationUuid = this.$route.params.uuid;
	        } else if (this.$route.params.transactionLineOverview) {
	          this.itemsParams.uuid = this.$route.params.transactionUuid;
	        } else {
	          this.itemsParams.uuid = this.$route.params.uuid;
	        }
	      } else {
	        this.itemsParams.organizationUuid = '';
	        this.itemsParams.uuid = '';
	      }
	
	      if (this.searching) {
	        this.itemsParams.searchValue = this.itemsSearchValue;
	        this.getFunction = 'searchFunction';
	      } else {
	        this.itemsParams.searchValue = '';
	        this.getFunction = 'overviewFunction';
	      }
	      if (this.form.filter.length > 0) {
	        this.itemsParams.filterField = this.actions.filter.name;
	        this.itemsParams.filterValues = this.form.filter[0];
	        for (var i = 1; i < this.form.filter.length; i++) {
	          this.itemsParams.filterValues = this.itemsParams.filterValues + ',' + this.form.filter[i];
	        }
	      } else {
	        this.itemsParams.filterValues = [];
	      }
	
	      if (this.dataSource.endpoint === 'till' && this.$route.name === 'management.unit.read') {
	        this.itemsParams = { uuid: this.$route.params.uuid, params: this.itemsParams };
	      }
	
	      this.dataSource[this.getFunction](this.itemsParams).then(function (response) {
	        _this3.content = (0, _typeof3.default)(response.body.items) === 'object' ? response.body.items : [response.body];
	        if ((0, _typeof3.default)(_this3.content) !== 'object' || _this3.content.length <= 0) {
	          _this3.itemsShowLoading = false;
	          _this3.itemsError = _vue2.default.t('generic.overview.search.noresults');
	
	          if (_this3.pageNumber > 1) {
	            var previousPage = _this3.pageNumber - 1;
	            _this3.handlePaginationChange(previousPage);
	          }
	          return false;
	        }
	
	        _this3.itemsError = false;
	
	        if (_this3.dataSource.endpoint === 'unit' && _this3.$route.name === 'management.unit.read') {
	          _this3.content = _this3.content.map(function (item) {
	            return (0, _extends3.default)({}, item, {
	              type: _this3.$t(item.type)
	            });
	          });
	        }
	
	        _this3.itemsData = _this3.content;
	
	        _this3.allItems = response.body.allItems;
	        _this3.filterValues = response.body.filterValues;
	
	        _this3.itemsTotal = response.body.totalItems ? response.body.totalItems : _this3.content.length;
	
	        _this3.pageNumber = response.body.pageNumber;
	
	        if (_this3.pageNumber === 1) {
	          _this3.paginationCurrentItems = '1 - ' + (_this3.itemsTotal < _this3.pagination.items ? _this3.itemsTotal : _this3.pagination.items);
	        } else if (_this3.pageNumber === Math.ceil(_this3.itemsTotal / _this3.pagination.items)) {
	          _this3.paginationCurrentItems = _this3.itemsTotal - _this3.content.length + ' - ' + _this3.itemsTotal;
	        } else {
	          _this3.paginationCurrentItems = (_this3.pageNumber - 1) * _this3.pagination.items + ' - ' + _this3.pageNumber * _this3.pagination.items;
	        }
	        if (refreshFilterData) {
	          _this3.getFilterData();
	        }
	
	        _this3.itemsShowLoading = false;
	      }, function (response) {
	        _this3.itemsShowLoading = false;
	        _this3.itemsError = _vue2.default.t('generic.overview.search.noresults');
	        return false;
	      });
	    },
	    containsUserRole: function containsUserRole(role) {
	      var userSession = this.$store.getters['generalSession/getCurrentSession'];
	      var userRoles = userSession.data.user.userRoles;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(userRoles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var r = _step2.value;
	
	          if (r.code === role) {
	            return true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return false;
	    },
	    unlockItem: function unlockItem(name, identifier) {
	      if (identifier === '') {
	        this.$message.error({ message: _vue2.default.t('generic.errors.emptycolumnidentifier') });
	        return false;
	      }
	
	      this.dialogUnlockLoading = false;
	
	      this.dialogUnlockName = name !== '' ? name : '';
	
	      this.dialogUnlockVisible = true;
	
	      this.dialogUnlockIdentifier = identifier;
	    },
	    confirmUnlockItem: function confirmUnlockItem() {
	      var _this4 = this;
	
	      if (this.dialogUnlockIdentifier === '') {
	        this.$message.error({ message: _vue2.default.t('generic.errors.emptycolumnidentifier') });
	        return false;
	      }
	
	      this.unlockParams[this.actions.unlock.column.identifier] = this.dialogUnlockIdentifier;
	
	      this.dataSource.unlockFunction(this.unlockParams).then(function (response) {
	        _this4.$message.success({ message: _vue2.default.t('generic.overview.pagination.success.unlocked', { field: _this4.dialogUnlockName }) });
	
	        _this4.handlePaginationChange(1);
	
	        _this4.getItemsData(false);
	      }, function (response) {
	        var errorMessage = response.status === 400 ? response.statusText : response.body.message;
	        _this4.submitLoading = false;
	        _this4.redirectToError('unknown_error', errorMessage);
	      });
	
	      this.dialogUnlockLoading = true;
	
	      this.dialogUnlockVisible = false;
	    },
	    deleteItem: function deleteItem(item, column) {
	      var name = item[column['name']];
	      var identifier = void 0;
	
	      if (!column.identifier) {
	        throw new Error('Identifier required for column definition');
	      }
	
	      if ((0, _typeof3.default)(column.identifier) === 'object') {
	        identifier = {};
	
	        for (var key in column.identifier) {
	          if (!column.identifier.hasOwnProperty(key)) continue;
	
	          var value = column.identifier[key];
	
	          if (value.indexOf('.') === -1) {
	            identifier[key] = item[value];
	          } else {
	            var parts = value.split('.');
	            var itemValue = item;
	
	            for (var i = 0; i < parts.length; i++) {
	              itemValue = itemValue[parts[i]];
	            }
	
	            identifier[key] = itemValue;
	          }
	        }
	      } else {
	        identifier = {};
	        identifier[column.identifier] = item[column.identifier];
	      }
	
	      if (identifier === '') {
	        this.$message.error({ message: _vue2.default.t('generic.errors.emptycolumnidentifier') });
	        return false;
	      }
	
	      this.dialogDeleteLoading = false;
	
	      this.dialogDeleteName = typeof name !== 'undefined' ? name : 'this item';
	
	      this.dialogDeleteVisible = true;
	
	      this.dialogDeleteIdentifier = identifier;
	
	      if (column.units) {
	        this.dialogDeleteUnitList = item[column['units']].map(function (u) {
	          return u.name;
	        });
	        this.dialogDeleteUnitFormatted = this.dialogDeleteUnitList.map(function (d) {
	          return '<li>&nbsp; &nbsp; &bull; <strong>' + d + '</strong></li>';
	        }).join('');
	      }
	    },
	    confirmDeleteItem: function confirmDeleteItem() {
	      var _this5 = this;
	
	      if (!this.dialogDeleteIdentifier) {
	        this.$message.error({ message: _vue2.default.t('generic.errors.emptycolumnidentifier') });
	        return false;
	      }
	
	      this.deleteParams = this.dialogDeleteIdentifier;
	
	      this.dataSource.deleteFunction(this.deleteParams).then(function () {
	        _this5.$message.success({ message: _vue2.default.t('generic.overview.pagination.success.deleted', { field: _this5.dialogDeleteName }) });
	
	        if (_this5.$route.path === '/organization/overview') {
	          _this5.$store.commit('generalOrganization/setOrganizationSimpleTree');
	        }
	        _this5.getItems();
	      }, function (response) {
	        var errorMessage = response.status === 400 ? response.statusText : response.body.message;
	        _this5.submitLoading = false;
	        _this5.redirectToError('unknown_error', errorMessage);
	      });
	
	      this.dialogDeleteLoading = true;
	
	      this.dialogDeleteVisible = false;
	    },
	    isEmpty: function isEmpty(searchTerm) {
	      return searchTerm === 'undefined' || !searchTerm || searchTerm === null || searchTerm === '';
	    },
	    searchOnChange: function searchOnChange() {
	      var oldSearch = this.oldSearchValue;
	      var newSearch = this.itemsSearchValue;
	
	      if (this.isEmpty(oldSearch) && this.isEmpty(newSearch) || oldSearch === newSearch) {
	        return;
	      }
	      this.getSearch();
	    },
	    getSearch: function getSearch() {
	      this.searching = !this.isEmpty(this.itemsSearchValue);
	      if (this.searching) {
	        this.itemsShowLoading = true;
	        this.itemsParams.page = 1;
	      }
	
	      clearTimeout(this.timer);
	      this.timer = setTimeout(function () {
	        this.getItems();
	      }.bind(this), 350);
	      this.oldSearchValue = this.itemsSearchValue;
	    },
	    addParam: function addParam(url, name, value) {
	      if (value && value !== '') {
	        var firstparam = url.indexOf('?') === -1;
	        url += (firstparam ? '?' : '&') + name + '=' + value;
	      }
	      return url;
	    },
	    constructNewReadUrl: function constructNewReadUrl(baseurl, item) {
	      return baseurl + item.uuid;
	    },
	    constructNewOverviewUrl: function constructNewOverviewUrl() {
	      var url = window.location.pathname;
	      var currentRoute = this.$route.path;
	      var queryParams = {
	        search: this.itemsSearchValue,
	        page: this.itemsParams.page,
	        pagesize: this.paginationPageSize,
	        filter: this.itemsParams.filterValues
	      };
	      this.$router.replace({ path: currentRoute, query: queryParams });
	
	      url = this.addParam(url, searchUrlParamName, this.itemsSearchValue);
	      url = this.addParam(url, pageUrlParamName, this.itemsParams.page);
	      url = this.addParam(url, pageSizeUrlParamName, this.paginationPageSize);
	      url = this.addParam(url, filterParamName, this.itemsParams.filterValues);
	      return url;
	    },
	    filter: function filter(value, _filter, item) {
	      var formatValue;
	
	      if (typeof _filter !== 'undefined') {
	        if (value !== '') {
	          switch (_filter.type) {
	            case 'object':
	              if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value !== null) {
	                switch (_filter.select) {
	                  case 'first':
	                    formatValue = value[0][_filter.name];
	                    break;
	                  case 'last':
	                    formatValue = value[(0, _keys2.default)(value)[(0, _keys2.default)(value).length - 1]][_filter.name];
	                    break;
	                  default:
	                    formatValue = value[_filter.name];
	                    break;
	                }
	              }
	              break;
	            case 'array':
	              var arr = [];
	              for (var i = 0; i < value.length; i++) {
	                arr.push(value[i][_filter.key]);
	              }
	              formatValue = arr.join(', ');
	              break;
	            case 'uppercase':
	              formatValue = value.toUpperCase();
	              break;
	            case 'lowercase':
	              formatValue = value.toLowerCase();
	              break;
	            case 'currency':
	              {
	                formatValue = parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	                formatValue = formatValue === 'NaN' ? '' : formatValue;
	                var currencySymbol = (0, _currencySymbolMap2.default)(item.currency);
	                if (formatValue !== '') {
	                  formatValue = (typeof currencySymbol !== 'undefined' ? currencySymbol : '') + ' ' + formatValue;
	                } else {
	                  formatValue = '';
	                }
	                break;
	              }
	            case 'number':
	              {
	                var formatDecimal = typeof _filter.decimal === 'undefined' ? 2 : _filter.decimal;
	                formatValue = parseFloat(value).toFixed(formatDecimal);
	                formatValue = formatValue === 'NaN' ? '' : formatValue;
	                break;
	              }
	            case 'numberplus':
	              {
	                var _formatDecimal = typeof _filter.decimal === 'undefined' ? 2 : _filter.decimal;
	                formatValue = parseFloat(value).toFixed(_formatDecimal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	                formatValue = formatValue === 'NaN' ? '' : formatValue;
	                break;
	              }
	            case 'prefix':
	              formatValue = _filter.prefix + value.toUpperCase();
	              break;
	          }
	        }
	      } else {
	        formatValue = value;
	      }
	
	      return formatValue;
	    }
	  },
	  redirectToError: function redirectToError(error, text) {
	    this.$router.push({
	      name: 'generic.error.ErrorPage',
	      params: {
	        error_response: {
	          error_message: error,
	          error_text: text
	        }
	      }
	    });
	  }
	};

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(50);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueTimepicker = __webpack_require__(480);
	
	var _vueTimepicker2 = _interopRequireDefault(_vueTimepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DqSettingspanel',
	  replace: true,
	  props: {
	    label: '',
	    overridden: false,
	    settings: {},
	    readOnly: false,
	    form: {},
	    formRules: {}
	  },
	  data: function data() {
	    return {
	      activeNames: [1],
	      settingsNew: [],
	      selectedValues: [],
	      timePickerEnabled: false,
	      timePickerTimeStamp: '',
	      managerUnlockDelay: '',
	      managerUnlockStartTime: '',
	      managerUnlockEndTime: '',
	      useDefaultValues: [],
	      originalValues: [],
	      charitiesField: 'charities'
	    };
	  },
	  mounted: function mounted() {
	    this.updateSettings();
	  },
	
	  watch: {
	    settings: function settings() {
	      this.updateSettings();
	    }
	  },
	  components: {
	    VueTimepicker: _vueTimepicker2.default
	  },
	  methods: {
	    hasToolTipTranslationKey: function hasToolTipTranslationKey(key) {
	      return !_vue2.default.t('management.softwaresettings.toolTip.' + key).includes('management.softwaresettings.toolTip');
	    },
	    updateSettings: function updateSettings() {
	      this.settingsNew = [];
	      for (var index in this.settings) {
	        if (this.settings[index].type === 5) {
	          this.selectedValues = this.settings[index].value.split(',');
	        }
	        if (this.settings[index].type === 9) {
	          this.timePickerEnabled = JSON.parse(this.settings[index].value).enabled;
	          this.timePickerTimeStamp = JSON.parse(this.settings[index].value).timeStamp;
	        }
	        if (this.settings[index].type === 10) {
	          this.useDefaultValues[index] = this.settings[index].value == null;
	          this.originalValues[index] = this.settings[index].value;
	          this.form[this.settings[index].key] = this.settings[index].value;
	          this.updateFormRules(index);
	        }
	        if (this.settings[index].type === 16) {
	          var parsed = JSON.parse(this.settings[index].value);
	          this.settings[index].parsedValue = parsed.value;
	        }
	        if (!this.settings.hasOwnProperty(index)) continue;
	        this.settingsNew.push(this.settings[index]);
	      }
	
	      this.$store.commit('overrideSettings/setOverrideSettings', { settings: this.settingsNew });
	    },
	    updateFormRules: function updateFormRules(index) {
	      if (this.useDefaultValues[index]) {
	        delete this.formRules[this.settings[index].key];
	      } else {
	        var values = JSON.parse(this.settings[index].values);
	        var key = this.settings[index].key;
	        this.formRules[key] = [{ required: values.rules.required, message: _vue2.default.t('generic.forms.errors.required', { field: _vue2.default.t('generic.forms.errors.fields.' + key) }), trigger: 'blur' }, { min: values.rules.minLength, message: _vue2.default.t('generic.forms.errors.mincharlength', { min: values.rules.minLength }), trigger: 'blur' }, { max: values.rules.maxLength, message: _vue2.default.t('generic.forms.errors.maxcharlength', { max: values.rules.maxLength }), trigger: 'blur' }];
	      }
	    },
	    updateMultiSelection: function updateMultiSelection() {
	      for (var index in this.settings) {
	        if (this.settings[index].type === 5) {
	          this.settings[index].value = this.selectedValues.toString();
	        }
	      }
	    },
	    updateMaskedKeys: function updateMaskedKeys(index) {
	      var item = this.settings[index];
	      var newValue = item.parsedValue;
	
	      if (!newValue) {
	        item.value = (0, _stringify2.default)({ value: null, override: false });
	      } else {
	        item.value = (0, _stringify2.default)({ value: newValue, override: false });
	      }
	    },
	    updateTimeStampSelection: function updateTimeStampSelection() {
	      for (var index in this.settings) {
	        if (this.settings[index].type === 9) {
	          var tmpJson = JSON.parse(this.settings[index].value);
	          tmpJson.enabled = this.timePickerEnabled;
	          tmpJson.timeStamp = this.timePickerTimeStamp;
	          this.settings[index].value = (0, _stringify2.default)(tmpJson);
	        }
	      }
	    },
	    updateDefaultValueSelection: function updateDefaultValueSelection(index) {
	      this.updateFormRules(index);
	      if (this.useDefaultValues[index]) {
	        this.settings[index].value = null;
	      } else {
	        this.settings[index].value = this.originalValues[index];
	      }
	    },
	    generateNewDefaultValue: function generateNewDefaultValue(index) {
	      var values = JSON.parse(this.settings[index].values);
	      this.settings[index].value = this.generateRandomString(values.rules.minLength);
	      this.updateSettings();
	    },
	    generateRandomString: function generateRandomString(length) {
	      var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	      var result = '';
	      for (var i = length; i > 0; --i) {
	        result += chars[Math.floor(Math.random() * chars.length)];
	      }
	      return result;
	    },
	    hideTooltip: function hideTooltip(key) {
	      var keysWithoutTooltip = ['unitInitialLanguage', 'defaultLedColor', 'transactionReceiptNumber'];
	      return keysWithoutTooltip.includes(key);
	    }
	  }
	};

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DqSidemenu',
	  props: {
	    model: ''
	  },
	  methods: {
	    goToRoute: function goToRoute(uuid) {
	      if (this.$route.name !== 'management.unit.read') {
	        this.$router.push({
	          params: {
	            uuid: uuid
	          },
	          name: this.$route.name
	        });
	      }
	    },
	    isActive: function isActive(child) {
	      if (this.$route.name !== 'management.unit.read') {
	        return child.uuid === this.$route.params.uuid;
	      }
	      var parents = this.$store.getters['generalSession/getCurrentSession'].parentUuids;
	      for (var index in parents) {
	        var parentUuid = parents[index];
	        if (child.uuid === parentUuid) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }
	};

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(25);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DqTariffspanel',
	  replace: true,
	  props: {
	    label: '',
	    overridden: false,
	    companyTariffs: [],
	    readOnly: false
	  },
	  data: function data() {
	    return {
	      companyTariffsNew: [].concat((0, _toConsumableArray3.default)(this.companyTariffs))
	    };
	  },
	  mounted: function mounted() {
	    this.updateSettings();
	  },
	
	  watch: {
	    tariffsSettings: function tariffsSettings() {
	      this.updateSettings();
	    }
	  },
	  methods: {
	    updateSettings: function updateSettings() {
	      this.companyTariffsNew = [].concat((0, _toConsumableArray3.default)(this.companyTariffs));
	      this.$store.commit('overrideTariffSettings/setOverrideTariffSettings', { companyTariffs: this.companyTariffsNew });
	    }
	  }
	};

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DqUsermenu',
	  props: {
	    label: '',
	    showLogout: false
	  },
	  data: function data() {
	    return {
	      user: undefined
	    };
	  },
	  created: function created() {
	    this.user = this.$store.getters['generalSession/getCurrentSession'].data.user;
	  },
	
	  methods: {
	    resetUserQrSecret: function resetUserQrSecret(userUUID) {
	      var _this = this;
	
	      this.$dataApi().endpoints.user.resetQrSecret(userUUID).then(function (response) {
	        if (response.status === 200) {
	          _this.$message.success({ message: _vue2.default.t('management.user.messages.qrSecretReset') });
	        } else {
	          _this.$message.warning({ message: _vue2.default.t('generic.errors.mfaResetError') });
	        }
	      });
	    },
	    checkRoles: function checkRoles(roles) {
	      var userRoles = this.user.userRoles.map(function (role) {
	        return role.code;
	      });
	
	      return roles.some(function (item) {
	        return userRoles.includes(item);
	      });
	    }
	  },
	  computed: {
	    isMixUser: function isMixUser() {
	      return this.checkRoles(['manager', 'headmanager']);
	    },
	    canChangePin: function canChangePin() {
	      return this.checkRoles(['manager', 'employee', 'assistantmanager']);
	    }
	  }
	};

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

	module.exports = {"generic":{"application_name":"LincSafe Portal","copy_right":"Alle Rechte vorbehalten","submenu":{"title":"Organisationen","reset_text":"Zurücksetzen"},"mainmenu":{"login":"Anmelden","submenu":"Submenu","units":"Gerat","users":"Benutzers","locations":"Location","organizations":"Organisationen","tills":"Kassaladen","mixes":"Mischen","report":"Rapporten","citworkflow":"WTU workflow","softwaresettings":"Software settings","adminsettings":"Admin settings","departments":"Departments","roles":"Unit roles"},"overview":{"pagination":{"showing":"<strong>{current}</strong> von <strong>{total}</strong> Ansicht","pagesize":{"before":"Ansicht","after":"Importe"},"success":{"added":"hinzugefügt {field}","updated":"Aktualisiert {field}","deleted":"Gelöscht {field}","unlocked":"Freigeschaltet {field}"}},"dialog":{"delete":{"title":"Löschen bestätigen","description":"Sie sind dabei, diesen Benutzer zu löschen: ","confirmation":"Bist du sicher?","tillDescriptionName":"You are about to delete: ","tillDescriptionUnit":"and disconnect from {noUnits} unit(s): <ul>{units}</ul>","tillDescriptionUnits":"and disconnect from {noUnits} units?"},"warning":{"title":"Warnung","description":"Die CIT-Organisation wurde geändert. Bitte stellen Sie sicher, dass die neue Auswahl über Workflows verfügt, die alle Gerätetypen dieser Organisation unterstützen.","confirmation":"Sind Sie sicher, dass Sie mit der Aktualisierung fortfahren möchten?"},"unlock":{"title":"Freischalten bestatigen","description":"Sie sind dabei, diesen Benutzer zu freischalten: <strong>{name}</strong>","confirmation":"Bist du sicher??"},"filter":{"title":"Filter","confirmation":"Ok"}},"search":{"placeholder":"Suche...","noresults":"Wir konnten keine Ergebnisse für Ihre Suche finden..."},"filter":{"selectall":"Wählen Sie Alle","deselectall":"Alles abwählen","hide":"Filter ausblenden","show":"Show Filter"},"buttons":{"back":"Zuruck","cancel":"Annuleer","confirm":"Bestätigen","reset":"Zurücksetzen","create":"Erstellen","update":"Aktualisiert","delete":"Gelöscht","read":"Lesen","filter":"Filter","unlock":"Freischalten","ok":"OK","upload":"Upload"}},"forms":{"errors":{"required":"Es {field} ist ein Pflichtfeld","donotmatch":"Es{field} Feld ist nicht korrekt","minvalue":"Der Mindestwert ist {min}","maxvalue":"Der Maximalwert ist {max}","mincharlength":"Die minimale Feldlänge beträgt {min}","maxcharlength":"Die maximale Feldlänge beträgt {max}","minmaxcharlength":"Die Mindestanzahl von Zeichen ist {min} und die maximale Anzahl von Zeichen ist {max}","form":"Im Formular wurden Fehler gefunden. Überprüfen Sie die Felder unten","userNotFound":"E-mail adresse wurde nicht gefunden!","noworkflow":"Für den ausgewählten Gerätetyp ist kein Workflow verfügbar (Bitte erstellen Sie einen neuen Workflow auf der CIT-Workflow-Seite)","positiveOnly":"Nur positive Zahlen sind erlaubt","password":{"missing_lowercase":"Muss mindestens einen Kleinbuchstaben enthalten(a-z)","missing_uppercase":"Muss mindestens einen Großbuchstaben enthalten (A-Z)","missing_digit":"Muss mindestens eine Nummer enthalten (0-9)","missing_special":"Muss mindestens ein Sonderzeichen enthalten (!\"#%&'()*+,-.:;/<=>?@^_`{|}~)","missing_illegal":"Darf keine illegalen Zeichen enthalten"},"html":{"name":"Invalid characters detected"},"fields":{"firstuserrole":"erste Benutzerrolle","seconduserrole":"zweite Benutzerrolle","name":"name","unittype":"Gerätetyp","logintype":"Anmeldetyp","city":"Stadt","country":"land","location":"location","legalform":"Rechtsform","currency":"Wahrung","machinename":"Maschinenname","ownerorganization":"Mutterorganisation","pincodedropsafe":"pin Seite safe","pincodedropsafeconfirm":"pin Seite safe Bestatigung","pincodedrawer":"pin Schublade","pincodedrawerconfirm":"pin Schublade Bestatigung","firstname":"Vorname","lastname":"Nachname","organizations":"organisations","organization":"organisation","userroles":"Benutzerrolle","email":"e-mail","password":"Passwort","pin":"pin","mixname":"mischen Name","totalamount":"Gesamtmenge","maximumAmount":"maximale Menge","overrideworkflow":"workflow ändern","apiKeySettings":"API key","units":"units","mixes":"mixes","mfaEnabled":"MFA enabled","mfaSecret":"MFA Secret","username":"Username","placeholder":"component","placeholderAction":"component action","translationNl":"dutch translation","unittypefamily":"unit type family","timeZone":"timezone","serialnumber":"serial number","transactionCashOutLimit":"transaction cash out limit","dailyCashOutLimit":"daily cash out limit"},"required-because":"Das Feld {field} ist ein Pflichtfeld, da {field1} ausgewählt ist","maxPavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Max pavement value\"","pavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Pavement value\"","wrongDates":"Start datetime must be before end datetime","alphaCharsOnly":"Only alphabetical characters allowed","numbersOnly":"Only numerical characters (numbers) allowed","safeId":"Must consist of 1 alphabetical character followed by 14 digits. Example: A01234567890123","unable_to_process_request":"Unable to process your request at this time. Contact your administrator or try again later."},"loading":"Wird geladen...","select":"-- Wählen Sie aus der Liste --","messages":{"check_email_for_reset_link":"Please check your email for the reset link."}},"errors":{"title":"Ein Fehler ist aufgetreten","unknown_error":"Beim Abrufen der angeforderten Daten ist ein unbekannter Fehler aufgetreten.<br/>Versuchen Sie es später noch einmal.","could_not_load":"Wir konnten die angeforderten Informationen nicht abrufen.<br/>{response}","unauthorized":"Unautorisierter Zugriff","unauthorized_expired":"Sie wurden abgemeldet, weil Sie lange nicht aktiv waren oder weil Sie auf einem anderen System angemeldet","network_down":"Ein Netzwerkproblem ist aufgetreten. Bitte überprüfen Sie Ihr Netzwerk","back_button":"zurück zur vorherigen Seite","illegal_argument_uuid":"Ungültiger Eintrag gefunden","duplicate_entry":"Dieser Eintrag existiert bereits","emptycolumnidentifier":"Das Spalteneingabefeld ist leer","no_information":"Keine Information","mfaResetError":"Fehler beim Versuch, QR/Geheimnis für den Benutzer zurückzusetzen"},"login":{"title":"Anmeldung","mfaTitle":"Überprüfung","continue":"Continue","forgotPassword":{"title":"Passwort vergessen!","success":"Passwort erfolgreich zurückgesetzt!"},"mfaFlow":{"mfa_required":"MFA erforderlich","mfa_required_description":"Ihre Organisation verlangt, dass Sie eine MFA-Authentifizierung durchführen.","mfaHelp":"Hilfe bei MFA","errorGettingSecret":"Error obtaining your secret and QR","errorGettingMfaSettings":"Error obtaining MFA settings","mfaHelpTitle":"How restore MFA pairing in case of lost Phone/Authenticator","mfaHelpInstructions":"Contact your organization and provide them:<br/><br/> Full name <br/> Phone contact <br/> <br/> They will validate the information with you, and after that enable <strong>QR/secret</strong> pairing again.You shall receive an email once is done and will be able to see QR/secre from login screen again.","mfaHelpInstructionsOtherMfa":"There are more MFA methods available connect with them. <br/> If your organization enabled self QR/Secret recovery, click on your name at top right to see the <strong>User menu</strong> and click on Reset QR/Secret, so next login you will see the QR for new pairing.","understood":"Understood","setupMfaTitle":"Setup MFA","setupMfaDescription":"Please select one MFA type and click con continue.","setupMfaSelectType":"Select type of MFA","mfaPairingTitle":"Telefon-App-Einrichtung (einmalig)","mfaPairingQrImage":"QR-Bild:","mfaPairingSecret":"MFA secret: ","mfaPairingInstructionsTitle":"Anweisungen für die MFA Telefon-App","mfaPairingInstructionsLine1":"Laden Sie eine Authentifizierungs-App wie Google oder Microsoft Authenticator herunter.","mfaPairingInstructionsLine2":"Öffnen Sie es, klicken Sie auf Hinzufügen und wählen Sie dann QR oder Schlüssel aus.","mfaPairingInstructionsLine3":"Mit QR bitte das obige Bild scannen und für die manuelle Eingabe das MFA-Geheimnis kopieren.","mfaPhoneInstructionsTitle":"Anweisungen für die MFA Telefon-App","mfaPhoneInstructionsLine1":"Öffnen Sie Ihr Authenticator-Gerät oder Smartphone und suchen Sie nach dem dort angegebenen Code.","mfaPhoneInstructionsLine2":"Zur erneuten Kopplung siehe MFA-Fehlerbehebung.","mfaPhoneInstructionsLine3":"Wenn Sie diese Methode nicht mehr verwenden können, versuchen Sie es mit einer anderen MFA-Methode wie E-Mail.","mfaEmailInstructionsTitle":"Anweisungen für E-Mail MFA","mfaEmailInstructionsLine1":"Sie haben ein temporäres Zugriffstoken in Ihrer E-Mail erhalten.","mfaEmailInstructionsLine2":"Das Token ist für einige Minuten gültig.","mfaValidationTitle":" Code-Überprüfung","mfaValidationDescription":"Geben Sie den Code ein, der von Ihnen gewählten MFA-Methode bereitgestellt wird"},"form":{"username":"Nutzername","password":"Passwort","email":"E-mail","mfaCode":"Mfa Code"},"buttons":{"login":"Anmeldung","validate":"Überprüfen","forgotPassword":"Passwort vergessen!","reset":"Setze mein Passwort zurück"}},"logout":{"title":"Uitloggen","buttons":{"logout":"Ausloggen","profile":"Profil","changepassword":"Ändere das Passwort","changepin":"Andere pin","mfaResetQrSecret":"Reset MFA QR/Secret"}}},"management":{"unit":{"titles":{"overview":"Gerate","create":"Fügen Sie eine Gerate zu","update":"Ändern Sie eine Gerate","read":"Gerate Einzelheiten","inventory":"Inventar","readsettings":"Geräteeinstellungen","preview":"Unit preview"},"breadcrumb":{"title":"Uberblick"},"columns":{"no":"#","name":"Name","compartment":"Abteil","valueIn":"In","valueOut":"Aus","sales":"Verkauf","type":"Art","currentValue":"Aktueller Wert","insurableValue":"Versicherter Wert","location":"Location","unitStatus":"Gerate status","currency":"Währung","buildVersion":"Version","closeTime":"Zeit","userLoginName":"Benutzer","transactionNumber":"Nummer","counter":"Nummer","value":"Wert","dateTimeStopped":"Datum zeit stoppt","userAccountName":"Benutzer","valueProcessed":"Wert","machineName":"Gerate name","machineType":"Gerate type","serialNo":"Ordnungsnummer","unitIpAddress":"IP adresse","unitMacAddress":"MAC address","vpnIpAddress":"VPN IP adresse","teamviewerId":"Remote ID","remoteSupportId":"Remote-Hilfe ID","placeholder":"Komponent","placeholders":"Komponenten","date":"Datum","status":"Status","reason":"Grund","message":"Botschaft","description":"Beschreibung","source":"Quelle","level":"Niveau","amount":"Menge","total":"Gesamtwert","direction":"Richtung"},"form":{"machineName":"Machinename","location":"Location","organizations":"Organisation","ownerOrganization":"Mutterorganisation","supportMultipleClient":"Unterstützt mehrere Clients","clientOrganizations":"Clients organisations","inheritedCIT":"Mutter WTU","inheritedMaintenance":"Mutter Wartung","overrideCIT":"WTU ändern","overrideMaintenance":"Wartung ändern","overrideWorkflow":"Workflow ändern","unitType":"Gerat type","unitTypeFamily":"Unit type family","serialNo":"Ordnungsnummer","currency":"Währung","endOfDayTime":"Zeitende des Tages","hours":"Stunden","minutes":"Minuten","alarmOn":"Alarm ein","alarmValuePerDay":"Alarm Wert pro Tag","alarmOnMonday":"Montag","alarmOnTuesday":"Dienstag","alarmOnWednesday":"Mittwoch","alarmOnThursday":"Donnerstag","alarmOnFriday":"Freitag","alarmOnSaturday":"Samstag","alarmOnSunday":"Sonntag","maximumAmount":"Maximale Anzahl Münzen / Banknoten pro Kassette","insurableValue":"Versicherter Wert","offlineTimeout":"Offline-Dauer","pincodeDrawer":"Pin Schublade","sideSafe":"Hat seite safe","advancedManualDeposit":"erweiterte manuelle Einzahlung","drawer":"Hat Schublade","pincodeDropsafe":"Pin seite safe","pincodeDrawerConfirm":"Bestätigen PIN Schublade","pincodeDropsafeConfirm":"Bestätigen PIN seite safe","overrideSettings":"Muttereinstellungen überschreiben","apiKey":"API key","safeId":"Safe ID","maxPavementWarningPercentage":"Alarm on","departments":"Departments","coinDistribution":"Management"},"toolTip":{"machineName":"Der Name der Maschine","location":"Location ist die adresse, an der sich die Maschine befindet, muss erstellt werden, bevor das Gerät erstellt wird","organizations":"Organisations","ownerOrganization":"Die Organisation, die die Maschine verwaltet","supportMultipleClient":"Lassen Sie die Maschine von mehreren Organisationen verwenden","clientOrganizations":"Die Organisationen, die Geld in den Gerate einzahlen können","inheritedCIT":"Der von der übergeordneten Organisation geerbte WTU","inheritedMaintenance":"Die Wartungsorganisation, die von der übergeordneten Organisation geerbt wurde","overrideCIT":"So verwenden Sie eine andere WTU Organisation als den WTU, der von der übergeordneten Organisation stammt","overrideMaintenance":"So verwenden Sie eine andere Organisation als die Wartungsorganisation, die von der übergeordneten Organisation stammt","overrideWorkflow":"Ich verwende ein anderes WTU als das von der Mutterorganisation stammende Verfahren","unitType":"Was für eine Maschine ist das? Daraus werden verschiedene technische Details abgeleitet, z. B. aus welchen Komponenten die Maschine besteht. Dieses Feld kann nicht aktualisiert werden.","unitTypeFamily":"The family of unit types","serialNo":"Ordnungsnummer des Lincsafe-Systems, die auf einem Schild am Gerät zu finden ist. Dieser Code wird verwendet, wenn das Gerät zum ersten Mal eine Verbindung zum Portal herstellt","currency":"Die Währung, die von der Maschine verwendet werden kann","endOfDayTime":"HDie Zeit, die für die Berichterstellung vor Tagesende verwendet wird, z. B. für ein Geschäft, das nach Mitternacht schließt.","hours":"Stunden","minutes":"Minuten","alarmOn":"Sendet eine E-Mail, wenn das Gerät fast voll ist. Dies wird gesendet, wenn der eingegebene Prozentsatz des Versicherungswerts erreicht wurde. Die Empfänger können geändert werden, indem Sie auf der Organisationsübersichtsseite auf das Uhrensymbol neben der Organisation klicken","alarmValuePerDay":"Sendet eine E-Mail, wenn das Gerät fast voll ist. Dies wird gesendet, wenn der eingegebene Prozentsatz des Versicherungswerts erreicht wurde. Die Empfänger können geändert werden, indem Sie auf der Organisationsübersichtsseite auf das Uhrensymbol neben der Organisation klicken","alarmOnMonday":"Montag","alarmOnTuesday":"Dienstag","alarmOnWednesday":"Mittwoch","alarmOnThursday":"Donnerstag","alarmOnFriday":"Freitag","alarmOnSaturday":"Samstag","alarmOnSunday":"Sonntag","maximumAmount":"The maximum amount of bills/coins that can physically fit in a compartment. Not applicable for Lincstation","insurableValue":"Der maximale Geldwert in der Maschine, der durch eine Versicherung abgedeckt ist. Dies wird verwendet, um festzustellen, wann die Maschine voll ist und geleert werden muss.","offlineTimeout":"Die Zeit, die das Portal auf eine Heartbeat-Nachricht vom Gerät wartet, bevor das Gerät als online markiert wird.","pincodeDrawer":"Der PIN, der am Gerät eingegeben werden muss, um die Schublade zu öffne","sideSafe":"Das Gerät verfügt über einen Seitensafe, in den beispielsweise Gutscheine eingegeben werden können","advancedManualDeposit":"Erweiterte manuelle Eingabe aktivieren: Der Seitentresor kann für die offizielle Bareingabe verwendet werden, die von einem WTU-Unternehmen abgeholt werden kann","drawer":"Die Maschine verfügt über eine Schublade, mit der festsitzende Scheine / Münzen entfernt werden können","pincodeDropsafe":"Der PIN-Code, der am Gerät eingegeben werden muss, um den Seitensafe zu öffnen","pincodeDrawerConfirm":"Bestätigung des PIN-Codes für die Schublade","pincodeDropsafeConfirm":"Bestätigung der PIN für den Seitensafe","overrideSettings":"Stellen Sie den Tresor anders ein als die Standardeinstellungen der übergeordneten Organisation","maxPavementWarningPercentage":"A warning will pop up on the machine screen, telling the managers/CIT that the bag will be full soon. The user will be informed when it has reached the entered percentage of the max pavement value.","safeId":"Optional, custom, unique, 15 character identifier for this unit","overrideBankAccount":"Do not inherit primary bank account from Location. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Location. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Location. Instead, define a new one specific to this unit","coinDistribution":"Twin coin system distribution setting management in percentage"},"softwaresettings":{"1":"Freie Auszahlung","2":"Von hoch nach niedrig","listUserByOrganization":"Benutzer nach Organisation auflisten","listUserByUsername":"Benutzer nach Namen auflisten","xmlExportName":"XML exports","useReferenceNumber":"Nummer Seite (nicht verwenden, nur für alte Versionen)","referenceNumberLength":"Referenznummer Länge","unitBarcodeTypeOnFirstCitPage":"Display Barcode of Unit Name (CIT Screen)","currencyCode":"Währung","hopper1Value":"Werte hopper 1","hopper2Value":"Werte hopper 2","numberOfCoins":"Anzahl der Münzen","beepOnBillRejected":"Lärm, wenn eine Banknote abgelehnt wird","transactionPerBill":"Transaktion pro Banknote","loginRequiredTransaction":"Anmelden für die Transaktion","buzzerTimeout":"Sound-Timeout","hasPrinterAttached":"Druckerbenachrichtigungen anzeigen","enableOTC":"OTC einschalten","billMaxAmount":"Maximum amount threshold for bills","coinMaxAmount":"Maximum amount coins overflow","heartbeatRate":"Heartbeat Frequenz","downloadRate":"Download Frequenz","safeStatusRate":"Safe status Frequenz","inventorySettings":"Inventar Einstellungen","payableValue":"Wert zu zahlen","floatValue":"Tagesstart wert","floatSettings":"Tagesstart Einstellungen","payOutMethod":"Auszahlungsmethode","round":"Abgerundeter Wert","payOutLimit":"Auszahlungslimit","language":"Sprache","bins":"Bank Id Nummers","ecrId":"Pin Terminal Id","ecrUrl":"Payplaza Url","charities":"Charities","g4sApiUrl":"Banks Authorization Url","authApiKey":"Authorization API Key","employeeSelection":"Mitarbeiterauswahl","supportedLanguages":"Unterstützte Sprachen","showDeviceTotal":"Maschinensumme anzeigen","showExtraButtonOnUserSelectScreen":"Knopf zum Auswählen extra Benutzer zeigen","pavementLimit":"Bürgersteig Grenze","communicationRate":"Communication Frequenz","depositTimeout":"Timeout-Eingabe in Sekunden","normalDepositReceipts":"Anzahl der Belege Transaktion","manualDepositReceipts":"Anzahl der Belege manuelle Transaktion","showDenominationDetailsOnDepositPrint":"Anzahl der Stückelungen beim Drucken der Anzahlung anzeigen","showUserTotals":"Show user totals function","showDailyReports":"Show daily reports function","manualEndOfDay":"Manual end of day","textLanguage":"Text language selection","dateFormat":"Date format","MMddyyyy":"United States (12/31/2000)","dd-MM-yyyy":"International (31-12-2000)","MMMddyyyy":"US Global (Dec 31 2000)","ddMMMyyyy":"Alternate International (31 Dec 2000)","yyyy-MM-dd":"Year-Month-Day (2000-12-31)","screenSaver":"Bildschirmschoner","preTransactionTask":"Referenznummer anzeigen","noTask":"Nein","refNr":"Referenznummernseite anzeigen","low":"Niedrig","medium":"Mittel","high":"Hoch","high_low_medium":"Benutzerdefiniert 1","Low":"Niedrig","Medium":"Mittel","High":"Hoch","namelist":"Namensliste","empnr":"Geben Sie die Mitarbeiternummern ein","en":"Englisch","nl":"Niederländisch","fr":"Französisch","hu":"Ungarisch","sk":"Slowakisch","pl":"Polieren","EUR":"EUR","TR":"TR","USD":"USD","noExport":"keine export","MLSA":"OCS export","puloonCassette1":"Puloon Cassette 1","puloonCassette2":"Puloon Cassette 2","puloonCassette3":"Puloon Cassette 3","puloonCassette4":"Puloon Cassette 4","EUR-5":"5 €","EUR-10":"10 €","EUR-20":"20 €","EUR-50":"50 €","EUR-100":"100 €","EUR-200":"200 €","EUR-500":"500 €","puloonCassette1FixedAmount":"Puloon Casette 1 Fester Zahl","puloonCassette2FixedAmount":"Puloon Casette 2 Fester Zahl","puloonCassette3FixedAmount":"Puloon Casette 3 Fester Zahl","puloonCassette4FixedAmount":"Puloon Casette 4 Fester Zahl","inventoryCheckOnPayment":"Überprüfen Sie das Inventar bei Zahlung","tariffs":"Tariffs","acceptablesSetting":"Enabled denominations","minimumOrderRolls":"Minimal roll order amount","inventoryOptimumReset":"Inventory float down time","escrowEmptyAmount":"Escrow empty amount","maxBagValue":"Max pavement value","ledLightColor":"LED light color","yellow":"Gelb","red":"Rot","green":"Grün","blue":"Blau","magenta":"Magenta","cyan":"Cyan","white":"Weiß","posMode":"POS mode","none":"None","barcode_itf":"Barcode ITF","qrcode":"QR Code","inventorypanel":{"denomination":"Denomination","material":"Material","recycled":"Recycelt","numberOfRecyclers":"Recycler count","min":"Min","optimum":"Optimaal","max":"Max","value":"Wert","COIN":"Coin","BILL":"Bill","ROLL":"Roll","messages":{"recyclerStatusInfo":"{totalRecyclers} of {maxNumberOfRecyclers} recyclers are used","recyclerStatusError":"Error: Exceed the max recycler count ({maxNumberOfRecyclers}); claimed: {totalRecyclers}","excideMaximumDrawer":"Max drawer dispensable limit is {limit}","excideMaximumCup":"Max cup dispensable limit is {limit}"},"low":"Low","maxDispensable":"Max dispensable","high":"High"},"tariffspanel":{"transaction_fee":"Gebühr pro Transaktion","value_fee":"Gebühr pro Munzrolle"},"minimumOrderPanel":{"min":"Min (1)","max":"Max (200)"},"timeSelector":{"enabled":"Enabled"},"minimumOrderCoinRollsSettings":"Mindest- und Höchstbestellmengen für Münzrollen","apiKeySettings":"API-Schlüssel","useDefaultValue":"Standardwert verwenden","om61InventorySettings":"OM61-Inventareinstellungen","allowManagerEmptyAllRecyclers":"Manager darf alle Recycler leeren","managerUnlockDelay":"Verzögerungszeit zum Entsperren der Tresortüren","managerUnlockStartTime":"Startzeit für das Entsperren","managerUnlockEndTime":"Endzeit für das Entsperren","localPinChange":"Benutzer-PIN auf der Einheit ändern","customXmlHeader":"Benutzerdefinierte XML-Header","coinDistribution":"Einstellung für die Verteilung im Twin-Coin-System","puloonRejectBinMaxAmount":"Maximale Anzahl von Banknoten, die der Puloon Reject Bin verarbeiten kann","puloonRejectBinWarningPercentage":"Warnstufe für die volle Kapazität des Puloon Reject Bins (Prozentsatz)","autoFloatDownWhenSystemIsIdle":"Automatische Absenkung, wenn das System nicht aktiv ist","tillRestrictions":"Restricted tills","maxPavementWarningPercentage":"Max pavement value alarm","g4sCertificate":"G4S Certificate","payplazaCertificate":"Payplaza Certificate","storageVault":"Storage vault","userManagement":"User management"},"actions":{"create":"Gerat zufügen","read":"Gerat anzeigen","update":"Gerat ändern","delete":"Gerat Löschen","filter":"Geraten nach Status filtern","readsettings":"Geräteeinstellungen sehen","preview":"Unit preview"},"messages":{"added":"Das gerat {name} ist zugefügt","updated":"Das gerat {name} ist geändert"},"read":{"tabs":{"detail":"Detail","specifications":"Technische Spezifikationen","status":"Status","users":"Benutzer","sales":"Verkauf","internal":"Intern","mixes":"Mixes","citLegacy":"Legacy","citDynamic":"Dynamic","citStatic":"Static"},"summary":{"maximumAmount":"Max. Münzen / Banknoten pro Kassette","machineName":"Machine name","insurableValue":"Versicherter Wert","currentValue":"Aktueller Wert","currentDepositValue":"Aktueller eingezahlter Wert","unitModelName":"Gerat type","unitTypeFamily":"Unit type family","location":"Location","placeholders":"Komponenten","lastTransactionDate":"Letztes Transaktionsdatum","currency":"Währung","currentStatus":"Aktueller Status","networkStatus":"Netzwerkstatus","lastClearBox":"Letzte Entleerung","yesterdayTurnover":"Umsatz von gestern","lastClearBoxDate":"Datum der letztes Entleerung","fillGrade":"Füllgrad","numberOfTransactions":"Anzahl der Transaktionen","name":"Name","addressLine1":"Adresse","city":"Stadt","unitFillStatus":"Füllgrad erreicht","ALMOST_FULL":"FAST VOLL","FULL":"VOLL","NORMAL":"NORMAL","null":"null"},"titles":{"unitStatus":"Gerat status","unitDetail":"Gerat detail","unitDetails":"Gerat details","location":"Standortdaten","lastTransactions":"Letzte Transaktion","campaignsUnit":"Gerat Entleerung","lastClearBoxes":"Letzte Entleerung","component":"Technische Spezifikationen","eventsByUnit":"Veranstaltungen","lastEvents":"Letzte Veranstaltungen","hardwareStatus":"Hardware: ","networkStatus":"Netzwerk: ","notifications":"Benachrichtigungen","departments":"Department details"},"status":{"ALMOST_EMPTY":"FAST LEER","ALMOST_FULL":"FAST VOLL","DEBUG":"Debug","EMPTY":"LEER","ERROR":"Error","FATAL":"Ende","FULL":"VOLL","INFO":"Info","INVENTORY_NOT_SUFFICIENT":"Muss gefüllt werden","INVENTORY_OVER_MAXIMUM":"Muss geleert werden","INVENTORY_UNDER_MIN":"LAGER unter Minimum","INVENTORY_UNDER_LOW":"LAGER unter low","JAMMED":"Entfernen Sie den Stau","NOT_CONNECTED":"Überprüfen Sie die Netzwerkverbindung zum Gerät","NOT_SECURE":"Entriegeln Sie die Tür und schließen Sie sie und verriegeln Sie sie erneut","OFFLINE":"Gerät ist offline","OK":"OK","OPEN":"Schliessen Sie die Tur","OVERRIDDEN":"Verwenden Sie das Menü, um die Tür zu entriegeln und dann zu verriegeln","RECYCLER_ALMOST_EMPTY":"Füllen Sie den Recycler","RECYCLER_ALMOST_FULL":"Recycler fast voll","RECYCLER_EMPTY":"Recycler leer","RECYCLER_FULL":"Recycler voll","STACKER_FULL":"Löschen Sie die Scheine aus dem Stapler","STORAGE_ALMOST_FULL":"Lager fast voll","STORAGE_DETACHED":"Bringen Sie den Lager an","STORAGE_FULL":"Lager muus geleert werden","TRACE":"Trace","UNLOCKED":"Schließen Sie die Tür","WARN":"Warnung","WARNING":"Warnung"},"techSpec":{"ACCEPTING":"Annahme","ALMOST_EMPTY":"Fast Leer","ALMOST_FULL":"Fast Voll","BAG_OPEN":"Bag Open","CALIBRATING":"Kalibrieren","CASSETTE_ERROR":"Cassette Error","CASSETTE_ATTACHED":"Cassette Befestigt","CASSETTE_DETACHED":"Cassette Entfernt","CARTRIDGE_DETACHED":"Cartridge Entfert","CLOSED":"Geschlossen","CONNECTED":"in Verbindung","DOOR_CLOSED":"Tur Geschlossen","DOOR_OPEN":"Tur offnen","DOOR_LOCKED":"Tur gesperrt","DOOR_UNLOCKED":"Tur freigeschaltet","DOWNLOADING":"wird heruntergeladen","EMPTY":"Leer","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Zugriff nicht Leer","EXTENSION_STALL":"Extension stall","FAILED":"Gescheitert","FEED_FAILURE":"Zugriff gescheitert","FULL":"Voll","INVENTORY_NOT_SUFFICIENT":"Lager nicht ausreichend","INVENTORY_OVER_MAXIMUM":"Lager über maximal","INVENTORY_UNDER_MIN":"Lager unter minimum","INVENTORY_UNDER_LOW":"Lager unter low","JAM_CLEARED":"Stau gelöscht","JAMMED":"Stau","LOCKED":"Gesperrt","LOCKS_SECURE":"Locks Secure","NOT_ACCEPTING":"Nicht akzeptiert","NOT_CONNECTED":"Nicht verbunden","NOT_FOUND":"Konfiguration nicht gefunden","NOT_OPERATIONAL":"Nicht funktionsfähig","NOT_OVERRIDDEN":"Nicht Overridden","NOT_SECURE":"Nicht sichern","OFFLINE":"OFFLINE","ONLINE":"ONLINE","NETWORK_DISCONNECTED":"Network disconnected","NETWORK_RESTORED":"Network restored","OK":"OK","OPEN":"offnen","OVERRIDDEN":"Overridden","PAUSE":"Pause","POWER_UP":"Einschalten","RECYCLER_ALMOST_EMPTY":"Recycler fast leer","RECYCLER_ALMOST_FULL":"Recycler fast voll","RECYCLER_EMPTY":"Recycler Leer","RECYCLER_FULL":"Recycler Voll","REJECT_NOT_EMPTY":"Die Ablehnung ist nicht leer","OUTPUT_NOT_EMPTY":"Output is not empty","SAFE_DOOR_OPEN":"Safe door open","SECURE":"Sichern","SIDE_SAFE_ONE_LOCKED":"Seitensafe 1 verriegelt","SIDE_SAFE_ONE_UNLOCKED":"Seitensafe 1 entriegelt","STACKER_FULL":"Stacker Voll","STORAGE_ALMOST_EMPTY_005":"Münzrollenlager fast leer für 5 Cent","STORAGE_ALMOST_EMPTY_010":"Münzrollenlager fast leer für 10 Cent","STORAGE_ALMOST_EMPTY_020":"Münzrollenlager fast leer für 20 Cent","STORAGE_ALMOST_EMPTY_050":"Münzrollenlager fast leer für 50 Cent","STORAGE_ALMOST_EMPTY_100":"Münzrollenlager fast leer für 1 Euro","STORAGE_ALMOST_EMPTY_200":"Münzrollenlager fast leer für 2 Euro","STALLED":"Stalled","STORAGE_ALMOST_FULL":"Lager fast Voll","STORAGE_ALMOST_FULL_CLEARED":"Storage Almost Full Cleared","STORAGE_ATTACHED":"Lager Befestigt","STORAGE_DETACHED":"Lager Entfernt","STORAGE_FULL":"Lager Voll","TOP_DOOR_CLOSED":"Obere Tür geschlossen","TOP_DOOR_OPEN":"Obere Tur öffne","UNLOCKED":"Unlocked"}},"inventory":{"unitInventory":"Gerat Inventar","noTransactions":"Keine Transaktionen","noTransactionsDesc":"Keine Transaktionen gefunden, bitte versuchen Sie es später erneut.!","items":"Artikel","total":"Gesamt ","cassette":"Kassette"},"campaign":{"read":"Last clearboxes","columns":{"no":"#","group":"Group","placeholder":"Component","dateTimeStopped":"Date time stopped","userAccountName":"User","insertedValue":"Inserted","valueProcessed":"Collected","totalValueProcessed":"Total value processed"}}},"softwaresettings":{"titles":{"overview":"Softwareeinstellungen","create":"Softwareeinstellungen hinzufügen","update":"Ändern Sie die Softwareeinstellungen","readsettings":"Lesen Sie die Softwareeinstellungen"},"breadcrumb":{"title":"Überblick"},"actions":{"create":"Softwareeinstellung hinzufügen","read":"Sehen Softwareeinstellung","update":"Veränder Softwareeinstellung","delete":"Löschen Softwareeinstellung","readsettings":"Lesen Sie die Softwareeinstellungen"},"columns":{"ownerOrganization":"Mutter organization","unitType":"Gerat Type"},"messages":{"added":"Neue Einstellungen wurden hinzugefügt","updated":"Einstellungen wurden geändert"},"form":{"ownerOrganization":"Mutter organisation","unitType":"Gerat Type","overrideSettings":"Standardeinstellungen überschreiben","selectOverrideSettings":"Wählen Sie die zu überschreibenden Einstellungen aus und verwenden Sie sie","checkAll":"Alles überprüfen","cassettesAssignment":"Cassettes Assignment"},"toolTip":{"hasPrinterAttached":"Nur verwenden, wenn ein Drucker angeschlossen ist","listUserByOrganization":"Listen Sie die Benutzer nach Organisation auf, wenn der Tresor mehrere Clients unterstützt","listUserByUsername":"Zeigen Sie die Namen der Benutzer an. Wenn diese Einstellung deaktiviert ist, werden nur die Mitarbeiternummern angezeigt","xmlExportName":"Zum Exportieren von XML-Dateien an Dritte","useReferenceNumber":"Einstellung zum Anzeigen einer zusätzlichen Seite mit einer Zahlung, nur für alte Versionen","referenceNumberLength":"Länge der Referenznummer","currencyCode":"Valuta voor NS Wisselaar hoppers","hopper1Value":"Waarde NS Wisselaar hopper 1","hopper2Value":"Waarde NS Wisselaar hopper 2","numberOfCoins":"Hoeveelheid munten per NS wisselaar hopper","beepOnBillRejected":"Macht ein Ton, wenn ein Ticket abgelehnt wird (nur für Automaten mit Lautsprecher)","transactionPerBill":"Erstellen Sie für jede eingegebene Banknote eine neue Transaktion","loginRequiredTransaction":"Der Benutzer muss sich anmelden, bevor Banknote eingegeben werden können","buzzerTimeout":"Maximale Dauer, in der der Ton mit einem abgelehnten Banknote erzeugt wird","enableOTC":"OTC Sperrcodes","heartbeatRate":"Häufigkeit zum Senden des Herzschlags an das Portal","downloadRate":"Häufigkeit zum Herunterladen von Konfigurationsdateien vom Portal auf das Gerät","safeStatusRate":"Häufigkeit zum Senden des Status des Geräts an das Portal","inventorySettings":"Der Einstellung für den Inhalt des Lincstation-Safes handelt es sich um akzeptierte Materialien, recycelte Materialien, Mindestwert, Tagestart-Wert und Maximalwert pro Stückelung","payableValue":"Mindestwert, den die Lincstation enthalten muss, bevor sie betriebsbereit ist und Zahlungen akzeptiert","floatValue":"Tagesstartwert der Lincstation","billMaxAmount":"Maximum amount threshold for bills in Lincstation","coinMaxAmount":"Maximum amount of coins in the overflow. A warning will be generated at 80% of this value.","payOutMethod":"Auszahlungsmethode für das Smart Coin System auf der de Lincstation","round":"Diese Einstellung wird verwendet, um den eingegebenen Wert einer Zahlung auf der Lincstation abzurunden","payOutLimit":"Limit pro Auszahlung an der Lincstation","language":"Die Sprache, die auf dem Gerät aktiv ist","bins":"Liste der pro Bank unterstützten Bank-ID-Nummern","employeeSelection":"Zeigen Sie für eine Zahlung einen Bildschirm an, auf dem ein Mitarbeiter mit einer Mitarbeiternummer gefunden werden kann, oder zeigen Sie eine Liste mit Namen an","supportedLanguages":"De talen die ondersteunt worden door de unit","showDeviceTotal":"Toon de totale inhoud van de unit en de details per denominatie in het manager menu","showExtraButtonOnUserSelectScreen":"Wenn aktiviert, wird auf den Schirm für Benutzerauswahl ein zusätzlicher Knopf zum Benutzerauswahl gezeigt","pavementLimit":"Bürgersteig Grenze fur die cassette","communicationRate":"Frequenz für die Kommunikation zwischen dem Gerät und dem Portal. Diese Einstellung legt die Download- und Heartbeat-Frequenz fest. Mit den Optionen 'Hoch', 'Mittel' und 'Niedrig' werden beide Frequenzen auf diesen Pegel eingestellt. Mit der Option 'Benutzerdefiniert 1' ist die Downloadfrequenz niedrig und die Herzschlagfrequenz hoch","depositTimeout":"Timeout-Dauer für den Zahlungsbildschirm","normalDepositReceipts":"Anzahl der nach einer normalen Zahlung gedruckten Belege","manualDepositReceipts":"Anzahl der nach einer manuellen Zahlung gedruckten Belege (z. B. Eingabe des Wertes eines Gutscheins)","showDenominationDetailsOnDepositPrint":"Zeigen Sie die Stückelungen auf der Quittung für eine Zahlung an","showUserTotals":"Show user totals function in settings screen","showDailyReports":"Show daily reports function in management screen","manualEndOfDay":"End of day will be manually performed by a manager (This setting disables the automatic end of day feature)","textLanguage":"Use text language selection screen (instead of flags)","dateFormat":"The date format displayed on receipts and screen","preTransactionTask":"Zeigen Sie vor Beginn einer Zahlung eine Seite an, auf der die Referenznummer eingegeben werden kann","screenSaver":"Bildschirmschoner anzeigen, wenn das Gerät nicht verwendet wird","puloonCassette1":"Stückelung für Casette 1","puloonCassette2":"Stückelung für Casette 2","puloonCassette3":"Stückelung für Casette 3","puloonCassette4":"Stückelung für Casette 4","puloonCassette1FixedAmount":"Feste Anzahl von Noten in Casette 1","puloonCassette2FixedAmount":"Feste Anzahl von Noten in Casette 2","puloonCassette3FixedAmount":"Feste Anzahl von Noten in Casette 3","puloonCassette4FixedAmount":"Feste Anzahl von Noten in Casette 4","inventoryCheckOnPayment":"Überprüft, ob der eingegebene Betrag während der Zahlung ausgegeben werden kann","charities":"Charity organizations data","escrowEmptyAmount":"Minimum amount for escrow to be emptied","maxBagValue":"Maximum value for the bag","inventoryOptimumReset":"The time when the inventory of the machine will reset back to optimum values based on the inventory settings","apiKeySettings":"API Key for the connector","ledLightColor":"LED-Lichtfarbe","posMode":"Point of sale mode limits machine functionality by disabling some buttons","ecrId":"The id for the terminal connected to the unit","ecrUrl":"The endpoint used to perform payments and other card transactions","g4sApiUrl":"The endpoint used for the authorization of cards","allowManagerEmptyAllRecyclers":"Enables the manager to dispense all available notes and coins locally on the unit","managerUnlockDelay":"Manager delay for opening tills and coin drawer","localPinChange":"Able to change user pin code on unit","customXmlHeader":"Set custom XML data needed for integration","puloonRejectBinMaxAmount":"Puloon reject bin maximum notes capacity","puloonRejectBinWarningPercentage":"Warning level set in percentage for Puloon reject bin. This functionality is disabled if 0 is set","unitBarcodeTypeOnFirstCitPage":"Enables unit name to be shown as a barcode on device display at the start of CIT flow","autoFloatDownWhenSystemIsIdle":"Auto float down if no active transaction and recycler is full","g4sCertificate":"Certificate for software management","payplazaCertificate":"Certificate for software management","managerUnlockStartTime":"Unlock start time","managerUnlockEndTime":"Unlock end time","tillRestrictions":"When selected, tills are only allowed to be dispensed once. They will become available again after the till is deposited back into the machine. When deselected, tills can be used multiple times.","storageVault":"Enable additional storage vault","userManagement":"Enable user management","authApiKey":"Authorization API Key"},"billsDenominationTable":{"yes":"YES","no":"NO","columns":{"cassettes":"Cassettes","recycler":"Recycler","denomination":"Denomination","currency":"Currency","optimum":"Optimum","max":"Max"}}},"user":{"titles":{"overview":"Benutzer","create":"Fügen einen Benutzer zu","update":"Ändern einen Benutzer","changepassword":"Passwort ändern","changepincodes":"PIN ändern","updateprofile":"Profil ändern","forgotpassword":"Passwort vergessen","resetpassword":"Passwort zurücksetzen","readsettings":"Benutzereinstellungen"},"breadcrumb":{"title":"Überblick"},"columns":{"name":"Name","organization":"Organisation","email":"E-mail","roles":"Benutzerregeln"},"form":{"firstName":"Vorname","lastName":"Nachname","rfid":"RFID / Dallas Key","employeeNumber":"Mitarbeiternummer","organization":"Organisation","roles":"Benutzerregeln","email":"E-mail","password":"Passwort","username":"Username","passwordConfirm":"Bestätige Passwort","sendTemporaryPassword":"Temporäres Passwort senden","pin":"Pin","pinConfirm":"Bestätige pin","openDropsafeWithPin":"öffnen seite safe mit pin","openDrawerWithPin":"öffnen schublade mit pin","units":"Gerat","oldPassword":"Altes Passwort","newPassword":"Neues Passwort","confirmPassword":"Bestätige neues Passwort","oldPin":"Altes pin","newPin":"Neues pin","tills":"Kassenschubladen","mixes":"Mischen","dailyDispenseLimit":"Tägliches Abgabelimit","dailyPayoutLimit":"Daily payout limit","mfaEnabled":"Enable multi-factor authentication","generate":"Generate","copied":"Copied","secretkey":"Secret key","useExternalRoles":"Use external roles","externalUsername":"External Username","externalPassword":"External Password","unitRoles":"Unit role","storageVaultAccess":"Storage vault access","departments":"Departments"},"actions":{"create":"Benutzer hinzufügen","read":"Benutzer sehen","update":"Benutzer andern","delete":"Benutzer löschen","unlock":"Benutzer freischalten","readsettings":"Benutzereinstellungen sehen"},"messages":{"added":"Der Benutzer {name} wurde hinzugefügt","updated":"Der Benutzer {name} wurde geändert","changedpassword":"das Passwort wurde geändert","changedpin":"Der Pin wurde geändert","updateprofile":"Das Profil wurde geändert","qrSecretReset":"The QR/secret has been reset correctly"},"toolTip":{"mfaEnabled":"Enable multi-factor authentication","copySecret":"Copy secret text","useExternalRoles":"Use external roles"}},"location":{"titles":{"overview":"Location","create":"Füge einen Ort hinzu","update":"Ändern Sie einen Ort","readsettings":"Ortseinstellungen"},"breadcrumb":{"title":"Überblick"},"columns":{"city":"Stadt","name":"Name","addressLine":"Adresse"},"form":{"name":"Name","city":"Stadt","addressLine1":"Adresse","addressLine2":"Adresse 2","postalCode":"Postleitzahl","country":"Land","phoneNumber":"Telefonnummer","email":"E-mail","organization":"Organization","state":"State/Province","timeZone":"Timezone","departments":"Departments"},"actions":{"create":"Location hinzufügen","read":"Location sehen","update":"Location andern","delete":"Location löschen","readsettings":"Ortseinstellungen sehee"},"messages":{"added":"Die location {name} ist hinzugefügt","updated":"Die location {name} ist geändert"},"toolTip":{"organization":"Organization to which this location belongs to","timeZone":"Machine time will be set up according to the timezone.","overrideBankAccount":"Do not inherit primary bank account from Organization. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Organization. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Organization. Instead, define a new one specific to this unit"}},"organization":{"titles":{"overview":"Organisation","create":"Füge einen Organisation hinzu","jobs":"Organisation Arbeitsplätze","update":"Organisation andern","readsettings":"Organisationseinstellungen","mfaTypes":"MFA types"},"breadcrumb":{"title":"Überblick"},"columns":{"name":"Name","location":"Location","parentOrganization":"Mutter organisation","organizationType":"Organisation type"},"form":{"dayTotalJob":"Täglich insgesamt","mailSendingTime":"Sendezeit der E-Mail","enabled":"Aktiviert","remainingUsers":"Übrig gebliebene Benutzer","subscribers":"Abonnenten","affectedUnits":"Aktivierte Gerate","name":"Name","ipWhiteList":"IP white list","pin":"Pin","organizationType":"Organisation type","parentOrganization":"Mutter organisation","inheritedCIT":"Mutter WTU","inheritedMaintenance":"Mutter wartung","overrideCIT":"WTU organisation Überschreiben ","overrideMaintenance":"Wartung organisation Überschreiben","defaultCIT":"Standard WTU","defaultMaintenance":"Standaard wartung","reportedOrganizations":"Implementierte organisation","location":"Location","legalForm":"Rechtliche Identität","remark":"Hinweis","forceMfaForUsers":"Force MFA auth for users","enableUserMfaSecretReset":"Allow users to reset their QR/Secret","enableAuthdeviceMfa":"Phone/Authenticator device MFA","enableEmailMfa":"Email MFA","enableSmsMfa":"SMS MFA","workflows":"Workflows","forceEmployeePin":"Obligatorische PIN für Mitarbeiter","userPincodeSeverity":"User pincode severity","ibutton":{"overview":"iButton keys overview","noData":"There are no iButton keys to show","add":"Add iButton key","uploadCSV":"Upload CSV","name":"iButton Key","removeAll":"Remove all iButton keys","removeAllConfirmationText":"Are you sure that you want to delete all ibuttons?","remove":"Remove","cancel":"Cancel","delete":"Delete","ok":"OK","invalidCSVfile":"Please upload a valid CSV file.","uploadInfo":"Upload is finished.","uploadDescription":"It seems that some keys weren't inserted because they didn't meet the required criteria.","uploadCSVInfo":"Only valid ibutton key names will be uploaded.","invalidButtonName":"Validation failed! iButton key name must be exactly 16 hexadecimal characters and should not be a duplicate.","search":"Type to search ibutton key"}},"actions":{"create":"Füge einen Organisation hinzu","read":"Organisation sehen","update":"Organization andern","delete":"Organization löschen","readsettings":"Organisationseinstellungen sehen"},"messages":{"added":"Die organization {name} ist hinzugefügt","updated":"Die organization {name} ist geändert","selectOneMfaOption":"Select at least one MFA option"},"toolTip":{"dayTotalJob":"Täglich insgesamt","mailSendingTime":"Sendezeit der E-Mail","enabled":"Aktiviert","remainingUsers":"Übrig gebliebene Benutzer","subscribers":"Abonnenten","affectedUnits":"Aktivierte Gerate","name":"Der Name des organisation","ipWhiteList":"Die IP-Adressen, die mit den Geräten kommunizieren dürfen (derzeit nicht verwendet)","pin":"Die PIN der Organisation (wird derzeit nicht verwendet)","organizationType":"Die Art der Organisation. WTU: für Organisationen, die Geld von den Einheiten sammeln. Allgemein: Dies wird für die meisten Organisationen verwendet. Wartung: Für Organisationen, die Wartungsarbeiten an den Einheiten durchführen. Berichtsgruppe: Für Organisationen, die Organisationsberichte an verschiedenen Stellen im Stammbaum der Organisation anzeigen müssen","parentOrganization":"Die Organisation über der aktuellen Organisation im Stammbaum der Organisation. Administratoren der übergeordneten Organisation können die aktuelle Organisation und ihre Einheiten im Portal anzeigen. Die aktuelle Organisation kann eine Wartungs- und WTU-Organisation von ihrer übergeordneten Organisation erben. Wenn keine übergeordnete Organisation ausgewählt ist, muss eine WTU- und Wartungsorganisation für die aktuelle Organisation erstellt werden","inheritedCIT":"Der WTU, der von der übergeordneten Mutter Organisation stammt","inheritedMaintenance":"Der Wartungsfirma, der von der übergeordneten Mutter Organisation stammt","overrideCIT":"So verwenden Sie eine andere Organisation als den WTU, der von der übergeordneten Organisation stammt","overrideMaintenance":"So verwenden Sie eine andere Organisation als die Wartungsorganisation, die von der übergeordneten Organisation stammt","defaultCIT":"Damit dieser WTU automatisch von den Einheiten und Unterorganisationen genutzt wird","defaultMaintenance":"Damit diese Wartungsorganisation automatisch von den Einheiten und Unterorganisationen verwendet wird","reportedOrganizations":"Die Organisationen, deren Mitglieder der aktuellen Organisation die Berichte anzeigen dürfen","location":"Die Adresse der Organisation (diese muss vor dem Erstellen der Organisation erstellt werden)","remark":"Hinweis zur Organisation, sichtbar für Personen, die die Organisation aktualisieren","forceMfaForUsers":"Enable this option to force multifactor authentication for all users when they log in to the portal.","enableAuthdeviceMfa":"Enable authenticator device and phone apps as user MFA option","enableEmailMfa":"Enable Email as user MFA option","enableSmsMfa":"Enable SMS as user MFA option","enableUserMfaSecretReset":"Allow users to reset theirselves their QR/Secret from user menu if more than one MFA mode is enabled","workflows":"Die Procedure dieser WTU-Organisation verwendeten Geldsammelverfahren","forceEmployeePin":"Die PIN für alle Mitarbeiter dieser Organisation und ihrer Unterorganisationen verbindlich zu machen"},"notifications":{"titles":{"notifications":"Notifications","notificationType":"Notification Type"},"types":{"UNIT_OFFLINE":"Unit Offline"},"form":{"enabled":"Enabled","unsubscribed":"Remaining Users","subscribed":"Subscribed"}}},"till":{"titles":{"overview":"Kassenschubladen","create":"Fügen eine Kassenschublade hinzu","update":"Kassenschublade einstellen"},"breadcrumb":{"title":"Überblick"},"columns":{"name":"Name","organization":"Organisation","mixes":"Mischen"},"form":{"name":"Name","organizations":"Organisation","units":"Gerate","maximumAmount":"Maximale Menge","mixes":"Mischen"},"actions":{"create":"Fügen eine Kassenschublade hinzu","read":"Kassenschublade sehen","update":"Kassenschublade andern","delete":"Kassenschublade löschen"},"messages":{"added":"Kassenschublade {name} ist hinzugefügt","updated":"Kassenschublade {name} ist geändert","disconnected":"These units will be disconnected {units} from the till {till}"}},"cit":{"titles":{"overview":"WTU workflows","create":"Fügen eine WTU workflow hinzu","update":"WTU workflow  andern","readsettings":"WTU-Workflow-Einstellungen"},"breadcrumb":{"title":"Überschreiben"},"columns":{"name":"Name","unitType":"Gerat Type","advancedSettings":"Erweiterte Einstellungen","stepTabEdit":"Step edit","stepTabNew":"Step create","cancel":"Cancel","create":"Create","update":"Update","steps":"Steps","addNewStep":"New step","version":"Version"},"form":{"name":"Name","unitType":"Gerat Type","organization":"Organisation","loginType":"Anmeldetyp","firstUserRole":"Benutzerrolle anmelden *","secondUserRole":"Zweite Benutzerrolle *","allSteps":"Alle Schritte","selectedSteps":"Ausgewählte Schritte","performPrint":"WTU Quittung","scanLength":"Barcode-Länge","prefixBarcode":"Barcode-Präfix","emptyCoinDevice":"LMunzen Leren","printOnCassetteDetached":"Empfang auf Kassette lose","placeholder":"Component","placeholderAction":"Komponentenaktion","stepCondition":"Condition","stepSkip":"Skip to","loadingPlaceholderText":"Select any unit type first","loadingPlaceholderActionText":"Select a component first","loadingPlaceholderConditionText":"Select a component first","nextStep":"Next step","next":"Next","skipTo":"Step: {number}","options":{"autologin":"Automatische Anmeldung","singlelogin":"Einmaliges Anmeldung","multiplelogin":"4 Augen anmelden","locklogin":"Anmeldung mit Pin"},"translationEn":"Schrittstitel","translationNl":"Schrittstitel","translationUs":"Schrittstitel","translationFr":"Schrittstitel","translationPl":"Schrittstitel","translationEl":"Schrittstitel","translationHu":"Schrittstitel","translationSk":"Schrittstitel","translationDe":"Schrittstitel","translationKey":"Übersetzungsschlüssel","translationKeyInfo":"Übersetzungsschlüssel: {translationKey}","confirmDialog":"Bestätigungsdialog","confirmationDialogLabel":"Soll der Bestätigungsdialog angezeigt werden?","noMatchingCondition":"Die ausgewählte Komponente hat keine Bedingung.","noMatchingAction":"Die ausgewählte Komponente hat keine Aktionen.","importWorkflow":"Workflow importieren","sdcGrouping":"Disable SDC grouping"},"toolTip":{"name":"Der Name des Workflows. Der Einheitentyp und die Organisation können im Namen verwendet werden, um das Auffinden des Workflows zu erleichtern","unitType":"Der Einheitentyp der Gerate, die diesen Workflow verwenden können","organization":"Die Organisation, die diesen Workflow ändern darf","loginType":"Die Art und Weise, wie sich der Benutzer beim Gerät anmelden kann, bevor er das Geld einsammelt. Wenn die automatische Anmeldung ausgewählt ist, beginnt der Vorgang mit dem Öffnen der Tür","firstUserRole":"Die Rolle des Benutzers, der sich vor dem Entleeren am Gerät anmelden muss","secondUserRole":"Die Rolle des zweiten Benutzers, der sich vor dem Entleeren am Gerät anmeldet","allSteps":"Alle möglichen Seiten, die ein Gerät während des WTU-Vorgangs anzeigen kann, um das Geld aus dem Automaten zu entleeren. Die Seiten können durch Ziehen von links nach rechts ausgewählt werden. Seiten, die mit (Legacy) beginnen, können nicht von Geräten mit Softwareversion 4 und höher verwendet werden.","selectedSteps":"Die Seiten, die das Gerät während des WTU-Vorgangs anzeigt, um das Geld aus dem Automaten zu entleeren.","performPrint":"Drucken Sie die Quittung am Ende des Vorgangs aus","scanLength":"Die Länge des Barcodes auf der Geldkassette / Tasche","prefixBarcode":"Der Text am Anfang des Barcodes, zum Beispiel AT. Dies erscheint auf einer Schaltfläche, wenn der Barcode manuell eingegeben wird","emptyCoinDevice":"Angenommen, die Münzen werden während der WTU geleert und der Wert der Münzen vom Gesamtbetrag in der Maschine abgezogen","printOnCassetteDetached":"Drucken Sie eine Quittung mit dem Inhalt der Kassette aus, nachdem diese aus dem Gerät entfernt wurde","placeholder":"Component des ausgewählten Einheitentyps.","placeholderAction":"Aktionen für den ausgewählten component.","stepCondition":"Condition","stepSkip":"Skip to next step","options":{"autologin":"Automatische Anmeldung","singlelogin":"Einmaliges Anmeldung","multiplelogin":"4 Augen anmelden","locklogin":"Anmeldung mit Pin"},"translationEn":"Schrittstitel wird angezeigt, wenn die englische Sprache ausgewählt ist","translationNl":"Schrittstitel wird angezeigt, wenn die niederländische Sprache ausgewählt ist","translationUs":"Schrittstitel wird angezeigt, wenn die englische (US) Sprache ausgewählt ist","translationFr":"Schrittstitel wird angezeigt, wenn die französische Sprache ausgewählt ist","translationDe":"Schrittstitel wird angezeigt, wenn die deutsche Sprache ausgewählt ist","translationPl":"Schrittstitel wird angezeigt, wenn die polnische Sprache ausgewählt ist","translationEl":"Schrittstitel wird angezeigt, wenn die griechische Sprache ausgewählt ist","translationHu":"Schrittstitel wird angezeigt, wenn die ungarische Sprache ausgewählt ist","translationSk":"Schrittstitel wird angezeigt, wenn die slowenische Sprache ausgewählt ist","translationKey":"Übersetzungsschlüssel","confirmDialog":"Bestätigungsdialog","importXmlTooltip":"Akzeptiert nur eine einzelne .xml-Datei","sdcGrouping":"If this is checked, system will create separate 'Clear box item' per placeholder, instead of grouping them into one SDC."},"conditions":{"REJECT_BIN_IS_EMPTY":"Der Ablehnschacht ist leer","COIN_OVERFLOW_NOT_FULL":"Münzüberlauf ist nicht voll"},"actions":{"create":"Füge einen WTU workflow hinzu","read":"WTU workflow sehen","update":"WTU workflow andern","delete":"WTU workflow löschen","readsettings":"WTU-Workflow-Einstellungen sehen","export":"Export workflow"},"messages":{"added":"Die WTU workflow {name} ist hinzugefügt","updated":"Die WTU workflow {name} ist geändert","noPageSelected":"Bitte wählen Sie einen Schritt","checkStepFormFields":"Überprüfen Sie, ob alle Felder des Schritts korrekt sind","stepAdded":"Schritt hinzugefügt","stepUpdated":"Schritt aktualisiert","noStepSelectedV2":"Bitte erstellen Sie einen Schritt","invalidXmlFile":"Bitte laden Sie eine gültige XML-Datei hoch","xmlUploadSuccess":"Workflow erfolgreich importiert","xmlUploadFailed":"Workflow konnte nicht hochgeladen werden","cantMoveStepUp":"Can't move this Step up","cantMoveStepDown":"Can't move this Step down"},"workflow":{"Login":"(Legacy) Log in","Remove_left_cassette":"(Legacy) Remove left cassette","Insert_left_cassette":"(Legacy) Insert left cassette","Remove_right_cassette":"(Legacy) Remove right cassette","Insert_right_cassette":"(Legacy) Insert right cassette","Remove_any_cassette":"(Legacy) Remove any cassette","Insert_any_cassette":"(Legacy) Insert any cassette","Remove_cassette":"(Legacy) Remove cassette","Insert_cassette":"(Legacy) Insert cassette","Scan_left_reader_barcode":"(Legacy) Scan left reader barcode","Scan_right_reader_barcode":"(Legacy) Scan right reader barcode","Scan_new_cassette_barcode":"(Legacy) Scan new cassette barcode","Open_the_door_Linux":"(Legacy) Open the door (Linux)","Close_the_door__Linux":"(Legacy) Close the door (Linux)","Lock_the_door":"(Legacy) Lock the door","Sign_out":"(Legacy) Sign out","Unlock_the_door":"(Legacy) Unlock the door","Open_coin_acceptor_dropsafe_Linux":"(Legacy) Open coin acceptor dropsafe (Linux)","Empty_cassette_and_close_the_dropsafe_Linux":"(Legacy) Empty cassette and close the dropsafe (Linux)","Scan_new_left_cassette_barcode":"(Legacy) Scan new left cassette barcode","Scan_new_right_cassette_barcode":"(Legacy) Scan new right cassette barcode","Securing_safe":"(Legacy) Securing safe","CIT_procedure_completed":"(Legacy) CIT procedure completed","Open_the_door_Windows":"(Legacy) Open the door (Windows)","Close_the_door_Windows":"(Legacy) Close the door (Windows)","Open_coin_acceptor_dropsafe_Windows":"(Legacy) Open coin acceptor dropsafe (Windows)","Empty_cassette_and_close_the_dropsafe_Windows":"(Legacy) Empty cassette and close the dropsafe (Windows)","AUTO_UNLOCK_FRONT_DOOR":"Automatically unlock front door","WI_UNLOCK_FRONT_DOOR":"Unlock front door (no PIN)","LP_UNLOCK_FRONT_DOOR":"Unlock front door (LPLOCK)","LP_LOCK_FRONT_DOOR":"Lock front door (LPLOCK)","LP_OPEN_FRONT_DOOR":"Open front door (LPLOCK)","LP_CLOSE_FRONT_DOOR":"Close front door (LPLOCK)","VIM_READ_KEY_CIT":"Present CIT key","V2_UNLOCK_CIT_DOOR":"WTU Tur entsperren (Linux)","V2_OPEN_CIT_DOOR_LINUX":"Offene Tür (Linux)","V2_REMOVE_STORAGE":"Lager entfernen","V2_INSERT_STORAGE":"Lager einfügen","V2_CLOSE_CIT_DOOR_LINUX":"WTU Tur Schließen (Linux)","V2_LOCK_CIT_DOOR":"WTU Tur sperren (Linux)","V2_PROCESSING_CIT":"Sicher Safe - Lincstation","V2_REMOVE_CASSETTE":"Cassette entfernen","V2_INSERT_CASSETTE":"Cassette einfugen","V2_EMPTY_CASSETTE":"Empty cassette","V2_OPEN_CIT_DOOR_WINDOWS":"Offene Tür(Windows)","V2_CLOSE_CIT_DOOR_WINDOWS":"Tur Schließen (Windows)","V2_REMOVE_LEFT_CASSETTE":"Entfernen linken Kassette","V2_INSERT_LEFT_CASSETTE":"Fugen die linken Kassette ein","V2_REMOVE_RIGHT_CASSETTE":"Entfernen rechten Kassette","V2_INSERT_RIGHT_CASSETTE":"Fugen die rechten Kassette ein","V2_LOGIN":"Benutzer-Anmeldung","V2_CIT_PROCEDURE_COMPLETED":"CIT procedure fertig","V2_SDC_CIT_COMPLETE_CHECK":"Bestätigung des CIT procedure","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_LINUX":"Münzseitensafe öffnen (Linux)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_LINUX":"Münzseitensafe leeren (Linux)","V2_SCAN_LEFT_READER_BARCODE":"Scannen Sie den linken Barcode","V2_SCAN_RIGHT_READER_BARCODE":"Scannen Sie den rechten Barcode","V2_SCAN_STORAGE_BARCODE":"Scan lager","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_WINDOWS":"Münzseitensafe öffnen(Windows)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_WINDOWS":"Münzseitensafe leeren(Windows)","V2_OPEN_CIT_DOOR":"Öffnen die WTU Tür","V2_CLOSE_CIT_DOOR":"Schließen die WTU Tür","V2_PROCESSING_LINCSTATION_CIT":"Sicher Safe (Lincstation)","V2_OPEN_THE_DOOR_LINUX":"Offene Tür (Linux)","V2_CLOSE_THE_DOOR_LINUX":"Tur Schließen(Linux)","V2_UNLOCK_DOOR":"Tur entsperren (Linux)","V2_LOCK_DOOR":"Tur sperren (Linux)","V2_PROCESSING_SAFE_CIT":"Secure WTU safe","V2_PRINT_LEFT_CASSETTE":"Linke Kassette drucken","V2_PRINT_RIGHT_CASSETTE":"Rechte Kassette drucken","V2_PRINT_CIT_TOTAL":"WTU Summen drucken","V2_SEAL_BAG":"Beutel verschließen","V2_UNLOCK_SIDESAFE_WITH_BO_COIN":"Entsperren Sie die seitensafe Münze","V2_UNLOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Entsperren Sie die seitensafe","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_COIN":"Münzseitensafe leeren und verriegeln","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Seitensafe leeren und verriegeln","V2_SEALING_BAG":"Beutel verschließen","V2_REPLACE_SEAL_BAG":"Beutel ersetzen","V2_SCAN_COIN_STORAGE_BARCODE":"Scan coin storage","V2_COIN_ROLL_FILL_UP":"Coin roll fill up","V2_EMPTY_COUNTERS":"Empty counters","V2_EMPTY_ESCROW":"Empty escrow","V2_SKIP_EMPTY_ESCROW_SAFEBAG_FULL":"Skip empty escrow, safebag full","V2_WAIT_10":"Delay 10 seconds","V2_OPEN_OM61_DOOR":"Open OM61 door","V2_CLOSE_OM61_DOOR":"Close OM61 door","V2_UNLOCK_OM61_BAG_STORAGE":"Unlock OM61 bag storage compartment","V2_TAKE_OM61_STORAGE_BAG":"Take OM61 storage bag","V2_INSERT_NEW_OM61_STORAGE_BAG":"Insert OM61 new storage bag","V2_OPEN_CIT_DOOR_LINCSTATION_V3":"Open door (Lincstation v3)","V2_CLOSE_CIT_LINCSTATION_V3":"Close door (Lincstation v3)","V2_PROCESSING_CIT_LINCSTATION_V3":"Secure safe (Lincstation v3)","V2_UNLOCK_LINCSTATION_V3":"Unlock door (Lincstation v3)","V2_LOCK_LINCSTATION_V3":"Lock door (Lincstation v3)","V2_INSTALL_OM61_STORAGE_BAG":"Install OM61 storage bag","V2_UNLOCK_FRONT_DOOR":"Unlock front door","V2_UNLOCK_FRONT_DOOR_SPT":"Unlock front door (SPT)","V2_OPEN_FRONT_DOOR":"Open front door","V2_CLOSE_FRONT_DOOR":"Close front door","V2_LOCK_FRONT_DOOR":"Lock front door","V2_LOCK_FRONT_DOOR_SPT":"Lock front door (SPT)","V2_PAUSE_CIT":"Pause CIT","V2_REMOVE_REJECT_BIN":"Remove reject bin","V2_CONFIRM_EMPTY_REJECT_BIN":"Confirm empty reject bin","V2_INSERT_REJECT_BIN":"Insert reject bin","V2_FILL_UP_COINS":"Fill up coin recycler","V2_OPEN_COIN_OVERFLOW_DOOR_SPT":"Open coin overflow door (SPT)","V2_EMPTY_COINS_AND_CLOSE_COIN_OVERFLOW_DOOR_SPT":"Empty coins and close coin overflow door (SPT)","V2_SECURE_SAFE":"Secure safe","V2_REMOVE_PULOON_CASSETTE_1":"Remove 1st present dispenser cassette","V2_REMOVE_PULOON_CASSETTE_2":"Remove 2nd present dispenser cassette","V2_INSERT_PULOON_CASSETTE_1":"Insert 1st new dispenser cassette","V2_INSERT_PULOON_CASSETTE_2":"Insert 2nd new dispenser cassette","V2_UNLOCK_CIT_DOOR_2":"Unlock CIT door 2","V2_LOCK_CIT_DOOR_2":"Lock CIT door 2","V2_OPEN_CIT_DOOR_LINUX_2":"Open safe door (Linux) 2","V2_CLOSE_CIT_DOOR_LINUX_2":"Close safe door (Linux) 2","V2_UNLOCK_FRONT_DOOR_2":"Unlock front door 2","V2_UNLOCK_FRONT_DOOR_SPT_2":"Unlock front door 2 (SPT)","V2_OPEN_FRONT_DOOR_2":"Open front door 2","V2_CLOSE_FRONT_DOOR_2":"Close front door 2","V2_LOCK_FRONT_DOOR_2":"Lock front door 2","V2_LOCK_FRONT_DOOR_SPT_2":"Lock front door 2 (SPT)","V2_SECURE_CIT_DOOR":"Secure CIT door (SPT)","V2_SECURE_CIT_DOOR_2":"Secure CIT door 2 (SPT)","V2_SECURE_FRONT_DOOR":"Secure front door (SPT)","V2_SECURE_FRONT_DOOR_2":"Secure front door 2 (SPT)","dynamic":{"LOCK_OPEN":"Open lock","LOCK_CLOSE":"Close lock","LOCK_OPEN_WITH_PIN":"Open lock with pin","DOOR_OPEN":"Open door","DOOR_CLOSE":"Close door","DOOR_SECURE":"Secure door","CIT_COMPLETED":"Cit completed","CIT_PAUSE":"Cit paused","CIT_DIALOG":"Cit dialog","CIT_USER_LOGIN":"Cit user login","COIN_FILL_UP":"Fill up coin","COIN_EMPTY_OVERFLOW_STORAGE":"Empty coin overflow storage","STORAGE_REMOVE_CASSETTE":"Remove storage cassette","STORAGE_ATTACH_CASSETTE":"Attach storage cassette","STORAGE_PULOON_REMOVE_DISPENSER_1":"Remove storage puloon dispenser 1","STORAGE_PULOON_ATTACH_DISPENSER_1":"Attach storage puloon dispenser 1","STORAGE_PULOON_REMOVE_DISPENSER_2":"Remove storage puloon dispenser 2","STORAGE_PULOON_ATTACH_DISPENSER_2":"Attach storage puloon dispenser 2","STORAGE_PULOON_REMOVE_DISPENSER_3":"Remove storage puloon dispenser 3","STORAGE_PULOON_ATTACH_DISPENSER_3":"Attach storage puloon dispenser 3","STORAGE_PULOON_REMOVE_DISPENSER_4":"Remove storage puloon dispenser 4","STORAGE_PULOON_ATTACH_DISPENSER_4":"Attach storage puloon dispenser 4","STORAGE_PULOON_REMOVE_REJECT_BIN":"Remove storage puloon reject bin","STORAGE_PULOON_ATTACH_REJECT_BIN":"Attach storage puloon reject bin","COIN_REMOVE_AND_EMPTY_OVERFLOW_STORAGE":"Remove and empty coin bucket","COIN_FILL_UP_SPLIT_START":"Start split fill up","COIN_FILL_UP_SPLIT_END":"Stop split fill up","COIN_INSERT_OVERFLOW_STORAGE":"Insert coin bucket","CIT_IBUTTON_LOGIN":"iButton login","MANUAL_DEPOSIT_EMPTY":"Empty manual deposit","CENCON_LOCK_OPEN":"Open Cencon lock","CENCON_LOCK_CLOSE":"Close Cencon lock","TRAY_OPEN":"Open hitachi door","TRAY_CLOSE":"Close hitachi door","HITACHI_REJECT_BOX_CLOSE":"Close reject box","HITACHI_REJECT_BOX_OPEN":"Open reject box and empty its contents","STORAGE_ONE_ATTACHED":"Attach Puloon storage cassette","STORAGE_ONE_REMOVED":"Remove Puloon storage cassette","HITACHI_STORAGE_ONE_ATTACHED":"Attach hitachi storage","HITACHI_STORAGE_ONE_REMOVED":"Remove hitachi storage","HITACHI_STORAGE_TWO_ATTACHED":"Attach Hitachi storage cassette 2","HITACHI_STORAGE_TWO_REMOVED":"Remove Hitachi storage cassette 2","HITACHI_STORAGE_THREE_ATTACHED":"Attach Hitachi storage cassette 3","HITACHI_STORAGE_THREE_REMOVED":"Remove Hitachi storage cassette 3","HITACHI_STORAGE_FOUR_ATTACHED":"Attach Hitachi storage cassette 4","HITACHI_STORAGE_FOUR_REMOVED":"Remove Hitachi storage cassette 4","HITACHI_STORAGE_FIVE_ATTACHED":"Attach Hitachi storage cassette 5","HITACHI_STORAGE_FIVE_REMOVED":"Remove Hitachi storage cassette 5","HITACHI_STORAGE_ONE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 1","HITACHI_STORAGE_ONE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 1","HITACHI_STORAGE_TWO_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 2","HITACHI_STORAGE_TWO_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 2","HITACHI_STORAGE_THREE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 3","HITACHI_STORAGE_THREE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 3","HITACHI_STORAGE_FOUR_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 4","HITACHI_STORAGE_FOUR_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 4","HITACHI_STORAGE_FIVE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 5","HITACHI_STORAGE_FIVE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 5","HITACHI_STORAGE_SIX_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 6","HITACHI_STORAGE_SIX_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 6"},"V2_REMOVE_SEALPACK_FROM_COIN_STORAGE":"Take out sealpack from coin storage","V2_INSERT_NEW_SEALPACK_TO_COIN_STORAGE":"Insert new sealpack to coin storage"},"dialog":{"title":"Confirm change order","description":"The Step: {stepOrder} can't be moved without breaking Skip to value of Step: {colindantStepOrder}","confirmation":"Change order anyway and remove Skip to value ?"}},"notification":{"titles":{"read":"Benachrichtigungs details"},"read":"Benachrichtigungs details"},"report":{"buttons":{"createReport":"BERICHT ERSTELLEN","generating":"Generating..."},"titles":{"overview":"Bericht","create":"Fug ein Bericht hinzu","update":"Bericht andern"},"breadcrumb":{"title":"Bericht"},"form":{"orgUuid":"Organisation","unitUuid":"Gerat","type":"Type","startDate":"Von","endDate":"Bis","types":{"getReptileCampaignsAndTransactionsByDate":"Transaktionen und Leerungen","getReptileCampaignsAndTransactionsMoneyInOutCounterByDate":"Transaktionen und Leerungen mit Gelde in/aus zähler","getReptileTransactionsByDate":"Transaktionen","getManualTransactionsByDate":"[Deprecated] Seitesafe","getReptileManualTransactionsByDate":"Seitesafe - Neu","getReptileReportForClosedCampaignsByUnitAndDate":"Leerungen","getReptileClearboxDenomination":"[Deprecated] Clearboxes denomination","getReptileClearboxDenominationV2":"Clearboxes denomination","getReptileEndOfDayInfoByDate":"Ende des Tages pro Gerat Gesamt","getReptileLincstationEndOfDayInfoByDate":"Lincstation Ende des Tages pro Gerat Gesamt","getEndOfDayClientsByDate":"[Deprecated] Ende des Tages pro organisation","getReptileEndOfDayClientsByDate":"Ende des Tages pro organisation - Neu","getEventsByDate":"Veranstaltungen pro Tag","getReptileEventsByDate":"Veranstaltungen pro Tag - Neu","getReptileReportForDenominationPerUser":"Stückelungen pro Benutzer","getReptileReportForDenominationWithPin":"Stückelungen mit Pin","getReptileSalesByDate":"Verkauf - NEW","getInternalTransactionsByDate":"[Deprecated] Interne Transaktionen","getReptileInternalTransactionsByDate":"Interne Transaktionen - Neu","getReptileAdvancedManualDeposit":"Manuelle Einzahlungen","getReptileRecyclerReport":"Lincstation overall report","getReptileTransactionsWithReference":"Transaktionen mit Referenznummer","getTransactionsWithReference":"[Deprecated] Transaktionen mit Referenznummer","getCampaignsWithBarcodes":"[Deprecated] Leerungen mit Etikettennummern","getSalesByDate":"[Deprecated] Verkauf","getCurrentlyOfflineUnits":"Currently Offline Units (.csv)","getReptileCashCoinEndOfDayInfoByDate":"End of Day Cash/Coin","getReptileUnitInventory":"Unit Inventory (.pdf)","getReptileCampaignsAndTransactionsByDateWithSource":"Smartsafes transactions and clearboxes","getReptileEndOfDaySmartSafes":"Smartsafes End Of Day (.pdf)","getReptileEndOfDaySmartSafesXlsx":"Smartsafes End Of Day (.xlsx)","getReptileEndOfDayRecyclerXlsx":"Recycler End Of Day (.xlsx)","getReptileCampaignSmartSafesPdf":"Smartsafes Campaign (.pdf)","getReptileCampaignSmartSafesXlsx":"Smartsafes Campaign (.xlsx)","getReptileTransactionSmartSafesPdf":"Smartsafes Transaction (.pdf)","getReptileTransactionSmartSafesXlsx":"Smartsafes Transaction (.xlsx)","getReptileTransactionSmartSafesDetailedPdf":"Smartsafes Transaction Detailed (.pdf)","getReptileTransactionSmartSafesDetailedXlsx":"Smartsafes Transaction Detailed (.xlsx)","getOrganizationAssetsXlsx":"Smartsafes Asset Management (.xlsx)","getOrganizationAssetsPdf":"Smartsafes Asset Management (.pdf)","getReptileEventSmartSafesXlsx":"Smartsafes Event (.xlsx)","getReptileEventSmartSafesPdf":"Smartsafes Event (.pdf)"}},"messages":{"success":"Der Bericht wurde erfolgreich erstellt. Die Datei sollte jetzt automatisch heruntergeladen werden...","failed":"The report could not be generated. Please try again later","reptileDateLimitExceeded":"The report could not be generated. The specified date limit has been exceeded. Please adjust your date range and try again.","reptileGenericBadRequest":"The report could not be generated due to a bad request. Please review your input parameters and try again later.","cannotOutputToCsvFile":"The report could not be generated. Please try again later and/or with different parameters.","errorOccurred":"The report could not be generated. Unknown error occurred."},"dialog":{"title":"Der Bericht wurde erfolgreich erstellt.","download":"Klicke hier zum herunterladen","close":"Schließen"}},"transaction":{"read":"Transaktionsdetail"},"adminsettings":{"titles":{"overview":"Währungspflege"},"breadcrumb":{"title":"Überblick"},"messages":{"updated":"Währung und Stückelungen aktualisiert","error":"Something went wrong, currency and denominations not updated","reptileDateLimitExceeded":"Der Bericht konnte nicht generiert werden. Die angegebene Datengrenze wurde überschritten. Bitte passen Sie Ihren Datumsbereich an und versuchen Sie es erneut.","reptileGenericBadRequest":"Der Bericht konnte nicht generiert werden, aufgrund einer ungültigen Anfrage. Überprüfen Sie bitte Ihre Eingabeparameter und versuchen Sie es später erneut."},"form":{"currency":"Währung","iso1":"ISO1","iso2":"ISO2","iso3":"ISO3","symbol":"Symbol","symbolCode":"Symbol code","defaultValue":"Standardwert","enabled":"Aktiviert","denomination":{"value":"Wert","coins":"Münzen","bills":"Banknoten","enabled":"Aktiviert","remove":"Entfernen"}}},"mix":{"titles":{"overview":"Mischungen","create":"Mischung hinzufügen","update":"Mischung aktualisieren"},"breadcrumb":{"title":"Übersicht"},"form":{"mixName":"Mischname","totalAmount":"Gesamtbetrag","organization":"Organisation","denominations":"Stückelungen","currency":"Currency","eur":"EURO","usd":"USD","gbp":"GBP"},"columns":{"name":"Mischname","totalAmount":"Gesamtbetrag","details":"Details","totalValue":"Gesamtwert"},"read":{"mixDetails":"Mischungsdetails"},"actions":{"create":"Mischung hinzufügen","update":"Mischung aktualisieren","delete":"Mischung löschen","read":"Mischung lesen"}},"common":{"form":{"bankAccount":"Primary bank account number","citAccount":"CIT account number","affiliateCode":"Affiliate code","overrideBankAccount":"Override primary bank account number","overrideCitAccount":"Override CIT account number","overrideAffiliateCode":"Override affiliate code"},"toolTip":{"bankAccount":"Bank account number to which deposits/withdrawals are transmitted from the safe(s). Can be overridden at a more granular level","citAccount":"Bank account number to which funds are deposited after CIT. Usually the same as primary bank account number","affiliateCode":"4 digit alphabetical code"}},"department":{"titles":{"overview":"Departments","create":"Create a department","update":"Update department","preview":"Preview department"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Name","organizationName":"Organization"},"form":{"name":"Name","organization":"Organization","bankAccount":"Bank account number"},"toolTip":{"organization":"Which organization does this department belong to","bankAccount":"Optional bank account number to which deposits/withdrawals are transmitted from the safe(s)","overrideBankAccount":"Do not inherit primary bank account from unit. Instead, define a new one specific to this department"},"actions":{"create":"Create department","read":"Preview department","update":"Update department","delete":"Delete department","preview":"Preview department"},"messages":{"added":"Department {name} has been created","updated":"Department {name} has been updated"}},"unitRoles":{"titles":{"overview":"Unit roles","create":"Add a unit role","update":"Update unit role"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Unit role name","organization":"Organization"},"actions":{"create":"Add unit role","update":"Update unit role","delete":"Delete unit role"},"form":{"name":"Unit role name","organization":"Organization","transactionCashOutLimit":"Transaction cash out limit","dailyCashOutLimit":"Daily cash out limit","permissions":"Permissions"},"messages":{"added":"The unit role {name} is added","updated":"The unit role {name} is updated"}}},"server_messages":{"accessNotAllowed":"Nicht erlaubt.","authorizationFailed":"Autorisation fehlgeschlagen.","campaignNotFound":"Entleerung nicht gefunden!","cityCannotBeEmpty":"Stadt sollte nicht leer sein!","componentNotFound":"Komponente nicht gefunden!","countryCannotBeEmpty":"Land sollte nicht leer sein!","countryNotFound":"Land nicht gefunden!","credentialsCannotBeEmpty":"Anmeldedaten dürfen nicht leer sein","currencyNotFound":"Währung nicht gefunden!","duplicateItemFound":"Daten existieren bereits!","errorOccurred":"Ein Fehler ist aufgetreten und wurde protokolliert.","ILLEGAL_ARGUMENT":"Falscher Wert","ILLEGAL_ARGUMENT_ADDRESS_TYPE":"Mit der Adresse ist etwas schiefgegangen","ILLEGAL_ARGUMENT_ADDRESSLINE1":"Bitte ändern Sie die Adresszeile 1","ILLEGAL_ARGUMENT_ADDRESSLINE2":"Bitte ändern Sie die Adresszeile 2","ILLEGAL_ARGUMENT_BANK_ACCOUNT":"Bitte ändern Sie die Bankkontonummer","ILLEGAL_ARGUMENT_CHILD_ORGANIZATION":"Ändern Sie zunächst die Organisation daruntert","ILLEGAL_ARGUMENT_CIT":"Mit den WTU-Informationen ist ein Fehler aufgetretene","ILLEGAL_ARGUMENT_CITY":"Bitte ändern Sie den Ort","ILLEGAL_ARGUMENT_CLIENT_ORGANIZATION":"Bitte ändern Sie die Kundenorganisation","ILLEGAL_ARGUMENT_COUNTRY":"Bitte ändern Sie das Land","ILLEGAL_ARGUMENT_CURRENCY":"Bitte ändern Sie die Währung","ILLEGAL_ARGUMENT_DATE":"Bitte ändern Sie das Datum","ILLEGAL_ARGUMENT_DESCRIPTION":"Bitte ändern Sie die Beschreibung","ILLEGAL_ARGUMENT_FIRST_NAME":"Bitte ändern Sie den Vornamen","ILLEGAL_ARGUMENT_GENDER":"Mit dem Geschlecht ist etwas schief gelaufen","ILLEGAL_ARGUMENT_ID":"Bitte ändern Sie die ID","ILLEGAL_ARGUMENT_LAST_NAME":"Bitte ändern Sie den Nachnamen","ILLEGAL_ARGUMENT_LEGAL_FORM":"Die rechtliche Identität ändern","ILLEGAL_ARGUMENT_LOCATION":"Bitte ändern Sie den lokation","ILLEGAL_ARGUMENT_LOCATION_UUID":"Wir können den lokation nicht finden","ILLEGAL_ARGUMENT_MACHINE_TYPE":"Bitte ändern Sie den Gerat typ","ILLEGAL_ARGUMENT_MAIL":"Bitte ändern Sie die E-Mail-Adresse","ILLEGAL_ARGUMENT_MAINTENANCE":"Bei den Wartungsinformationen ist ein Fehler aufgetreten","ILLEGAL_ARGUMENT_NAME":"Bitte ändern Sie den Namen","ILLEGAL_ARGUMENT_ORGANIZATION":"Bitte ändern Sie die Organisation","ILLEGAL_ARGUMENT_ORGANIZATION_TYPE":"Bitte ändern Sie die Organisation typ","ILLEGAL_ARGUMENT_ORGANIZATION_UNIT_TYPE":"Bei der Kombination von Organisation und Einheitentyp ist ein Fehler aufgetreten","ILLEGAL_ARGUMENT_ORGANIZATION_UUID":"kann die Organisation nicht finden","ILLEGAL_ARGUMENT_OWNER_ORGANIZATION":"Bitte ändern Sie Ihre Organisation","ILLEGAL_ARGUMENT_PAGE_NUMBER":"Bei der Seitenzahl ist ein Fehler aufgetreten","ILLEGAL_ARGUMENT_PAGE_SIZE":"Bei der Seitengröße ist ein Fehler aufgetreten","ILLEGAL_ARGUMENT_PARENT_ORGANIZATION":"Bitte ändern Sie die Mutter Organisation","ILLEGAL_ARGUMENT_PASSWORD":"Bitte ändern Sie das Passwort","ILLEGAL_ARGUMENT_PERSON":"Bei den Benutzerinformationen ist ein Fehler aufgetreten","ILLEGAL_ARGUMENT_PHONE_NUMBER":"Bitte ändern Sie die Telefonnummer","ILLEGAL_ARGUMENT_PIN":"Bitte ändern Sie die PIN","ILLEGAL_ARGUMENT_REPORTED_ORGANIZATIONS":"Ändern Sie die gemeldeten Organisationen","ILLEGAL_ARGUMENT_ROLES":"Bitte ändern Sie die Rolle","ILLEGAL_ARGUMENT_SDC":"Beim Entleeren ist etwas schiefgegangen","ILLEGAL_ARGUMENT_SERIAL":"Bitte ändern Sie die Seriennummer","ILLEGAL_ARGUMENT_TOKEN":"Mit den Anmeldeinformationen stimmt etwas nicht","ILLEGAL_ARGUMENT_UNIT":"Ändern Sie die Gerat","ILLEGAL_ARGUMENT_UNIT_TYPE":"Ändern Sie die Gerat typ","ILLEGAL_ARGUMENT_UNIT_UUID":"Wir können das Gerät nicht finden","ILLEGAL_ARGUMENT_USER":"Bitte ändern Sie den Benutzer","ILLEGAL_ARGUMENT_UUID":"Wir können die Informationen nicht abrufen","INVALID_CREDENTIALS":"Ungültige Eingabe","INVALID_PATH":"Nicht gültiger Link","invalidData":"Fehlerhafte Daten","legalFormNotFound":"Rechtsform nicht gefunden!","locationInUse":"Der Standort wird verwendet","locationNameCannotBeEmpty":"Der Standortname darf nicht leer sein!","locationNotFound":"Location nicht gefunden","locationUpdateDataIsInvalid":"Die geänderten Standortdaten sind falsch!","LOCKED":"Gesperrt","LOGOUT":"Abgemeldet!","NO_RESULT":"keine Ergebnisse","organizationInUse":"Organisation wird verwendet","organizationListFetched":"Organisationsliste abgerufen.","organizationNotFound":"Organisation nicht gefunden.","organizationTypeNotFound":"Organisationstyp nicht gefunden.","passwordIsInvalid":"Das Passwort ist inkorrekt!","phoneNumberLengthIsIncorrect":"Die Länge der Telefonnummer ist falsch","pinIsEmpty":"Geben Sie eine PIN ein","pinNotNumeric":"Bitte verwenden Sie nur Zahlen in der PIN.","roleNotFound":"Rolle nicht gefunden.","sessionTimeout":"Session timeout","settingsNotFound":"Einstellungen nicht gefunden","SUCCESS":"Viel Glück","SYSTEM_FAIL":"System ausgefallen!","transactionNotFound":"Transaktion nicht gefunden","UNABLE_TO_STORE_INFO":"Die Informationen konnten nicht gespeichert werden","UNAUTHORIZED":"Unautorisierter Zugriff","unitNotFound":"Gerät nicht gefunden.","unitTypeListFetched":"Gerattypliste abgerufen.","userAlreadyExists":"Benutzer existiert bereits","userIsLocked":"Benutzer ist gesperrt.","userNotFound":"Benutzer wurde nicht gefunden","workflowInUseByOtherOrg":"Workflow, der mit einer anderen Organisation verwendet wird, ändern Sie die Organisation oder entfernen Sie den Workflow aus den anderen Organisationen / Einheiten","workflowNotFound":"Workflow nicht gefunden!","invalidFormatException":"Falsches Datenformat, überprüfen Sie bitte die Daten in der JSON-Struktur.","unrecognizedPropertyException":"Bitte überprüfen Sie die Felder in der JSON-Struktur.","jsonParseException":"JSON konnte nicht ordnungsgemäß verarbeitet (analysiert) werden. Überprüfen Sie die Struktur.","jsonMappingException":"JSON-Format konnte nicht ordnungsgemäß verarbeitet werden. Überprüfen Sie die Struktur","iOException":"JSON konnte nicht ordnungsgemäß verarbeitet (analysiert) werden.","minimumGreaterThanOptimum":"Mindestmenge größer als optimal","maximumLessThanOptimum":"Maximale Menge weniger als optimal","ILLEGAL_ARGUMENT_MIX_UUID":"Kann keine Mischungen finden","ILLEGAL_ARGUMENT_MAX_AMOUNT":"Bitte ändern Sie den Höchstbetrag","TILL_IS_BEING_USED_BY_USER":"Kassalade wird vom Benutzer verwendet","TILL_IS_BEING_USED_BY_UNIT":"Kassalade wird vom Gerat verwendet","secretIsEmpty":"Empty secret found","secretAlreadyExists":"Ungültiges Geheimnis generiert. Bitte erneut generieren","MIN_FOUR_DIGITS":"PIN muss mindestens 4 Ziffern lang sein","MIN_SIX_DIGITS":"PIN muss mindestens 6 Ziffern lang sein","MAX_SIX_DIGITS":"PIN darf höchstens 6 Ziffern lang sein","NO_DUPLICATE_DIGITS":"PIN darf keine wiederholten Ziffern haben","NO_INCREMENTING_DIGITS":"PIN darf nicht in aufsteigender Reihenfolge sein","NO_DECREMENTING_DIGITS":"PIN darf nicht in absteigender Reihenfolge sein","MAX_NINETY_DAYS":"PIN verfällt nach 90 Tagen. Bitte ändern Sie die PIN","MAX_SIXTY_DAYS":"PIN verfällt nach 60 Tagen. Bitte ändern Sie die PIN","MAX_THIRTY_DAYS":"PIN verfällt nach 30 Tagen. Bitte ändern Sie die PIN","PIN_LENGTH_NOT_IN_4_TO_6":"PIN-Länge zwischen 4 und 6 Ziffern","ILLEGAL_ARGUMENT_EXTERNAL_USERNAME_IS_NULL":"Benutzername darf nicht null sein","ILLEGAL_ARGUMENT_EXTERNAL_PASSWORD_IS_NULL":"Externes Passwort darf nicht null sein","ILLEGAL_ARGUMENT_EXTERNAL_HS600_PASSWORD_INVALID":"Externes HS600-Passwort ist ungültig. Nur numerische Werte sind erlaubt","ILLEGAL_ARGUMENT_ROLES_ONE_EXTERNAL_HS600_ROLE_ALLOWED":"Es ist nur eine Rolle erlaubt","ILLEGAL_ARGUMENT_USERNAME_NULL":"Externer Benutzername darf nicht null sein","maxDispensableGreatherThenAllowed":"Max dispensable is greather then allowed","MFA_REQUIRED":"Multi-Faktor-Authentifizierung erforderlich","duplicateSafeIdFound":"Safe ID already exists!","validationError":"Validation failed.","ILLEGAL_ARGUMENT_MIX_DENOMINATIONS":"Please select currency.","unitRoleInUseByUser":"This unit cannot be deleted because it is currently assigned to a user.","emailNotUnique":"The email address is already in use","NON_UNIQUE_USERNAME":"Duplicate user accounts found, please contact your administrator","departmentAlreadyExists":"Department name has already been taken. Please choose another name","maxAndOptimumRequiredException":"Please enter the value for the Optimum and Max column before updating the page","invalidParentOrganizationType":"The parent organization must either be of type 'GENERAL' or match the type of the organization","workflowInUseByUnits":"Workflow in use by units [{reason}]. Make sure no units are using this workflow before deleting it."},"placeholder_names":{"cit":{"LR":"Linke Banknoteneinzahlung","RR":"Rechte Banknoteneinzahlung","CA":"Münzprüfer","BA":"Banknoteneinzahlung","R3":"Mittlere Banknoteneinzahlung","B1":"Banknoteneinzahlung","RC":"Banknoten Recycling","CC":"Münz Recycling"},"LR":"Linke Banknoteneinzahlung","RR":"Rechte Banknoteneinzahlung","PR":"Drucker","CA":"Münzprüfer","BO":"Breakout board","DS":"Türsensor","PU":"Banknoten ausgeben","SC":"Doppelt Münzprüfer","SS":"Seitensensor","SD":"Seitlicher Treibersenso","WI":"Lincsafe Smartlock","LL":"Untere Verriegelung","HO":"Münzbehälter","BA":"Banknoteneinzahlung","DR":"Tur Leser","R3":"Mittlere Banknoteneinzahlung","ST":"Oberer Sensor","TD":"Top Fahrersensor","SB":"Unterseite Sensor","BD":"Unterseite Fahrersensor","B1":"Banknoteneinzahlung","H1":"Behälter ein","H2":"Behälter zwei","UL":"Oberes Schloss","BP":"Signalton","RC":"Banknoten Recycling","CC":"Münz Recycling","DT":"Oberer Tur","DM":"Mittlere Tur","DB":"Untere Tur","CD":"WTU Tur","MD":"Serienwartung durch Tur Sensor","RF":"RFID Leser","SL":"Sealer","UNIT":"Gerat","null":"","DRAWER":"Schublade","SIDE_SAFE":"Seitesafe","COIN_DROP_SAFE":"Münzen Seitesafe","COIN_ROLL":"Coin roll","PIN_TERMINAL":"PIN terminal","WI_MAINTENANCE":"Lincsafe Wartungstür Smart Lock","om61":"OM61","DOOR_BOTTOM":"Untere Tür","DOOR_MIDDLE":"Mittlere Tür","DOOR_TOP":"Top von","EXB":"Erweiterungsplatine","MLOCK_TOP":"Top m-lock","SOLENOID_BOTTOM":"Unteres Magnetventil","SWITCH_COIN_TUBE":"Coin chute","WI_MIDDLE":"Mittleres weißes Kopfschloss","NETWORK":"Network","STORAGE_INVENTORY":"Storage inventory","UNKONWN":"Unbekannt","DOOR_FRONT":"Door front sensor","DOOR_LEFT":"Door left sensor","DOOR_RIGHT":"Door right sensor","SOLENOID":"Solenoid","VIM":"Vault Interface Module","LOCK_FRONT":"Front door lock","LPLOCK":"Front door lock","MLOCK":"MLock","BOTTOM_LOCK":"Bottom lock","BO_1":"Bo 1","BO_2":"Bo 2","BUTTON_A":"Button A","BUTTON_B":"Button B","BUTTON_C":"Button C","BUTTON_D":"Button D","DOOR_TOP_LEFT":"Door top left","DOOR_TOP_RIGHT":"Door top right","EBM":"EBM","EBS":"EBS","HOPPERS":"Hoppers","HSCD":"HSCD","TOP_LEFT_LOCK":"Top left lock","WI_TOP":"WI top","CIT_COMPLETED":"Unit","DOOR_HATCH":"Door top hatch sensor","LPLOCK_STORAGE":"LP lock storage","IBUTTON":"iButton","HITACHI_LOCK":"Cencon lock","XR":"Hitachi","JACK_STATUS":"Status der Kopfhörerbuchse"},"compartment_names":{"RECYCLER":"RECYCLER","STORAGE":"LAGER","MANUAL_STORAGE":"Manual storage","ESCROW":"ESCROW","HOPPERS":"HOPPERS","REJECT":"REJECT"},"notifications":{"ACCEPTING":"Maschine nimmt Geld","BOTTOM_DOOR_OPEN":"Die Tür des Münzüberlaufs ist offen!","BOTTOM_SIDE_DOOR_OPEN":"Die seitliche Sicherheitstür ist offen","CALIBRATING":"Maschine wird kalibriert","CARTRIDGE_DETACHED":"Cartridge ist entfernt","CHEATED":"Betrugsversuch erkannt","CIT_DOOR_OPEN":"WTU Tur offen","COIN_DRAWER_OPENED":"Munzenlade offen","COIN_DROP_SAFE_OPENED":"Munzen seitliche Sicherheittur ist offen","DEVICE_CAN_NOT_PAYOUT":"Lager nicht genug, um auszuzahlen","DOOR_OPEN":"Tur ist offen","DOWNLOADING":"Downloading firmware","DRAWER_OPENED":"Schublade offen","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Der Eintrag ist nicht leer","errorOccurred":"Interner Serverfehler","EXTENSION_STALL":"Gestoppt","EXCEEDS_PAYOUT_LIMIT":"Die Auszahlung ist höher als das festgelegte Limit.","FAILED":"Fehler erkannt","FEED_FAILURE":"Eingabe fehlgeschlagen","FLOAT_NOT_SET":"Im Portal ist kein START KASSA festgelegt. Richten Sie es zuerst ein!","ILLEGAL_ARGUMENT":"Falscher Eingang","INSURABLE_VALUE_REACHED":"Versicherter Wert erreicht. Die Maschine muss geleert werden!","CASSETTE_LIMIT_REACHED":"Cassettelimiet erreicht","INVALID_CREDENTIALS":"Falsche Anmeldeinformationen!","INVENTORY_LOWER_THAN_FLOAT":"Der Lagerbestand ist niedriger als der Startkasse","INVENTORY_NOT_SUFFICIENT":"Lager zu niedrig, Maschine nachfüllen!","INVENTORY_OVER_MAX":"Lager höher als das Maximum, überfliegen Sie die Maschine!","INVENTORY_SETTINGS_NULL":"Lagerposition nicht gefunden, informieren Sie den Manager!","INVENTORY_UNDER_MIN":"Lager unter dem Minimum, füllen Sie die Maschine nach!","JAMMED":"Maschine ist blockiert","LAST_TRANSACTION_FAILED":"Letzte Zahlung wurde storniert, informieren Sie den Manager!","LOCK_NOT_SECURE":"Das elektronische Schloss ist nicht geschlossen!","MACHINE_BUSY":"Maschine ist bereits beschäftigt, bitte warten Sie, bis die Transaktion abgeschlossen ist","MACHINE_NOT_OPERATIONAL":"Maschine ist nicht betriebsbereit, bitte Nachrichten überprüfen","MAINTENANCE_DOOR_OPEN":"Wartungstür offen","MIDDLE_DOOR_OPEN":"WTU tur offen!","NO_ACCESS":"Unsere Mitarbeiter haben<br/>keinen Zugang zum Safe","NOT_CONNECTED":"Maschine ist nicht angeschlossen","NOT_OPERATIONAL":"Nicht funktionsfähig","NOT_RECYCLED_MATERIAL":"Kein gerecycleerd material","NOT_SECURE":"Maschine ist nicht richtig geschlossen, informieren Sie den Manager!","ORGANIZATION_NOT_FOUND":"Organisation nicht gefunden","OVERRIDDEN":"Overridden","PAPER_EMPTY":"Kein Papier mehr","PAPER_LOW":"Papier ist fast leer","PAUSE":"Pause","PAYOUT_FAILED":"Konnte nicht auszahlen","PAYOUT_LIMIT_NOT_FOUND":"Die maximale Auszahlung wurde noch nicht festgelegt!","PIN_EMPTY":"PIN darf nicht leer sein!","POWER_UP":"Power up","RECYCLER_ALMOST_EMPTY":"Recycler ist fast leer","RECYCLER_ALMOST_FULL":"Recycler ist fast voll","RECYCLER_EMPTY":"Recycler ist leer","RECYCLER_FULL":"Recycler ist voll","REJECT_NOT_EMPTY":"Die Ablehnung ist nicht leer","SIDE_DOOR_ONE_OPEN":"Seitliche tur (1) ist offen","SIDE_DOOR_OPEN":"Seitliche tur ist offen","SIDE_SAFE_OPENED":"Seitliche tur offen","STACKER_FULL":"Stacker ist voll","STALLED":"Gestoppt","STORAGE_ALMOST_FULL":"Kassette fast voll, bitte leeren Sie die Maschine.","STORAGE_DETACHED":"Kassette wurde entfernt","STORAGE_FULL":"Kassette ist voll, leeren Sie die Maschine","TOP_DOOR_OPEN":"Wartungstür ist offen!","TOP_SIDE_DOOR_OPEN":"Seitliche obere Tür ist offen","USER_BLOCKED":"Benutzer ist gespert","USER_NOT_FOUND":"Benutzer wurde nicht gefunden","WORKFLOW_NOT_FOUND":"WTU-workflow nicht gefunden. Überprüfen Sie das Portal","ZERO_AMOUNT":"Betrag muss größer sein als 0","INVALID_CONFIGURATION":"Recycler-Konfiguration falsch","LAST_NOTE_HIGHEST_RECYCLED_VALUE":"Es ist nur 1 hochwertige Note nacheinander zulässig","MAX_AMOUNT_REACHED":"Der Recycler für diese Stückelung ist voll","NON_RECYCLED_DENOMINATION":"Stückelung wird nicht recycelt","THREE_HIGH_VALUE_NOTES_IN_SUCCESSION":"Es sind nicht mehr als drei aufeinanderfolgende Banknoten mit hohem Nennwert zulässig","NOT_OPERATIONAL_005":"Coin roll dispenser for 5 cents is not operational","NOT_OPERATIONAL_010":"Coin roll dispenser for 10 cents is not operational","NOT_OPERATIONAL_020":"Coin roll dispenser for 20 cents is not operational","NOT_OPERATIONAL_050":"Coin roll dispenser for 50 cents is not operational","NOT_OPERATIONAL_100":"Coin roll dispenser for 1 euro is not operational","NOT_OPERATIONAL_200":"Coin roll dispenser for 2 euro is not operational","STORAGE_ALMOST_EMPTY_005":"Coin roll dispenser is almost empty for 5 cents","STORAGE_ALMOST_EMPTY_010":"Coin roll dispenser is almost empty for 10 cents","STORAGE_ALMOST_EMPTY_020":"Coin roll dispenser is almost empty for 20 cents","STORAGE_ALMOST_EMPTY_050":"Coin roll dispenser is almost empty for 50 cents","STORAGE_ALMOST_EMPTY_100":"Coin roll dispenser is almost empty for 1 euro","STORAGE_ALMOST_EMPTY_200":"Coin roll dispenser is almost empty for 2 euro","INVENTORY_UNDER_LOW":"Inventory level is under low, please fill up the machine!","PAYMENT_NOT_POSSIBLE_WITH_THIS_AMOUNT":"Payment not possible with this amount"}}

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

	module.exports = {"generic":{"application_name":"LincSafe Portal","copy_right":"All rights reserved","submenu":{"title":"Organizations","reset_text":"Reset"},"mainmenu":{"login":"Login","submenu":"Submenu","units":"Units","users":"Users","locations":"Locations","departments":"Departments","organizations":"Organizations","tills":"Tills","mixes":"Mixes","roles":"Unit roles","report":"Report","citworkflow":"CIT workflow","softwaresettings":"Software settings","adminsettings":"Admin settings"},"overview":{"pagination":{"showing":"<strong>{current}</strong> of <strong>{total}</strong> showing","pagesize":{"before":"Show","after":"entries"},"success":{"added":"Added {field}","updated":"Updated {field}","deleted":"Deleted {field}","unlocked":"User {field} is unlocked"}},"dialog":{"delete":{"title":"Confirm delete","description":"You are about to delete: ","tillDescriptionName":"You are about to delete: ","tillDescriptionUnit":"and disconnect from {noUnits} unit(s): <ul>{units}</ul>","tillDescriptionUnits":"and disconnect from {noUnits} units?","confirmation":"Are you sure?"},"warning":{"title":"Warning","description":"The CIT organization is being changed. Make sure the new CIT organization has workflows for all device types, otherwise the machines may stop working.","confirmation":"Are you sure you want to proceed with updating?"},"unlock":{"title":"Confirm unlock","description":"You are about to unlock <strong>{name}</strong>","confirmation":"Are you sure?"},"filter":{"title":"Filter","confirmation":"Ok"}},"search":{"placeholder":"Search...","noresults":"We could not find any results matching your query..."},"filter":{"selectall":"Select All","deselectall":"Deselect All","hide":"Hide Filter","show":"Show Filter"},"buttons":{"back":"Back","cancel":"Cancel","confirm":"Confirm","reset":"Reset","create":"Create","update":"Update","delete":"Delete","read":"Read","filter":"Filter","unlock":"Unlock","ok":"OK","upload":"Upload"}},"forms":{"errors":{"required":"The {field} is a required field","required-because":"The {field} is a required field, because {field1} is selected","donotmatch":"The {field} fields do not match","minvalue":"The minimal value is {min}","maxvalue":"The maximal value is {max}","mincharlength":"The minimal character length is {min}","maxcharlength":"The maximum character length is {max}","minmaxcharlength":"The minimal character length is {min} and the maximum character length is {max}","invalidEmail":"Please enter a valid email","form":"Some errors were found in the form. Please check the fields below","userNotFound":"E-mail address not found!","maxPavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Max pavement value\"","pavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Pavement value\"","noworkflow":"No workflow available for selected unit type (Please create a new workflow in CIT workflow page)","positiveOnly":"Only positive number allowed","wrongDates":"Start datetime must be before end datetime","alphaCharsOnly":"Only alphabetical characters allowed","alphaNumericCharsOnly":"Only alphabetical characters and numbers allowed","affiliateCodeValidation":"Must contain exactly 4 alphanumeric characters","numbersOnly":"Only numerical characters (numbers) allowed","safeId":"Must consist of 1 alphabetical character followed by 14 digits. Example: A01234567890123","password":{"missing_lowercase":"Must contain at least one lowercase letter (a-z)","missing_uppercase":"Must contain at least one uppercase letter (A-Z)","missing_digit":"Must contain at least one digit (0-9)","missing_special":"Must contain at least one special character (!\"#%&'()*+,-.:;/<=>?@^_`{|}~)","missing_illegal":"Must not contain illegal characters"},"pin":{"newPinMustBeDifferent":"The new PIN must be different from the current PIN"},"html":{"name":"Invalid characters detected"},"fields":{"firstuserrole":"first user role","seconduserrole":"second user role","name":"name","unittype":"unit type","unittypefamily":"unit type family","logintype":"login type","city":"city","country":"country","timeZone":"timezone","location":"location","legalform":"legal form","currency":"currency","machinename":"machine name","serialnumber":"serial number","ownerorganization":"owner organization","pincodedropsafe":"pincode dropsafe","pincodedropsafeconfirm":"pincode dropfsafe confirm","pincodedrawer":"pincode drawer","pincodedrawerconfirm":"pincode drawer confirm","firstname":"first name","lastname":"last name","organizations":"organizations","organization":"organization","userroles":"user roles","email":"e-mail","password":"password","pin":"pin","mixname":"mix name","totalamount":"total amount","maximumAmount":"maximum amount","units":"units","mixes":"mixes","overrideworkflow":"CIT workflow","apiKeySettings":"API key","mfaEnabled":"MFA enabled","mfaSecret":"MFA Secret","username":"Username","placeholder":"component","placeholderAction":"component action","translationNl":"dutch translation","transactionCashOutLimit":"transaction cash out limit","dailyCashOutLimit":"daily cash out limit"},"unable_to_process_request":"Unable to process your request at this time. Contact your administrator or try again later."},"loading":"Loading...","select":"-- Select from the list --","messages":{"check_email_for_reset_link":"Please check your email for the reset link."}},"errors":{"title":"An error has occurred","unknown_error":"An unknown error occurred while trying to load the requested data.<br/>Please try again later.","could_not_load":"Could not load the requested data.<br/>{response}","unauthorized":"Unauthorized access","unauthorized_expired":"You were logged out because of inactivity for a longer period of time or because you logged in elsewhere","network_down":"A network error occurred. Please check your network","back_button":"Return to the previous page","illegal_argument_uuid":"Invalid identifier found","duplicate_entry":"This item already exists","emptycolumnidentifier":"The column identifier is empty","no_information":"No information","mfaResetError":"Error trying to reset QR/Secret for user"},"login":{"title":"Login","mfaTitle":"Verification","continue":"Continue","forgotPassword":{"title":"Forgot password!","success":"Password reset successfully!"},"mfaFlow":{"mfa_required":"MFA required","mfa_required_description":"Your organization requires you to perform MFA authentication.","mfaHelp":"Help with MFA","errorGettingSecret":"Error obtaining your secret and QR","errorGettingMfaSettings":"Error obtaining MFA settings","mfaHelpTitle":"How restore MFA pairing in case of lost Phone/Authenticator","mfaHelpInstructions":"Contact your organization and provide them:<br/><br/> Full name <br/> Phone contact <br/> <br/> They will validate the information with you, and after that enable <strong>QR/secret</strong> pairing again.You shall receive an email once is done and will be able to see QR/secre from login screen again.","mfaHelpInstructionsOtherMfa":"There are more MFA methods available connect with them. <br/> If your organization enabled self QR/Secret recovery, click on your name at top right to see the <strong>User menu</strong> and click on Reset QR/Secret, so next login you will see the QR for new pairing.","understood":"Understood","setupMfaTitle":"Setup MFA","setupMfaDescription":"Please select one MFA type and click con continue.","setupMfaSelectType":"Select type of MFA","mfaPairingTitle":"Phone app setup (one time)","mfaPairingQrImage":"QR image:","mfaPairingSecret":"MFA secret: ","mfaPairingInstructionsTitle":"Instructions for Phone app MFA setup","mfaPairingInstructionsLine1":"Download any authenticator app such as google, microsoft authenticator.","mfaPairingInstructionsLine2":"Open it and click on Add and then select QR or Key.","mfaPairingInstructionsLine3":"With QR please scan the image above and for manual input copy the MFA secret","mfaPhoneInstructionsTitle":"Instructions for Phone app MFA","mfaPhoneInstructionsLine1":"Open your Authenticator device or Smartphone and check for the code provided there.","mfaPhoneInstructionsLine2":"To pair again check MFA troubleshoot.","mfaPhoneInstructionsLine3":"If you can't use this method anymore try with other MFA method such as Email.","mfaEmailInstructionsTitle":"Instructions for Email MFA","mfaEmailInstructionsLine1":"You had received a temporal access token in your email.","mfaEmailInstructionsLine2":"The token will be valid for some minutes.","mfaValidationTitle":"Code validation","mfaValidationDescription":"Enter the code provided by your selected MFA method"},"form":{"username":"Username","password":"Password","email":"E-mail","mfaCode":"Mfa Code"},"buttons":{"login":"Login","validate":"Verify","forgotPassword":"Forgot password","reset":"Reset my password"}},"logout":{"title":"Logout","buttons":{"logout":"Logout","profile":"Profile","changepassword":"Change password","changepin":"Change pin","mfaResetQrSecret":"Reset MFA QR/Secret"}},"new_portal":{"title":"Try the new Lincsafe Portal ✨","dialog":{"description_1":"Experience the redesigned Lincsafe Portal with a fresh look and improved features — your account data and settings remain exactly as they are.","description_2":"<br/><b>Note</b>: The Legacy Version will be retired soon.","confirm":"Explore new UI"}}},"management":{"common":{"form":{"primaryAccount":"Primary bank account number","citAccount":"CIT account number","affiliateCode":"Affiliate code","overrideBankAccount":"Override primary bank account number","overrideCitAccount":"Override CIT account number","overrideAffiliateCode":"Override affiliate code"},"toolTip":{"primaryAccount":"Bank account number to which deposits/withdrawals are transmitted from the safe(s). Can be overridden at a more granular level","citAccount":"Bank account number to which funds are deposited after CIT. Usually the same as primary bank account number","affiliateCode":"4 digit alphabetical code"}},"unit":{"titles":{"overview":"Units","create":"Add a unit","update":"Update unit","preview":"Unit preview","read":"Unit details","inventory":"Inventory","readsettings":"Unit settings"},"breadcrumb":{"title":"Overview"},"columns":{"no":"#","amount":"Amount","buildVersion":"Version","closeTime":"Time","till":"Till","compartment":"Compartment","counter":"Number","currency":"Currency","currentValue":"Current value","date":"Date","dateTimeStopped":"Date time stopped","description":"Description","message":"Message","direction":"Direction","insurableValue":"Insurable value","level":"Level","location":"Location","machineName":"Machine name","machineType":"Machine type","name":"Name","placeholder":"Component","placeholders":"Components","reason":"Reason","remoteSupportId":"Remote support ID","sales":"Sales","serialNo":"Serial number","source":"Source","status":"Status","teamviewerId":"Teamviewer ID","total":"Total Value","transactionNumber":"Number","type":"Type","unitIpAddress":"IP address","unitMacAddress":"MAC address","unitStatus":"Unit status","userAccountName":"User","userLoginName":"User","value":"Value","valueIn":"In","valueOut":"Out","valueProcessed":"Value","totalValue":"Total Value","vpnIpAddress":"VPN IP address"},"form":{"machineName":"Machine name","apiKey":"API key","location":"Location","organizations":"Organizations","ownerOrganization":"Owner organization","supportMultipleClient":"Support multiple client","clientOrganizations":"Client organizations","inheritedCIT":"Inherited CIT","inheritedMaintenance":"Inherited Maintenance","overrideCIT":"Override CIT","overrideMaintenance":"Override maintenance","overrideWorkflow":"CIT workflow","unitTypeFamily":"Unit type family","unitType":"Unit type","serialNo":"Serial number","safeId":"Safe ID","currency":"Currency","endOfDayTime":"End of day time","hours":"Hours","minutes":"Minutes","alarmOn":"Alarm on","alarmValuePerDay":"Alarm value per day","alarmOnMonday":"Monday","alarmOnTuesday":"Tuesday","alarmOnWednesday":"Wednesday","alarmOnThursday":"Thursday","alarmOnFriday":"Friday","alarmOnSaturday":"Saturday","alarmOnSunday":"Sunday","maximumAmount":"Maximum amount of coins/notes per cassette","insurableValue":"Insurable value","offlineTimeout":"Offline timeout","pincodeDrawer":"Pincode drawer","sideSafe":"Has dropsafe","advancedManualDeposit":"Enable AMD","drawer":"Has drawer","pincodeDropsafe":"Pincode dropsafe","pincodeDrawerConfirm":"Confirm pincode drawer","pincodeDropsafeConfirm":"Confirm pincode dropsafe","overrideSettings":"Override inherited settings","maxPavementWarningPercentage":"Alarm on","departments":"Departments","coinDistribution":"Management","iban":"IBAN","creditorName":"Creditor name","creditorIbanNumber":"Creditor IBAN number","errors":{"cassetteError":"Please enter the value for the Optimum and Max column before updating the page"},"capacityAlertThreshold":"Capacity"},"toolTip":{"maxPavementWarningPercentage":"A warning will pop up on the machine screen, telling the managers/CIT that the bag will be full soon. The user will be informed when it has reached the entered percentage of the max pavement value.","machineName":"The name of the machine","location":"The address where the machine is located, this needs to be created before creating the unit","organizations":"Organizations","ownerOrganization":"The organization that manages the machine","supportMultipleClient":"Let the machine be used by multiple organizations","clientOrganizations":"Only sub-organizations of the owner that can deposit into the machine","inheritedCIT":"The Cash in Transit organization that is inherited from the owner organization","inheritedMaintenance":"The maintenance organization that is inherited from the owner organization","overrideCIT":"To use a different Cash in Transit organization than the one that was inherited from the owner organization","overrideMaintenance":"To use a different maintenance organization than the one that was inherited from the owner organization","overrideWorkflow":"To use a different cash in transit procedure than the one that was inherited from the owner organization","unitTypeFamily":"The family of unit types","unitType":"Which kind of machine this is. Several technical details are determined based on this, such as which components the machine consists of. This field cannot be edited.","serialNo":"Serial number from Lincsafe's system, it can be found on a plaque on the safe. The first time the unit connects to the portal it uses this code to connect","safeId":"Optional, custom, unique, 15 character identifier for this unit","currency":"Which currency can be used by the machine for {organization} organization","endOfDayTime":"The time that is used in reporting for the end of the day, this can be used for example by shops that close after twelve.","hours":"Hours","minutes":"Minutes","alarmOn":"Sends an email when the unit is almost full. It will be sent when it has reached the entered percentage of the insurable value. The subscribers can be altered by clicking on the clock symbol next to the organization on the organization overview page","alarmValuePerDay":"Sends an email when the unit is almost full. It will be sent when it has reached the entered percentage for that day. The subscribers can be altered by clicking on the clock symbol next to the organization on the organization overview page","alarmOnMonday":"Monday","alarmOnTuesday":"Tuesday","alarmOnWednesday":"Wednesday","alarmOnThursday":"Thursday","alarmOnFriday":"Friday","alarmOnSaturday":"Saturday","alarmOnSunday":"Sunday","maximumAmount":"The maximum amount of bills/coins that can physically fit in a compartment. Not applicable for Lincstation","insurableValue":"The maximum value of money in the machine that is covered by insurance. This is used to determine if the unit is full and should be emptied.","offlineTimeout":"The time the portal waits for a heartbeat message from the unit, before marking it as offline.","pincodeDrawer":"The pincode that needs to be entered on the machine to open the drawer","sideSafe":"The machine has a drop safe in which for example vouchers can be entered","advancedManualDeposit":"Enable advanced manual deposit: the dropsafe can be used for official money deposits that can be picked up by a CIT company","drawer":"The machine has a drawer that can be used to fix jams","pincodeDropsafe":"The pincode that needs to be entered on the machine to open the dropsafe","pincodeDrawerConfirm":"Confirm pincode drawer","pincodeDropsafeConfirm":"Confirm pincode dropsafe","overrideSettings":"Change the settings for this machine to be different than the default settings for this organization","overrideBankAccount":"Do not inherit primary bank account from Location. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Location. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Location. Instead, define a new one specific to this unit","coinDistribution":"Twin coin system distribution setting management in percentage","departments":"1) This Unit and its selected Location must belong to the same Organization in order to have departments shown.\n2) Only Departments assigned to the above selected Location (or owner Organization if Location doesn't have any Departments) are shown.","mfaEnabled":"Enable this option for each user when they log into the Portal","cassetteCapacity":"The note limit of each cassette in the unit.","capacityAlertThreshold":"The percentage of capacity at which point an alert will be generated"},"softwaresettings":{"1":"Free pay","2":"High to low","changeCassetteHardware":"Please note that cassette hardware should be changed","tillRestrictions":"Restricted tills","maxPavementWarningPercentage":"Max pavement value alarm","g4sCertificate":"G4S Certificate","payplazaCertificate":"Payplaza Certificate","autoFloatDownWhenSystemIsIdle":"Auto float down","listUserByOrganization":"List user by organization","listUserByUsername":"List user by username","xmlExportName":"XML export","useReferenceNumber":"Nr page (don't use this setting, only for old versions)","referenceNumberLength":"Reference number length","unitBarcodeTypeOnFirstCitPage":"Display Barcode of Unit Name (CIT Screen)","hitachiRejectBoxHandling":"Empty Upper Reject Box Handling","manager":"Manager will empty reject box","cit":"CIT will empty reject box","managerReconciled":"Manager will reconcile and empty reject box","hitachiRejectBoxFullPct":"Reject Box full notification (%)","currencyCode":"Currency","hopper1Value":"Hopper 1 value","hopper2Value":"Hopper 2 value","numberOfCoins":"Number of coins","beepOnBillRejected":"Beep on bill rejected","transactionPerBill":"Transaction per bill","loginRequiredTransaction":"Login required transaction","buzzerTimeout":"Buzzer timeout","enableOTC":"Enable OTC","billMaxAmount":"Maximum amount threshold for bills","coinMaxAmount":"Maximum amount coins overflow","heartbeatRate":"Heartbeat rate","downloadRate":"Download rate","safeStatusRate":"Safe status rate","inventorySettings":"Inventory settings","coinInventory":"Coin inventory","om61InventorySettings":"OM61 inventory settings","payableValue":"Payable value","floatValue":"Float value","floatSettings":"Float settings","payOutMethod":"Pay out method","round":"Rounded value","payOutLimit":"Pay out limit","language":"Initial language of the unit","bins":"Bank Bins","ecrId":"Pin Terminal Id","ecrUrl":"Payplaza Url","charities":"Charities","g4sApiUrl":"Banks Authorization Url","authApiKey":"Authorization API Key","employeeSelection":"Employee selection","supportedLanguages":"Supported languages","unitInitialLanguage":"Initial language of the Unit","showDeviceTotal":"Show device total","baseUrl":"Api base URL","clientId":"Api client ID","storageVault":"Storage vault","userManagement":"User management","showExtraButtonOnUserSelectScreen":"Show extra user select button","pavementLimit":"Pavement Limit","communicationRate":"Communication rate","depositTimeout":"Deposit idle timeout in seconds","normalDepositReceipts":"Deposit receipt count","manualDepositReceipts":"Manual deposit receipt count","transactionReceiptNumber":"Number of receipts per transaction","showDenominationDetailsOnDepositPrint":"Show denomination on deposit print","showUserTotals":"Show user totals function","showDailyReports":"Show daily reports function","manualEndOfDay":"Manual end of day","textLanguage":"Text language selection","accountabilityType":"Accountability type","dateFormat":"Date format","MMddyyyy":"United States (12/31/2000)","dd-MM-yyyy":"International (31-12-2000)","MMMddyyyy":"US Global (Dec 31 2000)","ddMMMyyyy":"Alternate International (31 Dec 2000)","yyyy-MM-dd":"Year-Month-Day (2000-12-31)","screenSaver":"Screen saver","preTransactionTask":"Show Reference Number","noTask":"No","refNr":"Show reference number page","low":"Low","medium":"Medium","high":"High","high_low_medium":"Custom 1","Low":"Low","Medium":"Medium","High":"High","namelist":"List of names","empnr":"Enter employee number","barcode":"User log in with Barcode","hasPrinterAttached":"Show printer notifications","en":"English","us":"English US","nl":"Dutch","fr":"French","hu":"Hungarian","sk":"Slovak","pl":"Polish","el":"Greek","de":"German","EUR":"EUR","TR":"TR","USD":"USD","noExport":"no export","MLSA":"OCS export","puloonCassette1":"Puloon Cassette 1","puloonCassette2":"Puloon Cassette 2","puloonCassette3":"Puloon Cassette 3","puloonCassette4":"Puloon Cassette 4","EUR-5":"5 €","EUR-10":"10 €","EUR-20":"20 €","EUR-50":"50 €","EUR-100":"100 €","EUR-200":"200 €","EUR-500":"500 €","puloonCassette1FixedAmount":"Puloon Cassette 1 Fixed Amount","puloonCassette2FixedAmount":"Puloon Cassette 2 Fixed Amount","puloonCassette3FixedAmount":"Puloon Cassette 3 Fixed Amount","puloonCassette4FixedAmount":"Puloon Cassette 4 Fixed Amount","inventoryCheckOnPayment":"Check inventory on payment","tariffs":"Tariffs","acceptablesSetting":"Enabled denominations","minimumOrderRolls":"Minimal roll order amount","inventoryOptimumReset":"Inventory float down time","escrowEmptyAmount":"Escrow empty amount","maxBagValue":"Max pavement value","ledLightColor":"LED color in idle state","defaultLedColor":"Default LED color in idle state","yellow":"Yellow","red":"Red","green":"Green","blue":"Blue","magenta":"Magenta","cyan":"Cyan","white":"White","posMode":"POS mode","none":"None","barcode_itf":"Barcode ITF","qrcode":"QR Code","allowManagerEmptyAllRecyclers":"Allow manager to empty all recylers","allowManagerEmptyManualDeposit":"Allow manager to empty manual deposit box","managerUnlockDelay":"Delay time to unlock safe doors","managerUnlockStartTime":"Unlock start time","managerUnlockEndTime":"Unlock end time","apiKeyMasked":"API Key","secretKeyMasked":"Secret Key","customXmlHeader":"Custom XML Header","coinDistribution":"Twin coin system distribution setting","includeManualStorageInDeviceTotalAndSDC":"Include Manual Storage in Totals and SDC","autoPrintEndOfDay":"Auto Print End of Day Receipts","disableManualDenominationSelection":"Disable Manual Denomination Selection","tubeDispenserEnabled":"Tube Dispenser","coinOverflowCapacityGrams":"Coin overflow capacity (grams)","coinOverflowCapacityWarningPercentage":"Coin overflow full capacity warning (percentage)","allowManagerEmptyCoinOverflow":"Allow manager to empty coin overflow","inventorypanel":{"denomination":"Denomination","material":"Material","recycled":"Recycled","numberOfRecyclers":"Recycler count","min":"Min","low":"Low","optimum":"Optimum","max":"Max","high":"High","value":"Value","COIN":"Coin","BILL":"Bill","ROLL":"Roll","maxDispensable":"Max dispensable","nonRecyclable":"Storage Bin / Non-Recyclable Coin Inventory","messages":{"recyclerStatusInfo":"{totalRecyclers} of {maxNumberOfRecyclers} recyclers are used","recyclerStatusError":"Error: Exceed the max recycler count ({maxNumberOfRecyclers}); claimed: {totalRecyclers}","excideMaximumDrawer":"Max drawer dispensable limit is {limit}","excideMaximumCup":"Max cup dispensable limit is {limit}"}},"tariffspanel":{"transaction_fee":"Fee per transaction","value_fee":"Fee per roll"},"minimumOrderPanel":{"min":"Min (1)","max":"Max (200)"},"timeSelector":{"enabled":"Enabled"},"minimumOrderCoinRollsSettings":"Min and max coin rolls order amounts","apiKeySettings":"API key","useDefaultValue":"Use default value","localPinChange":"Change user pin on unit","puloonRejectBinMaxAmount":"Maximum amount of notes that puloon reject bin can handle","puloonRejectBinWarningPercentage":"Puloon reject bin full capacity warning (percentage)","cashierAccountability":"Cashier accountability","laneAccountability":"Lane accountability","simpleMode":"Simple mode","printTrxDailyBalance":"Print daily balance on the transaction receipt","printBarcodesOnCitReceipt":"Print barcodes on CIT receipt","code39":"Code 39","code128":"Code 128 (B type)","cassetteCapacity":"Cassette Capacity","capacityAlertThreshold":"Capacity Alert Threshold","showNoteValidationOnDashboard":"Show Note Validation on the Dashboard"},"actions":{"create":"Add unit","read":"Read unit","update":"Update unit","preview":"Unit preview","delete":"Delete unit","filter":"Filter units on status","readsettings":"Read unit settings"},"messages":{"added":"The unit {name} is added","updated":"The unit {name} is updated"},"read":{"tabs":{"detail":"Details","transactionDetails":"Transaction Details","specifications":"Technical specifications","status":"Status","users":"Users","sales":"Sales","internal":"Internal","mixes":"Mixes","tills":"Tills","citLegacy":"Legacy","citStatic":"Static","citDynamic":"Dynamic"},"summary":{"maximumAmount":"Max coins/notes per cassette","machineName":"Machine name","insurableValue":"Insurable value","currentValue":"Current value","currentDepositValue":"Current deposit value","unitModelName":"Unit type","unitTypeFamily":"Unit type family","location":"Location","placeholders":"Components","lastTransactionDate":"Last transaction date","currency":"Currency","currentStatus":"Current status","networkStatus":"Network status","lastClearBox":"Last clear box","yesterdayTurnover":"Yesterday turnover","lastClearBoxDate":"Last clear box date","fillGrade":"Fill grade","manualDepositValue":"Manual Deposits","totalValue":"Total","numberOfTransactions":"Number of transactions","name":"Name","addressLine1":"Address","city":"City","unitFillStatus":"Threshold reached","ALMOST_FULL":"ALMOST FULL","FULL":"FULL","NORMAL":"NORMAL","null":"null"},"titles":{"unitStatus":"Unit status","unitDetail":"Unit detail","unitDetails":"Unit details","location":"Location details","departments":"Department details","lastTransactions":"Last transactions","campaignsUnit":"Clearboxes unit","lastClearBoxes":"Last clear boxes","component":"Technical specifications","eventsByUnit":" Events","lastEvents":"Last events","hardwareStatus":"Hardware: ","networkStatus":"Network: ","notifications":"Notifications"},"status":{"ALMOST_EMPTY":"Needs to be filled","ALMOST_FULL":"Needs to be cleared","DEBUG":"Debug","EMPTY":"Needs to be filled","ERROR":"Error","FATAL":"Fatal","FULL":"Needs to be cleared","INFO":"Info","INVENTORY_NOT_SUFFICIENT":"Needs to be filled","INVENTORY_OVER_MAXIMUM":"Needs to be emptied","INVENTORY_UNDER_MIN":"Needs to be filled","INVENTORY_UNDER_LOW":"Needs to be filled","JAMMED":"Clear the jam","NOT_CONNECTED":"Check the connection to the device","NOT_SECURE":"Unlock the door and close and lock it again","OFFLINE":"Unit is offline","OK":"OK","OPEN":"Close the door","OVERRIDDEN":"Use the menu to unlock and then lock the door","RECYCLER_ALMOST_EMPTY":"Fill the recycler","RECYCLER_ALMOST_FULL":"Remove some material from the recycler","RECYCLER_EMPTY":"Fill the recycler","RECYCLER_FULL":"Remove some material from the recycler","STACKER_FULL":"Clear the bills from the stacker","STORAGE_ALMOST_FULL":"Clear the Storage","STORAGE_DETACHED":"Attach the storage","STORAGE_FULL":"Clear the Storage","TRACE":"Trace","UNLOCKED":"Lock the door","WARN":"Warning","WARNING":"Warning"},"techSpec":{"ACCEPTING":"Accepting","ALMOST_EMPTY":"Almost Empty","ALMOST_FULL":"Almost Full","BAG_OPEN":"Bag Open","CALIBRATING":"Calibrating","CASSETTE_ERROR":"Cassette Error","CASSETTE_ATTACHED":"Cassette Attached","CASSETTE_DETACHED":"Cassette Detached","CARTRIDGE_DETACHED":"Cartridge detached","CLOSED":"Closed","CONNECTED":"Connected","DOOR_CLOSED":"Door Closed","DOOR_OPEN":"Door Open","DOOR_LOCKED":"Door Locked","DOOR_UNLOCKED":"Door Unlocked","DOWNLOADING":"Downloading","EMPTY":"Empty","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Entrance not empty","EXTENSION_STALL":"Extension stall","FAILED":"Failed","FEED_FAILURE":"Feed Failed","FULL":"Full","INVENTORY_MISMATCH":"Tube inventory mismatch detected","INVENTORY_NOT_SUFFICIENT":"Inventory Not Sufficient","INVENTORY_OVER_MAXIMUM":"Inventory over maximum","INVENTORY_UNDER_MIN":"Inventory under minimum","INVENTORY_UNDER_LOW":"Inventory under low","JAM_CLEARED":"Jam cleared","JAMMED":"Jammed","LOCKED":"Locked","LOCKS_SECURE":"Locks Secure","NOT_ACCEPTING":"Not Accepting","NOT_CONNECTED":"Not Connected","NOT_FOUND":"Configuration not found","NOT_OVERRIDDEN":"Not Overridden","NOT_OPERATIONAL":"Not Operational","NOT_SECURE":"Not Secure","NEGATIVE_RESERVE_CHANGE":"Reserve change balance is negative","OFFLINE":"OFFLINE","ONLINE":"ONLINE","NETWORK_DISCONNECTED":"Network disconnected","NETWORK_RESTORED":"Network restored","OK":"OK","OPEN":"Open","OVERRIDDEN":"Overridden","PAUSE":"Pause","POWER_UP":"Power up","RECYCLER_ALMOST_EMPTY":"RECYCLER Almost Empty","RECYCLER_ALMOST_FULL":"RECYCLER Almost Full","RECYCLER_EMPTY":"RECYCLER Empty","RECYCLER_FULL":"RECYCLER Full","REJECT_NOT_EMPTY":"Reject is not empty","RCF_TUBE_AUDIT_DUE":"Change and tube audit required","OUTPUT_NOT_EMPTY":"Output is not empty","SAFE_DOOR_OPEN":"Safe door open","SECURE":"Secure","SIDE_SAFE_ONE_LOCKED":"Side safe 1 locked","SIDE_SAFE_ONE_UNLOCKED":"Side safe 1 unlocked","STACKER_FULL":"Stacker Full","STALLED":"Stalled","STORAGE_ALMOST_FULL":"Storage Almost Full","STORAGE_ALMOST_FULL_CLEARED":"Storage Almost Full Cleared","STORAGE_ATTACHED":"Storage attached","STORAGE_DETACHED":"Storage detached","STORAGE_FULL":"Storage Full","STORAGE_ALMOST_EMPTY_005":"Coin Roll storage almost empty for 5 cents","STORAGE_ALMOST_EMPTY_010":"Coin Roll storage almost empty for 10 cents","STORAGE_ALMOST_EMPTY_020":"Coin Roll storage almost empty for 20 cents","STORAGE_ALMOST_EMPTY_050":"Coin Roll storage almost empty for 50 cents","STORAGE_ALMOST_EMPTY_100":"Coin Roll storage almost empty for 2 euro","STORAGE_ALMOST_EMPTY_200":"Coin Roll storage almost empty for 2 euro","TOP_DOOR_CLOSED":"Top door closed","TOP_DOOR_OPEN":"Top door open","UNLOCKED":"Unlocked","CIT_STARTED":"CIT started","CIT_COMPLETED":"CIT completed","MAINTENANCE_STARTED":"Maintenance started","MAINTENANCE_COMPLETED":"Maintenance completed"}},"inventory":{"unitInventory":"Unit Inventory","noTransactions":"No Transactions","noTransactionsDesc":"No transactions found please retry later!","items":"Items","total":"Total ","cassette":"Cassette","columns":{"DENOMINATION":"Denomination","QTY":"QTY","COMPARTMENT_INDEX":"Index","SUTOTAL":"Subtotal"}},"campaign":{"read":"Last clearboxes","columns":{"no":"#","group":"Group","placeholder":"Component","dateTimeStopped":"Date time stopped","userAccountName":"User","insertedValue":"Inserted","valueProcessed":"Collected","totalValueProcessed":"Total value processed"}}},"softwaresettings":{"titles":{"overview":"Software settings","create":"Add software settings","update":"Update software settings","readsettings":"Read software settings"},"breadcrumb":{"title":"Currency"},"actions":{"create":"Add software setting","read":"Read software setting","update":"Update software setting","delete":"Delete software setting","readsettings":"Read software settings"},"columns":{"ownerOrganization":"Owner organization","unitType":"Unit Type"},"messages":{"added":"New settings are added","updated":"Settings are updated"},"form":{"ownerOrganization":"Owner organization","unitType":"Unit Type","overrideSettings":"Override default settings","selectOverrideSettings":"Select settings to override and use","checkAll":"Check all","cassettesAssignment":"Cassettes Assignment","noteAssignment":"Note assignment"},"toolTip":{"g4sCertificate":"Certificate for software management","hitachiRejectBoxHandling":"How the reject box will be managed and emptied.\nIf Manager will reconcile is selected it will allow the manger to adjust the recycler inventory based on the actual count of the rejected notes.","hitachiRejectBoxFullPct":"Reject Box full (200) notification (%)","payplazaCertificate":"Certificate for software management","managerUnlockStartTime":"Unlock start time","managerUnlockEndTime":"Unlock end time","autoFloatDownWhenSystemIsIdle":"Auto float down if no active transaction and recycler is full","hasPrinterAttached":"Only use when a printer is attached","listUserByOrganization":"List employees by organization when unit supports multi client","listUserByUsername":"List employees by user name, otherwise list by employee number","xmlExportName":"Used when 3rd party xml export is needed","useReferenceNumber":"Deposit setting, only for old versions","referenceNumberLength":"Reference number length","currencyCode":"Currency for NS Wisselaar hoppers","hopper1Value":"NS Wisselaar hopper1 value","hopper2Value":"NS Wisselaar hopper2 value","numberOfCoins":"NS Wisselaar coin amount per hopper","beepOnBillRejected":"Beep on bill rejected","transactionPerBill":"Bill acceptor only accepts one bill per transaction","loginRequiredTransaction":"Login is required to start a new deposit","tillRestrictions":"When selected, tills are only allowed to be dispensed once. They will become available again after the till is deposited back into the machine. When deselected, tills can be used multiple times.","buzzerTimeout":"Buzzer beeping timeout duration","enableOTC":"Used to enable OTC mode for smart lock","heartbeatRate":"Frequency of sending heartbeat from unit to portal","downloadRate":"Frequency of downloading configuration files from portal to unit","safeStatusRate":"Frequency of sending safe status from unit to portal","inventorySettings":"Inventory settings for Lincstation, consists acceptable materials, recycled materials, minimum, float and maximum levels of denominations","payableValue":"Minimum value to check inventory whether Lincstation is operational for a payment or not","floatValue":"Day start value of Lincstation","coinMaxAmount":"Maximum amount of coins in the overflow. A warning will be generated at 80% of this value.","billMaxAmount":"Maximum amount threshold for bills in Lincstation","payOutMethod":"Pay out mode for Smart Coin System in Lincstation","round":"Used to round the value entered for a payment in Lincstation","payOutLimit":"Limit per pay out in Lincstation","language":"Initial language of the Unit until User changes it","bins":"List on Bins per Bank that is supported","ecrId":"The id for the terminal connected to the unit","ecrUrl":"The endpoint used to perform payments and other card transactions","g4sApiUrl":"The endpoint used for the authorization of cards","employeeSelection":"Searching employees by entering employee number, or see the employees displayed in a list","supportedLanguages":"Supported languages by device","showDeviceTotal":"Used for showing device total value and denomination details on manager menu","storageVault":"Enable additional storage vault","userManagement":"Enable user management","showExtraButtonOnUserSelectScreen":"When enabled, this causes a 5th user select button to appear on the user select screen","pavementLimit":"Pavement limit for the cassette","communicationRate":"Sets how often the unit communicates with the portal to confirm it is active ('heartbeat') and checks for updates. Options: \n- High: Every 2 minutes (120 seconds)\n- Medium: Every 15 minutes (900 seconds)\n- Low: Every hour (3600 seconds)","depositTimeout":"Timeout duration for deposit screen","normalDepositReceipts":"Number of receipt to print after normal deposit","manualDepositReceipts":"Number of receipt to print after manual deposit","showDenominationDetailsOnDepositPrint":"Show denomination on deposit print","showUserTotals":"Show user totals function in settings screen","showDailyReports":"Show daily reports function in management screen","manualEndOfDay":"End of day will be manually performed by a manager (This setting disables the automatic end of day feature)","textLanguage":"Use text language selection screen (instead of flags)","accountabilityType":"Select the method that aligns with the accounting approach","dateFormat":"The date format displayed on receipts and screen","preTransactionTask":"Used for showing denomination details per transaction on deposit receipt","screenSaver":"Show screen saver when machine is idle","puloonCassette1":"Denomination for Cassette 1","puloonCassette2":"Denomination for Cassette 2","puloonCassette3":"Denomination for Cassette 3","puloonCassette4":"Denomination for Cassette 4","puloonCassette1FixedAmount":"Fixed amount of bills in the Cassette 1","puloonCassette2FixedAmount":"Fixed amount of bills in the Cassette 2","puloonCassette3FixedAmount":"Fixed amount of bills in the Cassette 3","puloonCassette4FixedAmount":"Fixed amount of bills in the Cassette 4","inventoryCheckOnPayment":"Checks if inserted amount can be dispensed during the payment","charities":"Charity organizations data","escrowEmptyAmount":"Minimum amount for escrow to be emptied","maxBagValue":"Maximum value for the bag","inventoryOptimumReset":"The time when the inventory of the machine will reset back to optimum values based on the inventory settings","apiKeySettings":"API key for the connector","ledLightColor":"LED light color","authApiKey":"Authorization API Key","posMode":"Point of sale mode limits machine functionality by disabling some buttons","allowManagerEmptyAllRecyclers":"Enables the manager to dispense all available notes and coins locally on the unit","managerUnlockDelay":"Manager delay for opening tills and coin drawer","localPinChange":"Able to change user pin code on unit","customXmlHeader":"Set custom XML data needed for integration","puloonRejectBinMaxAmount":"Puloon reject bin maximum notes capacity","puloonRejectBinWarningPercentage":"Warning level set in percentage for Puloon reject bin. This functionality is disabled if 0 is set","unitBarcodeTypeOnFirstCitPage":"Enables unit name to be shown as a barcode on device display at the start of CIT flow","printBarcodesOnCitReceipt":"When printing CIT receipt on the machine, barcodes can also be printed","coinOverflowCapacityGrams":"Approximate weight capacity for the coin overflow","coinOverflowCapacityWarningPercentage":"Warning level set in percentage for Coin overflow. This functionality is disabled if 0 is set","cassetteCapacity":"The note limit of each cassette in the unit.","capacityAlertThreshold":"The percentage of capacity at which point an alert will be generated"},"billsDenominationTable":{"yes":"YES","no":"NO","columns":{"cassettes":"Cassettes","recycler":"Recycler","denomination":"Denomination","currency":"Currency","optimum":"Optimum","max":"Max"}}},"user":{"titles":{"overview":"Users","create":"Add a user","update":"Update user","changepassword":"Change password","changepincodes":"Change pincode","updateprofile":"Update profile","forgotpassword":"Forgot password","resetpassword":"Reset password","readsettings":"User settings"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Name","organization":"Organization","email":"E-mail","roles":"User roles"},"form":{"firstName":"First name","lastName":"Last name","rfid":"RFID / Dallas Key","employeeNumber":"Employee number","mfaEnabled":"Enable multi-factor authentication","generate":"Generate","copied":"Copied","secretkey":"Secret key","organization":"Organization","roles":"User roles","unitRoles":"Unit role","email":"E-mail","externalUsername":"External Username","externalPassword":"External Password","password":"Password","passwordConfirm":"Confirm Password","sendTemporaryPassword":"Send temporary password","pin":"Pin","pinConfirm":"Confirm pin","openDropsafeWithPin":"Open dropsafe with pin","storageVaultAccess":"Storage vault access","openDrawerWithPin":"Open drawer with pin","forcePinReset":"Force PIN reset","units":"Units","oldPassword":"Old password","newPassword":"New password","confirmPassword":"Confirm new password","oldPin":"Old pin","newPin":"New pin","tills":"Tills","mixes":"Mixes","dailyDispenseLimit":"Daily dispense limit value of coins and notes","dailyPayoutLimit":"Daily payout limit","useExternalRoles":"Use external roles","departments":"Departments"},"actions":{"create":"Add user","read":"Read user","update":"Update user","delete":"Delete user","unlock":"Unlock user","readsettings":"Read user settings"},"messages":{"added":"The user {name} is added","updated":"The user {name} is updated","changedpassword":"The password is updated","changedpin":"The pin is updated","updateprofile":"The profile is updated","qrSecretReset":"The QR/secret has been reset correctly","attemptFirst":"first","attemptNext":"next"},"toolTip":{"mfaEnabled":"Enable multi-factor authentication","copySecret":"Copy secret text","useExternalRoles":"Assign one of the specialized roles which belong to a specific unit e.g. HS600","departments":"Only Departments assigned to the above selected Organization are shown.","forcePinReset":"Require the user to change their PIN code during their {attempt} login on the device. Available on the Safe version 4.26.11 or higher"}},"location":{"titles":{"overview":"Locations","create":"Add a location","update":"Update location","readsettings":"Location settings"},"breadcrumb":{"title":"Overview"},"columns":{"city":"City","name":"Name","addressLine":"Address"},"form":{"organization":"Organization","name":"Name","city":"City","addressLine1":"Address 1","addressLine2":"Address 2","postalCode":"Postal code","country":"Country","state":"State/Province","timeZone":"Timezone","email":"E-mail","phoneNumber":"Phone number","departments":"Departments"},"toolTip":{"organization":"Organization to which this Location belongs to. Available departments depend on this","timeZone":"Machine time will be set up according to the timezone.","overrideBankAccount":"Do not inherit primary bank account from Organization. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Organization. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Organization. Instead, define a new one specific to this unit","departments":"Only Departments assigned to the above selected Organization are shown."},"actions":{"create":"Add location","read":"Read location","update":"Update location","delete":"Delete location","readsettings":"Read location settings"},"messages":{"added":"The location {name} is added","updated":"The location {name} is updated"}},"department":{"titles":{"overview":"Departments","create":"Create a department","update":"Update department","preview":"Preview department"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Name","organizationName":"Organization"},"form":{"name":"Name","organization":"Organization","bankAccount":"Bank account number"},"toolTip":{"organization":"Which organization does this department belong to","bankAccount":"Bank account number to which deposits/withdrawals are transmitted from the safe(s)","overrideBankAccount":"Do not inherit primary bank account from unit. Instead, define a new one specific to this department","affiliateCode":"Bank account number's affiliate code.","overrideAffiliateCode":"Do not inherit affiliate code from Organization. Instead, define a new one, specific to this department."},"actions":{"create":"Create department","read":"Preview department","update":"Update department","delete":"Delete department","preview":"Preview department"},"messages":{"added":"Department {name} has been created","updated":"Department {name} has been updated"}},"organization":{"titles":{"overview":"Organizations","create":"Add an organization","jobs":"Organization jobs","update":"Update organization","readsettings":"Organization settings","mfaTypes":"MFA types"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Name","location":"Location","parentOrganization":"Parent organization","organizationType":"Organization type"},"form":{"dayTotalJob":"Day Total Job","recyclerOverallJob":"Recycler Overall Job","mailSendingTime":"Mail sending time","enabled":"Enabled","remainingUsers":"Remaining Users","subscribers":"Subscribers","affectedUnits":"Affected Units","name":"Name","ipWhiteList":"IP white list","pin":"Pin","organizationType":"Organization type","parentOrganization":"Parent organization","inheritedCIT":"Inherited CIT","inheritedMaintenance":"Inherited Maintenance","overrideCIT":"Override CIT","overrideMaintenance":"Override maintenance","defaultCIT":"Default CIT","defaultMaintenance":"Default Maintenance","reportedOrganizations":"Reported organizations","location":"Location","legalForm":"Legal form","remark":"Remark","forceMfaForUsers":"Force MFA auth for users","enableUserMfaSecretReset":"Allow users to reset their QR/Secret","enableAuthdeviceMfa":"Phone/Authenticator device MFA","enableEmailMfa":"Email MFA","enableSmsMfa":"SMS MFA","supportAccountNumbers":"Support account numbers","ibutton":{"iButtons":"iButtons","overview":"iButton keys overview","noData":"There are no iButton keys to show.","add":"Add iButton key","uploadCSV":"Upload CSV","name":"iButton Key","removeAll":"Remove all iButton keys","removeAllConfirmationText":"Are you sure that you want to delete all ibuttons?","remove":"Remove","cancel":"Cancel","delete":"Delete","ok":"OK","invalidCSVfile":"Please upload a valid CSV file.","uploadInfo":"Upload is finished.","uploadDescription":"It seems that some keys weren't inserted because they didn't meet the required criteria.","uploadCSVInfo":"Only valid ibutton key names will be uploaded.","invalidButtonName":"Validation failed! iButton key name must be exactly 16 hexadecimal characters and should not be a duplicate.","search":"Type to search ibutton key"},"workflows":"Workflows","forceEmployeePin":"Employees require PIN","userPincodeSeverity":"User pincode severity"},"pincodeSeverity":{"OFF":"OFF","LOW":"LOW","MEDIUM":"MEDIUM","HIGH":"HIGH","HIGH90":"HIGH90"},"actions":{"create":"Add organization","read":"Read organization","update":"Update organization","delete":"Delete organization","readsettings":"Read organization settings"},"messages":{"added":"The organization {name} is added","updated":"The organization {name} is updated","selectOneMfaOption":"Select at least one MFA option"},"toolTip":{"dayTotalJob":"Day Total Job","mailSendingTime":"Mail sending time","enabled":"Enabled","remainingUsers":"Remaining Users","subscribers":"Subscribers","affectedUnits":"Affected Units","name":"The name of the organization","userPincodeSeverity":"low: 4 or more digits, max 90 days \n\n medium: between 4 or 6 digits, max 60 days, 3 or more duplicated consecutive digits are not allowed \n\n high: 6 or more digits, max 30 days, 3 or more duplicated / incrementing / decrementing consecutive digits are not allowed","ipWhiteList":"IP addresses that are allowed to communicate with the units (not in use at the moment)","pin":"The pin code of the organization (not in use at the moment)","organizationType":"The type of the organization. Cash in Transit: for organizations that collect money from the units. General: this is used for most organizations. Maintenance: for organizations that do maintenance on the units. Reporting Group: for organizations that need to see reports of organizations in various places in the organization tree","parentOrganization":"The organization above this one in the organization tree. Administrators of the parent organization can see the current organization and its units in the portal. The current organization can inherit the maintenance and CIT organization from its parent. If no parent organization is defined, a CIT and Maintenance organization need to be created for the current organization.","inheritedCIT":"The Cash in Transit organization that is inherited from the parent organization","inheritedMaintenance":"The maintenance organization that is inherited from the parent organization","overrideCIT":"To use a different cash in transit organization than the one that's inherited from the parent organization","overrideMaintenance":"To use a different maintenance organization than the one that's inherited from the parent organization","defaultCIT":"To make this the Cash in Transit organization that will automatically be used by units and sub-organizations","defaultMaintenance":"To make this the maintenance organization that will automatically be used by units and sub-organizations","reportedOrganizations":"The organizations that members of the current organization are allowed to see the reports of","location":"The address of this organizations (this needs to be created before creating an organization)","remark":"Remarks about the organization, that are visible to people editing it","workflows":"The cash in transit procedures that will be used on the units that this organization is the cash in transit organization of","forceEmployeePin":"To make the pincode required for all employees of this organization and sub-organizations","forceMfaForUsers":"Enable this option to force multifactor authentication for all users when they log in to the portal","enableAuthdeviceMfa":"Enable authenticator device and phone apps as user MFA option","enableEmailMfa":"Enable Email as user MFA option","enableSmsMfa":"Enable SMS as user MFA option","enableUserMfaSecretReset":"Allow users to reset theirselves their QR/Secret from user menu if more than one MFA mode is enabled"},"notifications":{"titles":{"notifications":"Notifications","notificationType":"Notification Type"},"types":{"UNIT_OFFLINE":"Unit Offline","CAPACITY_WARNING":"Capacity Warning"},"form":{"enabled":"Enabled","unsubscribed":"Remaining Users","subscribed":"Subscribed"}}},"till":{"titles":{"overview":"Tills","create":"Add a till","update":"Update till","read":"Till details"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Name","organization":"Organization","mixes":"Mixes"},"form":{"name":"Name","organizations":"Organization","units":"Units","maximumAmount":"Maximum Value","mixes":"Mixes"},"actions":{"create":"Add till","read":"Read till","update":"Update till","delete":"Delete till"},"messages":{"added":"The till {name} is added","updated":"The till {name} is updated","disconnected":"These units will be disconnected {units} from the till {till}"}},"cit":{"titles":{"overview":"CIT workflows","create":"Add a CIT workflow","update":"Update CIT workflow","readsettings":"CIT workflow settings"},"breadcrumb":{"title":"Override"},"columns":{"name":"Name","unitType":"Unit Type","version":"Version","advancedSettings":"Advanced settings","stepTabEdit":"Step edit","stepTabNew":"Step create","cancel":"Cancel","create":"Create","update":"Update","steps":"Steps","addNewStep":"New step"},"form":{"name":"Name","unitType":"Unit Type","organization":"Organization","loginType":"Login Type","firstUserRole":"Login user role *","secondUserRole":"Second login user role *","allSteps":"All steps","selectedSteps":"Selected steps","performPrint":"CIT receipt","scanLength":"Barcode length","prefixBarcode":"Barcode prefix","emptyCoinDevice":"Empty coin storage","printOnCassetteDetached":"Receipt on cassette detached","placeholder":"Component","placeholderAction":"Component Action","stepCondition":"Condition","stepSkip":"Conditional next step","loadingPlaceholderText":"Select any unit type first","loadingPlaceholderActionText":"Select a component first","loadingPlaceholderConditionText":"Select a component first","nextStep":"Next step","next":"Next","skipTo":"Step: {number}","options":{"autologin":"Auto login","singlelogin":"Single login","multiplelogin":"Multiple login","locklogin":"Login With Lock Pin"},"translationEn":"Step title","translationNl":"Step title","translationUs":"Step title","translationFr":"Step title","translationPl":"Step title","translationEl":"Step title","translationHu":"Step title","translationSk":"Step title","translationDe":"Step title","translationKey":"Translation key","translationKeyInfo":"Translation key: {translationKey}","confirmDialog":"Confirm dialog","confirmationDialogLabel":"Should show confirmation dialog?","noMatchingCondition":"The selected component doesn't have condition.","noMatchingAction":"The selected component doesn't have actions.","importWorkflow":"Import workflow","sdcGrouping":"Disable SDC grouping"},"toolTip":{"name":"The name of the workflow. The unit type and organization can be included in the name to make it easier to find","unitType":"The unit type of the units that can use this workflow","organization":"The organization that is allowed to edit this workflow","loginType":"The way the user has to log in on the unit, before collecting the money. When auto login is selected, the procedure will start upon opening the door","firstUserRole":"The role of the user that has to log in on the unit before collecting the money","secondUserRole":"The role of the second user that has to log in on the unit before collecting the money","allSteps":"The pages that you can choose for a unit to through during a Cash in Transit procedure to collect money from the machine. The pages can be selected by dragging them from left to right. The pages that start with (legacy) are no longer in use by machines with software version 4 and higher.","selectedSteps":"The pages that the unit will go through during a Cash in Transit procedure to collect money from the machine","performPrint":"Print receipt at the end of the procedure","scanLength":"The length of the barcode on the container that holds the money","prefixBarcode":"The text that the barcode starts with, for example BE. This will appear on a button when the barcode will be entered manually","emptyCoinDevice":"Assume that the coin storage will be emptied during the CIT and subtract the value of the coins from the total value in the machine","printOnCassetteDetached":"After a casette is detached, a receipt with the content of that cassette will be printed","placeholder":"Components of the selected unit type.","placeholderAction":"Actions for the selected component.","stepCondition":"Conditions of the selected component","stepSkip":"Skip to next step","options":{"autologin":"Auto login","singlelogin":"Single login","multiplelogin":"Multiple login","locklogin":"Login With Lock Pin"},"translationEn":"Step title will be shown when English language is selected","translationNl":"Step title will be shown when Dutch language is selected","translationUs":"Step title will be shown when English (US) language is selected","translationFr":"Step title will be shown when French language is selected","translationDe":"Step title will be shown when German language is selected","translationPl":"Step title will be shown when Polish language is selected","translationEl":"Step title will be shown when Greek language is selected","translationHu":"Step title will be shown when Hungarian language is selected","translationSk":"Step title will be shown when Slovenian language is selected","translationKey":"Translation key","confirmDialog":"Confirm dialog","importXmlTooltip":"Only accept a single .xml file","sdcGrouping":"If this is checked, system will create separate 'Clear box item' per placeholder, instead of grouping them into one SDC."},"conditions":{"REJECT_BIN_IS_EMPTY":"Reject bin is empty","COIN_OVERFLOW_NOT_FULL":"Coin overflow is not full"},"actions":{"create":"Add workflow","read":"Read workflow","update":"Update workflow","delete":"Delete workflow","readsettings":"Read workflow settings","export":"Export workflow"},"messages":{"added":"The workflow {name} is added","updated":"The workflow {name} is updated","noPageSelected":"Please select any step","checkStepFormFields":"Verify that all Step fields are correct","stepAdded":"Step added","stepUpdated":"Step updated","noStepSelectedV2":"Please create any step","cantMoveStepUp":"Can't move this Step up","cantMoveStepDown":"Can't move this Step down","invalidXmlFile":"Please upload a valid XML file","xmlUploadSuccess":"Workflow successfully imported","xmlUploadFailed":"Unable to upload workflow"},"dialog":{"title":"Confirm change order","description":"The Step: {stepOrder} can't be moved without breaking Skip to value of Step: {colindantStepOrder}","confirmation":"Change order anyway and remove Skip to value ?"},"workflow":{"Login":"(Legacy) Log in","Remove_left_cassette":"(Legacy) Remove left cassette","Insert_left_cassette":"(Legacy) Insert left cassette","Remove_right_cassette":"(Legacy) Remove right cassette","Insert_right_cassette":"(Legacy) Insert right cassette","Remove_any_cassette":"(Legacy) Remove any cassette","Insert_any_cassette":"(Legacy) Insert any cassette","Remove_cassette":"(Legacy) Remove cassette","Insert_cassette":"(Legacy) Insert cassette","Scan_left_reader_barcode":"(Legacy) Scan left reader barcode","Scan_right_reader_barcode":"(Legacy) Scan right reader barcode","Scan_new_cassette_barcode":"(Legacy) Scan new cassette barcode","Open_the_door_Linux":"(Legacy) Open the door (Linux)","Close_the_door__Linux":"(Legacy) Close the door (Linux)","Lock_the_door":"(Legacy) Lock the door","Sign_out":"(Legacy) Sign out","Unlock_the_door":"(Legacy) Unlock the door","Open_coin_acceptor_dropsafe_Linux":"(Legacy) Open coin acceptor dropsafe (Linux)","Empty_cassette_and_close_the_dropsafe_Linux":"(Legacy) Empty cassette and close the dropsafe (Linux)","Scan_new_left_cassette_barcode":"(Legacy) Scan new left cassette barcode","Scan_new_right_cassette_barcode":"(Legacy) Scan new right cassette barcode","Securing_safe":"(Legacy) Securing safe","CIT_procedure_completed":"(Legacy) CIT procedure completed","Open_the_door_Windows":"(Legacy) Open the door (Windows)","Close_the_door_Windows":"(Legacy) Close the door (Windows)","Open_coin_acceptor_dropsafe_Windows":"(Legacy) Open coin acceptor dropsafe (Windows)","Empty_cassette_and_close_the_dropsafe_Windows":"(Legacy) Empty cassette and close the dropsafe (Windows)","AUTO_UNLOCK_FRONT_DOOR":"Automatically unlock front door","WI_UNLOCK_FRONT_DOOR":"Unlock front door (no PIN)","LP_UNLOCK_FRONT_DOOR":"Unlock front door (LPLOCK)","LP_LOCK_FRONT_DOOR":"Lock front door (LPLOCK)","LP_OPEN_FRONT_DOOR":"Open front door (LPLOCK)","LP_CLOSE_FRONT_DOOR":"Close front door (LPLOCK)","VIM_READ_KEY_CIT":"Present CIT key","V2_UNLOCK_CIT_DOOR":"Unlock door (Linux)","V2_OPEN_CIT_DOOR_LINUX":"Open door (Linux)","V2_REMOVE_SEALPACK_FROM_COIN_STORAGE":"Take out sealpack from coin storage","V2_INSERT_NEW_SEALPACK_TO_COIN_STORAGE":"Insert new sealpack to coin storage","V2_SCAN_STORAGE_BARCODE_WITH_FORMULA_CHECK":"Scan storage barcode with formula check","V2_SCAN_COIN_STORAGE_BARCODE_WITH_FORMULA_CHECK":"Scan coin storage barcode with formula check","V2_SCAN_RIGHT_READER_BARCODE_WITH_FORMULA_CHECK":"Scan right reader barcode with formula check","V2_SCAN_LEFT_READER_BARCODE_WITH_FORMULA_CHECK":"Scan left reader barcode with formula check","V2_REMOVE_STORAGE":"Remove storage","V2_INSERT_STORAGE":"Insert storage","V2_CLOSE_CIT_DOOR_LINUX":"Close door (Linux)","V2_LOCK_CIT_DOOR":"Lock door (Linux)","V2_PROCESSING_CIT":"Secure safe - Lincstation","V2_REMOVE_CASSETTE":"Remove cassette","V2_INSERT_CASSETTE":"Insert cassette","V2_EMPTY_CASSETTE":"Empty cassette","V2_OPEN_CIT_DOOR_WINDOWS":"Open door (Windows)","V2_CLOSE_CIT_DOOR_WINDOWS":"Close door (Windows)","V2_REMOVE_LEFT_CASSETTE":"Remove left cassette","V2_INSERT_LEFT_CASSETTE":"Insert left cassette","V2_REMOVE_RIGHT_CASSETTE":"Remove right cassette","V2_INSERT_RIGHT_CASSETTE":"Insert right cassette","V2_LOGIN":"User Login","V2_CIT_PROCEDURE_COMPLETED":"CIT procedure completed","V2_SDC_CIT_COMPLETE_CHECK":"CIT completed confirmation","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_LINUX":"Open coin side safe (Linux)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_LINUX":"Empty coin side safe (Linux)","V2_SCAN_LEFT_READER_BARCODE":"Scan left barcode","V2_SCAN_RIGHT_READER_BARCODE":"Scan right barcode","V2_SCAN_STORAGE_BARCODE":"Scan storage","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_WINDOWS":"Open coin side safe (Windows)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_WINDOWS":"Empty coin side safe (Windows)","V2_OPEN_CIT_DOOR":"Open CIT door","V2_CLOSE_CIT_DOOR":"Close CIT door","V2_PROCESSING_LINCSTATION_CIT":"Secure safe (Lincstation)","V2_OPEN_THE_DOOR_LINUX":"Open door (Linux)","V2_CLOSE_THE_DOOR_LINUX":"Close door (Linux)","V2_UNLOCK_DOOR":"Unlock door (Linux)","V2_LOCK_DOOR":"Lock door (Linux)","V2_PROCESSING_SAFE_CIT":"Secure safe","V2_PRINT_LEFT_CASSETTE":"Print left cassette","V2_PRINT_RIGHT_CASSETTE":"Print right cassette","V2_PRINT_CIT_TOTAL":"Print CIT totals","V2_SEAL_BAG":"Seal bag","V2_UNLOCK_SIDESAFE_WITH_BO_COIN":"Unlock coin sidesafe","V2_UNLOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Unlock sidesafe","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_COIN":"Empty and lock coin sidesafe","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Empty and lock sidesafe","V2_SEALING_BAG":"Sealing bag","V2_REPLACE_SEAL_BAG":"Replace seal bag","V2_SCAN_COIN_STORAGE_BARCODE":"Scan coin storage","V2_COIN_ROLL_FILL_UP":"Coin roll fill up","V2_EMPTY_COUNTERS":"Empty counters","V2_WAIT_10":"Delay 10 seconds","V2_OPEN_OM61_DOOR":"Open OM61 door","V2_CLOSE_OM61_DOOR":"Close OM61 door","V2_UNLOCK_OM61_BAG_STORAGE":"Unlock OM61 bag storage compartment","V2_TAKE_OM61_STORAGE_BAG":"Take OM61 storage bag","V2_INSERT_NEW_OM61_STORAGE_BAG":"Insert OM61 new storage bag","V2_OPEN_CIT_DOOR_LINCSTATION_V3":"Open door (Lincstation v3)","V2_CLOSE_CIT_LINCSTATION_V3":"Close door (Lincstation v3)","V2_PROCESSING_CIT_LINCSTATION_V3":"Secure safe (Lincstation v3)","V2_UNLOCK_LINCSTATION_V3":"Unlock door (Lincstation v3)","V2_LOCK_LINCSTATION_V3":"Lock door (Lincstation v3)","V2_INSTALL_OM61_STORAGE_BAG":"Install OM61 storage bag","V2_UNLOCK_FRONT_DOOR":"Unlock front door","V2_UNLOCK_FRONT_DOOR_SPT":"Unlock front door (SPT)","V2_OPEN_FRONT_DOOR":"Open front door","V2_CLOSE_FRONT_DOOR":"Close front door","V2_LOCK_FRONT_DOOR":"Lock front door","V2_LOCK_FRONT_DOOR_SPT":"Lock front door (SPT)","V2_EMPTY_ESCROW":"Empty escrow","V2_SKIP_EMPTY_ESCROW_SAFEBAG_FULL":"Skip emptying escrow when sealbag is full","V2_PAUSE_CIT":"Pause CIT","V2_REMOVE_REJECT_BIN":"Remove reject bin","V2_CONFIRM_EMPTY_REJECT_BIN":"Confirm empty reject bin","V2_INSERT_REJECT_BIN":"Insert reject bin","V2_FILL_UP_COINS":"Fill up coin recycler","V2_OPEN_COIN_OVERFLOW_DOOR_SPT":"Open coin overflow door (SPT)","V2_EMPTY_COINS_AND_CLOSE_COIN_OVERFLOW_DOOR_SPT":"Empty coins and close coin overflow door (SPT)","V2_SECURE_SAFE":"Secure safe","V2_REMOVE_PULOON_CASSETTE_1":"Remove 1st present dispenser cassette","V2_REMOVE_PULOON_CASSETTE_2":"Remove 2nd present dispenser cassette","V2_INSERT_PULOON_CASSETTE_1":"Insert 1st new dispenser cassette","V2_INSERT_PULOON_CASSETTE_2":"Insert 2nd new dispenser cassette","V2_UNLOCK_CIT_DOOR_2":"Unlock CIT door 2","V2_LOCK_CIT_DOOR_2":"Lock CIT door 2","V2_OPEN_CIT_DOOR_LINUX_2":"Open safe door (Linux) 2","V2_CLOSE_CIT_DOOR_LINUX_2":"Close safe door (Linux) 2","V2_OPEN_AND_EMPTY_MANUAL_STORAGE":"Empty the manual storage","V2_CLOSE_MANUAL_STORAGE":"Close the storage vault","V2_UNLOCK_FRONT_DOOR_2":"Unlock front door 2","V2_UNLOCK_FRONT_DOOR_SPT_2":"Unlock front door 2 (SPT)","V2_OPEN_FRONT_DOOR_2":"Open front door 2","V2_CLOSE_FRONT_DOOR_2":"Close front door 2","V2_LOCK_FRONT_DOOR_2":"Lock front door 2","V2_LOCK_FRONT_DOOR_SPT_2":"Lock front door 2 (SPT)","V2_SECURE_CIT_DOOR":"Secure CIT door (SPT)","V2_SECURE_CIT_DOOR_2":"Secure CIT door 2 (SPT)","V2_SECURE_FRONT_DOOR":"Secure front door (SPT)","V2_SECURE_FRONT_DOOR_2":"Secure front door 2 (SPT)","dynamic":{"LOCK_OPEN":"Open lock","LOCK_CLOSE":"Close lock","LOCK_OPEN_WITH_PIN":"Open lock with pin","DOOR_OPEN":"Open door","DOOR_CLOSE":"Close door","DOOR_SECURE":"Secure door","CIT_COMPLETED":"CIT completed","CIT_PAUSE":"CIT paused","CIT_DIALOG":"CIT dialog","CIT_IBUTTON_LOGIN":"iButton login","MANUAL_DEPOSIT_EMPTY":"Empty manual deposit","COIN_OVERFLOW_EMPTY":"Empty coin overflow","COIN_FILL_UP":"Fill up coin","COIN_FILL_UP_SPLIT_START":"Start split fill up","COIN_FILL_UP_SPLIT_END":"Stop split fill up","COIN_EMPTY_OVERFLOW_STORAGE":"Empty coin overflow storage","STORAGE_REMOVE_CASSETTE":"Remove storage cassette","STORAGE_ATTACH_CASSETTE":"Attach storage cassette","STORAGE_PULOON_REMOVE_DISPENSER_1":"Remove storage puloon dispenser 1","STORAGE_PULOON_ATTACH_DISPENSER_1":"Attach storage puloon dispenser 1","STORAGE_PULOON_REMOVE_DISPENSER_2":"Remove storage puloon dispenser 2","STORAGE_PULOON_ATTACH_DISPENSER_2":"Attach storage puloon dispenser 2","STORAGE_PULOON_REMOVE_DISPENSER_3":"Remove storage puloon dispenser 3","STORAGE_PULOON_ATTACH_DISPENSER_3":"Attach storage puloon dispenser 3","STORAGE_PULOON_REMOVE_DISPENSER_4":"Remove storage puloon dispenser 4","STORAGE_PULOON_ATTACH_DISPENSER_4":"Attach storage puloon dispenser 4","STORAGE_PULOON_REMOVE_REJECT_BIN":"Remove storage puloon reject bin","STORAGE_PULOON_ATTACH_REJECT_BIN":"Attach storage puloon reject bin","COIN_REMOVE_AND_EMPTY_OVERFLOW_STORAGE":"Remove and empty coin bucket","COIN_INSERT_OVERFLOW_STORAGE":"Insert coin bucket","CENCON_LOCK_OPEN":"Open Cencon lock","CENCON_LOCK_CLOSE":"Close Cencon lock","TRAY_OPEN":"Open hitachi door","TRAY_CLOSE":"Close hitachi door","STORAGE_ONE_ATTACHED":"Attach Puloon storage cassette","STORAGE_ONE_REMOVED":"Remove Puloon storage cassette","HITACHI_STORAGE_ONE_ATTACHED":"Attach Hitachi storage cassette 1","HITACHI_STORAGE_ONE_REMOVED":"Remove Hitachi storage cassette 1","HITACHI_STORAGE_TWO_ATTACHED":"Attach Hitachi storage cassette 2","HITACHI_STORAGE_TWO_REMOVED":"Remove Hitachi storage cassette 2","HITACHI_STORAGE_THREE_ATTACHED":"Attach Hitachi storage cassette 3","HITACHI_STORAGE_THREE_REMOVED":"Remove Hitachi storage cassette 3","HITACHI_STORAGE_FOUR_ATTACHED":"Attach Hitachi storage cassette 4","HITACHI_STORAGE_FOUR_REMOVED":"Remove Hitachi storage cassette 4","HITACHI_STORAGE_FIVE_ATTACHED":"Attach Hitachi storage cassette 5","HITACHI_STORAGE_FIVE_REMOVED":"Remove Hitachi storage cassette 5","HITACHI_STORAGE_ONE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 1","HITACHI_STORAGE_ONE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 1","HITACHI_STORAGE_TWO_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 2","HITACHI_STORAGE_TWO_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 2","HITACHI_STORAGE_THREE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 3","HITACHI_STORAGE_THREE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 3","HITACHI_STORAGE_FOUR_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 4","HITACHI_STORAGE_FOUR_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 4","HITACHI_STORAGE_FIVE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 5","HITACHI_STORAGE_FIVE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 5","HITACHI_STORAGE_SIX_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 6","HITACHI_STORAGE_SIX_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 6","HITACHI_REJECT_BOX_CLOSE":"Close reject box","HITACHI_REJECT_BOX_OPEN":"Open reject box and empty its contents","ENTER_BAG_NUMBER":"Enter bag number"}}},"mix":{"titles":{"overview":"Mixes","create":"Add a mix","update":"Update mix"},"breadcrumb":{"title":"Overview"},"form":{"mixName":"Mix name","totalAmount":"Total amount","organization":"Organization","denominations":"Denominations","coins":"Coins","bills":"Bills","currency":"Currency","eur":"EURO","usd":"USD","gbp":"GBP"},"columns":{"name":"Mix name","totalValue":"Total value","details":"Details"},"read":{"mixDetails":"Mix details"},"actions":{"create":"Add mix","update":"Update mix","delete":"Delete mix","read":"Read mix"}},"notification":{"titles":{"read":"Notification Details"},"read":"Notification Details"},"unitRoles":{"titles":{"overview":"Unit roles","create":"Add a unit role","update":"Update unit role"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Unit role name","organization":"Organization"},"actions":{"create":"Add unit role","update":"Update unit role","delete":"Delete unit role"},"form":{"name":"Unit role name","organization":"Organization","transactionCashOutLimit":"Transaction cash out limit","dailyCashOutLimit":"Daily cash out limit","permissions":"Permissions"},"messages":{"added":"The unit role {name} is added","updated":"The unit role {name} is updated"}},"report":{"buttons":{"createReport":"CREATE REPORT","generating":"Generating..."},"titles":{"overview":"Report","create":"Add a report","update":"Update report"},"breadcrumb":{"title":"report"},"form":{"orgUuid":"Organization","unitUuid":"Unit","type":"Type","startDate":"From","endDate":"To","types":{"getReptileCampaignsAndTransactionsByDate":"Transactions and Clearboxes","getReptileCampaignsAndTransactionsMoneyInOutCounterByDate":"Transactions and Clearboxes with Money in/out Counter","getReptileTransactionsByDate":"Transactions","getReptileRecyclerOverallReport":"Recycler Overall Report","getCurrentlyOfflineUnits":"Currently Offline Units (.csv)","getManualTransactionsByDate":"[Deprecated] Dropsafe","getReptileManualTransactionsByDate":"Dropsafe - New","getReptileReportForClosedCampaignsByUnitAndDate":"Clearboxes","getReptileClearboxDenomination":"[Deprecated] Clearboxes Denomination","getReptileClearboxDenominationV2":"Clearboxes Denomination","getReptileEndOfDayInfoByDate":"End of Day Unit Total","getReptileLincstationEndOfDayInfoByDate":"Lincstation End of Day Unit Total","getEndOfDayClientsByDate":"[Deprecated] End of Day Clients","getReptileEndOfDayClientsByDate":"End of Day Clients - New","getEventsByDate":"Events by Date","getReptileEventsByDate":"Events by Date - New","getReptileReportForDenominationPerUser":"Denominations per User","getReptileReportForDenominationWithPin":"Denominations with Pin","getReptileSalesByDate":"Sales - New","getInternalTransactionsByDate":"[Deprecated] Internal Transactions","getReptileInternalTransactionsByDate":"Internal Transactions - New","getReptileAdvancedManualDeposit":"Advanced Manual Deposits","getReptileRecyclerReport":"Lincstation Overall Report","getReptileTransactionsWithReference":"Transactions with Reference Number","getReptileUserActivityPdf":"User activity transactions (.pdf)","getReptileUserActivityCsv":"User activity transactions (.csv)","getTransactionsWithReference":"[Deprecated] Transactions with Reference Number","getSalesByDate":"[Deprecated] Sales","getCampaignsWithBarcodes":"[Deprecated] Clearboxes with Sealnumbers","getReptileCashCoinEndOfDayInfoByDate":"End of Day Cash/Coin","getReptileUnitInventory":"Unit Inventory (.pdf)","getReptileCampaignsAndTransactionsByDateWithSource":"Smartsafes transactions and clearboxes","getReptileEndOfDaySmartSafes":"Smartsafes End Of Day (.pdf)","getReptileEndOfDaySmartSafesXlsx":"Smartsafes End Of Day (.xlsx)","getReptileEndOfDayRecyclerXlsx":"Recycler End Of Day (.xlsx)","getReptileCampaignSmartSafesPdf":"Smartsafes Campaign (.pdf)","getReptileCampaignSmartSafesXlsx":"Smartsafes Campaign (.xlsx)","getReptileTransactionSmartSafesPdf":"Smartsafes Transaction (.pdf)","getReptileTransactionSmartSafesXlsx":"Smartsafes Transaction (.xlsx)","getReptileTransactionSmartSafesDetailedPdf":"Smartsafes Transaction Detailed (.pdf)","getReptileTransactionSmartSafesDetailedXlsx":"Smartsafes Transaction Detailed (.xlsx)","getOrganizationAssetsXlsx":"Smartsafes Asset Management (.xlsx)","getOrganizationAssetsPdf":"Smartsafes Asset Management (.pdf)","getReptileEventSmartSafesXlsx":"Smartsafes Event (.xlsx)","getReptileEventSmartSafesPdf":"Smartsafes Event (.pdf)"}},"messages":{"success":"The report was successfully retrieved. The file should automatically start downloading...","failed":"The report could not be generated. Please try again later","reptileDateLimitExceeded":"The report could not be generated. The specified date limit has been exceeded. Please adjust your date range and try again.","reptileGenericBadRequest":"The report could not be generated due to a bad request. Please review your input parameters and try again later.","cannotOutputToCsvFile":"The report could not be generated. Please try again later and/or with different parameters.","errorOccurred":"The report could not be generated. Unknown error occurred.","cannotCreateReport":"The report could not be generated due to an internal server error."},"dialog":{"title":"The report was successfully retrieved.","download":"Click here to download the report","close":"Close"}},"transaction":{"read":"Transaction Detail"},"adminsettings":{"titles":{"overview":"Currency maintenance"},"breadcrumb":{"title":"Overview"},"messages":{"updated":"Currency and domination updated","error":"Something went wrong, currency and denominations not updated"},"form":{"currency":"Currency","iso1":"ISO1","iso2":"ISO2","iso3":"ISO3","symbol":"Symbol","symbolCode":"Symbol code","defaultValue":"Default value","enabled":"Enabled","denomination":{"value":"Value","coins":"Coins","bills":"Bills","enabled":"Enabled","remove":"Remove"}}}},"server_messages":{"SELECT_A_UNIT_FOR_THE_EMPLOYEE":"Select a unit for the employee!","accessNotAllowed":"Access not allowed.","authorizationFailed":"Authorization failed.","campaignNotFound":"Campaign not found!","cityCannotBeEmpty":"City cannot be empty!","componentNotFound":"Component not found!","countryCannotBeEmpty":"Country cannot be empty!","countryNotFound":"Country not found!","credentialsCannotBeEmpty":"Credentials cannot be empty","currencyNotFound":"Currency not found!","duplicateItemFound":"Duplicate item found!","duplicateSerialNumberFound":"Serial Number already exists!","duplicateSafeIdFound":"Safe ID already exists!","errorOccurred":"An error occurred and logged.","validationError":"Validation failed.","ILLEGAL_ARGUMENT_MIX_DENOMINATIONS":"Please select currency.","unitRoleInUseByUser":"This unit cannot be deleted because it is currently assigned to a user.","ILLEGAL_ARGUMENT":"Wrong input","ILLEGAL_ARGUMENT_ADDRESS_TYPE":"Something went wrong with the address","ILLEGAL_ARGUMENT_ADDRESSLINE1":"Please change address line one","ILLEGAL_ARGUMENT_ADDRESSLINE2":"Please change address line two","ILLEGAL_ARGUMENT_BANK_ACCOUNT":"Please change the bank account","ILLEGAL_ARGUMENT_CHILD_ORGANIZATION":"Please change the child organization","ILLEGAL_ARGUMENT_CIT":"Something went wrong with the CIT information","ILLEGAL_ARGUMENT_CITY":"Please change the city","ILLEGAL_ARGUMENT_CLIENT_ORGANIZATION":"Please change the client organization","ILLEGAL_ARGUMENT_COUNTRY":"Please change the country","ILLEGAL_ARGUMENT_CURRENCY":"Please change the currency","ILLEGAL_ARGUMENT_DATE":"Please change the date","ILLEGAL_ARGUMENT_DESCRIPTION":"Please change description","ILLEGAL_ARGUMENT_FIRST_NAME":"Please change the first name","ILLEGAL_ARGUMENT_GENDER":"Something went wrong with the gender","ILLEGAL_ARGUMENT_ID":"Please change the ID","ILLEGAL_ARGUMENT_LAST_NAME":"Please change the last name","ILLEGAL_ARGUMENT_LEGAL_FORM":"Please change the legal form","ILLEGAL_ARGUMENT_LOCATION":"Please change the location","ILLEGAL_ARGUMENT_LOCATION_UUID":"Cannot find the location","ILLEGAL_ARGUMENT_MACHINE_TYPE":"Please change the machine type","ILLEGAL_ARGUMENT_MAIL":"Please change the email address","ILLEGAL_ARGUMENT_MAINTENANCE":"Something went wrong with the Maintenance information","ILLEGAL_ARGUMENT_NAME":"Please change the name","ILLEGAL_ARGUMENT_ORGANIZATION":"Please change the organization","ILLEGAL_ARGUMENT_ORGANIZATION_TYPE":"Please change the organization type","ILLEGAL_ARGUMENT_ORGANIZATION_UNIT_TYPE":"Something went wrong with the combination of organization and unit type","ILLEGAL_ARGUMENT_ORGANIZATION_UUID":"Cannot find the organization","ILLEGAL_ARGUMENT_OWNER_ORGANIZATION":"Please change the owner organization","ILLEGAL_ARGUMENT_PAGE_NUMBER":"Something went wrong with the page number","ILLEGAL_ARGUMENT_PAGE_SIZE":"Something went wrong with the page size","ILLEGAL_ARGUMENT_PARENT_ORGANIZATION":"Please change the parent organization","ILLEGAL_ARGUMENT_PASSWORD":"Please change the password","ILLEGAL_ARGUMENT_PERSON":"Something went wrong with user information","ILLEGAL_ARGUMENT_PHONE_NUMBER":"Please change the phone number","ILLEGAL_ARGUMENT_PIN":"Please change the pin","ILLEGAL_ARGUMENT_REPORTED_ORGANIZATIONS":"Please change the reported organizations","ILLEGAL_ARGUMENT_ROLES":"Please change the roles","ILLEGAL_ARGUMENT_SDC":"Something went wrong with the clearbox","ILLEGAL_ARGUMENT_SERIAL":"Please change the serial number","ILLEGAL_ARGUMENT_TOKEN":"Something is wrong with the log in information","ILLEGAL_ARGUMENT_UNIT":"Please change the unit","ILLEGAL_ARGUMENT_UNIT_TYPE":"Please change the unit type","ILLEGAL_ARGUMENT_UNIT_UUID":"Cannot find the unit","ILLEGAL_ARGUMENT_USER":"Please change the user","ILLEGAL_ARGUMENT_UUID":"Unable to retrieve the information","INVALID_CREDENTIALS":"Invalid credentials","INVALID_PATH":"Invalid path","invalidData":"Invalid data","legalFormNotFound":"Legal Form not found!","locationInUse":"Location in use","locationNameCannotBeEmpty":"Location name cannot be empty!","locationNotFound":"Location not found!","locationUpdateDataIsInvalid":"Location update data is invalid!","LOCKED":"Locked","LOGOUT":"Logged out!","NO_RESULT":"No result","organizationInUse":"Organization in use","organizationListFetched":"Organization list fetched.","organizationNotFound":"Organization not found.","organizationTypeNotFound":"Organization Type not found.","passwordIsInvalid":"Password is invalid!","phoneNumberLengthIsIncorrect":"Phone number length is incorrect","pinIsEmpty":"PIN is mandatory","pinNotNumeric":"PIN must contain only digits 0-9","oldOrNewPinIsEmpty":"Both old and new PINs are mandatory","oldPinNotMatch":"Wrong old PIN","pinNotChanged":"New PIN cannot be the same as old PIN","roleNotFound":"Role not found.","sessionTimeout":"Session timeout","settingsNotFound":"Settings not found","SUCCESS":"Success","SYSTEM_FAIL":"System failed!","transactionNotFound":"Transaction not found","UNABLE_TO_STORE_INFO":"The data could not be saved","UNAUTHORIZED":"Unauthorized access","unitNotFound":"Unit not found.","unitTypeNotFound":"Unit type not found.","unitTypeListFetched":"Unit type list fetched.","userAlreadyExists":"User already exists","userIsLocked":"User is locked.","userNotFound":"User not found","workflowInUseByOtherOrg":"Workflow is in use by an organization, please unlink the workflow from the Organization first","workflowNotFound":"Workflow not found!","invalidFormatException":"Invalid data format, please check data in JSON structure","unrecognizedPropertyException":"Please check properties in JSON structure","jsonParseException":"Couldn't parse JSON, please check structure","jsonMappingException":"Couldn't map JSON, please check structure","iOException":"Couldn't parse JSON, please check structure","minimumGreaterThanOptimum":"Minimum amount greater than optimum","maximumLessThanOptimum":"Maximum amount less than optimum","ILLEGAL_ARGUMENT_MIX_UUID":"Cannot find mixes","ILLEGAL_ARGUMENT_MAX_AMOUNT":"Please change maximum amount","TILL_IS_BEING_USED_BY_USER":"Till is being used by user","TILL_IS_BEING_USED_BY_UNIT":"Till is being used by unit","secretIsEmpty":"Empty secret found","secretAlreadyExists":"Invalid secret generated. Please generate again","MIN_FOUR_DIGITS":"PIN must be at least 4 digits in length","MIN_SIX_DIGITS":"PIN must be at least 6 digits in length","MAX_SIX_DIGITS":"PIN must be at most 6 digits in length","NO_DUPLICATE_DIGITS":"PIN must not have repeated digits","NO_INCREMENTING_DIGITS":"PIN must not be in incrementing order","NO_DECREMENTING_DIGITS":"PIN must not be in decrementing order","MAX_NINETY_DAYS":"Pin expired after 90 days, Please change pin","MAX_SIXTY_DAYS":"Pin expired after 60 days, Please change pin","MAX_THIRTY_DAYS":"Pin expired after 30 days, Please change pin","PIN_LENGTH_NOT_IN_4_TO_6":"Pin length between 4 and 6 digits","ILLEGAL_ARGUMENT_USERNAME_NULL":"External Username must not be null","ILLEGAL_ARGUMENT_EXTERNAL_USERNAME_IS_NULL":"External Username must not be null","ILLEGAL_ARGUMENT_EXTERNAL_PASSWORD_IS_NULL":"External password must not be null","ILLEGAL_ARGUMENT_EXTERNAL_HS600_PASSWORD_INVALID":"External HS600 password is invalid. Only numeric values allowed","ILLEGAL_ARGUMENT_ROLES_ONE_EXTERNAL_HS600_ROLE_ALLOWED":"Only one external HS600 role is allowed","maxDispensableGreatherThenAllowed":"Max dispensable is greather then allowed","emailNotUnique":"The email address is already in use","NON_UNIQUE_USERNAME":"Duplicate user accounts found, please contact your administrator","departmentAlreadyExists":"Department name has already been taken. Please choose another name","locationAlreadyExists":"Location name has already been taken. Please choose another name","MFA_REQUIRED":"Multi factor authentication required","sdcWorkflowNameAlreadyExists":"CIT workflow with that name already exists","invalidParentOrganizationType":"The parent organization must either be of type 'GENERAL' or match the type of the organization","maxAndOptimumRequiredException":"Please enter the value for the Optimum and Max column before updating the page","invalidFileName":"Invalid file name","maxFileNameLength":"File name length is greater than maximum (54)","invalidFileContent":"File content is not in valid Base64 scheme","DEFAULT_CIT_ORGANIZATION":"Organization is default CIT and cannot be deleted [{reason}]","DEFAULT_MAINTENANCE_ORGANIZATION":"Organization is default maintenance and cannot be deleted [{reason}]","UNIT_SERIAL_NUMBERS_IN_USE":"Cannot delete organization since it is used as owner org for units [{reason}]","OVERRIDE_CIT_ORG_IN_USE":"Cannot delete organization since it is overrideCitOrganization on other organizations [{reason}]","OVERRIDE_CIT_ORG_UNIT_IN_USE":"Cannot delete organization since it is used as overrideCit org for units [{reason}]","OVERRIDE_MAINTENANCE_ORG_UNIT_IN_USE":"Cannot delete organization since it is used as overrideMaintenance org for units [{reason}]","ORG_IN_USE_BY_USERS":"Cannot delete organization since active users are assigned to it [{reason}]","ORG_IN_USE_BY_JOBS":"Cannot delete organization since some jobs are configured for it [{reason}]","ORG_IN_USE_BY_DEPARTMENTS":"Cannot delete organization since departments are assigned to it [{reason}]","ORG_IS_PARENT_TO_OTHER_ORGS":"Cannot delete organization since it is parent of other organizations [{reason}]","ORG_IS_ORG_MAINTENANCE_TO_OTHER_ORGS":"Cannot delete organization since it is organizationMaintenance of other organizations [{reason}]","ORG_IS_USED_IN_TILLS":"Cannot delete organization since it is used in tills [{reason}]","ORG_IS_USED_IN_MIXES":"Cannot delete organization since it is used in mixes [{reason}]","ORG_IS_USED_IN_RFID_CODES":"Cannot delete organization since it is used in rfid codes [{reason}]","ORG_IS_USED_IN_SDC_WORKFLOWS":"Cannot delete organization since it is used in CIT workflows [{reason}]","ORG_IS_USED_IN_ORG_NOTIFICATIONS":"Cannot delete organization since it is used in notifications for users [{reason}]","ORG_IS_REPORTED_ORG_TO_OTHER_ORGS":"Cannot delete organization since it is reported org for other organizations [{reason}]","ORG_IS_REPORTER_ORG_TO_OTHER_ORGS":"Cannot delete organization since it is reporter org for the following organizations [{reason}]","ORG_IS_SET_ON_LOCATIONS":"Cannot delete organization since it has locations defined [{reason}]","workflowInUseByUnits":"Workflow in use by units [{reason}]. Make sure no units are using this workflow before deleting it.","acceptanceBoxesMustComeBeforeRecyclerCassettes":"Acceptance boxes must come before recycler cassettes","firstCassetteMustBeAcceptanceBox":"First cassette must be an acceptance box","storageMustComeBeforeRecyclerCassettes":"Acceptance boxes must come before recycler cassettes","firstCassetteMustBeStorage":"First cassette must be an acceptance box"},"TRANSACTION":{"TYPE":{"NORMAL":"Normal","MANUAL":"Manual","INTERNAL":"Internal","FILL_UP":"Fill up","CHANGE":"Change"},"SOURCE_ACTION":{"UNKNOWN":"Unknown source action","SHIFT_START":"Start of shift","SHIFT_END":"End of shift","DEPOSIT":"Deposit","DISPENSE":"Dispense","MANUAL_DEPOSIT":"Manual deposit","EMPTY":"Empty","FLOAT":"Float","FILL_UP":"Fill up","SALES_IN":"Sales in (payment)","SALES_OUT":"Sales out (payout)","CHANGE":"Change","NOTE_VERIFICATION":"Note verification","EMPTY_ESCROW":"Empty escrow","ADD_RESERVE_CHANGE":"Add reserve change","REMOVE_RESERVE_CHANGE":"Remove reserve change","AUDIT_RESERVE_CHANGE":"Audit reserve change","TUBE_LOAD":"Tube load","TUBE_UNLOAD":"Tube unload","TUBE_DISPENSE":"Tube dispense","TUBE_BUY":"Tube buy","DELIVER_RESERVE_CHANGE":"Deliver reserve change","EMPTY_COIN_OVERFLOW":"Empty coin overflow","EMPTY_REJECT_BOX":"Empty reject box","MANUAL_CORRECTION":"Manual correction","INTERNAL_REJECT":"Internal reject","CHANGE_IN":"Change in","CHANGE_OUT":"Change out"}},"placeholder_names":{"cit":{"LR":"Left note deposit","RR":"Right note deposit","CA":"Coin overflow","BA":"Note deposit","R3":"Middle note deposit","B1":"Note deposit","RC":"Note deposit","CC":"Coin overflow"},"LR":"Left bill reader","RR":"Right bill reader","PR":"Printer","CA":"Coin acceptor","BO":"Breakout board","DS":"Door sensor","PU":"Bill dispenser","SC":"Twin coin recycler","SS":"Side sensor","SD":"Side driver sensor","WI":"Lincsafe smart lock","LL":"Lower lock","HO":"Coin hopper","BA":"Bill acceptor","DR":"Door reader","R3":"Middle bill reader","ST":"Top sensor","TD":"Top driver sensor","SB":"Bottom driver sensor","BD":"Bottom driver sensor","B1":"Bill reader","H1":"Hopper one","H2":"Hopper two","UL":"Upper lock","BP":"Beeper","RC":"Bill recycler","CC":"Coin recycler","DT":"Top door","DM":"Middle door","DB":"Bottom door","CD":"CIT door","MD":"Serial maintenance door sensor","RF":"RFID reader","SL":"Sealer","UNIT":"Unit","null":"","DRAWER":"Drawer","SIDE_SAFE":"Side safe","COIN_DROP_SAFE":"Coin drop safe","COIN_ROLL":"Coin roll","PIN_TERMINAL":"PIN terminal","WI_MAINTENANCE":"Lincsafe maintenance door smart lock","om61":"OM61","DOOR_BOTTOM":"Bottom door","DOOR_MIDDLE":"Middle door","DOOR_TOP":"Top door","EXB":"Extension board","MLOCK_TOP":"Top m-lock","SOLENOID_BOTTOM":"Bottom solenoid","SWITCH_COIN_TUBE":"Coin chute","WI_MIDDLE":"Middle wittkopp lock","WI_UPPER":"Upper door lock","WI_LOWER":"Lower door lock","COIN_OVERFLOW":"Coin overflow","DOOR_LOWER":"Lower door","DOOR_UPPER":"Upper door","NETWORK":"Network","STORAGE_INVENTORY":"Storage inventory","UNKONWN":"Unkown","DOOR_FRONT":"Door front sensor","DOOR_LEFT":"Coin overflow bucket","DOOR_HATCH":"Door top hatch sensor","DOOR_RIGHT":"Door right sensor","SOLENOID":"Solenoid","VIM":"Vault Interface Module","LOCK_FRONT":"Front door lock","LPLOCK":"Front door lock","LPLOCK_STORAGE":"LP lock storage","TOP_DOOR":"Top door","TOP_LOCK":"Top lock","SAFE_LOCK_INHIBIT":"Safe lock inhibit","IBUTTON":"iButton","MLOCK":"MLock","BOTTOM_LOCK":"Bottom lock","BO_1":"Bo 1","BO_2":"Bo 2","BUTTON_A":"Button A","BUTTON_B":"Button B","BUTTON_C":"Button C","BUTTON_D":"Button D","DOOR_TOP_LEFT":"Door top left","DOOR_TOP_RIGHT":"Door top right","EBM":"EBM","EBS":"EBS","HOPPERS":"Hoppers","HSCD":"HSCD","TOP_LEFT_LOCK":"Top left lock","SOLENOID_IDLE":"SOLENOID_IDLE","Amalthea":"Amalthea","HATCH_SECURE":"HATCH_SECURE","NOTE_HATCH_LOCK_OPEN":"Note hatch lock open","EBR-N":"EBR-N","WI_TOP":"WI top","CIT_COMPLETED":"Unit","HITACHI_LOCK":"Cencon lock","XR":"Hitachi","hopper_1":"Hopper 1","hopper_2":"Hopper 2","hopper_3":"Hopper 3","hopper_4":"Hopper 4","hopper_5":"Hopper 5","hopper_6":"Hopper 6","hopper_7":"Hopper 7","hopper_8":"Hopper 8","hopper_9":"Hopper 9","hopper_10":"Hopper 10","cctalk_bus_one":"Coin device","LOCKS_SECURE":"Locks secure","DOORS_CLOSED":"Doors closed","MACHINE_SECURE":"Machine secured","SAFE_DOOR":"Safe door","DOOR_NOTE":"Door note","RECYCLER_FULL":"Recycler is full","RECYCLER_INVENTORY":"Recycler inventory","NOT_OPERATIONAL":"Not Operational","CAS1":"Left bill reader","CAS2":"Right bill reader","HATCH_LOCK_NOTE":"Note hatch","HOPPER_DRAWER_LOCK_COIN":"Hopper lock","SERVICE_HATCH_LOCK_COIN":"Coin service hatch lock","SAFE_LOCK_SECURE":"Safe door lock","MANUAL_STORAGE":"Manual storage","JACK_STATUS":"Headphone jack status"},"compartment_names":{"RECYCLER":"RECYCLER","STORAGE":"STORAGE","MANUAL_STORAGE":"Manual storage","ESCROW":"ESCROW","HOPPERS":"HOPPERS","REJECT":"REJECT"},"notifications":{"ACCEPTING":"Cash device(s) is/are accepting","BOTTOM_DOOR_OPEN":"Coin acceptor overflow door is open!","BOTTOM_SIDE_DOOR_OPEN":"Sidesafe bottom door is open","CALIBRATING":"Cash device is being calibrated","CARTRIDGE_DETACHED":"Cartridge has been detached","CHEATED":"Cheat attempt","CIT_DOOR_OPEN":"Cit door opened","COIN_DRAWER_OPENED":"Coin drawer opened","COIN_DROP_SAFE_OPENED":"Coin side safe is opened","DEVICE_CAN_NOT_PAYOUT":"Inventory not enough to payout","DOOR_OPEN":"Door is open","DOWNLOADING":"Downloading firmware","DRAWER_OPENED":"Drawer opened","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Entrance is not empty","errorOccurred":"Internal server error","EXCEEDS_PAYOUT_LIMIT":"Value to payout exceeds payout limit.","EXTENSION_STALL":"Stalled","FAILED":"Failure has been detected","FEED_FAILURE":"Feed failed","FLOAT_NOT_SET":"Float value has not been set on portal, please first set value on portal!","ILLEGAL_ARGUMENT":"Illegal argument","INSURABLE_VALUE_REACHED":"Insurable value reached, please empty the machine!","CASSETTE_LIMIT_REACHED":"Cassette limit reached","INVALID_CREDENTIALS":"Invalid credentials!","INVENTORY_LOWER_THAN_FLOAT":"Inventory is already lower than float","INVENTORY_NOT_SUFFICIENT":"Inventory is not sufficient, please fill up the machine!","INVENTORY_OVER_MAX":"Inventory level is higher than maximum, please float down the machine!","INVENTORY_SETTINGS_NULL":"Can not find inventory settings, please contact the manager!","INVENTORY_UNDER_MIN":"Inventory level is lower than minimum, please fill up the machine!","INVENTORY_UNDER_LOW":"Inventory level is under low, please fill up the machine!","JAMMED":"Device is jammed","LAST_TRANSACTION_FAILED":"Last payment was failed, please contact the manager!","LOCK_NOT_SECURE":"Smart (wittkopp) lock is not secure!","MACHINE_BUSY":"The machine is already busy, please wait to complete running transaction","MACHINE_NOT_OPERATIONAL":"The machine is not operational, please check notifications","MAINTENANCE_DOOR_OPEN":"Maintenance door open","MIDDLE_DOOR_OPEN":"CIT door is open!","NO_ACCESS":"Personnel does not have access<br/>to the value in the safe","NOT_CONNECTED":"Device is not connected","NOT_OPERATIONAL":"Not operational","NOT_RECYCLED_MATERIAL":"Not a recycled material","NOT_SECURE":"The machine is not secure, please contact the manager!","ORGANIZATION_NOT_FOUND":"Organization could not be found","OVERRIDDEN":"The lock is overridden","PAPER_EMPTY":"Paper is empty","PAPER_LOW":"Paper is low","PAUSE":"Pause","PAYOUT_FAILED":"Could not pay out value","PAYOUT_LIMIT_NOT_FOUND":"Payout limit has not been defined yet!","PIN_EMPTY":"Pin can not be empty!","POWER_UP":"Power up","RECYCLER_ALMOST_EMPTY":"Recycler is almost empty","RECYCLER_ALMOST_FULL":"Recycler is almost full","RECYCLER_EMPTY":"Recycler is empty","RECYCLER_FULL":"Recycler is full","REJECT_NOT_EMPTY":"Reject is not empty","SIDE_DOOR_ONE_OPEN":"Sidesafe(1) door is open","SIDE_DOOR_OPEN":"Sidesafe door is open","SIDE_SAFE_OPENED":"Side safe opened","STACKER_FULL":"Stacker is full","STALLED":"Stalled","STORAGE_ALMOST_FULL":"Cassette is almost full, please empty the machine","STORAGE_DETACHED":"Cassette is detached","STORAGE_FULL":"Cassette is full, please empty the machine","TOP_DOOR_OPEN":"Maintenance door is open!","TOP_SIDE_DOOR_OPEN":"Sidesafe top door is open","USER_BLOCKED":"User has been blocked","USER_NOT_FOUND":"User could not be found","WORKFLOW_NOT_FOUND":"Cit workflow could not be found, please check portal","ZERO_AMOUNT":"Amount should be bigger than 0","PAYMENT_NOT_POSSIBLE_WITH_THIS_AMOUNT":"Payment not possible with this amount","INVALID_CONFIGURATION":"Invalid recycler configuration","LAST_NOTE_HIGHEST_RECYCLED_VALUE":"Only 1 high value note in succession allowed","MAX_AMOUNT_REACHED":"Recycler for this denomination is full","NON_RECYCLED_DENOMINATION":"Denomination is not recycled","THREE_HIGH_VALUE_NOTES_IN_SUCCESSION":"No more than three high denomination notes in succession are allowed ","NOT_OPERATIONAL_005":"Coin roll dispenser for 5 cents is not operational","NOT_OPERATIONAL_010":"Coin roll dispenser for 10 cents is not operational","NOT_OPERATIONAL_020":"Coin roll dispenser for 20 cents is not operational","NOT_OPERATIONAL_050":"Coin roll dispenser for 50 cents is not operational","NOT_OPERATIONAL_100":"Coin roll dispenser for 1 euro is not operational","NOT_OPERATIONAL_200":"Coin roll dispenser for 2 euro is not operational","STORAGE_ALMOST_EMPTY_005":"Coin roll dispenser is almost empty for 5 cents","STORAGE_ALMOST_EMPTY_010":"Coin roll dispenser is almost empty for 10 cents","STORAGE_ALMOST_EMPTY_020":"Coin roll dispenser is almost empty for 20 cents","STORAGE_ALMOST_EMPTY_050":"Coin roll dispenser is almost empty for 50 cents","STORAGE_ALMOST_EMPTY_100":"Coin roll dispenser is almost empty for 1 euro","STORAGE_ALMOST_EMPTY_200":"Coin roll dispenser is almost empty for 2 euro"}}

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

	module.exports = {"generic":{"application_name":"Portail LincSafe","copy_right":"Tous les droits sont réservés","submenu":{"title":"Les organisations","reset_text":"Réinitialiser"},"mainmenu":{"login":"S'identifier","submenu":"Sous menu","units":"Unité","users":"Utilisateurs","locations":"Emplacements","organizations":"Les organisations","tills":"Tills","mixes":"Mixes","report":"Rapport","citworkflow":"Flux de travail CIT","softwaresettings":"Paramètres du logiciel","adminsettings":"Admin settings","departments":"Departements","roles":"Unit roles"},"overview":{"pagination":{"showing":"<strong>{current}</ strong> sur <strong>{total}</ strong>","pagesize":{"before":"Affichage","after":"Enregistrements"},"success":{"added":"Ajouté {champ}","updated":"Mis à jour {field}","deleted":"Supprimé {champ}","unlocked":"Débloqué {champ}"}},"dialog":{"delete":{"title":"Confirmation de la suppression","description":"Vous êtes sur le point de supprimer: ","confirmation":"Êtes-vous sûr?","tillDescriptionName":"You are about to delete: ","tillDescriptionUnit":"and disconnect from {noUnits} unit(s): <ul>{units}</ul>","tillDescriptionUnits":"and disconnect from {noUnits} units?"},"warning":{"title":"Warning","description":"The CIT organization has been changed. Please make sure the new selection has workflows to support all unit types of this organization","confirmation":"Are you sure you want to proceed with updating?"},"unlock":{"title":"Confirmer le déverrouillage","description":"Vous êtes sur le point de déverrouiller <strong>{name}</ strong>.","confirmation":"Êtes-vous sûr?"},"filter":{"title":"Filter","confirmation":"Ok"}},"search":{"placeholder":"Chercher...","noresults":"Nous n'avons trouvé aucun résultat correspondant à votre requête ..."},"filter":{"selectall":"Tout sélectionner","deselectall":"Tout déselectionner","hide":"Masquer le filtre","show":"Afficher le filtre"},"buttons":{"back":"Retour","cancel":"Annuler","confirm":"Confirmer","reset":"Réinitialiser","create":"Créer","update":"Mettre à jour","delete":"Effacer","read":"Lis","filter":"Filtre","unlock":"Ouvrir","ok":"OK","upload":"Upload"}},"forms":{"errors":{"required":"Le {field} est un champ obligatoire","donotmatch":"Les champs {field} ne correspondent pas","minvalue":"Le value minimal est {min}","maxvalue":"Le value maximal est {max}","mincharlength":"La longueur minimale de caractère est {min}","maxcharlength":"La longueur maximale de caractère est {max}","minmaxcharlength":"La longueur minimale des caractères est {min} et la longueur maximale des caractères est {max}.","form":"Certaines erreurs ont été trouvées dans le formulaire. Veuillez vérifier les champs ci-dessous","userNotFound":"Adresse e-mail introuvable!","noworkflow":"No workflow available for selected unit type (Please create a new workflow in CIT workflow page)","positiveOnly":"Only positive number allowed","password":{"missing_lowercase":"Doit contenir au moins une lettre minuscule (a-z)","missing_uppercase":"Doit contenir au moins une lettre majuscule (A-Z)","missing_digit":"Doit contenir au moins un chiffre (0-9)","missing_special":"Doit contenir au moins un caractère spécial (!\"#%&'()*+,-.:;/<=>?@^_`{|}~)","missing_illegal":"Ne doit pas contenir de caractères illégaux"},"html":{"name":"Invalid characters detected"},"fields":{"firstuserrole":"premier rôle d'utilisateur","seconduserrole":"deuxième rôle d'utilisateur","name":"nom","unittype":"type d'unité","logintype":"type de connexion","city":"ville","country":"pays","location":"emplacement","legalform":"forme juridique","currency":"devise","machinename":"nom de la machine","ownerorganization":"propriétaire de l’organisation","pincodedropsafe":"dropsafe code PIN","pincodedropsafeconfirm":"code PIN dropfsafe confirmer","pincodedrawer":"tiroir à code PIN","pincodedrawerconfirm":"tiroir code PIN confirmer","firstname":"Prénom","lastname":"nom de famille","organizations":"organisations","organization":"organisation","userroles":"rôles d'utilisateur","email":"e-mail","password":"mot de passe","pin":"épingle","mixname":"nom du mélange","totalamount":"montant total","maximumAmount":"maximum amount","overrideworkflow":"Propriétaire du flux de travail","apiKeySettings":"API key","units":"unité","mixes":"mixes","mfaEnabled":"MFA enabled","mfaSecret":"MFA Secret","username":"Username","placeholder":"component","placeholderAction":"component action","translationNl":"dutch translation","unittypefamily":"Type d’unité famille","timeZone":"timezone","serialnumber":"serial number","transactionCashOutLimit":"transaction cash out limit","dailyCashOutLimit":"daily cash out limit"},"required-because":"The {field} is a required field, because {field1} is selected","maxPavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Max pavement value\"","pavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Pavement value\"","wrongDates":"Start datetime must be before end datetime","alphaCharsOnly":"Only alphabetical characters allowed","numbersOnly":"Only numerical characters (numbers) allowed","safeId":"Must consist of 1 alphabetical character followed by 14 digits. Example: A01234567890123","unable_to_process_request":"Unable to process your request at this time. Contact your administrator or try again later."},"loading":"Chargement...","select":"-- Sélectionnez dans la liste --","messages":{"check_email_for_reset_link":"Please check your email for the reset link."}},"errors":{"title":"Une erreur est survenue","unknown_error":"Une erreur inconnue s'est produite lors de la tentative de chargement des données demandées. <br/>Veuillez réessayer plus tard.","could_not_load":"Impossible de charger les données demandées. <br/>{response}","unauthorized":"L'accès non autorisé","unauthorized_expired":"Vous avez été déconnecté pour une longue période d'inactivité ou parce que vous vous êtes connecté ailleurs","network_down":"Une erreur de réseau s'est produite. S'il vous plaît vérifier votre réseau","back_button":"Retournez à la page précédente","illegal_argument_uuid":"Identifiant non valide trouvé","duplicate_entry":"Cet article existe déjà","emptycolumnidentifier":"L'identifiant de la colonne est vide","no_information":"Aucune information","mfaResetError":"Error trying to reset QR/Secret for user"},"login":{"title":"S'identifier","mfaTitle":"Verification","continue":"Continue","forgotPassword":{"title":"Mot de passe oublié!","success":"Mot de passe réinitialisé avec succès!"},"mfaFlow":{"mfa_required":"MFA required","mfa_required_description":"Your organization requires you to perform MFA authentication.","mfaHelp":"Help with MFA","errorGettingSecret":"Error obtaining your secret and QR","errorGettingMfaSettings":"Error obtaining MFA settings","mfaHelpTitle":"How restore MFA pairing in case of lost Phone/Authenticator","mfaHelpInstructions":"Contact your organization and provide them:<br/><br/> Full name <br/> Phone contact <br/> <br/> They will validate the information with you, and after that enable <strong>QR/secret</strong> pairing again.You shall receive an email once is done and will be able to see QR/secre from login screen again.","mfaHelpInstructionsOtherMfa":"There are more MFA methods available connect with them. <br/> If your organization enabled self QR/Secret recovery, click on your name at top right to see the <strong>User menu</strong> and click on Reset QR/Secret, so next login you will see the QR for new pairing.","understood":"Understood","setupMfaTitle":"Setup MFA","setupMfaDescription":"Please select one MFA type and click con continue.","setupMfaSelectType":"Select type of MFA","mfaPairingTitle":"Phone app setup (one time)","mfaPairingQrImage":"QR image:","mfaPairingSecret":"MFA secret: ","mfaPairingInstructionsTitle":"Instructions for Phone app MFA setup","mfaPairingInstructionsLine1":"Download any authenticator app such as google, microsoft authenticator.","mfaPairingInstructionsLine2":"Open it and click on Add and then select QR or Key.","mfaPairingInstructionsLine3":"With QR please scan the image above and for manual input copy the MFA secret","mfaPhoneInstructionsTitle":"Instructions for Phone app MFA","mfaPhoneInstructionsLine1":"Open your Authenticator device or Smartphone and check for the code provided there.","mfaPhoneInstructionsLine2":"To pair again check MFA troubleshoot.","mfaPhoneInstructionsLine3":"If you can't use this method anymore try with other MFA method such as Email.","mfaEmailInstructionsTitle":"Instructions for Email MFA","mfaEmailInstructionsLine1":"You had received a temporal access token in your email.","mfaEmailInstructionsLine2":"The token will be valid for some minutes.","mfaValidationTitle":"Code validation","mfaValidationDescription":"Enter the code provided by your selected MFA method"},"form":{"username":"Nom d'utilisateur","password":"Mot de passe","email":"E-mail","mfaCode":"Mfa Code"},"buttons":{"login":"S'identifier","validate":"Verify","forgotPassword":"Mot de passe oublié","reset":"Réinitialiser mon mot de passe"}},"logout":{"title":"Connectez - Out","buttons":{"logout":"Connectez - Out","profile":"Profil","changepassword":"Changer le mot de passe","changepin":"Changer le code pin","mfaResetQrSecret":"Reset MFA QR/Secret"}}},"management":{"unit":{"titles":{"overview":"Unités","create":"Ajouter une unité","update":"Mettre à jour l'unité","read":"Détails de l'unité","inventory":"Inventaire","readsettings":"Paramètres de l'unité","preview":"Aperçu de l’unité"},"breadcrumb":{"title":"Aperçu"},"columns":{"no":"#","amount":"Montant","buildVersion":"Version","closeTime":"Temps","compartment":"Compartiment","counter":"Nombre","currency":"Devise","currentValue":"Valeur actuelle","date":"Date","dateTimeStopped":"Date heure arrêtée","message":"Message","description":"La description","direction":"Direction","insurableValue":"Valeurs assurable","level":"Niveau","location":"Emplacement","machineName":"Nom de la machine","machineType":"Type de machine","name":"nom","placeholder":"Composant","placeholders":"Composants","reason":"Raison","remoteSupportId":"ID de support à distance","sales":"Ventes","serialNo":"Numéro de série","source":"La source","status":"Statut","teamviewerId":"ID Teamviewer","total":"Valeur totale","transactionNumber":"Nombre","type":"Type","unitIpAddress":"adresse IP","unitMacAddress":"MAC address","unitStatus":"Statut de l'unité","userAccountName":"Utilisateur","userLoginName":"Utilisateur","value":"Valeur","valueIn":"In","valueOut":"Out","valueProcessed":"Valeur","vpnIpAddress":"Adresse VPN IP"},"form":{"machineName":"Nom de la machine","location":"Emplacement","organizations":"Les organisations","ownerOrganization":"Organisation propriétaire","supportMultipleClient":"Support de plusieurs clients","clientOrganizations":"Organisations clientes","inheritedCIT":"CIT hérité","inheritedMaintenance":"Maintenance héritée","overrideCIT":"Propriétaire CIT","overrideMaintenance":"Propriétaire maintenance","overrideWorkflow":"Ignorer le flux de travail","unitType":"Type d'unité","unitTypeFamily":"Type d’unité famille","serialNo":"Numéro de série","currency":"Devise","endOfDayTime":"Fin de journée","hours":"Heures","minutes":"Minutes","alarmOn":"Alarme sur","alarmValuePerDay":"Valeur d'alarme par jour","alarmOnMonday":"Lundi","alarmOnTuesday":"Mardi","alarmOnWednesday":"Mercredi","alarmOnThursday":"Jeudi","alarmOnFriday":"Vendredi","alarmOnSaturday":"Samedi","alarmOnSunday":"Dimanche","maximumAmount":"Quantité maximum de pièces / billets par cassette","insurableValue":"Valeurs assurable","offlineTimeout":"Délai d'attente hors ligne","pincodeDrawer":"Tiroir à code","sideSafe":"A dropsafe","advancedManualDeposit":"Enable AMD","drawer":"Has drawer","pincodeDropsafe":"Confirmer le code PIN du tiroir","pincodeDrawerConfirm":"Confirmer le code PIN drawer","pincodeDropsafeConfirm":"Confirmer le code PIN dropsafe","overrideSettings":"Remplacer les paramètres existants","apiKey":"Clef API","safeId":"Safe ID","maxPavementWarningPercentage":"Alarm on","departments":"Departements","coinDistribution":"Management"},"toolTip":{"machineName":"Le nom de la machine","location":"L'adresse où se trouve la machine, cela doit être créé avant de créer l'unité","organizations":"Organisations","ownerOrganization":"L'organisation qui gère la machine","supportMultipleClient":"Permettez à la machine d'être utilisée par plusieurs organisations","clientOrganizations":"Les organisations qui peuvent déposer de l'argent dans la machine","inheritedCIT":"L'organisation de transfert de fonds qui est héritée de l'organisation propriétaire","inheritedMaintenance":"L'organisation de maintenance qui est héritée de l'organisation propriétaire","overrideCIT":"Pour utiliser une organisation de transfert de fonds différente de celle qui a été héritée de l'organisation propriétaire","overrideMaintenance":"Pour utiliser une organisation de maintenance différente de celle qui a été héritée de l'organisation propriétaire","overrideWorkflow":"Pour utiliser une procédure de transfert de fonds différente de celle qui a été héritée de l'organisation propriétaire","unitType":"Quel type de machine il s'agit. Plusieurs détails techniques sont déterminés en fonction de cela, tels que les composants de la machine. Ce champ ne peut pas être modifié.","unitTypeFamily":"La famille des types d'unités","serialNo":"Numéro de série du système Lincsafe, il peut être trouvé sur une plaque sur l'unité. La première fois que l'unité se connecte au portail, elle utilise ce code pour se connecter","currency":"Quelle devise peut être utilisée par la machine","endOfDayTime":"L'heure utilisée dans les rapports pour la fin de la journée, cela peut être utilisé par exemple par les magasins qui ferment après midi.","hours":"Heures","minutes":"Minutes","alarmOn":"Envoie un e-mail lorsque l'unité est presque pleine. Il sera envoyé lorsqu'il aura atteint le pourcentage saisi de la valeurs assurée. Les abonnés peuvent être modifiés en cliquant sur le symbole de l'horloge à côté de l'organisation sur la page d'aperçu de l'organisation","alarmValuePerDay":"Envoie un e-mail lorsque l'unité est presque pleine. Il sera envoyé lorsqu'il aura atteint le pourcentage saisi pour ce jour-là. Les abonnés peuvent être modifiés en cliquant sur le symbole de l'horloge à côté de l'organisation sur la page d'aperçu de l'organisation","alarmOnMonday":"Lundi","alarmOnTuesday":"Mardi","alarmOnWednesday":"Mercredi","alarmOnThursday":"Jeudi","alarmOnFriday":"Vendredi","alarmOnSaturday":"Samedi","alarmOnSunday":"Dimanche","maximumAmount":"Le montant maximum de billets/pièces qui peut physiquement tenir dans un compartiment. Non applicable pour Lincstation","insurableValue":"La valeur maximale de l'argent dans la machine couverte par l'assurance. Cela est utilisé pour déterminer si l'unité est pleine et doit être vidée.","offlineTimeout":"Le temps d'attente du portail pour un message de battement de cœur de l'unité, avant de la marquer comme hors ligne.","pincodeDrawer":"Le code PIN à entrer sur la machine pour ouvrir le tiroir","sideSafe":"La machine a un coffre-fort latéral dans lequel des bons, par exemple, peuvent être introduits","advancedManualDeposit":"Activer le dépôt manuel avancé : le coffre-fort latéral peut être utilisé pour les dépôts d'argent officiels qui peuvent être récupérés par une entreprise de transport de fonds","drawer":"La machine a un tiroir qui peut être utilisé pour résoudre les bourrages","pincodeDropsafe":"Le code PIN à entrer sur la machine pour ouvrir le coffre-fort latéral","pincodeDrawerConfirm":"Confirmer le code PIN du tiroir","pincodeDropsafeConfirm":"Confirmer le code PIN du coffre-fort latéral","overrideSettings":"Changer les paramètres de cette machine pour qu'ils soient différents des paramètres par défaut de cette organisation","maxPavementWarningPercentage":"A warning will pop up on the machine screen, telling the managers/CIT that the bag will be full soon. The user will be informed when it has reached the entered percentage of the max pavement value.","safeId":"Optional, custom, unique, 15 character identifier for this unit","overrideBankAccount":"Do not inherit primary bank account from Location. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Location. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Location. Instead, define a new one specific to this unit","coinDistribution":"Twin coin system distribution setting management in percentage"},"softwaresettings":{"1":"Paiement libre","2":"Élevée à faible","listUserByOrganization":"Liste des utilisateurs par organisation","listUserByUsername":"Liste des utilisateurs par nom d'utilisateur","xmlExportName":"Exportation XML","useReferenceNumber":"Nr page (ne pas utiliser, uniquement pour les anciennes versions)","referenceNumberLength":"Longueur du numéro de référence","unitBarcodeTypeOnFirstCitPage":"Display Barcode of Unit Name (CIT Screen)","currencyCode":"Devise","hopper1Value":"Hopper 1 valeur","hopper2Value":"Hopper 2 valeur","numberOfCoins":"Nombre de pièces","beepOnBillRejected":"Bip sur facture rejetée","transactionPerBill":"Transaction par facture","loginRequiredTransaction":"Connexion requise pour la transaction","buzzerTimeout":"Délai de sonnerie","hasPrinterAttached":"Afficher les notifications d'imprimante","enableOTC":"Activer OTC","billMaxAmount":"Seuil de montant maximum pour les billets","coinMaxAmount":"Montant maximum de surplus pour les pièces","heartbeatRate":"Rythme cardiaque","downloadRate":"Taux de téléchargement","safeStatusRate":"Taux de statut sécurisé","inventorySettings":"Paramètres d'inventaire","payableValue":"Valeur à payer","floatValue":"Valeur flottante","floatSettings":"Paramètres de flottant","payOutMethod":"Méthode de paiement","round":"Valeur arrondie","payOutLimit":"Limite de paiement","language":"Langue initiale","bins":"Numéro d'identification bancaire","ecrId":"Pin Terminal Id","ecrUrl":"Payplaza Url","charities":"Charities","g4sApiUrl":"Banks Authorization Url","authApiKey":"Authorization API Key","employeeSelection":"Sélection des employés","supportedLanguages":"Langue acceptée","showDeviceTotal":"Afficher le total de l'appareil","showExtraButtonOnUserSelectScreen":"Show extra user select button","pavementLimit":"Valeurs assurable fractionnée","communicationRate":"Taux de communication","depositTimeout":"Délai d'inactivité du dépôt en secondes","normalDepositReceipts":"Récépissés normaux","manualDepositReceipts":"Récépissés manuels","showDenominationDetailsOnDepositPrint":"Afficher la dénomination Détails sur le dépôt Imprimer","showUserTotals":"Show user totals function","showDailyReports":"Show daily reports function","manualEndOfDay":"Manual end of day","textLanguage":"Text language selection","dateFormat":"Date format","MMddyyyy":"United States (12/31/2000)","dd-MM-yyyy":"International (31-12-2000)","MMMddyyyy":"US Global (Dec 31 2000)","ddMMMyyyy":"Alternate International (31 Dec 2000)","yyyy-MM-dd":"Year-Month-Day (2000-12-31)","screenSaver":"Économiseur d'écran","preTransactionTask":"Utiliser le numéro de référence","noTask":"No","refNr":"Utiliser le numéro de référence","low":"Faible","medium":"Moyen","high":"Élevé","high_low_medium":"Personnalisé 1","Low":"Faible","Medium":"Moyen","High":"Élevé","namelist":"Nom","empnr":"Entrez le Numéro d'employé","en":"Anglais","nl":"Néerlandais","fr":"Français","hu":"Hongrois","sk":"Slovaque","pl":"Polonais","EUR":"EUR","TR":"TR","USD":"USD","noExport":"pas d'exportation","MLSA":"OCS exportation","puloonCassette1":"Puloon Cassette 1","puloonCassette2":"Puloon Cassette 2","puloonCassette3":"Puloon Cassette 3","puloonCassette4":"Puloon Cassette 4","EUR-5":"5 €","EUR-10":"10 €","EUR-20":"20 €","EUR-50":"50 €","EUR-100":"100 €","EUR-200":"200 €","EUR-500":"500 €","puloonCassette1FixedAmount":"Puloon Cassette 1 Fixed Amount","puloonCassette2FixedAmount":"Puloon Cassette 2 Fixed Amount","puloonCassette3FixedAmount":"Puloon Cassette 3 Fixed Amount","puloonCassette4FixedAmount":"Puloon Cassette 4 Fixed Amount","inventoryCheckOnPayment":"Vérifier l'inventaire lors du paiement","tariffs":"Tariffs","acceptablesSetting":"Enabled denominations","minimumOrderRolls":"Minimal roll order amount","inventoryOptimumReset":"Délai limite des inventaires","escrowEmptyAmount":"Escrow empty amount","maxBagValue":"Max pavement value","ledLightColor":"Couleur de la lumière LED","yellow":"Jaune","red":"Rouge","green":"Verte","blue":"Bleue","magenta":"Magenta","cyan":"Cyan","white":"Blanche","posMode":"POS mode","none":"None","barcode_itf":"Barcode ITF","qrcode":"QR Code","inventorypanel":{"denomination":"Denomination","material":"Matérial","recycled":"Recyclé","numberOfRecyclers":"Recycler count","min":"Min","low":"Faible","optimum":"Optimum","max":"Max","value":"Value","COIN":"Coin","BILL":"Bill","ROLL":"Roll","maxDispensable":"Max dispensable","messages":{"recyclerStatusInfo":"{totalRecyclers} of {maxNumberOfRecyclers} recyclers are used","recyclerStatusError":"Error: Exceed the max recycler count ({maxNumberOfRecyclers}); claimed: {totalRecyclers}","excideMaximumDrawer":"Max drawer dispensable limit is {limit}","excideMaximumCup":"Max cup dispensable limit is {limit}"},"high":"High"},"tariffspanel":{"transaction_fee":"Fee per transaction","value_fee":"Fee per roll"},"minimumOrderPanel":{"min":"Min (1)","max":"Max (200)"},"timeSelector":{"enabled":"Activé"},"minimumOrderCoinRollsSettings":"Paramètres de commande minimale et maximale de rouleaux de pièces","apiKeySettings":"Clef API","useDefaultValue":"Utiliser la valeur par défaut","om61InventorySettings":"Paramètres d'inventaire OM61","allowManagerEmptyAllRecyclers":"Autoriser le gestionnaire à vider tous les recycleurs","managerUnlockDelay":"Délai de déverrouillage des portes du coffre par le gestionnaire","managerUnlockStartTime":"Heure de début de déverrouillage par le gestionnaire","managerUnlockEndTime":"Heure de fin de déverrouillage par le gestionnaire","localPinChange":"Changer le code PIN utilisateur sur l'unité","customXmlHeader":"En-tête XML personnalisé","coinDistribution":"Réglage de la distribution du système de pièces jumelles","puloonRejectBinMaxAmount":"Montant maximum de billets que la benne de rejet Puloon peut contenir","puloonRejectBinWarningPercentage":"Avertissement de capacité maximale de la benne de rejet Puloon (pourcentage)","autoFloatDownWhenSystemIsIdle":"Flottement automatique lorsque le système est inactif","tillRestrictions":"Restricted tills","maxPavementWarningPercentage":"Max pavement value alarm","g4sCertificate":"G4S Certificate","payplazaCertificate":"Payplaza Certificate","storageVault":"Storage vault","userManagement":"User management"},"actions":{"create":"Ajouter une unité","read":"Unité de lecture","update":"Mettre à jour l'unité","delete":"Supprimer l'unité","filter":"Filtre l'unité","readsettings":"Paramètres de l'unité de lecture","preview":"Aperçu de l’unité"},"messages":{"added":"L'unité {name} est ajoutée","updated":"L'unité {name} est mise à jour"},"read":{"tabs":{"detail":"Détails","specifications":"Spécifications techniques","status":"Statut","users":"Utilisateurs","sales":"Ventes","internal":"Interne","mixes":"Mixes","citLegacy":"Legacy","citDynamic":"Dynamic","citStatic":"Static"},"summary":{"maximumAmount":"Max pièces / billets par cassette","machineName":"Nom de la machine","insurableValue":"Valeurs assurable","currentValue":"Valeur actuelle","currentDepositValue":"Valeur actuelle du dépôt","unitModelName":"Type d'unité","unitTypeFamily":"Type d’unité famille","location":"Emplacement","placeholders":"Composants","lastTransactionDate":"Date de la dernière transaction","currency":"Devise","currentStatus":"Statut actuel","networkStatus":"L'état du réseau","lastClearBox":"Dernier enlèvement","yesterdayTurnover":"Chiffre d'affaires d'hier","lastClearBoxDate":"Date de la dernière enlèvement","fillGrade":"Niveau de remplissage","numberOfTransactions":"Nombre de transactions","name":"nom","addressLine1":"Adresse","city":"Ville","unitFillStatus":"Limite atteinte","ALMOST_FULL":"PRESQUE PLEIN","FULL":"PLEIN","NORMAL":"ORDINAIRE","null":"nul"},"titles":{"unitStatus":"Statut de l'unité","unitDetail":"Détail de l'unité","unitDetails":"Détails de l'unité","location":"Détails de la localisation","lastTransactions":"Dernières transactions","campaignsUnit":"Unité Clearboxes","lastClearBoxes":"Dernier enlèvement","component":"Spécifications techniques","eventsByUnit":"Évènements","lastEvents":"Derniers évènements","hardwareStatus":"Matériel:","networkStatus":"Réseau:","notifications":"Les notifications","departments":"Departement details"},"status":{"ALMOST_EMPTY":"Doit être comblé","ALMOST_FULL":"Doit être effacé","DEBUG":"Déboguer","EMPTY":"Doit être comblé","ERROR":"Erreur","FATAL":"Fatal","FULL":"Doit être effacé","INFO":"Info","INVENTORY_NOT_SUFFICIENT":"Doit être comblé","INVENTORY_OVER_MAXIMUM":"Doit être vidé","INVENTORY_UNDER_MIN":"Doit être comblé","INVENTORY_UNDER_LOW":"Doit être comblé","JAMMED":"Dégagez la confiture","NOT_CONNECTED":"Vérifier la connexion à l'appareil","NOT_SECURE":"Déverrouillez la porte et fermez-la à nouveau","OFFLINE":"L'unité est hors ligne","OK":"D'accord","OPEN":"Ferme la porte","OVERRIDDEN":"Utilisez le menu pour déverrouiller puis verrouiller la porte","RECYCLER_ALMOST_EMPTY":"Remplir le recycleur","RECYCLER_ALMOST_FULL":"Enlevez du matériel du recycleur","RECYCLER_EMPTY":"Remplir le recycleur","RECYCLER_FULL":"Enlevez du matériel du recycleur","STACKER_FULL":"Effacer les factures de l'empileur","STORAGE_ALMOST_FULL":"Effacer le stockage","STORAGE_DETACHED":"Attacher le stockage","STORAGE_FULL":"Effacer le stockage","TRACE":"Trace","UNLOCKED":"Verrouiller la porte","WARN":"Attention","WARNING":"Attention"},"techSpec":{"ACCEPTING":"Acceptant","ALMOST_EMPTY":"Presque vide","ALMOST_FULL":"Presque plein","BAG_OPEN":"Bag Open","CALIBRATING":"Étalonnage","CASSETTE_ERROR":"Cassette Error","CASSETTE_ATTACHED":"Cassette attachée","CASSETTE_DETACHED":"Cassette Détachée","CARTRIDGE_DETACHED":"Cartridge Détachée","CLOSED":"Fermé","CONNECTED":"Connecté","DOOR_CLOSED":"Porte fermée","DOOR_OPEN":"Porte ouverte","DOOR_LOCKED":"Porte Fermé à clef","DOOR_UNLOCKED":"Porte Débloqué","DOWNLOADING":"Téléchargement","EMPTY":"Vide","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Entrance pas leur","EXTENSION_STALL":"Extension stall","FAILED":"Failed","FEED_FAILURE":"Feed Failed","FULL":"Plein","INVENTORY_NOT_SUFFICIENT":"Inventaire insuffisant","INVENTORY_OVER_MAXIMUM":"Inventaire supérieur au maximum","INVENTORY_UNDER_MIN":"Inventaire sous minimum","INVENTORY_UNDER_LOW":"Inventaire est bas","JAM_CLEARED":"Confiture supprimée","JAMMED":"Coincé","LOCKED":"Fermé à clef","LOCKS_SECURE":"Locks Secure","NOT_ACCEPTING":"Ne pas accepter","NOT_CONNECTED":"Pas connecté","NOT_FOUND":"Configuration non trouvée","NOT_OPERATIONAL":"Pas opérationnel","NOT_OVERRIDDEN":"Pas annulé","NOT_SECURE":"Non sécurisé","OFFLINE":"HORS LIGNE","ONLINE":"ONLINE","NETWORK_DISCONNECTED":"Network disconnected","NETWORK_RESTORED":"Network restored","OK":"D'accord","OPEN":"Ouvrir","OVERRIDDEN":"Annulé","PAUSE":"Pause","POWER_UP":"Mise sous tension","RECYCLER_ALMOST_EMPTY":"RECYCLEUR presque vide","RECYCLER_ALMOST_FULL":"RECYCLEUR presque plein","RECYCLER_EMPTY":"RECYCLER vide","RECYCLER_FULL":"RECYCLER Full","REJECT_NOT_EMPTY":"Reject is not empty","OUTPUT_NOT_EMPTY":"Output is not empty","SAFE_DOOR_OPEN":"Safe door open","SECURE":"Garantir","SIDE_SAFE_ONE_LOCKED":"Coffre-fort 1 verrouillé","SIDE_SAFE_ONE_UNLOCKED":"Coffre-fort 1 déverrouillé","STACKER_FULL":"Stacker Full","STALLED":"En panne","STORAGE_ALMOST_FULL":"Stockage presque plein","STORAGE_ALMOST_FULL_CLEARED":"Storage Almost Full Cleared","STORAGE_ATTACHED":"Stockage attaché","STORAGE_DETACHED":"Stockage détaché","STORAGE_FULL":"Stockage complet","STORAGE_ALMOST_EMPTY_005":"Stockage de rouleaux de pièces presque vide pour 5 cents","STORAGE_ALMOST_EMPTY_010":"Stockage de rouleaux de pièces presque vide pour 10 cents","STORAGE_ALMOST_EMPTY_020":"Stockage de rouleaux de pièces presque vide pour 20 cents","STORAGE_ALMOST_EMPTY_050":"Stockage de rouleaux de pièces presque vide pour 50 cents","STORAGE_ALMOST_EMPTY_100":"Stockage de rouleaux de pièces presque vide pour 1 euro","STORAGE_ALMOST_EMPTY_200":"Stockage de rouleaux de pièces presque vide pour 2 euro","TOP_DOOR_CLOSED":"Porte supérieure fermée","TOP_DOOR_OPEN":"Porte supérieure ouverte","UNLOCKED":"Débloqué"}},"inventory":{"unitInventory":"Inventaire des unités","noTransactions":"Aucune transaction","noTransactionsDesc":"Aucune transaction trouvée, veuillez réessayer plus tard!","items":"Articles","total":"Total","cassette":"Cassette"},"campaign":{"read":"Last clearboxes","columns":{"no":"#","group":"Nr. transaction","placeholder":"Component","dateTimeStopped":"Date fin de transaction","userAccountName":"Utilisateur","insertedValue":"Inserted","valueProcessed":"Collecter","totalValueProcessed":"Total value processed"}}},"softwaresettings":{"titles":{"overview":"Paramètres du logiciel","create":"Ajouter des paramètres logiciels","update":"Mettre à jour les paramètres du logiciel","readsettings":"Lire les paramètres du logiciel"},"breadcrumb":{"title":"Aperçu"},"actions":{"create":"Ajouter un paramètre logiciel","read":"Lire les paramètres du logiciel","update":"Mise à jour du logiciel","delete":"Supprimer les paramètres du logiciel","readsettings":"Lire les paramètres du logiciel"},"columns":{"ownerOrganization":"Propriétaire de l’organisation","unitType":"Type d'unité"},"messages":{"added":"De nouveaux paramètres sont ajoutés","updated":"Les paramètres sont mis à jour"},"form":{"ownerOrganization":"Propriétaire de l’organisation","unitType":"Type d'unité","overrideSettings":"Remplacer les paramètres par défaut","selectOverrideSettings":"Sélectionnez les paramètres à remplacer et à utiliser","checkAll":"Vérifie tout","cassettesAssignment":"Cassettes Assignment"},"toolTip":{"hasPrinterAttached":"Utiliser uniquement lorsque l'imprimante est connectée","listUserByOrganization":"List employees by organization when unit supports multi client","listUserByUsername":"List employees by user name, otherwise list by employee number","xmlExportName":"Used when 3rd party xml export is needed","useReferenceNumber":"Enter reference number before deposit","referenceNumberLength":"Reference number length","currencyCode":"Currency for NS Wisselaar hoppers","hopper1Value":"NS Wisselaar hopper1 value","hopper2Value":"NS Wisselaar hopper2 value","numberOfCoins":"NS Wisselaar coin amount per hopper","beepOnBillRejected":"Beep on bill rejected","transactionPerBill":"Bill acceptor only accepts one bill per transaction","loginRequiredTransaction":"Login is required to start a new deposit","buzzerTimeout":"Buzzer beeping timeout duration","enableOTC":"Used to enable OTC mode for smart lock","heartbeatRate":"Frequency of sending heartbeat from unit to portal","downloadRate":"Frequency of downloading configuration files from portal to unit","safeStatusRate":"Frequency of sending safe status from unit to portal","inventorySettings":"Inventory settings for Lincstation, consists acceptable materials, recycled materials, minimum, float and maximum levels of denominations","payableValue":"Minimum value to check inventory whether Lincstation is operational for a payment or not","floatValue":"Day start value of Lincstation","billMaxAmount":"Maximum amount threshold for bills in Lincstation","coinMaxAmount":"Maximum amount of coins in the overflow. A warning will be generated at 80% of this value.","payOutMethod":"Pay out mode for Smart Coin System in Lincstation","round":"Used to round the value entered for a payment in Lincstation","payOutLimit":"Limit per pay out in Lincstation","language":"Active selected language on device","employeeSelection":"Searching employees by entering employee number, or see the employees displayed in a list","supportedLanguages":"Supported languages by device","showDeviceTotal":"Used for showing device total value and denomination details on manager menu","showExtraButtonOnUserSelectScreen":"When enabled, this causes a 5th user select button to appear on the user select screen","pavementLimit":"Limite de chaussée pour la cassette","communicationRate":"Frequency of communication between unit and portal. This setting controls download and heartbeat frequency. For the options \"High\", \"Medium\" and \"Low\" both frequencies are set to this level. For the option \"Custom 1\" download frequency is low and heartbeat frequency is high","depositTimeout":"Timeout duration for deposit screen","normalDepositReceipts":"Number of receipt to print after normal deposit","manualDepositReceipts":"Number of receipt to print after manual deposit","showDenominationDetailsOnDepositPrint":"Show denomination on deposit print","showUserTotals":"Show user totals function in settings screen","showDailyReports":"Show daily reports function in management screen","manualEndOfDay":"End of day will be manually performed by a manager (This setting disables the automatic end of day feature)","textLanguage":"Use text language selection screen (instead of flags)","dateFormat":"The date format displayed on receipts and screen","preTransactionTask":"Used for showing denomination details per transaction on deposit receipt","screenSaver":"Show screen saver when machine is idle","puloonCassette1":"Denomination for Cassette 1","puloonCassette2":"Denomination for Cassette 2","puloonCassette3":"Denomination for Cassette 3","puloonCassette4":"Denomination for Cassette 4","puloonCassette1FixedAmount":"Fixed amount of bills in the Cassette 1","puloonCassette2FixedAmount":"Fixed amount of bills in the Cassette 2","puloonCassette3FixedAmount":"Fixed amount of bills in the Cassette 3","puloonCassette4FixedAmount":"Fixed amount of bills in the Cassette 4","inventoryCheckOnPayment":"Vérifie si le montant inséré peut être distribué lors du paiement","charities":"Charity organizations data","escrowEmptyAmount":"Minimum amount for escrow to be emptied","maxBagValue":"Maximum value for the bag","inventoryOptimumReset":"The time when the inventory of the machine will reset back to optimum values based on the inventory settings","apiKeySettings":"API Key for the connector","ledLightColor":"Couleur de la lumière LED","posMode":"Point of sale mode limits machine functionality by disabling some buttons","bins":"List on Bins per Bank that is supported","ecrId":"The id for the terminal connected to the unit","ecrUrl":"The endpoint used to perform payments and other card transactions","g4sApiUrl":"The endpoint used for the authorization of cards","allowManagerEmptyAllRecyclers":"Enables the manager to dispense all available notes and coins locally on the unit","managerUnlockDelay":"Manager delay for opening tills and coin drawer","localPinChange":"Able to change user pin code on unit","customXmlHeader":"Set custom XML data needed for integration","puloonRejectBinMaxAmount":"Puloon reject bin maximum notes capacity","puloonRejectBinWarningPercentage":"Warning level set in percentage for Puloon reject bin. This functionality is disabled if 0 is set","unitBarcodeTypeOnFirstCitPage":"Enables unit name to be shown as a barcode on device display at the start of CIT flow","autoFloatDownWhenSystemIsIdle":"Auto float down if no active transaction and recycler is full","g4sCertificate":"Certificate for software management","payplazaCertificate":"Certificate for software management","managerUnlockStartTime":"Unlock start time","managerUnlockEndTime":"Unlock end time","tillRestrictions":"When selected, tills are only allowed to be dispensed once. They will become available again after the till is deposited back into the machine. When deselected, tills can be used multiple times.","storageVault":"Enable additional storage vault","userManagement":"Enable user management","authApiKey":"Authorization API Key"},"billsDenominationTable":{"yes":"YES","no":"NO","columns":{"cassettes":"Cassettes","recycler":"Recycler","denomination":"Denomination","currency":"Currency","optimum":"Optimum","max":"Max"}}},"user":{"titles":{"overview":"Utilisateurs","create":"Ajouter un utilisateur","update":"Mettre à jour l'utilisateur","changepassword":"Changer le mot de passe","changepincodes":"Changer le code","updateprofile":"Mettre à jour le profil","forgotpassword":"Mot de passe oublié","resetpassword":"Réinitialiser le mot de passe","readsettings":"Paramètres utilisateur"},"breadcrumb":{"title":"Aperçu"},"columns":{"name":"nom","organization":"Organisation","email":"E-mail","roles":"Rôles de l'utilisateur"},"form":{"firstName":"Prénom","lastName":"Nom de famille","rfid":"RFID / Dallas Key","employeeNumber":"Numéro d'employé","organization":"Organisation","roles":"Rôles d'utilisateur","email":"E-mail","externalUsername":"External Username","externalPassword":"External Password","password":"Mot de passe","passwordConfirm":"Confirmez le mot de passe","sendTemporaryPassword":"Envoyer un mot de passe temporaire","pin":"Épingle","pinConfirm":"Confirmer le code PIN","openDropsafeWithPin":"Dropsafe ouvert avec épingle","openDrawerWithPin":"Tiroir ouvert avec épingle","units":"Unité","oldPassword":"Ancien mot de passe","newPassword":"Nouveau mot de passe","confirmPassword":"Confirmer le nouveau mot de passe","oldPin":"Vieille épingle","newPin":"Nouvelle épingle","tills":"Tills","mixes":"Mixes","dailyDispenseLimit":"Daily dispense limit","dailyPayoutLimit":"Daily payout limit","mfaEnabled":"Enable multi-factor authentication","generate":"Generate","copied":"Copied","secretkey":"Secret key","useExternalRoles":"Use external roles","unitRoles":"Unit role","storageVaultAccess":"Storage vault access","departments":"Departements"},"actions":{"create":"Ajouter un utilisateur","read":"Lire l'utilisateur","update":"Mettre à jour l'utilisateur","delete":"Supprimer l'utilisateur","unlock":"Déverrouiller l'utilisateur","readsettings":"Lecture des paramètres utilisateur"},"messages":{"added":"L'utilisateur {name} est ajouté","updated":"L'utilisateur {name} est mis à jour","changedpassword":"Le mot de passe est mis à jour","changedpin":"Lle code PIN est mise à jour","updateprofile":"Le profil est mis à jour","qrSecretReset":"The QR/secret has been reset correctly"},"toolTip":{"mfaEnabled":"Enable multi-factor authentication","copySecret":"Copy secret text","useExternalRoles":"Use external roles"}},"location":{"titles":{"overview":"Emplacements","create":"Ajouter un lieu","update":"Mettre à jour l'emplacement","readsettings":"Les paramètres de localisation"},"breadcrumb":{"title":"Aperçu"},"columns":{"city":"Ville","name":"Nom","addressLine":"Adresse"},"form":{"name":"Nom","city":"Ville","addressLine1":"Adresse","addressLine2":"Adresse","postalCode":"Code postal","country":"Pays","phoneNumber":"Numéro de téléphone","email":"E-mail","organization":"Organization","state":"State/Province","timeZone":"Timezone","departments":"Departements"},"actions":{"create":"Ajouter un emplacement","read":"Lire l'emplacement","update":"Mettre à jour l'emplacement","delete":"Supprimer le lieu","readsettings":"Lecture des paramètres de localisation"},"messages":{"added":"L'emplacement {name} est ajouté","updated":"L'emplacement {name} est mis à jour"},"toolTip":{"organization":"Organization to which this location belongs to","timeZone":"Machine time will be set up according to the timezone.","overrideBankAccount":"Do not inherit primary bank account from Organization. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Organization. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Organization. Instead, define a new one specific to this unit"}},"organization":{"titles":{"overview":"Les organisations","create":"Ajouter une organisation","jobs":"Emplois organisation","update":"Mettre à jour l'organisation","readsettings":"Paramètres de l'organisation","mfaTypes":"MFA types"},"breadcrumb":{"title":"Aperçu"},"columns":{"name":"Nom","location":"Emplacement","parentOrganization":"Organisation parente","organizationType":"Type d'Organisation"},"form":{"dayTotalJob":"Jour total de travail","mailSendingTime":"Heure d'envoi du courrier","enabled":"Activé","remainingUsers":"Utilisateurs restants","subscribers":"Les abonnés","affectedUnits":"Unité affectées","name":"Nom","ipWhiteList":"Liste blanche IP","pin":"Épingle","organizationType":"Type d'Organisation","parentOrganization":"Organisation parente","inheritedCIT":"CIT hérité","inheritedMaintenance":"Maintenance héritée","overrideCIT":"Remplacer CIT","overrideMaintenance":"Remplacer la maintenance","defaultCIT":"CIT par défaut","defaultMaintenance":"Maintenance par défaut","reportedOrganizations":"Organisations signalées","location":"Emplacement","legalForm":"Forme juridique","remark":"Remarque","forceMfaForUsers":"Force MFA auth for users","enableUserMfaSecretReset":"Allow users to reset their QR/Secret","enableAuthdeviceMfa":"Phone/Authenticator device MFA","enableEmailMfa":"E-mail MFA","enableSmsMfa":"SMS MFA","workflows":"Flux de travail","forceEmployeePin":"Les employés ont besoin d'un code PIN","userPincodeSeverity":"User pincode severity","ibutton":{"overview":"iButton keys overview","noData":"There are no iButton keys to show","add":"Add iButton key","uploadCSV":"Upload CSV","name":"iButton Key","removeAll":"Remove all iButton keys","removeAllConfirmationText":"Are you sure that you want to delete all ibuttons?","remove":"Remove","cancel":"Cancel","delete":"Delete","ok":"OK","invalidCSVfile":"Please upload a valid CSV file.","uploadInfo":"Upload is finished.","uploadDescription":"It seems that some keys weren't inserted because they didn't meet the required criteria.","uploadCSVInfo":"Only valid ibutton key names will be uploaded.","invalidButtonName":"Validation failed! iButton key name must be exactly 16 hexadecimal characters and should not be a duplicate.","search":"Type to search ibutton key"}},"actions":{"create":"Ajouter une organisation","read":"Lire l'organisation","update":"Mettre à jour l'organisation","delete":"Supprimer l'organisation","readsettings":"Lecture des paramètres de l'organisation"},"messages":{"added":"L'organisation {name} est ajoutée","updated":"L'organisation {name} est mise à jour","selectOneMfaOption":"Select at least one MFA option"},"toolTip":{"dayTotalJob":"Travail total de la journée","mailSendingTime":"Heure d'envoi des mails","enabled":"Activé","remainingUsers":"Utilisateurs restants","subscribers":"Abonnés","affectedUnits":"Unité concernées","name":"Le nom de l'organisation","ipWhiteList":"Adresses IP autorisées à communiquer avec les unités (actuellement non utilisées)","pin":"Le code PIN de l'organisation (actuellement non utilisé)","organizationType":"Le type d'organisation. Cash in Transit : pour les organisations qui collectent de l'argent auprès des unités. General : utilisé pour la plupart des organisations. Maintenance : pour les organisations qui effectuent la maintenance des unités. Reporting Group : pour les organisations qui ont besoin de voir des rapports d'organisations à divers endroits dans l'arborescence de l'organisation","parentOrganization":"L'organisation au-dessus de celle-ci dans l'arborescence de l'organisation. Les administrateurs de l'organisation parent peuvent voir l'organisation actuelle et ses unités dans le portail. L'organisation actuelle peut hériter de l'organisation de maintenance et CIT de sa parente. Si aucune organisation parente n'est définie, une organisation CIT et Maintenance doit être créée pour l'organisation actuelle.","inheritedCIT":"L'organisation Cash in Transit héritée de l'organisation parente","inheritedMaintenance":"L'organisation de maintenance héritée de l'organisation parente","overrideCIT":"Utiliser une organisation de transport de fonds différente de celle héritée de l'organisation parente","overrideMaintenance":"Utiliser une organisation de maintenance différente de celle héritée de l'organisation parente","defaultCIT":"Faire de ceci l'organisation Cash in Transit qui sera automatiquement utilisée par les unités et les sous-organisations","defaultMaintenance":"Faire de ceci l'organisation de maintenance qui sera automatiquement utilisée par les unités et les sous-organisations","reportedOrganizations":"Les organisations que les membres de l'organisation actuelle sont autorisés à voir dans les rapports","location":"L'adresse de cette organisation (doit être créée avant de créer une organisation)","remark":"Remarques sur l'organisation, visibles par les personnes qui la modifient","forceMfaForUsers":"Enable this option to force multifactor authentication for all users when they log in to the portal.","enableAuthdeviceMfa":"Enable authenticator device and phone apps as user MFA option","enableEmailMfa":"Enable Email as user MFA option","enableSmsMfa":"Enable SMS as user MFA option","enableUserMfaSecretReset":"Allow users to reset theirselves their QR/Secret from user menu if more than one MFA mode is enabled","workflows":"Les procédures de transport de fonds qui seront utilisées sur les unités dont cette organisation est l'organisation de transport de fonds","forceEmployeePin":"Rendre le code PIN obligatoire pour tous les employés de cette organisation et des sous-organisations"},"notifications":{"titles":{"notifications":"Notifications","notificationType":"Notification Type"},"types":{"UNIT_OFFLINE":"Unit Offline"},"form":{"enabled":"Activé","unsubscribed":"Remaining Users","subscribed":"Subscribed"}}},"till":{"titles":{"overview":"Caisse enregistreuse","create":"Ajouter une caisse","update":"Mettre à jour la caisse"},"breadcrumb":{"title":"Aperçu"},"columns":{"name":"Nom","organization":"Organisation","mixes":"Combinaisons"},"form":{"name":"Nom","organizations":"Organisation","units":"Unité","maximumAmount":"Montant maximum","mixes":"Combinaisons"},"actions":{"create":"Ajouter une caisse","read":"Consulter la caisse","update":"Mettre à jour la caisse","delete":"Supprimer la caisse"},"messages":{"added":"La caisse {name} a été ajoutée","updated":"La caisse {name} a été mise à jour","disconnected":"Ces unité {units} seront déconnectées de la caisse {till}"},"toolTip":{"dayTotalJob":"Total du jour","mailSendingTime":"Heure d'envoi des e-mails","enabled":"Activé","remainingUsers":"Utilisateurs restants","subscribers":"Abonnés","affectedUnits":"Unité affectées","name":"Nom de l'organisation","ipWhiteList":"Adresses IP autorisées à communiquer avec les unités (non utilisées pour le moment)","pin":"Code PIN de l'organisation (non utilisé pour le moment)","organizationType":"Le type d'organisation. Cash in Transit : pour les organisations qui collectent de l'argent des unités. Général : utilisé pour la plupart des organisations. Maintenance : pour les organisations qui effectuent la maintenance des unités. Reporting Group : pour les organisations qui doivent voir les rapports d'autres organisations à divers endroits dans l'arborescence de l'organisation","parentOrganization":"L'organisation au-dessus de celle-ci dans l'arborescence de l'organisation. Les administrateurs de l'organisation parent peuvent voir l'organisation actuelle et ses unités dans le portail. L'organisation actuelle peut hériter de l'organisation Maintenance et CIT de sa parent. Si aucune organisation parent n'est définie, une organisation CIT et Maintenance doit être créée pour l'organisation actuelle.","inheritedCIT":"L'organisation Cash in Transit héritée de l'organisation parent","inheritedMaintenance":"L'organisation de maintenance héritée de l'organisation parent","overrideCIT":"Utiliser une organisation Cash in Transit différente de celle héritée de l'organisation parent","overrideMaintenance":"Utiliser une organisation de maintenance différente de celle héritée de l'organisation parent","defaultCIT":"Faire de cela l'organisation Cash in Transit qui sera automatiquement utilisée par les unités et les sous-organisations","defaultMaintenance":"Faire de cela l'organisation de maintenance qui sera automatiquement utilisée par les unités et les sous-organisations","reportedOrganizations":"Les organisations que les membres de l'organisation actuelle sont autorisés à voir les rapports","location":"L'adresse de cette organisation (doit être créée avant de créer une organisation)","remark":"Remarques sur l'organisation, visibles par les personnes qui l'éditent","workflows":"Les procédures de Cash in Transit qui seront utilisées sur les unités dont cette organisation est l'organisation Cash in Transit","forceEmployeePin":"Rendre le code PIN obligatoire pour tous les employés de cette organisation et des sous-organisations"}},"cit":{"titles":{"overview":"Flux de travail CIT","create":"Ajouter un flux de travail CIT","update":"Mettre à jour le flux de travail CIT","readsettings":"Paramètres de flux de travail CIT"},"breadcrumb":{"title":"Passer outre"},"columns":{"name":"Nom","unitType":"Type d'unité","advancedSettings":"Réglages avancés","stepTabEdit":"Modifier l'étape","stepTabNew":"Créer une nouvelle étape","cancel":"Annuler","create":"Créer","update":"Mettre à jour","steps":"Étapes","addNewStep":"Nouvelle étape","version":"Version"},"form":{"name":"Nom","unitType":"Type d'unité","organization":"Organisation","loginType":"Type de connexion","firstUserRole":"Rôle d'utilisateur de connexion *","secondUserRole":"Deuxième rôle d'utilisateur de connexion *","allSteps":"Toutes les étapes","selectedSteps":"Étapes sélectionnées","performPrint":"Effectuer une impression après CIT","scanLength":"Longueur du code à barres","prefixBarcode":"Préfixe de code à barres","emptyCoinDevice":"Empty coin storage","printOnCassetteDetached":"Reçu sur cassette détachée","placeholder":"Component","placeholderAction":"Action du Component","stepCondition":"Condition","stepSkip":"Skip to","loadingPlaceholderText":"Select any unit type first","loadingPlaceholderActionText":"Select a component first","loadingPlaceholderConditionText":"Select a component first","nextStep":"Next step","next":"Next","skipTo":"Step: {number}","options":{"autologin":"Connexion automatique","singlelogin":"Connexion unique","multiplelogin":"Connexion multiple","locklogin":"Connexion avec goupille de verrouillage"},"translationEn":"Titre de l'étape","translationNl":"Titre de l'étape","translationUs":"Titre de l'étape","translationFr":"Titre de l'étape","translationPl":"Titre de l'étape","translationEl":"Titre de l'étape","translationHu":"Titre de l'étape","translationSk":"Titre de l'étape","translationDe":"Titre de l'étape","translationKey":"Clé de traduction","translationKeyInfo":"Clé de traduction : {translationKey}","confirmDialog":"Dialogue de confirmation","confirmationDialogLabel":"Doit afficher le dialogue de confirmation ?","noMatchingCondition":"Le composant sélectionné n'a pas de condition.","noMatchingAction":"Le composant sélectionné n'a pas d'actions.","importWorkflow":"Importer le flux de travail","sdcGrouping":"Disable SDC grouping"},"toolTip":{"name":"Le nom du flux de travail. Le type d'unité et l'organisation peuvent être inclus dans le nom pour le rendre plus facile à trouver","unitType":"Le type d'unité des unités qui peuvent utiliser ce flux de travail","organization":"L'organisation autorisée à modifier ce flux de travail","loginType":"La manière dont l'utilisateur doit se connecter sur l'unité avant de collecter l'argent. Lorsque la connexion automatique est sélectionnée, la procédure démarre lors de l'ouverture de la porte","firstUserRole":"Le rôle de l'utilisateur qui doit se connecter sur l'unité avant de collecter l'argent","secondUserRole":"Le rôle du deuxième utilisateur qui doit se connecter sur l'unité avant de collecter l'argent","allSteps":"Les pages que vous pouvez choisir pour qu'une unité les parcoure lors d'une procédure de transfert de fonds pour collecter de l'argent dans la machine. Les pages peuvent être sélectionnées en les faisant glisser de gauche à droite. Les pages qui commencent par (legacy) ne sont plus utilisées par les machines avec la version logicielle 4 et supérieure.","selectedSteps":"Les pages que l'unité parcourra lors d'une procédure de transfert de fonds pour collecter de l'argent dans la machine","performPrint":"Imprimer le reçu à la fin de la procédure","scanLength":"La longueur du code-barres sur le contenant qui contient l'argent","prefixBarcode":"Le texte avec lequel commence le code-barres, par exemple BE. Cela apparaîtra sur un bouton lorsque le code-barres sera saisi manuellement","emptyCoinDevice":"Supposer que le stockage des pièces sera vidé pendant le transfert de fonds et déduire la valeur des pièces de la valeur totale dans la machine","printOnCassetteDetached":"Après qu'une cassette est détachée, un reçu avec le contenu de cette cassette sera imprimé","placeholder":"Composant pour le type d'unité sélectionné.","placeholderAction":"Actions pour le composant sélectionné.","stepCondition":"Condition","stepSkip":"Passer à l'étape suivante","options":{"autologin":"Connexion automatique","singlelogin":"Connexion unique","multiplelogin":"Connexion multiple","locklogin":"Connexion avec code PIN de verrouillage"},"translationEn":"Le titre de l'étape sera affiché lorsque la langue anglaise est sélectionnée","translationNl":"Le titre de l'étape sera affiché lorsque la langue néerlandaise est sélectionnée","translationUs":"Le titre de l'étape sera affiché lorsque la langue anglaise (US) est sélectionnée","translationFr":"Le titre de l'étape sera affiché lorsque la langue française est sélectionnée","translationDe":"Le titre de l'étape sera affiché lorsque la langue allemande est sélectionnée","translationPl":"Le titre de l'étape sera affiché lorsque la langue polonaise est sélectionnée","translationEl":"Le titre de l'étape sera affiché lorsque la langue grecque est sélectionnée","translationHu":"Le titre de l'étape sera affiché lorsque la langue hongroise est sélectionnée","translationSk":"Le titre de l'étape sera affiché lorsque la langue slovène est sélectionnée","translationKey":"Clé de traduction","confirmDialog":"Dialogue de confirmation","importXmlTooltip":"Accepte uniquement un seul fichier .xml","sdcGrouping":"If this is checked, system will create separate 'Clear box item' per placeholder, instead of grouping them into one SDC."},"conditions":{"REJECT_BIN_IS_EMPTY":"La benne de rejet est vide","COIN_OVERFLOW_NOT_FULL":"Le débordement de pièces n'est pas plein"},"actions":{"create":"Ajouter un flux de travail","read":"Lire le flux de travail","update":"Mise à jour du flux de travail","delete":"Supprimer le workflow","readsettings":"Lecture des paramètres de flux de travail CIT","export":"Export workflow"},"messages":{"added":"Le flux de travail {name} est ajouté","updated":"Le flux de travail {name} est mis à jour","noPageSelected":"Veuillez sélectionner une étape","checkStepFormFields":"Vérifiez que tous les champs de l'étape sont corrects","stepAdded":"Étape ajoutée","stepUpdated":"Étape mise à jour","noStepSelectedV2":"Veuillez créer une étape","invalidXmlFile":"Veuillez télécharger un fichier XML valide","xmlUploadSuccess":"Le flux de travail a été importé avec succès","xmlUploadFailed":"Impossible de télécharger le flux de travail","cantMoveStepUp":"Can't move this Step up","cantMoveStepDown":"Can't move this Step down"},"workflow":{"Login":"(Legacy) Log in","Remove_left_cassette":"(Legacy) Remove left cassette","Insert_left_cassette":"(Legacy) Insert left cassette","Remove_right_cassette":"(Legacy) Remove right cassette","Insert_right_cassette":"(Legacy) Insert right cassette","Remove_any_cassette":"(Legacy) Remove any cassette","Insert_any_cassette":"(Legacy) Insert any cassette","Remove_cassette":"(Legacy) Remove cassette","Insert_cassette":"(Legacy) Insert cassette","Scan_left_reader_barcode":"(Legacy) Scan left reader barcode","Scan_right_reader_barcode":"(Legacy) Scan right reader barcode","Scan_new_cassette_barcode":"(Legacy) Scan new cassette barcode","Open_the_door_Linux":"(Legacy) Open the door (Linux)","Close_the_door__Linux":"(Legacy) Close the door (Linux)","Lock_the_door":"(Legacy) Lock the door","Sign_out":"(Legacy) Sign out","Unlock_the_door":"(Legacy) Unlock the door","Open_coin_acceptor_dropsafe_Linux":"(Legacy) Open coin acceptor dropsafe (Linux)","Empty_cassette_and_close_the_dropsafe_Linux":"(Legacy) Empty cassette and close the dropsafe (Linux)","Scan_new_left_cassette_barcode":"(Legacy) Scan new left cassette barcode","Scan_new_right_cassette_barcode":"(Legacy) Scan new right cassette barcode","Securing_safe":"(Legacy) Securing safe","CIT_procedure_completed":"(Legacy) CIT procedure completed","Open_the_door_Windows":"(Legacy) Open the door (Windows)","Close_the_door_Windows":"(Legacy) Close the door (Windows)","Open_coin_acceptor_dropsafe_Windows":"(Legacy) Open coin acceptor dropsafe (Windows)","Empty_cassette_and_close_the_dropsafe_Windows":"(Legacy) Empty cassette and close the dropsafe (Windows)","AUTO_UNLOCK_FRONT_DOOR":"Automatically unlock front door","WI_UNLOCK_FRONT_DOOR":"Unlock front door (no PIN)","LP_UNLOCK_FRONT_DOOR":"Unlock front door (LPLOCK)","LP_LOCK_FRONT_DOOR":"Lock front door (LPLOCK)","LP_OPEN_FRONT_DOOR":"Open front door (LPLOCK)","LP_CLOSE_FRONT_DOOR":"Close front door (LPLOCK)","VIM_READ_KEY_CIT":"Present CIT key","V2_UNLOCK_CIT_DOOR":"Unlock door (Linux)","V2_OPEN_CIT_DOOR_LINUX":"Open door (Linux)","V2_REMOVE_STORAGE":"Remove storage","V2_INSERT_STORAGE":"Insert storage","V2_CLOSE_CIT_DOOR_LINUX":"Close door (Linux)","V2_LOCK_CIT_DOOR":"Lock door (Linux)","V2_PROCESSING_CIT":"Secure safe - Lincstation","V2_REMOVE_CASSETTE":"Remove cassette","V2_INSERT_CASSETTE":"Insert cassette","V2_EMPTY_CASSETTE":"Empty cassette","V2_OPEN_CIT_DOOR_WINDOWS":"Open door (Windows)","V2_CLOSE_CIT_DOOR_WINDOWS":"Close door (Windows)","V2_REMOVE_LEFT_CASSETTE":"Remove left cassette","V2_INSERT_LEFT_CASSETTE":"Insert left cassette","V2_REMOVE_RIGHT_CASSETTE":"Remove right cassette","V2_INSERT_RIGHT_CASSETTE":"Insert right cassette","V2_LOGIN":"User Login","V2_CIT_PROCEDURE_COMPLETED":"CIT procedure completed","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_LINUX":"Open coin side safe (Linux)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_LINUX":"Empty coin side safe (Linux)","V2_SCAN_LEFT_READER_BARCODE":"Scan left barcode","V2_SCAN_RIGHT_READER_BARCODE":"Scan right barcode","V2_SCAN_STORAGE_BARCODE":"Scan storage","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_WINDOWS":"Open coin side safe (Windows)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_WINDOWS":"Empty coin side safe (Windows)","V2_OPEN_CIT_DOOR":"Open CIT door","V2_CLOSE_CIT_DOOR":"Close CIT door","V2_PROCESSING_LINCSTATION_CIT":"Secure safe (Lincstation)","V2_OPEN_THE_DOOR_LINUX":"Open door (Linux)","V2_CLOSE_THE_DOOR_LINUX":"Close door (Linux)","V2_UNLOCK_DOOR":"Unlock door (Linux)","V2_LOCK_DOOR":"Lock door (Linux)","V2_PROCESSING_SAFE_CIT":"Secure safe","V2_PRINT_LEFT_CASSETTE":"Print left cassette","V2_PRINT_RIGHT_CASSETTE":"Print right cassette","V2_PRINT_CIT_TOTAL":"Print CIT totals","V2_SEAL_BAG":"Seal bag","V2_UNLOCK_SIDESAFE_WITH_BO_COIN":"Unlock coin sidesafe","V2_UNLOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Unlock sidesafe","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_COIN":"Empty and lock coin sidesafe","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Empty and lock sidesafe","V2_SEALING_BAG":"Sealing bag","V2_REPLACE_SEAL_BAG":"Replace seal bag","V2_SCAN_COIN_STORAGE_BARCODE":"Scan coin storage","V2_COIN_ROLL_FILL_UP":"Coin roll fill up","V2_EMPTY_COUNTERS":"Empty counters","V2_WAIT_10":"Delay 10 seconds","V2_OPEN_OM61_DOOR":"Open OM61 door","V2_CLOSE_OM61_DOOR":"Close OM61 door","V2_UNLOCK_OM61_BAG_STORAGE":"Unlock OM61 bag storage compartment","V2_TAKE_OM61_STORAGE_BAG":"Take OM61 storage bag","V2_INSERT_NEW_OM61_STORAGE_BAG":"Insert OM61 new storage bag","V2_OPEN_CIT_DOOR_LINCSTATION_V3":"Open door (Lincstation v3)","V2_CLOSE_CIT_LINCSTATION_V3":"Close door (Lincstation v3)","V2_PROCESSING_CIT_LINCSTATION_V3":"Secure safe (Lincstation v3)","V2_UNLOCK_LINCSTATION_V3":"Unlock door (Lincstation v3)","V2_LOCK_LINCSTATION_V3":"Lock door (Lincstation v3)","V2_INSTALL_OM61_STORAGE_BAG":"Install OM61 storage bag","V2_UNLOCK_FRONT_DOOR":"Unlock front door","V2_UNLOCK_FRONT_DOOR_SPT":"Unlock front door (SPT)","V2_OPEN_FRONT_DOOR":"Open front door","V2_CLOSE_FRONT_DOOR":"Close front door","V2_LOCK_FRONT_DOOR":"Lock front door","V2_LOCK_FRONT_DOOR_SPT":"Lock front door (SPT)","V2_EMPTY_ESCROW":"Empty escrow","V2_PAUSE_CIT":"Pause CIT","V2_REMOVE_REJECT_BIN":"Remove reject bin","V2_CONFIRM_EMPTY_REJECT_BIN":"Confirm empty reject bin","V2_INSERT_REJECT_BIN":"Insert reject bin","V2_FILL_UP_COINS":"Fill up coin recycler","V2_OPEN_COIN_OVERFLOW_DOOR_SPT":"Open coin overflow door (SPT)","V2_EMPTY_COINS_AND_CLOSE_COIN_OVERFLOW_DOOR_SPT":"Empty coins and close coin overflow door (SPT)","V2_SECURE_SAFE":"Secure safe","V2_REMOVE_PULOON_CASSETTE_1":"Remove 1st present dispenser cassette","V2_REMOVE_PULOON_CASSETTE_2":"Remove 2nd present dispenser cassette","V2_INSERT_PULOON_CASSETTE_1":"Insert 1st new dispenser cassette","V2_INSERT_PULOON_CASSETTE_2":"Insert 2nd new dispenser cassette","V2_UNLOCK_CIT_DOOR_2":"Unlock CIT door 2","V2_LOCK_CIT_DOOR_2":"Lock CIT door 2","V2_OPEN_CIT_DOOR_LINUX_2":"Open safe door (Linux) 2","V2_CLOSE_CIT_DOOR_LINUX_2":"Close safe door (Linux) 2","V2_UNLOCK_FRONT_DOOR_2":"Unlock front door 2","V2_UNLOCK_FRONT_DOOR_SPT_2":"Unlock front door 2 (SPT)","V2_OPEN_FRONT_DOOR_2":"Open front door 2","V2_CLOSE_FRONT_DOOR_2":"Close front door 2","V2_LOCK_FRONT_DOOR_2":"Lock front door 2","V2_LOCK_FRONT_DOOR_SPT_2":"Lock front door 2 (SPT)","V2_SECURE_CIT_DOOR":"Secure CIT door (SPT)","V2_SECURE_CIT_DOOR_2":"Secure CIT door 2 (SPT)","V2_SECURE_FRONT_DOOR":"Secure front door (SPT)","V2_SECURE_FRONT_DOOR_2":"Secure front door 2 (SPT)","V2_SKIP_EMPTY_ESCROW_SAFEBAG_FULL":"Skip emptying escrow when sealbag is full","dynamic":{"LOCK_OPEN":"Open lock","LOCK_CLOSE":"Close lock","LOCK_OPEN_WITH_PIN":"Open lock with pin","DOOR_OPEN":"Open door","DOOR_CLOSE":"Close door","DOOR_SECURE":"Secure door","CIT_COMPLETED":"Cit completed","CIT_PAUSE":"Cit paused","CIT_DIALOG":"Cit dialog","CIT_USER_LOGIN":"Cit user login","COIN_FILL_UP":"Fill up coin","COIN_EMPTY_OVERFLOW_STORAGE":"Empty coin overflow storage","STORAGE_REMOVE_CASSETTE":"Remove storage cassette","STORAGE_ATTACH_CASSETTE":"Attach storage cassette","STORAGE_PULOON_REMOVE_DISPENSER_1":"Remove storage puloon dispenser 1","STORAGE_PULOON_ATTACH_DISPENSER_1":"Attach storage puloon dispenser 1","STORAGE_PULOON_REMOVE_DISPENSER_2":"Remove storage puloon dispenser 2","STORAGE_PULOON_ATTACH_DISPENSER_2":"Attach storage puloon dispenser 2","STORAGE_PULOON_REMOVE_DISPENSER_3":"Remove storage puloon dispenser 3","STORAGE_PULOON_ATTACH_DISPENSER_3":"Attach storage puloon dispenser 3","STORAGE_PULOON_REMOVE_DISPENSER_4":"Remove storage puloon dispenser 4","STORAGE_PULOON_ATTACH_DISPENSER_4":"Attach storage puloon dispenser 4","STORAGE_PULOON_REMOVE_REJECT_BIN":"Remove storage puloon reject bin","STORAGE_PULOON_ATTACH_REJECT_BIN":"Attach storage puloon reject bin","COIN_REMOVE_AND_EMPTY_OVERFLOW_STORAGE":"Remove and empty coin bucket","COIN_FILL_UP_SPLIT_START":"Start split fill up","COIN_FILL_UP_SPLIT_END":"Stop split fill up","COIN_INSERT_OVERFLOW_STORAGE":"Insert coin bucket","CIT_IBUTTON_LOGIN":"iButton login","MANUAL_DEPOSIT_EMPTY":"Empty manual deposit","CENCON_LOCK_OPEN":"Open Cencon lock","CENCON_LOCK_CLOSE":"Close Cencon lock","TRAY_OPEN":"Open hitachi door","TRAY_CLOSE":"Close hitachi door","HITACHI_REJECT_BOX_CLOSE":"Close reject box","HITACHI_REJECT_BOX_OPEN":"Open reject box and empty its contents","STORAGE_ONE_ATTACHED":"Attach Puloon storage cassette","STORAGE_ONE_REMOVED":"Remove Puloon storage cassette","HITACHI_STORAGE_ONE_ATTACHED":"Attach hitachi storage","HITACHI_STORAGE_ONE_REMOVED":"Remove hitachi storage","HITACHI_STORAGE_TWO_ATTACHED":"Attach Hitachi storage cassette 2","HITACHI_STORAGE_TWO_REMOVED":"Remove Hitachi storage cassette 2","HITACHI_STORAGE_THREE_ATTACHED":"Attach Hitachi storage cassette 3","HITACHI_STORAGE_THREE_REMOVED":"Remove Hitachi storage cassette 3","HITACHI_STORAGE_FOUR_ATTACHED":"Attach Hitachi storage cassette 4","HITACHI_STORAGE_FOUR_REMOVED":"Remove Hitachi storage cassette 4","HITACHI_STORAGE_FIVE_ATTACHED":"Attach Hitachi storage cassette 5","HITACHI_STORAGE_FIVE_REMOVED":"Remove Hitachi storage cassette 5","HITACHI_STORAGE_ONE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 1","HITACHI_STORAGE_ONE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 1","HITACHI_STORAGE_TWO_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 2","HITACHI_STORAGE_TWO_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 2","HITACHI_STORAGE_THREE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 3","HITACHI_STORAGE_THREE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 3","HITACHI_STORAGE_FOUR_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 4","HITACHI_STORAGE_FOUR_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 4","HITACHI_STORAGE_FIVE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 5","HITACHI_STORAGE_FIVE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 5","HITACHI_STORAGE_SIX_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 6","HITACHI_STORAGE_SIX_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 6"},"V2_REMOVE_SEALPACK_FROM_COIN_STORAGE":"Take out sealpack from coin storage","V2_INSERT_NEW_SEALPACK_TO_COIN_STORAGE":"Insert new sealpack to coin storage"},"dialog":{"title":"Confirm change order","description":"The Step: {stepOrder} can't be moved without breaking Skip to value of Step: {colindantStepOrder}","confirmation":"Change order anyway and remove Skip to value ?"}},"notification":{"titles":{"read":"Détails de la notification"},"read":"Détails de la notification"},"report":{"buttons":{"createReport":"CREER UN RAPPORT","generating":"Generating..."},"titles":{"overview":"Rapport","create":"Ajouter un rapport","update":"Rapport de mise à jour"},"breadcrumb":{"title":"Rapport"},"form":{"orgUuid":"Organisation","unitUuid":"Unité","type":"Type","startDate":"De","endDate":"À","types":{"getReptileCampaignsAndTransactionsByDate":"Transactions et clear boxes","getReptileCampaignsAndTransactionsMoneyInOutCounterByDate":"Transactions et clear boxes avec compteur d'entrée/sortie d'argent","getReptileTransactionsByDate":"Transactions","getManualTransactionsByDate":"[Deprecated] Dropsafe","getReptileManualTransactionsByDate":"Dropsafe - Nouveau","getReptileReportForClosedCampaignsByUnitAndDate":"Clearboxes","getReptileClearboxDenomination":"[Deprecated] Clearboxes denomination","getReptileClearboxDenominationV2":"Clearboxes denomination","getReptileEndOfDayInfoByDate":"Unité de fin de journée Total","getReptileLincstationEndOfDayInfoByDate":"Lincstation Unité de fin de journée Total","getEndOfDayClientsByDate":"[Deprecated] Clients de fin de journée","getReptileEndOfDayClientsByDate":"Clients de fin de journée - Nouveau","getEventsByDate":"Évènements par date","getReptileEventsByDate":"Évènements par date - Nouveau","getReptileReportForDenominationPerUser":"Dénominations par utilisateur","getReptileReportForDenominationWithPin":"Dénominations avec Pin","getReptileSalesByDate":"Ventes - New","getInternalTransactionsByDate":"[Deprecated] Transactions internes","getReptileInternalTransactionsByDate":"Transactions internes - Nouveau","getReptileAdvancedManualDeposit":"Advanced manual deposits","getReptileRecyclerReport":"Lincstation overall report","getReptileTransactionsWithReference":"Transactions avec numéro de référence","getTransactionsWithReference":"[Deprecated] Transactions avec numéro de référence","getCampaignsWithBarcodes":"[Deprecated] Clearboxes avec Sealnumbers","getSalesByDate":"[Deprecated] Ventes","getCurrentlyOfflineUnits":"Currently Offline Units (.csv)","getReptileCashCoinEndOfDayInfoByDate":"End of Day Cash/Coin","getReptileUnitInventory":"Unit Inventory (.pdf)","getReptileCampaignsAndTransactionsByDateWithSource":"Smartsafes transactions and clearboxes","getReptileEndOfDaySmartSafes":"Smartsafes End Of Day (.pdf)","getReptileEndOfDaySmartSafesXlsx":"Smartsafes End Of Day (.xlsx)","getReptileEndOfDayRecyclerXlsx":"Recycler End Of Day (.xlsx)","getReptileCampaignSmartSafesPdf":"Smartsafes Campaign (.pdf)","getReptileCampaignSmartSafesXlsx":"Smartsafes Campaign (.xlsx)","getReptileTransactionSmartSafesPdf":"Smartsafes Transaction (.pdf)","getReptileTransactionSmartSafesXlsx":"Smartsafes Transaction (.xlsx)","getReptileTransactionSmartSafesDetailedPdf":"Smartsafes Transaction Detailed (.pdf)","getReptileTransactionSmartSafesDetailedXlsx":"Smartsafes Transaction Detailed (.xlsx)","getOrganizationAssetsXlsx":"Smartsafes Asset Management (.xlsx)","getOrganizationAssetsPdf":"Smartsafes Asset Management (.pdf)","getReptileEventSmartSafesXlsx":"Smartsafes Event (.xlsx)","getReptileEventSmartSafesPdf":"Smartsafes Event (.pdf)"}},"messages":{"success":"Le rapport a été récupéré avec succès. Le fichier devrait commencer automatiquement à télécharger ...","failed":"The report could not be generated. Please try again later","reptileDateLimitExceeded":"Le rapport n'a pas pu être généré. La limite de date spécifiée a été dépassée. Veuillez ajuster votre plage de dates et réessayer.","reptileGenericBadRequest":"Le rapport n'a pas pu être généré en raison d'une requête incorrecte. Veuillez vérifier vos paramètres d'entrée et réessayer ultérieurement.","cannotOutputToCsvFile":"The report could not be generated. Please try again later and/or with different parameters.","errorOccurred":"The report could not be generated. Unknown error occurred."},"dialog":{"title":"Le rapport a été récupéré avec succès.","download":"Cliquez ici pour télécharger le rapport","close":"Fermer"}},"transaction":{"read":"Détail de la transaction"},"adminsettings":{"titles":{"overview":"Maintenance des devises"},"breadcrumb":{"title":"Aperçu"},"messages":{"updated":"Devise et valeurs actualisées","error":"Quelque chose s'est mal passé, devise et valeurs non actualisées"},"form":{"currency":"Devise","iso1":"ISO1","iso2":"ISO2","iso3":"ISO3","symbol":"Symbole","symbolCode":"Code du symbole","defaultValue":"Valeur par défaut","enabled":"Activé","denomination":{"value":"Valeur","coins":"Pièces","bills":"Billets","enabled":"Activé","remove":"Supprimer"}}},"mix":{"titles":{"overview":"Combinaisons","create":"Ajouter une combinaison","update":"Mettre à jour la combinaison"},"breadcrumb":{"title":"Aperçu"},"form":{"mixName":"Nom de la combinaison","totalAmount":"Montant total","organization":"Organisation","denominations":"Dénominations","currency":"Currency","eur":"EURO","usd":"USD","gbp":"GBP"},"columns":{"name":"Nom de la combinaison","totalAmount":"Montant total","details":"Détails","totalValue":"Valeur totale"},"read":{"mixDetails":"Détails de la combinaison"},"actions":{"create":"Ajouter une combinaison","update":"Mettre à jour la combinaison","delete":"Supprimer la combinaison","read":"Lire la combinaison"}},"common":{"form":{"bankAccount":"Primary bank account number","citAccount":"CIT account number","affiliateCode":"Affiliate code","overrideBankAccount":"Remplacer le numéro de compte bancaire principal","overrideCitAccount":"Remplacer le numéro de compte CIT","overrideAffiliateCode":"Remplacer le code d’affiliation"},"toolTip":{"bankAccount":"Bank account number to which deposits/withdrawals are transmitted from the safe(s). Can be overridden at a more granular level","citAccount":"Bank account number to which funds are deposited after CIT. Usually the same as primary bank account number","affiliateCode":"4 digit alphabetical code"}},"department":{"titles":{"overview":"Departments","create":"Create a department","update":"Update department","preview":"Preview department"},"breadcrumb":{"title":"Aperçu"},"columns":{"name":"Name","organizationName":"Organization"},"form":{"name":"Name","organization":"Organization","bankAccount":"Bank account number"},"toolTip":{"organization":"Which organization does this department belong to","bankAccount":"Optional bank account number to which deposits/withdrawals are transmitted from the safe(s)","overrideBankAccount":"Do not inherit primary bank account from unit. Instead, define a new one specific to this department"},"actions":{"create":"Create department","read":"Preview department","update":"Update department","delete":"Delete department","preview":"Preview department"},"messages":{"added":"Department {name} has been created","updated":"Department {name} has been updated"}},"unitRoles":{"titles":{"overview":"Unit roles","create":"Add a unit role","update":"Update unit role"},"breadcrumb":{"title":"Aperçu"},"columns":{"name":"Unit role name","organization":"Organization"},"actions":{"create":"Add unit role","update":"Update unit role","delete":"Delete unit role"},"form":{"name":"Unit role name","organization":"Organization","transactionCashOutLimit":"Transaction cash out limit","dailyCashOutLimit":"Daily cash out limit","permissions":"Permissions"},"messages":{"added":"The unit role {name} is added","updated":"The unit role {name} is updated"}}},"server_messages":{"accessNotAllowed":"Accès non autorisé.","authorizationFailed":"L'autorisation à échouée.","campaignNotFound":"Campagne non trouvée!","cityCannotBeEmpty":"La ville ne peut pas être vide!","componentNotFound":"Composant non trouvé!","countryCannotBeEmpty":"Le pays ne peut pas être vide!","countryNotFound":"Pays non trouvé!","credentialsCannotBeEmpty":"Les informations d'identification ne peuvent pas être vides","currencyNotFound":"Monnaie non trouvée!","duplicateItemFound":"Dupliquer l'article trouvé!","errorOccurred":"Une erreur est survenue et enregistrée.","ILLEGAL_ARGUMENT":"Mauvaise entrée","ILLEGAL_ARGUMENT_ADDRESS_TYPE":"Quelque chose s'est mal passé avec l'adresse","ILLEGAL_ARGUMENT_ADDRESSLINE1":"Veuillez changer l'adresse ligne un","ILLEGAL_ARGUMENT_ADDRESSLINE2":"S'il vous plaît changer l'adresse ligne deux","ILLEGAL_ARGUMENT_BANK_ACCOUNT":"S'il vous plaît changer le compte bancaire","ILLEGAL_ARGUMENT_CHILD_ORGANIZATION":"S'il vous plaît changer l'organisation de l'enfant","ILLEGAL_ARGUMENT_CIT":"Quelque chose s'est mal passé avec les informations CIT","ILLEGAL_ARGUMENT_CITY":"S'il vous plaît changer la ville","ILLEGAL_ARGUMENT_CLIENT_ORGANIZATION":"S'il vous plaît changer l'organisation du client","ILLEGAL_ARGUMENT_COUNTRY":"S'il vous plaît changer le pays","ILLEGAL_ARGUMENT_CURRENCY":"S'il vous plaît changer la devise","ILLEGAL_ARGUMENT_DATE":"S'il vous plaît changer la date","ILLEGAL_ARGUMENT_DESCRIPTION":"S'il vous plaît changer la description","ILLEGAL_ARGUMENT_FIRST_NAME":"S'il vous plaît changer le prénom","ILLEGAL_ARGUMENT_GENDER":"Quelque chose a mal tourné avec le genre","ILLEGAL_ARGUMENT_ID":"S'il vous plaît changer l'ID","ILLEGAL_ARGUMENT_LAST_NAME":"S'il vous plaît changer le nom de famille","ILLEGAL_ARGUMENT_LEGAL_FORM":"S'il vous plaît changer la forme juridique","ILLEGAL_ARGUMENT_LOCATION":"S'il vous plaît changer l'emplacement","ILLEGAL_ARGUMENT_LOCATION_UUID":"Impossible de trouver l'emplacement","ILLEGAL_ARGUMENT_MACHINE_TYPE":"Veuillez changer le type de machine","ILLEGAL_ARGUMENT_MAIL":"S'il vous plaît changer l'adresse e-mail","ILLEGAL_ARGUMENT_MAINTENANCE":"Quelque chose s'est mal passé avec les informations de maintenance","ILLEGAL_ARGUMENT_NAME":"S'il vous plaît changer le nom","ILLEGAL_ARGUMENT_ORGANIZATION":"S'il vous plaît changer l'organisation","ILLEGAL_ARGUMENT_ORGANIZATION_TYPE":"Veuillez changer le type d'organisation","ILLEGAL_ARGUMENT_ORGANIZATION_UNIT_TYPE":"Quelque chose ne va pas avec la combinaison d'organisation et de type d'unité","ILLEGAL_ARGUMENT_ORGANIZATION_UUID":"Impossible de trouver l'organisation","ILLEGAL_ARGUMENT_OWNER_ORGANIZATION":"S'il vous plaît changer propriétaire de l’organisation","ILLEGAL_ARGUMENT_PAGE_NUMBER":"Quelque chose s'est mal passé avec le numéro de page","ILLEGAL_ARGUMENT_PAGE_SIZE":"Quelque chose s'est mal passé avec la taille de la page","ILLEGAL_ARGUMENT_PARENT_ORGANIZATION":"S'il vous plaît changer l'organisation mère","ILLEGAL_ARGUMENT_PASSWORD":"S'il vous plaît changer le mot de passe","ILLEGAL_ARGUMENT_PERSON":"Quelque chose s'est mal passé avec les informations utilisateur","ILLEGAL_ARGUMENT_PHONE_NUMBER":"S'il vous plaît changer le numéro de téléphone","ILLEGAL_ARGUMENT_PIN":"S'il vous plaît changer le code PIN","ILLEGAL_ARGUMENT_REPORTED_ORGANIZATIONS":"S'il vous plaît changer les organisations rapportées","ILLEGAL_ARGUMENT_ROLES":"S'il vous plaît changer les rôles","ILLEGAL_ARGUMENT_SDC":"Quelque chose s'est mal passé avec la boîte transparente","ILLEGAL_ARGUMENT_SERIAL":"S'il vous plaît changer le numéro de série","ILLEGAL_ARGUMENT_TOKEN":"Quelque chose ne va pas avec les informations de connexion","ILLEGAL_ARGUMENT_UNIT":"S'il vous plaît changer l'unité","ILLEGAL_ARGUMENT_UNIT_TYPE":"S'il vous plaît changer le type d'unité","ILLEGAL_ARGUMENT_UNIT_UUID":"Impossible de trouver l'unité","ILLEGAL_ARGUMENT_USER":"S'il vous plaît changer l'utilisateur","ILLEGAL_ARGUMENT_UUID":"Impossible de récupérer les informations","INVALID_CREDENTIALS":"les informations d'identification invalides","INVALID_PATH":"Chemin invalide","invalidData":"Données invalides","legalFormNotFound":"Forme légale non trouvée!","locationInUse":"Lieu d'utilisation","locationNameCannotBeEmpty":"Le nom de l'emplacement ne peut pas être vide!","locationNotFound":"Lieu non trouvé!","locationUpdateDataIsInvalid":"Les données de mise à jour d'emplacement sont invalides!","LOCKED":"Fermé à clef","LOGOUT":"Déconnecté!","NO_RESULT":"Pas de résultat","organizationInUse":"Organisation utilisée","organizationListFetched":"Liste d'organisation récupérée.","organizationNotFound":"Organisation non trouvée.","organizationTypeNotFound":"Type d'organisation non trouvé.","passwordIsInvalid":"Le mot de passe est invalide!","phoneNumberLengthIsIncorrect":"La longueur du numéro de téléphone est incorrecte","pinIsEmpty":"Veuillez insérer un code PIN","pinNotNumeric":"N'utilisez que des chiffres dans l'épingle, s'il vous plaît","roleNotFound":"Rôle non trouvé.","sessionTimeout":"Session timeout","settingsNotFound":"Paramètres non trouvés","SUCCESS":"Succès","SYSTEM_FAIL":"Le système a échoué!","transactionNotFound":"Transaction non trouvée","UNABLE_TO_STORE_INFO":"Les données n'ont pas pu être sauvegardées","UNAUTHORIZED":"L'accès non autorisé","unitNotFound":"Unité non trouvée.","unitTypeListFetched":"Liste de type d'unité récupérée.","userAlreadyExists":"L'utilisateur existe déjà","userIsLocked":"L'utilisateur est verrouillé.","userNotFound":"Utilisateur non trouvé","workflowInUseByOtherOrg":"Flux de travail utilisé par un autre organisation, changez l'organisation, s'il vous plait","workflowNotFound":"Flux de travail non trouvé!","invalidFormatException":"Invalid data format, please check data in JSON structure","unrecognizedPropertyException":"Please check properties in JSON structure","jsonParseException":"Couldn't parse JSON, please check structure","jsonMappingException":"Couldn't map JSON, please check structure","iOException":"Couldn't parse JSON, please check structure","minimumGreaterThanOptimum":"Minimum amount greater than optimum","maximumLessThanOptimum":"Maximum amount less than optimum","ILLEGAL_ARGUMENT_MIX_UUID":"Cannot find mixes","ILLEGAL_ARGUMENT_MAX_AMOUNT":"Please change maximum amount","TILL_IS_BEING_USED_BY_USER":"Till is being used by user","TILL_IS_BEING_USED_BY_UNIT":"Till is being used by unit","secretIsEmpty":"Empty secret found","secretAlreadyExists":"Invalid secret generated. Please generate again","MIN_FOUR_DIGITS":"PIN must be at least 4 digits in length","MIN_SIX_DIGITS":"PIN must be at least 6 digits in length","MAX_SIX_DIGITS":"PIN must be at most 6 digits in length","NO_DUPLICATE_DIGITS":"PIN must not have repeated digits","NO_INCREMENTING_DIGITS":"PIN must not be in incrementing order","NO_DECREMENTING_DIGITS":"PIN must not be in decrementing order","MAX_NINETY_DAYS":"Pin expired after 90 days, Please change pin","MAX_SIXTY_DAYS":"Pin expired after 60 days, Please change pin","MAX_THIRTY_DAYS":"Pin expired after 30 days, Please change pin","PIN_LENGTH_NOT_IN_4_TO_6":"Pin length between 4 and 6 digits","ILLEGAL_ARGUMENT_USERNAME_NULL":"External Username must not be null","ILLEGAL_ARGUMENT_EXTERNAL_USERNAME_IS_NULL":"External Username must not be null","ILLEGAL_ARGUMENT_EXTERNAL_PASSWORD_IS_NULL":"External password must not be null","ILLEGAL_ARGUMENT_EXTERNAL_HS600_PASSWORD_INVALID":"External HS600 password is invalid. Only numeric values allowed","ILLEGAL_ARGUMENT_ROLES_ONE_EXTERNAL_HS600_ROLE_ALLOWED":"Only one external HS600 role is allowed","maxDispensableGreatherThenAllowed":"Max dispensable is greather then allowed","MFA_REQUIRED":"Multi factor authentication required","duplicateSafeIdFound":"Safe ID already exists!","validationError":"Validation failed.","ILLEGAL_ARGUMENT_MIX_DENOMINATIONS":"Please select currency.","unitRoleInUseByUser":"This unit cannot be deleted because it is currently assigned to a user.","emailNotUnique":"The email address is already in use","NON_UNIQUE_USERNAME":"Duplicate user accounts found, please contact your administrator","departmentAlreadyExists":"Department name has already been taken. Please choose another name","workflowInUseByUnits":"Workflow in use by units [{reason}]. Make sure no units are using this workflow before deleting it."},"placeholder_names":{"cit":{"LR":"Dépôt de note gauche","RR":"Dépôt de note à droite","CA":"Débordement de pièces","BA":"Dépôt de note","R3":"Dépôt de note moyenne","B1":"Dépôt de note","RC":"Dépôt de note","CC":"Débordement de pièces"},"LR":"Lecteur de billets gauche","RR":"Lecteur de facture droit","PR":"Imprimante","CA":"Accepteur de pièces","BO":"Tableau de discussion","DS":"Capteur de porte","PU":"Distributeur de billets","SC":"Double Recycleur de pièces","SS":"Capteur latéral","SD":"Capteur côté conducteur","WI":"Serrure intelligente Lincsafe","LL":"Verrou inférieur","HO":"Trémie à monnaie","BA":"Accepteur de facture","DR":"Lecteur de porte","R3":"Lecteur de billets moyen","ST":"Capteur supérieur","TD":"Capteur supérieur du conducteur","SB":"Capteur de pilote inférieur","BD":"Capteur de pilote inférieur","B1":"Lecteur de facture","H1":"Trémie un","H2":"Hopper deux","UL":"Serrure supérieure","BP":"Bip","RC":"Recycleur de billet","CC":"Recycleur de pièces","DT":"Porte supérieure","DM":"Porte du milieu","DB":"Porte du bas","CD":"Porte CIT","MD":"Capteur de porte de maintenance en série","RF":"Lecteur RFID","SL":"Sealer","UNIT":"Unité","null":"","DRAWER":"Drawer","SIDE_SAFE":"Side safe","COIN_DROP_SAFE":"Coin drop safe","COIN_ROLL":"Coin roll","PIN_TERMINAL":"PIN terminal","WI_MAINTENANCE":"Serrure intelligente de porte de maintenance Lincsafe","om61":"OM61","DOOR_BOTTOM":"Porte du bas","DOOR_MIDDLE":"Porte du milieu","DOOR_TOP":"Haut par","EXB":"Carte d'extension","MLOCK_TOP":"Top m-lock","SOLENOID_BOTTOM":"Solénoïde inférieur","SWITCH_COIN_TUBE":"Coin chute","WI_MIDDLE":"Serrure de tête blanche moyenne","NETWORK":"Network","STORAGE_INVENTORY":"Storage inventory","UNKONWN":"Inconnu","DOOR_FRONT":"Door front sensor","DOOR_LEFT":"Door left sensor","DOOR_RIGHT":"Door right sensor","SOLENOID":"Solenoid","VIM":"Vault Interface Module","LOCK_FRONT":"Front door lock","LPLOCK":"Front door lock","MLOCK":"MLock","BOTTOM_LOCK":"Bottom lock","BO_1":"Bo 1","BO_2":"Bo 2","BUTTON_A":"Button A","BUTTON_B":"Button B","BUTTON_C":"Button C","BUTTON_D":"Button D","DOOR_TOP_LEFT":"Door top left","DOOR_TOP_RIGHT":"Door top right","EBM":"EBM","EBS":"EBS","HOPPERS":"Hoppers","HSCD":"HSCD","TOP_LEFT_LOCK":"Top left lock","WI_TOP":"WI top","CIT_COMPLETED":"Unit","DOOR_HATCH":"Door top hatch sensor","LPLOCK_STORAGE":"LP lock storage","IBUTTON":"iButton","HITACHI_LOCK":"Cencon lock","XR":"Hitachi","JACK_STATUS":"État de la prise casque"},"compartment_names":{"RECYCLER":"RECYCLEUR","STORAGE":"ESPACE DE RANGEMENT","MANUAL_STORAGE":"Manual storage","ESCROW":"ESCROW","HOPPERS":"HOPPERS","REJECT":"REJECT"},"notifications":{"ACCEPTING":"Appareil de paiement accepté / accepte","BOTTOM_DOOR_OPEN":"La porte de trop-plein accepteur de pièce est ouverte!","BOTTOM_SIDE_DOOR_OPEN":"La porte latérale du bas est ouverte","CALIBRATING":"Le dispositif de caisse est en cours de calibration","CARTRIDGE_DETACHED":"Cartridge has been detached","CHEATED":"Cheat attempt detected","CIT_DOOR_OPEN":"Cit à travers ouvert","COIN_DRAWER_OPENED":"Coin drawer opened","COIN_DROP_SAFE_OPENED":"Coin side safe is opened","DEVICE_CAN_NOT_PAYOUT":"Inventaire pas assez pour payer","DOOR_OPEN":"Porte ouverte","DOWNLOADING":"Téléchargement du firmware","DRAWER_OPENED":"Drawer opened","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Entrance is not empty","errorOccurred":"Erreur Interne du Serveur","EXTENSION_STALL":"Stalled","EXCEEDS_PAYOUT_LIMIT":"La valeur du paiement dépasse la limite de paiement.","FAILED":"Failure has been detected","FEED_FAILURE":"Feed failed","FLOAT_NOT_SET":"La valeur flottante n'a pas été définie sur le portail, veuillez d'abord définir la valeur sur le portail!","ILLEGAL_ARGUMENT":"Argument illégal","INSURABLE_VALUE_REACHED":"Valeurs assurable atteinte, veuillez vider la machine!","CASSETTE_LIMIT_REACHED":"Limite de cassette atteinte","INVALID_CREDENTIALS":"Les informations d'identification invalides!","INVENTORY_LOWER_THAN_FLOAT":"L'inventaire est déjà inférieur à float","INVENTORY_NOT_SUFFICIENT":"L'inventaire n'est pas suffisant, veuillez remplir la machine!","INVENTORY_OVER_MAX":"Le niveau d'inventaire est supérieur au maximum, veuillez faire descendre la machine!","INVENTORY_SETTINGS_NULL":"Impossible de trouver les paramètres d’inventaire, veuillez contacter le responsable!","INVENTORY_UNDER_MIN":"Le niveau d'inventaire est inférieur au minimum, veuillez remplir la machine!","INVENTORY_UNDER_LOW":"Le niveau d'inventaire est bas, veuillez remplir la machine!","JAMMED":"L'appareil est coincé","LAST_TRANSACTION_FAILED":"Le dernier paiement a échoué, veuillez contacter le responsable!","LOCK_NOT_SECURE":"Smart (wittkopp) le verrouillage n’est pas sécurisé!","MACHINE_BUSY":"La machine est déjà occupée, veuillez patienter pour terminer l'opération en cours.","MACHINE_NOT_OPERATIONAL":"La machine n'est pas opérationnelle, veuillez vérifier les notifications","MAINTENANCE_DOOR_OPEN":"Porte de maintenance ouverte","MIDDLE_DOOR_OPEN":"La porte du CIT est ouverte!","NO_ACCESS":"Personnel does not have access<br/>to the value in the safe","NOT_CONNECTED":"L'appareil n'est pas connecté","NOT_OPERATIONAL":"Non opérationnel","NOT_RECYCLED_MATERIAL":"Pas un matériau recyclé","NOT_SECURE":"La machine n'est pas sécurisée, veuillez contacter le responsable!","ORGANIZATION_NOT_FOUND":"Organisation introuvable","OVERRIDDEN":"Annulé","PAPER_EMPTY":"Le papier est vide","PAPER_LOW":"Le papier est faible","PAUSE":"Pause","PAYOUT_FAILED":"Impossible de payer la valeur","PAYOUT_LIMIT_NOT_FOUND":"La limite de paiement n'a pas encore été définie!","PIN_EMPTY":"Le code pin ne peut pas être vide!","POWER_UP":"Mise sous tension","RECYCLER_ALMOST_EMPTY":"Le recycleur est presque vide","RECYCLER_ALMOST_FULL":"Le recycleur est presque plein","RECYCLER_EMPTY":"Le recycleur est vide","RECYCLER_FULL":"Le recycleur est plein","REJECT_NOT_EMPTY":"Reject is not empty","SIDE_DOOR_ONE_OPEN":"La porte latérale est ouverte (1)","SIDE_DOOR_OPEN":"La porte latérale est ouverte","SIDE_SAFE_OPENED":"Side safe opened","STACKER_FULL":"L'empileur est plein","STALLED":"En panne","STORAGE_ALMOST_FULL":"La cassette est presque pleine, veuillez vider la machine","STORAGE_DETACHED":"La cassette est détachée","STORAGE_FULL":"La cassette est pleine, veuillez vider la machine","TOP_DOOR_OPEN":"La porte de maintenance est ouverte!","TOP_SIDE_DOOR_OPEN":"La porte supérieure est ouverte","USER_BLOCKED":"L'utilisateur a été bloqué","USER_NOT_FOUND":"Utilisateur introuvable","WORKFLOW_NOT_FOUND":"Le flux de travail Cit n'a pas été trouvé, veuillez vérifier le portail","ZERO_AMOUNT":"Le montant doit être supérieur à 0","PAYMENT_NOT_POSSIBLE_WITH_THIS_AMOUNT":"Paiement impossible avec ce montant","INVALID_CONFIGURATION":"Configuration du recycleur incorrecte","LAST_NOTE_HIGHEST_RECYCLED_VALUE":"Un seul billet de grande valeur à la suite autorisé","MAX_AMOUNT_REACHED":"Le recycleur pour cette dénomination est plein","NON_RECYCLED_DENOMINATION":"La dénomination n'est pas recyclée","THREE_HIGH_VALUE_NOTES_IN_SUCCESSION":"Pas plus de trois billets de haute dénomination consécutifs sont autorisés","NOT_OPERATIONAL_005":"Coin roll dispenser for 5 cents is not operational","NOT_OPERATIONAL_010":"Coin roll dispenser for 10 cents is not operational","NOT_OPERATIONAL_020":"Coin roll dispenser for 20 cents is not operational","NOT_OPERATIONAL_050":"Coin roll dispenser for 50 cents is not operational","NOT_OPERATIONAL_100":"Coin roll dispenser for 1 euro is not operational","NOT_OPERATIONAL_200":"Coin roll dispenser for 2 euro is not operational","STORAGE_ALMOST_EMPTY_005":"Coin roll dispenser is almost empty for 5 cents","STORAGE_ALMOST_EMPTY_010":"Coin roll dispenser is almost empty for 10 cents","STORAGE_ALMOST_EMPTY_020":"Coin roll dispenser is almost empty for 20 cents","STORAGE_ALMOST_EMPTY_050":"Coin roll dispenser is almost empty for 50 cents","STORAGE_ALMOST_EMPTY_100":"Coin roll dispenser is almost empty for 1 euro","STORAGE_ALMOST_EMPTY_200":"Coin roll dispenser is almost empty for 2 euro"}}

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

	module.exports = {"generic":{"application_name":"LincSafe Portal","copy_right":"Alle rechten voorbehouden","submenu":{"title":"Organisaties","reset_text":"Reset"},"mainmenu":{"login":"Inloggen","submenu":"Submenu","units":"Units","users":"Gebruikers","locations":"Locaties","organizations":"Organisaties","tills":"Geldlades","mixes":"Kassa mix","report":"Rapporten","citworkflow":"CIT procedure","softwaresettings":"Software instellingen","adminsettings":"Admin instellingen","departments":"Departments","roles":"Unit roles"},"overview":{"pagination":{"showing":"<strong>{current}</strong> van <strong>{total}</strong> resultaten","pagesize":{"before":"Bekijk","after":"resultaten"},"success":{"added":"Toegevoegd {field}","updated":"Gewijzigd {field}","deleted":"Verwijderd {field}","unlocked":"Ontgrendeld {field}"}},"dialog":{"delete":{"title":"Verwijderen bevestigen","description":"U staat op het punt om <strong>{name}</strong> te verwijderen. ","confirmation":"Weet u het zeker?","tillDescriptionName":"U staat op het punt te verwijderen: ","tillDescriptionUnit":"en los te koppelen van {noUnits} eenheid(en): <ul>{units}</ul>","tillDescriptionUnits":"en los te koppelen van {noUnits} eenheden?"},"warning":{"title":"Waarschuwing","description":"De CIT-organisatie wordt gewijzigd. Zorg ervoor dat de nieuwe CIT-organisatie workflows heeft voor alle apparaattypen, anders kunnen de machines stoppen met werken.","confirmation":"Weet u zeker dat u de wijzigingen wilt doorvoeren?"},"unlock":{"title":"Ontgrendeling bevestigen","description":"U staat op het punt om <strong>{name}</strong> te ontgrendelen?","confirmation":"Weet u het zeker?"},"filter":{"title":"Filter","confirmation":"Oké"}},"search":{"placeholder":"Zoek...","noresults":"Wij konden geen resultaten voor uw zoekopdracht vinden..."},"filter":{"selectall":"Alles selecteren","deselectall":"Alles deselecteren","hide":" Filter verbergen","show":"Filter weergeven"},"buttons":{"back":"Terug","cancel":"Annuleren","confirm":"Bevestigen","reset":"Reset","create":"Creër","update":"Bijwerken","delete":"Verwijderen","read":"Bekijk","filter":"Filter","unlock":"Ontgrendel","ok":"Oké","upload":"Upload"}},"forms":{"errors":{"required":"{field} is een verplicht veld","required-because":"{field} is een verplicht veld, omdat {field1} is geselecteerd","donotmatch":"{field} veld is incorrect","minvalue":"De minimale waarde is {min}","maxvalue":"De maximale waarde is {max}","mincharlength":"Het veld moet minimaal voldoen aan {min} karakters","maxcharlength":"Het veld moet maximaal voldoen aan {max} karakters","minmaxcharlength":"Het minimale aantal karakters zijn {min} en het maximale aantal karakters zijn {max}","form":"Er zijn enkele errors gevonden in het formulier. Controleer de onderstaande velden","userNotFound":"E-mail adres is niet gevonden!","noworkflow":"Geen procedure beschikbaar voor geselecteerde unit type (maak een nieuwe procedure aan op de CIT procedure pagina)","positiveOnly":"Alleen positieve getallen zijn toegestaan","password":{"lowercase":"Moet ten minste één kleine letter bevatten (a-z)","uppercase":"Moet minstens één hoofdletter bevatten (A-Z)","digit":"Moet ten minste één cijfer bevatten (0-9)","special":"Moet ten minste één speciale karakter bevatten (!\"#%&'()*+,-./:; <=>?@[\\]^_`{|}~)","illegal":"Mag geen illegale tekens bevatten","missing_lowercase":"Must contain at least one lowercase letter (a-z)","missing_uppercase":"Must contain at least one uppercase letter (A-Z)","missing_digit":"Must contain at least one digit (0-9)","missing_special":"Must contain at least one special character (!\"#%&'()*+,-.:;/<=>?@^_`{|}~)","missing_illegal":"Must not contain illegal characters"},"html":{"name":"Ongeldige karakter(s) gedetecteerd"},"fields":{"firstuserrole":"eerste gebruikersrol","seconduserrole":"tweede gebruikersrol","name":"naam","unittype":"unit type","logintype":"login type","city":"plaats","country":"land","location":"locatie","legalform":"juridische identiteit","currency":"valuta","machinename":"machine naam","ownerorganization":"Bovenliggende organisatie","pincodedropsafe":"pincode dropsafe","pincodedropsafeconfirm":"pincode dropsafe bevestiging","pincodedrawer":"pincode lade","pincodedrawerconfirm":"pincode lade bevestigen","firstname":"voornaam","lastname":"achternaam","organizations":"organisaties","organization":"organisatie","userroles":"gebruikersrollen","email":"e-mail","password":"wachtwoord","pin":"pin","mixname":"kassa mix naam","totalamount":"totale hoeveelheid","maximumAmount":"maximale hoeveelheid","overrideworkflow":"wijzig procedure","apiKeySettings":"API Sleutel","units":"units","mixes":"kassa mix","mfaEnabled":"MFA ingeschakeld","mfaSecret":"MFA geheim","username":"gebruikersnaam","placeholder":"component","placeholderAction":"component action","translationNl":"dutch translation","unittypefamily":"unit type family","timeZone":"timezone","serialnumber":"serial number","transactionCashOutLimit":"transaction cash out limit","dailyCashOutLimit":"daily cash out limit"},"maxPavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Max pavement value\"","pavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Pavement value\"","wrongDates":"Start datetime must be before end datetime","alphaCharsOnly":"Only alphabetical characters allowed","alphaNumericCharsOnly":"Only alphabetical characters and numbers allowed","affiliateCodeValidation":"Moet precies 4 alfanumerieke karakters bevatten","numbersOnly":"Only numerical characters (numbers) allowed","safeId":"Must consist of 1 alphabetical character followed by 14 digits. Example: A01234567890123","unable_to_process_request":"Unable to process your request at this time. Contact your administrator or try again later."},"loading":"Laden...","select":"-- Selecteer van de lijst --","messages":{"check_email_for_reset_link":"Please check your email for the reset link."}},"errors":{"title":"Er is een error opgetreden","unknown_error":"Er is een onbekende error opgetreden tijdens het laden van de opgevraagde gegevens.<br/>Probeer het later nog eens.","could_not_load":"Kon de opgevraagde gegevens niet laden.<br/>{response}","unauthorized":"Ongeautoriseerde toegang","unauthorized_expired":"U bent uitgelogd omdat u een langere tijd niet actief was of omdat u ergens anders bent ingelogd","network_down":" Er is een netwerkerror opgetreden. Controleer aub uw netwerk","back_button":"Terug naar de vorige pagina","illegal_argument_uuid":"Ongeldige invoer gevonden","duplicate_entry":"Deze invoer bestaat al","emptycolumnidentifier":"Het kolom invoerveld is leeg","no_information":"Geen informatie","mfaResetError":"Error trying to reset QR/Secret for user"},"login":{"title":"Login","mfaTitle":"Verificatie","continue":"Continue","forgotPassword":{"title":"Wachtwoord vergeten!","success":"Wachtwoord succesvol gereset!"},"mfaFlow":{"mfa_required":"MFA verplicht","mfa_required_description":"Uw organisatie vereist om een MFA authenticatie te gebruiken.","mfaHelp":"Help nodig bij MFA","errorGettingSecret":"Fout opgetreden met ophalen van uw MFA gegevens","errorGettingMfaSettings":"Fout opgetreden met ophalen MFA instellingen","mfaHelpTitle":"Hulp met herstellen van MFA","mfaHelpInstructions":"Neem contact op met uw organisatie en deel de volgende gegevens: <br/> Uw naam <br/> Mail of telefoonnummer <br/> Uw informatie wordt gevalideerd gevolgd door een MFA reset. Er wordt contact met u gezocht over deze actie.","mfaHelpInstructionsOtherMfa":"Er zijn meerdere MFA methodes beschikbaar. Wanneer uw organisatie de optie om gebruikers zelf hun MFA te herstellen heeft ingeschakeld kunt u via het menu in de rechterbovenhoek uw MFA opnieuw instellen.","understood":"Akkoord","setupMfaTitle":"MFA instellen","setupMfaDescription":"Maak een keuze over de volgende MFA methodes","setupMfaSelectType":"Kies een MFA methode","mfaPairingTitle":"MFA op telefoon instellen","mfaPairingQrImage":"QR code:","mfaPairingSecret":"MFA geheim: ","mfaPairingInstructionsTitle":"Instructies voor het instellen van MFA op een telefoon","mfaPairingInstructionsLine1":"Download een 'authenticator app'","mfaPairingInstructionsLine2":"Open de authenticator app en druk op toevoegen via QR of geheim.","mfaPairingInstructionsLine3":"Scan de QR code of voer het geheim handmatig in","mfaPhoneInstructionsTitle":"Instructies voor uitlezen MFA met uw telefoon","mfaPhoneInstructionsLine1":"Open uw authenticatie apparaat of telefoon en controleer de daar getoonde code.","mfaPhoneInstructionsLine2":"Kijk bij 'MFA Troubleshoot' om opnieuw te koppelen","mfaPhoneInstructionsLine3":"Wanneer uw problemen ervaart met deze methode, probeer een andere methode. Bijvoorbeeld MFA via e-mail.","mfaEmailInstructionsTitle":"Instructies voor instellen MFA via e-mail","mfaEmailInstructionsLine1":"Er is een mail gestuurd met een toegangscode.","mfaEmailInstructionsLine2":"Deze toegangscode is enkele minuten geldig","mfaValidationTitle":"Code validatie","mfaValidationDescription":"Geef de code op die door de gekozen MFA methode is gegeven"},"form":{"username":"Gebruikersnaam","password":"Wachtwoord","email":"E-mail","mfaCode":"Mfa Code"},"buttons":{"login":"Login","validate":"Controleer","forgotPassword":"Wachtwoord vergeten","reset":"Reset mijn wachtwoord","mfaResetQrSecret":"Herstel MFA"}},"logout":{"title":"Uitloggen","buttons":{"logout":"Log uit","profile":"Profiel","changepassword":"Verander wachtwoord","changepin":"Verander pin","mfaResetQrSecret":"Reset MFA QR/Secret"}},"new_portal":{"title":"Probeer de nieuwe Lincsafe Portal ✨","dialog":{"description_1":"Ervaar de vernieuwde Lincsafe portal met een nieuwe uistraling en verbeterde functionaliteiten - Uw account gegevens zullen hetzelfde blijven.","description_2":"<br/><b>Opmerking</b>: Oude versie is binnenkort niet meer beschikbaar.","confirm":"Ontdek nieuwe UI"}}},"management":{"unit":{"titles":{"overview":"Units","create":"Voeg een unit toe","update":"Wijzig een unit","read":"Unit details","inventory":"Inhoud","readsettings":"Unit instellingen","preview":"Unit preview"},"breadcrumb":{"title":"Overzicht"},"columns":{"no":"#","name":"Naam","compartment":"Compartiment","valueIn":"In","valueOut":"Uit","sales":"Verkoop","type":"Type","currentValue":"Huidige waarde","insurableValue":"Verzekerde waarde","location":"Locatie","unitStatus":"Unit status","currency":"Valuta","buildVersion":"Versie","closeTime":"Tijd","userLoginName":"Gebruiker","transactionNumber":"Nummer","counter":"Nummer","value":"Waarde","dateTimeStopped":"Datum tijd gestopt","userAccountName":"Gebruiker","valueProcessed":"Waarde","machineName":"Machine naam","machineType":"Machine type","serialNo":"Serienummer","unitIpAddress":"IP adres","unitMacAddress":"MAC adres","vpnIpAddress":"VPN IP adres","teamviewerId":"Teamviewer ID","remoteSupportId":"Hulp op afstand ID","placeholder":"Component","placeholders":"Componenten","date":"Datum","status":"Status","reason":"Reden","message":"Bericht","description":"Omschrijving","source":"Bron","level":"Niveau","amount":"Aantal","total":"Totale Waarde","direction":"Richting"},"form":{"machineName":"Machine naam","location":"Locatie","organizations":"Organisaties","ownerOrganization":"Bovenliggende organisatie","supportMultipleClient":"Ondersteunt meerdere klanten","clientOrganizations":"Klant organisaties","inheritedCIT":"Geërfde CIT","inheritedMaintenance":"Geërfde Onderhoud","overrideCIT":"Overschrijf CIT","overrideMaintenance":"Overschrijf onderhoudsorganisatie","overrideWorkflow":"Wijzig procedure","unitType":"Unit type","unitTypeFamily":"Unit type familie","serialNo":"Serienummer","currency":"Valuta","endOfDayTime":"Einde dag tijdstip","hours":"Uren","minutes":"Minuten","alarmOn":"Alarm aan","alarmValuePerDay":"Alarm waarde per dag","alarmOnMonday":"Maandag","alarmOnTuesday":"Dinsdag","alarmOnWednesday":"Woensdag","alarmOnThursday":"Donderdag","alarmOnFriday":"Vrijdag","alarmOnSaturday":"Zaterdag","alarmOnSunday":"Zondag","maximumAmount":"Maximale aantal munten/biljetten per cassette","insurableValue":"Verzekerde waarde","offlineTimeout":"Offline timeout","pincodeDrawer":"Pincode lade","sideSafe":"Heeft zijkluis","advancedManualDeposit":"Activeer AMD","drawer":"Heeft lade","pincodeDropsafe":"Pincode dropsafe","pincodeDrawerConfirm":"Bevestig pincode lade","pincodeDropsafeConfirm":"Bevestig pincode dropsafe","overrideSettings":"Overschrijf geërfde instellingen","apiKey":"API Sleutel","safeId":"Safe ID","maxPavementWarningPercentage":"Alarm on","departments":"Departments","coinDistribution":"Management","capacityAlertThreshold":"Capacity"},"toolTip":{"machineName":"De naam van de machine","location":"Het adres waar de machine zich bevindt, dit moet worden aangemaakt voordat de unit wordt aangemaakt","organizations":"Organisaties","ownerOrganization":"De organisatie die de machine beheert","supportMultipleClient":"Laat de machine door meerdere organisaties gebruiken","clientOrganizations":"De organisaties die geld kunnen storten in de machine","inheritedCIT":"De geld ophaal dienst die is geërfd van de bovenliggende organisatie","inheritedMaintenance":"De onderhoudsorganisatie die is geërfd van de bovenliggende organisatie","overrideCIT":"Om een andere CIT organisatie te gebruiken dan degene die afkomstig is van de bovenliggende organisatie","overrideMaintenance":"Om een andere organisatie te gebruiken dan de onderhoudsorganisatie die afkomstig is van de bovenliggende organisatie","overrideWorkflow":"Om een andere geld ophaal procedure te gebruiken dan de procedure afkomstig van de bovenliggende organisatie","unitType":"Wat voor soort machine dit is. Verscheidene technische details worden hier van afgeleid, zoals uit welke componenten de machine bestaat. Dit veld kan niet worden aangepast.","unitTypeFamily":"De familie van unit types","serialNo":"Serienummer van het Lincsafe systeem, dit kan gevonden worden op een plakkaat op de unit. Deze code wordt gebruikt wanneer de unit voor het eerst verbinding maakt met de portal","currency":"De valuta die wordt gebruikt door de machine","endOfDayTime":"Het tijdstip die in de rapportage wordt gebruikt voor het einde van de dag. Dit kan bijvoorbeeld worden gebruikt door winkels die na twaalven sluiten.","hours":"Uren","minutes":"Minuten","alarmOn":"Stuurt een e-mail wanneer de unit bijna vol is. Deze wordt verstuurd wanneer het ingevoerde percentage van de verzekerde waarde is bereikt. De ontvangers kunnen aangepast worden door op het klok symbool naast de organisatie op de organisatie-overzichtspagina te klikken","alarmValuePerDay":"Stuurt een e-mail wanneer de unit bijna vol is. Deze wordt verstuurd wanneer het ingevoerde percentage van die dag is bereikt. De ontvangers kunnen aangepast worden door op het klok symbool naast de organisatie op de organisatie-overzichtspagina te klikken","alarmOnMonday":"Maandag","alarmOnTuesday":"Dinsdag","alarmOnWednesday":"Woensdag","alarmOnThursday":"Donderdag","alarmOnFriday":"Vrijdag","alarmOnSaturday":"Zaterdag","alarmOnSunday":"Zondag","maximumAmount":"Het maximale aantal biljetten/munten dat fysiek in een compartiment past. Niet van toepassing voor Lincstation","insurableValue":"De maximale geldwaarde in de machine die gedekt is door de verzekering. Dit wordt gebruikt om te bepalen of de machine vol is en geleegd moet worden.","offlineTimeout":"De tijd dat de portal wacht op een heartbeat boodschap van de unit, voordat de unit als online wordt gemarkeerd.","pincodeDrawer":"De pincode die op de machine dient te worden ingevoerd om de lade te openen","sideSafe":"De machine heeft een zijkluis waarin bijvoorbeeld vouchers kunnen worden ingevoerd","advancedManualDeposit":"Activeer geavanceerde handmatige invoer: de zijkluis kan gebruikt worden voor officiele geld invoer die opgehaald kan worden door een CIT organisatie","drawer":"De machine heeft een lade die gebruikt kan worden om biljetten/munten die vastzitten te verwijderen","pincodeDropsafe":"De pincode die dient te worden ingevoerd op de machine om de dropsafe te openen","pincodeDrawerConfirm":"Bevestig de pincode voor de lade","pincodeDropsafeConfirm":"Bevestig de pincode voor de dropsafe","overrideSettings":"Stel de machine anders in dan de standaard instellingen die afkomstig zijn van de bovenliggende organisatie","maxPavementWarningPercentage":"A warning will pop up on the machine screen, telling the managers/CIT that the bag will be full soon. The user will be informed when it has reached the entered percentage of the max pavement value.","safeId":"Optional, custom, unique, 15 character identifier for this unit","overrideBankAccount":"Do not inherit primary bank account from Location. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Location. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Location. Instead, define a new one specific to this unit","coinDistribution":"Twin coin system distribution setting management in percentage","cassetteCapacity":"The note limit of each cassette in the unit.","capacityAlertThreshold":"The percentage of capacity at which point an alert will be generated"},"softwaresettings":{"1":"Vrij uitbetalen","2":"Van hoog naar laag","listUserByOrganization":"Gebruiker per organisatie weergeven","listUserByUsername":"Gebruiker weergeven per gebruikersnaam","xmlExportName":"XML export","useReferenceNumber":"Nr pagina (niet gebruiken, dit is alleen voor oude versies)","referenceNumberLength":"Lengte referentienummer","currencyCode":"Valuta","hopper1Value":"Waarde hopper 1","hopper2Value":"Waarde hopper 2","numberOfCoins":"Aantal munten","beepOnBillRejected":"Geluid bij geweigerd biljet","transactionPerBill":"Transactie per biljet","loginRequiredTransaction":"Inloggen voor transactie","buzzerTimeout":"Geluid timeout","hasPrinterAttached":"Geef printer notificaties weer","enableOTC":"OTC inschakelen","billMaxAmount":"Maximaal aantal biljetten in de Lincstation","coinMaxAmount":"Maximaal aantal munten in overflow","heartbeatRate":"Heartbeat frequentie","downloadRate":"Download frequentie","safeStatusRate":"Kluis status frequentie","inventorySettings":"Inhoud instellingen","payableValue":"Te betalen waarde","floatValue":"Float waarde van Lincstation","floatSettings":"Float instellingen","payOutMethod":"Uitbetaalmethode","round":"Afgeronde waarde","payOutLimit":"Uitbetalingslimiet","language":"Taal","bins":"Bank ID Nummers","ecrId":"Pin Terminal ID","ecrUrl":"Payplaza URL","charities":"Goede doelen","g4sApiUrl":"Bank Autorisatie Url","authApiKey":"Autorisatie API Sleutel","employeeSelection":"Medewerker selectie","supportedLanguages":"Ondersteunde talen","showDeviceTotal":"Toon machine totaal","showExtraButtonOnUserSelectScreen":"Extra gebruikersselectieknop weergeven","pavementLimit":"Looptransport limiet","communicationRate":"Communicatie frequentie","depositTimeout":"Storting time-out in seconden","normalDepositReceipts":"Bon aantal stortingen","manualDepositReceipts":"Bon aantal handmatige transactie","cashierAccountability":"Kassier verantwoordelijkheid","laneAccountability":"Kassa verantwoordelijkheid","simpleMode":"Eenvoudige modus","printTrxDailyBalance":"Dagbalans afdrukken op het transactiebewijs","showDenominationDetailsOnDepositPrint":"Weergeef denominatie bij afdrukken van storting","showUserTotals":"Weergeef gebruikerstotaal functie","showDailyReports":"Weergeef dagelijkse rapporten functie","manualEndOfDay":"Handmatig einde dag","textLanguage":"Teksttaal selecteren","dateFormat":"Datum notatie","MMddyyyy":"United States (12/31/2000)","dd-MM-yyyy":"International (31-12-2000)","MMMddyyyy":"US Global (Dec 31 2000)","ddMMMyyyy":"Alternate International (31 Dec 2000)","yyyy-MM-dd":"Jaar-Maand-Dag (2000-12-31)","screenSaver":"Schermbeveiliging","preTransactionTask":"Toon referentienummer","noTask":"Nee","refNr":"Toon referentienummer pagina","low":"Laag","medium":"Midden","high":"Hoog","high_low_medium":"Aangepast 1","Low":"Laag","Medium":"Midden","High":"Hoog","namelist":"Lijst met namen","empnr":"Vul medewerkersnummers in","en":"Engels","nl":"Nederlands","fr":"Frans","hu":"Hongaars","sk":"Slowaaks","pl":"Pools","EUR":"EUR","TR":"TR","USD":"USD","noExport":"geen export","MLSA":"OCS export","puloonCassette1":"Puloon Cassette 1","puloonCassette2":"Puloon Cassette 2","puloonCassette3":"Puloon Cassette 3","puloonCassette4":"Puloon Cassette 4","EUR-5":"5 €","EUR-10":"10 €","EUR-20":"20 €","EUR-50":"50 €","EUR-100":"100 €","EUR-200":"200 €","EUR-500":"500 €","puloonCassette1FixedAmount":"Puloon Casette 1 Vast aantal","puloonCassette2FixedAmount":"Puloon Casette 2 Vast aantal","puloonCassette3FixedAmount":"Puloon Casette 3 Vast aantal","puloonCassette4FixedAmount":"Puloon Casette 4 Vast aantal","inventoryCheckOnPayment":"Controleer inhoud bij betaling","tariffs":"Tarieven","acceptablesSetting":"Ingeschakelde denominaties","minimumOrderRolls":"Minimale rol bestel afname","inventoryOptimumReset":"Inhoud float uitvaltijd","escrowEmptyAmount":"Escrow leeg bedrag","maxBagValue":"Maximale looptransport waarde","ledLightColor":"LED-lichtkleur","yellow":"Geel","red":"Rood","green":"Groen","blue":"Blauw","magenta":"Magenta","cyan":"Cyaan","white":"Wit","posMode":"POS modus","none":"Geen","barcode_itf":"Barcode ITF","qrcode":"QR Code","allowManagerEmptyCoinOverflow":"Manager mag munt overflow legen","inventorypanel":{"denomination":"Denominatie","material":"Materiaal","recycled":"Gerecycled","numberOfRecyclers":"Aantal recyclers","min":"Min","low":"Laag","optimum":"Optimaal","max":"Max","value":"Waarde","COIN":"Munt","BILL":"Biljet","ROLL":"Rol","maxDispensable":"Max dispensable","messages":{"recyclerStatusInfo":"{totalRecyclers} van {maxNumberOfRecyclers} recyclers worden gebruikt","recyclerStatusError":"Error: overschrijding van het maximale aantal recyclers ({maxNumberOfRecyclers}); geclaimd: {totalRecyclers}","excideMaximumDrawer":"Max drawer dispensable limit is {limit}","excideMaximumCup":"Max cup dispensable limit is {limit}"},"high":"High"},"tariffspanel":{"transaction_fee":"Kosten per transaction","value_fee":"Kosten per rol"},"minimumOrderPanel":{"min":"Min (1)","max":"Max (200)"},"timeSelector":{"enabled":"Ingeschakeld"},"minimumOrderCoinRollsSettings":"Minimum en maximum muntrol afname","apiKeySettings":"API Sleutel","useDefaultValue":"Gebruik standaardwaarde","om61InventorySettings":"OM61 inhoud instellingen","allowManagerEmptyAllRecyclers":"Manager toestaan om alle recylers te legen","managerUnlockDelay":"Vertragingstijd om kluisdeuren te ontgrendelen","managerUnlockStartTime":"Starttijd ontgrendelen","managerUnlockEndTime":"Eindtijd ontgrendelen","localPinChange":"Gebruikerspin op unit wijzigen","customXmlHeader":"Custom XML Header","puloonRejectBinMaxAmount":"Maximum aantal biljetten dat de Puloon afkeerbak kan verwerken","puloonRejectBinWarningLevel":"Puloon afkeurbak waarschuwingsniveau volle capaciteit","coinDistribution":"Twin coin systeemdistributie-instelling","puloonRejectBinWarningPercentage":"Puloon afkeurbak volle capaciteit waarschuwing (percentage)","autoFloatDownWhenSystemIsIdle":"Automatisch float omlaag","unitBarcodeTypeOnFirstCitPage":"Barcode van de Unit weergeven (CIT-scherm)","tillRestrictions":"Restricted tills","maxPavementWarningPercentage":"Max pavement value alarm","g4sCertificate":"G4S Certificate","payplazaCertificate":"Payplaza Certificate","storageVault":"Storage vault","userManagement":"User management","autoPrintEndOfDay":"Auto-print End Of Day","coinOverflowCapacityGrams":"Munt overflow capaciteit (gram)","coinOverflowCapacityWarningPercentage":"Waarschuwing volle munt overflow (percentage)","disableManualDenominationSelection":"Disable manual deposit denomination selection","printBarcodesOnCitReceipt":"Print barcodes op CIT bonnen","code39":"Code 39","code128":"Code 128 (B type)","rcfTubeAuditLastRequested":"Request reserve change and tube dispenser audit","rcfTubeAuditDays":"Change and Tube audit max interval (days)","cassetteCapacity":"Cassette Capacity","capacityAlertThreshold":"Capacity Alert Threshold","showNoteValidationOnDashboard":"Toon biljet validatie op home scherm"},"actions":{"create":"Voeg unit toe","read":"Bekijk unit","update":"Wijzig unit","delete":"Verwijder unit","filter":"Filter units op status","readsettings":"Bekijk unit instellingen","preview":"Unit preview"},"messages":{"added":"De unit {name} is toegevoegd","updated":"De unit {name} is gewijzigd"},"read":{"tabs":{"detail":"Details","specifications":"Technische specificaties","status":"Status","users":"Gebruikers","sales":"Verkoop","internal":"Intern","mixes":"Kassa Mix","citLegacy":"Legacy","citDynamic":"Dynamisch","citStatic":"Static"},"summary":{"maximumAmount":"Max munten/biljetten per cassette","machineName":"Machine naam","insurableValue":"Verzekerde waarde","currentValue":"Huidige waarde","currentDepositValue":"Huidige gestorte waarde","unitModelName":"Unit type","unitTypeFamily":"Unit type familie","location":"Locatie","placeholders":"Componenten","lastTransactionDate":"Laatste transactiedatum","currency":"Valuta","currentStatus":"Huidige status","networkStatus":"Netwerk status","lastClearBox":"Laatste clear box","yesterdayTurnover":"Omzet van gisteren","lastClearBoxDate":"laatste clearbox datum","fillGrade":"Vullingsgraad","numberOfTransactions":"Aantal transacties","name":"Naam","addressLine1":"Adres","city":"Plaats","unitFillStatus":"Drempel bereikt","ALMOST_FULL":"BIJNA VOL","FULL":"VOL","NORMAL":"NORMAL","null":"null"},"titles":{"unitStatus":"Unit status","unitDetail":"Unit detail","unitDetails":"Unit details","location":"Locatiegegevens","lastTransactions":"Laatste transactie","campaignsUnit":"Clearboxes unit","lastClearBoxes":"Laatste clear boxes","component":"Technische specificaties","eventsByUnit":" Gebeurtenissen","lastEvents":"Laatste gebeurtenissen","hardwareStatus":"Hardware: ","networkStatus":"Netwerk: ","notifications":"Notificaties","departments":"Department details"},"status":{"ALMOST_EMPTY":"Bijna leeg, moet gevuld worden ","ALMOST_FULL":"Bijna vol, moet worden leeggemaakt","DEBUG":"Debug","EMPTY":"Needs to be filled","ERROR":"Error","FATAL":"Fatal","FULL":"Vol, moet worden leeggemaakt","INFO":"Info","INVENTORY_NOT_SUFFICIENT":"Moet gevuld worden","INVENTORY_OVER_MAXIMUM":"Moet geleegd worden","INVENTORY_UNDER_MIN":"Moet gevuld worden","INVENTORY_UNDER_LOW":"Moet gevuld worden","JAMMED":"Verhelp de blokkade","NOT_CONNECTED":"Controleer de verbinding met het apparaat","NOT_SECURE":"Ontgrendel de deur en sluit deze weer","OFFLINE":"Unit is Offline","OK":"OKÉ","OPEN":"Sluit de deur","OVERRIDDEN":"Gebruik het menu om de deur te ontgrendelen en te vergrendelen","RECYCLER_ALMOST_EMPTY":"Recycler bijna leeg","RECYCLER_ALMOST_FULL":"Recycler bijna vol","RECYCLER_EMPTY":"RECYCLER Leeg","RECYCLER_FULL":"RECYCLER Vol","STACKER_FULL":"Verwijder de biljetten uit de stacker","STORAGE_ALMOST_FULL":"De cassette leegmaken","STORAGE_DETACHED":"Plaats cassette","STORAGE_FULL":"Leeg de cassette","TRACE":"Traceer","UNLOCKED":"Vergrendel de deur","WARN":"Waarschuwing","WARNING":"Waarschuwing"},"techSpec":{"ACCEPTING":"Accepteren","ALMOST_EMPTY":"Bijna Leeg","ALMOST_FULL":"Bijna Vol","BAG_OPEN":"Sealbag Open","CALIBRATING":"Kaliberen","CASSETTE_ERROR":"Cassette Error","CASSETTE_ATTACHED":"Cassette Geplaatst","CASSETTE_DETACHED":"Cassette Verwijderd","CARTRIDGE_DETACHED":"Cartridge is verwijderd","CLOSED":"Gesloten","CONNECTED":"Verbonden","DOOR_CLOSED":"Deur Gesloten","DOOR_OPEN":"Deur Open","DOOR_LOCKED":"Deur vergrendeld","DOOR_UNLOCKED":"Deur ontgrendeld","DOWNLOADING":"Downloading","EMPTY":"Leeg","END_OF_DAY":"Eind van de dag achterstallig","ENTRANCE_NOT_EMPTY":"Biljet invoer niet leeg","EXTENSION_STALL":"Extensie gestagneerd","FAILED":"Gefaald","FEED_FAILURE":"Bijvullen mislukt","FULL":"Vol","INVENTORY_MISMATCH":"Tube inventory mismatch detected","INVENTORY_NOT_SUFFICIENT":"Inhoud onvoldoende","INVENTORY_OVER_MAXIMUM":"Inhoud boven het maximum","INVENTORY_UNDER_MIN":"Inhoud onder het minimum","INVENTORY_UNDER_LOW":"Inhoud onder laag","JAM_CLEARED":"Blokkade verwijderd","JAMMED":"Geblokkeerd","LOCKED":"Vergrendeld","LOCKS_SECURE":"Sloten Beveiligd","NEGATIVE_RESERVE_CHANGE":"Reserve change balance is negative","NOT_ACCEPTING":"Niet geaccepteerd","NOT_CONNECTED":"Niet verbonden","NOT_FOUND":"Configuratie niet gevonden","NOT_OPERATIONAL":"Niet Operationeel","NOT_OVERRIDDEN":"Niet Overschrijven","NOT_SECURE":"Niet veilig","OFFLINE":"OFFLINE","ONLINE":"ONLINE","NETWORK_DISCONNECTED":"Netwerk verbroken","NETWORK_RESTORED":"Netwerk hersteld","OK":"OKÉ","OPEN":"Open","OVERRIDDEN":"Overschreven","PAUSE":"Pauze","POWER_UP":"Aanzetten","RECYCLER_ALMOST_EMPTY":"RECYCLER Bijna Leeg","RECYCLER_ALMOST_FULL":"RECYCLER Bijna Vol","RECYCLER_EMPTY":"RECYCLER Leeg","RECYCLER_FULL":"RECYCLER Vol","REJECT_NOT_EMPTY":"REJECT is niet leeg","RCF_TUBE_AUDIT_DUE":"Change and tube audit required","OUTPUT_NOT_EMPTY":"OUTPUT is niet leeg","SAFE_DOOR_OPEN":"Kluis deur open","SECURE":"Veilig","SIDE_SAFE_ONE_LOCKED":"Zijkluis 1 vergrendeld","SIDE_SAFE_ONE_UNLOCKED":"Zijkluis 1 ontgrendeld","STACKER_FULL":"Stacker Vol","STALLED":"gestopt","STORAGE_ALMOST_FULL":"Cassette bijna vol","STORAGE_ALMOST_FULL_CLEARED":"Cassette bijna volledig leeg","STORAGE_ATTACHED":"Cassette geplaatst","STORAGE_DETACHED":"Cassette verwijderd","STORAGE_FULL":"Cassette Vol","STORAGE_ALMOST_EMPTY_005":"Muntrolhouder bijna leeg voor 5 cent","STORAGE_ALMOST_EMPTY_010":"Muntrolhouder bijna leeg voor 10 cent","STORAGE_ALMOST_EMPTY_020":"Muntrolhouder bijna leeg voor 20 cent","STORAGE_ALMOST_EMPTY_050":"Muntrolhouder bijna leeg voor 50 cent","STORAGE_ALMOST_EMPTY_100":"Muntrolhouder bijna leeg voor 1 euro","STORAGE_ALMOST_EMPTY_200":"Muntrolhouder bijna leeg voor 2 euro","TOP_DOOR_CLOSED":"Top deur gesloten","TOP_DOOR_OPEN":"Top deur open","UNLOCKED":"Ontgrendeld"}},"inventory":{"unitInventory":"Unit Inhoud","noTransactions":"Geen transacties","noTransactionsDesc":"Geen transacties gevonden, probeer het later nog eens a.u.b.!","items":"Items","total":"Totaal ","cassette":"Cassette","columns":{"DENOMINATION":"Denominatie","QTY":"QTY","COMPARTMENT_INDEX":"Index","SUTOTAL":"Subtotaal"}},"campaign":{"read":"Laatste clearboxes","columns":{"no":"#","group":"Groep","placeholder":"Component","dateTimeStopped":"Datum tijd gestopt","userAccountName":"Gebruiker","insertedValue":"Ingevoerd","valueProcessed":"Verzameld","totalValueProcessed":"Totale waarde verwerkt"}}},"softwaresettings":{"titles":{"overview":"Software instellingen","create":"Voeg software instellingen toe","update":"Wijzig software instellingen","readsettings":"Lees de software instellingen"},"breadcrumb":{"title":"Overzicht"},"actions":{"create":"Voeg software instellingen toe","read":"Bekijk software instellingen","update":"Wijzig software instellingen","delete":"Verwijder software instellingen","readsettings":"Lees de software instellingen"},"columns":{"ownerOrganization":"Bovenliggende organisatie","unitType":"Unit Type"},"messages":{"added":"Nieuwe settings zijn toegevoegd","updated":"Instellingen zijn gewijzigd"},"form":{"ownerOrganization":"Bovenliggende organisatie","unitType":"Unit Type","overrideSettings":"Standaardinstellingen overschrijven","selectOverrideSettings":"Selecteer instellingen om te overschrijven en gebruik deze","checkAll":"Controleer alles","cassettesAssignment":"Cassettes Assignment"},"toolTip":{"hasPrinterAttached":"Gebruik alleen wanneer er een printer is verbonden","listUserByOrganization":"Geeft de gebruikers weer per organisatie, als de unit meerdere klanten ondersteunt","listUserByUsername":"Toont de namen van de gebruikers, wanneer deze setting uit staat wordt slechts het medewerkersnummer weergegeven","xmlExportName":"Voor het exporteren van xml bestanden naar een derde partij","useReferenceNumber":"Instelling voor de weergave van een extra pagina bij een betaling, dit is alleen voor oude versies","referenceNumberLength":"Lengte van het referentienummer","unitBarcodeTypeOnFirstCitPage":"Hiermee kan de naam van de unit als barcode op het apparaat scherm worden weergegeven aan het begin van de CIT-flow","currencyCode":"Valuta voor NS Wisselaar hoppers","hopper1Value":"Waarde NS Wisselaar hopper 1","hopper2Value":"Waarde NS Wisselaar hopper 2","numberOfCoins":"Hoeveelheid munten per NS wisselaar hopper","beepOnBillRejected":"Maak geluid wanneer er een biljet wordt geweigerd (alleen voor machines met een beeper)","transactionPerBill":"Biljettenacceptor accepteert maar één biljet per transactie","loginRequiredTransaction":"Gebruiker moet inloggen voordat een nieuwe storting kan starten","buzzerTimeout":"Maximale duur dat een geluid produceerd bij een geweigerd biljet","enableOTC":"Gebruikt om OTC-modus in te schakelen voor smart lock","heartbeatRate":"Frequentie voor het verzenden van de heartbeat van unit naar de portal","downloadRate":"Frequentie voor het downloaden van configuratie bestanden van de portal naar de unit","safeStatusRate":"Frequentie voor het sturen van de kluis status van de unit naar de portal","inventorySettings":"Inhoud instellingen voor de Lincstation kluis, dit betreft geaccepteerde materialen, geryclede materialen, minimum waarde, float waarde en maximale waarde per denominatie","payableValue":"Minimale waarde die de Lincstation moet bevatten voordat deze operiationeel is en betalingen zal accepteren","floatValue":"Dag start float waarde van de Lincstation","billMaxAmount":"Maximaal aantal biljetten in Lincstation","coinMaxAmount":"Maximaal aantal munten in de overflow lade. Een waarschuwing wordt gegenereerd bij 80% van deze waarde","payOutMethod":"Uitbetaalmethode voor het Smart Coin systeem op de Lincstation","round":"Deze instelling wordt gebruikt om ingevoerde waarde van een betaling af te ronden op de Lincstation","payOutLimit":"Limiet per uitbetaling op de Lincstation","language":"De taal die actief is op de unit","bins":"Lijst met bank-id-nummers die per bank wordt ondersteund","hitachiRejectBoxHandling":"Hoe de reject box afgehandeld en geleegd wordt.\nAls de manager Reconcilieert is gekozen dan kan de manager de inhoud van de recyclers corrigeren aan de hand van de echte tellingen van de","hitachiRejectBoxFullPct":"Reject Box vol (200) waarschuwing (%)","employeeSelection":"Voor een betaling, toon een scherm waarop een medewerker met medewerkers nummer gevonden kan worden, of laat een lijst met namen zien","supportedLanguages":"De talen die ondersteunt worden door de unit","showDeviceTotal":"Toont de totale inhoud van de unit en de details over de denominatie in het manager menu","showExtraButtonOnUserSelectScreen":"Als deze optie is ingeschakeld, verschijnt er een 5e gebruikersselectieknop op het gebruikersselectiescherm","pavementLimit":"Looptransport limiet voor de cassette","communicationRate":"Frequentie voor de communicatie tussen de unit en de portal. Deze setting stelt download- en heartbeatfrequentie in. Bij de opties \"Hoog\", \"Midden\" en \"Laag\" worden beide frequenties op dit niveau ingesteld. Bij de optie \"Custom 1\" is de downloadfrequentie laag en hartslagfrequentie hoog","depositTimeout":"Storting timeout duur voor het stortingsscherm","normalDepositReceipts":"Aantal bonnen dat wordt geprint na een normale storting","manualDepositReceipts":"Aantal bonnen dat wordt geprint wordt na een handmatige storting (bijvoorbeeld het invoeren van de waarde van een voucher)","showDenominationDetailsOnDepositPrint":"Weergeef denominaties op de bon voor een storting","showUserTotals":"Weergeef gebruikerstotaal functie op instellingen scherm","showDailyReports":"Weergeef dagelijkse rapporten functie op management scherm","manualEndOfDay":"Het einde van de dag wordt handmatig uitgevoerd door een manager (Deze instelling schakelt de automatische einde dagfunctie uit.)","textLanguage":"Teksttaal selectie scherm gebruiken (in plaats van vlaggen)","dateFormat":"De datumnotatie die wordt weergegeven op de bonnen en het scherm","preTransactionTask":"Gebruikt voor het tonen van denominatiegegevens per transactie op de stortingsbon","screenSaver":"Toon schermbeveiliging wanneer de machine inactief is","puloonCassette1":"Denominatie voor Casette 1","puloonCassette2":"Denominatie voor Casette 2","puloonCassette3":"Denominatie voor Casette 3","puloonCassette4":"Denominatie voor Casette 4","puloonCassette1FixedAmount":"Vast aantal biljetten in Casette 1","puloonCassette2FixedAmount":"Vast aantal biljetten in Casette 2","puloonCassette3FixedAmount":"Vast aantal biljetten in Casette 3","puloonCassette4FixedAmount":"Vast aantal biljetten in Casette 4","inventoryCheckOnPayment":"Controleert of het ingevoerde bedrag tijdens de betaling kan worden uitgegeven","charities":"Gegevens van Goede doelen organisaties","manager":"Manager leegt de Upper Reject Box","cit":"CIT leegt de Upper Reject Box","managerReconciled":"Manager reconcilieert en leeft de Upper Reject Box","escrowEmptyAmount":"Minimaal te legen bedrag voor escrow","maxBagValue":"Maximale waarde voor opslag","inventoryOptimumReset":"De tijd waarop de inhoud van de machine wordt teruggezet naar de optimale waarden op basis van de inhoud instellingen","apiKeySettings":"API Sleutel for the connector","ledLightColor":"LED-lichtkleur","posMode":"De Point-of-sale-modus beperkt de functionaliteit van de machine door enkele knoppen uit te schakelen","ecrId":"De ID voor de terminal die is verbonden aan de unit","ecrUrl":"Het eindpunt dat wordt gebruikt om betalingen en andere pintransacties uit te voeren","g4sApiUrl":"Het eindpunt dat wordt gebruikt voor de autorisatie van pinpassen","allowManagerEmptyAllRecyclers":"Stelt de manager in staat om alle beschikbare biljetten en munten lokaal op de unit uit te geven","managerUnlockDelay":"Manager vertraging voor het openen van kassa's en muntenlade","localPinChange":"De mogelijkheid om de pincode van de gebruiker op de unit te wijzigen","customXmlHeader":"Aangepaste XML-data instellen die nodig zijn voor integratie","puloonRejectBinMaxAmount":"Puloon afkeurbak maximale capaciteit","puloonRejectBinWarningPercentage":"Waarschuwingsniveau ingesteld in percentage voor Puloon afkeurbak. Deze functionaliteit is uitgeschakeld als 0 is ingesteld","autoFloatDownWhenSystemIsIdle":"Automatisch float als er geen actieve transactie is en de recycler vol is","g4sCertificate":"Certificate for software management","payplazaCertificate":"Certificate for software management","managerUnlockStartTime":"Unlock start time","managerUnlockEndTime":"Unlock end time","tillRestrictions":"When selected, tills are only allowed to be dispensed once. They will become available again after the till is deposited back into the machine. When deselected, tills can be used multiple times.","storageVault":"Enable additional storage vault","userManagement":"Enable user management","authApiKey":"Authorization API Key","printBarcodesOnCitReceipt":"Print barcodes op CIT bonnen","cassetteCapacity":"The note limit of each cassette in the unit.","capacityAlertThreshold":"The percentage of capacity at which point an alert will be generated"},"billsDenominationTable":{"yes":"YES","no":"NO","columns":{"cassettes":"Cassettes","recycler":"Recycler","denomination":"Denomination","currency":"Currency","optimum":"Optimum","max":"Max"}}},"user":{"titles":{"overview":"Gebruikers","create":"Voeg een gebruiker toe","update":"Wijzig een gebruiker","changepassword":"Wijzig wachtwoord","changepincodes":"Wijzig pincode","updateprofile":"Wijzig profiel","forgotpassword":"Wachtwoord vergeten","resetpassword":"Reset Wachtwoord","readsettings":"Gebruikersinstellingen","puloonRejectBinMaxAmount":"Puloon afkeurbak maximale capaciteit biljetten","puloonRejectBinWarningLevel":"Puloon afkeurbak waarschuwingsniveau volle capaciteit"},"breadcrumb":{"title":"Overzicht"},"columns":{"name":"Naam","organization":"Organisatie","email":"E-mail","roles":"Gebruikers rollen"},"form":{"firstName":"Voornaam","lastName":"Achternaam","rfid":"RFID / Dallas Key","employeeNumber":"Medewerkersnummer","organization":"Organisatie","roles":"Gebruikersrollen","email":"E-mail","externalUsername":"Externe Gebruikersnaam","externalPassword":"External Password","password":"Wachtwoord","passwordConfirm":"Bevestig Wachtwoord","sendTemporaryPassword":"Stuur tijdelijk wachtwoord","pin":"Pin","pinConfirm":"Bevestig pin","openDropsafeWithPin":"Open dropsafe met pin","openDrawerWithPin":"Open lade met pin","units":"Units","oldPassword":"Oud wachtwoord","newPassword":"Nieuw wachtwoord","confirmPassword":"Bevestig nieuw wachtwoord","oldPin":"Oude pin","newPin":"Nieuwe pin","tills":"Geldlades","mixes":"Kassa mix","dailyDispenseLimit":"Dagelijkse uitgiftelimiet","dailyPayoutLimit":"Dagelijkse uitbetalingslimiet","mfaEnabled":"Schakel multi-factor authenticatie in","generate":"Genereer","copied":"gekopieerd","secretkey":"Secret key","useExternalRoles":"Gebruik externe rollen","unitRoles":"Unit role","storageVaultAccess":"Storage vault access","departments":"Departments"},"actions":{"create":"Voeg gebruiker toe","read":"Bekijk user","update":"Wijzig user","delete":"Verwijder user","unlock":"Unlock user","readsettings":"Bekijk de gebruikersinstellingen"},"messages":{"added":"De gebruiker {name} is toegevoegd","updated":"De gebruiker {name} is gewijzigd","changedpassword":"Het wachtwoord is gewijzigd","changedpin":"De pin is gewijzigd","updateprofile":"Het profiel is gewijzigd","qrSecretReset":"The QR/secret has been reset correctly"},"toolTip":{"mfaEnabled":"Schakel multi-factor authenticatie in","copySecret":"Copy secret tekst","useExternalRoles":"Wijs een van de gespecialiseerde rollen toe die bij een specifieke unit horen, bijv. HS600"}},"location":{"titles":{"overview":"Locaties","create":"Voeg een locatie toe","update":"Wijzig een locatie","readsettings":"Locatie instellingen"},"breadcrumb":{"title":"Overzicht"},"columns":{"city":"Plaats","name":"Naam","addressLine":"Adres"},"form":{"name":"Naam","city":"Plaats","addressLine1":"Adres","addressLine2":"Adres 2","postalCode":"Postcode","country":"Land","phoneNumber":"Telefoonnummer","email":"E-mail","organization":"Organization","state":"State/Province","timeZone":"Timezone","departments":"Departments"},"actions":{"create":"Voeg locatie toe","read":"Bekijk locatie","update":"Wijzig locatie","delete":"Verwijder locatie","readsettings":"Bekijk locatie instellingen"},"messages":{"added":"De locatie {name} is toegevoegd","updated":"De locatie {name} is gewijzigd"},"toolTip":{"organization":"Organization to which this location belongs to","timeZone":"Machine time will be set up according to the timezone.","overrideBankAccount":"Do not inherit primary bank account from Organization. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Organization. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Organization. Instead, define a new one specific to this unit"}},"organization":{"titles":{"overview":"Organisaties","create":"Voeg een organisatie toe","jobs":"Organisatie banen","update":"Wijzig een organisatie","readsettings":"Organisatie-instellingen","mfaTypes":"MFA methodes"},"breadcrumb":{"title":"Overzicht"},"columns":{"name":"Naam","location":"Locatie","parentOrganization":"Bovenliggende organisatie","organizationType":"Organisatie type"},"form":{"dayTotalJob":"Dagtotaal taak","recyclerOverallJob":"Algemene functie Recycler","mailSendingTime":"Mail verzendtijd","enabled":"Ingeschakeld","remainingUsers":"Overige gebruikers","subscribers":"Abonnees","affectedUnits":"Betrokken units","name":"Naam","ipWhiteList":"IP white list","pin":"Pin","organizationType":"Organisatie type","parentOrganization":"Bovenliggende organisatie","inheritedCIT":"Geërfde CIT","inheritedMaintenance":"Geërfde onderhoud","overrideCIT":"Overschrijf CIT organisatie","overrideMaintenance":"Overschrijf onderhoudsorganisatie","defaultCIT":"Standaard CIT","defaultMaintenance":"Standaard Onderhoud","reportedOrganizations":"Gemelde organisaties","location":"Locatie","legalForm":"Juridische identiteit","remark":"Opmerking","forceMfaForUsers":"Verplicht gebruikers MFA te gebruiken","enableUserMfaSecretReset":"Sta gebruikers toe hun eigen MFA opnieuw in te stellen","enableAuthdeviceMfa":"MFA via authenticatie app","enableEmailMfa":"MFA via e-mail","enableSmsMfa":"MFA via SMS","workflows":"Workflows","forceEmployeePin":"Werknemers vereisen PIN","userPincodeSeverity":"Gebruiker pincode ernstgraad","ibutton":{"overview":"iButton keys overview","noData":"There are no iButton keys to show","add":"Add iButton key","uploadCSV":"Upload CSV","name":"iButton Key","removeAll":"Remove all iButton keys","removeAllConfirmationText":"Are you sure that you want to delete all ibuttons?","remove":"Remove","cancel":"Cancel","delete":"Delete","ok":"OK","invalidCSVfile":"Please upload a valid CSV file.","uploadInfo":"Upload is finished.","uploadDescription":"It seems that some keys weren't inserted because they didn't meet the required criteria.","uploadCSVInfo":"Only valid ibutton key names will be uploaded.","invalidButtonName":"Validation failed! iButton key name must be exactly 16 hexadecimal characters and should not be a duplicate.","search":"Type to search ibutton key"}},"actions":{"create":"Voeg organisatie toe","read":"Bekijk organisatie","update":"Wijzig organisatie","delete":"Verwijder organisatie","readsettings":"Bekijk de organisatie-instellingen"},"pincodeSeverity":{"OFF":"UIT","LOW":"LAAG","MEDIUM":"MEDIUM","HIGH":"HOOG","HIGH90":"HOOG90"},"messages":{"added":"De organisatie {name} is toegevoegd","updated":"De organisatie {name} is gewijzigd","selectOneMfaOption":"Selecteer minimaal één optie"},"toolTip":{"dayTotalJob":"Dagtotaal taak","mailSendingTime":"Mail verzendtijd","enabled":"Ingeschakeld","remainingUsers":"Overige gebruikers","subscribers":"Abonnees","affectedUnits":"Betrokken units","name":"De naam van de organisatie","ipWhiteList":"De IP adressen die mogen communiceren met de units (niet in gebruik op het moment)","pin":"De pincode van de organisatie (niet in gebruik op het moment)","organizationType":"Het type organisatie. Cash in Transit: voor organisatie die geld ophalen vanuit de units. Algemeen: dit wordt gebruikt voor de meeste organisaties. Onderhoud: voor organisaties die onderhoud plegen aan de units. Rapporteringsgroep: voor organisaties die rapporten moeten inzien van organisatie op verschillende plekken in de organisatie stamboom","parentOrganization":"De organisatie boven de huidige organisatie in de organisatie stamboom. Administrators van de bovenliggende organisatie kunnen de huidige organisatie en de units zien in de Portal. De huidige organisatie kan de onderhoud en CIT organisatie erven van de bovenliggende organisatie. Indien er geen bovenliggende organisatie is gekozen, dan is het nodig dat er een CIT en onderhoudsorganisatie wordt gemaakt voor de huidige organisatie.","inheritedCIT":"De geld ophaal dienst afkomstig van de bovenliggende organisatie","inheritedMaintenance":"De onderhoudsorganisatie afkomstig van de bovenliggende organisatie","overrideCIT":"Om een andere organisatie te gebruiken dan de CIT die afkomstig is van de bovenliggende organisatie","overrideMaintenance":"Om een andere organisatie te gebruiken dan de onderhoudsorganisatie afkomstig van de bovenliggende organisatie","defaultCIT":"Om dit de CIT organisatie te maken die automatisch wordt gebruikt door units en onderliggende organisaties","defaultMaintenance":"Om dit de CIT organisatie te maken die automatisch wordt gebruikt door units en onderliggende organisaties","reportedOrganizations":"De organisaties waarvan leden van de huidige organisatie de rapporten mogen inzien","location":"Het adres van de organisatie (dit dient te worden aangemaakt alvorens het aanmaken van de organisatie)","remark":"Opmerkingen over de organisatie, die zichtbaar zijn voor mensen die het bewerken ","forceMfaForUsers":"Enable this option to force multifactor authentication for all users when they log in to the portal.","enableAuthdeviceMfa":"Schakel de methode MFA via authenticatie applicaties in","enableEmailMfa":"Schakel de methode MFA via e-mail in","enableSmsMfa":"Schakel de methode MFA via SMS in","enableUserMfaSecretReset":"Sta gebruikers toe om hun eigen MFA instellingen te herstellen.","workflows":"De CIT procedures die worden gebruikt op de units waarvan deze organisatie de CIT organisatie is van","forceEmployeePin":"Om de pincode verplicht te maken voor alle medewerkers van deze organisatie en de onderliggende organisaties"},"notifications":{"titles":{"notifications":"Notifications","notificationType":"Notification Type"},"types":{"UNIT_OFFLINE":"Unit Offline"},"form":{"enabled":"Enabled","unsubscribed":"Remaining Users","subscribed":"Subscribed"}}},"till":{"titles":{"overview":"Geldlades","create":"Voeg een geldlade toe","update":"Pas geldlade aan"},"breadcrumb":{"title":"Overzicht"},"columns":{"name":"Naam","organization":"Organisatie","mixes":"Kassa Mix"},"form":{"name":"Naam","organizations":"Organisaties","units":"Units","maximumAmount":"Maximale Hoeveelheid","mixes":"Kassa Mix"},"actions":{"create":"Voeg een kassalade toe","read":"Bekijk kassalade","update":"Pas kassalade aan","delete":"Verwijder kassalade"},"messages":{"added":"De kas {name} is toegevoegd","updated":"De kas {name} is gewijzigd","disconnected":"Deze {units} units worden losgekoppeld van de geldlade {till}"}},"cit":{"titles":{"overview":"CIT procedure","create":"Voeg een CIT procedure toe","update":"Wijzig een CIT procedure","readsettings":"CIT-procedureinstellingen"},"breadcrumb":{"title":"Overschrijven"},"columns":{"name":"Naam","unitType":"Unit Type","advancedSettings":"Geavanceerde instellingen","stepTabEdit":"Stap wijzigen","stepTabNew":"Stap aanmaken","cancel":"Annuleren","create":"Creëer","update":"Wijzig","steps":"Stappen","addNewStep":"Nieuwe stap","version":"Version"},"form":{"name":"Naam","unitType":"Unit Type","organization":"Organisatie","loginType":"Login Type","firstUserRole":"Eerste gebruikersrol *","secondUserRole":"Tweede gebruikersrol *","allSteps":"Alle stappen","selectedSteps":"Geselecteerde stappen","performPrint":"CIT bonnen","scanLength":"Barcode lengte","prefixBarcode":"Barcode voorvoegsel","emptyCoinDevice":"Legen munten opslag","printOnCassetteDetached":"Ontvangstbewijs op cassette verwijderd","placeholder":"Componenten","placeholderAction":"Componenten Actie","stepCondition":"Voorwaarde","stepSkip":"Voorwaardelijke vervolgstap","loadingPlaceholderText":"Selecteer eerst een willekeurig type unit","loadingPlaceholderActionText":"Selecteer eerst een component","loadingPlaceholderConditionText":"Selecteer eerst een component","nextStep":"Volgende stap","next":"Volgende","skipTo":"Stap: {number}","options":{"autologin":"Automatische login","singlelogin":"Enkele login","multiplelogin":"Meerdere logins","locklogin":"Login met Lock Pin"},"translationEn":"Stap titel","translationNl":"Stap titel","translationUs":"Stap titel","translationFr":"Stap titel","translationPl":"Stap titel","translationEl":"Stap titel","translationHu":"Stap titel","translationSk":"Stap titel","translationDe":"Stap titel","translationKey":"Vertaalsleutel","translationKeyInfo":"Vertaalsleutel: {translationKey}","confirmDialog":"Dialoog bevestigen","confirmationDialogLabel":"Moet bevestigingsvenster worden weergegeven?","noMatchingCondition":"Het geselecteerde onderdeel heeft geen voorwaarde.","noMatchingAction":"Het geselecteerde component heeft geen acties.","importWorkflow":"Importeer workflow","sdcGrouping":"Disable SDC grouping"},"toolTip":{"name":"De naam van de werkflow. Het unit type en de organisatie kunnen in de naam worden opgenomen, zodat de werkflow makkelijker gevonden kan worden","unitType":"Het unit type van de units die deze werkflow kunnen gebruiken","organization":"De organization die deze werkflow mag wijzigen","loginType":"De manier waarop de gebruiker in kan loggen op de unit, alvorens het geld wordt opgehaald. Wanneer automatische login is geselecteerd, start de procedure wanneer de deur is geopend","firstUserRole":"De rol van de gebruiker die in moet loggen op de unit, alvorens deze wordt geleegd","secondUserRole":"De rol van de tweede gebruiker die in moet loggen op de unit, alvorens deze wordt geleegd","allSteps":"De pagina's die je kunt kiezen voor een unit om doorheen te gaan tijdens een CIT procedure om geld op te halen uit de machine. De pagina's kunnen geselecteerd worden door ze van links naar rechts te slepen. De pagina's die beginnen met (legacy) kunnen niet gebruikt worden door units met softwareversie 4 en hoger.","selectedSteps":"De pagina's die de unit zal doorlopen tijdens een CIT procedure om het geld te legen uit de machine.","performPrint":"Print bon aan het einde van de procedure","scanLength":"De lengte van de barcode op de geldcassette/zak","prefixBarcode":"De text aan het begin van de barcode, bijvoorbeeld BE. Dit verschijnt op een knop wanneer de barcode handmatig wordt ingevoerd","emptyCoinDevice":"Ga er van uit dat de munten geleegd worden tijdens de CIT en trek de waarde van de munten af van de totaal waarde in de machine","printOnCassetteDetached":"Nadat een cassette is verwijderd, wordt een ontvangstbewijs met de inhoud van die cassette afgedrukt","placeholder":"Componenten van het geselecteerde unit type.","placeholderAction":"Acties voor de geselecteerde componenten.","stepCondition":"Voorwaarden van de geselecteerde component","stepSkip":"Doorgaan naar de volgende stap","options":{"autologin":"Automatische login","singlelogin":"Enkele login","multiplelogin":"Meerdere logins","locklogin":"Login met Lock Pin"},"translationEn":"De stappentitel wordt getoond wanneer Engels is geselecteerd","translationNl":"De stappentitel wordt getoond wanneer Nederlands is geselecteerd","translationUs":"De stappentitel wordt getoond wanneer Engels (VS) is geselecteerd","translationFr":"De stappentitel wordt getoond wanneer Frans is geselecteerd","translationDe":"De stappentitel wordt getoond wanneer Duits is geselecteerd","translationPl":"De stappentitel wordt getoond wanneer Pools is geselecteerd","translationEl":"De stappentitel wordt getoond wanneer Grieks is geselecteerd","translationHu":"De stappentitel wordt getoond wanneer Hongaars is geselecteerd","translationSk":"De stappentitel wordt getoond wanneer Sloveens is geselecteerd","translationKey":"Vertaalsleutel","confirmDialog":"Dialoog bevestigen","importXmlTooltip":"Accepteer slechts één .xml bestand","sdcGrouping":"If this is checked, system will create separate 'Clear box item' per placeholder, instead of grouping them into one SDC."},"conditions":{"REJECT_BIN_IS_EMPTY":"Weigerbak is leeg","COIN_OVERFLOW_NOT_FULL":"Muntoverloop is niet vol"},"actions":{"create":"Voeg workflow toe","read":"Bekijk workflow","update":"Wijzig workflow","delete":"Verwijder workflow","readsettings":"Bekijk de workflow-instellingen","export":"Exporteer werkflow"},"messages":{"added":"De workflow {name} is toegevoegd","updated":"De workflow {name} is gewijzigd","noPageSelected":"Selecteer een stap, a.u.b.","checkStepFormFields":"Verify that all Step fields are correct","stepAdded":"Step toegevoegd","stepUpdated":"Step gewijzigd","noStepSelectedV2":"Creëer een willekeurige stop aub","invalidXmlFile":"Upload een geldig XML bestand aub","xmlUploadSuccess":"Workflow successvol geïmporteerd","xmlUploadFailed":"Kan workflow niet uploaden","cantMoveStepUp":"Can't move this Step up","cantMoveStepDown":"Can't move this Step down"},"workflow":{"Login":"(Legacy) Log in","Remove_left_cassette":"(Legacy) Verwijder linker cassette","Insert_left_cassette":"(Legacy) Plaats linker cassette","Remove_right_cassette":"(Legacy) Verwijder rechter cassette","Insert_right_cassette":"(Legacy) Plaats rechter cassette","Remove_any_cassette":"(Legacy) Verwijder willekeurige cassette","Insert_any_cassette":"(Legacy) Plaats willekeurige cassette","Remove_cassette":"(Legacy) Verwijder cassette","Insert_cassette":"(Legacy) Plaats cassette","Scan_left_reader_barcode":"(Legacy) Scan barcode van linker lezer","Scan_right_reader_barcode":"(Legacy) Scan barcode van rechter lezer","Scan_new_cassette_barcode":"(Legacy) Scan nieuwe cassette barcode","Open_the_door_Linux":"(Legacy) Open de deur (Linux)","Close_the_door__Linux":"(Legacy) Sluit de deur (Linux)","Lock_the_door":"(Legacy) Vergrendel de deur","Sign_out":"(Legacy) Log uit","Unlock_the_door":"(Legacy) Ontgrendel de deur","Open_coin_acceptor_dropsafe_Linux":"(Legacy) Open munt acceptor dropsafe (Linux)","Empty_cassette_and_close_the_dropsafe_Linux":"(Legacy) Leeg cassette en sluit de dropsafe (Linux)","Scan_new_left_cassette_barcode":"(Legacy) Scan nieuwe linker cassette barcode","Scan_new_right_cassette_barcode":"(Legacy) Scan nieuwe rechter cassette barcode","Securing_safe":"(Legacy) Veiligstellen kluis","CIT_procedure_completed":"(Legacy) CIT procedure voltooid","Open_the_door_Windows":"(Legacy) Open de deur (Windows)","Close_the_door_Windows":"(Legacy) Sluit de deur (Windows)","Open_coin_acceptor_dropsafe_Windows":"(Legacy) Open munt acceptor dropsafe (Windows)","Empty_cassette_and_close_the_dropsafe_Windows":"(Legacy) Leeg cassette en sluit de dropsafe (Windows)","AUTO_UNLOCK_FRONT_DOOR":"Automatically unlock front door","WI_UNLOCK_FRONT_DOOR":"Unlock front door (no PIN)","LP_UNLOCK_FRONT_DOOR":"Ontgrendel voordeur (LPLOCK)","LP_LOCK_FRONT_DOOR":"Vergrendel voordeur (LPLOCK)","LP_OPEN_FRONT_DOOR":"Open voordeur (LPLOCK)","LP_CLOSE_FRONT_DOOR":"Sluit voordeur front door (LPLOCK)","VIM_READ_KEY_CIT":"Presenteer CIT sleutel","V2_UNLOCK_CIT_DOOR":"Ontgrendel deur (Linux)","V2_OPEN_CIT_DOOR_LINUX":"Open deur (Linux)","V2_REMOVE_SEALPACK_FROM_COIN_STORAGE":"Verwijder sealpack uit de muntopslag","V2_INSERT_NEW_SEALPACK_TO_COIN_STORAGE":"Plaats nieuwe sealpack in muntopslag","V2_REMOVE_STORAGE":"Verwijder opslag","V2_INSERT_STORAGE":"PLaats opslag","V2_CLOSE_CIT_DOOR_LINUX":"Sluit deur (Linux)","V2_LOCK_CIT_DOOR":"Vergrendel deur (Linux)","V2_PROCESSING_CIT":"Beveilig kluis - Lincstation","V2_REMOVE_CASSETTE":"Verwijder cassette","V2_INSERT_CASSETTE":"Plaats cassette","V2_EMPTY_CASSETTE":"Leeg de cassette","V2_OPEN_CIT_DOOR_WINDOWS":"Open deur (Windows)","V2_CLOSE_CIT_DOOR_WINDOWS":"Sluit deur (Windows)","V2_REMOVE_LEFT_CASSETTE":"Verwijder linker cassette","V2_INSERT_LEFT_CASSETTE":"Plaats linker cassette","V2_REMOVE_RIGHT_CASSETTE":"Verwijder rechter cassette","V2_INSERT_RIGHT_CASSETTE":"Plaats rechter cassette","V2_LOGIN":"Gebruiker Login","V2_CIT_PROCEDURE_COMPLETED":"CIT procedure voltooid","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_LINUX":"Open munt dropsafe (Linux)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_LINUX":"Leeg munt dropsafe (Linux)","V2_SCAN_LEFT_READER_BARCODE":"Scan linker barcode","V2_SCAN_RIGHT_READER_BARCODE":"Scan rechter barcode","V2_SCAN_STORAGE_BARCODE":"Scan opslag","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_WINDOWS":"Open munt dropsafe (Windows)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_WINDOWS":"Leeg munt dropsafe (Windows)","V2_OPEN_CIT_DOOR":"Open CIT deur","V2_CLOSE_CIT_DOOR":"Sluit CIT deur","V2_PROCESSING_LINCSTATION_CIT":"Beveilig kluis (Lincstation)","V2_OPEN_THE_DOOR_LINUX":"Open de deur (Linux)","V2_CLOSE_THE_DOOR_LINUX":"Sluit deur (Linux)","V2_UNLOCK_DOOR":"Ontgrendel deur (Linux)","V2_LOCK_DOOR":"Vergrendel deur (Linux)","V2_PROCESSING_SAFE_CIT":"Beveilig kluis","V2_PRINT_LEFT_CASSETTE":"Print linker cassette","V2_PRINT_RIGHT_CASSETTE":"Print rechter cassette","V2_PRINT_CIT_TOTAL":"Print CIT totaal","V2_SEAL_BAG":"Seal bag","V2_UNLOCK_SIDESAFE_WITH_BO_COIN":"Ontgrendel munt zijkluis","V2_UNLOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Ontgrendel zijkluis","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_COIN":"Leeg en vergrendel munt zijkluis","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Leeg en vergrendel zijkluis","V2_SEALING_BAG":"Sealing bag","V2_REPLACE_SEAL_BAG":"Vervang seal bag","V2_SCAN_COIN_STORAGE_BARCODE":"Scan munt opslag","V2_COIN_ROLL_FILL_UP":"Muntrol vullen","V2_EMPTY_COUNTERS":"Lege tellers","V2_EMPTY_ESCROW":"Lege escrow","V2_SKIP_EMPTY_ESCROW_SAFEBAG_FULL":"Sla legen van escrow over wanneer sealbag vol is","V2_WAIT_10":"10 Seconden vertraging","V2_OPEN_OM61_DOOR":"Open OM61 deur","V2_CLOSE_OM61_DOOR":"Sluit OM61 deur","V2_UNLOCK_OM61_BAG_STORAGE":"Ontgrendel het opbergvak van de OM61-zak","V2_TAKE_OM61_STORAGE_BAG":"Neem OM61 opbergzak","V2_INSERT_NEW_OM61_STORAGE_BAG":"Plaats nieuwe OM61 opbergzak","V2_OPEN_CIT_DOOR_LINCSTATION_V3":"Open deur (Lincstation v3)","V2_CLOSE_CIT_LINCSTATION_V3":"Sluit deur (Lincstation v3)","V2_PROCESSING_CIT_LINCSTATION_V3":"Beveilig kluis (Lincstation v3)","V2_UNLOCK_LINCSTATION_V3":"Ontgrendel deur (Lincstation v3)","V2_LOCK_LINCSTATION_V3":"Vergrendel deur (Lincstation v3)","V2_INSTALL_OM61_STORAGE_BAG":"Installeer OM61 opbergzak","V2_UNLOCK_FRONT_DOOR":"Ontgrendel voordeur","V2_UNLOCK_FRONT_DOOR_SPT":"Ontgrendel voordeur (SPT)","V2_OPEN_FRONT_DOOR":"Open voordeur","V2_CLOSE_FRONT_DOOR":"Vergrendel voordeur","V2_LOCK_FRONT_DOOR":"Vergrendel voordeur","V2_LOCK_FRONT_DOOR_SPT":"Vergrendel voordeur (SPT)","V2_SECURE_SAFE":"Kluis afsluiten","V2_REMOVE_PULOON_CASSETTE_1":"Verwijder 1e aanwezige dispenser cassette","V2_REMOVE_PULOON_CASSETTE_2":"Verwijder 2e aanwezige dispenser cassette","V2_INSERT_PULOON_CASSETTE_1":"Plaats 1e nieuwe dispenser cassette","V2_INSERT_PULOON_CASSETTE_2":"Plaats 2e nieuwe dispenser cassette","V2_UNLOCK_CIT_DOOR_2":"Ontgrendel CIT deur 2","V2_LOCK_CIT_DOOR_2":"Vergrendel kluisdeur 2","V2_OPEN_CIT_DOOR_LINUX_2":"Open kluisdeur (Linux) 2","V2_CLOSE_CIT_DOOR_LINUX_2":"Sluit kluisdeur (Linux) 2","V2_UNLOCK_FRONT_DOOR_2":"Ontgrendel voordeur 2","V2_UNLOCK_FRONT_DOOR_SPT_2":"Ontgrendel voordeur 2 (SPT)","V2_OPEN_FRONT_DOOR_2":"Open voordeur 2","V2_CLOSE_FRONT_DOOR_2":"Sluit voordeur 2","V2_LOCK_FRONT_DOOR_2":"Vergrendel voordeur 2","V2_LOCK_FRONT_DOOR_SPT_2":"Vergrendel voordeur 2 (SPT)","V2_PAUSE_CIT":"Pauze CIT","V2_REMOVE_REJECT_BIN":"Verwijder afkeerbak","V2_CONFIRM_EMPTY_REJECT_BIN":"Bevestig lege afkeurbak","V2_INSERT_REJECT_BIN":"Plaats afkeerbak","V2_FILL_UP_COINS":"Vul coin recycler bij","V2_OPEN_COIN_OVERFLOW_DOOR_SPT":"Open munt overflow deur (SPT)","V2_EMPTY_COINS_AND_CLOSE_COIN_OVERFLOW_DOOR_SPT":"Leeg munten en sluit munt overflow deur (SPT)","V2_SECURE_CIT_DOOR":"Beveilig CIT deur (SPT)","V2_SECURE_CIT_DOOR_2":"Beveilig CIT deur 2 (SPT)","V2_SECURE_FRONT_DOOR":"Beveilig voordeur (SPT)","V2_SECURE_FRONT_DOOR_2":"Beveilig voordeur 2 (SPT)","dynamic":{"LOCK_OPEN":"Slot openen","LOCK_CLOSE":"Slot sluiten","LOCK_OPEN_WITH_PIN":"Slot openen met pin","DOOR_OPEN":"Open deur","DOOR_CLOSE":"Sluit deur","DOOR_SECURE":"Beveilig deur","CIT_COMPLETED":"CIT voltooid","CIT_PAUSE":"CIT pauzeerd","CIT_DIALOG":"CIT dialoog","CIT_USER_LOGIN":"CIT gebruiker login","COIN_OVERFLOW_EMPTY":"Munt overflow legen","COIN_FILL_UP":"Vul munt bij","COIN_EMPTY_OVERFLOW_STORAGE":"Leeg munt overflow opslag","STORAGE_REMOVE_CASSETTE":"Verwijder opslag cassette","STORAGE_ATTACH_CASSETTE":"Bevestig opslag cassette","STORAGE_PULOON_REMOVE_DISPENSER_1":"Verwijder storage puloon dispenser 1","STORAGE_PULOON_ATTACH_DISPENSER_1":"Bevestig storage puloon dispenser 1","STORAGE_PULOON_REMOVE_DISPENSER_2":"Verwijder storage puloon dispenser 2","STORAGE_PULOON_ATTACH_DISPENSER_2":"Bevestig storage puloon dispenser 2","STORAGE_PULOON_REMOVE_DISPENSER_3":"Verwijder storage puloon dispenser 3","STORAGE_PULOON_ATTACH_DISPENSER_3":"Bevestig storage puloon dispenser 3","STORAGE_PULOON_REMOVE_DISPENSER_4":"Verwijder storage puloon dispenser 4","STORAGE_PULOON_ATTACH_DISPENSER_4":"Bevestig storage puloon dispenser 4","STORAGE_PULOON_REMOVE_REJECT_BIN":"Verwijder storage puloon afkeerbak","STORAGE_PULOON_ATTACH_REJECT_BIN":"Bevestig storage puloon afkeerbak","COIN_REMOVE_AND_EMPTY_OVERFLOW_STORAGE":"Remove and empty coin bucket","COIN_FILL_UP_SPLIT_START":"Start deel vulling","COIN_FILL_UP_SPLIT_END":"Stop deel vulling","COIN_INSERT_OVERFLOW_STORAGE":"Insert coin bucket","CIT_IBUTTON_LOGIN":"iButton login","MANUAL_DEPOSIT_EMPTY":"Leeg manuele storting","CENCON_LOCK_OPEN":"Open Cencon lock","CENCON_LOCK_CLOSE":"Close Cencon lock","TRAY_OPEN":"Open hitachi door","TRAY_CLOSE":"Close hitachi door","HITACHI_REJECT_BOX_CLOSE":"Close reject box","HITACHI_REJECT_BOX_OPEN":"Open reject box and empty its contents","STORAGE_ONE_ATTACHED":"Plaats opslag cassette","STORAGE_ONE_REMOVED":"Verwijder opslag cassette","HITACHI_STORAGE_ONE_ATTACHED":"Attach hitachi storage","HITACHI_STORAGE_ONE_REMOVED":"Remove hitachi storage","HITACHI_STORAGE_TWO_ATTACHED":"Plaats cassette 2","HITACHI_STORAGE_TWO_REMOVED":"Verwijder cassette 2","HITACHI_STORAGE_THREE_ATTACHED":"Plaats cassette 3","HITACHI_STORAGE_THREE_REMOVED":"Verwijder cassette 3","HITACHI_STORAGE_FOUR_ATTACHED":"Plaats cassette 4","HITACHI_STORAGE_FOUR_REMOVED":"Verwijder cassette 4","HITACHI_STORAGE_FIVE_ATTACHED":"Plaats cassette 5","HITACHI_STORAGE_FIVE_REMOVED":"Verwijder cassette 5","HITACHI_STORAGE_ONE_SCAN_NEW_BARCODE":"Scan nieuwe barcode voor cassette 1","HITACHI_STORAGE_ONE_SCAN_OLD_BARCODE":"Scan oude barcode voor cassette 1","HITACHI_STORAGE_TWO_SCAN_NEW_BARCODE":"Scan nieuwe barcode voor cassette 2","HITACHI_STORAGE_TWO_SCAN_OLD_BARCODE":"Scan oude barcode voor cassette 2","HITACHI_STORAGE_THREE_SCAN_NEW_BARCODE":"Scan nieuwe barcode voor cassette 3","HITACHI_STORAGE_THREE_SCAN_OLD_BARCODE":"Scan oude barcode voor cassette 3","HITACHI_STORAGE_FOUR_SCAN_NEW_BARCODE":"Scan nieuwe barcode voor cassette 4","HITACHI_STORAGE_FOUR_SCAN_OLD_BARCODE":"Scan de oude barcode voor cassette 4","HITACHI_STORAGE_FIVE_SCAN_NEW_BARCODE":"Scan de nieuwe barcode voor cassette 5","HITACHI_STORAGE_FIVE_SCAN_OLD_BARCODE":"Scan de oude barcode voor cassette 5","HITACHI_STORAGE_SIX_SCAN_NEW_BARCODE":"Scan de nieuwe barcode voor cassette 6","HITACHI_STORAGE_SIX_SCAN_OLD_BARCODE":"Scan de oude barcode voor cassette 6","ENTER_BAG_NUMBER":"Tasnummer invoeren"}},"dialog":{"title":"Confirm change order","description":"The Step: {stepOrder} can't be moved without breaking Skip to value of Step: {colindantStepOrder}","confirmation":"Change order anyway and remove Skip to value ?"}},"notification":{"titles":{"read":"Notificatie Details"},"read":"Notificatie Details"},"report":{"buttons":{"createReport":"CREËER RAPPORT","generating":"Bezig met genereren..."},"titles":{"overview":"Rapport","create":"Voeg een rapport toe","update":"Wijzig een rapport"},"breadcrumb":{"title":"rapport"},"form":{"orgUuid":"Organisatie","unitUuid":"Unit","type":"Type","startDate":"Van","endDate":"Tot","types":{"getReptileCampaignsAndTransactionsByDate":"Transacties en clearboxes","getReptileCampaignsAndTransactionsMoneyInOutCounterByDate":"Transacties en clearboxes met geld in/uit teller","getReptileTransactionsByDate":"Transacties","getManualTransactionsByDate":"[Verouderd] Dropsafe","getReptileManualTransactionsByDate":"Dropsafe - Nieuw","getReptileReportForClosedCampaignsByUnitAndDate":"Clearboxes","getReptileClearboxDenomination":"[Verouderd] Clearboxes denominatie","getReptileClearboxDenominationV2":"Clearboxes denominatie","getReptileEndOfDayInfoByDate":"Einde van de dag totaal per unit","getReptileLincstationEndOfDayInfoByDate":"Lincstation Einde van de dag Totaal Per Unit","getEndOfDayClientsByDate":"[Verouderd] Einde Dag per organisatie","getReptileEndOfDayClientsByDate":"Einde Dag per organisatie - Nieuw","getEventsByDate":"Gebeurtenissen per dag","getReptileEventsByDate":"Gebeurtenissen per dag - Nieuw","getReptileReportForDenominationPerUser":"Denominaties Per Gebruiker","getReptileReportForDenominationWithPin":"Denominaties met Pin","getReptileSalesByDate":"Verkoop - Nieuw","getInternalTransactionsByDate":"[Verouderd] Interne transacties","getReptileInternalTransactionsByDate":"Interne transacties - Nieuw","getReptileAdvancedManualDeposit":"Geavanceerde handmatige invoer","getReptileRecyclerReport":"Algemeen rapport Lincstation","getReptileTransactionsWithReference":"Transacties met referentienummer","getReptileUserActivityPdf":"Gebruikers Transactie Rapport (.pdf)","getReptileUserActivityCsv":"Gebruikers Transactie Rapport (.csv)","getTransactionsWithReference":"[Verouderd] Transacties met referentienummer","getCampaignsWithBarcodes":"[Verouderd] Clearboxes met Sealnummers","getSalesByDate":"[Verouderd] Verkoop","getCurrentlyOfflineUnits":"Currently Offline Units (.csv)","getReptileCashCoinEndOfDayInfoByDate":"End of Day Cash/Coin","getReptileUnitInventory":"Unit Inventory (.pdf)","getReptileCampaignsAndTransactionsByDateWithSource":"Smartsafes transactions and clearboxes","getReptileEndOfDaySmartSafes":"Smartsafes End Of Day (.pdf)","getReptileEndOfDaySmartSafesXlsx":"Smartsafes End Of Day (.xlsx)","getReptileEndOfDayRecyclerXlsx":"Recycler End Of Day (.xlsx)","getReptileCampaignSmartSafesPdf":"Smartsafes Campaign (.pdf)","getReptileCampaignSmartSafesXlsx":"Smartsafes Campaign (.xlsx)","getReptileTransactionSmartSafesPdf":"Smartsafes Transaction (.pdf)","getReptileTransactionSmartSafesXlsx":"Smartsafes Transaction (.xlsx)","getReptileTransactionSmartSafesDetailedPdf":"Smartsafes Transaction Detailed (.pdf)","getReptileTransactionSmartSafesDetailedXlsx":"Smartsafes Transaction Detailed (.xlsx)","getOrganizationAssetsXlsx":"Smartsafes Asset Management (.xlsx)","getOrganizationAssetsPdf":"Smartsafes Asset Management (.pdf)","getReptileEventSmartSafesXlsx":"Smartsafes Event (.xlsx)","getReptileEventSmartSafesPdf":"Smartsafes Event (.pdf)"}},"messages":{"success":"Het rapport is met succes opgehaald. Het bestand zou nu automatisch moeten downloaden...","failed":"Het rapport kon niet gegenereerd worden. Probeer het later nog eens","reptileDateLimitExceeded":"Het rapport kon niet worden gegenereerd. De opgegeven datalimiet is overschreden. Pas uw datumbereik aan en probeer het opnieuw.","reptileGenericBadRequest":"Het rapport kon niet worden gegenereerd vanwege een ongeldige aanvraag. Controleer uw invoerparameters en probeer het later opnieuw.","cannotOutputToCsvFile":"The report could not be generated. Please try again later and/or with different parameters.","errorOccurred":"The report could not be generated. Unknown error occurred."},"dialog":{"title":"Het rapport is met succes opgehaald.","download":"Klik hier om het rapport te downloaden","close":"Sluiten"}},"transaction":{"read":"Transactie Detail"},"adminsettings":{"titles":{"overview":"Valuta onderhoud"},"breadcrumb":{"title":"Overzicht"},"messages":{"updated":"Valuta en denominatie gewijzigd","error":"Er is iets misgegaan, valuta en denominatie niet bijgewerkt"},"form":{"currency":"Valuta","iso1":"ISO1","iso2":"ISO2","iso3":"ISO3","symbol":"Symbool","symbolCode":"Symbool code","defaultValue":"standaardwaarde","enabled":"Ingeschakeld","denomination":{"value":"Waarde","coins":"Munten","bills":"Biljetten","enabled":"Ingeschakeld","remove":"Verwijder"}}},"mix":{"titles":{"overview":"Kassa mix","create":"Creëer kassa mix","update":"Wijzig kassa mix"},"breadcrumb":{"title":"Overzicht"},"form":{"mixName":"Kassa mix naam","totalAmount":"Totaal Aantal","organization":"Organisatie","denominations":"Denominaties","currency":"Currency","eur":"EURO","usd":"USD","gbp":"GBP"},"columns":{"name":"Kassa mix naam","totalAmount":"Total Aantal","details":"Details","totalValue":"Totale Waarde"},"read":{"mixDetails":"Kassa mix details"},"actions":{"create":"Voeg kassa mix toe","update":"Wijzig kassa mix","delete":"Verwijder kassa mix","read":"Bekijk kassa mix"}},"common":{"form":{"bankAccount":"Primary bank account number","citAccount":"CIT account number","affiliateCode":"Affiliate code","overrideBankAccount":"Override primary bank account number","overrideCitAccount":"Override CIT account number","overrideAffiliateCode":"Override affiliate code"},"toolTip":{"bankAccount":"Bank account number to which deposits/withdrawals are transmitted from the safe(s). Can be overridden at a more granular level","citAccount":"Bank account number to which funds are deposited after CIT. Usually the same as primary bank account number","affiliateCode":"4 digit alphabetical code"}},"department":{"titles":{"overview":"Departments","create":"Create a department","update":"Update department","preview":"Preview department"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Name","organizationName":"Organization"},"form":{"name":"Name","organization":"Organization","bankAccount":"Bank account number"},"toolTip":{"organization":"Which organization does this department belong to","bankAccount":"Bankrekeningnummer waarnaar stortingen/opnames vanuit de kluis(en) worden overgemaakt.","overrideBankAccount":"Neem de primaire bankrekening niet over van de Organisatie. Definieer in plaats daarvan een nieuwe rekening die specifiek is voor deze afdeling.","affiliateCode":"Affiliatecode van het bankrekeningnummer.","overrideAffiliateCode":"Neem de affiliatecode niet over van de Organisatie. Definieer in plaats daarvan een nieuwe rekening die specifiek is voor deze afdeling."},"actions":{"create":"Create department","read":"Preview department","update":"Update department","delete":"Delete department","preview":"Preview department"},"messages":{"added":"Department {name} has been created","updated":"Department {name} has been updated"}},"unitRoles":{"titles":{"overview":"Unit roles","create":"Add a unit role","update":"Update unit role"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Unit role name","organization":"Organization"},"actions":{"create":"Add unit role","update":"Update unit role","delete":"Delete unit role"},"form":{"name":"Unit role name","organization":"Organization","transactionCashOutLimit":"Transaction cash out limit","dailyCashOutLimit":"Daily cash out limit","permissions":"Permissions"},"messages":{"added":"The unit role {name} is added","updated":"The unit role {name} is updated"}}},"server_messages":{"accessNotAllowed":"Geen toegang toegestaan.","authorizationFailed":"Authorisatie is mislukt.","campaignNotFound":"Clearbox niet gevonden!","cityCannotBeEmpty":"Stad mag niet leeg zijn!","componentNotFound":"Component niet gevonden!","countryCannotBeEmpty":"Land mag niet leeg zijn!","countryNotFound":"Land niet gevonden!","credentialsCannotBeEmpty":"Inloggegevens mogen niet leeg zijn","currencyNotFound":"Valuta niet gevonden!","duplicateItemFound":"Item bestaat al!","errorOccurred":"Er heeft een fout plaatsgevonden en die is gelogd.","ILLEGAL_ARGUMENT":"Verkeerde waarde","ILLEGAL_ARGUMENT_ADDRESS_TYPE":"Er ging iets fout met het adres","ILLEGAL_ARGUMENT_ADDRESSLINE1":"Verander adres regel 1 aub","ILLEGAL_ARGUMENT_ADDRESSLINE2":"Verander adres regel 2 aub","ILLEGAL_ARGUMENT_BANK_ACCOUNT":"Verander het bank rekening nummer aub","ILLEGAL_ARGUMENT_CHILD_ORGANIZATION":"Verander eerst de onderliggende organisatie","ILLEGAL_ARGUMENT_CIT":"Er ging iets fout met de CIT informatie","ILLEGAL_ARGUMENT_CITY":"Verander de plaats aub","ILLEGAL_ARGUMENT_CLIENT_ORGANIZATION":"Verander de client organisatie aub","ILLEGAL_ARGUMENT_COUNTRY":"Verander het land aub","ILLEGAL_ARGUMENT_CURRENCY":"Verander de valuta svp","ILLEGAL_ARGUMENT_DATE":"Verander de datum aub","ILLEGAL_ARGUMENT_DESCRIPTION":"Verander de omschrijving aub","ILLEGAL_ARGUMENT_FIRST_NAME":"Verander de voornaam aub","ILLEGAL_ARGUMENT_GENDER":"Er ging iets fout met het geslacht","ILLEGAL_ARGUMENT_ID":"Verander de ID aub","ILLEGAL_ARGUMENT_LAST_NAME":"Verander de achternaam aub","ILLEGAL_ARGUMENT_LEGAL_FORM":"verander de juridische identiteit","ILLEGAL_ARGUMENT_LOCATION":"Verander de locatie aub","ILLEGAL_ARGUMENT_LOCATION_UUID":"Kan de locatie niet vinden","ILLEGAL_ARGUMENT_MACHINE_TYPE":"Verander de machine type","ILLEGAL_ARGUMENT_MAIL":"Verander het email adres aub","ILLEGAL_ARGUMENT_MAINTENANCE":"Er ging iets fout met de onderhoud informatie","ILLEGAL_ARGUMENT_NAME":"Verander de naam aub","ILLEGAL_ARGUMENT_ORGANIZATION":"Verander de organisatie aub","ILLEGAL_ARGUMENT_ORGANIZATION_TYPE":"Verander de organisatie type","ILLEGAL_ARGUMENT_ORGANIZATION_UNIT_TYPE":"Er ging iets fout met de combinatie van organisatie en unit type","ILLEGAL_ARGUMENT_ORGANIZATION_UUID":"kan de organisatie niet vinden","ILLEGAL_ARGUMENT_OWNER_ORGANIZATION":"Verander de eigenaar organisatie aub","ILLEGAL_ARGUMENT_PAGE_NUMBER":"Er ging iets fout met het pagina nummer","ILLEGAL_ARGUMENT_PAGE_SIZE":"Er ging iets fout met de pagina grootte","ILLEGAL_ARGUMENT_PARENT_ORGANIZATION":"Verander de bovenliggende organisatie aub","ILLEGAL_ARGUMENT_PASSWORD":"Verander het wachtwoord aub","ILLEGAL_ARGUMENT_PERSON":"Er ging iets fout met de gebruikersinformatie","ILLEGAL_ARGUMENT_PHONE_NUMBER":"Verander het telefoon nummer aub","ILLEGAL_ARGUMENT_PIN":"Verander de PIN aub","ILLEGAL_ARGUMENT_REPORTED_ORGANIZATIONS":"Verander de gerapporteerde organisaties","ILLEGAL_ARGUMENT_ROLES":"Verander de rol aub","ILLEGAL_ARGUMENT_SDC":"Er ging iets fout met de clearbox","ILLEGAL_ARGUMENT_SERIAL":"Verander het serienummer aub","ILLEGAL_ARGUMENT_TOKEN":"Er is iets fout met de login informatie","ILLEGAL_ARGUMENT_UNIT":"Verander de unit","ILLEGAL_ARGUMENT_UNIT_TYPE":"Verander het unit type","ILLEGAL_ARGUMENT_UNIT_UUID":"Kan de unit niet vinden","ILLEGAL_ARGUMENT_USER":"Verander de gebruiker aub","ILLEGAL_ARGUMENT_UUID":"We kunnen de informatie niet ophalen","INVALID_CREDENTIALS":"Ongeldige aanmeldgegevens","INVALID_PATH":"Ongeldig pad","invalidData":"Ongeldige gegevens","legalFormNotFound":"Juridisch formulier niet gevonden!","locationInUse":"Locatie is in gebruik","locationNameCannotBeEmpty":"Locatie naam mag niet leeg zijn!","locationNotFound":"Locatie niet gevonden!","locationUpdateDataIsInvalid":"De gewijzigde gegevens voor de locatie zijn ongeldig!","LOCKED":"Vergrendeld","LOGOUT":"Uitgelogd!","NO_RESULT":"geen resultaten","organizationInUse":"Organisatie is in gebruik","organizationListFetched":"Organisatie lijst opgehaald.","organizationNotFound":"Organisatie niet gevonden.","organizationTypeNotFound":"Organisatie type niet gevonden.","passwordIsInvalid":"Wachtwoord is ongeldig!","phoneNumberLengthIsIncorrect":"De lengte van het telefoonnummer is incorrect","pinIsEmpty":"Voer een PIN in aub","pinNotNumeric":"Gebruik alleen cijfers in de pin, a.u.b.","roleNotFound":"Rol niet gevonden.","sessionTimeout":"Sessie timeout","settingsNotFound":"Instellingen niet gevonden","SUCCESS":"Succes","SYSTEM_FAIL":"System gefaald!","transactionNotFound":"Transactie niet gevonden","UNABLE_TO_STORE_INFO":"De informatie kon niet worden opgeslagen","UNAUTHORIZED":"Ongeautoriseerde toegang","unitNotFound":"Unit niet gevonden.","unitTypeListFetched":"Unit type lijst opgehaald.","userAlreadyExists":"Gebruiker bestaat al","userIsLocked":"Gebruiker is geblokkeerd.","userNotFound":"Gebruiker niet gevonden","workflowInUseByOtherOrg":"Workflow in gebruik bij een andere organisatie, verander de organisatie of verwijder de workflow van de andere organisaties/units","workflowNotFound":"Workflow niet gevonden!","invalidFormatException":"Incorrect data formaat, controleer de data in de JSON structuur a.u.b.","unrecognizedPropertyException":"Controleer de velden in het JSON structuur a.u.b.","jsonParseException":"Kon de JSON niet goed verwerken (parsen), controleer de structuur a.u.b.","jsonMappingException":"Kon de indeling van de JSON niet goed verwerken, controleer de structuur a.u.b","iOException":"Kon de JSON niet goed verwerken (parsen), controleer de structuur a.u.b.","minimumGreaterThanOptimum":"Minimaal aantal is groter dan optimaal","maximumLessThanOptimum":"Maximaal aantal is minder dan optimaal","ILLEGAL_ARGUMENT_MIX_UUID":"Kan kassa mix niet vinden","ILLEGAL_ARGUMENT_MAX_AMOUNT":"Verander maximale aantal aub","TILL_IS_BEING_USED_BY_USER":"Geldlade wordt gebruikt door gebruiker","TILL_IS_BEING_USED_BY_UNIT":"Geldlade wordt gebruikt door unit","secretIsEmpty":"Leeg geheim gevonden","secretAlreadyExists":"Ongeldig geheim gegenereerd. Gelieve opnieuw te genereren","MIN_FOUR_DIGITS":"PIN code moet minstens 4 cijfers lang zijn","MIN_SIX_DIGITS":"PIN code moet minstens 6 cijfers lang zijn","MAX_SIX_DIGITS":"PIN-code moet maximaal 6 cijfers lang zijn","NO_DUPLICATE_DIGITS":"PIN code mag geen herhaalde cijfers bevatten","NO_INCREMENTING_DIGITS":"PIN mag niet in oplopende volgorde staan","NO_DECREMENTING_DIGITS":"PIN mag niet in aflopende volgorde staan","MAX_NINETY_DAYS":"Pin is verlopen na 90 dagen, wijzig pin a.u.b.","MAX_SIXTY_DAYS":"Pin is verlopen na 60 dagen, wijzig pin a.u.b.","MAX_THIRTY_DAYS":"Pin is verlopen na 30 dagen, wijzig pin a.u.b.","PIN_LENGTH_NOT_IN_4_TO_6":"Pin lengte tussen 4 en 6 cijfers","ILLEGAL_ARGUMENT_USERNAME_NULL":"Externe gebruikersnaam mag niet leeg zijn","ILLEGAL_ARGUMENT_EXTERNAL_USERNAME_IS_NULL":"Externe gebruikersnaam mag niet leeg zijn","ILLEGAL_ARGUMENT_EXTERNAL_PASSWORD_IS_NULL":"Externe gebruikersnaam mag niet leeg zijn","ILLEGAL_ARGUMENT_EXTERNAL_HS600_PASSWORD_INVALID":"Externe HS600 wachtwoord is ongeldig. Alleen numerieke waarden zijn toegestaan","ILLEGAL_ARGUMENT_ROLES_ONE_EXTERNAL_HS600_ROLE_ALLOWED":"Slechts één externe HS600 rol is toegestaan","maxDispensableGreatherThenAllowed":"Max hoeveelheid is groter dan toegestaan","MFA_REQUIRED":"Gebruik van MFA is verplicht","duplicateSafeIdFound":"Safe ID already exists!","validationError":"Validation failed.","ILLEGAL_ARGUMENT_MIX_DENOMINATIONS":"Please select currency.","unitRoleInUseByUser":"This unit cannot be deleted because it is currently assigned to a user.","emailNotUnique":"The email address is already in use","NON_UNIQUE_USERNAME":"Duplicate user accounts found, please contact your administrator","departmentAlreadyExists":"Department name has already been taken. Please choose another name","maxAndOptimumRequiredException":"Please enter the value for the Optimum and Max column before updating the page","invalidParentOrganizationType":"The parent organization must either be of type 'GENERAL' or match the type of the organization","workflowInUseByUnits":"Workflow in use by units [{reason}]. Make sure no units are using this workflow before deleting it.","acceptanceBoxesMustComeBeforeRecyclerCassettes":"Acceptance boxes must come before recycler cassettes","firstCassetteMustBeAcceptanceBox":"First cassette must be an acceptance box","storageMustComeBeforeRecyclerCassettes":"Acceptance boxes must come before recycler cassettes","firstCassetteMustBeStorage":"First cassette must be an acceptance box"},"TRANSACTION":{"TYPE":{"NORMAL":"Normaal","MANUAL":"Handmatig","INTERNAL":"Intern","FILL_UP":"Bijvullen","CHANGE":"Wisselgeld"},"SOURCE_ACTION":{"UNKNOWN":"Onbekende bron","SHIFT_START":"Start dienst","SHIFT_END":"Einde dienst","DEPOSIT":"Storting","DISPENSE":"Uitgifte","MANUAL_DEPOSIT":"Handmatige storting","EMPTY":"Leegmaken","FLOAT":"Afromen","FILL_UP":"Bijvullen","SALES_IN":"Verkoop in","SALES_OUT":"Verkoop uit","CHANGE":"Wisselen","NOTE_VERIFICATION":"Biljetcontrole","EMPTY_ESCROW":"Leegmaken escrow","ADD_RESERVE_CHANGE":"Wisselgeld toevoegen","REMOVE_RESERVE_CHANGE":"Wisselgeld verwijderen","AUDIT_RESERVE_CHANGE":"Wisselgeld controleren","TUBE_LOAD":"Koker vullen","TUBE_UNLOAD":"Koker leegmaken","TUBE_DISPENSE":"Koker uitgeven","TUBE_BUY":"Koker kopen","DELIVER_RESERVE_CHANGE":"Wisselgeld levering toevoegen","EMPTY_COIN_OVERFLOW":"Munt-overloop legen","EMPTY_REJECT_BOX":"Empty reject box","MANUAL_CORRECTION":"Manual correction","INTERNAL_REJECT":"Internal reject","CHANGE_IN":"Wisselen in","CHANGE_OUT":"Wisselen uit"}},"placeholder_names":{"cit":{"LR":"Left note deposit","RR":"Right note deposit","CA":"Coin overflow","BA":"Note deposit","R3":"Middle note deposit","B1":"Note deposit","RC":"Note deposit","CC":"Coin overflow"},"LR":"Linker biljetlezer","RR":"Rechter biljetlezer","PR":"Printer","CA":"Munt acceptor","BO":"Breakout bord","DS":"Deursensor","PU":"Biljet dispenser","SC":"Twin coin recycler","SS":"Zij sensor","SD":"Zij driver sensor","WI":"Lincsafe smart slot","LL":"Onderste slot","HO":"Munt hopper","BA":"Biljet acceptor","DR":"Deur lezer","R3":"Midden biljet lezer","ST":"Boven sensor","TD":"Boven driver sensor","SB":"Beneden driver sensor","BD":"Beneden driver sensor","B1":"Biljet lezer","H1":"Hopper één","H2":"Hopper twee","UL":"Boven slot","BP":"Pieper","RC":"Biljet recycler","CC":"Munt recycler","DT":"Boven deur","DM":"Midden deur","DB":"Onder deur","CD":"CIT deur","MD":"Seriële onderhoudssensor voor deur","RF":"RFID lezer","SL":"Sealer","UNIT":"Unit","null":"","DRAWER":"La","SIDE_SAFE":"Zijkluis","COIN_DROP_SAFE":"Munten dropsafe","COIN_ROLL":"Munt rol","PIN_TERMINAL":"PIN terminal","WI_MAINTENANCE":"Lincsafe onderhoudsdeur smart lock","om61":"OM61","DOOR_BOTTOM":"Onderste deur","DOOR_MIDDLE":"Middelste deur","DOOR_TOP":"Bovenste deur","EXB":"Uitbreidingsbord","MLOCK_TOP":"Bovenste M-LOCK","SOLENOID_BOTTOM":"Onderste solenoïde","SWITCH_COIN_TUBE":"Coin chute","WI_MIDDLE":"Middelste wittkopp slot","NETWORK":"Netwerk","STORAGE_INVENTORY":"Opslag inhoud","UNKONWN":"Onbekend","DOOR_FRONT":"Voordeur sensor","DOOR_LEFT":"Linkerdeur sensor","DOOR_RIGHT":"Rechterdeur sensor","SOLENOID":"Solenoid","VIM":"Vault Interface Module","LOCK_FRONT":"Front door lock","LPLOCK":"Voordeur vergrendeling","MLOCK":"MLock","BOTTOM_LOCK":"Onderste vergrendeling","BO_1":"Bo 1","BO_2":"Bo 2","BUTTON_A":"Knop A","BUTTON_B":"Knop B","BUTTON_C":"Knop C","BUTTON_D":"Knop D","DOOR_TOP_LEFT":"Bovenste deur links","DOOR_TOP_RIGHT":"Bovenste deur links","EBM":"EBM","EBS":"EBS","HOPPERS":"Hoppers","HSCD":"HSCD","TOP_LEFT_LOCK":"Vergrendeling links boven","WI_TOP":"WI top","CIT_COMPLETED":"Unit","DOOR_HATCH":"Door top hatch sensor","LPLOCK_STORAGE":"LP lock storage","IBUTTON":"iButton","HITACHI_LOCK":"Cencon lock","XR":"Hitachi","JACK_STATUS":"Status koptelefoon"},"compartment_names":{"RECYCLER":"RECYCLER","STORAGE":"INHOUD","MANUAL_STORAGE":"Handmatige opslag","ESCROW":"ESCROW","HOPPERS":"HOPPERS","REJECT":"AFKEUR"},"notifications":{"ACCEPTING":"Machine is aan het accepteren","BOTTOM_DOOR_OPEN":"Deur van munt acceptor overflow is open!","BOTTOM_SIDE_DOOR_OPEN":"Onderste Sidesafe deur is open","CALIBRATING":"Machine calibreerd","CARTRIDGE_DETACHED":"Cartridge is verwijderd","CHEATED":"Fraude poging gedetecteerd","CIT_DOOR_OPEN":"Cit deur open","COIN_DRAWER_OPENED":"Munten lade is open","COIN_DROP_SAFE_OPENED":"Munten zijkluis is geopend","DEVICE_CAN_NOT_PAYOUT":"Inhoud onvoldoende om uit te betalen","DOOR_OPEN":"Deur is open","DOWNLOADING":"Downloading firmware","DRAWER_OPENED":"Lade geopend","END_OF_DAY":"Eind van de dag is achterstallig","ENTRANCE_NOT_EMPTY":"Biljet invoer is niet leeg","errorOccurred":"Interne server fout","EXTENSION_STALL":"Gestagneerd","EXCEEDS_PAYOUT_LIMIT":"Uitbetaling is hoger dan de ingestelde limiet","FAILED":"Storing gedetecteerd","FEED_FAILURE":"Bijvullen mislukt","FLOAT_NOT_SET":"Er is geen float waarde ingesteld in de Portal, stel deze eerst in!","ILLEGAL_ARGUMENT":"Verkeerde invoer","INSURABLE_VALUE_REACHED":"Verzekerde waarde bereikt. De machine dient geleegd te worden!","CASSETTE_LIMIT_REACHED":"Cassettelimiet bereikt","INVALID_CREDENTIALS":"Login details kloppen niet!","INVENTORY_LOWER_THAN_FLOAT":"Inhoud is al lager dan de float","INVENTORY_NOT_SUFFICIENT":"Inhoud is niet genoeg, vul de machine bij!","INVENTORY_OVER_MAX":"Inhoud hoger dan het maximum, float de machine af!","INVENTORY_SETTINGS_NULL":"Inhoud instellingen niet gevonden, informeer de manager!","INVENTORY_UNDER_MIN":"Inhoud onder het minimum, vul de unit bij!","INVENTORY_UNDER_LOW":"Het inhoudsniveau is te laag, vul de machine a.u.b.!","JAMMED":"Blokkade in machine","LAST_TRANSACTION_FAILED":"Laatste betaling afgebroken, informeer de manager!","LOCK_NOT_SECURE":"Smart lock is niet goed vergrendeld!","MACHINE_BUSY":"Machine is bezig, wacht tot de huidige transactie klaar is","MACHINE_NOT_OPERATIONAL":"The machine is niet operationeel, controleer notificaties","MAINTENANCE_DOOR_OPEN":"Onderhoudsdeur open","MIDDLE_DOOR_OPEN":"CIT deur is open!","NO_ACCESS":"Medewerkers hebben<br/>geen toegang tot de waarde van de kluis","NOT_CONNECTED":"Machine niet verbonden","NOT_OPERATIONAL":"Niet operationeel","NOT_RECYCLED_MATERIAL":"Niet een recycled materiaal","NOT_SECURE":"Machine is niet goed gesloten, informeer de manager!","ORGANIZATION_NOT_FOUND":"Organisatie niet gevonden","OVERRIDDEN":"Het slot is extern ontgrendeld","PAPER_EMPTY":"Papier is op","PAPER_LOW":"Papier is bijna op","PAUSE":"Gepauzeerd","PAYOUT_FAILED":"Uitbetaling mislukt","PAYOUT_LIMIT_NOT_FOUND":"Maximale uitbetalingslimiet is nog niet ingesteld!","PIN_EMPTY":"Pincode mag niet leeg zijn!","POWER_UP":"Aanzetten","RECYCLER_ALMOST_EMPTY":"Recycler is bijna leeg","RECYCLER_ALMOST_FULL":"Recycler is bijna vol","RECYCLER_EMPTY":"Recycler is leeg","RECYCLER_FULL":"Recycler is vol","REJECT_NOT_EMPTY":"Reject is niet leeg","SIDE_DOOR_ONE_OPEN":"Zijkluis(1) deur is open","SIDE_DOOR_OPEN":"Zijkluis deur is open","SIDE_SAFE_OPENED":"Zijkluis geopend","STACKER_FULL":"Stacker is vol","STALLED":"Gestagneerd","STORAGE_ALMOST_FULL":"Cassette is bijna vol, leeg de machine a.u.b.","STORAGE_DETACHED":"Cassette is verwijderd","STORAGE_FULL":"Cassette is vol, leeg de machine","TOP_DOOR_OPEN":"Onderhoudsdeur is open!","TOP_SIDE_DOOR_OPEN":"Bovenste zijkluis is deur is open","USER_BLOCKED":"Gebruiker is geblokkeerd","USER_NOT_FOUND":"Gebruiker niet gevonden","WORKFLOW_NOT_FOUND":"CIT procedure niet gevonden. Controleer de portal","ZERO_AMOUNT":"Bedrag moet groter zijn dan 0","PAYMENT_NOT_POSSIBLE_WITH_THIS_AMOUNT":"Betaling met dit bedrag is niet mogelijk","INVALID_CONFIGURATION":"Recycler configuratie incorrect","LAST_NOTE_HIGHEST_RECYCLED_VALUE":"Slechts 1 biljet met hoge waarde achter elkaar is toegestaan","MAX_AMOUNT_REACHED":"Recycler voor deze denominatie is vol","NON_RECYCLED_DENOMINATION":"Denominatie is niet gerecyceld","THREE_HIGH_VALUE_NOTES_IN_SUCCESSION":"Niet meer dan drie biljetten met hoge denominatie achter elkaar toegestaan","NOT_OPERATIONAL_005":"Muntrol dispenser 5 cent is niet operationeel","NOT_OPERATIONAL_010":"Muntrol dispenser 10 cent is niet operationeel","NOT_OPERATIONAL_020":"Muntrol dispenser 20 cent is niet operationeel","NOT_OPERATIONAL_050":"Muntrol dispenser 50 cent is niet operationeel","NOT_OPERATIONAL_100":"Muntrol dispenser 1 euro werkt niet","NOT_OPERATIONAL_200":"Muntrol dispenser 2 euro werkt niet","STORAGE_ALMOST_EMPTY_005":"Muntrol dispenser is bijna leeg voor 5 cent","STORAGE_ALMOST_EMPTY_010":"Muntrol dispenser is bijna leeg voor 10 cent","STORAGE_ALMOST_EMPTY_020":"Muntrol dispenser is bijna leeg voor 20 cent","STORAGE_ALMOST_EMPTY_050":"Muntrol dispenser is bijna leeg voor 50 cent","STORAGE_ALMOST_EMPTY_100":"Muntrol dispenser is bijna leeg voor 1 euro","STORAGE_ALMOST_EMPTY_200":"Muntrol dispenser is bijna leeg voor 2 euro"}}

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

	module.exports = {"generic":{"application_name":"LincSafe Portal","copy_right":"Wszelkie prawa zastrzeżone","submenu":{"title":"Organizacje","reset_text":"Resetowanie"},"mainmenu":{"login":"Login","submenu":"Submenu","units":"Urządzenia","users":"Użytkownicy","locations":"Lokalizacje","organizations":"Organizacje","tills":"Kasy","mixes":"Mixes","report":"Raport","citworkflow":"Proces CIT","softwaresettings":"Ustawienia oprogramowania","adminsettings":"Ustawienia administratora","departments":"Departments","roles":"Unit roles"},"overview":{"pagination":{"showing":"<strong>{current}</strong> z <strong>{total}</strong> widocznych","pagesize":{"before":"Pokaż","after":"wpisy"},"success":{"added":"Dodany {field}","updated":"Zaktualizowano {field}","deleted":"Usunięto {field}","unlocked":"Odblokowany {field}"}},"dialog":{"delete":{"title":"Potwierdź usunięcie","description":"Zamierzasz usunąć: ","confirmation":"Na pewno?","tillDescriptionName":"You are about to delete: ","tillDescriptionUnit":"and disconnect from {noUnits} unit(s): <ul>{units}</ul>","tillDescriptionUnits":"and disconnect from {noUnits} units?"},"warning":{"title":"Warning","description":"The CIT organization has been changed. Please make sure the new selection has workflows to support all unit types of this organization","confirmation":"Are you sure you want to proceed with updating?"},"unlock":{"title":"Potwierdź odblokowanie","description":"Chcesz odblokować <strong>{name}</strong>","confirmation":"Na pewno?"},"filter":{"title":"Filtr","confirmation":"OK"}},"search":{"placeholder":"Szukaj...","noresults":"Brak wyników pasujących do Twojego zapytania..."},"filter":{"selectall":"Zaznacz wszystko","deselectall":"Odznacz wszystkie","hide":"Ukryj filtr","show":"Pokaż filtr"},"buttons":{"back":"Z powrotem","cancel":"Anuluj","confirm":"Potwierdź","reset":"Resetuj","create":"Stwórz","update":"Aktualizuj","delete":"Usuń","read":"Czytaj","filter":"Filtruj","unlock":"Odblokuj","ok":"OK","upload":"Upload"}},"forms":{"errors":{"required":"{field} jest wymaganym polem","donotmatch":"{field} te pola nie pasują","minvalue":"Minimalna wartość to {min}","maxvalue":"Maksymalna wartość to {max}","mincharlength":"Minimalna długość znaku to {min}","maxcharlength":"Maksymalna długość znaków to {max}","minmaxcharlength":"Minimalna długość znaku to {min} a maksymalna długość znaków to {max}","form":"W formularzu znaleziono błędy. Sprawdź poniższe pola","userNotFound":"Nie znaleziono adresu e-mail!","password":{"missing_lowercase":"Musi zawierać co najmniej jedną małą literę (a-z)","missing_uppercase":"Musi zawierać co najmniej jedną wielką literę (A-Z)","missing_digit":"Musi zawierać co najmniej jedną cyfrę (0-9)","missing_special":"Musi zawierać co najmniej jeden znak specjalny (!\"#%&'()*+,-.:;/<=>?@^_`{|}~)","missing_illegal":"Nie może zawierać niedozwolonych znaków"},"html":{"name":"Invalid characters detected"},"fields":{"firstuserrole":"pierwsza rola użytkownika","seconduserrole":"druga rola użytkownika","name":"nazwa","unittype":"typ urządzenia","logintype":"typ logowania","city":"miasto","country":"kraj","location":"lokalizacja","legalform":"forma prawna","currency":"waluta","machinename":"nazwa urządzenia","ownerorganization":"organizacja właściciela","pincodedropsafe":"kod PIN wrzutni","pincodedropsafeconfirm":"Potwierdź kod PIN dropfsafe","pincodedrawer":"kod PIN szuflady","pincodedrawerconfirm":"potwierdż kod PIN szuflady","firstname":"imię","lastname":"nazwisko","organizations":"organizacje","organization":"organizacja","userroles":"role użytkowników","email":"e-mail","password":"hasło","pin":"pin","mixname":"mixe name","totalamount":"łączna kwota","maximumAmount":"maksymalna ilość","units":"urządzenia","mixes":"miksy","overrideworkflow":"override workflow","apiKeySettings":"API key","mfaEnabled":"MFA enabled","mfaSecret":"MFA Secret","username":"Username","placeholder":"component","placeholderAction":"component action","translationNl":"dutch translation","unittypefamily":"unit type family","timeZone":"timezone","serialnumber":"serial number","transactionCashOutLimit":"transaction cash out limit","dailyCashOutLimit":"daily cash out limit"},"noworkflow":"Brak dostępnego procesu dla wybranego rodzaju jednostki (Proszę utworzyć nowy proces na stronie procesów CIT)","positiveOnly":"Dozwolone są tylko liczby dodatnie","required-because":"{field} jest polem wymaganym, ponieważ zostało wybrane {field1}","maxPavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Max pavement value\"","pavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Pavement value\"","wrongDates":"Start datetime must be before end datetime","alphaCharsOnly":"Only alphabetical characters allowed","numbersOnly":"Only numerical characters (numbers) allowed","safeId":"Must consist of 1 alphabetical character followed by 14 digits. Example: A01234567890123","unable_to_process_request":"Unable to process your request at this time. Contact your administrator or try again later."},"loading":"Ładowanie...","select":"-- Wybierz z listy --","messages":{"check_email_for_reset_link":"Please check your email for the reset link."}},"errors":{"title":"Wystąpił błąd","unknown_error":"Wystąpił nieznany błąd podczas próby załadowania żądanych danych.<br/>Spróbuj ponownie później.","could_not_load":"Nie udało się wczytać żądanych danych.<br/>{response}","unauthorized":"Nieautoryzowany dostęp","unauthorized_expired":"Zostałeś wylogowany z powodu braku aktywności przez dłuższy czas lub ponieważ zalogowałeś się gdzie indziej","network_down":"Wystąpił błąd sieci. Sprawdź swoją sieć","back_button":"Powrót do poprzedniej strony","illegal_argument_uuid":"Znaleziono nieprawidłowy identyfikator","duplicate_entry":"Ten przedmiot już istnieje","emptycolumnidentifier":"Identyfikator kolumny jest pusty","no_information":"Brak informacji","mfaResetError":"Error trying to reset QR/Secret for user"},"login":{"title":"Zaloguj się","mfaTitle":"Verification","continue":"Continue","forgotPassword":{"title":"Przypomnij hasło!","success":"Hasło zostało zresetowne!"},"mfaFlow":{"mfa_required":"MFA required","mfa_required_description":"Your organization requires you to perform MFA authentication.","mfaHelp":"Help with MFA","errorGettingSecret":"Error obtaining your secret and QR","errorGettingMfaSettings":"Error obtaining MFA settings","mfaHelpTitle":"How restore MFA pairing in case of lost Phone/Authenticator","mfaHelpInstructions":"Contact your organization and provide them:<br/><br/> Full name <br/> Phone contact <br/> <br/> They will validate the information with you, and after that enable <strong>QR/secret</strong> pairing again.You shall receive an email once is done and will be able to see QR/secre from login screen again.","mfaHelpInstructionsOtherMfa":"There are more MFA methods available connect with them. <br/> If your organization enabled self QR/Secret recovery, click on your name at top right to see the <strong>User menu</strong> and click on Reset QR/Secret, so next login you will see the QR for new pairing.","understood":"Understood","setupMfaTitle":"Setup MFA","setupMfaDescription":"Please select one MFA type and click con continue.","setupMfaSelectType":"Select type of MFA","mfaPairingTitle":"Phone app setup (one time)","mfaPairingQrImage":"QR image:","mfaPairingSecret":"MFA secret: ","mfaPairingInstructionsTitle":"Instructions for Phone app MFA setup","mfaPairingInstructionsLine1":"Download any authenticator app such as google, microsoft authenticator.","mfaPairingInstructionsLine2":"Open it and click on Add and then select QR or Key.","mfaPairingInstructionsLine3":"With QR please scan the image above and for manual input copy the MFA secret","mfaPhoneInstructionsTitle":"Instructions for Phone app MFA","mfaPhoneInstructionsLine1":"Open your Authenticator device or Smartphone and check for the code provided there.","mfaPhoneInstructionsLine2":"To pair again check MFA troubleshoot.","mfaPhoneInstructionsLine3":"If you can't use this method anymore try with other MFA method such as Email.","mfaEmailInstructionsTitle":"Instructions for Email MFA","mfaEmailInstructionsLine1":"You had received a temporal access token in your email.","mfaEmailInstructionsLine2":"The token will be valid for some minutes.","mfaValidationTitle":"Code validation","mfaValidationDescription":"Enter the code provided by your selected MFA method"},"form":{"username":"Nazwa użytkownika","password":"Hasło","email":"E-mail","mfaCode":"Mfa Code"},"buttons":{"login":"Logowanie","validate":"Verify","forgotPassword":"Przypomnij hasło","reset":"Resetuj hasło"}},"logout":{"title":"Logout","buttons":{"logout":"Wyloguj","profile":"Profil","changepassword":"Zmień hasło","changepin":"Zmień PIN","mfaResetQrSecret":"Reset MFA QR/Secret"}}},"management":{"unit":{"titles":{"overview":"Urządzenia","create":"Dodaj urzadzenie","update":"Aktualizuj urzadzenie","read":"Szczegóły urzadzenia","inventory":"Zapas","readsettings":"Ustawienia urządzeń","preview":"Unit preview"},"breadcrumb":{"title":"Przegląd"},"columns":{"no":"#","amount":"Ilość","buildVersion":"Wersja","closeTime":"Czas","compartment":"Przedział","counter":"Numer","currency":"Waluta","currentValue":"Aktualna wartość","date":"Data","dateTimeStopped":"Data i godzina zatrzymana","description":"Opis","message":"Wiadomość","direction":"Kierunek","insurableValue":"Wartość ubezpieczona","level":"Poziom","location":"Lokalizacja","machineName":"Nazwa urządzenia","machineType":"Typ urządzenia","name":"Nazwa","placeholder":"Składnik","placeholders":"Składniki","reason":"Powód","remoteSupportId":"ID zdalnego wsparcia","sales":"Sprzedaż","serialNo":"Numer seryjny","source":"Źródło","status":"Status","teamviewerId":"ID Teamviewer","total":"Całkowita wartość","transactionNumber":"Numer","type":"Typ","unitIpAddress":"Adres IP","unitMacAddress":"MAC address","unitStatus":"Stan urzadzenia","userAccountName":"Użytkownik","userLoginName":"Użytkownik","value":"Wartość","valueIn":"Wewnątrz ","valueOut":"Na zewnątrz","valueProcessed":"Wartość","vpnIpAddress":"Adres IP VPN"},"form":{"machineName":"Nazwa sejfu","location":"Lokalizacja","organizations":"Organizacje","ownerOrganization":"Organizacja właściciela","supportMultipleClient":"Obsługa wielu klientów","clientOrganizations":"Organizacja klienta","inheritedCIT":"Dziedziczenie CIT","inheritedMaintenance":"Dziedziczenie utrzymania","overrideCIT":"Nadpisanie CIT","overrideMaintenance":"Nadpisanie utrzymania","overrideWorkflow":"Nadpisanie workflow","unitTypeFamily":"Rodzina typów urządzeń","unitType":"Typ urządzenia","serialNo":"Numer seryjny","currency":"Waluta","endOfDayTime":"Koniec dnia","hours":"Godziny","minutes":"Minuty","alarmOn":"Alarm włączony","alarmValuePerDay":"Wartość alarmu na dzień","alarmOnMonday":"Poniedziałek","alarmOnTuesday":"Wtorek","alarmOnWednesday":"Środa","alarmOnThursday":"Czwartek","alarmOnFriday":"Piątek","alarmOnSaturday":"Sobota","alarmOnSunday":"Niedziela","maximumAmount":"Maksymalna ilość monet/banknotów w kasecie","insurableValue":"Wartość podlegająca ubezpieczeniu","offlineTimeout":"Limit czasu offline","pincodeDrawer":"Szuflada z kodem PIN","sideSafe":"Posiada wrzutnię","advancedManualDeposit":"Włącz AMD","drawer":"Ma szufladę","pincodeDropsafe":"Kod PIN dropsafe","pincodeDrawerConfirm":"Potwierdź kod PIN szuflady","pincodeDropsafeConfirm":"Potwierdź kod PIN wrzutni","overrideSettings":"Nadpisz ustawienia dziedziczenia","apiKey":"API key","safeId":"Safe ID","maxPavementWarningPercentage":"Alarm on","departments":"Departments","coinDistribution":"Management"},"toolTip":{"machineName":"Nazwa urządzenia","location":"Adres, pod którym znajduje się urządzenie, należy go utworzyć przed utworzeniem urządzenia","organizations":"Organizacja","ownerOrganization":"Organizacja, która zarządza urządzeniem","supportMultipleClient":"Pozwól, aby urzadzenie było używane przez wiele organizacji","clientOrganizations":"Organizacje, które mogą wpłacać depozyty do sejfów","inheritedCIT":"Organizacja CIT, która jest dziedziczona po organizacji właściciela","inheritedMaintenance":"Firma Serwisowa dziedziczona po organizacji właściciela","overrideCIT":"Aby użyć innej firmy CIT niż ta, która została odziedziczona po organizacji właściciela","overrideMaintenance":"Korzystanie z innej firmy Serwisowej niż ta, która została odziedziczona po organizacji właściciela","overrideWorkflow":"Aby skorzystać z innej procedury CIT niż ta, która została odziedziczona po organizacji właściciela","unitTypeFamily":"Rodzina typów urządzeń","unitType":"Jaki to typ urzadzenia. Na tej podstawie określa się kilka szczegółów technicznych, takich jak elementy składowe urzadzenia. Tego pola nie można edytować.","serialNo":"Numer seryjny z systemu Lincsafe, znajduje się na tabliczce na urzadzeniu. Gdy urządzenie łączy się z portalem po raz pierwszy, używa tego kodu do połączenia","currency":"Jakiej waluty może używać urzadzenie","endOfDayTime":"Czas, który jest wykorzystywany w raportowaniu na koniec dnia, może być wykorzystany na przykład przez sklepy zamykające się po dwunastej.","hours":"Godziny","minutes":"Minuty","alarmOn":"Wysyła wiadomość e-mail, gdy urządzenie jest prawie pełne. Zostanie wysłany, gdy osiągnie wpisany procent ubezpieczonej wartości. Odbiorców można zmienić, klikając symbol zegara na podglądowej stronie organizacji","alarmValuePerDay":"Wysyła wiadomość e-mail, gdy urządzenie jest prawie pełne. Zostanie wysłany, gdy osiągnie wprowadzoną wartość procentową na dany dzień. Odbiorców można zmienić, klikając symbol zegara obok organizacji na stronie podglądu organizacji","alarmOnMonday":"Poniedziałek","alarmOnTuesday":"Wtorek","alarmOnWednesday":"Środa","alarmOnThursday":"Czwartek","alarmOnFriday":"Piatek","alarmOnSaturday":"Sobota","alarmOnSunday":"Niedziela","maximumAmount":"Maksymalna ilość banknotów/monet, która może fizycznie zmieścić się w przegrodzie.","insurableValue":"Maksymalna wartość pieniędzy w sejfie objęta ubezpieczeniem. Służy do określenia, czy urzadzenia jest pełne i powinno zostać opróżnione.","offlineTimeout":"Czas, przez jaki portal czeka odpowiedź od urządzenia przed oznaczeniem go jako offline.","pincodeDrawer":"Kod PIN, który należy wprowadzić w urządzeniu, aby otworzyć szufladę","sideSafe":"Urzadzenie posiada sejf wrzutowy, w którym można deponować np. bony","advancedManualDeposit":"Włącz zaawansowaną wpłatę ręczną: wrzutnia może być używana do oficjalnych wpłat pieniężnych, które może odebrać firma CIT","drawer":"Urzadzenie posiada szufladę, która może służyć do usuwania zacięć","pincodeDropsafe":"Kod PIN, który należy wprowadzić do sejfu, aby otworzyć wrzutnię","pincodeDrawerConfirm":"Potwierdź kod PIN szuflady","pincodeDropsafeConfirm":"Potwierdź kod PIN wrzutni","overrideSettings":"Zmień ustawienia tego urządzenia, aby były inne niż ustawienia domyślne dla tej organizacji","maxPavementWarningPercentage":"A warning will pop up on the machine screen, telling the managers/CIT that the bag will be full soon. The user will be informed when it has reached the entered percentage of the max pavement value.","safeId":"Optional, custom, unique, 15 character identifier for this unit","overrideBankAccount":"Do not inherit primary bank account from Location. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Location. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Location. Instead, define a new one specific to this unit","coinDistribution":"Twin coin system distribution setting management in percentage"},"softwaresettings":{"1":"Darmowa płatność","2":"Malejąco","listUserByOrganization":"Lista użytkowników według organizacji","listUserByUsername":"Lista użytkowników według nazwy","xmlExportName":"Eksport XML","useReferenceNumber":"Nr strony (nie używaj tego ustawienia, tylko dla starych wersji)","referenceNumberLength":"Długość numeru referencyjnego","unitBarcodeTypeOnFirstCitPage":"Display Barcode of Unit Name (CIT Screen)","currencyCode":"Waluta","hopper1Value":"Wartośc pojemnika 1","hopper2Value":"Wartośc pojemnika 2","numberOfCoins":"Liczba monet","beepOnBillRejected":"Sygnał dźwiękowy odrzuconego banknotu","transactionPerBill":"Transakcja na rachunek","loginRequiredTransaction":"Transakcja wymaga logowania","buzzerTimeout":"Limit czasu buzzera","enableOTC":"Włącz OTC","billMaxAmount":"Maksymalna ilość banknotów","coinMaxAmount":"Maksymalna ilość monet","heartbeatRate":"Szybkość odpowiedzi","downloadRate":"Szybkość pobierania","safeStatusRate":"Safe status rate","inventorySettings":"Ustawienia zapasów","payableValue":"Wartość do zapłaty","floatValue":"Float kasowy wartość","floatSettings":"Ustawienie Floatu kasowego","payOutMethod":"Metoda wypłaty","round":"Zaokrąglona wartość","payOutLimit":"Limit wypłat","language":"Język","bins":"Pojemniki bankowe","ecrId":"Identyfikator pinu terminala","ecrUrl":"URL Payplaza","charities":"Organizacje charytatywne","g4sApiUrl":"Adres URL autoryzacji banków","authApiKey":"Klucz API autoryzacji","employeeSelection":"Wybór pracowników","supportedLanguages":"Obsługiwane języki","showDeviceTotal":"Pokaż sumę urządzenia","showExtraButtonOnUserSelectScreen":"Show extra user select button","pavementLimit":"Pvement Limit","communicationRate":"Szybkość komunikacji","depositTimeout":"Limit bezczynności wpłaty (w sekundach)","normalDepositReceipts":"Liczba potwierdzeń wpłaty","manualDepositReceipts":"Ręczna liczba potwierdzeń wpłaty","showDenominationDetailsOnDepositPrint":"Pokaż nominał na druku wpłaty","showUserTotals":"Show user totals function","showDailyReports":"Show daily reports function","manualEndOfDay":"Manual end of day","textLanguage":"Text language selection","dateFormat":"Date format","MMddyyyy":"United States (12/31/2000)","dd-MM-yyyy":"International (31-12-2000)","MMMddyyyy":"US Global (Dec 31 2000)","ddMMMyyyy":"Alternate International (31 Dec 2000)","yyyy-MM-dd":"Year-Month-Day (2000-12-31)","screenSaver":"Wygaszacz ekranu","preTransactionTask":"Pokaż numer referencyjny","noTask":"Nie","refNr":"Pokaż stronę z numerem referencyjnym","low":"Niski","medium":"Średni","high":"Wysoki","high_low_medium":"Dedykowany 1","Low":"Niski","Medium":"Średni","High":"Wysoki","namelist":"Lista nazwisk","empnr":"Wpisz numer pracownika","hasPrinterAttached":"Pokaż powiadomienia drukarki","en":"Angielski","nl":"Niderlandzki","fr":"Francuski","hu":"Węgierski","sk":"Słowacki","pl":"Polskie","EUR":"EUR","TR":"TR","USD":"USD","noExport":"brak eksportu","MLSA":"eksport OCS","puloonCassette1":"Kaseta Puloon 1","puloonCassette2":"Kaseta Puloon 2","puloonCassette3":"Kaseta Puloon 3","puloonCassette4":"Kaseta Puloon 4","EUR-5":"5 €","EUR-10":"10 €","EUR-20":"20 €","EUR-50":"50 €","EUR-100":"100 €","EUR-200":"200 €","EUR-500":"500 €","puloonCassette1FixedAmount":"Kaseta Puloon 1 Stała Kwota","puloonCassette2FixedAmount":"Kaseta Puloon 2 Stała Kwota","puloonCassette3FixedAmount":"Kaseta Puloon 3 Stała Kwota","puloonCassette4FixedAmount":"Kaseta Puloon 4 Stała Kwota","inventoryCheckOnPayment":"Sprawdź stan zaopatrzenia przy płatności","tariffs":"Taryfy","acceptablesSetting":"Włączone nominały","minimumOrderRolls":"Minimalna kwota zamówienia w gilzach","inventorypanel":{"denomination":"Nominał","material":"Materiał","recycled":"Recykling","min":"Minimalny","low":"Niski","optimum":"Optymalny","max":"Maksymalny","value":"Wartość","COIN":"Moneta","BILL":"Banknot","ROLL":"Gilza","maxDispensable":"Max dispensable","numberOfRecyclers":"Recycler count","messages":{"recyclerStatusInfo":"{totalRecyclers} of {maxNumberOfRecyclers} recyclers are used","recyclerStatusError":"Error: Exceed the max recycler count ({maxNumberOfRecyclers}); claimed: {totalRecyclers}","excideMaximumDrawer":"Max drawer dispensable limit is {limit}","excideMaximumCup":"Max cup dispensable limit is {limit}"},"high":"High"},"tariffspanel":{"transaction_fee":"Opłata za transakcję","value_fee":"Opłata za gilzę"},"minimumOrderPanel":{"min":"Min (1)","max":"Max (200)"},"minimumOrderCoinRollsSettings":"Minimalne i maksymalne kwoty zamówień w rolkach na monety","om61InventorySettings":"OM61 inventory settings","inventoryOptimumReset":"Inventory float down time","escrowEmptyAmount":"Escrow empty amount","maxBagValue":"Max pavement value","ledLightColor":"LED light color","yellow":"Yellow","red":"Red","green":"Green","blue":"Blue","magenta":"Magenta","cyan":"Cyan","white":"White","posMode":"POS mode","none":"None","barcode_itf":"Barcode ITF","qrcode":"QR Code","timeSelector":{"enabled":"Enabled"},"apiKeySettings":"API key","useDefaultValue":"Use default value","allowManagerEmptyAllRecyclers":"Allow manager to empty all recylers","managerUnlockDelay":"Delay time to unlock safe doors","managerUnlockStartTime":"Unlock start time","managerUnlockEndTime":"Unlock end time","localPinChange":"Change user pin on unit","customXmlHeader":"Custom XML Header","coinDistribution":"Twin coin system distribution setting","puloonRejectBinMaxAmount":"Maximum amount of notes that puloon reject bin can handle","puloonRejectBinWarningPercentage":"Puloon reject bin full capacity warning (percentage)","autoFloatDownWhenSystemIsIdle":"Auto float down","tillRestrictions":"Restricted tills","maxPavementWarningPercentage":"Max pavement value alarm","g4sCertificate":"G4S Certificate","payplazaCertificate":"Payplaza Certificate","storageVault":"Storage vault","userManagement":"User management"},"actions":{"create":"Dodaj urządzenie","read":"Zobacz urządzenie","update":"Zaktualizuj urządzenie","delete":"Usuń urządzenie","filter":"Filtruj urządzenia według statusu","readsettings":"Odczytaj ustawienia urządzenia","preview":"Unit preview"},"messages":{"added":"Urządzenie {name} jest dodane","updated":"Urządzenie {name} jest zaktualizowane"},"read":{"tabs":{"detail":"Detale","specifications":"Specyfikacja techniczna","status":"Status","users":"Użytkownicy","sales":"Sprzedaż","internal":"Wewnętrzny","mixes":"Mixes","citLegacy":"Legacy","citDynamic":"Dynamic","citStatic":"Static"},"summary":{"maximumAmount":"Maks. monety/banknoty na kasetę","machineName":"Nazwa urządzenia","insurableValue":"Wartość podlegająca ubezpieczeniu","currentValue":"Aktualna wartość","currentDepositValue":"Aktualnie zdeponowana wartość","unitModelName":"Typ urządzenia","unitTypeFamily":"Rodzina typów urządzeń","location":"Lokalizacja","placeholders":"Komponenty","lastTransactionDate":"Data ostatniej transakcji","currency":"Waluta","currentStatus":"Aktualny stan","networkStatus":"Status sieci","lastClearBox":"Ostatnie wyczyszczone pudełko","yesterdayTurnover":"Wczorajszy obrót","lastClearBoxDate":"Data ostatniego wyczyszczenia pola","fillGrade":"Stopień wypełnienia","numberOfTransactions":"Liczba transakcji","name":"Nazwa","addressLine1":"Adres","city":"Miejscowość","unitFillStatus":"Osiągnięto próg","ALMOST_FULL":"PRAWIE PEŁNY","FULL":"PEŁNY","NORMAL":"W NORMIE","null":"zero"},"titles":{"unitStatus":"Stan urządzenia","unitDetail":"Szczegóły urządzenia","unitDetails":"Szczegóły urządzenia","location":"Szczegóły lokalizacji","lastTransactions":"Ostatnie transakcje","campaignsUnit":"Urządzenie","lastClearBoxes":"Ostatnie opróżnianie kasety","component":"Specyfikacja techniczna","eventsByUnit":" Wydarzenia","lastEvents":"Ostatnie wydarzenia","hardwareStatus":"Hardware: ","networkStatus":"Śieć: ","notifications":"Powiadomienia","departments":"Department details"},"status":{"ALMOST_EMPTY":"Musi być wypełniony","ALMOST_FULL":"Musi zostać opróżniony","DEBUG":"Debug","EMPTY":"Musi być wypełniony","ERROR":"Błąd","FATAL":"Bład Krytyczny","FULL":"Musi zostać opróżniony","INFO":"Informacje","INVENTORY_NOT_SUFFICIENT":"Musi być wypełniony","INVENTORY_OVER_MAXIMUM":"Musi zostać opróżniony","INVENTORY_UNDER_MIN":"Musi być wypełniony","INVENTORY_UNDER_LOW":"Musi być wypełniony","JAMMED":"Usuń zacięcie","NOT_CONNECTED":"Sprawdź połączenie z urządzeniem","NOT_SECURE":"Odblokuj drzwi, zamknij i ponownie zarygluj","OFFLINE":"Urzączenie jest offline","OK":"OK","OPEN":"Zamknąć drzwi","OVERRIDDEN":"Użyj menu, aby odblokować, a następnie zablokować drzwi","RECYCLER_ALMOST_EMPTY":"Napełnij recykler","RECYCLER_ALMOST_FULL":"Usuń trochę materiału z recyklera","RECYCLER_EMPTY":"Napełnij recykler","RECYCLER_FULL":"Usuń trochę materiału z recyklera","STACKER_FULL":"Usuń banknoty z kasety","STORAGE_ALMOST_FULL":"Wyczyść schowek","STORAGE_DETACHED":"Dołącz schowek","STORAGE_FULL":"Opróżnij schowek","TRACE":"Namierzaj","UNLOCKED":"Zamknij drzwi","WARN":"Uwaga","WARNING":"Uwaga"},"techSpec":{"ACCEPTING":"Akceptuję","ALMOST_EMPTY":"Prawie pusty","ALMOST_FULL":"Prawie pełny","BAG_OPEN":"Bag Open","CALIBRATING":"Kalibracja","CASSETTE_ERROR":"Cassette Error","CASSETTE_ATTACHED":"Dołączona kaseta","CASSETTE_DETACHED":"Kaseta odłączona","CARTRIDGE_DETACHED":"Cartridge odłączony","CLOSED":"Zamknięte","CONNECTED":"Połączony","DOOR_CLOSED":"Drzwi zamknięte","DOOR_OPEN":"Drzwi otwarte","DOOR_LOCKED":"Zamknięte drzwi","DOOR_UNLOCKED":"Drzwi odblokowane","DOWNLOADING":"Downloading","EMPTY":"Pusty","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Wejście nie jest puste","EXTENSION_STALL":"Extension stall","FAILED":"Nieudane","FEED_FAILURE":"Deponowanie nieudane","FULL":"Pełny","INVENTORY_NOT_SUFFICIENT":"Zapasy niewystarczające","INVENTORY_OVER_MAXIMUM":"Zapasy powyżej maksimum","INVENTORY_UNDER_MIN":"Zapasy poniżej minimum","INVENTORY_UNDER_LOW":"Zapasy poniżej niskich","JAM_CLEARED":"Zacięcie usunięte","JAMMED":"Zacięty","LOCKED":"Zablokowany","LOCKS_SECURE":"Locks Secure","NOT_ACCEPTING":"Nie akceptuję","NOT_CONNECTED":"Nie połączony","NOT_FOUND":"Nie znaleziono konfiguracji","NOT_OVERRIDDEN":"Nie zastąpiono","NOT_OPERATIONAL":"Nie działa","NOT_SECURE":"Nie zabezpieczone","OFFLINE":"OFFLINE","ONLINE":"ONLINE","NETWORK_DISCONNECTED":"Network disconnected","NETWORK_RESTORED":"Network restored","OK":"OK","OPEN":"Otwarty","OVERRIDDEN":"Zastąpiony","PAUSE":"Pauza","POWER_UP":"Power Up","RECYCLER_ALMOST_EMPTY":"RECYCLER Prawie pusty","RECYCLER_ALMOST_FULL":"RECYCLER Prawie pełny","RECYCLER_EMPTY":"RECYKLER Pusty","RECYCLER_FULL":"RECYKLER Pełna","REJECT_NOT_EMPTY":"Odrzucone wartości opróżnij","OUTPUT_NOT_EMPTY":"Output is not empty","SAFE_DOOR_OPEN":"Safe door open","SECURE":"Bezpieczne","SIDE_SAFE_ONE_LOCKED":"Sejf boczny 1 zablokowany","SIDE_SAFE_ONE_UNLOCKED":"Sejf boczny 1 odblokowany","STACKER_FULL":"Kaseta pełna","STALLED":"Zatrzymany","STORAGE_ALMOST_FULL":"Schowek prawie pełny","STORAGE_ALMOST_FULL_CLEARED":"Storage Almost Full Cleared","STORAGE_ATTACHED":"Schowek dołączony","STORAGE_DETACHED":"Schowek odłączony","STORAGE_FULL":"Schowek pełny","STORAGE_ALMOST_EMPTY_005":"Pojemnik na gilzy jest prawie pusty, pozostało 5 gr","STORAGE_ALMOST_EMPTY_010":"Pojemnik na gilzy jest prawie pusty, pozostało 10 gr","STORAGE_ALMOST_EMPTY_020":"Pojemnik na gilzy jest prawie pusty, pozostało 20 gr","STORAGE_ALMOST_EMPTY_050":"Pojemnik na gilzy jest prawie pusty, pozostało 50 gr","STORAGE_ALMOST_EMPTY_100":"Pojemnik na gilzy jest prawie pusty, pozostało 1 zł","STORAGE_ALMOST_EMPTY_200":"Pojemnik na gilzy jest prawie pusty, pozostało 2 zł","TOP_DOOR_CLOSED":"Górne drzwi zamknięte","TOP_DOOR_OPEN":"Otwarte drzwi górne","UNLOCKED":"Odblokowany"}},"inventory":{"unitInventory":"Jednostka zapasów","noTransactions":"Brak transakcji","noTransactionsDesc":"Nie znaleziono transakcji, spróbuj ponownie później!","items":"Przedmioty","total":"Total ","cassette":"Kaseta"},"campaign":{"read":"Ostatnie opróżnianie","columns":{"no":"#","group":"Grupa","placeholder":"Składnik","dateTimeStopped":"Data i godzina zatrzymana","userAccountName":"Użytkownik","insertedValue":"Inserted","valueProcessed":"Collected","totalValueProcessed":"Całkowita przetworzona wartość"}}},"softwaresettings":{"titles":{"overview":"Ustawienia oprogramowania","create":"Dodaj ustawienia oprogramowania","update":"Zaktualizuj ustawienia oprogramowania","readsettings":"Przeczytaj ustawienia oprogramowania"},"breadcrumb":{"title":"Waluta"},"actions":{"create":"Dodaj ustawienia oprogramowania","read":"Przeczytaj ustawienia oprogramowania","update":"Zaktualizuj ustawienia oprogramowania","delete":"Usuń ustawienia oprogramowania","readsettings":"Przeczytaj ustawienia oprogramowania"},"columns":{"ownerOrganization":"Organizacja właścicielska","unitType":"Typ urządzenia"},"messages":{"added":"Dodano nowe ustawienia","updated":"Ustawienia zostały zaktualizowane"},"form":{"ownerOrganization":"Własność organizacji","unitType":"Typ urządzenia","overrideSettings":"Zastąp ustawienia domyślne","selectOverrideSettings":"Wybierz ustawienia do zastąpienia i użycia","checkAll":"Zaznacz wszystkie","cassettesAssignment":"Cassettes Assignment"},"toolTip":{"hasPrinterAttached":"Używaj tylko gdy podłączona drukarka","listUserByOrganization":"Lista pracowników według organizacji, gdy urządzenie obsługuje wielu klientów","listUserByUsername":"Lista pracowników według nazwy użytkownika, w przeciwnym razie lista według numeru pracownika","xmlExportName":"Używane, gdy potrzebny jest eksport plików xml innej organizacji","useReferenceNumber":"Ustawienie depozytu, tylko dla starych wersji","referenceNumberLength":"Długość numeru referencyjnego","currencyCode":"Waluta dla pojemnika","hopper1Value":"Wartość pojemnika1","hopper2Value":"Wartość pojemnika2","numberOfCoins":"Ilość monet w pojemniku","beepOnBillRejected":"Sygnał dźwiękowy odrzuconego banknotu","transactionPerBill":"Akceptuje tylko pojedynczy banknot na transakcję","loginRequiredTransaction":"Aby rozpocząć nową wpłatę, wymagane jest zalogowanie","buzzerTimeout":"Czas trwania sygnału dźwiękowego brzęczyka","enableOTC":"Użyj do włączania trybu OTC dla zamka","heartbeatRate":"Częstotliwość komunikacji urządzenia z portalem","downloadRate":"Częstotliwość pobierania plików konfiguracyjnych z portalu do urządzenia","safeStatusRate":"Częstotliwość wysyłania statusu bezpieczeństwa z urządzenia do portalu","inventorySettings":"Ustawienia zapasów dla Lincstation, składają się z akceptowalnych materiałów, materiałów pochodzących z recyklingu, minimalnych, startoych i maksymalnych poziomów nominałów","payableValue":"Minimalna wartość do sprawdzenia zapasów, kiedy Lincstation operacyjnie umożliwia płatności","floatValue":"Dzienna wartość początkowa dla Lincstation","coinMaxAmount":"Maksymalna ilość monet w Lincstation","billMaxAmount":"Maksymalna ilość banknotów w Lincstation","payOutMethod":"Tryb wypłaty za system Smart Coin w Lincstation","round":"Służy do zaokrąglania wartości wprowadzonej dla płatności w Lincstation","payOutLimit":"Limit wypłaty w Lincstation","language":"Aktywny wybrany język w urządzeniu","bins":"Lista obsługiwanych pojemników według banku","ecrId":"Identyfikator terminala podłączonego do urządzenia","ecrUrl":"Punkt końcowy używany do dokonywania płatności i innych transakcji kartowych","g4sApiUrl":"Punkt końcowy używany do autoryzacji kart","employeeSelection":"Wyszukiwanie pracowników poprzez wpisanie numeru pracownika lub podgląd pracowników wyświetlanych na liście","supportedLanguages":"Obsługiwane języki","showDeviceTotal":"Służy do wyświetlania całkowitej wartości urządzenia i szczegółów nominału w menu menedżera","showExtraButtonOnUserSelectScreen":"When enabled, this causes a 5th user select button to appear on the user select screen","pavementLimit":"Limit dla kasety","communicationRate":"Częstotliwość komunikacji między urządzeniem a portalem. Dla opcji \"Wysoki\", \"Średni\" i \"Niski\" obie częstotliwości są ustawione na tym poziomie. Dla opcji \"Dedykowany 1\" częstotliwość pobierania jest niska, a częstotliwość komunikacji wysoka","depositTimeout":"Czas oczekiwania na ekran wpłaty","normalDepositReceipts":"Numer paragonu do wydrukowania po normalnej wpłacie","manualDepositReceipts":"Numer paragonu do wydrukowania po ręcznej wpłacie","showDenominationDetailsOnDepositPrint":"Pokaż nominał na druku depozytowym","showUserTotals":"Show user totals function in settings screen","showDailyReports":"Show daily reports function in management screen","manualEndOfDay":"End of day will be manually performed by a manager (This setting disables the automatic end of day feature)","textLanguage":"Use text language selection screen (instead of flags)","dateFormat":"The date format displayed on receipts and screen","preTransactionTask":"Służy do pokazywania szczegółów nominału dla każdej transakcji na paragonie","screenSaver":"Pokaż wygaszacz ekranu, gdy urzadzenie jest bezczynna","puloonCassette1":"Nominał dla Kasety 1","puloonCassette2":"Nominał dla Kasety 2","puloonCassette3":"Nominał dla Kasety 3","puloonCassette4":"Nominał dla Kasety 4","puloonCassette1FixedAmount":"Stała ilość banknotów w Kasecie 1","puloonCassette2FixedAmount":"Stała ilość banknotów w Kasecie 2","puloonCassette3FixedAmount":"Stała ilość banknotów w Kasecie 3","puloonCassette4FixedAmount":"Stała ilość banknotów w Kasecie 4","inventoryCheckOnPayment":"Sprawdza, czy włożona kwota może zostać wydana podczas płatności","charities":"Dane organizacji charytatywnych","escrowEmptyAmount":"Minimum amount for escrow to be emptied","maxBagValue":"Maximum value for the bag","inventoryOptimumReset":"The time when the inventory of the machine will reset back to optimum values based on the inventory settings","apiKeySettings":"API key for the connector","ledLightColor":"LED light color","posMode":"Point of sale mode limits machine functionality by disabling some buttons","allowManagerEmptyAllRecyclers":"Enables the manager to dispense all available notes and coins locally on the unit","managerUnlockDelay":"Manager delay for opening tills and coin drawer","localPinChange":"Able to change user pin code on unit","customXmlHeader":"Set custom XML data needed for integration","puloonRejectBinMaxAmount":"Puloon reject bin maximum notes capacity","puloonRejectBinWarningPercentage":"Warning level set in percentage for Puloon reject bin. This functionality is disabled if 0 is set","unitBarcodeTypeOnFirstCitPage":"Enables unit name to be shown as a barcode on device display at the start of CIT flow","autoFloatDownWhenSystemIsIdle":"Auto float down if no active transaction and recycler is full","g4sCertificate":"Certificate for software management","payplazaCertificate":"Certificate for software management","managerUnlockStartTime":"Unlock start time","managerUnlockEndTime":"Unlock end time","tillRestrictions":"When selected, tills are only allowed to be dispensed once. They will become available again after the till is deposited back into the machine. When deselected, tills can be used multiple times.","storageVault":"Enable additional storage vault","userManagement":"Enable user management","authApiKey":"Authorization API Key"},"billsDenominationTable":{"yes":"YES","no":"NO","columns":{"cassettes":"Cassettes","recycler":"Recycler","denomination":"Denomination","currency":"Currency","optimum":"Optimum","max":"Max"}}},"user":{"titles":{"overview":"Użytkownicy","create":"Dodaj użytkownika","update":"Zaktualizuj użytkownika","changepassword":"Zmień hasło","changepincodes":"Zmień kod PIN","updateprofile":"Zaktualizuj profil","forgotpassword":"Zapomniane hasło","resetpassword":"Reset hasła","readsettings":"Ustawienia użytkownika"},"breadcrumb":{"title":"Przegląd"},"columns":{"name":"Nazwa","organization":"Organizacja","email":"E-mail","roles":"Role użytkowników"},"form":{"firstName":"Imię","lastName":"Nazwisko","rfid":"RFID / Dallas Key","employeeNumber":"Numer pracownika","organization":"Organizacja","roles":"Role użytkowników","email":"E-mail","externalUsername":"External Username","externalPassword":"External Password","password":"Hasło","passwordConfirm":"Potwierdź hasło","sendTemporaryPassword":"Wyślij hasło tymczasowe","pin":"PIN","pinConfirm":"Potwierdź PIN","openDropsafeWithPin":"Otwórz wrzutnię PINem","openDrawerWithPin":"Otwórz wrzutnię PINem","units":"Urządzenia","oldPassword":"Stare hasło","newPassword":"Nowe hasło","confirmPassword":"Potwierdź nowe hasło","oldPin":"Stary PIN","newPin":"Nowy PIN","tills":"Kasy","mixes":"Mixes","dailyDispenseLimit":"Dzienny limit dyspensera","dailyPayoutLimit":"Daily payout limit","mfaEnabled":"Enable multi-factor authentication","generate":"Generate","copied":"Copied","secretkey":"Secret key","useExternalRoles":"Use external roles","unitRoles":"Unit role","storageVaultAccess":"Storage vault access","departments":"Departments"},"actions":{"create":"Dodaj użytkownika","read":"Zobacz użytkownika","update":"Zaktualizuj użytkownika","delete":"Usuń użytkownika","unlock":"Odblokuj użytkownika","readsettings":"Przeczytaj ustawienia użytkownika"},"messages":{"added":"Użytkownik {name} został dodany","updated":"Użytkownik {name} został zaktualizowany","changedpassword":"Hasło zaktualizowane","changedpin":"PIN zaktualizowany","updateprofile":"Profil zaktualizowany","qrSecretReset":"The QR/secret has been reset correctly"},"toolTip":{"mfaEnabled":"Enable multi-factor authentication","copySecret":"Copy secret text","useExternalRoles":"Use external roles"}},"location":{"titles":{"overview":"Lokalizacje","create":"Dodaj lokalizację","update":"Zaktualizuj lokalizację","readsettings":"Ustawienia lokalizacji"},"breadcrumb":{"title":"Przegląd"},"columns":{"city":"Miejscowość","name":"Nazwa","addressLine":"Adres"},"form":{"name":"Nazwa","city":"Miejscowość","addressLine1":"Adres","addressLine2":"Adres","postalCode":"Kod pocztowy","country":"Kraj","phoneNumber":"Numer telefonu","email":"E-mail","organization":"Organization","state":"State/Province","timeZone":"Timezone","departments":"Departments"},"actions":{"create":"Dodaj lokalizację","read":"Zobacz lokalizację","update":"Zaktualizuj lokalizację","delete":"Usuń lokalizację","readsettings":"Zobacz ustawienia lokalizacji"},"messages":{"added":"Lokalizacja {name} została dodana","updated":"Lokalizacja {name} została zaktualizowana"},"toolTip":{"organization":"Organization to which this location belongs to","timeZone":"Machine time will be set up according to the timezone.","overrideBankAccount":"Do not inherit primary bank account from Organization. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Organization. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Organization. Instead, define a new one specific to this unit"}},"organization":{"titles":{"overview":"Organizacja","create":"Dodaj organizację","jobs":"Praca w organizacji","update":"Zaktualizuj organizację","readsettings":"Ustawienia organizacji","mfaTypes":"MFA types"},"breadcrumb":{"title":"Przegląd"},"columns":{"name":"Nazwa","location":"Organizacja","parentOrganization":"Organizacja nadrzędna","organizationType":"Typ organizacji"},"form":{"dayTotalJob":"Dzienny utarg","mailSendingTime":"Czas wysyłania maila","enabled":"Włączony","remainingUsers":"Pozostali użytkownicy","subscribers":"Odbiorcy","affectedUnits":"Objęte urządzenia","name":"Nazwa","ipWhiteList":"biała lista IP","pin":"PIN","organizationType":"Typ organizacji","parentOrganization":"Organizacja nadrzędna","inheritedCIT":"CIT dziedziczony","inheritedMaintenance":"Serwis dziedziczony","overrideCIT":"CIT nadpisany","overrideMaintenance":"Serwis nadpisany","defaultCIT":"Domyślny CIT","defaultMaintenance":"Domyślny Serwis","reportedOrganizations":"Zgłoś organizacje","location":"Lokalizacja","legalForm":"Forma prawna","remark":"Uwaga","forceMfaForUsers":"Force MFA auth for users","enableUserMfaSecretReset":"Allow users to reset their QR/Secret","enableAuthdeviceMfa":"Phone/Authenticator device MFA","enableEmailMfa":"Email MFA","enableSmsMfa":"SMS MFA","workflows":"Procesy","forceEmployeePin":"Pracownicy wymagają PIN","userPincodeSeverity":"User pincode severity","ibutton":{"overview":"iButton keys overview","noData":"There are no iButton keys to show","add":"Add iButton key","uploadCSV":"Upload CSV","name":"iButton Key","removeAll":"Remove all iButton keys","removeAllConfirmationText":"Are you sure that you want to delete all ibuttons?","remove":"Remove","cancel":"Cancel","delete":"Delete","ok":"OK","invalidCSVfile":"Please upload a valid CSV file.","uploadInfo":"Upload is finished.","uploadDescription":"It seems that some keys weren't inserted because they didn't meet the required criteria.","uploadCSVInfo":"Only valid ibutton key names will be uploaded.","invalidButtonName":"Validation failed! iButton key name must be exactly 16 hexadecimal characters and should not be a duplicate.","search":"Type to search ibutton key"}},"actions":{"create":"Dodaj organizację","read":"Zobacz organizację","update":"Aktualizuj organizację","delete":"Usuń organizację","readsettings":"Zobacz ustawienia organizacji"},"messages":{"added":"Organizacja {name} została dodana","updated":"Organizacja {name} została zaktualizowana","selectOneMfaOption":"Select at least one MFA option"},"toolTip":{"dayTotalJob":"Dzienny utarg","mailSendingTime":"Czas wysyłania maila","enabled":"Włączony","remainingUsers":"Pozostali użytkownicy","subscribers":"Odbiorcy","affectedUnits":"Objęte urządzenia","name":"Nazwa organizacji","ipWhiteList":"Adresy IP, które mogą komunikować się z urządzeniam (obecnie nieużywane)","pin":"Kod PIN organizacji (obecnie nieużywany)","organizationType":"Rodzaj organizacji. CIT: dla organizacji, które zbierają pieniądze z urządzeń. Ogólne: jest używane w większości organizacji. Serwis: dla organizacji, które wykonują konserwację urządzeń. Grupa Raportowania: dla organizacji, które muszą widzieć raporty firm na różnych szczeblach organizacyjnych","parentOrganization":"Organizacja Nadrzędna powyżej tej w szczeblu organizacyjnym. Administratorzy organizacji nadrzędnej widzą w portalu bieżącą organizację i jej urządzenia. Obecna organizacja może odziedziczyć firmy Serwisujące i CIT od organizacji nadrzędnej. Jeśli nie zdefiniowano organizacji nadrzędnej, należy utworzyć firmę CIT i Serwisującą dla bieżącej organizacji.","inheritedCIT":"Firma CIT, która jest dziedziczona po organizacji nadrzędnej","inheritedMaintenance":"Firma serwisujaca odziedziczona po organizacji nadrzędnej","overrideCIT":"Wykorzystaj inną firmę CIT niż ta, która została odziedziczona po organizacji nadrzędnej","overrideMaintenance":"Wykorzystaj inną firmę Serwisową niż ta, która została odziedziczona po organizacji nadrzędnej","defaultCIT":"Użyj aby ta firma CIT, była automatycznie wykorzystywana przez urządzenia i organizacje zależne ","defaultMaintenance":"Aby uczynić to firmą serwisową, która będzie automatycznie wykorzystywana przez urządzenia i organizacje zależne","reportedOrganizations":"Organizacja, której członkowie obecnej organizacji mogą przeglądać raporty","location":"Adres tej organizacji (należy go utworzyć przed utworzeniem organizacji)","remark":"Uwagi o organizacji, które są widoczne dla osób edytujących","forceMfaForUsers":"Enable this option to force multifactor authentication for all users when they log in to the portal.","enableAuthdeviceMfa":"Enable authenticator device and phone apps as user MFA option","enableEmailMfa":"Enable Email as user MFA option","enableSmsMfa":"Enable SMS as user MFA option","enableUserMfaSecretReset":"Allow users to reset theirselves their QR/Secret from user menu if more than one MFA mode is enabled","workflows":"Procedury transportu gotówki, które będą stosowane w urządzeniach, dla których ta firma jest firmą CIT","forceEmployeePin":"Aby kod PIN był wymagany dla wszystkich pracowników tej organizacji i organizacji podległej"},"notifications":{"titles":{"notifications":"Notifications","notificationType":"Notification Type"},"types":{"UNIT_OFFLINE":"Unit Offline"},"form":{"enabled":"Enabled","unsubscribed":"Remaining Users","subscribed":"Subscribed"}}},"till":{"titles":{"overview":"Kasy","create":"Dodaj kasę","update":"Zaktualizuj kasę"},"breadcrumb":{"title":"Przegląd"},"columns":{"name":"Nazwa","organization":"Organizacja","mixes":"Mixes"},"form":{"name":"Nazwa","organizations":"Organizacj","units":"Urządzenie","maximumAmount":"Maksymalna kwota","mixes":"Mixes"},"actions":{"create":"Dodaj kasę","read":"Podgląd kasy","update":"Aktualizacja kasy","delete":"Usuń kasę"},"messages":{"added":"Kasa {name} została dodana","updated":"Kasa {name} została zaktualizowna","disconnected":"These units will be disconnected {units} from the till {till}"}},"cit":{"titles":{"overview":"Procesy CIT","create":"Dodaj procesy CIT","update":"Aktualizuj procesy CIT","readsettings":"Ustawienia procesów CIT"},"breadcrumb":{"title":"Nadpisz"},"columns":{"name":"Nazwa","unitType":"Typ urządzenia","advancedSettings":"Ustawienia zaawansowane","stepTabEdit":"Step edit","stepTabNew":"Step create","cancel":"Cancel","create":"Create","update":"Update","steps":"Steps","addNewStep":"New step","version":"Version"},"form":{"name":"Nazwa","unitType":"Typ urządzenia","organization":"Organizacja","loginType":"Typ logowania","firstUserRole":"Rola użytkownika *","secondUserRole":"Rola drugiego użytkownika *","allSteps":"Wszystkie kroki","selectedSteps":"Wybrane kroki","performPrint":"Paragon CIT","scanLength":"Długość kodu kreskowego","prefixBarcode":"Prefiks kodu kreskowego","emptyCoinDevice":"Puste miejsce do przechowywania monet","printOnCassetteDetached":"Paragon na kasecie","placeholder":"Składnik","placeholderAction":"Składnik Działanie","stepCondition":"Condition","stepSkip":"Skip to","loadingPlaceholderText":"Select any unit type first","loadingPlaceholderActionText":"Select a component first","loadingPlaceholderConditionText":"Select a component first","nextStep":"Next step","next":"Next","skipTo":"Step: {number}","options":{"autologin":"Automatyczne logowanie","singlelogin":"Pojedyncze logowanie","multiplelogin":"Wielokrotne logowanie","locklogin":"Logowanie za pomocą PIN"},"translationEn":"Step title","translationNl":"Step title","translationUs":"Step title","translationFr":"Step title","translationPl":"Step title","translationEl":"Step title","translationHu":"Step title","translationSk":"Step title","translationDe":"Step title","translationKey":"Translation key","translationKeyInfo":"Translation key: {translationKey}","confirmDialog":"Confirm dialog","confirmationDialogLabel":"Should show confirmation dialog?","noMatchingCondition":"The selected component doesn't have condition.","noMatchingAction":"The selected component doesn't have actions.","importWorkflow":"Import workflow","sdcGrouping":"Disable SDC grouping"},"toolTip":{"name":"Nazwa procesu. W nazwie wpisz organizację i typ urządzenia, to ułatwi wyszukiwanie.","unitType":"Rodzaj urządzeń, jakie mogą korzystać z tego procesu","organization":"Organizacja, która może edytować ten proces","loginType":"Sposób, w jaki użytkownik musi się zalogować na urządzeniu przed odebraniem pieniędzy. Po wybraniu automatycznego logowania procedura rozpocznie się po otwarciu drzwi","firstUserRole":"Rola użytkownika, który musi zalogować się do urządzenia przed odebraniem pieniędzy","secondUserRole":"Rola drugiego użytkownika, który musi zalogować się do urządzenia przed odebraniem pieniędzy","allSteps":"Strony, które możesz wybrać dla urządzenia podczas procedury CIT, aby odebrać pieniądze z urządzenia. Strony można wybierać, przeciągając je od lewej do prawej. Strony zaczynające się od -Legacy- nie są już używane przez urządzenia z oprogramowaniem w wersji 4 i wyższej.","selectedSteps":"Strony, przez które przejdzie urządzenie podczas procedury CIT, aby odebrać pieniądze z urządzenia","performPrint":"Wydrukuj pokwitowanie po zakończeniu procedury","scanLength":"Długość kodu kreskowego na pojemniku z pieniędzmi","prefixBarcode":"Tekst, od którego zaczyna się kod kreskowy, na przykład BE. Pojawi się na przycisku, gdy kod kreskowy zostanie wprowadzony ręcznie","emptyCoinDevice":"Załóżmy, że pojemnik na monety zostanie opróżniony podczas procedury CIT i odejmij wartość monet od całkowitej wartości w automacie","printOnCassetteDetached":"Po wyjęciu kasety wydrukowany zostanie paragon z zawartością tej kasety","placeholder":"Placeholders wybranego typu jednostki.","placeholderAction":"Działania dla wybranych Składnik.","stepCondition":"Condition","stepSkip":"Skip to next step","options":{"autologin":"Automatyczne logowanie","singlelogin":"Pojedyncze logowanie","multiplelogin":"Wielokrotne logowanie","locklogin":"Logowanie za pomocą PIN"},"translationEn":"Step title will be shown when English language is selected","translationNl":"Step title will be shown when Dutch language is selected","translationUs":"Step title will be shown when English (US) language is selected","translationFr":"Step title will be shown when French language is selected","translationDe":"Step title will be shown when German language is selected","translationPl":"Step title will be shown when Polish language is selected","translationEl":"Step title will be shown when Greek language is selected","translationHu":"Step title will be shown when Hungarian language is selected","translationSk":"Step title will be shown when Slovenian language is selected","translationKey":"Translation key","confirmDialog":"Confirm dialog","importXmlTooltip":"Only accept a single .xml file","sdcGrouping":"If this is checked, system will create separate 'Clear box item' per placeholder, instead of grouping them into one SDC."},"conditions":{"REJECT_BIN_IS_EMPTY":"Reject bin is empty","COIN_OVERFLOW_NOT_FULL":"Coin overflow is not full"},"actions":{"create":"Dodaj proces","read":"Zobacz proces","update":"Aktualizuj proces","delete":"Usuń proces","readsettings":"Zobacz ustawienia procesu","export":"Export workflow"},"messages":{"added":"Proces {name} został dodany","updated":"Proces {name} został zaktualizownay","noPageSelected":"Wybierz dowolny krok","checkStepFormFields":"Verify that all Step fields are correct","stepAdded":"Step added","stepUpdated":"Step updated","noStepSelectedV2":"Please create any step","invalidXmlFile":"Please upload a valid XML file","xmlUploadSuccess":"Workflow successfully imported","xmlUploadFailed":"Unable to upload workflow","cantMoveStepUp":"Can't move this Step up","cantMoveStepDown":"Can't move this Step down"},"workflow":{"Login":"(Legacy) Zaloguj sie","Remove_left_cassette":"(Legacy) Wyjmij lewą kasetę","Insert_left_cassette":"(Legacy) Włóż lewą kasetę","Remove_right_cassette":"(Legacy) Wyjmij prawą kasetę","Insert_right_cassette":"(Legacy) Włóż prawą kasetę","Remove_any_cassette":"(Legacy) Wyjmij dowolną kasetę","Insert_any_cassette":"(Legacy) Włóż dowolną kasetę","Remove_cassette":"(Legacy) Wyjmij kasetę","Insert_cassette":"(Legacy) Włóż kasetę","Scan_left_reader_barcode":"(Legacy) Zeskanuj kod kreskowy lewego czytnika","Scan_right_reader_barcode":"(Legacy) Zeskanuj kod kreskowy prawego czytnika","Scan_new_cassette_barcode":"(Legacy) Scan new cassette barcode","Open_the_door_Linux":"(Legacy) Otwórz drzwi (Linux)","Close_the_door__Linux":"(Legacy) Zamknij drzwi (Linux)","Lock_the_door":"(Legacy) Zablokuj drzwi","Sign_out":"(Legacy) Wyloguj się","Unlock_the_door":"(Legacy) Odblokuj drzwi","Open_coin_acceptor_dropsafe_Linux":"(Legacy) Otwórz wrzutnię monet (Linux)","Empty_cassette_and_close_the_dropsafe_Linux":"(Legacy) Opróżnij kasetę i zamknij wrzutnię (Linux)","Scan_new_left_cassette_barcode":"(Legacy) Zeskanuj nowy kod kreskowy lewej kasety","Scan_new_right_cassette_barcode":"(Legacy) Zeskanuj nowy kod kreskowy prawej kasety","Securing_safe":"(Legacy) Zabezpieczanie urządzenia","CIT_procedure_completed":"(Legacy) Procedura CIT zakończona","Open_the_door_Windows":"(Legacy) Otwórz drzwi (Windows)","Close_the_door_Windows":"(Legacy) Zamknij drzwi (Windows)","Open_coin_acceptor_dropsafe_Windows":"(Legacy) Otwórz depozytor monet wrzutni (Windows)","Empty_cassette_and_close_the_dropsafe_Windows":"(Legacy) Opróżnij kasetę i zamknij wrzutnię (Windows)","AUTO_UNLOCK_FRONT_DOOR":"Automatically unlock front door","WI_UNLOCK_FRONT_DOOR":"Unlock front door (no PIN)","LP_UNLOCK_FRONT_DOOR":"Unlock front door (LPLOCK)","LP_LOCK_FRONT_DOOR":"Lock front door (LPLOCK)","LP_OPEN_FRONT_DOOR":"Open front door (LPLOCK)","LP_CLOSE_FRONT_DOOR":"Close front door (LPLOCK)","VIM_READ_KEY_CIT":"Present CIT key","V2_UNLOCK_CIT_DOOR":"Odblokuj drzwi (Linux)","V2_OPEN_CIT_DOOR_LINUX":"Otwórz drzwi (Linux)","V2_REMOVE_STORAGE":"Wyciągnij schowek","V2_INSERT_STORAGE":"Włóż schowek","V2_CLOSE_CIT_DOOR_LINUX":"Zamknij drzwi (Linux)","V2_LOCK_CIT_DOOR":"Zablokuj drzwi (Linux)","V2_PROCESSING_CIT":"Urządzenie zabezpieczone - Lincstation","V2_REMOVE_CASSETTE":"Wyjmij kasetę","V2_INSERT_CASSETTE":"Włóż kasetę","V2_EMPTY_CASSETTE":"Empty cassette","V2_OPEN_CIT_DOOR_WINDOWS":"Otwórz drzwi (Windows)","V2_CLOSE_CIT_DOOR_WINDOWS":"Zamknij drzwi (Windows)","V2_REMOVE_LEFT_CASSETTE":"Wyjmij lewą kasetę","V2_INSERT_LEFT_CASSETTE":"Włóż lewą kasetę","V2_REMOVE_RIGHT_CASSETTE":"Wyjmij prawą kasetę","V2_INSERT_RIGHT_CASSETTE":"Włóż prawą kasetę","V2_LOGIN":"Login użytkownika","V2_CIT_PROCEDURE_COMPLETED":"Procedura CIT zakończona","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_LINUX":"Otwórz sejf boczny na monety (Linux)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_LINUX":"Pusty sejf na monety (Linux)","V2_SCAN_LEFT_READER_BARCODE":"Zeskanuj lewy kod kreskowy","V2_SCAN_RIGHT_READER_BARCODE":"Zeskanuj prawy kod kreskowy","V2_SCAN_STORAGE_BARCODE":"Skanuj schowek","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_WINDOWS":"Otwórz sejf boczny na monety (Windows)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_WINDOWS":"Pusty sejf na monety (Windows)","V2_OPEN_CIT_DOOR":"Otwórz drzwi CIT","V2_CLOSE_CIT_DOOR":"Zamknij drzwi CIT","V2_PROCESSING_LINCSTATION_CIT":"Bezpieczny sejf (Lincstation)","V2_OPEN_THE_DOOR_LINUX":"Otwórz drzwi (Linux)","V2_CLOSE_THE_DOOR_LINUX":"Zamknij drzwi (Linux)","V2_UNLOCK_DOOR":"Odblokuj drzwi (Linux)","V2_LOCK_DOOR":"Zablokuj (Linux)","V2_PROCESSING_SAFE_CIT":"Bezpieczny sejf","V2_PRINT_LEFT_CASSETTE":"Wydrukuj lewą kasetę","V2_PRINT_RIGHT_CASSETTE":"Drukuj prawą kasetę","V2_PRINT_CIT_TOTAL":"Drukuj sumy CIT","V2_SEAL_BAG":"Torba plombowana","V2_UNLOCK_SIDESAFE_WITH_BO_COIN":"Odblokuj sejf na monety","V2_UNLOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Odblokuj sejf boczny","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_COIN":"Opróżnij i zablokuj sejf na monety","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Opróżnij i zablokuj sejf boczny","V2_SEALING_BAG":"Torba plombowana","V2_REPLACE_SEAL_BAG":"Wymień torbę plombowaną","V2_SCAN_COIN_STORAGE_BARCODE":"Scan coin storage","V2_COIN_ROLL_FILL_UP":"Coin roll fill up","V2_EMPTY_COUNTERS":"Empty counters","V2_WAIT_10":"Delay 10 seconds","V2_OPEN_OM61_DOOR":"Open OM61 door","V2_CLOSE_OM61_DOOR":"Close OM61 door","V2_UNLOCK_OM61_BAG_STORAGE":"Unlock OM61 bag storage compartment","V2_TAKE_OM61_STORAGE_BAG":"Take OM61 storage bag","V2_INSERT_NEW_OM61_STORAGE_BAG":"Insert OM61 new storage bag","V2_OPEN_CIT_DOOR_LINCSTATION_V3":"Open door (Lincstation v3)","V2_CLOSE_CIT_LINCSTATION_V3":"Close door (Lincstation v3)","V2_PROCESSING_CIT_LINCSTATION_V3":"Secure safe (Lincstation v3)","V2_UNLOCK_LINCSTATION_V3":"Unlock door (Lincstation v3)","V2_LOCK_LINCSTATION_V3":"Lock door (Lincstation v3)","V2_INSTALL_OM61_STORAGE_BAG":"Install OM61 storage bag","V2_UNLOCK_FRONT_DOOR":"Unlock front door","V2_UNLOCK_FRONT_DOOR_SPT":"Unlock front door (SPT)","V2_OPEN_FRONT_DOOR":"Open front door","V2_CLOSE_FRONT_DOOR":"Close front door","V2_LOCK_FRONT_DOOR":"Lock front door","V2_LOCK_FRONT_DOOR_SPT":"Lock front door (SPT)","V2_EMPTY_ESCROW":"Empty escrow","V2_PAUSE_CIT":"Pause CIT","V2_REMOVE_REJECT_BIN":"Remove reject bin","V2_CONFIRM_EMPTY_REJECT_BIN":"Confirm empty reject bin","V2_INSERT_REJECT_BIN":"Insert reject bin","V2_FILL_UP_COINS":"Fill up coin recycler","V2_OPEN_COIN_OVERFLOW_DOOR_SPT":"Open coin overflow door (SPT)","V2_EMPTY_COINS_AND_CLOSE_COIN_OVERFLOW_DOOR_SPT":"Empty coins and close coin overflow door (SPT)","V2_SECURE_SAFE":"Secure safe","V2_REMOVE_PULOON_CASSETTE_1":"Remove 1st present dispenser cassette","V2_REMOVE_PULOON_CASSETTE_2":"Remove 2nd present dispenser cassette","V2_INSERT_PULOON_CASSETTE_1":"Insert 1st new dispenser cassette","V2_INSERT_PULOON_CASSETTE_2":"Insert 2nd new dispenser cassette","V2_UNLOCK_CIT_DOOR_2":"Unlock CIT door 2","V2_LOCK_CIT_DOOR_2":"Lock CIT door 2","V2_OPEN_CIT_DOOR_LINUX_2":"Open safe door (Linux) 2","V2_CLOSE_CIT_DOOR_LINUX_2":"Close safe door (Linux) 2","V2_UNLOCK_FRONT_DOOR_2":"Unlock front door 2","V2_UNLOCK_FRONT_DOOR_SPT_2":"Unlock front door 2 (SPT)","V2_OPEN_FRONT_DOOR_2":"Open front door 2","V2_CLOSE_FRONT_DOOR_2":"Close front door 2","V2_LOCK_FRONT_DOOR_2":"Lock front door 2","V2_LOCK_FRONT_DOOR_SPT_2":"Lock front door 2 (SPT)","V2_SECURE_CIT_DOOR":"Secure CIT door (SPT)","V2_SECURE_CIT_DOOR_2":"Secure CIT door 2 (SPT)","V2_SECURE_FRONT_DOOR":"Secure front door (SPT)","V2_SECURE_FRONT_DOOR_2":"Secure front door 2 (SPT)","V2_SKIP_EMPTY_ESCROW_SAFEBAG_FULL":"Skip emptying escrow when sealbag is full","dynamic":{"LOCK_OPEN":"Open lock","LOCK_CLOSE":"Close lock","LOCK_OPEN_WITH_PIN":"Open lock with pin","DOOR_OPEN":"Open door","DOOR_CLOSE":"Close door","DOOR_SECURE":"Secure door","CIT_COMPLETED":"Cit completed","CIT_PAUSE":"Cit paused","CIT_DIALOG":"Cit dialog","CIT_USER_LOGIN":"Cit user login","COIN_FILL_UP":"Fill up coin","COIN_EMPTY_OVERFLOW_STORAGE":"Empty coin overflow storage","STORAGE_REMOVE_CASSETTE":"Remove storage cassette","STORAGE_ATTACH_CASSETTE":"Attach storage cassette","STORAGE_PULOON_REMOVE_DISPENSER_1":"Remove storage puloon dispenser 1","STORAGE_PULOON_ATTACH_DISPENSER_1":"Attach storage puloon dispenser 1","STORAGE_PULOON_REMOVE_DISPENSER_2":"Remove storage puloon dispenser 2","STORAGE_PULOON_ATTACH_DISPENSER_2":"Attach storage puloon dispenser 2","STORAGE_PULOON_REMOVE_DISPENSER_3":"Remove storage puloon dispenser 3","STORAGE_PULOON_ATTACH_DISPENSER_3":"Attach storage puloon dispenser 3","STORAGE_PULOON_REMOVE_DISPENSER_4":"Remove storage puloon dispenser 4","STORAGE_PULOON_ATTACH_DISPENSER_4":"Attach storage puloon dispenser 4","STORAGE_PULOON_REMOVE_REJECT_BIN":"Remove storage puloon reject bin","STORAGE_PULOON_ATTACH_REJECT_BIN":"Attach storage puloon reject bin","COIN_REMOVE_AND_EMPTY_OVERFLOW_STORAGE":"Remove and empty coin bucket","COIN_FILL_UP_SPLIT_START":"Start split fill up","COIN_FILL_UP_SPLIT_END":"Stop split fill up","COIN_INSERT_OVERFLOW_STORAGE":"Insert coin bucket","CIT_IBUTTON_LOGIN":"iButton login","MANUAL_DEPOSIT_EMPTY":"Empty manual deposit","CENCON_LOCK_OPEN":"Open Cencon lock","CENCON_LOCK_CLOSE":"Close Cencon lock","TRAY_OPEN":"Open hitachi door","TRAY_CLOSE":"Close hitachi door","HITACHI_REJECT_BOX_CLOSE":"Close reject box","HITACHI_REJECT_BOX_OPEN":"Open reject box and empty its contents","STORAGE_ONE_ATTACHED":"Attach Puloon storage cassette","STORAGE_ONE_REMOVED":"Remove Puloon storage cassette","HITACHI_STORAGE_ONE_ATTACHED":"Attach hitachi storage","HITACHI_STORAGE_ONE_REMOVED":"Remove hitachi storage","HITACHI_STORAGE_TWO_ATTACHED":"Attach Hitachi storage cassette 2","HITACHI_STORAGE_TWO_REMOVED":"Remove Hitachi storage cassette 2","HITACHI_STORAGE_THREE_ATTACHED":"Attach Hitachi storage cassette 3","HITACHI_STORAGE_THREE_REMOVED":"Remove Hitachi storage cassette 3","HITACHI_STORAGE_FOUR_ATTACHED":"Attach Hitachi storage cassette 4","HITACHI_STORAGE_FOUR_REMOVED":"Remove Hitachi storage cassette 4","HITACHI_STORAGE_FIVE_ATTACHED":"Attach Hitachi storage cassette 5","HITACHI_STORAGE_FIVE_REMOVED":"Remove Hitachi storage cassette 5","HITACHI_STORAGE_ONE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 1","HITACHI_STORAGE_ONE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 1","HITACHI_STORAGE_TWO_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 2","HITACHI_STORAGE_TWO_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 2","HITACHI_STORAGE_THREE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 3","HITACHI_STORAGE_THREE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 3","HITACHI_STORAGE_FOUR_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 4","HITACHI_STORAGE_FOUR_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 4","HITACHI_STORAGE_FIVE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 5","HITACHI_STORAGE_FIVE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 5","HITACHI_STORAGE_SIX_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 6","HITACHI_STORAGE_SIX_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 6"},"V2_REMOVE_SEALPACK_FROM_COIN_STORAGE":"Take out sealpack from coin storage","V2_INSERT_NEW_SEALPACK_TO_COIN_STORAGE":"Insert new sealpack to coin storage"},"dialog":{"title":"Confirm change order","description":"The Step: {stepOrder} can't be moved without breaking Skip to value of Step: {colindantStepOrder}","confirmation":"Change order anyway and remove Skip to value ?"}},"mix":{"titles":{"overview":"Utarg mieszany","create":"Dodaj mieszany zasiłek","update":"Zaktualizuj mieszany zasiłek"},"breadcrumb":{"title":"Przegląd"},"form":{"mixName":"Nazwa mixu","totalAmount":"Całkowita kwota","organization":"Organizacja","denominations":"Nominały","currency":"Currency","eur":"EURO","usd":"USD","gbp":"GBP"},"columns":{"name":"Nazwa mixu","totalAmount":"Całkowita kwota","details":"Szczegóły","totalValue":"Total value"},"read":{"mixDetails":"Szczegóły mixu"},"actions":{"create":"Dodaj mix","update":"Zaktualizuj mix","delete":"Delete mix","read":"Read mix"}},"notification":{"titles":{"read":"Szczegóły powiadomienia"},"read":"Szczegóły powiadomienia"},"report":{"buttons":{"createReport":"TWORZENIE RAPORTU","generating":"Generowanie..."},"titles":{"overview":"Raport","create":"Dodaj raport","update":"Aktualizuj raport"},"breadcrumb":{"title":"raport"},"form":{"orgUuid":"Organizacja","unitUuid":"Urządzenie","type":"Typ","startDate":"Do","endDate":"Do","types":{"getReptileCampaignsAndTransactionsByDate":"Transakcje i opróżnienia kaset","getReptileCampaignsAndTransactionsMoneyInOutCounterByDate":"Transakcje i opróżnienia kaset z licznikiem wpłat i wypłat","getReptileTransactionsByDate":"Transakcje","getManualTransactionsByDate":"[Deprecated] Wrzutnia","getReptileManualTransactionsByDate":"Wrzutnia - Nowy","getReptileReportForClosedCampaignsByUnitAndDate":"Opróżnianie kaset","getReptileClearboxDenomination":"[Deprecated] Clearboxes denomination","getReptileClearboxDenominationV2":"Clearboxes denomination","getReptileEndOfDayInfoByDate":"Utarg urządzenia na koniec dnia","getReptileLincstationEndOfDayInfoByDate":"Utarg Lincstation na koniec dnia","getEndOfDayClientsByDate":"[Deprecated] Utarg klienta na koniec dnia","getReptileEndOfDayClientsByDate":"Utarg klienta na koniec dnia - Nowy","getEventsByDate":"Wydarzenia według daty","getReptileEventsByDate":"Wydarzenia według daty - Nowy","getReptileReportForDenominationPerUser":"Nominały wg użytkownika","getReptileReportForDenominationWithPin":"Nominały na PIN","getReptileSalesByDate":"Sprzedaż - Nowa","getInternalTransactionsByDate":"[Deprecated] Transakcje wewnętrzne","getReptileInternalTransactionsByDate":"Transakcje wewnętrzne - Nowy","getReptileAdvancedManualDeposit":"Zaawansowane wpłaty ręczne","getReptileRecyclerReport":"Raport ogólny Lincstation","getReptileTransactionsWithReference":"Transakcje z numerem referencyjnym","getTransactionsWithReference":"[Deprecated] Transakcje z numerem referencyjnym","getCampaignsWithBarcodes":"[Deprecated] Opróżnianie kaser z numerem plomb","getSalesByDate":"[Deprecated] Sprzedaż","getCurrentlyOfflineUnits":"Currently Offline Units (.csv)","getReptileCashCoinEndOfDayInfoByDate":"End of Day Cash/Coin","getReptileUnitInventory":"Unit Inventory (.pdf)","getReptileCampaignsAndTransactionsByDateWithSource":"Smartsafes transactions and clearboxes","getReptileEndOfDaySmartSafes":"Smartsafes End Of Day (.pdf)","getReptileEndOfDaySmartSafesXlsx":"Smartsafes End Of Day (.xlsx)","getReptileEndOfDayRecyclerXlsx":"Recycler End Of Day (.xlsx)","getReptileCampaignSmartSafesPdf":"Smartsafes Campaign (.pdf)","getReptileCampaignSmartSafesXlsx":"Smartsafes Campaign (.xlsx)","getReptileTransactionSmartSafesPdf":"Smartsafes Transaction (.pdf)","getReptileTransactionSmartSafesXlsx":"Smartsafes Transaction (.xlsx)","getReptileTransactionSmartSafesDetailedPdf":"Smartsafes Transaction Detailed (.pdf)","getReptileTransactionSmartSafesDetailedXlsx":"Smartsafes Transaction Detailed (.xlsx)","getOrganizationAssetsXlsx":"Smartsafes Asset Management (.xlsx)","getOrganizationAssetsPdf":"Smartsafes Asset Management (.pdf)","getReptileEventSmartSafesXlsx":"Smartsafes Event (.xlsx)","getReptileEventSmartSafesPdf":"Smartsafes Event (.pdf)"}},"messages":{"success":"Raport został pomyślnie pobrany. Pobieranie pliku powinno rozpocząć się automatycznie...","failed":"Nie udało się wygenerować raportu. Spróbuj ponownie później","reptileDateLimitExceeded":"Nie można było wygenerować raportu. Przekroczono określony limit daty. Proszę dostosować zakres dat i spróbować ponownie.","reptileGenericBadRequest":"Nie można było wygenerować raportu z powodu błędnie sformułowanego żądania. Proszę sprawdzić parametry wejściowe i spróbować ponownie później.","cannotOutputToCsvFile":"The report could not be generated. Please try again later and/or with different parameters.","errorOccurred":"The report could not be generated. Unknown error occurred."},"dialog":{"title":"Raport został pobrany pomyślnie.","download":"Kliknij tutaj, aby pobrać raport","close":"Zamknij"}},"transaction":{"read":"Szczegóły transakcji"},"adminsettings":{"titles":{"overview":"Currency maintenance"},"breadcrumb":{"title":"Przegląd"},"messages":{"updated":"Aktualizacja waluty i nominałów","error":"Coś poszło nie tak, waluta i nominały nie zostały zaktualizowane"},"form":{"currency":"Waluta","iso1":"ISO1","iso2":"ISO2","iso3":"ISO3","symbol":"Symbol","symbolCode":"Symbol kod","defaultValue":"Wartość domyślna","enabled":"Włączony","denomination":{"value":"Wartość","coins":"Monety","bills":"Banknoty","enabled":"Włączony","remove":"Usuń"}}},"common":{"form":{"bankAccount":"Primary bank account number","citAccount":"CIT account number","affiliateCode":"Affiliate code","overrideBankAccount":"Override primary bank account number","overrideCitAccount":"Override CIT account number","overrideAffiliateCode":"Override affiliate code"},"toolTip":{"bankAccount":"Bank account number to which deposits/withdrawals are transmitted from the safe(s). Can be overridden at a more granular level","citAccount":"Bank account number to which funds are deposited after CIT. Usually the same as primary bank account number","affiliateCode":"4 digit alphabetical code"}},"department":{"titles":{"overview":"Departments","create":"Create a department","update":"Update department","preview":"Preview department"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Name","organizationName":"Organization"},"form":{"name":"Name","organization":"Organization","bankAccount":"Bank account number"},"toolTip":{"organization":"Which organization does this department belong to","bankAccount":"Optional bank account number to which deposits/withdrawals are transmitted from the safe(s)","overrideBankAccount":"Do not inherit primary bank account from unit. Instead, define a new one specific to this department"},"actions":{"create":"Create department","read":"Preview department","update":"Update department","delete":"Delete department","preview":"Preview department"},"messages":{"added":"Department {name} has been created","updated":"Department {name} has been updated"}},"unitRoles":{"titles":{"overview":"Unit roles","create":"Add a unit role","update":"Update unit role"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Unit role name","organization":"Organization"},"actions":{"create":"Add unit role","update":"Update unit role","delete":"Delete unit role"},"form":{"name":"Unit role name","organization":"Organization","transactionCashOutLimit":"Transaction cash out limit","dailyCashOutLimit":"Daily cash out limit","permissions":"Permissions"},"messages":{"added":"The unit role {name} is added","updated":"The unit role {name} is updated"}}},"server_messages":{"accessNotAllowed":"Dostęp niedozwolony.","authorizationFailed":"Autoryzacja się nie powiodła.","campaignNotFound":"Nie znaleziono kampanii!","cityCannotBeEmpty":"Miejscowość nie może być pusta!","componentNotFound":"Nie znaleziono komponentu!","countryCannotBeEmpty":"Kraj nie może być pusty!","countryNotFound":"Nie znaleziono kraju!","credentialsCannotBeEmpty":"Kwalifikacje nie mogą być puste","currencyNotFound":"Nie znaleziono waluty!","duplicateItemFound":"Znaleziono zduplikowany przedmiot!","errorOccurred":"Wystąpił i został zarejestrowany błąd.","ILLEGAL_ARGUMENT":"Błędne dane wejściowe","ILLEGAL_ARGUMENT_ADDRESS_TYPE":"Coś poszło nie tak z adresem","ILLEGAL_ARGUMENT_ADDRESSLINE1":"Proszę zmienić pierwszy wiersz adresu","ILLEGAL_ARGUMENT_ADDRESSLINE2":"Proszę zmienić drugi wiersz adresu","ILLEGAL_ARGUMENT_BANK_ACCOUNT":"Proszę zmienić konto bankowe","ILLEGAL_ARGUMENT_CHILD_ORGANIZATION":"Zmień organizację podrzędną","ILLEGAL_ARGUMENT_CIT":"Coś poszło nie tak z informacjami o CIT","ILLEGAL_ARGUMENT_CITY":"Proszę zmienić miejscowość","ILLEGAL_ARGUMENT_CLIENT_ORGANIZATION":"Proszę zmienić organizację klienta","ILLEGAL_ARGUMENT_COUNTRY":"Proszę zmienić kraj","ILLEGAL_ARGUMENT_CURRENCY":"Proszę zmienić walutę","ILLEGAL_ARGUMENT_DATE":"Proszę zmienić datę","ILLEGAL_ARGUMENT_DESCRIPTION":"Proszę zmienić opis","ILLEGAL_ARGUMENT_FIRST_NAME":"Proszę zmienić nazwę","ILLEGAL_ARGUMENT_GENDER":"Coś poszło nie tak z płcią","ILLEGAL_ARGUMENT_ID":"Zmień identyfikator","ILLEGAL_ARGUMENT_LAST_NAME":"Proszę zmienić nazwisko","ILLEGAL_ARGUMENT_LEGAL_FORM":"Proszę zmienić formę prawną","ILLEGAL_ARGUMENT_LOCATION":"Proszę zmienić lokalizację","ILLEGAL_ARGUMENT_LOCATION_UUID":"Nie można znaleźć lokalizacji","ILLEGAL_ARGUMENT_MACHINE_TYPE":"Proszę zmienić typ sejfu","ILLEGAL_ARGUMENT_MAIL":"Zmień adres e-mail","ILLEGAL_ARGUMENT_MAINTENANCE":"Coś poszło nie tak z informacjami o serwisie","ILLEGAL_ARGUMENT_NAME":"Proszę zmienić nazwę","ILLEGAL_ARGUMENT_ORGANIZATION":"Proszę zmienić organizację","ILLEGAL_ARGUMENT_ORGANIZATION_TYPE":"Proszę zmienić typ organizacji","ILLEGAL_ARGUMENT_ORGANIZATION_UNIT_TYPE":"Coś poszło nie tak z kombinacją organizacji i typu urządzenia","ILLEGAL_ARGUMENT_ORGANIZATION_UUID":"Nie można znaleźć organizacji","ILLEGAL_ARGUMENT_OWNER_ORGANIZATION":"Zmień firmę właściciela","ILLEGAL_ARGUMENT_PAGE_NUMBER":"Coś poszło nie tak z numerem strony","ILLEGAL_ARGUMENT_PAGE_SIZE":"Coś poszło nie tak z rozmiarem strony","ILLEGAL_ARGUMENT_PARENT_ORGANIZATION":"Zmień organizację nadrzędną","ILLEGAL_ARGUMENT_PASSWORD":"Zmień hasło","ILLEGAL_ARGUMENT_PERSON":"Coś poszło nie tak z informacjami o użytkowniku","ILLEGAL_ARGUMENT_PHONE_NUMBER":"Zmień numer telefonu","ILLEGAL_ARGUMENT_PIN":"Zmień PIN","ILLEGAL_ARGUMENT_REPORTED_ORGANIZATIONS":"Proszę zmienić zgłoszone organizacje","ILLEGAL_ARGUMENT_ROLES":"Proszę zmienić role","ILLEGAL_ARGUMENT_SDC":"Coś poszło nie tak z Clearbox","ILLEGAL_ARGUMENT_SERIAL":"Zmień numer seryjny","ILLEGAL_ARGUMENT_TOKEN":"Coś jest nie tak z danymi logowania","ILLEGAL_ARGUMENT_UNIT":"Proszę zmienić urządzenie","ILLEGAL_ARGUMENT_UNIT_TYPE":"Proszę zmienić typ urządzenia","ILLEGAL_ARGUMENT_UNIT_UUID":"Nie można znaleźć urządzenia","ILLEGAL_ARGUMENT_USER":"Zmień użytkownika","ILLEGAL_ARGUMENT_UUID":"Nie można pobrać informacji","INVALID_CREDENTIALS":"Nieprawidłowe dane uwierzytelniające","INVALID_PATH":"Niewłaściwa ścieżka","invalidData":"Nieprawidłowe dane","legalFormNotFound":"Nie znaleziono formy prawnej!","locationInUse":"Lokalizacja w użyciu","locationNameCannotBeEmpty":"Nazwa lokalizacji nie może być pusta!","locationNotFound":"Nie znaleziono lokalizacji!","locationUpdateDataIsInvalid":"Dane aktualizacji lokalizacji są nieprawidłowe!","LOCKED":"Zablokowany","LOGOUT":"Wylogowano!","NO_RESULT":"Brak wyników","organizationInUse":"Organizacja w użyciu","organizationListFetched":"Pobrano listę organizacji.","organizationNotFound":"Organizacja nieodnaleziona.","organizationTypeNotFound":"Typ organizacji nieodnaleziony.","passwordIsInvalid":"Hasło jest niewłaściwe!","phoneNumberLengthIsIncorrect":"Długość numeru telefonu jest nieprawidłowa","pinIsEmpty":"Proszę wpisać kod PIN","pinNotNumeric":"Używaj tylko cyfr w szpilce, proszę","roleNotFound":"Nie znaleziono roli.","sessionTimeout":"Session timeout","settingsNotFound":"Nie znaleziono ustawień","SUCCESS":"Powodzenie","SYSTEM_FAIL":"System zawiódł!","transactionNotFound":"Nie znaleziono transakcji","UNABLE_TO_STORE_INFO":"Nie udało się zapisać danych","UNAUTHORIZED":"Nieautoryzowany dostęp","unitNotFound":"Nie znaleziono urządzenia.","unitTypeListFetched":"Pobrano listę typów urządzeń.","userAlreadyExists":"Użytkownik już istnieje","userIsLocked":"Użytkownik jest zablokowany.","userNotFound":"Użytkownik nie znaleziony","workflowInUseByOtherOrg":"Proces używany przez inną organizację, proszę zmienić organizację lub usunąć proces z innych organizacji/urządzeń","workflowNotFound":"Proces nieodnaleziony!","invalidFormatException":"Nieprawidłowy format danych, sprawdź dane w strukturze JSON","unrecognizedPropertyException":"Sprawdź właściwości w strukturze JSON","jsonParseException":"Nie udało się przeanalizować JSON, sprawdź strukturę","jsonMappingException":"Nie udało się zmapować JSON, sprawdź strukturę","iOException":"Nie udało się przeanalizować JSON, sprawdź strukturę","minimumGreaterThanOptimum":"Minimalna kwota większa niż optymalna","maximumLessThanOptimum":"Maksymalna ilość mniejsza niż optymalna","ILLEGAL_ARGUMENT_MIX_UUID":"Cannot find mixes","ILLEGAL_ARGUMENT_MAX_AMOUNT":"Zmień maksymalną kwotę","TILL_IS_BEING_USED_BY_USER":"Kasa jest zajęta przez użytkownika","TILL_IS_BEING_USED_BY_UNIT":"Kasa jest zajęta przez urządzenie","secretIsEmpty":"Empty secret found","secretAlreadyExists":"Invalid secret generated. Please generate again","MIN_FOUR_DIGITS":"PIN must be at least 4 digits in length","MIN_SIX_DIGITS":"PIN must be at least 6 digits in length","MAX_SIX_DIGITS":"PIN must be at most 6 digits in length","NO_DUPLICATE_DIGITS":"PIN must not have repeated digits","NO_INCREMENTING_DIGITS":"PIN must not be in incrementing order","NO_DECREMENTING_DIGITS":"PIN must not be in decrementing order","MAX_NINETY_DAYS":"Pin expired after 90 days, Please change pin","MAX_SIXTY_DAYS":"Pin expired after 60 days, Please change pin","MAX_THIRTY_DAYS":"Pin expired after 30 days, Please change pin","PIN_LENGTH_NOT_IN_4_TO_6":"Pin length between 4 and 6 digits","ILLEGAL_ARGUMENT_USERNAME_NULL":"External Username must not be null","ILLEGAL_ARGUMENT_EXTERNAL_USERNAME_IS_NULL":"External Username must not be null","ILLEGAL_ARGUMENT_EXTERNAL_PASSWORD_IS_NULL":"External password must not be null","ILLEGAL_ARGUMENT_EXTERNAL_HS600_PASSWORD_INVALID":"External HS600 password is invalid. Only numeric values allowed","ILLEGAL_ARGUMENT_ROLES_ONE_EXTERNAL_HS600_ROLE_ALLOWED":"Only one external HS600 role is allowed","maxDispensableGreatherThenAllowed":"Max dispensable is greather then allowed","MFA_REQUIRED":"Multi factor authentication required","duplicateSafeIdFound":"Safe ID already exists!","validationError":"Validation failed.","ILLEGAL_ARGUMENT_MIX_DENOMINATIONS":"Please select currency.","unitRoleInUseByUser":"This unit cannot be deleted because it is currently assigned to a user.","emailNotUnique":"The email address is already in use","NON_UNIQUE_USERNAME":"Duplicate user accounts found, please contact your administrator","departmentAlreadyExists":"Department name has already been taken. Please choose another name","maxAndOptimumRequiredException":"Please enter the value for the Optimum and Max column before updating the page","invalidParentOrganizationType":"The parent organization must either be of type 'GENERAL' or match the type of the organization","workflowInUseByUnits":"Workflow in use by units [{reason}]. Make sure no units are using this workflow before deleting it."},"placeholder_names":{"cit":{"LR":"Lewy depozytor banknotów","RR":"Prawy depozytor banknotów","CA":"Przepełnienie monet","BA":"Depozytor banknotów","R3":"Środkowy depozytor banknotów","B1":"Depozytor banknotów","RC":"Depozytor banknotów","CC":"Przepełnienie monet"},"LR":"Lewy czytnik banknotów","RR":"Prawy czytnik banknotów","PR":"Drukarka","CA":"Coin acceptor","BO":"Breakout board","DS":"Czujnik drzwi","PU":"Dyspenser banknotów","SC":"Recykler monet bliźniaczych","SS":"Czujnik boczny","SD":"Side driver sensor","WI":"Inteligentny zamek Lincsafe","LL":"Zamek dolny","HO":"Pojemnik na monety","BA":"Wrzutnia bilonu","DR":"Czytnik drzwi","R3":"Środkowy czytnik banknotów","ST":"Czujnik górny","TD":"Top driver sensor","SB":"Bottom driver sensor","BD":"Bottom driver sensor","B1":"Czytnik banknotów","H1":"Pierwszy pojemnik","H2":"Drugi pojemnik","UL":"Zamek górny","BP":"Sygnał dźwiękowy","RC":"Recykler banknotów","CC":"Recykler monet","DT":"Górne drzwi","DM":"Środkowe drzwi","DB":"Dolne drzwi","CD":"Drzwi CIT","MD":"Serial maintenance door sensor","RF":"Czytnik RFID","SL":"Zgrzewarka","UNIT":"Urządzenie","null":"","DRAWER":"Szuflada","SIDE_SAFE":"Sejf boczny","COIN_DROP_SAFE":"Sejf na monety","COIN_ROLL":"Gilza monet","PIN_TERMINAL":"Terminal PIN","WI_MAINTENANCE":"Serwis zamka do drzwi","NETWORK":"Network","STORAGE_INVENTORY":"Storage inventory","UNKONWN":"Nieznany","om61":"OM61","DOOR_BOTTOM":"Bottom door","DOOR_MIDDLE":"Middle door","DOOR_TOP":"Top door","EXB":"Extension board","MLOCK_TOP":"Top m-lock","SOLENOID_BOTTOM":"Bottom solenoid","SWITCH_COIN_TUBE":"Coin chute","WI_MIDDLE":"Middle wittkopp lock","DOOR_FRONT":"Door front sensor","DOOR_LEFT":"Door left sensor","DOOR_RIGHT":"Door right sensor","SOLENOID":"Solenoid","VIM":"Vault Interface Module","LOCK_FRONT":"Front door lock","LPLOCK":"Front door lock","MLOCK":"MLock","BOTTOM_LOCK":"Bottom lock","BO_1":"Bo 1","BO_2":"Bo 2","BUTTON_A":"Button A","BUTTON_B":"Button B","BUTTON_C":"Button C","BUTTON_D":"Button D","DOOR_TOP_LEFT":"Door top left","DOOR_TOP_RIGHT":"Door top right","EBM":"EBM","EBS":"EBS","HOPPERS":"Hoppers","HSCD":"HSCD","TOP_LEFT_LOCK":"Top left lock","WI_TOP":"WI top","CIT_COMPLETED":"Unit","DOOR_HATCH":"Door top hatch sensor","LPLOCK_STORAGE":"LP lock storage","IBUTTON":"iButton","HITACHI_LOCK":"Cencon lock","XR":"Hitachi","JACK_STATUS":"Stan gniazda słuchawkowego"},"compartment_names":{"RECYCLER":"RECYKLER","STORAGE":"SCHOWEK","MANUAL_STORAGE":"Manual storage","ESCROW":"ESCROW","HOPPERS":"HOPPERS","REJECT":"REJECT"},"notifications":{"ACCEPTING":"Urządzenie(a) gotówkowe jest/są akceptowane","BOTTOM_DOOR_OPEN":"Coin acceptor overflow door is open!","BOTTOM_SIDE_DOOR_OPEN":"Otwarte dolne drzwi sejfu bocznego","CALIBRATING":"Urządzenie kasowe jest kalibrowane","CARTRIDGE_DETACHED":"Wkład został odłączony","CHEATED":"Próba oszustwa","CIT_DOOR_OPEN":"Otwarte drzwi CIT","COIN_DRAWER_OPENED":"Szuflada na monety otwarta","COIN_DROP_SAFE_OPENED":"Sejf boczny na monety jest otwarty","DEVICE_CAN_NOT_PAYOUT":"Zapasy nie wystarczają do wypłaty","DOOR_OPEN":"Drzwi są otwarte","DOWNLOADING":"Pobieranie oprogramowania","DRAWER_OPENED":"Szuflada otwarta","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Wejście nie jest puste","errorOccurred":"Wewnętrzny błąd serwera","EXCEEDS_PAYOUT_LIMIT":"Wartość do wypłaty przekracza limit.","EXTENSION_STALL":"Zatrzymany","FAILED":"Wykryto awarię","FEED_FAILURE":"Feed failed","FLOAT_NOT_SET":"Wartość startowa cash float nie ustawiona, ustaw wartość float na  portalu!","ILLEGAL_ARGUMENT":"Nieprawdiłowa wartość","INSURABLE_VALUE_REACHED":"Osiągnięto wartość ubezpieczenia, opróżnij sejf!","CASSETTE_LIMIT_REACHED":"Osiągnięto limit kasety","INVALID_CREDENTIALS":"Nieprawidłowe dane uwierzytelniające!","INVENTORY_LOWER_THAN_FLOAT":"Zapas niższy od poziomu start cash float","INVENTORY_NOT_SUFFICIENT":"Zapasy są niewystarczające, proszę napełnić urzadzenie !","INVENTORY_OVER_MAX":"Poziom zapasów jest wyższy niż maksymalny, opróżnij urzadzenie !","INVENTORY_SETTINGS_NULL":"Nie można znaleźć ustawień zapasów, skontaktuj się z menedżerem!","INVENTORY_UNDER_MIN":"Zapasy są niższe niż minimum, proszę uzupełnić urzadzenie!","INVENTORY_UNDER_LOW":"Zapasy są  poniżej niskiego poziomu, proszę uzupełnić urzadzenie !","JAMMED":"Urządzenie się zacięło","LAST_TRANSACTION_FAILED":"Ostatnia płatność nie powiodła się, skontaktuj się z menedżerem!","LOCK_NOT_SECURE":"Inteligentny (wittkopp) zamek nie jest bezpieczny!","MACHINE_BUSY":"Urzadzenie zajęte, poczekaj na zakończenie uruchomionej transakcji","MACHINE_NOT_OPERATIONAL":"Urządzenie nie działa, sprawdź powiadomienia","MAINTENANCE_DOOR_OPEN":"Otwarte drzwi serwisowe","MIDDLE_DOOR_OPEN":"Drzwi CIT są otwarte!","NO_ACCESS":"Personel nie ma dostępu<br/>do wartości w sejfie","NOT_CONNECTED":"Urządzenie nie jest podłączone","NOT_OPERATIONAL":"Nie działa","NOT_RECYCLED_MATERIAL":"Not a recycled material","NOT_SECURE":"Urzadzenie niezabezpieczone, skontaktuj się z menedżerem!","ORGANIZATION_NOT_FOUND":"Nie można znaleźć organizacji","OVERRIDDEN":"Zamek jest overriden odblokowany","PAPER_EMPTY":"Brakuje papieru","PAPER_LOW":"Mało papieru","PAUSE":"Pauza","PAYOUT_FAILED":"Nie można wypłacić wartości","PAYOUT_LIMIT_NOT_FOUND":"Limit wypłat nie został jeszcze zdefiniowany!","PIN_EMPTY":"PIN nie może być pusty!","POWER_UP":"Power up","RECYCLER_ALMOST_EMPTY":"Recykler jest prawie pusty","RECYCLER_ALMOST_FULL":"Recykler jest prawie pełny","RECYCLER_EMPTY":"Recykler jest pusty","RECYCLER_FULL":"Recykler jest pełny","REJECT_NOT_EMPTY":"Odrzucone wartości opróżnij","SIDE_DOOR_ONE_OPEN":"Drzwi boczne (1) są otwarte","SIDE_DOOR_OPEN":"Drzwi boczne są otwarte","SIDE_SAFE_OPENED":"Sejf boczny otwarty","STACKER_FULL":"Układarka jest pełna","STALLED":"Zatrzymany","STORAGE_ALMOST_FULL":"Kaseta jest prawie pełna, opróżnij sejf","STORAGE_DETACHED":"Kaseta jest odłączona","STORAGE_FULL":"Kaseta jest pełna, opróżnij sejf","TOP_DOOR_OPEN":"Drzwi serwisowe są otwarte!","TOP_SIDE_DOOR_OPEN":"Górne drzwi są otwarte","USER_BLOCKED":"Użytkownik został zablokowany","USER_NOT_FOUND":"Użytkownik nie został znaleziony","WORKFLOW_NOT_FOUND":"Nie można znaleźć procedury CIT, sprawdź portal","ZERO_AMOUNT":"Kwota powinna być większa niż 0","PAYMENT_NOT_POSSIBLE_WITH_THIS_AMOUNT":"Płatność niemożliwa przy tej kwocie","INVALID_CONFIGURATION":"Nieprawidłowa konfiguracja recyklera","LAST_NOTE_HIGHEST_RECYCLED_VALUE":"Only 1 high value note in succession allowed","MAX_AMOUNT_REACHED":"Recykler dla tego nominału jest pełny","NON_RECYCLED_DENOMINATION":"Denomination is not recycled","THREE_HIGH_VALUE_NOTES_IN_SUCCESSION":"No more than three high denomination notes in succession are allowed ","NOT_OPERATIONAL_005":"Dyspenser gilz monet 5 gr nie działa","NOT_OPERATIONAL_010":"Dyspenser gilz monet 10 gr nie działa","NOT_OPERATIONAL_020":"Dyspenser gilz monet 20 gr nie działa","NOT_OPERATIONAL_050":"Dyspenser gilz monet 50 gr nie działa","NOT_OPERATIONAL_100":"Dyspenser gilz monet 1 zł nie działa","NOT_OPERATIONAL_200":"Dyspenser gilz monet 2 zł nie działa","STORAGE_ALMOST_EMPTY_005":"Dyspenser gilz monet 5 gr jest prawie pusty","STORAGE_ALMOST_EMPTY_010":"Dyspenser gilz monet 10 gr jest prawie pusty","STORAGE_ALMOST_EMPTY_020":"Dyspenser gilz monet 20 gr jest prawie pusty","STORAGE_ALMOST_EMPTY_050":"Dyspenser gilz monet 50 gr jest prawie pusty","STORAGE_ALMOST_EMPTY_100":"Dyspenser gilz monet 1 zł jest prawie pusty","STORAGE_ALMOST_EMPTY_200":"Dyspenser gilz monet 2 zł jest prawie pusty"}}

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

	module.exports = {"generic":{"application_name":"LincSafe Portal","copy_right":"Všetky práva vyhradené","submenu":{"title":"Organizácie","reset_text":"Reset"},"mainmenu":{"login":"Login","submenu":"Submenu","units":"Prístroje","users":"Používatelia","locations":"Lokácie","organizations":"Organizácie","tills":"Pokladnice","mixes":"Mixy","report":"Report","citworkflow":"CIT proces","softwaresettings":"Nastavenie Softwara","adminsettings":"Admin nastavenia","departments":"Departments","roles":"Unit roles"},"overview":{"pagination":{"showing":"<strong>{current}</strong> of <strong>{total}</strong> showing","pagesize":{"before":"Prehľad","after":"Záznamy"},"success":{"added":"Pridané {field}","updated":"Aktualizované {field}","deleted":"Vymazané {field}","unlocked":"Odomknuté {field}"}},"dialog":{"delete":{"title":"Potvrdenie vymazania","description":"Chystáte sa vymazať: ","confirmation":"Ste si istý?","tillDescriptionName":"You are about to delete: ","tillDescriptionUnit":"and disconnect from {noUnits} unit(s): <ul>{units}</ul>","tillDescriptionUnits":"and disconnect from {noUnits} units?"},"warning":{"title":"Warning","description":"The CIT organization has been changed. Please make sure the new selection has workflows to support all unit types of this organization","confirmation":"Are you sure you want to proceed with updating?"},"unlock":{"title":"Podtvrdte odomknutie","description":"Chystáte sa odomknúť <strong>{name}</strong>","confirmation":"Ste si istý?"},"filter":{"title":"Filter","confirmation":"OK"}},"search":{"placeholder":"Hľadať...","noresults":"Nenašli sme žiadne zodpovedajúce výsledky zodpovedajúce vášmu dotazu..."},"filter":{"selectall":"Vybrať všetko","deselectall":"Zrušiť výber všetkých","hide":"Skryť filter","show":"Zobraziť filter"},"buttons":{"back":"Späť","cancel":"Zrušiť","confirm":"Potvrdiť","reset":"Obnoviť","create":"Vytvoriť","update":"Aktualizovať","delete":"Vymazať","read":"Čítať","filter":"Filter","unlock":"Odomknúť","ok":"OK","upload":"Upload"}},"forms":{"errors":{"required":"{field} je povinné pole","donotmatch":"{field} polia sa nezhodujú","minvalue":"Minimálna hodnota je {min}","maxvalue":"Maximálna hodnota je {max}","mincharlength":"Minimálny počet znakov je {min}","maxcharlength":"maximálny počet znakov je {max}","minmaxcharlength":"Minimálna dĺžka znaku je {min} a maximálna dĺžka znaku je {max}","form":"Vo formulári boli nájdené chyby. Skontroľujte nasledovné polia","userNotFound":"E-mail adresa sa nenašla!","password":{"missing_lowercase":"Musí obsahovať aspoň jedno malé písmeno (a-z)","missing_uppercase":"Musí obsahovať aspoň jedno veľké písmeno (A-Z)","missing_digit":"Musí obsahovať aspoň jedno číslo(0-9)","missing_special":"Musí obsahovať aspoň jeden špeciálny znak (!\"#%&'()*+,-.:;/<=>?@^_`{|}~)","missing_illegal":"Nesmie obsahovať nelegálne znaky"},"html":{"name":"Invalid characters detected"},"fields":{"firstuserrole":"prvá rola používateľa","seconduserrole":"druká rola používateľa","name":"meno","unittype":"typ prístroja","logintype":"typ prihlásenia","city":"city","country":"krajina","location":"umiestnenie","legalform":"právna forma","currency":"mena","machinename":"názov zariadenia","ownerorganization":"vlastnícka organizácia","pincodedropsafe":"pin kód vhadzovacieho trezoru","pincodedropsafeconfirm":"potvrdiť kód vhadzovacieho trezoru","pincodedrawer":"pin kód zásuvky","pincodedrawerconfirm":"potvrdiť pin kód zásuvky","firstname":"krstné meno","lastname":"priezvisko","organizations":"organizácie","organization":"organizácia","userroles":"role používateľa","email":"e-mail","password":"heslo","pin":"pin","mixname":"označeni mixu","totalamount":"celková suma","maximumAmount":"maximálna suma","units":"prístroje","mixes":"mixy","overrideworkflow":"override workflow","apiKeySettings":"API key","mfaEnabled":"MFA enabled","mfaSecret":"MFA Secret","username":"Username","placeholder":"component","placeholderAction":"component action","translationNl":"dutch translation","unittypefamily":"unit type family","timeZone":"timezone","serialnumber":"serial number","transactionCashOutLimit":"transaction cash out limit","dailyCashOutLimit":"daily cash out limit"},"noworkflow":"No workflow available for selected unit type (Please create a new workflow in CIT workflow page)","positiveOnly":"Only positive number allowed","required-because":"The {field} is a required field, because {field1} is selected","maxPavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Max pavement value\"","pavementValueHigherThanInsurableValue":"Please be sure that the \"insurable value\" is higher than the \"Pavement value\"","wrongDates":"Start datetime must be before end datetime","alphaCharsOnly":"Only alphabetical characters allowed","numbersOnly":"Only numerical characters (numbers) allowed","safeId":"Must consist of 1 alphabetical character followed by 14 digits. Example: A01234567890123","unable_to_process_request":"Unable to process your request at this time. Contact your administrator or try again later."},"loading":"Načítanie...","select":"-- Výber zo zoznamu--","messages":{"check_email_for_reset_link":"Please check your email for the reset link."}},"errors":{"title":"Vyskytla sa chyba","unknown_error":"Pri pokuse o načítanie požadovaných údajov sa vyskytla neznáma chyba.<br/>Skúste znova neskôr.","could_not_load":"Napodarilo sa načítať požadované údaje.<br/>{response}","unauthorized":"Neoprávnený prístup","unauthorized_expired":"Boli ste odhlásený z dôvodu nečinnosti alebo ste sa prihlásili inde","network_down":"Vyskytla sa chyba siete. Skontrolujte sieť","back_button":"Návrat na predchádzajúcu stránku","illegal_argument_uuid":"Bol nájdený neplatný identifikátor","duplicate_entry":"Táto položka už existuje","emptycolumnidentifier":"Identifikátor stĺpca je prázdny","no_information":"Žiadne informácie","mfaResetError":"Error trying to reset QR/Secret for user"},"login":{"title":"Prihlásenie","mfaTitle":"Verification","continue":"Continue","forgotPassword":{"title":"Zabudli ste heslo!","success":"Heslo bolo úspešne obnovené!"},"mfaFlow":{"mfa_required":"MFA required","mfa_required_description":"Your organization requires you to perform MFA authentication.","mfaHelp":"Help with MFA","errorGettingSecret":"Error obtaining your secret and QR","errorGettingMfaSettings":"Error obtaining MFA settings","mfaHelpTitle":"How restore MFA pairing in case of lost Phone/Authenticator","mfaHelpInstructions":"Contact your organization and provide them:<br/><br/> Full name <br/> Phone contact <br/> <br/> They will validate the information with you, and after that enable <strong>QR/secret</strong> pairing again.You shall receive an email once is done and will be able to see QR/secre from login screen again.","mfaHelpInstructionsOtherMfa":"There are more MFA methods available connect with them. <br/> If your organization enabled self QR/Secret recovery, click on your name at top right to see the <strong>User menu</strong> and click on Reset QR/Secret, so next login you will see the QR for new pairing.","understood":"Understood","setupMfaTitle":"Setup MFA","setupMfaDescription":"Please select one MFA type and click con continue.","setupMfaSelectType":"Select type of MFA","mfaPairingTitle":"Phone app setup (one time)","mfaPairingQrImage":"QR image:","mfaPairingSecret":"MFA secret: ","mfaPairingInstructionsTitle":"Instructions for Phone app MFA setup","mfaPairingInstructionsLine1":"Download any authenticator app such as google, microsoft authenticator.","mfaPairingInstructionsLine2":"Open it and click on Add and then select QR or Key.","mfaPairingInstructionsLine3":"With QR please scan the image above and for manual input copy the MFA secret","mfaPhoneInstructionsTitle":"Instructions for Phone app MFA","mfaPhoneInstructionsLine1":"Open your Authenticator device or Smartphone and check for the code provided there.","mfaPhoneInstructionsLine2":"To pair again check MFA troubleshoot.","mfaPhoneInstructionsLine3":"If you can't use this method anymore try with other MFA method such as Email.","mfaEmailInstructionsTitle":"Instructions for Email MFA","mfaEmailInstructionsLine1":"You had received a temporal access token in your email.","mfaEmailInstructionsLine2":"The token will be valid for some minutes.","mfaValidationTitle":"Code validation","mfaValidationDescription":"Enter the code provided by your selected MFA method"},"form":{"username":"Používateľské meno","password":"Heslo","email":"E-mail","mfaCode":"Mfa Code"},"buttons":{"login":"Prihlásenie","validate":"Verify","forgotPassword":"Zabudnuté heslo","reset":"Obnoviť moje heslo","mfaResetQrSecret":"Reset MFA QR/Secret"}},"logout":{"title":"Logout","buttons":{"logout":"Odhlásenie","profile":"Profil","changepassword":"Zmeniť heslo","changepin":"Zmeniť pin","mfaResetQrSecret":"Reset MFA QR/Secret"}}},"management":{"unit":{"titles":{"overview":"Prístroje","create":"Pridať prístroj","update":"Aktualizovať prístroj","read":"Podrobnosti o prístroji","inventory":"Inventor","readsettings":"Unit settings","preview":"Unit preview"},"breadcrumb":{"title":"Prehľad"},"columns":{"no":"#","amount":"Suma","buildVersion":"Verzia","closeTime":"Čas","compartment":"Priehradka","counter":"Číslo","currency":"Mena","currentValue":"Aktuálna hodnota","date":"Dátum","dateTimeStopped":"Dátum a čas sa zastavil","description":"Popis","direction":"Smer","insurableValue":"Poistiteľná hodnota","level":"Úroveň","location":"Ĺokácia","machineName":"Názov zariadenia","machineType":"Typ zariadenia","name":"Meno","placeholder":"Komponent","placeholders":"Komponenty","reason":"Dôvod","remoteSupportId":"ID vzdialenej podpory","sales":"Predaj","serialNo":"Sériové číslo","source":"Zdroj","status":"Stav","teamviewerId":"Teamviewer ID","total":"Celková hodnota","transactionNumber":"Číslo","type":"Typ","unitIpAddress":"IP adresa","unitMacAddress":"MAC address","unitStatus":"Stav prístroja","userAccountName":"Používateľ","userLoginName":"Používateľ","value":"Hodnota","valueIn":"Do","valueOut":"Z","valueProcessed":"Hodnota","vpnIpAddress":"VPN IP adresa","message":"Message"},"form":{"machineName":"Názov zariadenia","location":"Lokácia","organizations":"Organizácie","ownerOrganization":"Organizácia vlastníka","supportMultipleClient":"Podpora viacerých klientov","clientOrganizations":"Organizácie klientov","inheritedCIT":"Pôvodná CIT","inheritedMaintenance":"Pôvodný servis","overrideCIT":"Zmenaná CIT","overrideMaintenance":"Zmenený servis","overrideWorkflow":"Zmenený proces","unitType":"Typ zariadenia","serialNo":"Sériové číslo","currency":"Mena","endOfDayTime":"Čas uzávierky","hours":"Hodiny","minutes":"Minúty","alarmOn":"PoplachÂ zapnutý","alarmValuePerDay":"Hodnota alarmu za deň","alarmOnMonday":"Pondelok","alarmOnTuesday":"Utorok","alarmOnWednesday":"Streda","alarmOnThursday":"Štvrtok","alarmOnFriday":"Piatok","alarmOnSaturday":"Sobota","alarmOnSunday":"Nedeľa","maximumAmount":"Maximálne množstvo mincí / bankoviek na kazetu","insurableValue":"Poistiteľná hodnota","offlineTimeout":"Časový limit offline","pincodeDrawer":"Zásuvka na PIN kód","sideSafe":"Má bočný tezor","advancedManualDeposit":"Povoliť  AMD","drawer":"Má zásuvku","pincodeDropsafe":"Zásuvka na PIN kód","pincodeDrawerConfirm":"Potvrdte zásuvku na PIN kód","pincodeDropsafeConfirm":"Potvrdte zásuvku na bočný trezor","overrideSettings":"Zmena pôvodného nastavenia","apiKey":"API key","unitTypeFamily":"Unit type family","safeId":"Safe ID","maxPavementWarningPercentage":"Alarm on","departments":"Departments","coinDistribution":"Management"},"toolTip":{"machineName":"Názov zariadenia","location":"Adresa, na ktorej má byť zariedenie umiestnené, musí by zadaná pred vytvorením jednotky","organizations":"Organizácie","ownerOrganization":"Organizácia, ktorá manažuje zariadenie","supportMultipleClient":"Nechajte zariadenie používať viacerým organizáciam","clientOrganizations":"Organizácie, ktoré môžu deponovať do zariadenia","inheritedCIT":"CiT organizácia, ktorá je pôvodnou od organizácie vlastníkov","inheritedMaintenance":"Organizácia servisu, ktorá je pôvodnou od organizácie vlastníkov","overrideCIT":"Použiť inú CIT ako tú, ktorá bola pôvodná pre organizáciu vlastníka","overrideMaintenance":"Použiť inú organizáciu servisu ako tú, ktorá bola pôvodná pre organizáciu vlastníka","overrideWorkflow":"použiť iný postup CIT ako ten,   ktorý bol pôvodný pre organizáciu vlastnika","unitType":"O aký typ zariadenia sa jedná. Na základe toho je možné určiť technické parametre, z ktorých sa zariadenie skladá. Toto pole nie je možné upraviť.","serialNo":"Sériové číslo v systém Lincsafe je uvedené na štítku na trezore. Pri prvom pripojení jednotky k portálu použite tento kód na pripojenie.","currency":"Akú menu môže zariadenie používať","endOfDayTime":"Čas, ktorý sa používa pre hlásenie o uzávierke dňa, môže byť využívaný pre obchody, ktoré zatvárajú po dvanáctej hodine.","hours":"Hodiny","minutes":"Minúty","alarmOn":"Pošle e-mail, keď je prístroj takmer plný. Odošle sa, keď dosiahne zadané percento poistiteľnej hodnoty. Subskripcie je možné zmeniť kliknutím na symbol hodín vedľa organizácie na stránke prehľadu organizácií","alarmValuePerDay":"Pošle e-mail, keď je prístroj takmer plný. Odošle sa, keď sa dosiahne zadané percento pre daný deň. Subskripcie je možné zmeniť kliknutím na symbol hodín vedľa organizácie na stránke prehľadu organizácií","alarmOnMonday":"Pondelok","alarmOnTuesday":"Utorok","alarmOnWednesday":"Streda","alarmOnThursday":"Štvrtok","alarmOnFriday":"Piatok","alarmOnSaturday":"Sobota","alarmOnSunday":"Nedeľa","maximumAmount":"Maximálne množstvo bankoviek / mincí, ktoré sa fyzicky zmestia do priehradky.","insurableValue":"Maximálna hodnota peňazí v zariadení, ktorá je krytá poistením. Používa sa na zistenie, či je jednotka plná a mala by sa vyprázdniť.","offlineTimeout":"Čas pre vyhlásením Offline web portálu, za ktorý ma byť doručená pulzná správa.","pincodeDrawer":"PIN kód, ktorý je potrebné zadať do zariadenia na otvorenie zásuvky","sideSafe":"Zariadenie má bočný trezor, do ktorého je možné vkladať napríklad poukazy / stravenky","advancedManualDeposit":"Povoliť pokročilý manuálny vklad: bočný trezor je možné použiť na oficiálne peňažné vklady, ktoré môže vyzdvihnúť CIT","drawer":"Zariadenie má zásuvku, ktorú je možné použiť na odstránenie zaseknutých bankoviek / mincí","pincodeDropsafe":"PIN kód, ktorý je potrebné zadať do stroja na otvorenie bočného trezoru","pincodeDrawerConfirm":"Potvrdte PIN kód pre zásuvku","pincodeDropsafeConfirm":"Potvrdte PIN kód pre bočný trezor","overrideSettings":"Zmeňte nastavenia pre toto zariadenie tak, aby boli odlišné od predvolených nastavení pre túto organizáciu","unitTypeFamily":"The family of unit types","maxPavementWarningPercentage":"A warning will pop up on the machine screen, telling the managers/CIT that the bag will be full soon. The user will be informed when it has reached the entered percentage of the max pavement value.","safeId":"Optional, custom, unique, 15 character identifier for this unit","overrideBankAccount":"Do not inherit primary bank account from Location. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Location. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Location. Instead, define a new one specific to this unit","coinDistribution":"Twin coin system distribution setting management in percentage"},"softwaresettings":{"1":"Voľná platba ","2":"Od najvyššej po najnižšiu","listUserByOrganization":"Zoznam používateľov podľa organizácie","listUserByUsername":"Zoznam používateľov podľa používateľského mena","xmlExportName":"XML export","useReferenceNumber":"Číslo strany (nepoužívajte toto nastavenie, iba pre staré verzie)","referenceNumberLength":"Dĺžka referenčného čísla","unitBarcodeTypeOnFirstCitPage":"Display Barcode of Unit Name (CIT Screen)","currencyCode":"Mena","hopper1Value":"Hodnota násypky 1","hopper2Value":"Hodnota násypky  2","numberOfCoins":"Počet mincí","beepOnBillRejected":"Pípnutie po odmietnutí bankovky","transactionPerBill":"Transakcia po bankovkách","loginRequiredTransaction":"Transakcia vyžaduje prihlásenie","buzzerTimeout":"Časový limit bzučiaka","enableOTC":"povoliť  OTC","heartbeatRate":"Frekvencia pulzov","downloadRate":"Rýchlosť sťahovania","safeStatusRate":"Rozsah stavu trezora","inventorySettings":"Nastavenie Inventora","payableValue":"Splatná hodnota","floatValue":"Hodnota preplnenia","floatSettings":"Nastavenie preplnenia","payOutMethod":"Metóda výplaty","round":"Zaokrúhlená hodnota","payOutLimit":"Limit výplaty","language":"Jazyk","bins":"Bankové ID","ecrId":"Pin Terminal Id","ecrUrl":"Payplaza URL","g4sApiUrl":"Authorizované URL banky","employeeSelection":"Výber pracovníka","supportedLanguages":"Podporované jazyky","showDeviceTotal":"Zobraziť celkový počet zariadení","showExtraButtonOnUserSelectScreen":"Show extra user select button","pavementLimit":"Základný Limit","communicationRate":"Komunikačná rýchlosť","depositTimeout":"Časový limit nečinnosti v sekundách","normalDepositReceipts":"Počet potvrdeniek o vklade","manualDepositReceipts":"Počet potvrdeniek o vklade ručne","showDenominationDetailsOnDepositPrint":"Zobraziť nominálnu hodnotu pri vklade","showUserTotals":"Show user totals function","showDailyReports":"Show daily reports function","manualEndOfDay":"Manual end of day","textLanguage":"Text language selection","dateFormat":"Date format","MMddyyyy":"United States (12/31/2000)","dd-MM-yyyy":"International (31-12-2000)","MMMddyyyy":"US Global (Dec 31 2000)","ddMMMyyyy":"Alternate International (31 Dec 2000)","yyyy-MM-dd":"Year-Month-Day (2000-12-31)","screenSaver":"Šetrič obrazovky","preTransactionTask":"Zobraziť referenčné číslo","noTask":"Nie","refNr":"Zobraziť stránku s referenčným číslom","low":"Nízka","medium":"Stredná","high":"Vysoká","high_low_medium":"Vlastné 1","Low":"Nízka","Medium":"Stredná","High":"Vysoká","namelist":"Zoznam mien","empnr":"Zadajte číslo zamestnanca","hasPrinterAttached":"Zobraziť upozornenia tlačiarne","en":"Angličtina","nl":"Holančtina","fr":"Francúzština","hu":"Maďarčina","sk":"Slovenský","pl":"Poľský","EUR":"EUR","TR":"TR","USD":"USD","noExport":"žiaden export","MLSA":"OCS export","puloonCassette1":"Puloon kazeta 1","puloonCassette2":"Puloon kazeta 2","puloonCassette3":"Puloon kazeta 3","puloonCassette4":"Puloon kazeta 4","EUR-5":"5 €‚¬","EUR-10":"10 €‚¬","EUR-20":"20 €‚¬","EUR-50":"50 €‚¬","EUR-100":"100 €‚¬","EUR-200":"200 €‚¬","EUR-500":"500 €‚¬","puloonCassette1FixedAmount":"Puloon kazeta 1 fixná hodnota","puloonCassette2FixedAmount":"Puloon kazeta 2 fixná hodnota","puloonCassette3FixedAmount":"Puloon kazeta 3 fixná hodnota","puloonCassette4FixedAmount":"Puloon kazeta 4 fixná hodnota","inventoryCheckOnPayment":"Skontrolovať Invetor pri platbe","tariffs":"Tarify","ledLightColor":"Farba svetla LED","yellow":"Žltá","red":"Červená","green":"Zelená","blue":"Modrá","magenta":"Purpurová","cyan":"Tyrkysový","white":"Biely","posMode":"POS mode","none":"None","barcode_itf":"Barcode ITF","qrcode":"QR Code","inventorypanel":{"denomination":"Nominál","material":"Materiál","recycled":"Recyklovaný","min":"Min","optimum":"Optimum","max":"Max","value":"Hodnota","numberOfRecyclers":"Recycler count","low":"Low","COIN":"Coin","BILL":"Bill","ROLL":"Roll","maxDispensable":"Max dispensable","messages":{"recyclerStatusInfo":"{totalRecyclers} of {maxNumberOfRecyclers} recyclers are used","recyclerStatusError":"Error: Exceed the max recycler count ({maxNumberOfRecyclers}); claimed: {totalRecyclers}","excideMaximumDrawer":"Max drawer dispensable limit is {limit}","excideMaximumCup":"Max cup dispensable limit is {limit}"},"high":"High"},"tariffspanel":{"transaction_fee":"Poplatok za transakciu","value_fee":"Poplatok za rolku"},"minimumOrderPanel":{"min":"Min (1)","max":"Max (200)"},"minimumOrderCoinRollsSettings":"Min and max coin rolls order amounts","billMaxAmount":"Maximum amount threshold for bills","coinMaxAmount":"Maximum amount coins overflow","om61InventorySettings":"OM61 inventory settings","charities":"Charities","authApiKey":"Authorization API Key","acceptablesSetting":"Enabled denominations","minimumOrderRolls":"Minimal roll order amount","inventoryOptimumReset":"Inventory float down time","escrowEmptyAmount":"Escrow empty amount","maxBagValue":"Max pavement value","timeSelector":{"enabled":"Enabled"},"apiKeySettings":"API key","useDefaultValue":"Use default value","allowManagerEmptyAllRecyclers":"Allow manager to empty all recylers","managerUnlockDelay":"Delay time to unlock safe doors","managerUnlockStartTime":"Unlock start time","managerUnlockEndTime":"Unlock end time","localPinChange":"Change user pin on unit","customXmlHeader":"Custom XML Header","coinDistribution":"Twin coin system distribution setting","puloonRejectBinMaxAmount":"Maximum amount of notes that puloon reject bin can handle","puloonRejectBinWarningPercentage":"Puloon reject bin full capacity warning (percentage)","autoFloatDownWhenSystemIsIdle":"Auto float down","tillRestrictions":"Restricted tills","maxPavementWarningPercentage":"Max pavement value alarm","g4sCertificate":"G4S Certificate","payplazaCertificate":"Payplaza Certificate","storageVault":"Storage vault","userManagement":"User management"},"actions":{"create":"Pridať prístroj","read":"Načítať prístroj","update":"Aktualizovať prístroj","delete":"Vymazať prístroj","filter":"Filtrovať prístroje na stav","readsettings":"Read unit settings","preview":"Unit preview"},"messages":{"added":"Prístroj {name} je pridaný","updated":"Prístroj {name} je aktualizovaný"},"read":{"tabs":{"detail":"Detaily","specifications":"Technické špecifikácie","status":"Status","users":"Používatelia","sales":"Predaj","internal":"Interne","mixes":"Mixy","citLegacy":"Legacy","citDynamic":"Dynamic","citStatic":"Static"},"summary":{"maximumAmount":"Maximum mincí/bankoviek na kazetu","machineName":"Názov stroja","insurableValue":"Poistiteľná hodnota","currentValue":"Aktuálna hodnota","currentDepositValue":"Aktuálna uložená hodnota","unitModelName":"Typ prístroja","location":"Lokácia","placeholders":"Komponenty","lastTransactionDate":"Dátum poslednej transakcie","currency":"Mena","currentStatus":"Aktuálny stav","networkStatus":"Stav siete","lastClearBox":"Posledný výber","yesterdayTurnover":"Včerajší obrat","lastClearBoxDate":"Dátum posledného výberu","fillGrade":"Úroveň naplnenia","numberOfTransactions":"Číslo transakcií","name":"Meno","addressLine1":"Adresa","city":"Mesto","unitFillStatus":"Dosiahnutý limit","ALMOST_FULL":"SKORO PLNÉ","FULL":"PLNÉ","NORMAL":"NORMÁL","null":"nula","unitTypeFamily":"Unit type family"},"titles":{"unitStatus":"Stav prístroja","unitDetail":"Detai prístroja","unitDetails":"Detaily prístrojov","location":"Podrobnosti o lokácii","lastTransactions":"Posledné transakcie","campaignsUnit":"Výbery prístroja","lastClearBoxes":"Posledný výber","component":"Technické špecifikácie","eventsByUnit":"Udalosti","lastEvents":"Posledná udalosť","hardwareStatus":"Hardware: ","networkStatus":"Sieť: ","notifications":"Notifikácie","departments":"Department details"},"status":{"ALMOST_EMPTY":"Potrebné naplniť","ALMOST_FULL":"Potrebné vybrať","DEBUG":"Debug","EMPTY":"Potrebné naplniť","ERROR":"Chyba","FATAL":"Fatal","FULL":"Potrebné vybrať","INFO":"Info","INVENTORY_NOT_SUFFICIENT":"Potrebné naplniť","INVENTORY_OVER_MAXIMUM":"Potrebné vyprázdniť","INVENTORY_UNDER_MIN":"Potrebné naplniť","JAMMED":"Odstrániť zásek","NOT_CONNECTED":"Skontrolovať pripojenie k zariadeniu","NOT_SECURE":"Odomknite dvierka, zatvorte a znova uzamknite","OFFLINE":"Prístroj je offline","OK":"OK","OPEN":"Zatvorte dvierka","OVERRIDDEN":"Pomocou Ponuky/Menu odomknite a znova zamknite dvierka","RECYCLER_ALMOST_EMPTY":"Naplnte recyklátor","RECYCLER_ALMOST_FULL":"Odstránte časť materiálu z recyklátoru","RECYCLER_EMPTY":"Naplnte recyklátor","RECYCLER_FULL":"Odstránte časť materiálu z recyklátoru","STACKER_FULL":"Odoberte bankovky z výdajného zásobníka","STORAGE_ALMOST_FULL":"Vyberte úložisko","STORAGE_DETACHED":"Doplnte úložisko","STORAGE_FULL":"Vyberte úložisko","TRACE":"Trace","UNLOCKED":"Zamknite dierka","WARN":"Varovanie","WARNING":"varovanie","INVENTORY_UNDER_LOW":"Needs to be filled"},"techSpec":{"ACCEPTING":"Akceptované","ALMOST_EMPTY":"Skoro prázdne","ALMOST_FULL":"Skoro plné","BAG_OPEN":"Bag Open","CALIBRATING":"Kalibrácia","CASSETTE_ERROR":"Cassette Error","CASSETTE_ATTACHED":"Pripojená kazeta","CASSETTE_DETACHED":"Odpojená kazeta","CARTRIDGE_DETACHED":"Zásobník odpojený","CLOSED":"Zatvorené","CONNECTED":"Pripojené","DOOR_CLOSED":"Dvierka zatvorené","DOOR_OPEN":"Dierka otvorené","DOOR_LOCKED":"Dierka zamknuté","DOOR_UNLOCKED":"Dvierka odomknuté","DOWNLOADING":"Downloading","EMPTY":"Prázdny","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Vstup nie je prázdny","EXTENSION_STALL":"Poškodený","FEED_FAILURE":"Podávač poškodený","FULL":"Plný","INVENTORY_NOT_SUFFICIENT":"Inventor nie je dostatočný","INVENTORY_OVER_MAXIMUM":"Inventor nad maximom","INVENTORY_UNDER_MIN":"Inventor pod minimom","JAM_CLEARED":"Zásek odstránený","JAMMED":"Zaseknutý","LOCKED":"Zablokovaný","LOCKS_SECURE":"Locks Secure","NOT_ACCEPTING":"Neprijíma","NOT_CONNECTED":"Nepripojený","NOT_FOUND":"Konfigurácia sa nenašla","NOT_OVERRIDDEN":"neprepísané","NOT_OPERATIONAL":"Mimo prevádzky","NOT_SECURE":"Nezabezpečené","OFFLINE":"OFFLINE","ONLINE":"ONLINE","NETWORK_DISCONNECTED":"Netwerk verbroken","NETWORK_RESTORED":"Netwerk hersteld","OK":"OK","OPEN":"Otvorené","OVERRIDDEN":"Prepísané","PAUSE":"Pauza","POWER_UP":"Zapnúť","RECYCLER_ALMOST_EMPTY":"RECYKLÁTOR skoro prázdny","RECYCLER_ALMOST_FULL":"RECYKLÁTOR skoro plný","RECYCLER_EMPTY":"RECYKLÁTOR prázdny","RECYCLER_FULL":"RECYKLÁTOR plný","REJECT_NOT_EMPTY":"Reject is not empty","OUTPUT_NOT_EMPTY":"Output is not empty","SAFE_DOOR_OPEN":"Safe door open","SECURE":"Zabezpečené","SIDE_SAFE_ONE_LOCKED":"Bočný trezor 1 uzamknutý","SIDE_SAFE_ONE_UNLOCKED":"Bočný trezor neuzamknutý","STACKER_FULL":"Výdajný zásobník plný","STALLED":"Preťažený","STORAGE_ALMOST_FULL":"Úložisko skoro plné","STORAGE_INVENTORY":"Storage inventory","STORAGE_ATTACHED":"Úložisko pripojené","STORAGE_DETACHED":"Úložisko odpojené","STORAGE_FULL":"Úložisko plné","TOP_DOOR_CLOSED":"Horné dvierka zatvorené","TOP_DOOR_OPEN":"Horné dvierka otvorené","UNLOCKED":"Odokmnuté","FAILED":"Failed","INVENTORY_UNDER_LOW":"Inventory under low","STORAGE_ALMOST_FULL_CLEARED":"Storage Almost Full Cleared","STORAGE_ALMOST_EMPTY_005":"Coin Roll storage almost empty for 5 cents","STORAGE_ALMOST_EMPTY_010":"Coin Roll storage almost empty for 10 cents","STORAGE_ALMOST_EMPTY_020":"Coin Roll storage almost empty for 20 cents","STORAGE_ALMOST_EMPTY_050":"Coin Roll storage almost empty for 50 cents","STORAGE_ALMOST_EMPTY_100":"Coin Roll storage almost empty for 2 euro","STORAGE_ALMOST_EMPTY_200":"Coin Roll storage almost empty for 2 euro"}},"inventory":{"unitInventory":"Inventor prístroja","noTransactions":"Žiadne transakcie","noTransactionsDesc":"Neboli nájdené žiadne transakcie, skúste neskôr!","items":"Položky","total":"Celkom ","cassette":"Kazeta"},"campaign":{"read":"Posledný výber","columns":{"no":"#","group":"Skupina","placeholder":"Komponent","dateTimeStopped":"Dátum a čas bol zastavený","userAccountName":"Používateľ","insertedValue":"Inserted","valueProcessed":"Collected","totalValueProcessed":"Celkovo spracovaná hodnota"}}},"softwaresettings":{"titles":{"overview":"Nastavenia SW","create":"Pridať nastavenia SW","update":"Aktualizovať nastavenie SW","readsettings":"Read software settings"},"breadcrumb":{"title":"Mena"},"actions":{"create":"Pridať nastavenie SW","read":"Načítať nastavenie SW","update":"Aktualizovať nastavenie SW","delete":"Vymazať nastavenie SW","readsettings":"Read software settings"},"columns":{"ownerOrganization":"Organizácia vlastníka","unitType":"Typ prístroja"},"messages":{"added":"Boli pridané nové nastavenia","updated":"Nastavenia boli aktualizované"},"form":{"ownerOrganization":"Organizácia vlastníka","unitType":"Typ prístroja","overrideSettings":"Prepísať predvolené nastavenie","selectOverrideSettings":"Vybrať nastavenia, ktoré chcete prepísať a používať","checkAll":"Skontrolovať všetko","cassettesAssignment":"Cassettes Assignment"},"toolTip":{"hasPrinterAttached":"Používať, iba ak je pripojená tlačiareň","listUserByOrganization":"Zoznam zamestnancov, ak prístroj podporuje viacerých klientov","listUserByUsername":"Zoznam zamestnancov podľa používateľského mena, inak zoznam podľa čísla zamestnanca","xmlExportName":"Používa sa, ak je potrebný export .xlm tretích strán","useReferenceNumber":"Nastavenie vkladu iba pre staré verzie","referenceNumberLength":"Dĺžka referenčného čísla","currencyCode":"Mena pre zásobníky NS Wisselaar","hopper1Value":"Hodnota NS Wisselaar zásobník1","hopper2Value":"Hodnota NS Wisselaar zásobník2","numberOfCoins":"Množstvo mincí v násypníku NS Wisselaa","beepOnBillRejected":"Pípnutie pri vrátení bankovky","transactionPerBill":"Akceptor bankolviek akceptuje len jednu bankovku na transakciu","loginRequiredTransaction":"Na prijatie nového vkladu sa vyžaduje prihlásenie","buzzerTimeout":"Trvanie časového limitu na bzučiak pípania","enableOTC":"Používa sa povolenie OTC režimu pre inteligentný zámok","heartbeatRate":"Frekvencia odosielania kontrólneho signálu z prístroja na portál","downloadRate":"Frekvencia sťahovania konfiguračných súborov z portálu na prístroj","safeStatusRate":"Frekvencia odosielania stavu zabezpečenia z prístroja na portál","inventorySettings":"Nastavenia Inventora pre Lincstation, ktoré pozostávajú z potrebných materiálov, recyklovaných materiálov, minimálnych, priebežných a maximálnych úrovní nominálnych hodnôt","payableValue":"Minimálna hodnota na kontorlu recyklačného zásobníka, nezávisle, či je Lincstation pripravený na platbu alebo nie.","floatValue":"Denná počiatočná hodnota Lincstation","payOutMethod":"Režim vyplaty pre inteligentný mincový systém v Lincstation","round":"Používa sa na zaokrúhlenie zadanej platby v Lincstation","payOutLimit":"Limit pre výplatu z Lincstation","language":"Aktívne vybraný jazyk v zariadení","bins":"Zoznam podporovaných bankových ID  pre každú banku","ecrId":"ID terminálu pripojehého k prístroju","ecrUrl":"Koncový bod používaný pre vykonávanie platieb a iných transakcií kartou","g4sApiUrl":"Koncový bod používaný pre autorizáciu kariet","employeeSelection":"Vyhľadávanie zamestnancov zadaním čísla zamestnanca alebo zobrazenie zamestnancov zobrazených v zozname","supportedLanguages":"Podporované jazyky podľa zariadenia","showDeviceTotal":"Používa sa na zobrazenie celkovej hodnoty a nominálnej hodnoty zariadenia v ponuke manager","showExtraButtonOnUserSelectScreen":"When enabled, this causes a 5th user select button to appear on the user select screen","pavementLimit":"Základný limit na kazetu","communicationRate":"Frekvencia komunikácie medzi jednotkou a portálom. Toto nastavenie riadi frekvenciu sťahovania kontrólneho signálu. Pre možnosti \"Vysoká\", \"Stredná\" and \"Nízka\" sú obe frekvencie nastavené na túto úroveň. Pre voľbu \"Vlastné 1\" download je frekvencia sťahovania nízka a frekvencia kontrólneho signálu vysoká.","depositTimeout":"Trvanie časového limitu pre obrazovku vkladu","normalDepositReceipts":"Číslo dokladu, ktorý sa má vytlačiť pop bežnom vklade","manualDepositReceipts":"Číslo  dokladu na tlač po manuálnom vklade","showDenominationDetailsOnDepositPrint":"Zobraz nominálne hodnoty pri tlači vkladu","showUserTotals":"Show user totals function in settings screen","showDailyReports":"Show daily reports function in management screen","manualEndOfDay":"End of day will be manually performed by a manager (This setting disables the automatic end of day feature)","textLanguage":"Use text language selection screen (instead of flags)","dateFormat":"The date format displayed on receipts and screen","preTransactionTask":"Používa sa na zobrazenie podrobností o nominálnych hodnotách každej transakcie na potvrdení o vklade","screenSaver":"Zobraziť šetrič obrazovky aj je zariadenie nečinné","puloonCassette1":"Nominálna hodnota pre kazetu 1","puloonCassette2":"Nominálna hodnota pre kazetu 2","puloonCassette3":"Nominálna hodnota pre kazetu 3","puloonCassette4":"Nominálna hodnota pre kazetu 4","puloonCassette1FixedAmount":"Fixné množstvo bankoviek pre kazetu 1","puloonCassette2FixedAmount":"Fixné množstvo bankoviek pre kazetu 2","puloonCassette3FixedAmount":"Fixné množstvo bankoviek pre kazetu 3","puloonCassette4FixedAmount":"Fixné množstvo bankoviek pre kazetu 4","inventoryCheckOnPayment":"Skontroluje, či je možné vloženú sumu vydať počas platby","ledLightColor":"Farba svetla LED","posMode":"Point of sale mode limits machine functionality by disabling some buttons","coinMaxAmount":"Maximum amount of coins in the overflow. A warning will be generated at 80% of this value.","billMaxAmount":"Maximum amount threshold for bills in Lincstation","charities":"Charity organizations data","escrowEmptyAmount":"Minimum amount for escrow to be emptied","maxBagValue":"Maximum value for the bag","inventoryOptimumReset":"The time when the inventory of the machine will reset back to optimum values based on the inventory settings","apiKeySettings":"API key for the connector","allowManagerEmptyAllRecyclers":"Enables the manager to dispense all available notes and coins locally on the unit","managerUnlockDelay":"Manager delay for opening tills and coin drawer","localPinChange":"Able to change user pin code on unit","customXmlHeader":"Set custom XML data needed for integration","puloonRejectBinMaxAmount":"Puloon reject bin maximum notes capacity","puloonRejectBinWarningPercentage":"Warning level set in percentage for Puloon reject bin. This functionality is disabled if 0 is set","unitBarcodeTypeOnFirstCitPage":"Enables unit name to be shown as a barcode on device display at the start of CIT flow","autoFloatDownWhenSystemIsIdle":"Auto float down if no active transaction and recycler is full","g4sCertificate":"Certificate for software management","payplazaCertificate":"Certificate for software management","managerUnlockStartTime":"Unlock start time","managerUnlockEndTime":"Unlock end time","tillRestrictions":"When selected, tills are only allowed to be dispensed once. They will become available again after the till is deposited back into the machine. When deselected, tills can be used multiple times.","storageVault":"Enable additional storage vault","userManagement":"Enable user management","authApiKey":"Authorization API Key"},"billsDenominationTable":{"yes":"YES","no":"NO","columns":{"cassettes":"Cassettes","recycler":"Recycler","denomination":"Denomination","currency":"Currency","optimum":"Optimum","max":"Max"}}},"user":{"titles":{"overview":"Používatelia","create":"Pridať používateľa","update":"Aktualizovať používateľa","changepassword":"Zmeniť heslo","changepincodes":"Zmeniť pinkód","updateprofile":"Aktualizovať profil","forgotpassword":"Zabudnuté heslo","resetpassword":"Obnoviť heslo","readsettings":"User settings"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Meno","organization":"Organizácia","email":"E-mail","roles":"Rola používateľa"},"form":{"firstName":"Krstné meno","lastName":"Priezvisko","rfid":"RFID / Dallas Key","employeeNumber":"Číslo zamestnanca","organization":"Organizácia","roles":"Rele používateľa","email":"E-mail","password":"heslo","externalUsername":"External Username","externalPassword":"External Password","passwordConfirm":"Potvrdiť heslo","sendTemporaryPassword":"Poslať dočasné heslo","pin":"Pin","pinConfirm":"potvrdiť pin","openDropsafeWithPin":"Otvoriť vhadzovací trezor pomocou pin","openDrawerWithPin":"Otvoriť driver pomocou pin","units":"Prístroje","oldPassword":"Staré heslo","newPassword":"Nové heslo","confirmPassword":"Potvrdiť nové heslo","oldPin":"Starý pin","newPin":"Nový pin","tills":"Pokladnice","mixes":"Mixy","dailyDispenseLimit":"Denný limit výdaja","dailyPayoutLimit":"Daily payout limit","mfaEnabled":"Enable multi-factor authentication","generate":"Generate","copied":"Copied","secretkey":"Secret key","useExternalRoles":"Use external roles","unitRoles":"Unit role","storageVaultAccess":"Storage vault access","departments":"Departments"},"actions":{"create":"Pridať používateľa","read":"Načítať používateľa","update":"Aktualizovať používateľa","delete":"Vymazať používateľa","unlock":"odomknúť používateľa","readsettings":"Read user settings"},"messages":{"added":"Používateľ {name} je pridaný","updated":"Používateľ {name} je aktualizovaný","changedpassword":"Heslo je aktualizované","changedpin":"Pin je aktualizovaný","updateprofile":"Profil je aktualizovaný","qrSecretReset":"The QR/secret has been reset correctly"},"toolTip":{"mfaEnabled":"Enable multi-factor authentication","copySecret":"Copy secret text","useExternalRoles":"Use external roles"}},"location":{"titles":{"overview":"Lokácie","create":"Pridať lokáciu","update":"Aktualizovať lokáciu","readsettings":"Location settings"},"breadcrumb":{"title":"Overview"},"columns":{"city":"Mesto","name":"meno","addressLine":"Adresa"},"form":{"name":"Meno","city":"Mesto","addressLine1":"Adresa","addressLine2":"Adresa","postalCode":"Poštové smerovacie číslo","country":"Krajina","phoneNumber":"Telefónne číslor","email":"E-mail","organization":"Organization","state":"State/Province","timeZone":"Timezone","departments":"Departments"},"actions":{"create":"Pridať lokáciu","read":"Načítať lokáciu","update":"Aktualizovať lokáciu","delete":"Vymazať lokáciu","readsettings":"Read location settings"},"messages":{"added":"Lokácia {name} je pridaná","updated":"Lokácia {name} je aktualizovaná"},"toolTip":{"organization":"Organization to which this location belongs to","timeZone":"Machine time will be set up according to the timezone.","overrideBankAccount":"Do not inherit primary bank account from Organization. Instead, define a new one specific to this unit","overrideCitAccount":"Do not inherit CIT bank account from Organization. Instead, define a new one specific to this unit","overrideAffiliateCode":"Do not inherit affiliate code from Organization. Instead, define a new one specific to this unit"}},"organization":{"titles":{"overview":"Organizácie","create":"Pridať organizáciu","jobs":"Pracoviská organizácie","update":"Aktualizovať organizáciu","readsettings":"Organization settings","mfaTypes":"MFA types"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Meno","location":"Lokácie","parentOrganization":"Materská organizácia","organizationType":"Typ organizácie"},"form":{"dayTotalJob":"Za celý deň","mailSendingTime":"Čas odosielania mailu","enabled":"Povolené","remainingUsers":"Zvyšní používatelia","subscribers":"Subskribcie","affectedUnits":"Aktivované prístroje","name":"Meno","ipWhiteList":"IP white list","pin":"Pin","organizationType":"Typ organizácie","parentOrganization":"Materská organizácia","inheritedCIT":"Materský CIT","inheritedMaintenance":"Materská servis","overrideCIT":"Prepísať  CIT","overrideMaintenance":"Prepísať servis ","defaultCIT":"Predvolená CIT","defaultMaintenance":"Predvolený servis","reportedOrganizations":"Reportované organizácie","location":"Lokácia","legalForm":"Právna forma","remark":"Poznámka","forceMfaForUsers":"Force MFA auth for users","enableUserMfaSecretReset":"Allow users to reset their QR/Secret","enableAuthdeviceMfa":"Phone/Authenticator device MFA","enableEmailMfa":"Email MFA","enableSmsMfa":"SMS MFA","workflows":"Procesy","forceEmployeePin":"zamestnanci požadujúci PIN","userPincodeSeverity":"User pincode severity","ibutton":{"overview":"iButton keys overview","noData":"There are no iButton keys to show","add":"Add iButton key","uploadCSV":"Upload CSV","name":"iButton Key","removeAll":"Remove all iButton keys","removeAllConfirmationText":"Are you sure that you want to delete all ibuttons?","remove":"Remove","cancel":"Cancel","delete":"Delete","ok":"OK","invalidCSVfile":"Please upload a valid CSV file.","uploadInfo":"Upload is finished.","uploadDescription":"It seems that some keys weren't inserted because they didn't meet the required criteria.","uploadCSVInfo":"Only valid ibutton key names will be uploaded.","invalidButtonName":"Validation failed! iButton key name must be exactly 16 hexadecimal characters and should not be a duplicate.","search":"Type to search ibutton key"}},"actions":{"create":"Pridať organizáciu","read":"Načítať organizáciu","update":"Aktualizovať organizáciu","delete":"Vymazať organizáciu","readsettings":"Read organization settings"},"messages":{"added":"Organizácia {name} je pridaná","updated":"Organizácia {name} je aktualizovaná","selectOneMfaOption":"Select at least one MFA option"},"toolTip":{"dayTotalJob":"Za celý deň","mailSendingTime":"Čas odosielania mailu","enabled":"Povelený","remainingUsers":"Zvyšní používatelia","subscribers":"Sunskribcie","affectedUnits":"Aktivované prístroje","name":"Meno organizácie","ipWhiteList":"IP adresy, ktoré môžu komunikovať s jednotkami (momentálne sa nepoužívajú)","pin":"PIN kód organizácie (momentálne sa nepoužíva)","organizationType":"Typ organizácie. Cash in Cransit (CIT): pre organizácie, ktoré vyberajú peniaze z prístrojov. Všeobecné: používa sa to pre väčšinu organizácií. Servis: pre organizácie, ktoré vykonávajú údržbu a servis prístrojov. Reportované skupiny: pre organizácie, ktoré musia vidieť reporty správ organizácií na rôznych miestach v členení organizácie","parentOrganization":"Organizácia nad touto organizačnou štruktúrou. Správcovia nadradenej organizácie môžu vidieť aktuálnu organizáciu a jej prístroje na portáli. Aktuálna organizácia môže prevziať organizáciu servisu a CIT od svojej nadradenej organizácie. Ak neexistuje žiadna nadradená organizácia, je potrebné pre súčasnú organizáciu vytvoriť CIT a organizáciu servisu.","inheritedCIT":"CIT , ktorá je prevzaná od materskej organizácie","inheritedMaintenance":"Servisná organizácia, ktorá je zdedená od materskej organizácie","overrideCIT":"Použitie inej CIT ako tej, ktorá je prevzatá od nadradenej organizácie","overrideMaintenance":"Použitie inej servisnej organizácie ako tej, ktorá je prevzatá od nadradenej organizácie","defaultCIT":"Aby táto organizácia CIT bola automaticky použitá prístrojmi  a pod-organizáciami","defaultMaintenance":"Aby táto servisná  organizácia bola automaticky použitá prístrojmi  a pod-organizáciami","reportedOrganizations":"Organizácie, ktorých členovia majú povolené vidieť reporty súčasnej organizácie","location":"Adresa tejto organizácie (je potrebné ju vytvoriť pred vytvorením organizácie)","forceMfaForUsers":"Enable this option to force multifactor authentication for all users when they log in to the portal.","enableAuthdeviceMfa":"Enable authenticator device and phone apps as user MFA option","enableEmailMfa":"Enable Email as user MFA option","enableSmsMfa":"Enable SMS as user MFA option","enableUserMfaSecretReset":"Allow users to reset theirselves their QR/Secret from user menu if more than one MFA mode is enabled","remark":"Pre túto organizáciu zriadené ziskové centrum","workflows":"Procesy prepravy hotovosti, ktoré sa použijú v prístrojoch danej organizácie organizáciou CIT","forceEmployeePin":"Vytvoriť požadovaný kód PIN pre všetkých zamestnancov tejto organizácie a podorganizácií"},"notifications":{"titles":{"notifications":"Notifications","notificationType":"Notification Type"},"types":{"UNIT_OFFLINE":"Unit Offline"},"form":{"enabled":"Enabled","unsubscribed":"Remaining Users","subscribed":"Subscribed"}}},"till":{"titles":{"overview":"Pokladnice","create":"Pridať pokladnicu","update":"Aktualizuvať pokladnicu"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Meno","organization":"Organizácia","mixes":"Mixy"},"form":{"name":"Meno","organizations":"Organizácia","units":"Prístroje","maximumAmount":"Maximálna suma","mixes":"Mixy"},"actions":{"create":"Pridať pokladnicu ","read":"Načítať pokladnicu","update":"Aktualizovať pokladnicu","delete":"Vymazať pokladnicu"},"messages":{"added":"Pokladnica {name} je pridaná","updated":"Pokladnica {name} je aktualizovaná","disconnected":"These units will be disconnected {units} from the till {till}"}},"cit":{"titles":{"overview":"CIT procesy","create":"Pridať CIT proces","update":"Aktualizovať CIT proces","readsettings":"CIT workflow settings"},"breadcrumb":{"title":"Prepísať"},"columns":{"name":"Meno","unitType":"Typ prístroja","advancedSettings":"Pokročilé nastavenia","stepTabEdit":"Step edit","stepTabNew":"Step create","cancel":"Cancel","create":"Create","update":"Update","steps":"Steps","addNewStep":"New step","version":"Version"},"form":{"name":"Meno","unitType":"Typ prístroja","organization":"Organizácia","loginType":"Typ Loginu","firstUserRole":"Prihlásenie do role používateľa *","secondUserRole":"Druhá prihlasovacia rola používateľa *","allSteps":"Všetky kroky","selectedSteps":"Vybrané kroky","performPrint":"CIT potvrdenka","scanLength":"Dĺžka bar kódu","prefixBarcode":"Prefix bar kódu","emptyCoinDevice":"Prázdne úložisko mincí","printOnCassetteDetached":"Potvrdenie odpojenej kazety","placeholder":"Komponent","placeholderAction":"Placeholder Akcia","stepCondition":"Condition","stepSkip":"Skip to","loadingPlaceholderText":"Select any unit type first","loadingPlaceholderActionText":"Select a component first","loadingPlaceholderConditionText":"Select a component first","nextStep":"Next step","next":"Next","skipTo":"Step: {number}","options":{"autologin":"Auto login","singlelogin":"Jednotlivý login","multiplelogin":"Hromadný login","locklogin":"Prihlásenie pomocou PIN zámku"},"translationEn":"Step title","translationNl":"Step title","translationUs":"Step title","translationFr":"Step title","translationPl":"Step title","translationEl":"Step title","translationHu":"Step title","translationSk":"Step title","translationDe":"Step title","translationKey":"Translation key","translationKeyInfo":"Translation key: {translationKey}","confirmDialog":"Confirm dialog","confirmationDialogLabel":"Should show confirmation dialog?","noMatchingCondition":"The selected component doesn't have condition.","noMatchingAction":"The selected component doesn't have actions.","importWorkflow":"Import workflow","sdcGrouping":"Disable SDC grouping"},"toolTip":{"name":"Názov procesu. Do názvu je možné zahrnúť typ prístroja a organizáciu, aby bolo hľadanie jednoduchšie","unitType":"Typ prístroja zo zariadení, ktorý môže tento proces","organization":"rganizácia, ktorá má povolenie upravovať tento proces","loginType":"Spôsob, akým sa používateľ musí prihlásiť na prístroji pred výberom peňazí. Keď je vybraté automatické prihlásenie, postup sa začne po otvorení dvierok","firstUserRole":"Rola používateľa, ktorý sa musí pred výberom  peňazí prihlásiť na prístroji","secondUserRole":"Rola druhého používateľa, ktorý sa musí pred výberom peňazí prihlásiť na prístroji","allSteps":"Stránky, ktoré si môžete  vybrať pre procedúru CIT počas výberu peňazí zo zariadenia. Stránky je možné zvoliť ich pretiahnutím zľava doprava. Stránky, ktoré sa začínajú (legacy) v zariadenia so softvérom verzie 4 a vyššej už nepoužívajú.","selectedSteps":"Stránky , ktoré zobrazuje prístroj počas CIT procedúry, aby boli vybrané peniaze zo zariadenia","performPrint":"Vytlačiť potvrdenku na konci procedúry","scanLength":"Dĺžka čiarového kódu na kontajneri, kde sú uložené peniaze.","prefixBarcode":"Text, ktorým čiarový kód začína, napríklad BE. Tento znak sa zobrazí na tlačidle, keď sa čiarový kód zadá ručne","emptyCoinDevice":"Predpokladajme, že CIT vyberie zásobník mincí a hodnota mincí sa odpočíta od celkovej hodnoty peňazí v stroji","printOnCassetteDetached":"Po odpojení kazety sa vytlačí potvrdenka o obsahu kazety","placeholder":"Komponentov zvoleného typu jednotky.","placeholderAction":"Akcie pre vybrané Komponent.","stepCondition":"Condition","stepSkip":"Skip to next step","options":{"autologin":"Auto login","singlelogin":"Jednotlivý login","multiplelogin":"Hromadný login","locklogin":"Prihlásenie pomocou PIN zámku"},"translationEn":"Step title will be shown when English language is selected","translationNl":"Step title will be shown when Dutch language is selected","translationUs":"Step title will be shown when English (US) language is selected","translationFr":"Step title will be shown when French language is selected","translationDe":"Step title will be shown when German language is selected","translationPl":"Step title will be shown when Polish language is selected","translationEl":"Step title will be shown when Greek language is selected","translationHu":"Step title will be shown when Hungarian language is selected","translationSk":"Step title will be shown when Slovenian language is selected","translationKey":"Translation key","confirmDialog":"Confirm dialog","importXmlTooltip":"Only accept a single .xml file","sdcGrouping":"If this is checked, system will create separate 'Clear box item' per placeholder, instead of grouping them into one SDC."},"conditions":{"REJECT_BIN_IS_EMPTY":"Reject bin is empty","COIN_OVERFLOW_NOT_FULL":"Coin overflow is not full"},"actions":{"create":"Pridať procedúru","read":"Načítať procedúru","update":"Aktualizovať procedúru","delete":"Vymazať procedúru","readsettings":"Read workflow settings","export":"Export workflow"},"messages":{"added":"Procedúra {name} je pridaná","updated":"Procedúra {name} je aktualizovaná","noPageSelected":"Vyberte ľubovolný krok","checkStepFormFields":"Verify that all Step fields are correct","stepAdded":"Step added","stepUpdated":"Step updated","noStepSelectedV2":"Please create any step","invalidXmlFile":"Please upload a valid XML file","xmlUploadSuccess":"Workflow successfully imported","xmlUploadFailed":"Unable to upload workflow","cantMoveStepUp":"Can't move this Step up","cantMoveStepDown":"Can't move this Step down"},"workflow":{"Login":"(Legacy) Prihlásiť sa","Remove_left_cassette":"(Legacy) Odstrániť ľavú kazetu","Insert_left_cassette":"(Legacy) Vložiť ľavú kazetu","Remove_right_cassette":"(Legacy) Odstrániť pravú kazetu","Insert_right_cassette":"(Legacy) Vložiť pravú kazetu","Remove_any_cassette":"(Legacy) Odstrániť jednu kazetu","Insert_any_cassette":"(Legacy) Vložiť jednu kazetu","Remove_cassette":"(Legacy) Odstrániť kazetu","Insert_cassette":"(Legacy) Vložiť kazetu","Scan_left_reader_barcode":"(Legacy) Naskenovať čiarový kód lavého readra","Scan_right_reader_barcode":"(Legacy) Naskenovať čiarový kód pravého readra","Scan_new_cassette_barcode":"(Legacy) Naskenovať čiarový kód novej kazery","Open_the_door_Linux":"(Legacy) Otvoriť dierka(Linux)","Close_the_door__Linux":"(Legacy) Zatvoriť dierka(Linux)","Lock_the_door":"(Legacy) Uzamknúť dvierka","Sign_out":"(Legacy) Potvrdiť prevzatie","Unlock_the_door":"(Legacy) Odomknúť dvierka","Open_coin_acceptor_dropsafe_Linux":"(Legacy) Otvoriť mincový akceptor na vhadzovacom trezore (Linux)","Empty_cassette_and_close_the_dropsafe_Linux":"(Legacy) Vyprázdniť kazetu a uzatvoriť vhadzovací trezor (Linux)","Scan_new_left_cassette_barcode":"(Legacy) Skenovať nový čiarový kód ľavej kazety","Scan_new_right_cassette_barcode":"(Legacy) Skenovať nový čiarový kód pravej kazety","Securing_safe":"(Legacy) Zabezpečenie trezora","CIT_procedure_completed":"(Legacy) CIT procedúrra kompletná","Open_the_door_Windows":"(Legacy) Otvoriť dvierka (Windows)","Close_the_door_Windows":"(Legacy) zatvoriť dvierka (Windows)","Open_coin_acceptor_dropsafe_Windows":"(Legacy) Otvoriť mincový akceptor na vhadzovacom trezore(Windows)","Empty_cassette_and_close_the_dropsafe_Windows":"(Legacy) Vyprázdniť kazetu a uzatvoriť vhadzovací trezor (Windows)","AUTO_UNLOCK_FRONT_DOOR":"Automatically unlock front door","WI_UNLOCK_FRONT_DOOR":"Unlock front door (no PIN)","LP_UNLOCK_FRONT_DOOR":"Unlock front door (LPLOCK)","LP_LOCK_FRONT_DOOR":"Lock front door (LPLOCK)","LP_OPEN_FRONT_DOOR":"Open front door (LPLOCK)","LP_CLOSE_FRONT_DOOR":"Close front door (LPLOCK)","VIM_READ_KEY_CIT":"Present CIT key","V2_UNLOCK_CIT_DOOR":"Odomknuté dvierka (Linux)","V2_OPEN_CIT_DOOR_LINUX":"Otvorené dvierka (Linux)","V2_REMOVE_STORAGE":"Odstrániť zásobník","V2_INSERT_STORAGE":"Vložiť zásobník","V2_CLOSE_CIT_DOOR_LINUX":"Zatvoriť dvierka (Linux)","V2_LOCK_CIT_DOOR":"Uzamknúť dvierka(Linux)","V2_PROCESSING_CIT":"Zabezpečiť safe - Lincstation","V2_REMOVE_CASSETTE":"Odstrániť kazetu","V2_INSERT_CASSETTE":"Vložiť kazetu","V2_EMPTY_CASSETTE":"Empty cassette","V2_OPEN_CIT_DOOR_WINDOWS":"Otvoriť dvierka (Windows)","V2_CLOSE_CIT_DOOR_WINDOWS":"Zatvoriť dvierka (Windows)","V2_REMOVE_LEFT_CASSETTE":"Odstrániť ľavú kazetu","V2_INSERT_LEFT_CASSETTE":"Vložiť ľavú kazetu","V2_REMOVE_RIGHT_CASSETTE":"Odstrániť pravú kazetu","V2_INSERT_RIGHT_CASSETTE":"Vložiť pravú kazetu","V2_LOGIN":"Používateľské prihlásenie","V2_CIT_PROCEDURE_COMPLETED":"CIT proceduúra komplet","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_LINUX":"Otvoriť bočný mincový trezor (Linux)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_LINUX":"Vyprázdniť bočný mincový trezor (Linux)","V2_SCAN_LEFT_READER_BARCODE":"Skenovať čiarový kód ľavého readra","V2_SCAN_RIGHT_READER_BARCODE":"Skenovať pravý čiarový kód","V2_SCAN_STORAGE_BARCODE":"Skenuj zásobník","V2_OPEN_COIN_ACCEPTOR_DROPSAFE_WINDOWS":"Otvoriť mincový akceptor vhadzovacieho trezoru (Windows)","V2_EMPTY_CASSETTE_AND_CLOSE_THE_DROPSAFE_WINDOWS":"Vyprázdniť bočný mincový trezor (Windows)","V2_OPEN_CIT_DOOR":"Otvoriť CIT dvierka","V2_CLOSE_CIT_DOOR":"Zatvoriť CIT dvierka","V2_PROCESSING_LINCSTATION_CIT":"Secure safe (Lincstation)","V2_OPEN_THE_DOOR_LINUX":"Open door (Linux)","V2_CLOSE_THE_DOOR_LINUX":"Close door (Linux)","V2_UNLOCK_DOOR":"Odomknúť dvierka (Linux)","V2_LOCK_DOOR":"Zamknúť dvierka (Linux)","V2_PROCESSING_SAFE_CIT":"Zabezpečiť trezor","V2_PRINT_LEFT_CASSETTE":"Vytlačiť ľavú kazetu","V2_PRINT_RIGHT_CASSETTE":"Vytlačiť pravú kazetu","V2_PRINT_CIT_TOTAL":"Vytlačiť CIT totals","V2_SEAL_BAG":"Vhadzovacie vrece","V2_UNLOCK_SIDESAFE_WITH_BO_COIN":"Odomknúť mincový bočný trezor","V2_UNLOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Odomknúť bočný trezor","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_COIN":"Vyprázdniť a zamknúť bočný mincový trezor","V2_EMPTY_AND_LOCK_SIDESAFE_WITH_BO_WITHOUT_COIN":"Vyprázdniť a zamknúť bočný trezor","V2_SEALING_BAG":"Zatavené vrece","V2_REPLACE_SEAL_BAG":"Vymeniť vhadzovacie vrece","V2_SCAN_COIN_STORAGE_BARCODE":"Scan coin storage","V2_COIN_ROLL_FILL_UP":"Coin roll fill up","V2_EMPTY_COUNTERS":"Empty counters","V2_WAIT_10":"Delay 10 seconds","V2_OPEN_OM61_DOOR":"Open OM61 door","V2_CLOSE_OM61_DOOR":"Close OM61 door","V2_UNLOCK_OM61_BAG_STORAGE":"Unlock OM61 bag storage compartment","V2_TAKE_OM61_STORAGE_BAG":"Take OM61 storage bag","V2_INSERT_NEW_OM61_STORAGE_BAG":"Insert OM61 new storage bag","V2_OPEN_CIT_DOOR_LINCSTATION_V3":"Open door (Lincstation v3)","V2_CLOSE_CIT_LINCSTATION_V3":"Close door (Lincstation v3)","V2_PROCESSING_CIT_LINCSTATION_V3":"Secure safe (Lincstation v3)","V2_UNLOCK_LINCSTATION_V3":"Unlock door (Lincstation v3)","V2_LOCK_LINCSTATION_V3":"Lock door (Lincstation v3)","V2_INSTALL_OM61_STORAGE_BAG":"Install OM61 storage bag","V2_UNLOCK_FRONT_DOOR":"Unlock front door","V2_UNLOCK_FRONT_DOOR_SPT":"Unlock front door (SPT)","V2_OPEN_FRONT_DOOR":"Open front door","V2_CLOSE_FRONT_DOOR":"Close front door","V2_LOCK_FRONT_DOOR":"Lock front door","V2_LOCK_FRONT_DOOR_SPT":"Lock front door (SPT)","V2_EMPTY_ESCROW":"Empty escrow","V2_PAUSE_CIT":"Pause CIT","V2_REMOVE_REJECT_BIN":"Remove reject bin","V2_CONFIRM_EMPTY_REJECT_BIN":"Confirm empty reject bin","V2_INSERT_REJECT_BIN":"Insert reject bin","V2_FILL_UP_COINS":"Fill up coin recycler","V2_OPEN_COIN_OVERFLOW_DOOR_SPT":"Open coin overflow door (SPT)","V2_EMPTY_COINS_AND_CLOSE_COIN_OVERFLOW_DOOR_SPT":"Empty coins and close coin overflow door (SPT)","V2_SECURE_SAFE":"Secure safe","V2_REMOVE_PULOON_CASSETTE_1":"Remove 1st present dispenser cassette","V2_REMOVE_PULOON_CASSETTE_2":"Remove 2nd present dispenser cassette","V2_INSERT_PULOON_CASSETTE_1":"Insert 1st new dispenser cassette","V2_INSERT_PULOON_CASSETTE_2":"Insert 2nd new dispenser cassette","V2_UNLOCK_CIT_DOOR_2":"Unlock CIT door 2","V2_LOCK_CIT_DOOR_2":"Lock CIT door 2","V2_OPEN_CIT_DOOR_LINUX_2":"Open safe door (Linux) 2","V2_CLOSE_CIT_DOOR_LINUX_2":"Close safe door (Linux) 2","V2_UNLOCK_FRONT_DOOR_2":"Unlock front door 2","V2_UNLOCK_FRONT_DOOR_SPT_2":"Unlock front door 2 (SPT)","V2_OPEN_FRONT_DOOR_2":"Open front door 2","V2_CLOSE_FRONT_DOOR_2":"Close front door 2","V2_LOCK_FRONT_DOOR_2":"Lock front door 2","V2_LOCK_FRONT_DOOR_SPT_2":"Lock front door 2 (SPT)","V2_SECURE_CIT_DOOR":"Secure CIT door (SPT)","V2_SECURE_CIT_DOOR_2":"Secure CIT door 2 (SPT)","V2_SECURE_FRONT_DOOR":"Secure front door (SPT)","V2_SECURE_FRONT_DOOR_2":"Secure front door 2 (SPT)","V2_SKIP_EMPTY_ESCROW_SAFEBAG_FULL":"Skip emptying escrow when sealbag is full","dynamic":{"LOCK_OPEN":"Open lock","LOCK_CLOSE":"Close lock","LOCK_OPEN_WITH_PIN":"Open lock with pin","DOOR_OPEN":"Open door","DOOR_CLOSE":"Close door","DOOR_SECURE":"Secure door","CIT_COMPLETED":"Cit completed","CIT_PAUSE":"Cit paused","CIT_DIALOG":"Cit dialog","CIT_USER_LOGIN":"Cit user login","COIN_FILL_UP":"Fill up coin","COIN_EMPTY_OVERFLOW_STORAGE":"Empty coin overflow storage","STORAGE_REMOVE_CASSETTE":"Remove storage cassette","STORAGE_ATTACH_CASSETTE":"Attach storage cassette","STORAGE_PULOON_REMOVE_DISPENSER_1":"Remove storage puloon dispenser 1","STORAGE_PULOON_ATTACH_DISPENSER_1":"Attach storage puloon dispenser 1","STORAGE_PULOON_REMOVE_DISPENSER_2":"Remove storage puloon dispenser 2","STORAGE_PULOON_ATTACH_DISPENSER_2":"Attach storage puloon dispenser 2","STORAGE_PULOON_REMOVE_DISPENSER_3":"Remove storage puloon dispenser 3","STORAGE_PULOON_ATTACH_DISPENSER_3":"Attach storage puloon dispenser 3","STORAGE_PULOON_REMOVE_DISPENSER_4":"Remove storage puloon dispenser 4","STORAGE_PULOON_ATTACH_DISPENSER_4":"Attach storage puloon dispenser 4","STORAGE_PULOON_REMOVE_REJECT_BIN":"Remove storage puloon reject bin","STORAGE_PULOON_ATTACH_REJECT_BIN":"Attach storage puloon reject bin","COIN_REMOVE_AND_EMPTY_OVERFLOW_STORAGE":"Remove and empty coin bucket","COIN_FILL_UP_SPLIT_START":"Start split fill up","COIN_FILL_UP_SPLIT_END":"Stop split fill up","COIN_INSERT_OVERFLOW_STORAGE":"Insert coin bucket","CIT_IBUTTON_LOGIN":"iButton login","MANUAL_DEPOSIT_EMPTY":"Empty manual deposit","CENCON_LOCK_OPEN":"Open Cencon lock","CENCON_LOCK_CLOSE":"Close Cencon lock","TRAY_OPEN":"Open hitachi door","TRAY_CLOSE":"Close hitachi door","HITACHI_REJECT_BOX_CLOSE":"Close reject box","HITACHI_REJECT_BOX_OPEN":"Open reject box and empty its contents","STORAGE_ONE_ATTACHED":"Attach Puloon storage cassette","STORAGE_ONE_REMOVED":"Remove Puloon storage cassette","HITACHI_STORAGE_ONE_ATTACHED":"Attach hitachi storage","HITACHI_STORAGE_ONE_REMOVED":"Remove hitachi storage","HITACHI_STORAGE_TWO_ATTACHED":"Attach Hitachi storage cassette 2","HITACHI_STORAGE_TWO_REMOVED":"Remove Hitachi storage cassette 2","HITACHI_STORAGE_THREE_ATTACHED":"Attach Hitachi storage cassette 3","HITACHI_STORAGE_THREE_REMOVED":"Remove Hitachi storage cassette 3","HITACHI_STORAGE_FOUR_ATTACHED":"Attach Hitachi storage cassette 4","HITACHI_STORAGE_FOUR_REMOVED":"Remove Hitachi storage cassette 4","HITACHI_STORAGE_FIVE_ATTACHED":"Attach Hitachi storage cassette 5","HITACHI_STORAGE_FIVE_REMOVED":"Remove Hitachi storage cassette 5","HITACHI_STORAGE_ONE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 1","HITACHI_STORAGE_ONE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 1","HITACHI_STORAGE_TWO_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 2","HITACHI_STORAGE_TWO_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 2","HITACHI_STORAGE_THREE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 3","HITACHI_STORAGE_THREE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 3","HITACHI_STORAGE_FOUR_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 4","HITACHI_STORAGE_FOUR_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 4","HITACHI_STORAGE_FIVE_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 5","HITACHI_STORAGE_FIVE_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 5","HITACHI_STORAGE_SIX_SCAN_NEW_BARCODE":"Scan new barcode for storage cassette 6","HITACHI_STORAGE_SIX_SCAN_OLD_BARCODE":"Scan old barcode for storage cassette 6"},"V2_REMOVE_SEALPACK_FROM_COIN_STORAGE":"Take out sealpack from coin storage","V2_INSERT_NEW_SEALPACK_TO_COIN_STORAGE":"Insert new sealpack to coin storage"},"dialog":{"title":"Confirm change order","description":"The Step: {stepOrder} can't be moved without breaking Skip to value of Step: {colindantStepOrder}","confirmation":"Change order anyway and remove Skip to value ?"}},"mix":{"titles":{"overview":"Mixy","create":"Pridať a zmiešať  ","update":"Aktualizovať mix"},"breadcrumb":{"title":"Prehľad"},"form":{"mixName":"Meno mixu","totalAmount":"Celková suma","organization":"Organizácia","denominations":"Nominály","currency":"Currency","eur":"EURO","usd":"USD","gbp":"GBP"},"columns":{"name":"meno mixu","totalAmount":"Celková suma","details":"Detaily","totalValue":"Total value"},"read":{"mixDetails":"Detaily mixu"},"actions":{"create":"Pridať mix","update":"Aktualizovať mix","delete":"Delete mix","read":"Read mix"}},"report":{"buttons":{"createReport":"VYTVORIŤ REPORT","generating":"Generating..."},"titles":{"overview":"Report","create":"Pridať report","update":"Aktualizovať report"},"breadcrumb":{"title":"report"},"form":{"orgUuid":"Organizácia","unitUuid":"Prístroj","type":"Typ","startDate":"Od","endDate":"Do","types":{"getReptileCampaignsAndTransactionsByDate":"Transakcie a výbery","getReptileCampaignsAndTransactionsMoneyInOutCounterByDate":"Transakcie a výbery s peniazmi na pokladni","getReptileTransactionsByDate":"Transakcie","getManualTransactionsByDate":"[Deprecated] Vhadzovací trezor","getReptileManualTransactionsByDate":"Vhadzovací trezor - Nový","getReptileReportForClosedCampaignsByUnitAndDate":"Výber","getReptileClearboxDenomination":"[Deprecated] Clearboxes denomination","getReptileClearboxDenominationV2":"Clearboxes denomination","getReptileEndOfDayInfoByDate":"Denná úzávierka za prístroj celkom","getEndOfDayClientsByDate":"[Deprecated] Denná uzávierka za klienta","getReptileEndOfDayClientsByDate":"Denná uzávierka za klienta - Nový","getEventsByDate":"Udalosti za deň","getReptileEventsByDate":"Udalosti za deň - Nový","getReptileReportForDenominationPerUser":"Nominály na používateľa","getReptileReportForDenominationWithPin":"Nominály s Pinom","getInternalTransactionsByDate":"[Deprecated] Interné transakcie","getReptileInternalTransactionsByDate":"Interné transakcie - Nový","getReptileAdvancedManualDeposit":"Pokročilé manuálne vklady","getReptileLincstationEndOfDayInfoByDate":"Lincstation End of Day Unit Total","getReptileSalesByDate":"Sales - New","getReptileRecyclerReport":"Lincstation overall report","getReptileTransactionsWithReference":"Transakcie s referenčnými číslami","getTransactionsWithReference":"[Deprecated] Transakcie s referenčnými číslami","getCampaignsWithBarcodes":"[Deprecated] Výbery s číslami etikiet","getSalesByDate":"[Deprecated] Predaje","getCurrentlyOfflineUnits":"Currently Offline Units (.csv)","getReptileCashCoinEndOfDayInfoByDate":"End of Day Cash/Coin","getReptileUnitInventory":"Unit Inventory (.pdf)","getReptileCampaignsAndTransactionsByDateWithSource":"Smartsafes transactions and clearboxes","getReptileEndOfDaySmartSafes":"Smartsafes End Of Day (.pdf)","getReptileEndOfDaySmartSafesXlsx":"Smartsafes End Of Day (.xlsx)","getReptileEndOfDayRecyclerXlsx":"Recycler End Of Day (.xlsx)","getReptileCampaignSmartSafesPdf":"Smartsafes Campaign (.pdf)","getReptileCampaignSmartSafesXlsx":"Smartsafes Campaign (.xlsx)","getReptileTransactionSmartSafesPdf":"Smartsafes Transaction (.pdf)","getReptileTransactionSmartSafesXlsx":"Smartsafes Transaction (.xlsx)","getReptileTransactionSmartSafesDetailedPdf":"Smartsafes Transaction Detailed (.pdf)","getReptileTransactionSmartSafesDetailedXlsx":"Smartsafes Transaction Detailed (.xlsx)","getOrganizationAssetsXlsx":"Smartsafes Asset Management (.xlsx)","getOrganizationAssetsPdf":"Smartsafes Asset Management (.pdf)","getReptileEventSmartSafesXlsx":"Smartsafes Event (.xlsx)","getReptileEventSmartSafesPdf":"Smartsafes Event (.pdf)"}},"messages":{"success":"Report bol úspešne načítaný. Súbor by sa mal automaticky začať sťahovať...","failed":"The report could not be generated. Please try again later","reptileDateLimitExceeded":"Nepodarilo sa vygenerovať správu. Prekročený bol stanovený časový limit. Prosím, upravte rozsah dátumov a skúste to znova.","reptileGenericBadRequest":"Nepodarilo sa vygenerovať správu z dôvodu chybného požiadavku. Skontrolujte svoje vstupné parametre a skúste to znova neskôr.","cannotOutputToCsvFile":"The report could not be generated. Please try again later and/or with different parameters.","errorOccurred":"The report could not be generated. Unknown error occurred."},"dialog":{"title":"Report bol úspečne načítaný.","download":"Kliknutím sem stiahnete report","close":"Zavrieť"}},"transaction":{"read":"Detail transkacie"},"adminsettings":{"titles":{"overview":"Údržba meny"},"breadcrumb":{"title":"Prehľad"},"messages":{"updated":"Mena a nominály aktualizované","error":"Niečo sa pokazilo, mena a nominálne hodnoty sa neaktualizovali"},"form":{"currency":"Mena","iso1":"ISO1","iso2":"ISO2","iso3":"ISO3","symbol":"Symbol","symbolCode":"Kód symbolu","defaultValue":"Predvolená hodnota","enabled":"Povolené","denomination":{"value":"Hodnota","coins":"Mince","bills":"Bankovky","enabled":"Povolené","remove":"Odstrániť"}}},"notification":{"titles":{"read":"Notification Details"},"read":"Notification Details"},"common":{"form":{"bankAccount":"Primary bank account number","citAccount":"CIT account number","affiliateCode":"Affiliate code","overrideBankAccount":"Override primary bank account number","overrideCitAccount":"Override CIT account number","overrideAffiliateCode":"Override affiliate code"},"toolTip":{"bankAccount":"Bank account number to which deposits/withdrawals are transmitted from the safe(s). Can be overridden at a more granular level","citAccount":"Bank account number to which funds are deposited after CIT. Usually the same as primary bank account number","affiliateCode":"4 digit alphabetical code"}},"department":{"titles":{"overview":"Departments","create":"Create a department","update":"Update department","preview":"Preview department"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Name","organizationName":"Organization"},"form":{"name":"Name","organization":"Organization","bankAccount":"Bank account number"},"toolTip":{"organization":"Which organization does this department belong to","bankAccount":"Optional bank account number to which deposits/withdrawals are transmitted from the safe(s)","overrideBankAccount":"Do not inherit primary bank account from unit. Instead, define a new one specific to this department"},"actions":{"create":"Create department","read":"Preview department","update":"Update department","delete":"Delete department","preview":"Preview department"},"messages":{"added":"Department {name} has been created","updated":"Department {name} has been updated"}},"unitRoles":{"titles":{"overview":"Unit roles","create":"Add a unit role","update":"Update unit role"},"breadcrumb":{"title":"Overview"},"columns":{"name":"Unit role name","organization":"Organization"},"actions":{"create":"Add unit role","update":"Update unit role","delete":"Delete unit role"},"form":{"name":"Unit role name","organization":"Organization","transactionCashOutLimit":"Transaction cash out limit","dailyCashOutLimit":"Daily cash out limit","permissions":"Permissions"},"messages":{"added":"The unit role {name} is added","updated":"The unit role {name} is updated"}}},"server_messages":{"accessNotAllowed":"Prístup nie je povolený.","authorizationFailed":"Autorizácia zlyhala.","campaignNotFound":"Kampaň sa nenašla!","cityCannotBeEmpty":"Mesto nemôže byť prázdne!","componentNotFound":"Komponent sa nenašiel!","countryCannotBeEmpty":"Krajina nemôže byť prádzna!","countryNotFound":"Krajina sa nenašla!","credentialsCannotBeEmpty":"Poverenia nemôžu byť prázdne","currencyNotFound":"Mena sa nenašla!","duplicateItemFound":"Bola nájdená duplicitná položka!","errorOccurred":"Vyskytla sa chyba a bola prihlásená.","ILLEGAL_ARGUMENT":"Chybný vstup","ILLEGAL_ARGUMENT_ADDRESS_TYPE":"Vyskytol sa problém s adresou","ILLEGAL_ARGUMENT_ADDRESSLINE1":"Zmeňte prosím prvý riadok adresy","ILLEGAL_ARGUMENT_ADDRESSLINE2":"Zmeňte prosím druhý riadok adresy","ILLEGAL_ARGUMENT_BANK_ACCOUNT":"Zmente bankový účet","ILLEGAL_ARGUMENT_CHILD_ORGANIZATION":"Zmente podriadenú organizáciu","ILLEGAL_ARGUMENT_CIT":"Niečo sa pokazilo s informáciami CIT","ILLEGAL_ARGUMENT_CITY":"Prosím zmente mesto","ILLEGAL_ARGUMENT_CLIENT_ORGANIZATION":"Prosím zmente organizáciu klienta","ILLEGAL_ARGUMENT_COUNTRY":"Prosím zmente krajinu","ILLEGAL_ARGUMENT_CURRENCY":"Prosím zmente menu","ILLEGAL_ARGUMENT_DATE":"prosím zmente dátum","ILLEGAL_ARGUMENT_DESCRIPTION":"Prosím zmente popis","ILLEGAL_ARGUMENT_FIRST_NAME":"Prosím zmente krstné meno","ILLEGAL_ARGUMENT_GENDER":"Vyskytol sa problém s pohlavím","ILLEGAL_ARGUMENT_ID":"Prosím zmente ID","ILLEGAL_ARGUMENT_LAST_NAME":"Prosím zmente priezvisko","ILLEGAL_ARGUMENT_LEGAL_FORM":"Prosím zmente právnu formu","ILLEGAL_ARGUMENT_LOCATION":"Prosím zmente lokalitu","ILLEGAL_ARGUMENT_LOCATION_UUID":"Nenájdená lokácia","ILLEGAL_ARGUMENT_MACHINE_TYPE":"Zmente typ stroja","ILLEGAL_ARGUMENT_MAIL":"Prosím zmente email adresu","ILLEGAL_ARGUMENT_MAINTENANCE":"Niečo sa pokazilo s informáciami o servise","ILLEGAL_ARGUMENT_NAME":"Prosím zmente meno","ILLEGAL_ARGUMENT_ORGANIZATION":"Prosím zmente organizáciu","ILLEGAL_ARGUMENT_ORGANIZATION_TYPE":"Prosím zmente typ organizácie","ILLEGAL_ARGUMENT_ORGANIZATION_UNIT_TYPE":"Pri kombinácii organizácie a typu prístroja sa vyskytla chyba","ILLEGAL_ARGUMENT_ORGANIZATION_UUID":"Nenájdená organizácia","ILLEGAL_ARGUMENT_OWNER_ORGANIZATION":"Prosím zmente organizáciu vlastníka","ILLEGAL_ARGUMENT_PAGE_NUMBER":"Pri čísle stránky sa niečo pokazilo","ILLEGAL_ARGUMENT_PAGE_SIZE":"Niečo sa pokazilo s veľkosťou stránky","ILLEGAL_ARGUMENT_PARENT_ORGANIZATION":"Prosím zmente nadriadenú organizáciu","ILLEGAL_ARGUMENT_PASSWORD":"Prosím zmente heslo","ILLEGAL_ARGUMENT_PERSON":"Ničo sa pokazilo s informáciami o používateľovi","ILLEGAL_ARGUMENT_PHONE_NUMBER":"Prosím zmente číslo telefónu","ILLEGAL_ARGUMENT_PIN":"Prosím zmente pin pin","ILLEGAL_ARGUMENT_REPORTED_ORGANIZATIONS":"Prosím zmente reportované oranizácie","ILLEGAL_ARGUMENT_ROLES":"Prosím zmente role","ILLEGAL_ARGUMENT_SDC":"Niečo sa pokazilo s výberom","ILLEGAL_ARGUMENT_SERIAL":"Prosím zmente sériové číslo","ILLEGAL_ARGUMENT_TOKEN":"Niečo nie je v poriadku s prihlasovacími informáciami","ILLEGAL_ARGUMENT_UNIT":"Prosím zmente prístroj","ILLEGAL_ARGUMENT_UNIT_TYPE":"Prosím zmente typ prístroja","ILLEGAL_ARGUMENT_UNIT_UUID":"Nenájdený prístroj","ILLEGAL_ARGUMENT_USER":"Prosím zmenta používateľa","ILLEGAL_ARGUMENT_UUID":"Nie je možné načítať informácie","INVALID_CREDENTIALS":"Neplatné poverenia","INVALID_PATH":"Neplatná cesta","invalidData":"Neplatné údaje","legalFormNotFound":"Nenájdená právna forma!","locationInUse":"Používaná lokácia","locationNameCannotBeEmpty":"Názov lokácie namôže byť prázdny!","locationNotFound":"Lokácia nenájdená!","locationUpdateDataIsInvalid":"Údaje o lokácii sú neplatné!","LOCKED":"Zamknuté","LOGOUT":"Odhásené!","NO_RESULT":"Žiaden výsledok","organizationInUse":"Používaná organizácia","organizationListFetched":"Vybraný zoznam organizácií.","organizationNotFound":"Organizácia sa nenašla.","organizationTypeNotFound":"Typ organizácie sa nenašiel.","passwordIsInvalid":"Heslo je neplatné!","phoneNumberLengthIsIncorrect":"Dĺžka telefónneho čísla je nesprávna","pinIsEmpty":"Prosím zadajte PIN","pinNotNumeric":"používajte len číslo v pine, prosím","roleNotFound":"Rola sa nenašla.","sessionTimeout":"Session timeout","settingsNotFound":"Nastavenia sa nenašli","SUCCESS":"Úspech","SYSTEM_FAIL":"Zlyhal systém!","transactionNotFound":"Transakcia sa neanšla","UNABLE_TO_STORE_INFO":"Údaje sa nepodarilo uložiť","UNAUTHORIZED":"Neautorizovaný prístup","unitNotFound":"Prístroj sa nenašiel.","unitTypeListFetched":"Načítaný zoznam prístrojov.","userAlreadyExists":"Používateľ už existuje","userIsLocked":"Používateľ je uzamknutý.","userNotFound":"Používateľ sa nenašiel","workflowInUseByOtherOrg":"Proces používaný inou organizáciou, zmeňte organizáciu alebo odstráňte proces iných organizácií / prístrojov","workflowNotFound":"Proces sa nenašiel!","invalidFormatException":"Neplatný formát údajov, skontrolujte údaje v štruktúre JSON","unrecognizedPropertyException":"Skontrolujte vlastnosti v štruktúre JSON","jsonParseException":"Nepodarilo sa analyzovať JSON, skontrolujte štruktúru","jsonMappingException":"Nepodarilo sa mapovať JSON, skontrolujte štruktúru","iOException":"Nepodarilo sa analyzovať JSON, skontrolujte štruktúru","minimumGreaterThanOptimum":"Minimálne množstvo väčšie ako optimálne","maximumLessThanOptimum":"Maximálne množstvo menšie ako optimálne","ILLEGAL_ARGUMENT_MIX_UUID":"Nemôžem nájsť mixy","ILLEGAL_ARGUMENT_MAX_AMOUNT":"Prosím zmente maximálne množstvo","TILL_IS_BEING_USED_BY_USER":"Pokladnicu užíva používateľ","TILL_IS_BEING_USED_BY_UNIT":"Pokladnicu užíva prístroj","secretIsEmpty":"Empty secret found","secretAlreadyExists":"Invalid secret generated. Please generate again","MIN_FOUR_DIGITS":"PIN must be at least 4 digits in length","MIN_SIX_DIGITS":"PIN must be at least 6 digits in length","MAX_SIX_DIGITS":"PIN must be at most 6 digits in length","NO_DUPLICATE_DIGITS":"PIN must not have repeated digits","NO_INCREMENTING_DIGITS":"PIN must not be in incrementing order","NO_DECREMENTING_DIGITS":"PIN must not be in decrementing order","MAX_NINETY_DAYS":"Pin expired after 90 days, Please change pin","MAX_SIXTY_DAYS":"Pin expired after 60 days, Please change pin","MAX_THIRTY_DAYS":"Pin expired after 30 days, Please change pin","PIN_LENGTH_NOT_IN_4_TO_6":"Pin length between 4 and 6 digits","ILLEGAL_ARGUMENT_USERNAME_NULL":"External Username must not be null","ILLEGAL_ARGUMENT_EXTERNAL_USERNAME_IS_NULL":"External Username must not be null","ILLEGAL_ARGUMENT_EXTERNAL_PASSWORD_IS_NULL":"External password must not be null","ILLEGAL_ARGUMENT_EXTERNAL_HS600_PASSWORD_INVALID":"External HS600 password is invalid. Only numeric values allowed","ILLEGAL_ARGUMENT_ROLES_ONE_EXTERNAL_HS600_ROLE_ALLOWED":"Only one external HS600 role is allowed","maxDispensableGreatherThenAllowed":"Max dispensable is greather then allowed","MFA_REQUIRED":"Multi factor authentication required","duplicateSafeIdFound":"Safe ID already exists!","validationError":"Validation failed.","ILLEGAL_ARGUMENT_MIX_DENOMINATIONS":"Please select currency.","unitRoleInUseByUser":"This unit cannot be deleted because it is currently assigned to a user.","emailNotUnique":"The email address is already in use","NON_UNIQUE_USERNAME":"Duplicate user accounts found, please contact your administrator","departmentAlreadyExists":"Department name has already been taken. Please choose another name","maxAndOptimumRequiredException":"Please enter the value for the Optimum and Max column before updating the page","invalidParentOrganizationType":"The parent organization must either be of type 'GENERAL' or match the type of the organization","workflowInUseByUnits":"Workflow in use by units [{reason}]. Make sure no units are using this workflow before deleting it."},"placeholder_names":{"cit":{"LR":"Ľavý vklad bankoviek","RR":"Pravý vklad bankoviek","CA":"Preplnenie mincami","BA":"Vklad bankovky","R3":"Stredný depozit bankoviek","B1":"Vklad bankoviek","RC":"Vklad bankoviek","CC":"Preplnenie mincami"},"LR":"Ľavý reader bankoviek","RR":"Pravý reader bankoviek","PR":"Tlačiareň","CA":"Mincový akceptor","BO":"Breakout board","DS":"Dverový senzor","PU":"Dispenzor bankoviek","SC":"Pripojený mincový recyklátor","SS":"Bočný senzor","SD":"Senzor bočného zariadenia","WI":"Lincsafe inteligentný zámok","LL":"Dolný zámok","HO":"Mincový násypník","BA":"Akceptor bankoviek","DR":"Dverový reader","R3":"Stredný bankovkový reader","ST":"Horný senzor","TD":"Horný senzor zariadenia","SB":"Dolný senzor zariadenia","BD":"Dolný senzor zariadenia","B1":"Bankovkový reader","H1":"Násypník jedna","H2":"Násypník dva","UL":"Doplný zámok","BP":"Bzučiak","RC":"Bill recycler","CC":"Coin recycler","DT":"Horné dvierka","DM":"Stredné dvierka","DB":"DOlné dvierka","CD":"CIT dvierka","MD":"Senzor dvierok pre sériovú údržbu","RF":"RFID reader","SL":"Zváračka","UNIT":"Prístroj","null":"","DRAWER":"Zásuvka","SIDE_SAFE":"Bočný trezor","COIN_DROP_SAFE":"Mincový vhadzovací senzor","DOOR_BOTTOM":"Spodné dvere","DOOR_MIDDLE":"Stredné dvere","DOOR_TOP":"Horné dvere","EXB":"Predlžovacia doska","MLOCK_TOP":"Horný m-zámok","SOLENOID_BOTTOM":"Spodný solenoid","SWITCH_COIN_TUBE":"Coin chute","WI_MIDDLE":"Stredný zámok zámku","NETWORK":"Network","STORAGE_INVENTORY":"Storage inventory","COIN_ROLL":"Coin roll","PIN_TERMINAL":"PIN terminal","WI_MAINTENANCE":"Lincsafe maintenance door smart lock","om61":"OM61","UNKONWN":"Unkown","DOOR_FRONT":"Door front sensor","DOOR_LEFT":"Door left sensor","DOOR_RIGHT":"Door right sensor","SOLENOID":"Solenoid","VIM":"Vault Interface Module","LOCK_FRONT":"Front door lock","LPLOCK":"Front door lock","MLOCK":"MLock","BOTTOM_LOCK":"Bottom lock","BO_1":"Bo 1","BO_2":"Bo 2","BUTTON_A":"Button A","BUTTON_B":"Button B","BUTTON_C":"Button C","BUTTON_D":"Button D","DOOR_TOP_LEFT":"Door top left","DOOR_TOP_RIGHT":"Door top right","EBM":"EBM","EBS":"EBS","HOPPERS":"Hoppers","HSCD":"HSCD","TOP_LEFT_LOCK":"Top left lock","WI_TOP":"WI top","CIT_COMPLETED":"Unit","DOOR_HATCH":"Door top hatch sensor","LPLOCK_STORAGE":"LP lock storage","IBUTTON":"iButton","HITACHI_LOCK":"Cencon lock","XR":"Hitachi","JACK_STATUS":"Stav konektora pre slúchadlá"},"compartment_names":{"RECYCLER":"RECYKLÁTOR","STORAGE":"ZÁSOBNÍK","MANUAL_STORAGE":"Manual storage","ESCROW":"ESCROW","HOPPERS":"HOPPERS","REJECT":"REJECT"},"notifications":{"ACCEPTING":"Cash device(s) is/are accepting","BOTTOM_DOOR_OPEN":"Coin acceptor overflow door is open!","BOTTOM_SIDE_DOOR_OPEN":"Sidesafe bottom door is open","CALIBRATING":"Cash device is being calibrated","CARTRIDGE_DETACHED":"Cartridge has been detached","CHEATED":"Cheat attempt","CIT_DOOR_OPEN":"Cit door opened","COIN_DRAWER_OPENED":"Coin drawer opened","COIN_DROP_SAFE_OPENED":"Coin side safe is opened","DEVICE_CAN_NOT_PAYOUT":"Inventory not enough to payout","DOOR_OPEN":"Door is open","DOWNLOADING":"Downloading firmware","DRAWER_OPENED":"Drawer opened","END_OF_DAY":"End of day is overdue","ENTRANCE_NOT_EMPTY":"Entrance is not empty","errorOccurred":"Internal server error","EXCEEDS_PAYOUT_LIMIT":"Value to payout exceeds payout limit.","EXTENSION_STALL":"Stalled","FAILED":"Failure has been detected","FEED_FAILURE":"Feed failed","FLOAT_NOT_SET":"Float value has not been set on portal, please first set value on portal!","ILLEGAL_ARGUMENT":"Illegal argument","INSURABLE_VALUE_REACHED":"Insurable value reached, please empty the machine!","CASSETTE_LIMIT_REACHED":"Cassette limit reached","INVALID_CREDENTIALS":"Invalid credentials!","INVENTORY_LOWER_THAN_FLOAT":"Inventory is already lower than float","INVENTORY_NOT_SUFFICIENT":"Inventory is not sufficient, please fill up the machine!","INVENTORY_OVER_MAX":"Inventory level is higher than maximum, please float down the machine!","INVENTORY_SETTINGS_NULL":"Can not find inventory settings, please contact the manager!","INVENTORY_UNDER_MIN":"Inventory level is lower than minimum, please fill up the machine!","INVENTORY_UNDER_LOW":"Inventory level is under low, please fill up the machine!","JAMMED":"Device is jammed","LAST_TRANSACTION_FAILED":"Last payment was failed, please contact the manager!","LOCK_NOT_SECURE":"Smart (wittkopp) lock is not secure!","MACHINE_BUSY":"The machine is already busy, please wait to complete running transaction","MACHINE_NOT_OPERATIONAL":"The machine is not operational, please check notifications","MAINTENANCE_DOOR_OPEN":"Maintenance door open","MIDDLE_DOOR_OPEN":"CIT door is open!","NO_ACCESS":"Personnel does not have access<br/>to the value in the safe","NOT_CONNECTED":"Device is not connected","NOT_OPERATIONAL":"Not operational","NOT_RECYCLED_MATERIAL":"Not a recycled material","NOT_SECURE":"The machine is not secure, please contact the manager!","ORGANIZATION_NOT_FOUND":"Organization could not be found","OVERRIDDEN":"The lock is overridden","PAPER_EMPTY":"Paper is empty","PAPER_LOW":"Paper is low","PAUSE":"Pause","PAYOUT_FAILED":"Could not pay out value","PAYOUT_LIMIT_NOT_FOUND":"Payout limit has not been defined yet!","PIN_EMPTY":"Pin can not be empty!","POWER_UP":"Power up","RECYCLER_ALMOST_EMPTY":"Recycler is almost empty","RECYCLER_ALMOST_FULL":"Recycler is almost full","RECYCLER_EMPTY":"Recycler is empty","RECYCLER_FULL":"Recycler is full","REJECT_NOT_EMPTY":"Reject is not empty","SIDE_DOOR_ONE_OPEN":"Sidesafe(1) door is open","SIDE_DOOR_OPEN":"Sidesafe door is open","SIDE_SAFE_OPENED":"Side safe opened","STACKER_FULL":"Stacker is full","STALLED":"Stalled","STORAGE_ALMOST_FULL":"Cassette is almost full, please empty the machine","STORAGE_DETACHED":"Cassette is detached","STORAGE_FULL":"Cassette is full, please empty the machine","TOP_DOOR_OPEN":"Maintenance door is open!","TOP_SIDE_DOOR_OPEN":"Sidesafe top door is open","USER_BLOCKED":"User has been blocked","USER_NOT_FOUND":"User could not be found","WORKFLOW_NOT_FOUND":"Cit workflow could not be found, please check portal","ZERO_AMOUNT":"Amount should be bigger than 0","PAYMENT_NOT_POSSIBLE_WITH_THIS_AMOUNT":"Payment not possible with this amount","INVALID_CONFIGURATION":"Invalid recycler configuration","LAST_NOTE_HIGHEST_RECYCLED_VALUE":"Only 1 high value note in succession allowed","MAX_AMOUNT_REACHED":"Recycler for this denomination is full","NON_RECYCLED_DENOMINATION":"Denomination is not recycled","THREE_HIGH_VALUE_NOTES_IN_SUCCESSION":"No more than three high denomination notes in succession are allowed ","NOT_OPERATIONAL_005":"Coin roll dispenser for 5 cents is not operational","NOT_OPERATIONAL_010":"Coin roll dispenser for 10 cents is not operational","NOT_OPERATIONAL_020":"Coin roll dispenser for 20 cents is not operational","NOT_OPERATIONAL_050":"Coin roll dispenser for 50 cents is not operational","NOT_OPERATIONAL_100":"Coin roll dispenser for 1 euro is not operational","NOT_OPERATIONAL_200":"Coin roll dispenser for 2 euro is not operational","STORAGE_ALMOST_EMPTY_005":"Coin roll dispenser is almost empty for 5 cents","STORAGE_ALMOST_EMPTY_010":"Coin roll dispenser is almost empty for 10 cents","STORAGE_ALMOST_EMPTY_020":"Coin roll dispenser is almost empty for 20 cents","STORAGE_ALMOST_EMPTY_050":"Coin roll dispenser is almost empty for 50 cents","STORAGE_ALMOST_EMPTY_100":"Coin roll dispenser is almost empty for 1 euro","STORAGE_ALMOST_EMPTY_200":"Coin roll dispenser is almost empty for 2 euro"}}

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(390)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(250),
	  /* template */
	  __webpack_require__(489),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(406)
	__webpack_require__(405)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(282),
	  /* template */
	  __webpack_require__(515),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(389)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(283),
	  /* template */
	  __webpack_require__(486),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(411)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(284),
	  /* template */
	  __webpack_require__(524),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(396)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(285),
	  /* template */
	  __webpack_require__(500),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(400)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(286),
	  /* template */
	  __webpack_require__(508),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(401)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(287),
	  /* template */
	  __webpack_require__(509),
	  /* scopeId */
	  "data-v-7246879d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(402)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(288),
	  /* template */
	  __webpack_require__(512),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(289),
	  /* template */
	  __webpack_require__(499),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(392)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(290),
	  /* template */
	  __webpack_require__(491),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(291),
	  /* template */
	  __webpack_require__(501),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(409)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(249),
	  /* template */
	  __webpack_require__(522),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 486:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group form-group--three-columns"
	  }, _vm._l((_vm.coindistributionsetting), function(item, index) {
	    return _c('div', {
	      staticClass: "form-row"
	    }, [_c('p', {
	      staticClass: "coin-text"
	    }, [_vm._v(_vm._s(parseFloat(_vm.coindistributionsetting[index].value / 100).toFixed(2) + " " + _vm.coindistributionsetting[index].currency))]), _vm._v(" "), _c('el-select', {
	      attrs: {
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.coindistributionsetting[index].location),
	        callback: function($$v) {
	          _vm.$set(_vm.coindistributionsetting[index], "location", $$v)
	        },
	        expression: "coindistributionsetting[index].location"
	      }
	    }, [_c('el-option', {
	      attrs: {
	        "value": 1
	      }
	    }), _vm._v(" "), _c('el-option', {
	      attrs: {
	        "value": 2
	      }
	    })], 1)], 1)
	  }), 0)
	},staticRenderFns: []}

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-container"
	  }, [_c('div', {
	    staticClass: "main-menu-bar"
	  }, [(_vm.isFTBStyleApplied && _vm.isLoggedIn) ? _c('div', {
	    staticClass: "right-shadow"
	  }) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "main-menu-bar__logo",
	    attrs: {
	      "to": _vm.getMainPage(),
	      "title": _vm.$t('generic.application_name'),
	      "alt": _vm.$t('generic.application_name')
	    }
	  }), _vm._v(" "), (_vm.getCurrentSession.state === 'ready' && _vm.getCurrentSession.data.user) ? _c('nav', [_c('ul', {
	    staticClass: "main-menu-bar__menu"
	  }, [(_vm.showSidemenu) ? _c('li', {
	    staticClass: "main-menu-bar__menu__list-item main-menu-bar__menu__list-item--toggle-menu"
	  }, [_c('a', {
	    class: ['main-menu-bar__menu__list-item__link', {
	      'active': _vm.isSubmenuActive
	    }],
	    attrs: {
	      "href": "#!",
	      "title": _vm.$t('generic.mainmenu.submenu'),
	      "alt": _vm.$t('generic.mainmenu.submenu')
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleSubMenu()
	      }
	    }
	  }, [_c('span'), _vm._v("\n                        " + _vm._s(_vm.$t('generic.mainmenu.submenu')) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _vm._l((Object.values(_vm.mainMenu)), function(mainMenuItem) {
	    return _c('li', {
	      key: mainMenuItem.name,
	      staticClass: "main-menu-bar__menu__list-item"
	    }, [(mainMenuItem.visible) ? _c('router-link', {
	      staticClass: "main-menu-bar__menu__list-item__link",
	      attrs: {
	        "to": {
	          name: mainMenuItem.name
	        }
	      }
	    }, [_c('i', {
	      staticClass: "main-menu-bar__menu__list-item__link__icon",
	      class: mainMenuItem.meta.icon
	    }), _vm._v(" " + _vm._s(mainMenuItem.meta.title) + "\n                    ")]) : _vm._e()], 1)
	  }), _vm._v(" "), _c('li', {
	    staticClass: "main-menu-bar__menu__list-item hide-desktop"
	  }, [(_vm.getCurrentSession.state === 'ready' && _vm.getCurrentSession.data.user) ? _c('dq-usermenu', {
	    attrs: {
	      "label": _vm.getCurrentSession.data.user.name,
	      "showLogout": true
	    }
	  }) : _vm._e()], 1)], 2)]) : _vm._e()], 1), _vm._v(" "), (_vm.getCurrentSession.state === 'ready' &&
	    _vm.getCurrentSession.data.user && _vm.showSidemenu) ? _c('div', {
	    class: ['sub-menu-bar', {
	      'open': _vm.isOpenActive
	    }, {
	      'sub-menu-bar__ftb-menu-padding': _vm.isFTBStyleApplied
	    }]
	  }, [_c('div', {
	    staticClass: "right-shadow-sub-menu"
	  }), _vm._v(" "), (_vm.$route.meta.sidemenu) ? _c('nav', [(_vm.$route.meta.sidemenu) ? _c('ul', {
	    class: ['sub-menu-bar__menu', {
	      'ftb-sub-menu-margin': _vm.isFTBStyleApplied
	    }]
	  }, [(_vm.isFTBStyleApplied) ? _c('img', {
	    staticClass: "right-shadow-sub-menu__ftb-logo",
	    attrs: {
	      "src": _vm.ftbLogo,
	      "alt": "ftb-logo"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('generic.submenu.title')) + " "), _c('a', {
	    staticClass: "reset__Link",
	    on: {
	      "click": _vm.resetSubMenu
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.submenu.reset_text')))])]), _vm._v(" "), _c('el-menu', {
	    attrs: {
	      "default-active": "2",
	      "unique-opened": true
	    },
	    on: {
	      "open": _vm.handleMenu,
	      "close": _vm.handleMenu
	    }
	  }, [_c('dq-sidemenu', {
	    attrs: {
	      "model": _vm.getOrganizationSimpleTree
	    }
	  })], 1)], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "loggedin-userinfo"
	  }, [(_vm.isLoggedIn) ? _c('div', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'logout'
	      },
	      "title": _vm.$t('generic.logout.buttons.logout'),
	      "alt": _vm.$t('generic.logout.buttons.logout')
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.logout')) + "\n            "), _c('i', {
	    staticClass: "ion-ios-locked-outline"
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('dq-usermenu', {
	    attrs: {
	      "label": _vm.getCurrentSession.data.user.name
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
	    class: [_vm.isLoggedIn ? '' : 'el-lang'],
	    attrs: {
	      "trigger": "click",
	      "menu-align": "start"
	    },
	    on: {
	      "command": _vm.changeLanguage
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('span', {
	    staticClass: "flag-icon",
	    class: _vm.getFlagClass(_vm.currentLanguage)
	  }), _vm._v(" "), _c('i', {
	    staticClass: "el-icon-arrow-down el-icon--right"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    staticClass: "el-dropdown-languages",
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('el-dropdown-item', {
	    attrs: {
	      "command": "en"
	    }
	  }, [_c('span', {
	    staticClass: "flag-icon",
	    class: [_vm.isFTBStyleApplied ? 'flag-icon-us' : 'flag-icon-en']
	  })]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "nl"
	    }
	  }, [_c('span', {
	    staticClass: "flag-icon flag-icon-nl"
	  })]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "fr"
	    }
	  }, [_c('span', {
	    staticClass: "flag-icon flag-icon-fr"
	  })]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "de"
	    }
	  }, [_c('span', {
	    staticClass: "flag-icon flag-icon-de"
	  })]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "sk"
	    }
	  }, [_c('span', {
	    staticClass: "flag-icon flag-icon-sk"
	  })]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "pl"
	    }
	  }, [_c('span', {
	    staticClass: "flag-icon flag-icon-pl"
	  })])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "el-dropdown"
	  }, [_c('el-button', {
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogTryNewPortal = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.new_portal.title')))])], 1)], 1), _vm._v(" "), _c('div', {
	    class: ['main-content', {
	      'open': _vm.isOpenActive
	    }]
	  }, [_c('router-view'), _vm._v(" "), _c('div', {
	    staticClass: "copy-right"
	  }, [_c('div', [_vm._v(" © " + _vm._s(_vm.currentYear) + " " + _vm._s(_vm.buildProp.name) + " v" + _vm._s(_vm.buildProp.version) + " - " + _vm._s(_vm.$t('generic.copy_right')) + " ")])])], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('generic.new_portal.title'),
	      "size": "tiny"
	    },
	    model: {
	      value: (_vm.dialogTryNewPortal),
	      callback: function($$v) {
	        _vm.dialogTryNewPortal = $$v
	      },
	      expression: "dialogTryNewPortal"
	    }
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('generic.new_portal.dialog.description_1'))
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.dialogTryNewPortal = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.navigateToNewPortal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.new_portal.dialog.confirm')))])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.tariffspanel.transaction_fee')))]), _vm._v(" "), _c('div', {
	    staticClass: "form-group--three-columns"
	  }, [_c('ul', _vm._l((_vm.companyTariffs), function(item, index) {
	    return _c('li', [_c('div', {
	      staticClass: "form-row"
	    }, [_c('p', {
	      staticClass: "linc-text"
	    }, [_vm._v(_vm._s(item.company) + ":")]), _vm._v(" "), _c('el-input', {
	      staticClass: "linc-tariff-input",
	      attrs: {
	        "type": "number",
	        "min": "0",
	        "disabled": !_vm.overridden
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.companyTariffs[index].transactionTariff),
	        callback: function($$v) {
	          _vm.$set(_vm.companyTariffs[index], "transactionTariff", $$v)
	        },
	        expression: "companyTariffs[index].transactionTariff"
	      }
	    })], 1)])
	  }), 0)]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.tariffspanel.value_fee')))]), _vm._v(" "), _c('el-table', {
	    staticClass: "inventoryTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.companyTariffs
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(scope.row.company))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": '0.05',
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.valueTariffs[0].tariff),
	            callback: function($$v) {
	              _vm.$set(scope.row.valueTariffs[0], "tariff", $$v)
	            },
	            expression: "scope.row.valueTariffs[0].tariff"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": '0.10',
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.valueTariffs[1].tariff),
	            callback: function($$v) {
	              _vm.$set(scope.row.valueTariffs[1], "tariff", $$v)
	            },
	            expression: "scope.row.valueTariffs[1].tariff"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": '0.20',
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.valueTariffs[2].tariff),
	            callback: function($$v) {
	              _vm.$set(scope.row.valueTariffs[2], "tariff", $$v)
	            },
	            expression: "scope.row.valueTariffs[2].tariff"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": '0.50',
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.valueTariffs[3].tariff),
	            callback: function($$v) {
	              _vm.$set(scope.row.valueTariffs[3], "tariff", $$v)
	            },
	            expression: "scope.row.valueTariffs[3].tariff"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": '1.00',
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.valueTariffs[4].tariff),
	            callback: function($$v) {
	              _vm.$set(scope.row.valueTariffs[4], "tariff", $$v)
	            },
	            expression: "scope.row.valueTariffs[4].tariff"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": '2.00',
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.valueTariffs[5].tariff),
	            callback: function($$v) {
	              _vm.$set(scope.row.valueTariffs[5], "tariff", $$v)
	            },
	            expression: "scope.row.valueTariffs[5].tariff"
	          }
	        })], 1)]
	      }
	    }])
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', _vm._l((_vm.model), function(child) {
	    return (child.subOrganizations.length) ? _c('el-submenu', {
	      class: {
	        'el-menu-active': _vm.isActive(child)
	      },
	      attrs: {
	        "index": child.uuid
	      }
	    }, [_c('template', {
	      slot: "title"
	    }, [_vm._v(_vm._s(child.name))]), _vm._v(" "), _c('dq-sidemenu', {
	      staticClass: "item",
	      attrs: {
	        "model": child.subOrganizations
	      }
	    })], 2) : _c('el-menu-item', {
	      class: {
	        'el-menu-active': _vm.isActive(child)
	      },
	      attrs: {
	        "index": child.uuid
	      },
	      on: {
	        "click": function($event) {
	          _vm.goToRoute(child.uuid)
	        }
	      }
	    }, [_vm._v(_vm._s(child.name))])
	  }), 1)
	},staticRenderFns: []}

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group--three-columns"
	  }, [_c('ul', _vm._l((_vm.minimumOrderCoinRollsSettings), function(item, index) {
	    return _c('li', [_c('div', {
	      staticClass: "form-row"
	    }, [_c('h4', [_vm._v(_vm._s(item.bank))]), _vm._v(" "), _c('p', {
	      staticClass: "linc-text"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.minimumOrderPanel.min')))]), _vm._v(" "), _c('el-input', {
	      staticClass: "linc-minimum-order-input",
	      attrs: {
	        "type": "number",
	        "min": "1",
	        "max": "200",
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.minimumOrderCoinRollsSettings[index].minimumOrderCoinRoll),
	        callback: function($$v) {
	          _vm.$set(_vm.minimumOrderCoinRollsSettings[index], "minimumOrderCoinRoll", $$v)
	        },
	        expression: "minimumOrderCoinRollsSettings[index].minimumOrderCoinRoll"
	      }
	    }), _vm._v(" "), _c('p', {
	      staticClass: "linc-text"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.minimumOrderPanel.max')))]), _vm._v(" "), _c('el-input', {
	      staticClass: "linc-minimum-order-input",
	      attrs: {
	        "type": "number",
	        "min": "1",
	        "max": "200",
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.minimumOrderCoinRollsSettings[index].maximumOrderCoinRoll),
	        callback: function($$v) {
	          _vm.$set(_vm.minimumOrderCoinRollsSettings[index], "maximumOrderCoinRoll", $$v)
	        },
	        expression: "minimumOrderCoinRollsSettings[index].maximumOrderCoinRoll"
	      }
	    })], 1)])
	  }), 0)])])
	},staticRenderFns: []}

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-dropdown', {
	    attrs: {
	      "trigger": "click"
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('span', {
	    staticClass: "hide-mobile"
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('i', {
	    staticClass: "el-icon-arrow-down el-icon--right"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('el-dropdown-item', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'management.user.update-profile'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.profile')))])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'management.user.change-password'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.changepassword')))])], 1), _vm._v(" "), (_vm.canChangePin) ? _c('el-dropdown-item', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'management.user.change-pincode'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.changepin')))])], 1) : _vm._e(), _vm._v(" "), (_vm.showLogout) ? _c('el-dropdown-item', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'logout'
	      },
	      "title": _vm.$t('generic.logout.buttons.logout'),
	      "alt": _vm.$t('generic.logout.buttons.logout')
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.logout')))])], 1) : _vm._e(), _vm._v(" "), (_vm.user.canResetMfaSecret) ? _c('el-dropdown-item', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.resetUserQrSecret(_vm.user.uuid)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.mfaResetQrSecret')))])]) : _vm._e()], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-table', {
	    staticClass: "om61InventoryTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.om61InventorySettings
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.denomination'),
	      "min-width": "10%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(scope.row.denomination.toFixed(2)))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.numberOfRecyclers'),
	      "min-width": "8%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-select', {
	          attrs: {
	            "filterable": "",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.recyclersUpdated(scope.row)
	            }
	          },
	          model: {
	            value: (scope.row.numberOfRecyclers),
	            callback: function($$v) {
	              _vm.$set(scope.row, "numberOfRecyclers", $$v)
	            },
	            expression: "scope.row.numberOfRecyclers"
	          }
	        }, _vm._l(((_vm.maxNumberOfRecyclers + 1)), function(value, index) {
	          return _c('el-option', {
	            attrs: {
	              "value": index
	            },
	            nativeOn: {
	              "click": function($event) {
	                _vm.forceUpdate()
	              }
	            }
	          })
	        }), 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.min'),
	      "min-width": "8%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.minAmount),
	            callback: function($$v) {
	              _vm.$set(scope.row, "minAmount", $$v)
	            },
	            expression: "scope.row.minAmount"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.optimum'),
	      "min-width": "8%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.optimumAmount),
	            callback: function($$v) {
	              _vm.$set(scope.row, "optimumAmount", $$v)
	            },
	            expression: "scope.row.optimumAmount"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.max'),
	      "min-width": "8%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          key: _vm.rowUpdateKey,
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.maxAmount),
	            callback: function($$v) {
	              _vm.$set(scope.row, "maxAmount", $$v)
	            },
	            expression: "scope.row.maxAmount"
	          }
	        })], 1)]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
	    class: [_vm.status.class]
	  }, [_vm._v(_vm._s(_vm.status.message))])]), _vm._v(" "), _c('el-form-item', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    attrs: {
	      "prop": "om61SettingsValid"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.form.om61SettingsValid),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "om61SettingsValid", $$v)
	      },
	      expression: "form.om61SettingsValid"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.hideIfNoRecords || _vm.itemsData.length !== 0) ? _c('div', {
	    class: _vm.overrideClass
	  }, [(_vm.componentErrorMessage) ? _c('div', {
	    staticClass: "error"
	  }, [_c('p', [_vm._v(_vm._s(_vm.componentErrorMessage))])]) : _vm._e(), _vm._v(" "), (_vm.search && !_vm.contentOnly) ? _c('div', {
	    staticClass: "form-row"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.itemsSearchValue),
	      expression: "itemsSearchValue"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('generic.overview.search.placeholder')
	    },
	    domProps: {
	      "value": (_vm.itemsSearchValue)
	    },
	    on: {
	      "keyup": [function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        _vm.getSearch()
	      }, function($event) {
	        _vm.searchOnChange()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.itemsSearchValue = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": _vm.constructNewOverviewUrl()
	    }
	  }, [_c('button', {
	    staticClass: "search",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        _vm.getSearch()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "ion-search"
	  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.itemsShowLoading) ? _c('div', [_c('i', {
	    staticClass: "ion-loop loading-animation"
	  })]) : _c('div', [(!_vm.contentOnly) ? _c('div', {
	    staticClass: "row pagination-list"
	  }, [(!_vm.itemsError) ? _c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.pagination.pagesize.before')))]) : _vm._e(), _vm._v(" "), (!_vm.itemsError) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.paginationPageSize),
	      expression: "paginationPageSize"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.paginationPageSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.handlePaginationPageSize]
	    }
	  }, _vm._l((_vm.paginationPageSizeOptions), function(option, index) {
	    return _c('option', {
	      key: index,
	      domProps: {
	        "value": option
	      }
	    }, [_vm._v(_vm._s(option))])
	  }), 0) : _vm._e(), _vm._v(" "), (!_vm.itemsError) ? _c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.pagination.pagesize.after')))]) : _vm._e(), _vm._v(" "), (!_vm.contentOnly) ? _c('div', {
	    staticClass: "form-row column__50 text-right"
	  }, [(_vm.actions.create.action && _vm.showButtons.create) ? _c('a', {
	    staticClass: "link",
	    attrs: {
	      "icon": "plus",
	      "loading": false,
	      "title": _vm.actions.create.label,
	      "alt": _vm.actions.create.label
	    },
	    on: {
	      "click": _vm.actions.create.action
	    }
	  }, [_c('i', {
	    staticClass: "ion-plus"
	  }), _vm._v(" " + _vm._s(_vm.actions.create.label) + "\n        ")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.itemsError) ? _c('div', {
	    staticClass: "error--text"
	  }, [_vm._v(_vm._s(_vm.overrideError ? _vm.$t(_vm.overrideError) : _vm.itemsError))]) : _c('div', {
	    staticClass: "table-scroll"
	  }, [_c('table', {
	    staticClass: "border",
	    class: {
	      zebra: _vm.rows.zebra
	    }
	  }, [_c('thead', [_c('tr', [_vm._l((_vm.columns), function(column, index) {
	    return _c('th', {
	      key: index,
	      style: ({
	        textAlign: column.headerAlign
	      })
	    }, [_c('a', {
	      staticStyle: {
	        "text-decoration": "none"
	      },
	      on: {
	        "click": function($event) {
	          _vm.sort(column.name)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(column.label) + "\n              "), (_vm.isSortField(column.name)) ? _c('i', {
	      class: (_vm.getSortDirection() === 'desc' ? 'el-icon-arrow-down' : 'el-icon-arrow-up')
	    }) : _vm._e()])])
	  }), _vm._v(" "), _c('th', {
	    staticClass: "tools"
	  }, [_c('a', {
	    staticClass: "tools--link"
	  }, [(_vm.filterHasToBeDisplayed()) ? _c('i', {
	    class: (_vm.isFilterEnabled() ? 'ion-funnel' : 'ion-android-funnel'),
	    on: {
	      "click": function($event) {
	        _vm.startFilterScreen()
	      }
	    }
	  }) : _vm._e()])])], 2), _vm._v(" "), (!_vm.contentOnly) ? _c('td') : _vm._e()]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemsData), function(item, index) {
	    return _c('tr', {
	      key: index,
	      class: {
	        canceled: item.canceled
	      }
	    }, [_vm._l((_vm.columns), function(column, index) {
	      return _c('td', {
	        key: index,
	        class: (column.action ? 'click-cell' : null),
	        style: ({
	          width: column.width,
	          textAlign: column.align
	        }),
	        on: {
	          "click": function($event) {
	            ((column.action && column.name !== 'currentValue') ? column.action({
	              item: item
	            }) : null)
	          }
	        }
	      }, [_vm._v("\n            " + _vm._s(column.processor ? _vm.filter(column.processor(item[column.name]), column.filter, item) : _vm.filter(item[column.name], column.filter, item)) + "\n          ")])
	    }), _vm._v(" "), _c('td', {
	      staticClass: "tools"
	    }, [_vm._l((_vm.itemActions), function(ia) {
	      return (!_vm.containsUserRole('dealerview')) ? _c('a', {
	        key: ia,
	        staticClass: "tools--link",
	        on: {
	          "click": function($event) {
	            ia.perform(item, index)
	          }
	        }
	      }, [_c('i', {
	        class: ia.icon
	      })]) : _vm._e()
	    }), _vm._v(" "), (!_vm.actions.unlock.disable && _vm.actions.unlock.column.identifier && !_vm.contentOnly && _vm.showButtons.unlock && item.locked) ? _c('a', {
	      staticClass: "tools--link",
	      attrs: {
	        "title": _vm.actions.unlock.label,
	        "alt": _vm.actions.unlock.label
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.unlockItem(item[_vm.actions.unlock.column.name], item[_vm.actions.unlock.column.identifier])
	        }
	      }
	    }, [_c('i', {
	      staticClass: "ion-android-lock"
	    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.read.disable && _vm.actions.read.action && !_vm.contentOnly && _vm.showButtons.read && _vm.actions.read.redirectUrl) ? _c('a', {
	      staticClass: "tools--link",
	      attrs: {
	        "title": _vm.actions.read.label,
	        "alt": _vm.actions.read.label
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.navigateToDetail(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "ion-search"
	    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.read.disable && _vm.actions.read.action && !_vm.contentOnly && _vm.showButtons.read && !_vm.actions.read.redirectUrl) ? _c('a', {
	      staticClass: "tools--link",
	      attrs: {
	        "title": _vm.actions.read.label,
	        "alt": _vm.actions.read.label
	      },
	      on: {
	        "click": function($event) {
	          _vm.actions.read.action({
	            item: item,
	            index: index
	          })
	        }
	      }
	    }, [_c('i', {
	      staticClass: "ion-search"
	    })]) : _vm._e(), _vm._v(" "), (_vm.actions.readsettings && !_vm.actions.readsettings.disable && _vm.actions.readsettings.action && !_vm.contentOnly && _vm.showButtons.readsettings) ? _c('a', {
	      staticClass: "tools--link",
	      attrs: {
	        "title": _vm.actions.readsettings.label,
	        "alt": _vm.actions.readsettings.label
	      },
	      on: {
	        "click": function($event) {
	          _vm.actions.readsettings.action({
	            item: item,
	            index: index
	          })
	        }
	      }
	    }, [_c('i', {
	      staticClass: "ion-clipboard"
	    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.update.disable && !_vm.contentOnly && _vm.showButtons.update &&
	      _vm.exportSdcWorkflow && _vm.actions.exportWorkflow && item.Version === 2) ? _c('a', {
	      staticClass: "tools--link",
	      attrs: {
	        "title": _vm.actions.exportWorkflow.label,
	        "alt": _vm.actions.exportWorkflow.label
	      },
	      on: {
	        "click": function($event) {
	          _vm.sdcWorkflowExport(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "ion-android-download"
	    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.update.disable && _vm.actions.update.action && !_vm.contentOnly && _vm.showButtons.update && _vm.actions.read.redirectUrl) ? _c('a', {
	      staticClass: "tools--link",
	      attrs: {
	        "href": _vm.actions.update.redirectUrl({
	          item: item
	        }),
	        "title": _vm.actions.update.label,
	        "alt": _vm.actions.update.label
	      }
	    }, [_c('i', {
	      staticClass: "ion-edit"
	    })]) : _vm._e(), _vm._v(" "), (_vm.actions.preview && !_vm.actions.preview.disable && _vm.actions.preview.action && !_vm.contentOnly && _vm.showButtons.preview && _vm.actions.preview.redirectUrl) ? _c('a', {
	      staticClass: "tools--link",
	      attrs: {
	        "href": _vm.actions.preview.redirectUrl({
	          item: item
	        }),
	        "title": _vm.actions.preview.label,
	        "alt": _vm.actions.preview.label
	      }
	    }, [_c('i', {
	      staticClass: "ion-eye"
	    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.update.disable && _vm.actions.update.action && !_vm.contentOnly && _vm.showButtons.update && !_vm.actions.read.redirectUrl) ? _c('a', {
	      staticClass: "tools--link",
	      attrs: {
	        "title": _vm.actions.update.label,
	        "alt": _vm.actions.update.label
	      },
	      on: {
	        "click": function($event) {
	          _vm.actions.update.action({
	            item: item,
	            index: index
	          })
	        }
	      }
	    }, [_c('i', {
	      staticClass: "ion-edit"
	    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.delete.disable && _vm.actions.delete.column.identifier && !_vm.contentOnly && _vm.showButtons.delete) ? _c('a', {
	      staticClass: "tools--link",
	      attrs: {
	        "title": _vm.actions.delete.label,
	        "alt": _vm.actions.delete.label
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.deleteItem(item, _vm.actions.delete.column)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "ion-trash-b"
	    })]) : _vm._e()], 2)], 2)
	  }), 0)])]), _vm._v(" "), (_vm.filterSection !== 'false' && !_vm.itemsError) ? _c('div', {
	    staticClass: "row row--nomargin"
	  }, [(_vm.totalText && !_vm.itemsError && !_vm.contentOnly) ? _c('div', {
	    staticClass: "form-row items-discovered column__50",
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('generic.overview.pagination.showing', {
	        current: _vm.paginationCurrentItems,
	        total: _vm.itemsTotal
	      }))
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-row column__50 text-right"
	  }, [(_vm.pagination.items && !_vm.contentOnly) ? _c('div', {
	    staticClass: "pagination"
	  }, [_c('el-pagination', {
	    attrs: {
	      "page-size": _vm.pagination.items,
	      "layout": "prev, pager, next",
	      "total": _vm.itemsTotal,
	      "current-page": _vm.itemsParams.page
	    },
	    on: {
	      "current-change": _vm.handlePaginationChange
	    }
	  })], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('generic.overview.dialog.delete.title'),
	      "size": "tiny"
	    },
	    model: {
	      value: (_vm.dialogDeleteVisible),
	      callback: function($$v) {
	        _vm.dialogDeleteVisible = $$v
	      },
	      expression: "dialogDeleteVisible"
	    }
	  }, [(_vm.dialogDeleteUnitList.length > 9) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.dialog.delete.tillDescriptionName')) + "\n        "), _c('span', {
	    staticClass: "strong"
	  }, [_vm._v(_vm._s(_vm.dialogDeleteName) + " ")]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('generic.overview.dialog.delete.tillDescriptionUnit', {
	        noUnits: _vm.dialogDeleteUnitList.length,
	        units: _vm.dialogDeleteUnitFormatted
	      }))
	    }
	  })])]) : (_vm.dialogDeleteUnitList.length > 0 && _vm.dialogDeleteUnitList.length < 10) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.dialog.delete.tillDescriptionName')) + "\n        "), _c('span', {
	    staticClass: "strong"
	  }, [_vm._v(_vm._s(_vm.dialogDeleteName) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.dialog.delete.tillDescriptionUnits', {
	    noUnits: _vm.dialogDeleteUnitList.length
	  })))])])]) : _c('span', [_vm._v("\n      " + _vm._s(_vm.$t('generic.overview.dialog.delete.description')) + " "), _c('span', {
	    staticClass: "strong"
	  }, [_vm._v(_vm._s(_vm.dialogDeleteName))]), _vm._v("?\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('generic.overview.dialog.delete.confirmation')) + "\n        ")]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.dialogDeleteVisible = false, _vm.dialogDeleteIdentifier = '', _vm.dialogDeleteLoading = ''
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.dialogDeleteLoading
	    },
	    on: {
	      "click": _vm.confirmDeleteItem
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.confirm')))])], 1)]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('generic.overview.dialog.unlock.title'),
	      "size": "tiny"
	    },
	    model: {
	      value: (_vm.dialogUnlockVisible),
	      callback: function($$v) {
	        _vm.dialogUnlockVisible = $$v
	      },
	      expression: "dialogUnlockVisible"
	    }
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('generic.overview.dialog.unlock.description', {
	        name: _vm.dialogUnlockName
	      }))
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('generic.overview.dialog.unlock.confirmation')) + "\n        ")]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.dialogUnlockVisible = false, _vm.dialogUnlockIdentifier = '', _vm.dialogUnlockLoading = ''
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.dialogUnlockLoading
	    },
	    on: {
	      "click": _vm.confirmUnlockItem
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.confirm')))])], 1)]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('generic.overview.dialog.filter.title'),
	      "size": "tiny"
	    },
	    model: {
	      value: (_vm.dialogFilterVisible),
	      callback: function($$v) {
	        _vm.dialogFilterVisible = $$v
	      },
	      expression: "dialogFilterVisible"
	    }
	  }, [(_vm.filterHasToBeDisplayed()) ? _c('span', {
	    staticClass: "side--label",
	    staticStyle: {
	      "color": "#2d4d5a"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.actions.filter.label))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row__column--50 text-left"
	  }, [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form
	    }
	  }, [_c('el-form-item', {
	    staticClass: "item-checkbox item-checkbox-inline",
	    attrs: {
	      "prop": "filter"
	    }
	  }, [_c('el-checkbox-group', {
	    staticClass: "item-checkbox",
	    attrs: {
	      "loading-text": _vm.loadingText,
	      "loading": _vm.loadingFilterData
	    },
	    on: {
	      "change": function($event) {
	        _vm.changeFilterSelection()
	      }
	    },
	    model: {
	      value: (_vm.form.dialog_filter),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "dialog_filter", $$v)
	      },
	      expression: "form.dialog_filter"
	    }
	  }, _vm._l((_vm.resultFilterDataIncluding), function(item) {
	    return _c('tr', {
	      key: item
	    }, [_c('td', [_c('el-checkbox', {
	      attrs: {
	        "label": item
	      }
	    }, [_vm._v(_vm._s(_vm.getFilterLabel(item)))])], 1)])
	  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "button button--cancel",
	    attrs: {
	      "native-type": "cancel",
	      "title": _vm.$t('generic.overview.buttons.cancel')
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogFilterVisible = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.dialogUnlockLoading
	    },
	    on: {
	      "click": function($event) {
	        _vm.filterOverview()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.ok')))])], 1)])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group--two-columns"
	  }, _vm._l((_vm.settings), function(item, index) {
	    return (_vm.settings.length >= 1) ? _c('div', {
	      staticClass: "form-row"
	    }, [(item.type === 1) ? _c('el-form-item', {
	      staticClass: "item-checkbox"
	    }, [_c('el-checkbox', {
	      attrs: {
	        "checked": _vm.settings[index].value,
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.settings[index].value),
	        callback: function($$v) {
	          _vm.$set(_vm.settings[index], "value", $$v)
	        },
	        expression: "settings[index].value"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n        ")]), _vm._v(" "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type === 2) ? _c('el-form-item', {
	      staticClass: "custom-label"
	    }, [_c('span', {
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (!_vm.hideTooltip(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-input', {
	      attrs: {
	        "type": "number",
	        "min": "0",
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.settings[index].value),
	        callback: function($$v) {
	          _vm.$set(_vm.settings[index], "value", $$v)
	        },
	        expression: "settings[index].value"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (item.type === 3) ? _c('el-form-item', {
	      staticClass: "custom-label"
	    }, [_c('span', {
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-input', {
	      staticClass: "settings-input",
	      attrs: {
	        "type": item.key === _vm.charitiesField ? 'textarea' : 'text',
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.settings[index].value),
	        callback: function($$v) {
	          _vm.$set(_vm.settings[index], "value", $$v)
	        },
	        expression: "settings[index].value"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (item.type === 4) ? _c('el-form-item', {
	      staticClass: "custom-label"
	    }, [_c('span', {
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (!_vm.hideTooltip(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-select', {
	      attrs: {
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.settings[index].value),
	        callback: function($$v) {
	          _vm.$set(_vm.settings[index], "value", $$v)
	        },
	        expression: "settings[index].value"
	      }
	    }, [_c('el-option', {
	      attrs: {
	        "label": _vm.$t('generic.forms.select')
	      }
	    }), _vm._v(" "), _vm._l((JSON.parse(_vm.settings[index].values)), function(option, key) {
	      return _c('el-option', {
	        attrs: {
	          "label": _vm.$t('management.unit.softwaresettings.' + key.replace(/[ :/]/g, '')),
	          "value": key,
	          "selected": "selected"
	        }
	      })
	    })], 2)], 1) : _vm._e(), _vm._v(" "), (item.type === 5) ? _c('el-form-item', {
	      staticClass: "custom-label"
	    }, [_c('span', {
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-select', {
	      attrs: {
	        "multiple": "",
	        "placeholder": _vm.$t('generic.forms.select'),
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateMultiSelection()
	        }
	      },
	      model: {
	        value: (_vm.selectedValues),
	        callback: function($$v) {
	          _vm.selectedValues = $$v
	        },
	        expression: "selectedValues"
	      }
	    }, _vm._l((JSON.parse(_vm.settings[index].values)), function(option, key) {
	      return _c('el-option', {
	        attrs: {
	          "label": option,
	          "value": key,
	          "selected": "selected"
	        }
	      })
	    }), 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 6) ? _c('div', {
	      staticClass: "not-showing"
	    }) : _vm._e(), _vm._v(" "), (item.type === 7) ? _c('div', {
	      staticClass: "not-showing"
	    }) : _vm._e(), _vm._v(" "), (item.type === 8) ? _c('div', {
	      staticClass: "not-showing"
	    }) : _vm._e(), _vm._v(" "), (item.type === 9) ? _c('el-form-item', {
	      staticClass: "custom-label"
	    }, [_c('span', {
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-checkbox', {
	      attrs: {
	        "disabled": !_vm.overridden || _vm.readOnly,
	        "checked": _vm.timePickerEnabled
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateTimeStampSelection()
	        }
	      },
	      model: {
	        value: (_vm.timePickerEnabled),
	        callback: function($$v) {
	          _vm.timePickerEnabled = $$v
	        },
	        expression: "timePickerEnabled"
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('management.unit.softwaresettings.timeSelector.enabled')) + "\n        ")]), _vm._v(" "), _c('el-time-select', {
	      attrs: {
	        "disabled": !_vm.overridden || _vm.readOnly || !_vm.timePickerEnabled,
	        "picker-options": {
	          start: '00:00',
	          step: '00:30',
	          end: '23:30'
	        }
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateTimeStampSelection()
	        }
	      },
	      model: {
	        value: (_vm.timePickerTimeStamp),
	        callback: function($$v) {
	          _vm.timePickerTimeStamp = $$v
	        },
	        expression: "timePickerTimeStamp"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (item.type === 10) ? _c('el-form-item', {
	      staticClass: "custom-label"
	    }, [_c('span', {
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-checkbox', {
	      attrs: {
	        "disabled": !_vm.overridden || _vm.readOnly,
	        "checked": _vm.useDefaultValues[index]
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateDefaultValueSelection(index)
	        }
	      },
	      model: {
	        value: (_vm.useDefaultValues[index]),
	        callback: function($$v) {
	          _vm.$set(_vm.useDefaultValues, index, $$v)
	        },
	        expression: "useDefaultValues[index]"
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.$t('management.unit.softwaresettings.useDefaultValue')) + "\n      ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!_vm.useDefaultValues[index]),
	        expression: "!useDefaultValues[index]"
	      }],
	      staticStyle: {
	        "display": "flex"
	      },
	      attrs: {
	        "disabled": !_vm.overridden || _vm.readOnly
	      }
	    }, [_c('el-form-item', {
	      attrs: {
	        "prop": item.key
	      }
	    }, [_c('el-input', {
	      attrs: {
	        "type": "text",
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.settings[index].value),
	        callback: function($$v) {
	          _vm.$set(_vm.settings[index], "value", $$v)
	        },
	        expression: "settings[index].value"
	      }
	    })], 1), _vm._v(" "), (_vm.overridden && !_vm.readOnly) ? _c('el-button', {
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.generateNewDefaultValue(index)
	        }
	      }
	    }, [_vm._v("Generate")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 11) ? _c('div', [_c('el-form-item', {
	      staticClass: "custom-label"
	    }, [_c('span', {
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "timer-show",
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_c('vue-timepicker', {
	      attrs: {
	        "drop-direction": "up",
	        "disabled": !_vm.overridden || _vm.readOnly,
	        "format": "mm:ss"
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.settings[index].value),
	        callback: function($$v) {
	          _vm.$set(_vm.settings[index], "value", $$v)
	        },
	        expression: "settings[index].value"
	      }
	    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 12) ? _c('div', [_c('el-form-item', {
	      staticClass: "custom-label"
	    }, [_c('span', {
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "timer-show",
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_c('vue-timepicker', {
	      attrs: {
	        "drop-direction": "up",
	        "disabled": !_vm.overridden || _vm.readOnly,
	        "format": "HH:mm:ss"
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (_vm.settings[index].value),
	        callback: function($$v) {
	          _vm.$set(_vm.settings[index], "value", $$v)
	        },
	        expression: "settings[index].value"
	      }
	    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 13) ? _c('div', {
	      staticClass: "custom-label"
	    }, [_c('div', {
	      staticClass: "el-form-item__label form__percentage-field"
	    }, [_c('span', {
	      staticClass: "form__percentage-field-label",
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.unit.toolTip.' + item.key)))])]) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
	      staticClass: "side--label",
	      attrs: {
	        "label": _vm.$t('management.unit.form.' + item.key),
	        "prop": "alarmOn"
	      }
	    }, [_c('span', {
	      staticClass: "label--after input-number"
	    }, [_vm._v("%")]), _vm._v(" "), _c('el-input-number', {
	      attrs: {
	        "id": "unit-alarm-on-input",
	        "min": 0,
	        "max": 100,
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      model: {
	        value: (_vm.settings[index].value),
	        callback: function($$v) {
	          _vm.$set(_vm.settings[index], "value", $$v)
	        },
	        expression: "settings[index].value"
	      }
	    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 16) ? _c('el-form-item', {
	      staticClass: "custom-label"
	    }, [_c('span', {
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [_vm._v("\n        " + _vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n        "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
	      staticClass: "help-tip"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-input', {
	      staticClass: "settings-input",
	      attrs: {
	        "type": "password",
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateMaskedKeys(index)
	        }
	      },
	      model: {
	        value: (_vm.settings[index].parsedValue),
	        callback: function($$v) {
	          _vm.$set(_vm.settings[index], "parsedValue", $$v)
	        },
	        expression: "settings[index].parsedValue"
	      }
	    })], 1) : _vm._e()], 1) : _vm._e()
	  }), 0)
	},staticRenderFns: []}

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group--three-columns acceptables-grid"
	  }, _vm._l((_vm.acceptablesSetting), function(item, index) {
	    return (_vm.acceptablesSetting.length >= 1) ? _c('div', {
	      staticClass: "form-row"
	    }, [_c('el-form-item', {
	      staticClass: "item-checkbox"
	    }, [_c('el-checkbox', {
	      attrs: {
	        "checked": item.prohibited,
	        "disabled": !_vm.overridden || _vm.readOnly
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateSettings()
	        }
	      },
	      model: {
	        value: (item.enabled),
	        callback: function($$v) {
	          _vm.$set(item, "enabled", $$v)
	        },
	        expression: "item.enabled"
	      }
	    }, [_vm._v("\n        " + _vm._s(parseFloat(item.denomination.value).toFixed(2)) + "\n        ")])], 1)], 1) : _vm._e()
	  }), 0)])
	},staticRenderFns: []}

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "vue__time-picker time-picker",
	    style: (_vm.inputWidthStyle)
	  }, [_c('input', {
	    ref: "input",
	    staticClass: "display-time",
	    class: [_vm.inputClass, {
	      'is-empty': _vm.inputIsEmpty,
	      'invalid': _vm.hasInvalidInput,
	      'all-selected': _vm.allValueSelected,
	      'disabled': _vm.disabled,
	      'has-custom-icon': _vm.$slots && _vm.$slots.icon
	    }],
	    style: (_vm.inputWidthStyle),
	    attrs: {
	      "type": "text",
	      "id": _vm.id,
	      "name": _vm.name,
	      "placeholder": _vm.placeholder ? _vm.placeholder : _vm.formatString,
	      "tabindex": _vm.disabled ? -1 : _vm.tabindex,
	      "disabled": _vm.disabled,
	      "readonly": !_vm.manualInput,
	      "autocomplete": _vm.autocomplete
	    },
	    domProps: {
	      "value": _vm.inputIsEmpty ? null : _vm.customDisplayTime
	    },
	    on: {
	      "focus": _vm.onFocus,
	      "change": _vm.onChange,
	      "blur": function($event) {
	        _vm.debounceBlur();
	        _vm.blurEvent()
	      },
	      "mousedown": _vm.onMouseDown,
	      "keydown": [_vm.keyDownHandler, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
	        return _vm.escBlur($event)
	      }],
	      "compositionstart": _vm.onCompostionStart,
	      "compositionend": _vm.onCompostionEnd,
	      "paste": _vm.pasteHandler
	    }
	  }), _vm._v(" "), (_vm.showClearBtn || _vm.showDropdownBtn) ? _c('div', {
	    staticClass: "controls",
	    attrs: {
	      "tabindex": "-1"
	    }
	  }, [(!_vm.isActive && _vm.showClearBtn) ? _c('span', {
	    staticClass: "clear-btn",
	    class: {
	      'has-custom-btn': _vm.$slots && _vm.$slots.clearButton
	    },
	    attrs: {
	      "tabindex": "-1"
	    },
	    on: {
	      "click": _vm.clearTime
	    }
	  }, [_vm._t("clearButton", [_c('span', {
	    staticClass: "char"
	  }, [_vm._v("×")])])], 2) : _vm._e(), _vm._v(" "), (_vm.showDropdownBtn) ? _c('span', {
	    staticClass: "dropdown-btn",
	    class: {
	      'has-custom-btn': _vm.$slots && _vm.$slots.dropdownButton
	    },
	    attrs: {
	      "tabindex": "-1"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setDropdownState(_vm.fixedDropdownButton ? !_vm.showDropdown : true, true)
	      },
	      "mousedown": _vm.keepFocusing
	    }
	  }, [_vm._t("dropdownButton", [_c('span', {
	    staticClass: "char"
	  }, [_vm._v("▾")])])], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$slots && _vm.$slots.icon) ? _c('div', {
	    staticClass: "custom-icon"
	  }, [_vm._t("icon")], 2) : _vm._e(), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    staticClass: "time-picker-overlay",
	    attrs: {
	      "tabindex": "-1"
	    },
	    on: {
	      "click": _vm.toggleActive
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showDropdown),
	      expression: "showDropdown"
	    }],
	    ref: "dropdown",
	    staticClass: "dropdown",
	    class: [_vm.dropdownDirClass],
	    style: (_vm.inputWidthStyle),
	    attrs: {
	      "tabindex": "-1"
	    },
	    on: {
	      "mouseup": _vm.keepFocusing,
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "select-list",
	    style: (_vm.inputWidthStyle),
	    attrs: {
	      "tabindex": "-1"
	    }
	  }, [(!_vm.advancedKeyboard) ? [_vm._l((_vm.columnsSequence), function(column) {
	    return [(column === 'hour') ? _c('ul', {
	      key: column,
	      staticClass: "hours",
	      on: {
	        "scroll": _vm.keepFocusing
	      }
	    }, [_c('li', {
	      staticClass: "hint",
	      domProps: {
	        "textContent": _vm._s(_vm.hourLabelText)
	      }
	    }), _vm._v(" "), _vm._l((_vm.hours), function(hr, hIndex) {
	      return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('hour', hr))) ? _c('li', {
	        key: hIndex,
	        class: {
	          active: _vm.hour === hr
	        },
	        attrs: {
	          "disabled": _vm.isDisabled('hour', hr),
	          "data-key": hr
	        },
	        domProps: {
	          "textContent": _vm._s(hr)
	        },
	        on: {
	          "click": function($event) {
	            _vm.select('hour', hr)
	          }
	        }
	      }) : _vm._e()]
	    })], 2) : _vm._e(), _vm._v(" "), (column === 'minute') ? _c('ul', {
	      key: column,
	      staticClass: "minutes",
	      on: {
	        "scroll": _vm.keepFocusing
	      }
	    }, [_c('li', {
	      staticClass: "hint",
	      domProps: {
	        "textContent": _vm._s(_vm.minuteLabelText)
	      }
	    }), _vm._v(" "), _vm._l((_vm.minutes), function(m, mIndex) {
	      return [(!_vm.opts.hideDisabledMinutes || (_vm.opts.hideDisabledMinutes && !_vm.isDisabled('minute', m))) ? _c('li', {
	        key: mIndex,
	        class: {
	          active: _vm.minute === m
	        },
	        attrs: {
	          "disabled": _vm.isDisabled('minute', m),
	          "data-key": m
	        },
	        domProps: {
	          "textContent": _vm._s(m)
	        },
	        on: {
	          "click": function($event) {
	            _vm.select('minute', m)
	          }
	        }
	      }) : _vm._e()]
	    })], 2) : _vm._e(), _vm._v(" "), (column === 'second') ? _c('ul', {
	      key: column,
	      staticClass: "seconds",
	      on: {
	        "scroll": _vm.keepFocusing
	      }
	    }, [_c('li', {
	      staticClass: "hint",
	      domProps: {
	        "textContent": _vm._s(_vm.secondLabelText)
	      }
	    }), _vm._v(" "), _vm._l((_vm.seconds), function(s, sIndex) {
	      return [(!_vm.opts.hideDisabledSeconds || (_vm.opts.hideDisabledSeconds && !_vm.isDisabled('second', s))) ? _c('li', {
	        key: sIndex,
	        class: {
	          active: _vm.second === s
	        },
	        attrs: {
	          "disabled": _vm.isDisabled('second', s),
	          "data-key": s
	        },
	        domProps: {
	          "textContent": _vm._s(s)
	        },
	        on: {
	          "click": function($event) {
	            _vm.select('second', s)
	          }
	        }
	      }) : _vm._e()]
	    })], 2) : _vm._e(), _vm._v(" "), (column === 'apm') ? _c('ul', {
	      key: column,
	      staticClass: "apms",
	      on: {
	        "scroll": _vm.keepFocusing
	      }
	    }, [_c('li', {
	      staticClass: "hint",
	      domProps: {
	        "textContent": _vm._s(_vm.apmLabelText)
	      }
	    }), _vm._v(" "), _vm._l((_vm.apms), function(a, aIndex) {
	      return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('apm', a))) ? _c('li', {
	        key: aIndex,
	        class: {
	          active: _vm.apm === a
	        },
	        attrs: {
	          "disabled": _vm.isDisabled('apm', a),
	          "data-key": a
	        },
	        domProps: {
	          "textContent": _vm._s(_vm.apmDisplayText(a))
	        },
	        on: {
	          "click": function($event) {
	            _vm.select('apm', a)
	          }
	        }
	      }) : _vm._e()]
	    })], 2) : _vm._e()]
	  })] : _vm._e(), _vm._v(" "), (_vm.advancedKeyboard) ? [_vm._l((_vm.columnsSequence), function(column) {
	    return [(column === 'hour') ? _c('ul', {
	      key: column,
	      staticClass: "hours",
	      attrs: {
	        "tabindex": "-1"
	      },
	      on: {
	        "scroll": _vm.keepFocusing
	      }
	    }, [_c('li', {
	      staticClass: "hint",
	      attrs: {
	        "tabindex": "-1"
	      },
	      domProps: {
	        "textContent": _vm._s(_vm.hourLabelText)
	      }
	    }), _vm._v(" "), _vm._l((_vm.hours), function(hr, hIndex) {
	      return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('hour', hr))) ? _c('li', {
	        key: hIndex,
	        class: {
	          active: _vm.hour === hr
	        },
	        attrs: {
	          "tabindex": _vm.isDisabled('hour', hr) ? -1 : _vm.tabindex,
	          "data-key": hr,
	          "disabled": _vm.isDisabled('hour', hr)
	        },
	        domProps: {
	          "textContent": _vm._s(hr)
	        },
	        on: {
	          "click": function($event) {
	            _vm.select('hour', hr)
	          },
	          "keydown": [function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
	            _vm.onTab('hour', hr, $event)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	            $event.preventDefault();
	            _vm.select('hour', hr)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	            $event.preventDefault();
	            _vm.select('hour', hr)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	            $event.preventDefault();
	            _vm.prevItem('hour', hr)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	            $event.preventDefault();
	            _vm.nextItem('hour', hr)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
	            if ('button' in $event && $event.button !== 0) { return null; }
	            $event.preventDefault();
	            _vm.toLeftColumn('hour')
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
	            if ('button' in $event && $event.button !== 2) { return null; }
	            $event.preventDefault();
	            _vm.toRightColumn('hour')
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
	            return _vm.debounceBlur($event)
	          }],
	          "blur": _vm.debounceBlur,
	          "focus": _vm.keepFocusing
	        }
	      }) : _vm._e()]
	    })], 2) : _vm._e(), _vm._v(" "), (column === 'minute') ? _c('ul', {
	      key: column,
	      staticClass: "minutes",
	      attrs: {
	        "tabindex": "-1"
	      },
	      on: {
	        "scroll": _vm.keepFocusing
	      }
	    }, [_c('li', {
	      staticClass: "hint",
	      attrs: {
	        "tabindex": "-1"
	      },
	      domProps: {
	        "textContent": _vm._s(_vm.minuteLabelText)
	      }
	    }), _vm._v(" "), _vm._l((_vm.minutes), function(m, mIndex) {
	      return [(!_vm.opts.hideDisabledMinutes || (_vm.opts.hideDisabledMinutes && !_vm.isDisabled('minute', m))) ? _c('li', {
	        key: mIndex,
	        class: {
	          active: _vm.minute === m
	        },
	        attrs: {
	          "tabindex": _vm.isDisabled('minute', m) ? -1 : _vm.tabindex,
	          "data-key": m,
	          "disabled": _vm.isDisabled('minute', m)
	        },
	        domProps: {
	          "textContent": _vm._s(m)
	        },
	        on: {
	          "click": function($event) {
	            _vm.select('minute', m)
	          },
	          "keydown": [function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
	            _vm.onTab('minute', m, $event)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	            $event.preventDefault();
	            _vm.select('minute', m)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	            $event.preventDefault();
	            _vm.select('minute', m)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	            $event.preventDefault();
	            _vm.prevItem('minute', m)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	            $event.preventDefault();
	            _vm.nextItem('minute', m)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
	            if ('button' in $event && $event.button !== 0) { return null; }
	            $event.preventDefault();
	            _vm.toLeftColumn('minute')
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
	            if ('button' in $event && $event.button !== 2) { return null; }
	            $event.preventDefault();
	            _vm.toRightColumn('minute')
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
	            return _vm.debounceBlur($event)
	          }],
	          "blur": _vm.debounceBlur,
	          "focus": _vm.keepFocusing
	        }
	      }) : _vm._e()]
	    })], 2) : _vm._e(), _vm._v(" "), (column === 'second') ? _c('ul', {
	      key: column,
	      staticClass: "seconds",
	      attrs: {
	        "tabindex": "-1"
	      },
	      on: {
	        "scroll": _vm.keepFocusing
	      }
	    }, [_c('li', {
	      staticClass: "hint",
	      attrs: {
	        "tabindex": "-1"
	      },
	      domProps: {
	        "textContent": _vm._s(_vm.secondLabelText)
	      }
	    }), _vm._v(" "), _vm._l((_vm.seconds), function(s, sIndex) {
	      return [(!_vm.opts.hideDisabledSeconds || (_vm.opts.hideDisabledSeconds && !_vm.isDisabled('second', s))) ? _c('li', {
	        key: sIndex,
	        class: {
	          active: _vm.second === s
	        },
	        attrs: {
	          "tabindex": _vm.isDisabled('second', s) ? -1 : _vm.tabindex,
	          "data-key": s,
	          "disabled": _vm.isDisabled('second', s)
	        },
	        domProps: {
	          "textContent": _vm._s(s)
	        },
	        on: {
	          "click": function($event) {
	            _vm.select('second', s)
	          },
	          "keydown": [function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
	            _vm.onTab('second', s, $event)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	            $event.preventDefault();
	            _vm.select('second', s)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	            $event.preventDefault();
	            _vm.select('second', s)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	            $event.preventDefault();
	            _vm.prevItem('second', s)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	            $event.preventDefault();
	            _vm.nextItem('second', s)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
	            if ('button' in $event && $event.button !== 0) { return null; }
	            $event.preventDefault();
	            _vm.toLeftColumn('second')
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
	            if ('button' in $event && $event.button !== 2) { return null; }
	            $event.preventDefault();
	            _vm.toRightColumn('second')
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
	            return _vm.debounceBlur($event)
	          }],
	          "blur": _vm.debounceBlur,
	          "focus": _vm.keepFocusing
	        }
	      }) : _vm._e()]
	    })], 2) : _vm._e(), _vm._v(" "), (column === 'apm') ? _c('ul', {
	      key: column,
	      staticClass: "apms",
	      attrs: {
	        "tabindex": "-1"
	      },
	      on: {
	        "scroll": _vm.keepFocusing
	      }
	    }, [_c('li', {
	      staticClass: "hint",
	      attrs: {
	        "tabindex": "-1"
	      },
	      domProps: {
	        "textContent": _vm._s(_vm.apmLabelText)
	      }
	    }), _vm._v(" "), _vm._l((_vm.apms), function(a, aIndex) {
	      return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('apm', a))) ? _c('li', {
	        key: aIndex,
	        class: {
	          active: _vm.apm === a
	        },
	        attrs: {
	          "tabindex": _vm.isDisabled('apm', a) ? -1 : _vm.tabindex,
	          "data-key": a,
	          "disabled": _vm.isDisabled('apm', a)
	        },
	        domProps: {
	          "textContent": _vm._s(_vm.apmDisplayText(a))
	        },
	        on: {
	          "click": function($event) {
	            _vm.select('apm', a)
	          },
	          "keydown": [function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
	            _vm.onTab('apm', a, $event)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	            $event.preventDefault();
	            _vm.select('apm', a)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	            $event.preventDefault();
	            _vm.select('apm', a)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	            $event.preventDefault();
	            _vm.prevItem('apm', a)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	            $event.preventDefault();
	            _vm.nextItem('apm', a)
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
	            if ('button' in $event && $event.button !== 0) { return null; }
	            $event.preventDefault();
	            _vm.toLeftColumn('apm')
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
	            if ('button' in $event && $event.button !== 2) { return null; }
	            $event.preventDefault();
	            _vm.toRightColumn('apm')
	          }, function($event) {
	            if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
	            return _vm.debounceBlur($event)
	          }],
	          "blur": _vm.debounceBlur,
	          "focus": _vm.keepFocusing
	        }
	      }) : _vm._e()]
	    })], 2) : _vm._e()]
	  })] : _vm._e()], 2)])])
	},staticRenderFns: []}

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-table', {
	    staticClass: "inventoryTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.filteredAcceptableMaterials()
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.denomination'),
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(parseFloat(scope.row.denomination.value).toFixed(2)))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.material'),
	      "min-width": "10%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.inventorypanel.' + scope.row.denomination.material)))])]
	      }
	    }])
	  }), _vm._v(" "), (_vm.hasRecycler) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.recycled'),
	      "min-width": "10%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "item-checkbox"
	        }, [_c('el-checkbox', {
	          attrs: {
	            "checked": scope.recycled,
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.recycled),
	            callback: function($$v) {
	              _vm.$set(scope.row, "recycled", $$v)
	            },
	            expression: "scope.row.recycled"
	          }
	        })], 1)]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), (_vm.hasMinAmount) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.min'),
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.minAmount),
	            callback: function($$v) {
	              _vm.$set(scope.row, "minAmount", $$v)
	            },
	            expression: "scope.row.minAmount"
	          }
	        })], 1)]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), (_vm.hasLowAmount) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.low'),
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.lowAmount),
	            callback: function($$v) {
	              _vm.$set(scope.row, "lowAmount", $$v)
	            },
	            expression: "scope.row.lowAmount"
	          }
	        })], 1)]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.optimum'),
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.optimumAmount),
	            callback: function($$v) {
	              _vm.$set(scope.row, "optimumAmount", $$v)
	            },
	            expression: "scope.row.optimumAmount"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), (!_vm.hasLowAmount && _vm.hasMaxAmount) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.max'),
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.maxAmount),
	            callback: function($$v) {
	              _vm.$set(scope.row, "maxAmount", $$v)
	            },
	            expression: "scope.row.maxAmount"
	          }
	        })], 1)]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), (_vm.hasHightAmount) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.high'),
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.highAmount),
	            callback: function($$v) {
	              _vm.$set(scope.row, "highAmount", $$v)
	            },
	            expression: "scope.row.highAmount"
	          }
	        })], 1)]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), (_vm.valueColumn) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.value'),
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings()
	            }
	          },
	          model: {
	            value: (scope.row.value),
	            callback: function($$v) {
	              _vm.$set(scope.row, "value", $$v)
	            },
	            expression: "scope.row.value"
	          }
	        })], 1)]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), (_vm.maxDispensableColumn) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.maxDispensable'),
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.denomination.material === 'COIN') ? _c('el-form-item', {
	          staticClass: "custom-label"
	        }, [_c('el-input', {
	          class: {
	            'max-dispensable-invalid': _vm.isInvalid(scope.row)
	          },
	          attrs: {
	            "type": "number",
	            "min": "0",
	            "max": _vm.getMaxDispensable(scope.row.denomination.value, scope.row.denomination.material),
	            "disabled": !_vm.overridden || _vm.readOnly
	          },
	          on: {
	            "change": function($event) {
	              _vm.updateSettings(scope.row, 'maxDispensable')
	            }
	          },
	          model: {
	            value: (scope.row.maxDispensable),
	            callback: function($$v) {
	              _vm.$set(scope.row, "maxDispensable", $$v)
	            },
	            expression: "scope.row.maxDispensable"
	          }
	        })], 1) : _vm._e()]
	      }
	    }])
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.nonRecyleableMaterials().length) ? _c('div', {
	    staticStyle: {
	      "width": "400px"
	    }
	  }, [_c('h4', {
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.inventorypanel.nonRecyclable')))]), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "auto"
	    },
	    attrs: {
	      "data": _vm.nonRecyleableMaterials()
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.denomination'),
	      "min-width": "15%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(parseFloat(scope.row.denomination.value).toFixed(2)))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.material'),
	      "min-width": "10%",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.inventorypanel.' + scope.row.denomination.material)))])]
	      }
	    }])
	  })], 1)], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.0a9832da88694f620af0.js